module.exports={
"label_emailtocloudcc_department":`Department`,
"label.wei.weiresearch":`Micro-poll`,
"message.error.appsecret.null":`The password of secret key cannot be null!`,
"label.file.orderbylastmodifydate":`Sorted by last modified time`,
"label.minus":`-Minus`,
"label.horizontalbar":`Horizontal Lines`,
"label.emailobject.emailsentfailed":`Mail failed to send！`,
"assignedresource.check":`This service resource has been assigned to a service appointment. Please do not add repeatedly.`,
"label.finish":`Complete`,
"label.document.history":`Download History`,
"label.customfields.number.numberLengthHelpText":`1.Please enter the length of the number and the number of decimal places. For example, a number with a length of 8 and 2 decimal places can accept values up to "12345678.90".`,
"label.standard.buttonandlink.info":`Overriding standard buttons and links changes the meaning of the CloudCC.com URL and any calls to that URL such as a CloudCC.com custom page, a browser shortcut, or an external system. You can replace the CloudCC.com URL for a standard button or link with a custom Page.`,
"front-epwechat-module-v1-contacts-desc":`When enabled, the object of WeCom Contacts will be added in the CloudCC system, customer information from WeCom will be synced to this object.`,
"label.mr.caption.contact.result":`Find Duplicates and Merge: Results for querying duplicates of Contacts`,
"label.ems.selectaccount":`Select account`,
"label.group.no.activity":`There are no matching active groups.`,
"label.call.for":`Invited By`,
"label.newreportguide":`New Report Guide`,
"component.telerecord.label.name":`Names`,
"vue.add.dashboard.component":`Add {titleName} Component`,
"label.chatter.sendEmailToGroupMember.check.V":`View Votes`,
"UG.ST.002":`Determine`,
"label.setting.intergrationmanage":`Integration Management`,
"label.field.apiname.validate":`Please enter a number between 0 and 6.`,
"label.emailmerge.list.deletefolder":`Delete Folder`,
"vue_label_pool_received":`Collected`,
"label_emailtocloudcc_step1_case1":`Email to Case`,
"message.sumlength":`The sum of length and number of decimal places cannot exceed 18 palces.`,
"vue_label_approve_reassignapproval":`{name} reassigned this approval to {people}`,
"label.specify.time":`Time: 13:00 June, 21th, 2016`,
"vue_label_report_sortdown":`Descending Sort`,
"chatter.login.now":`Uploading...`,
"label.import.page2.notsuited":`Unmapped`,
"label.please.fill.out":`Please fill in`,
"label.recordtype.edit.description":`Select a value from "Available Values", then add it to "Selected Values" and make it a picklist value for this record type. Note that deleting a value from picklist does not remove this value from any existing record. Finally, select the default picklist value for the record type.`,
"label.customer.tab.new":`New Custom Tab`,
"label.sameas":`Same as`,
"front-filter-module-v1-filter-a-week-ago":`A Week Ago`,
"label.processsetting.disable.process.failed":`Failed to deactivate the path!`,
"label.summaryreport.2018.step4":`Step 4 Select report criterias`,
"label.secrecyinfo":`Confidential Information,Do Not Spread`,
"label.custom.page.component.general.settings":`Component General Settings`,
"label.ccpeak.folder":`Unfiled Class Folders`,
"vue_label_homepage_select_button_operation":`Select Button`,
"message.pleaseinputrightdistance":`Please enter the correct interval days`,
"label.mobile.phone.required.short":`Required`,
"vue_label_account_equityseructure":`Equity Structure`,
"label.file.library.error1":`This file is already in this library.`,
"fliter.nextmonth":`Next Month`,
"label.mr.descreption.oneGroupNote2":`set of enterprise information,there are`,
"label.allfolderdashboard":`All Dashboard Folders`,
"lable.opppdt.selPdt.bykeywords":`By Keyword`,
"setup_layout_label_selectedfield":`Select fields`,
"label.file.preview.convert.firstpage.failure":`An error occurred when preveiw,please click preview details or download to view`,
"vue_label_systemSettings_companie":`Company Setup`,
"label.loginhis.recently":`Recent login history`,
"label.permission.visualpagepermission.edit":`Custom Page Assignment`,
"label.ccservice.validate.email":`The format of the corresponding value {2} of the field {1} under the object API {0} is incorrect.Please enter the correct email address!`,
"label.sms.companyname.gm":`SMS-2 Setting`,
"lable.opppdt.addpdt.table.discount":`Discount (% off)`,
"Lead.Scoring.Setting.LevelSetting":`Lead Popularity Setting`,
"message.duplication.label.duplicationremark":`is the operation of querying duplicate data when new or edit records`,
"label.file.preview.error":`An error occurred when preveiw, please download to view`,
"label.imgfield.type.input":`Insert Image`,
"label.file.share.email.content1":`File Name: #filename`,
"vue_label_notice_batchedit_fail":`The data update with id {0} fails with failure reason {1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Four`,
"label.view.sortview.printview":`Print`,
"label.projectManagement.Addposttask":`Add post-task`,
"vue_label_commonobjects_view_fail":`Failed to set default view`,
"label.dayinweek":`Week's`,
"label.layout.notexist":`The layout does not exist.`,
"label.brief.total":`Record {total}`,
"label.dashboardSetup.tz.bb":`Go to Reports`,
"label_emailtocloudcc_select3":`Please select record owner`,
"label.input.least.string":`Please enter at least {0} characters`,
"label.app.step2":`Step 2 Enter the Details`,
"lable.account.LastWeek":`Last Week`,
"label.notifications":`Notifications`,
"label.tabpage.viewname":`View name`,
"label.knowledge.language.italian":`Italian`,
"label.sendmail.step2.introduce":`Please choose a email templates`,
"label_enable_or_no":`Enable or Not`,
"pagecreator_button_save":`Save`,
"template.chart.cplb":`Product Category`,
"label.knowledge.publish":`Cannot be published for it it not qualified.`,
"label.name.required":`The name field is required`,
"component.chatter.label.myfans":`My followers`,
"label.rejectoperate":`Rejection Actions`,
"label.report.action.addtodashboard3":`Select Dashboard`,
"label.icon.101":`Textbook`,
"label.data.exp.su.ok":`Exporting`,
"label.appupload.component.type.layout":`Page Layout`,
"template.chart.yscb":`Budgeted Cost`,
"label.tabularreport.selectorder":`Determine the display sort of each report column`,
"email.title.one":`Retrieve Password`,
"label.case.copy.link":`Copy Web Link`,
"label.mr.descreption.oneGroupReData4":`group,is remaining`,
"label.newprocess5.error.des":`You can enter numbers only.`,
"label.partnerCloud.loginButton":`Login Button`,
"label.interfaceconstraint.adminonly":`Only administrators can use this interface.`,
"label.campaign.channel.input.date":`2.Please set the validity periord for your marketing channel:`,
"label.clientwebsiteentranceprofile":`Client Website Portal Profile`,
"UG.opportunity.011":`Import transaction`,
"label.page.copy.value.paste.template":`Copy and paste the merge field value into the template below.`,
"label.notselect":`No Select`,
"label.weixin.input.password":`Please enter your password.`,
"label.email.select.template":`Select Template`,
"label_chatter_ok":`Confirm`,
"permissionService.error":`Permission set assignment failed, please check if the application license has expired or the assignment has reached the upper limit.`,
"label.webtocloudcc.sorry":`Sorry, page error, please try again or contact your administrator.`,
"UG.opportunity.007":`Contact role`,
"label.manageAll.forapproval":`Items to Approve`,
"label.imgfield.type.ref":`Formula Image`,
"label.profile.setcustomtab":`Custom Menu Setup`,
"label.tabpage.datatyoez":`Data Type`,
"label.partnerCloud.basicSetting.editPersonal":`Allowing partner cloud users to edit personal information`,
"label.mr.caption.account":`Find Duplicates and Merge: Coditions for querying duplicates of Accounts`,
"message.serviceterritoryMe.time.violation":`Violation of sending time: sending period is not within the time range of regional members.`,
"pagecreator_page_message_publish_success":`Page published successfully`,
"label.field.formula.timezonetip":`Note the multiple time zone support for handling date/time type functions. when using the system function such as sysdate in a formula to get the current time, it should be replaced by its corresponding multi-time zone function, such as current_date.`,
"label.marketseamemset.specialuser":`Special Member`,
"label.staticresource.message":`Static Resource Detail`,
"label.workflow.rulecondition":`Rule Criteria`,
"component_salesperformance_label_nodata":`Add your business opportunity and return here to view the performance graph.`,
"label.customfields.textarea.tip":`Allow users to enter multiple lines of text, up to 4000 characters.`,
"font-evaluate-module-v1-template":`Custom Template`,
"label.step3.total5":`Step 3 of 5`,
"label.customfields.formula.percent.tip":`Calculate a percent and automatically add the percent sign to the number.`,
"label.sortdesc":`Descend`,
"lable.PowerProcess.edit":`Edit Entitlement Process`,
"label.dongshifang.description":`Configure the information of the Dongshifang to meet the needs of your organization's SMS sending and receiving services.`,
"label.chatter.addressee":`Recipient`,
"vue_label_systemSettings_obj2":`Objects Management Console`,
"label.selectreporttype.tip":`Choose the data type you want to include in this report`,
"label.version.enterprise":`Enterprise Edition`,
"label.area.add":`Add Territory`,
"label.h5.bookmarked":`Bookmarks`,
"label.step5.total7":`Step 5 of 7`,
"front-lightning-module-v1-title-quotation":`Preview Quote`,
"label.search.onlymyrecords":`Limit to items I own`,
"vue_label_commonobjects_noduplication":`Duplicate of {字段} in {记录}`,
"label.customerpage.edit":`Edit Tabs On Custom Pages`,
"message.please.choose.user":`Please select user`,
"label.approval.his.currentactor":`Current Approver`,
"label.field.duplicate.error.msg3":`You can creare 3 unique property fields at most.`,
"label.page_url":`Page URL`,
"label.permission.goback":`Back to Permission Sets`,
"vue_label_commonobjects_view_kanban_notice2":`To view all records, use the list view or split screen view`,
"label.group.no.recent.searchs":`There are no matching recently viewed groups.`,
"label.event.fiducial.point":`punctual`,
"label.integrations.mailchimp.addtolist":`Add the selected leads and contacts from your CloudCC account to your Mailchimp list`,
"label.workflow.configrule.introduce":`Enter the name, description, and criteria to trigger your workflow rule. In the next step, associate workflow actions with this workflow rule.`,
"label.icon.161":`Suitcase`,
"label.recordtype.enable":`Activate`,
"label_mailboxes_limit":`Number of mailbox exceeds the limit.`,
"label.notification.time3":`{0} hours ago`,
"label.setsharerule.step2":`Step 2 Select which records to be shared`,
"vue_label_homepage_somecomponents":`Caution! After adding the component, the height exceeds limit and caused incomplete display. Please delete some components`,
"label.icon.63":`Underground Well`,
"label.use.standard.sharerules":`Use Standard Share Rules`,
"label.button.step2.select.required.field":`Step 2 Select the required fields`,
"lable.Confirm.collect.potential.customers":`Confirm to collect lead {name}`,
"label.version.sum.custompage":`custom page(s)`,
"label.file.ccchat.changefile":`Change file`,
"label.mobile.phone.phone.call":`Call`,
"label.appupload.managed.img":`Controlled`,
"vue_label_chatter_comment":`comment`,
"label.central.european.time":`Central European Time`,
"label.three.quarter":`Third Quarter`,
"label.service.newBuildDialog.filter.editor":`Filter Editor`,
"pagecreator_systemstyle_funcpath":`/ builder / branded style library`,
"label_chatter_collect":`Bookmark`,
"label.custom.page.component.window.settings":`Component Window Settings`,
"component_chatter_file_label_title":`File upload`,
"label.marketsea.button.discard":`Discard`,
"label.Batch.input":`Batch Input`,
"vue_label_campaign_market_members":`Existing market members`,
"label.salescloud.salesdashboard":`Sales Dashboards`,
"message.summaryconditionrepeated":`Sorry, summary conditions duplicates, please re-select!`,
"label.tianyancha.h5.companycode":`Company code`,
"label.quickbooks.description":`Keep track of your QuickBooks Online invoices, payments and estimates.`,
"label.colombia.time":`Colombia Time`,
"label.usermanage.unknown.license":`Invalid license, and you cannot create new users, please contact your administrator.`,
"label.operatedata.selectoperateandobject":`Select opertation (Import or Export) and objects`,
"message.setup.field.picklist.valuerepeated":`List values cannot be repeated, please re-enter.`,
"label.editerror.list":`The data list was not edited.`,
"pagecreator_page_message_save_success":`Page saved successfully`,
"label.icon.154":`Computer`,
"label.emailsync.setting":`Personal Email Settings`,
"label.startuploadfile.step2":`Step 3 Click "start upload" to upload files`,
"label.dashboard.notmeet.conditions":`No matching information found and the dashboard has not been configured.`,
"label.temp.del.conf":`Are you sure you want to delete?`,
"label.sms.authkey":`Authentication Password`,
"lable.oppt.jieduan.choosejieduan":`Select the closed stage`,
"label.tabpage.viewNamez":`Please enter the view name`,
"label.totalQuotation":`Total of Quotation`,
"label.tabpage.hoursagoz":`Hours`,
"label.receiveadminnews":`Receive Administrator's News Broadcast`,
"label.field.is.lookup":`Is the field ralated to the lookup field?`,
"label.any_changes":`Any changes made here will also update your footer in`,
"lable.products.to.assets":`Confirm to transfer product to asset?`,
"label.dashboard.compare":`Comparison`,
"vue_label_chatter_notice1":`After deleting the group, all information in the group will be deleted, but the group files will not be deleted`,
"label_tabpage_exitz":`Logout`,
"label.potentialcustomerflow":`Leads Processes`,
"label.longtext":`Text Area (Long)`,
"october":`October`,
"label.customer.email":`Email`,
"label.partnerCloud.productSet.addChildren":`Add Sublevel`,
"label.defaultline.cannot.greater":`The default number of lines should not exceed 30.`,
"front-detail-module-v1-view-report":`View Report`,
"label.knowledge.setting.hint.sixteen":`Save knowledge and continue to transmit`,
"label.page.use.merged.field":`With Merge Field`,
"label.salescloud.salescloud.continuerecover":`If it continues, the deletion will be done and unrecoverable`,
"front-project-module-v1-from-template-create":`Create from Template`,
"label.exportall":`Export All`,
"label.weixin.recalculate.shared.results":`Recalculate sharing rule results`,
"label.components.isTemplate":`Template Data`,
"label_emailsync_status":`User's Email Status`,
"label.file.library.delete":`Are you sure you want to delete {librayrname}？`,
"label.integrations.username":`Username`,
"front-lightningset-module-v1-detail-page-report-chart":`Report Graphs on Detailpage`,
"label_tabular":`List Layout`,
"label.approverecords":`Approve`,
"vue_label_helpcenter_topic":`Lightning Version Use and Help`,
"label.h5.date.none":`None`,
"lable.outlook.mcto.allrecord":`All Records`,
"label.readandwrite":`Read/Write`,
"label.allfold":`Collapse All`,
"AD":`Address`,
"message.custom.field.donotdelete.reporttype":`The field is referenced by the report data source`,
"label.escalation.setup.newaction.title":`Escalation Action Edit`,
"label.dashboard.snapshot.settings":`Dashboard Snapshots Setup`,
"label.attendance.inner":`Office Worker`,
"chatter.ns":`New Message`,
"label.validate.nowork":`Error: Invalid field. Please re-select the error message location.`,
"label.custom.EmptyCanvas":`Clear Canvas`,
"label.service.miniProgram.fillImageOrder":`Please enter the carousel order.`,
"label.icon.16":`Service`,
"label.selected":`Selected`,
"component_chatter_link_label_name":`Link name`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Preferred Start Time`,
"label.file.uploadNewVersion":`Upload new version`,
"chatter.group.theMembership":`Membership`,
"label.knowledge.recommended.articles":`Suggested Articles`,
"label.appupload.install.parentobj":`Parent Object`,
"label.file.recent":`Recent`,
"vue_label_helpcenter_quote":`The quotation represents the suggested price of your company’s products and services. You can create quotes from opportunities and their products.<br>?In the upper right corner of the detailed information, you can use the button to synchronize the quotation from the business opportunity, or synchronize the quotation to the business opportunity. When the quote is synchronized with the opportunity, any changes to the quote line will be synchronized with the opportunity product, and vice versa. Each business opportunity can have multiple associated quotations, any one of which can be synchronized with the business opportunity.<br>?In the upper right corner of the detailed information, you can generate pdf and preview the quotation, and you can directly print, download or save.`,
"message.error.field.default":`The default value must be a positive integer.`,
"label.campaignmember.main.importmember.contacts.desc":`Import campaign contacts from files.`,
"vue_label_calendar_show_only_this_calendar":`Show Only This Calendar`,
"vue_label_quot_syncfrom":`Sync from Opportunity`,
"label.data.expnode.e_desc2":`2. Export by template: users can select the template to export data.`,
"label.login.verification.mfa.desc1":`You must install a MFA application on your smart device to continue.Common applications that support MFA on smart devices are: Onions, Google Authenticator.`,
"label.jiandangfenpei.desc":`Assign access of the current custom page to profile. Administrators have access to all custom pages.`,
"label_tabpage_thisrecord":`This record`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Rollup Receipts Amount`,
"message.error.object.notvalidcurrency":`Invalid Currency`,
"label.edit.discount":`Edit Discount`,
"label.setup.mobile.offlinecache.setenable":`Enable mobile-side offline function`,
"UG.ST.005":`I've got it, do not show me this page again and login straight next time.`,
"label.assignedapprover":`Assigned Approver`,
"template.chart.htlx":`Contract Type Statistics`,
"scope":`Within scope`,
"label.workmate.search":`Search colleagues`,
"message.validation.isnotdigits":`Please enter the invalid number`,
"label.ccpeak.use.class.time.page":`If the class is called by a custom page, call the invoker() method in the PageClsInvoker class.`,
"setup_mainpage_label_welcome27":`The CloudCC cloud platform provides functions such as importing, exporting, batch deleting, and batch transfer of all object data in the system.`,
"front-epwechat-module-v1-epwechat-integrate":`WeCom Integration`,
"label.file.publiclink":`Public link`,
"front-epwechat-module-v1-input-name":`Please enter name of enterprise`,
"lable.Number.of.columns":`Columns`,
"message.error.dev.service.duplicateparameter":`Service parameters duplicate.`,
"label.projectManagement.percent.complete":`Completion Percentage`,
"label.chatter.nextSevenday":`Next 7 days`,
"chatter.feed.myfollowers":`My Followers`,
"label.bacchtransfer.pleaseselecttouser":`Transfer To`,
"label_partner_workspace_member_memo":`All users with selected profile and permission set can access this partner cloud.`,
"label.marketsea.chosen.member":`Selected Members`,
"label.marketsea.assignment.setup":`Allocation Settings`,
"label.myaccount":`My Accounts`,
"label.schedulejob.setup.schedule.executedate":`Execute Time`,
"label.uploadaccessory":`Attachment Upload`,
"Homepage.News.004":`No recently news.`,
"label.marketsea.name":`Pool Name`,
"label.pending.task":`Open Tasks`,
"label.report.details":`Details`,
"UG.homepage.008":`Understand current business status (sales briefings, leaderboards, sales funnels, etc.), view business opportunities that may be problematic, predict future performance, timely accept and assign important issues, and make informed decisions.`,
"label.h5.similar.opportunity.clear.all":`Clear All`,
"label.tabpage.noz":`No`,
"label.report.recent.all.reports":`All reports`,
"vue_label_lead_to_score":`Click Score to score leads in the current view.`,
"vue_label_normal_receivable_sf":`Collection Plan`,
"label.layout.edittabdistribute":`Edit Tab Layout`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(field)`,
"label.salescloud.field.editoptionlist":`Picklist Edit`,
"APPIntegration.Dropbox.01":`Select files from Dropbox`,
"label.campaign.channel.step2":`Step 2: Set up the default lead field values of this marketing channel`,
"label_partner_new_function":`Function description`,
"vue_label_chat_no_search_results":`No search results`,
"vue_label_commonobjects_detail_visitstate":`Visit state`,
"label.sendemail.send.testemail":`This is a test email,if you can receive this email, you can use this mailbox to send email.`,
"label.attendance.clear.position":`Clear Landmarks`,
"chatter.write.n":`Comment on this post`,
"label_chatter_sendmail":`Send Email`,
"label.remindertime":`Reminder Time`,
"label.app.elegantgray":`Elegant Grey`,
"label.tabpage.ownedz":`Totally`,
"label.select.approval":`Select the approver`,
"UG.Lead.007":`Google Sync`,
"chatter.emailSetUp":`My CCChat Remind Setup`,
"label.default.censor":`Default Examinant`,
"vue_label_notice_uploadavatar_success":`Avatar uploaded successfully`,
"label.sms.title":`SMS Interface Information`,
"front-console-choose-contact":`Choose Contact`,
"label.field.edit.des":`Higher score shows more star icons, and the maximum score is 100.`,
"label.pw.big.letter":`Uppercase`,
"label.select.time.dimension":`Please choose time dimension`,
"UG_Campaign_004":`Import campaign`,
"label.dashboard.summary":`Metric`,
"label.ems.yahoo":`Yahoo!`,
"label.leadscore.rule.name":`Lead Scoring Rule Name`,
"vue_label_calendar_object_name":`Object name`,
"label.icon.69":`Machine`,
"label.reporttotal":`Totals`,
"lable.SalesCommitmentKanBan.theActualContract":`Actual Contract Amount`,
"label.project.member.data":`This user is already a member of the current project!`,
"label.cloudccclass.list.viewremark":`Help for this Page`,
"label.deleteObject.isNotAdministrator":`You are not a administrator and you cannot delete objects.`,
"lable.edit.queue.nameandemail":`Queue Name and Email Address`,
"label.recordtype.tabname":`Record Types`,
"label.file.is.ok":`Is it ok`,
"label.knowledge.language.german":`German`,
"label.layout.realityapprover":`Actual Approver`,
"label.ems.with7day":`Within 7 days`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Set up`,
"label.weixin.edit.polls":`Change vote`,
"label.layout.mobile.default.tab":`Select the default on tab in Mobile App`,
"vue_label_report_deletegroupcolumn":`Delete Group Column`,
"label.group.archived.success":`Archive successfully`,
"label.customfields.formula.returntype":`Formula Return Type`,
"label.file.followers":`Followers`,
"label.textmessage.new.templates.message1":`Template name cannot be empty！`,
"label.selected.field.length":`No more than 10 selected fileds`,
"ObjectDetailed_ViewKeyInformation_Layout":`Edit Key Information`,
"label.paging.totalofpage":`A total of {0} pages`,
"label.ccchat.message.new.error41":`To talk to more people, try using groups`,
"message.recordtype.detail.noselectlist":`No picklist can be displayed`,
"label.conditiontag.lookup.title":`Select the picklist values below to add.`,
"label_partner_setup":`Partner Cloud Settings`,
"front-epwechat-module-v1-android-packname":`Android Package Name:`,
"lable.custom.Current.CY":`Current CY`,
"label.newprocess2.desc":`If the discount is greater than 0.3%, evaluates to true.`,
"label.operatedata.selectobjectfields":`Select the fields of exported object`,
"report_reportdatasource_label":`Report Data Source`,
"label.chosesubject.others":`Other Activities`,
"label.list.desc2":`You can generate a PC page for PC-side access or a mobile page for mobile device access.`,
"vue_group_several_groups":`{totalSize} groups`,
"label.page.button.linkurl":`Button or Link URL`,
"show.week":`Show Weekend`,
"label.gotocalendar.new":`Go to calendar and create events`,
"button.reset.advancedsearch":`Clear Advanced Search Conditions`,
"label.h5.chatter.feedandcomnum":`Post and leave a message`,
"lable.opppdt.addpdt.table.unitprice":`Sales Price`,
"label.dataimport.validate":`Select the verification to be executed`,
"label.lead.score":`Lead Scoring`,
"vue_label_help_product":`Product & price brochure`,
"label.role.select":`Select Roles`,
"lable.opppdt.selPdt.searchproduct":`Find Products`,
"component_event_label_newevent":`New events`,
"front-invoice-online-payment-setup-configure-button":`Configure Now`,
"label.stdashbord.xsld.business.img2":`Total amount of opportunitiy stage with probability 1%-99%`,
"label.event.moveup.2week":`2 weeks ahead`,
"label.partnerCloud.priceOfManual.allCustomer":`All Accounts`,
"lable.account.dep":`Click the New button to define a new fiscal year.`,
"label.dataimport.insertdata.error.null.update":`The value of $schemefield_name$ in this record is null and cannot be updated. Import of this record has been ignored.`,
"label_component_helper_businesschange_0activity":`30 days without any activity`,
"lable.account.NextbbDays":`Next 60 Days`,
"label_scope_length":`Range-Length`,
"label.customfields.operation":`run a data export`,
"serviceappointment.save.workorder":`Please choose a work order associated with the work order line item.`,
"label.field.update.hide.editor":`Hide Formula Editor`,
"button.partner.new":`New partner cloud`,
"label.stdashbord.xsld.business.oppdetails":`Opportinity Details`,
"message.pleasewaitingnextversion":`This feature will be available in the next release.`,
"label_tabpage_potentialcustomersz":`Leads`,
"label_emailtocloudcc_step2":`Step 2`,
"label.weixin.username":`Name`,
"label.quickbooks.viewlist.type":`TYPE`,
"front-kefu-moudle-v1-Select-seats":`Choose Agent`,
"label.customsetting.manage":`Manage`,
"label.tabpage.field":`Field`,
"label.custom.page.button.icon.URL":`Button Icon URL`,
"font-evaluate-module-v1-evaluation-link":`Add evaluation link:`,
"vue_label_salesfunnel_notice3":`Number of opportunities with a probability of 1% - 99%`,
"front-email-payment-describe":`Thank you for your support for our business. You can pay online through the following link, and view, print and download invoices in PDF format.`,
"label.productsales.today.noevttskaddevt":`There are no open events and expiring tasks, you can click “ ” in the upper right corner to add new event.`,
"component.setup.iframe.label.memo":`Click the settings icon and enter the embedded url address.`,
"front-email-payment-select-country":`Please enter the country`,
"label.ems.starred":`Starred mails`,
"component_setup_label_object":`Objects`,
"label.query.detail.viewpartneruser":`View Partner User`,
"this.year":`This Year`,
"serviceresource.isactive.notactive":`This service redources is not enabled.`,
"label.marketing.message.recipientisnull":`The recipient cannot be empty`,
"label.unfold":`Expand`,
"label.service.assetBOM.view.tip":`You do not have the permission to view asset BOM. Please contact the administrator.`,
"label.validate.function.funcExplain.ISCHANGED":`Check the field value is different from the previous value. If not, return TRUE, otherwise return FALSE.`,
"label.validate.function.funcExplain.NOW":`Returns a datet and ime representing the current moment`,
"label.phoenix.islands.time":`Phoenix Is. Time`,
"vue_label_checkduplicate_complete_filter_rules":`Please complete filter conditions`,
"vue_label_report_rowcount":`Row Count`,
"chatter.p":`person`,
"label.umeng.activity.distributetask":`assigned you a task.`,
"UG_quota_05":`Bisync with Opportunities`,
"june":`June`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Tuesday`,
"vue_label_commonobjects_view_chart_upto5":`Up to 5 groups`,
"vue_label_opportunity_contactrole_searchallcontacts":`Search through All Contacts`,
"label.custom.field.task.notice":`Task Notification`,
"label.weixin.insert.address":`Insert Location`,
"label.attachementNew.desc":`Archive the attachment to a document, and the attachment cannot be deleted.`,
"setup_mainpage_label_welcome18":`CloudCC's enterprise-level permissions settings let you control the usage rights of individual users while working with data and modules. Role-based permission settings also include user positions, groups, roles, data sharing rules, and field-level security controls to enable data sharing between different people and departments of the enterprise.`,
"front-kefu-instance-noarea":`No instance has been created for this area, please reselect`,
"label.please.ChooseMax":`Please choose up to {a} product options.`,
"label.businesschance":`Opportunities`,
"label.verticalline-group":`Vertical Columns-Column grouping`,
"label.ordering.platform":`Shop`,
"label.product.pricebooks.ples":`Please select Price Book`,
"vue_label_norm_addcomponent":`New Component`,
"label.ServiceCloud.Installation.address":`Installation Address`,
"vue_label_report_groupcolumn":`Group Column`,
"label.ccchat.person.invite.notallsucc":`{0} email addresses were saved but not sent. to send an invitation, correct the following error and click send.`,
"label.customfields.optionlist.tip":`Allows users to select a value from a list you define.`,
"UG.activity.07":`Create a task`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Last`,
"label.permission.accessname":`Access Name`,
"lable.custom.year.stadate":`Custom Year Start Date`,
"label.ems.inputmails":`Receive email server (i)`,
"label.cpq.quote.transfer.order.already":`This quotation is transfered to order. Please delete the original order, then regenerate an order.`,
"label.sendletter.status":`Campaign Member Status`,
"vue_label_commonobjects_view_save_as_view":`Save as view`,
"message.mobilechooseatmostfive":`Select up to 5 fields`,
"label.errormessage.batchedit.nopermission":`No data record which you have edit permission.`,
"label.dataoperate.tip":`Select the operation and the objects.`,
"label.enableoperate":`Available Actions`,
"label.ems.usernamepassword.error":`Mailbox account or password error.`,
"label.campaignmember.selectmember.deletemember":`Remove members from`,
"label.Tab":`Tabs`,
"label.emailobject.template.message1":`Please select a field, and click "Insert". With the ">" means click to view more available fields.`,
"label.approvalstep3.tip":`Specify the user who should approve records that enter this step. Optionally, choose whether the delegate of approver is also allowed to approve these requests.`,
"label.inusing":`Active`,
"label.edit.select.tre":`Checkbox List`,
"label.appointmentconfirmail.wizard.title1":`Hello {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Set Up Alipay`,
"lable.edit.queue.avobj":`Available Objects`,
"vue_label_checkduplicate_verify_all_characters":`Verify all characters`,
"label.huntingzone":`Search Range`,
"label.request.approved":`The request has been approved, do not repeat.`,
"label.sharerule.msgerror":`Server internal error`,
"front-epwechat-module-v1-tick-unbound":`Please tick agree and accept the above unbinding information`,
"label.console.step6":`Step 6 Choose How Lists Display`,
"label.multilang.micropost.vote":`{0} ticket(s)`,
"message.error.appid.null":`The secret key cannot be null!`,
"lable.product.delq":`Delete Issues`,
"label.h5.approval.leixing":`Approval Type`,
"label.edit.field.select.style1":`Tile each option`,
"label.passwordPolicy.setup.alpandnum":`Must mix alpha and numeric characters`,
"label.ems.close2":`Close`,
"label.report.reporttypetitle":`Data source`,
"label.umeng.approval.approvalsuccess":`was submitted for approval.`,
"label.page.showamount":`Total records per page:`,
"label.copy.asset.successfully":`Copy asset BOM successfully.`,
"vue_label_homepage_bigscreen_dark":`Dark`,
"vue_label_email_selected_members":`Selected Members`,
"label.file.preview":`Preview`,
"label.partner.new.step3.name":`Name`,
"label.forecast.settings.periods.ago":`cycle(s) ago`,
"label.evaluation.praise":`Positive`,
"label.cloudccsite.edit":`Site Edit`,
"label.knowledgebase.advanced.filtering":`Advanced Filter`,
"label.knowledgebase.framework":`Frame`,
"vue_label_pool_ownedpool":`Master Pool`,
"label.exchange.sync.setting.license":`With this feature enabled, some of your organizational data may be saved to Microsoft Exchange server in internal deployment or cloud-base form and processed through Microsoft Exchange server.`,
"front-console-conversation-btn2":`Email Reply`,
"label.projectManagement.thelastone":`This is the last record.`,
"message.duplication.confirmscript.mergeoperation":`These records are merged into one record through the selected values. Note: the action of merging cannot be revoked. Are you sure you want to merge the records?`,
"lable.outlook.detail.nosyn":`Out of sync`,
"label.iscopy":`Allowing copy`,
"message.matrixReportSetupStage.row":`Please select 【Specify Row Headers】 subtotal basis, and you must select one subtotal basis at least in two subtotal bases.`,
"label.forecast.forehistory.possibility":`Probability`,
"label.timetrigger.validate":`The value entered must be a positive integer, and the system will automatically perform the workflow actions when the must be a positive integer,which is the time when the dependency of the workflow is met,the system will automatically execute the workflow operation.`,
"member.name.choice.field":`Member's name is a required field !`,
"label.undone_external page":`This is irreversible, so please confirm. This form is not used on any login page, but may be used elsewhere. For example, you may have used the embed code to insert it into an external page.`,
"UG_Lead_012":`Import clues`,
"component_chatter_label_fans":`Followers`,
"label.systeminfo":`System Information`,
"label.mr.descreption.oneGroupNote1":`Please select at least two pieces of data and click [Load Selected Information] to jump to the data merge page.<br>This is the`,
"label.wtd.changefields.selfields":`Select the fields to be on your Web to CloudCC form:`,
"message.error.fileinfoid.null":`fileinfoid cannot be empty! File information id`,
"label_tabpage_cownerz":`Change owner`,
"setup_layout_button_save":`Save`,
"Dashboard.View.Createdbyme":`Dashboards I Created`,
"label.escalation.setup.detail.order":`Order`,
"button.partner.start":`Start using`,
"label.htyj.remark1":`Your current edition does not support viewing contract object`,
"component.event.label.person":`Assigned To`,
"label.appointmentconfirmail.wizard.subtitle3":`Location`,
"label.emailtocloudcc.filed.username":`Email Address`,
"label.vlidaterule.remark":`Define a validation rule by specifying an error condition and a corresponding error message. The user can correct the error and try again.`,
"message.duplication.label.insertoption":`Action On Create`,
"front-web-module-v1-detail-comment-toast":`Please complete all the evaluations`,
"label.import.page2.notsuitedfiledwillbenotimport":`Notice: The system will not import unmapped fields`,
"label.h5.similar.opportunity.enable":`Enable Similar Opportunities`,
"label.allunfold":`Expand All`,
"component_setup_iframe_label_inputurl":`Enter the url address`,
"label.manage.all":`Manage All`,
"label.mobile.side.tab.cs":`Common functions`,
"label.datamanage.contact.information":`Contact Information`,
"lable.outlook.edit.sel":`Select a Value`,
"label.imgfield.type.url.tip2":`For example: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Section Properties`,
"label.date":`Date`,
"vue_label_commonobjects_detail_openfilter":`Expand Filter`,
"label.loginip.pagecue":`Enter the range of valid IP addresses from which users with this profile can log in.`,
"vue_label_email_not_valid":`The email you entered is not a valid email address`,
"label.page.step5.add.application":`Step 5 Add to Custom Apps`,
"label.dashboard.donot.delete":`You cannot delete this folder because some dashboards in it.`,
"label.visitAPPexchange":`CloudCC App Store (New Window)`,
"label.generate.location":`Generate Latitude and Longitude Data`,
"lable.quote.syncing.syncingbutton":`Sync`,
"label.pw.error.text":`The two passwords you typed do not match.`,
"label_partner_setup_Enable":`Verify`,
"label.file.preview.unav":`Preview unavaliabled`,
"label.sms.tip":`From The Internet`,
"setup.mainpage.label.welcome21":`The CloudCC cloud platform provides user-defined email template function, which is convenient for users to use and improve work efficiency.`,
"label.trigger.for.example":`For example: update the opportunity in account update trigger, update the account update trigger in opportunity and trigger the account update trigger. If there is no if no conditional control in the trigger, then the system allows for up to 3 such circular calls.`,
"setup.layout.button.layoutprop":`Propertities`,
"component.chatter.label.fans":`Followers`,
"lable.PowerProcess.event.edit":`Edit Milestone`,
"label.detailintro":`Line Items Description`,
"vue_label_report_nosearchresults":`No search results`,
"error.name.repeat":`Name cannot be repeated.`,
"label.emailEncoding":`Email Coding`,
"label.partnerCloud.financeSetting.enableAccount":`Activate Rebate Account`,
"label_emailtocloudcc_clear":`Clear`,
"setup_mainpage_label_welcome12":`The user can complete the report definition by clicking the mouse, without programming, and following the system prompt steps. The system has a list report, a summary report, and a matrix report to choose from. Display options for all fields are also available. Remove unnecessary field information. At the same time, it provides a variety of graphic displays including strips, fold lines, rings, funnels, and cakes, so that users can see at a glance.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Contract Start Date`,
"front-starter-v1-potential-customer-tips-success":`Activcate Lead Pool successfully`,
"UG_Forcast_02":`Forecasts are estimates of expected sales for a given period, and forecasting models can help you determine product demand and sales revenue in a certain period. Managers can use forecasts to set goals and measure team progress. The organization's overall forecast can reflect the summary of all sales by sales representative (regardless of the stage of completion of sales from the pipeline stage to the closed stage).`,
"label.escalation.setup.detail.ruleentries":`Rule Entries`,
"lable.SalesCommitmentKanBan.allComplete":`Total Complete Amount`,
"label.appupload.install.apicanuse":`The api name is available`,
"label.organiza.field":`Organizition Fields`,
"button.partner.workspace.manage":`Management`,
"lable.PowerProcess.setevent":`Milestones Setup`,
"label.emailobject.groupemail.msg2":`Email address is missing. This will prevent the email from sending to this recipent.`,
"label.h5.orderbyname":`Sorted by name`,
"vue_label_salesadvance_opportunities":`Opportunity number`,
"label.appointment.disable.cancel":`Deactivate Cancellation`,
"label.trigger.folder.edit":`Trigger Page : Edit Folder`,
"label.customfields.new.step2.opration.unique.info.v2":`Consider "ABC" and "abc" as different values (case sensitive)`,
"label.icon.40":`Positioning`,
"label.eventmenuandlink":`Event Buttons and Links`,
"label.service.gantt.candidate":`Candidate`,
"label.top.userphoto":`User Photo`,
"label.appointmentconfirmail.wizard.btn2":`Cancel meeting`,
"label.print":`Print`,
"saveandreturn":`Save & Back`,
"lable.account.CurrentandNextCY":`Current and Next CY`,
"label.group.no.recent1":`You have not viewed any active groups.`,
"lable.Asset.conversion":`Generate asset according to "Asset Transition" of the order product when transferring assets.`,
"label.emailtocloudcc.button.sure":`Confirm`,
"label.Path.List":`Path List`,
"label.please.rule.name":`Please enter the name of the rules.`,
"label.knowledge.category.hint.six":`Available Category Group`,
"setup_mainpage_label_welcome28":`Instructions: Click on the menu on the left side of this page → Manage Settings → Data Management → Data Import and Export, Batch Transfer, Batch Delete.`,
"vue_label_commonobjects_view_chart_editchart":`Edit Chart`,
"label.permission.detail.app.object":`Object Setup`,
"label.multilang.totalpage":`of`,
"label.marketsea.button.return":`Return`,
"Click.to.load.more":`Click to load more`,
"label.validate.globalvariable":`Global Variable`,
"label.marketsea.iseditseabymanager":`Allow administrator to change the pool belongs to.`,
"label.price.yuan":`Price (Yuan)`,
"label.service.resource.uesr.tip":`Select a user to create service resources and the resources type cannot be crew.`,
"vue_label_help_viewusageguide":`View User Guide for Lightning`,
"label.autoRegister.changepwd.setpwd.too.long":`Too long`,
"label.campagin.roi.fwsl":`Number of visits`,
"label.campaign.mobile":`Mobile App`,
"UG.Lead.012":`Import clues`,
"link.recordtype.detail.backtoobject":`Back to Custom Objects`,
"front-kefu-moudle-callcentrt-hasclose":`Call Center Has Closed`,
"label.category.5":`IT High-tech`,
"label.import.page1.selectwayofdealdata":`Select data processing mode`,
"chatter.emailReceiveEmail":`Receive CCChat Reminder`,
"vue_label_file_manage_lib_members":`Manage file library members`,
"label.appupload.upload.overview":`Recapitulation`,
"label.service.miniProgram.inputNumber":`Please fill in a number within 0-999.`,
"label.emailtemplate.finishdetailinfo":`Fill in the Email template details.`,
"label.weixin.fmu.before.day":`{0} days before`,
"label.integrations.login":`Login`,
"label.dashboard.setUpHomePage":`Homepage has been set to display`,
"label_partner_common_webSit":`Domain`,
"front-epwechat-module-v1-unbound-user":`Unbound Users`,
"label.partnerCloud.basicSetting.offline":`Activcate Offline Payment`,
"label.start.loginip":`Start IP Address`,
"label.projectManagement.delete.subtasks":`Sub-task and all related information of this sub-task will also be deleted if you remove the sub-task, and the data cannot be recovered. Are you sure to confirm the deletion?`,
"label.message.batchapp":`Batch Approval`,
"message.duplication.label.ruletitle":`Duplicate Rules`,
"label.all_networks":`All Network`,
"label.select_columns":`Select the columns you would like to see for your form submissions`,
"vue_label_notice_uploadavatar_exceed":`The size of the uploaded avatar image cannot exceed 2MB`,
"message.error.get.failed":`Failed to get information!`,
"label.quickbooks.viewlist.duedate":`DUE DATE`,
"label.ccchat.topic.search":`Search Topic`,
"label.forecast.shre.manager":`Assign Manager`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Thursday`,
"lable.product.pricebooks.copy":`Clone From Existing Price Book`,
"label.instrumentPanel.minLabelname":`This value must be positive and less than the breakpoint 1 value.`,
"front-market-form-createdsecond":`Autofill Field on the Registration Page`,
"label.submission_detail":`Submission Detail`,
"label.customfields.checkbox.tip":`Allow users to select a True (checked) or False (unchecked) value.`,
"label.escalation.setup.list.description":`You can determine automatically actions when the cases met the criterias and beyond the specified time. When you escalate a case, you can choose to automatically notify the user and reassign the case to a new user.`,
"UG.Forcast.05":`Forecast settings: step {0}/{1}`,
"label.data.import":`Data Import`,
"label.upload.error.cause":`upload failed due to`,
"label.search.change.remark":`This setting applies to the objects displayed on the left side of the homepage`,
"serviceappointment.edit.status.limitwithstatus":`The status of the service appointment cannot be changed from {0} to {1}`,
"label.department.operation":`Operation`,
"label.textmessage.vonage.message3":`To look for API Key and API Secret, you can login to your Vonage API account and go to "Settings" under your account name. To look up phone numbers you have in your Vonage API account, you can go to Numbers under Products, and click on "Your numbers" to see all phone numbers you have.`,
"label.privacystatement.dialog":`Privacy Statement (New window)`,
"label.datamanage.import.leadfield":`In the following list, select the fields in the import file taht should import leads. Then click next:`,
"label.appupload.upload.install.failar":`Install Failed`,
"label.viewall":`View All`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat reply to Bookmarked`,
"lable.custom.dp":`This page allows you to define custom years.`,
"label.mobile.more.share":`Share with Colleagues or Groups`,
"lable.name.cannot.be.empty":`Name cannot be empty`,
"label.autoRegister.changepwd.setpwd.password":`Your password`,
"label.multipleactivity.aevents":`Event(s)`,
"label.many.dayline.lastday":`Last Day`,
"lable.Please.bind.the.QuickBooks.record.first":`Please bind QuickBooks records first.`,
"vue_no_related_dashboards":`No relevant dashboards!`,
"label.newdashboardpage.name":`Name`,
"vue_label_commonobjects_detail_network":`Relation Net`,
"label.tianyancha.reginstitute":`Registration authority`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`The lower bound of each level shall equal to the upper bound of the upper level when pricing by blocks.`,
"label.chat.file.upload.info":`Upload Files`,
"label.appexchange.vlidaterule":`Validation Rules`,
"label.salescloud.salesdashboard.current.business":`Current Opportunities`,
"label.app.step4.homeisfrist":`Home page must be the first tab and cannot be removed.`,
"label.weixin.micro.research.optionname":`Micro Survey Choice Name`,
"label.paging.totalofnbsp":`A Total of {0}`,
"label.opportunity.perm.title":`Request Access`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Error of lessee verification. Please reenter`,
"label.unsaved_changes":`If you continue the operation, unsaved changes will be lost.`,
"label_partner_all_description":`Description`,
"lable.account.Next.CQ":`Next CQ`,
"chatter.feed.menutype.feed.me":`To Me`,
"label.sourcetranstemp":`Source - Produces one file that contains all of the text that is translatable`,
"label.apply.newuser.validate":`CloudCC registration of new user, validation code:`,
"label.user.password.error":`User name or password error, or invalid user!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`No quote line items are found in this quote line group. Please click "Add Product" to add.`,
"lable.PowerProcess.time.filed":`Based on the date and time field on {detailInterestType}`,
"label.file.default.value.is.integer":`Only integers can be entered`,
"label.processsetting.please.select.field":`Please select fields.`,
"label.app.step3.introduce":`The file size of a custom app logo must be smaller than 20 KB. Image dimensions should be a maximum of 300 pixels wide by 55 pixels high for best results. Larger images will be resized and may appear distorted.`,
"button_partner_save":`Save`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Available Custom Pages`,
"label.salescloud.teamrole.optionlist.choose.correct":`The same item existes in the list, please modify.`,
"System_ChangeUser_Info_001":`Owner changed and click to return to the previous page.`,
"front-console-no-contact":`No Contact`,
"component.assistant.label.overduetask":`Opportunities with Overdue Tasks`,
"label.roleofpartner":`Partner Role`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`You and {0}`,
"front-template-V1-Please-select-a-picture":`Please choose an image`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Total Signed Commit Rate`,
"label.h5.similar.opportunity.step2.conment":`Select between 3 and 10 fields or related lists to match against when finding similar opportunities.`,
"label.projectManagement.alert.frequency.will.not.work":`When you select No, reminder will not work.`,
"vue_label_fllscreen":`Fullscreen View`,
"label.customfields.selectcontainfieldlayout":`Select the page layouts that should include this field.`,
"label.appointment.wizard.subtitle1-4":`45 min`,
"label.tianyancha.businessverify.unagree":`Disagree`,
"label.unique":`Unique`,
"setup_mainpage_label_welcome10":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Object → Object Name → Custom Layout.`,
"vue_label_account_subsidiary":`Subsidiary`,
"label.dataimport.format.error":`Format error, please use the format like MM/DD/YYYY or YYYY-MM-DD.`,
"label.email.new":`New Email`,
"label.log.descri":`Operate Description`,
"vue_label_dashboard_componentname":`Please enter the component name`,
"label.weixin.quick.reply":`Quick Reply`,
"label.productsales.payment.badversion":`Your current edition does not support viewing contract object so you cannot view payment list.`,
"label.position":`Location`,
"label.Annex.Conditions":`Add logical filters for additional conditions （e.g.：1 And 2 Or 3 ）`,
"label_tabpage_endz":`End`,
"label.setup.mobile.bottombutton.prompt":`Notice: To save these settings will change the user's original settings of the mobile app's first-level.`,
"lable.Edit.template":`Edit Service Report Template`,
"vue_label_report_onlydisplay2000":`Only display 2000 data`,
"label.salescloud.salesdashboard.sign.account.top5":`Top 5 Signed Accounts`,
"label.weixin.ontime":`Punctual`,
"font-evaluate-module-v1-disappoint":`Sorry to disappoint you!`,
"chatter.sel.addre":`Up to 5 recipients can be selected!`,
"label.mobile.phone.month.summary":`Monthly Summary`,
"label.partnerCloud.priceOfManual.selected":`Selected Account`,
"label.south.georgia.time":`South Georgia Standard Time`,
"label.create.ccdocument":`Add Attachment`,
"label.chatter.to":`To`,
"label.ems.minute":`Minutes`,
"label.mobile.phone.submit.tome":`Submitted To Me`,
"label.approvalstep1":`Step 1 Enter Name and Description`,
"label.h5.similar.opportunity.last.months9":`Recent 6-9 Months`,
"Opportunity_Detailed_Phase_Label_003":`Change Stage`,
"lable.PowerProcess.time.input":`Please enter a time.`,
"label.stdashbord.xsld.business.yqzsr":`Expected Total Amount`,
"label.icon.64":`Searchlight`,
"label.data.choses.i_desc":`According to your needs, import data from a single object.`,
"label.integrations.mainlandchinaleads":`Mainland China Leads`,
"vue_label_notice_savemenu_success":`Menu saved successfully`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Choose Easemob online service`,
"label_chatter_name":`Name`,
"label.Viewon_Linkedin":`View from LinkedIn`,
"lable.PowerProcess.chioce.event":`Please select milestone.`,
"component.chatter.file.label.maxsize":`Maximum file size is 20m`,
"label.validate.function.funcExplain.SECOND":`Return second of day (From Date/Time fields)`,
"label.data.downpage.i.title.num4":`4、If you have a lookup relationship field and a master-detail relationship field in the object you want to import, the value for that field must be ID, otherwise it is invalid.`,
"label.icon.139":`Currency`,
"label.app.step4.atleastone":`The Home Tab cannot be removed.`,
"label.weixin.input.telephone":`Please enter the mobile number`,
"label.setup.mobile.bottombutton.remark":`An organization could configure the initial settings of the first-level page according to the business process.`,
"label.file.searchs":`Search Files...`,
"vue_label_email_there_is_no_draft_yet":`There is no draft yet`,
"front-kefu-moudle-v1-bind-seats":`Bind Agent`,
"label.customfields.lookupmuti.tip":`Creates a relationship that links this object to another object. The relationship field allows users to click on a lookup icon to select multiple values from a popup list. The other object is the source of the values in the list.`,
"label.integrations.password":`Password`,
"label.data.newtemplate.t_conditions":`Template Conditions`,
"message.error.repeatsubmit":`The submission is repeated or multiple window modifications are opened on the same page. If the latterm, please submit in the newly opened window.`,
"label.umeng.approval.approvalreassign":`Approval request for the #obj is reassigned. #objname`,
"lable.edit.queue.selobj":`Error: Queue must have at least one selected object`,
"label.compact.layout.frame":`Page layout frame`,
"label.sms.companyname.dsf.infor":`This service only supports mainland China`,
"template.report.individual.case.source":`Case Source`,
"pagecreator.button.pcpage":`PC end`,
"vue_label_commonobject_selectdatatime":`Choose date and time`,
"label.icon.181":`File`,
"label.loginip.setup.please":`Please specify the IP range.`,
"vue_label_dashboard_?secondarygroup":`Please select a secondary group`,
"lable.outlook.mcto.pleasedes":`Enter the email domains you do not want to associated with, and separated them by ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} send an email to {1}.`,
"label.sendmail.step4":`Step 4 The emails you submitted are being processed.`,
"label.monitorsys.delete.source":`Description`,
"label.monitorsys.log.datetime":`Download key operation audit log within search time range(Excel.xls)`,
"component_chatter_label_myfans":`My followers`,
"label.tianyancha.h5.registereddate":`Registered date`,
"label.multilang.feedtrack.operatecreate":`{0} record has been created：`,
"label.console.step6.no":`Choose How Lists Display`,
"four":`Four`,
"message.confirmsetpwdforuser":`Reset password for new users?`,
"label.cape.verde.time":`Cape Verde Time`,
"label.queue.new":`New Queue`,
"label.cloudccsite.start":`Active Site Homepage`,
"label.data.exp.way":`Export Method`,
"label.lock.record.donot.delete":`You can not delete the locked records.`,
"label_emailtocloudcc_filed_type":`Provider`,
"frame_personinfo_label_minipic":`Thumbnail Image`,
"label.checkfield.choosetab":`Select Fields to Check`,
"component.setup.tabs.label.default":`Default page`,
"page.404.button.toknowmore":`Learn More`,
"vue_label_SMS_message_sent_cannot_be_empty":`The content of the message sent cannot be empty`,
"label.lookupreplaceselectvalue":`Find and Replace Picklist`,
"pagecreator_layout_button_new":`New layout`,
"label.mobile.more.upload":`Upload New Version`,
"front-kefu-moudle-v1-Connection-failure":`Connection failed`,
"label.version.support.unlimited":`Unlimited Support`,
"message.error.notmarketseamember":`Not a member of the lead pool`,
"label.taskandincident":`Tasks and Events`,
"label.report.export.print.title":`Print Report Views`,
"label.file.publicview.error2":`The public link is incorrect, please use a new public link`,
"label_chatter_cancel":`Cancel`,
"front-web-module-v1-detail-comment-satisfied":`Satisfaction Level`,
"label.knowledge.delete.topic":`Error while deleting the subject used in this knowledge article.`,
"label.forecast.forehistory.all":`All`,
"label.displaybutton":`Displayed Buttons`,
"label.icon.148":`Robot`,
"label_tabpage_ok":`Confirm`,
"label.checkfield.merge.mainrecord":`Primary Record`,
"label.notification.arketsea.restored":`{5} restored {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Instructions: Click on the menu on the left side of this page → Manage Settings → Create → Application`,
"front-kefu-moudle-v1-jtrrt-connect":`Associating CloudCC users with TRRT's extensions`,
"vue_label_calendar_please_select":`Please select the displayed field`,
"setup.layout.label.pagename":`Page Layout Name`,
"template.chart.schdywjhz":`Campaign Opportunity Value`,
"label.access_report":`Who can access this report?`,
"label.assignment.layout.section.optional":`Available`,
"label_chatter_recently":`Recently`,
"lable.chat.advanced.setting":`Advanced Setup`,
"label.knowledge.category.hint.eight":`Category Group`,
"message.error.facebookuid.null":`Facebook user ID cannot be empty!`,
"label.step5.total6":`Step 5 of 6`,
"label.is.cancel.delete":`Cancel the deletion?`,
"setup_mainpage_label_welcome11":`Custom report`,
"label.answers":`Answers`,
"label.approvalstep1.tip":`Enter a name, description, and step number for your new approval step.`,
"template.chart.htjeph":`Contract Amount Ranking`,
"label.campaigns.onsiteregistration":`On-site registration`,
"front-epwechat-module-v1-input-agentid":`Please enter agentId`,
"label.emailobject.wizard.desc2":`Track emails being opened and open times`,
"label.multilang.chatterdetial.vote":`{0} ticket(s)`,
"label.customsetting.manage.value":`Custom Data`,
"front-electronic-export-listCount":`{totalView} data in total in the current view, select the imported data`,
"label.dashboard.create.prompt":`Can't create dashboards over tabular reports.`,
"label_tabpage_askz":`What would you like to ask`,
"label.ems.sentmail":`Outbox`,
"label.reportlist.untop":`Unpin from Top`,
"label.owner.h5.plzchose":`Please select the owner and save`,
"label.callcenter.addup.10.pieces":`Add 10 data once at most`,
"label.ccdocument.save":`Save Document`,
"label.productcannotnull":`Product cannot be empty`,
"label_tabpage_enabletomobile":`Whether to enable the mobile-side`,
"lable.account.CYAgo":`2 CY Ago`,
"lable.Select.the.returned.high.seas.pool":`Select the Pool to Return`,
"tuesday":`Tuesday`,
"label.partnerCloud.basicSetting.partnerPayment":`Activate Partner Fund`,
"label.validate.function.funcExplain.WEEKDAY":`Return a specific day of the week. 1 represents Sunday and 7 represents Saturday`,
"label.query.detail.manageexuser":`Manage External Users`,
"vue_label_systemSettings_environment":`Environment`,
"component_setup_tabs_label_delete":`Delete`,
"label.weixin.delete.ccchat":`Are you sure you want to delete this post?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`You can seleted up to 10 fields as your search criteria.`,
"label.project.hit.fourteen":`Milestone Update Notice`,
"label.createby":`Created By`,
"label.moreoperation":`More Operate`,
"label.lock.tip":`Lock the records to avoid being edited`,
"label.check.input.condition.three":`Field type of formula and rollup summary are not supported to insert`,
"label.quote.dingjia":`Pricing`,
"label.currentuseremail":`The Current Email Address of user`,
"UG_homepage_004":`Automation`,
"chatter.link":`Link`,
"label.new.zealand.standard.time":`New Zealand Daylight Time`,
"APPIntegration.Dropbox.setting.02":`Deactivate`,
"label.version.searchandmerge":`Check Duplication & Merge`,
"label.allmenus.showmsg.nomenu":`Did not find the menu！`,
"front-template-V1-Enable-disable":`Activate | Deactivate`,
"label.marketing.setting4":`Registration successfully returns to the default URL`,
"UG.Forcast.07":`Allow Forecast`,
"vue_label_systemSettings_correlation":`Related List Display Mode`,
"label.cloudccsite.remark.length":`Allows users to enter up to 255 characters`,
"label.favorite":`Bookmark`,
"template.report.converted.leads":`Converted Leads`,
"label.campaignmember.main.description":`Use this page to manage campaign memebers. You can add new campaign members or update current campaign members status.`,
"label.salescloud.teamrole.account.organization":`Team members may have a higher level of access to this account than default access settings by your orgnization.`,
"label.permission.modifyAppPermission.canselectapp":`Available apps`,
"front-epwechat-module-v1-self":`Selfcreated App Setup`,
"message.duplication.label.matchexactletters":`Exact`,
"label.appointmentdetail.wizard.title18":`Friday Plan`,
"label.area":`Territories`,
"label.sso.saml.sp.username":`Username`,
"lable.outlook.new":`New Exchange Sync Configuration`,
"label.custom.field.close.conversion":`Closed - Converted`,
"lable.outlook.detail.tmaping":`Map Task Fields`,
"label.emailobject.emaildetail.nextactivity.event":`Add an event`,
"vue_label_commonobjects_detail_date":`End date cannot be less than start date`,
"vue_label_email_mark?as":`Mark as`,
"label.guestgroup":`Account Team`,
"label_emailtocloudcc_filed_server":`Server`,
"label.icon.186":`Advisory`,
"label.department.user.edit":`Edit`,
"label.custom.page.component.button.settings":`Component Button Settings`,
"label.partnerCloud.orderingPlatform.nextProduct":`Do you want to save the current product configuration and configure next product?`,
"vue_label_appstore_cloud_platform":`cloud official platform`,
"label.page.previous":`Previous`,
"label.direct.dashboard.week.report":`New Weekly Work Note`,
"label.ServiceCloud.prompt.warning":`No resources distribution statistics by address.`,
"label.emailtocloudcc.position":`Position`,
"vue_label_email_please_enter_the_message_content":`Please enter the mail content`,
"labal_About_to_jump":`It is soon to redirect.`,
"label_profile_mobile_setup_stand":`Standard Homepage`,
"label.visualpage.component.n3":`3.Parameters. Parameter is written in the args propertites ,args="name:'zhang', age:26" Note single double quotes.`,
"vue_label_report_operationmode":`Running Mode of Report`,
"label.reportsSubscription.select.attached.file":`Please select the type of attached file.`,
"label.afghanistan.time":`Afghanistan Time`,
"label.vlidaterule.formulatrue":`If this formula expression is TRUE, display the text defined in the Error Message area.`,
"label.ccchat.person.invite.erroremail":`The format of the email address is incorrect.`,
"label.viewDashboard":`Go to Dashboard List`,
"label.at":`at`,
"label.notification.arketsea.beforeretrieve":`Your {0}：{1} is going to be recycled to {2}，remaining time: {6} days`,
"label.field.update.show.editor":`Show Formula Editor`,
"label.weixin.polls.time":`Vote Date`,
"vue_label_commonobjects_detail_activity_nostarttime":`No start time`,
"label.direct.dashboard.me.not.approval70":`Pending Approval Items Submitted By Me`,
"label.data.setok.t_desc3":`, Operation.`,
"label.view.edit.search.describe":`Search after entering keywords`,
"label.importsourcefiletip":`Before importing your translated tab separated file, please make sure of the following: <span><ul><li>1.Create a separate file for each language you would like to import that contains only the name and the translation.</li><li>2.The language attribute at the top of each file is required. ( Chinese Import not supported ).The language attribute looks like this\uff1aLanguage=en_US.</li><li>3.To make sure your import files are saved in UTF-8 encoding before importing.</li>4.Make sure you enter the line feed at the end of the file you want to import.</li></ul></span>`,
"UG.Case.01":`Case`,
"label.weixin.report.filters":`Filters`,
"vue_label_homepage_profilehomepageassignment":`Profile Homepage Assignment`,
"label_tabpage_editview":`Edit View`,
"label.tabpage.allpotentialcustomers":`All leads`,
"label.sendemail.send.standbyemail":`(spare outbox)`,
"errormessage.email.atleastonereceiver.z":`You must select or edit a receive address.`,
"workflow.action.tasks.assignortype.ownertype":`Owner Type`,
"label.list.userinterface.new.page.setup":`New page`,
"chatter.seladress":`Please select at least one recipient.`,
"Pagelayout_Setup_004":`Up to 4 fields can be set`,
"label.mobile.home.page.tenbig.opp":`Top 10 Opportunities in the next 30 days`,
"label.wtd.changefields.newpc":`Generate PC Page`,
"label.opportunity.perm.remark":`This is private opportunities, please contact the "owneridccname" <br> owner to get access.`,
"label.data.exp.tempdes":`Template Description`,
"label.appointment.wizard.subtitle2-1":`From`,
"lable.currencyManage.button.manageexchangeRate":`Manage Dated Exchange Rates`,
"label.file.viewinfo":`View file details`,
"label.integrations.mailchimp.export.failed":`Data export failed, please check your network connection and try again`,
"pagecreator_page_button_edit":`Edit`,
"label.icon.86":`Briefcase`,
"label.exchange.sync.reset":`Reset Sync`,
"label.customfields.lookupfilter":`You can create a filter to limit the records that are available to the user in the Lookup field.`,
"label.component.hotdeal.nopermission":`To see your business opportunity-related data, contact your CloudCC admin.`,
"label.address.province":`State`,
"lable.PowerProcess.3digit.input":`No more than three digits.`,
"label.asset":`Assets`,
"label.passwordPolicy.setup.nopwdremember":`No password remembered`,
"front-electronic-signature-setting-intro2":`Before initiating a contract, please preset the template on the DocuSign platform. When initiating the signing, you can select the preset contract template.`,
"pagecreator.page.button.new":`New page`,
"label.tabpage.step2":`Step 2 specify filter conditions`,
"label_switch_two_column_or_responsive_layout":`Switch to standard or responsive layout`,
"label.batchDelete":`Batch Delete`,
"chatter.edit.ct":`Edit your contact information.`,
"UG_ST_003":`You do not have permission to create {0}, please contact the administrator, click confirm to go directly to the {0} interface.`,
"label.timzone.tip.info2":`When using simpledateformat to format date, you should set time zones for simpledateformat instances, such as SimpleDateFormat myDateFormat=new SimpleDateFormat("yyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));or get an instance using the tool method provided by TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`First time synchronize the mails since how long ago`,
"label.currency.invalid":`Inactive Currencies`,
"label.mask.custom":`Customize`,
"lable.opppdt.addpdt.title":`Select Product`,
"label.appointment.wizard.subtitle3-3":`Wednesday`,
"label.weixin.report.criteria":`Grouped By`,
"label.appupload.upload.install.uninstall":`Unable to install`,
"label.compact.layout.frame.split":`Display on separated screen`,
"label.email.attach.complete.info":`After the upload is complete,the file will be displayed in the list of attachments below`,
"label.Receivables":`Collection Plan`,
"label.linkedin.title.setting":`Integrated Information of LinkedIn`,
"label.companynotice":`Company Announcement`,
"label.emailobject.discard":`Discard`,
"label.selected.searchfield":`Selected Search Result Fields`,
"front-electronic-signature-explainDocusign":`DocuSign Esignature Description:`,
"chatter.link.name":`Link Name`,
"label.low":`Low`,
"label.verticalline":`Vertical Columns`,
"label.approval.isallowed.reject.label":`Allow rejection when approving single data?`,
"label.emailtocloudcc.button.enable":`Active`,
"label.dashboardSetup.showdw.d5":`Integer Unit`,
"label.usermanage.not.authority":`You do not have sufficient permissions to do this.`,
"label.customobjects.track.introduce0":`This page allows you to select which fields to track in the {0} "Field Tracking" related list. Whenever a user modifies any of the fields selected below, the old field value and the new field value, as well as the date, time, change characteristics, and the user making the change are added to the "Field Tracking" related list.`,
"canlendarmonth":`Calendar Month`,
"vue_label_dashboard_minimum":`Please enter the minimum`,
"label.salescloud.optionlist.inputname.linealone":`Enter one or more picklist values below,with each value separated by a new line.`,
"message.error.organuzation.information.null":`Organization information does not exist.`,
"label.tabpage.maxfilez":`The maximum file size is`,
"message.validation.apiname":`It must begain with a letter.It must contain only letters,numbers,and underscore.It must contain only uppercase and lowercase letters,numbers,and underscore.And the maximum length is 50 characters, minimum length is 2 characters.`,
"report.type.label.contractPayment":`Contracts and Receivables`,
"label.limiting.choose.three.files":`You can select 3 files, selected now.`,
"label.reportTypeFocus":`Report Data Source Focus`,
"Report_Delete_Confirm_Title":`Please Confirm`,
"front-gantt-module-reorder-milestones":`Reorder milestones`,
"front-starter-v1-customer-tips-success":`Activcate Account Pool successfully`,
"label.tabpage.isdeleteview":`Are you sure to delete this view?`,
"label.favorite.title":`CloudCC Platform`,
"page.layout.sysinfo":`System Information`,
"label.tabpage.pleaseSelectz":`Please Select`,
"label.smsnotice":`SMS Notification`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`Reject Behavior`,
"label.searchlayout.view.example.new":`View example (New Window)`,
"vue_label_homepage_notice2":`You can manually assign the homepage layout, making it easier for employees to complete their daily tasks effectively`,
"label.import.index.chooseidorother":`3、You can choose to use ID or name to match the record and fill in the lookup field. If you need to acquire the corresponding record ID and other information, you can create a report and set the record name and record ID as group columns, and then export the report.`,
"label.westem.european.summer.time":`Western European Time`,
"label.brackets":`Parentheses`,
"asset.serialnumber.unique":`The asset serial number already exists, please do not add it repeatedly.`,
"label.callcenter.access.keyID":`Access Secret Key ID`,
"label.calendar.month.view":`Month View`,
"label.realdelete":`Permanently Delete`,
"label.partnerCloud.orderingPlatform.amountPaid:":`To Be Paid:`,
"label.reportTypName":`report data source Name`,
"lable.newtabpage.opensearchresult":`Expand Search Results`,
"front-kefu-moudle-v1-Session-duration":`Session Duration:`,
"label.import.index.ignore":`Ignore`,
"label.customfields.url.tip":`Allows users to enter any valid website address.When users click on the field, the URL will open in a new window or current window according users' settings, and the default is to open the URL in a new window.`,
"label.projectManagement.editMilestone":`Edit Milestone`,
"front-gantt-module-v1-project-gantt-list":`Project List`,
"label.validate.remark":`Validation rules help improve data quality by preventing users from saving incorrect data. You can define one or more validation rules that consist of an error condition and corresponding error message. Validation rules are executed at record save time. If an error condition is met, the save is aborted and an error message displayed.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`The phone number format is incorrect. Please reenter`,
"label.channel.name":`Channel name`,
"label.weixin.cloudcc.user.message":`CloudCC Users Information`,
"label.icon.59":`Workshop`,
"label.ccpeak.function":`Method`,
"lable.opppdt.selPdt.leastten.fields":`Please select up to 5 fields`,
"label.deadline":`Deadline`,
"label.product.sel":`Price Book Selection`,
"vue_label_helpcenter_detail2":`All events: Show all events you have access to, even if you are not participating.<br>    You can also filter the activity records you want to view based on the date range and activity type.<br>    4. Dynamic<br>    All persons who can view this record can leave a message and post under the "Dynamic" column of the record, and you can also view all information changes, latest activities, and other people's comments and posts about this record. This column facilitates online work communication and collaboration between you and your colleagues, helping to improve teamwork and efficiency.<br> Posting<br>    Step 1: Click on the posting bar and enter the posting content<br>    Step 2: Click on the File/Link button to add a file/link as needed<br>      nbsp;Step 3: Click "Share" to finish posting. <br> View post<br>    After the post is published successfully, you can see the micro-post you just published below. The micro-post consists of the following parts: avatar, person's name, micro-post content and interaction methods (like/comment/edit/delete post). <br> Sorting and finding posts<br>    Click the drop-down list to the right of "Sort" to change the sorting of posts. <br>     "Latest Activity" sorting: sort by the latest interaction time of the micro-posts;<br>     "Latest Post "Arrange: Arrange by the publication time of micro-posts;<br>    View different types of micro-posts<br>    Plain text micro-posts: Browse the entire content directly in the micro-post publication area;<br>    ;  Micro-posts containing files: click on the download button of the file to download the file locally for viewing;<br>    Micro-posts containing links: click on the link in the micro-post to open it;<br> Commenting and liking micro-posts<br>    Commenting<br>   Step 1: Click on "Comment" below each micro-post <br>    Step 2: Enter the comment in the text box that opens<br>   Step 3: Add the file/link to the comment as needed Step 4: Click "Comment" under the text box to complete the operation<br>    Delete comment<br>    The publisher of the comment can delete the comment content. Click the button to the right of the comment and select "Delete" in the drop-down box.`,
"pagecreator_layout_button_mergecell":`Merge cells`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Active`,
"label.query.detail.loginbypartneruser":`Login by partner user`,
"label.view.selectrenderfields":`Select fields to display`,
"label.code.add":`Add QR code link information`,
"label.appointmentconfirmpage.wizard.title1":`MEETING SCHEDULED`,
"label.timzone.tip.title":`Date/time type data multiple time zone support. when dealing with dates using new date() or calendar, care should be taken to handle the corresponding multiple time zone issues. in addition, the timeutil tool class provides a number of tools that support multiple time zones.`,
"label.tag.addtags.visibility":`Visibility`,
"label.appointmentconfirmpage.wizard.title3":`Are you sure to cancel the existing appointment and make a new appointment?`,
"lable.outlook.detail.oldest":`Oldest`,
"label.account.custom.quarter.timeerror":`The Custom Quarter Start Date or Custom Quarter End Date is in between of history custom quarters, please check and reset`,
"label.sendsms.idea":`Respected`,
"label.manageAll.pagenum2":`This is the last page.`,
"serviceterritory.isactive.notactive":`This service territory is not enabled.`,
"label.userinfo.newpwd.notnull":`Please enter your new password.`,
"vue_label_dashboard_nolinkagedashboard":`No linkage dashboard`,
"message.cannotdeleteapproval":`You cannot delete this approval process.`,
"label.wtd.detail.m":`Mobile`,
"label.app.step4.introduce":`Choose the tabs to include in this custom app.`,
"label.ccchat.error.permission":`No access`,
"UG_opportunity_009":`Or`,
"label.Receivables.TheActualAmountOfMoney":`Actual Receipts`,
"label.callcenter.no.search":`No relevant query to the information`,
"label.user.introduce":`Users`,
"message.datalocked.addpdt":`This Opportunity record is locked, you can not Add Pruduct.`,
"label.sendsms.step1":`Step1: Specify recipients`,
"label.brief.contracts":`Contracts`,
"label.setup.mini.swap":`Carousel Setup`,
"label.emailobject.wizard.desc1":`Connect your email, send mail here and automatically sync to the record`,
"label.login.verification.mfa.desc2":`If you are unable to verify for some reason, such as lost or mistakenly deleted MFA apps on your phone, you may have heard the administrator unbind the MFA.`,
"label.notification.receiveSms.message":`You have received a text message from {!fromaddress}, click to see more detail`,
"label.emailmerge.mergeFolder.publicfolder":`Unfiled Public Email Merge Templates`,
"label.password.update.false":`Failed to change the password, please contact the administrator!`,
"label_tabpage_systemz":`System(s)`,
"label.dataimport.objectid.null":`The object ID is empty and cannot be imported`,
"label.currency.type":`Currency Type`,
"component_setup_button_appurl":`System url`,
"label.appointmentconfirmail.wizard.title2":`You have a scheduled {0}`,
"lable.product.please.enter":`Please enter`,
"label.escalation.setup.title":`Case Escalation Rules`,
"label.create_failure":`Failed to create form`,
"label.weixin.brand.model":`Brand model`,
"label.layout.nameoftestobj2":`Test Object Two Name`,
"vue_label_filters_number":`15 filers are supported for each report.`,
"label.file.following":`Following`,
"vue_label_account_all_contracts":`Transfer all contracts of customer owners`,
"label.service.please.select.cycle.type":`Please select cycle type`,
"label.weixin.weipoll.optionname":`Name of Micro-poll Option`,
"label.data.newtemplate.null":`None`,
"message.passwordPolicy.validate.complexReq1":`Error: The password must have a mix of letters and numbers`,
"label.forecast.shre.editmanager":`Manager Edit`,
"label.emailtemplate.tip":`Below is a list of all your email templates in the folder selected. Click the new button to create a new text or HTML email template. You can use these email templates when sending single emails.`,
"label.tag.manage.button":`Manage Tags`,
"label.changepw":`Change Password`,
"label.sso.saml.sp.idsource.nameid":`Identity is in the NameIdentifier element of the Subject statement`,
"label.salescloud.teamrole.addmember":`Add upportunity team members CloudCC`,
"label.h5.similar.opportunity.last.months6":`Recent 3-6 months`,
"message.save.opportunity.role.save.failed":`Failed to save contact role`,
"vue_label_report_formulainformation":`Formula information`,
"label.area.assignuser.remark":`Assign Users To Territory`,
"label.multilang.viewlist.total":`{0} Selected`,
"label.newprocessstep4":`Step 4 Select Email Notification Template`,
"label.permission.objectpermission.open":`Open`,
"label.service.gantt.close.list":`Close List`,
"label.standarduserfield":`Standard User Field`,
"vue_label_commonobjects_detail_the_administrator":`The record has been locked, please contact the administrator.`,
"label.exchange.sync.account":`Exchange Service Account Credentials`,
"label.mr.title.button.back":`back, and reset the search criterias`,
"label.notsetup.operation":`Line condition error, no operator was set.`,
"label.notifications_center":`Notifications Center`,
"label.event.moveup.5hour":`5 hours ahead`,
"report_label_pleaseinput":`Enter what you want to search for`,
"label.batchadd.newbatchpage.errorlist":`Data add failed`,
"label.quickbooks.invoices":`Invoices`,
"chatter.feed.usingchatter":`Turn on CCChat, your users can follow a few people or records and post.`,
"label.all.marketing.activities":`Owner of market campaign`,
"label.lookup.finish":`Lookup Auto-completion`,
"label.weixin.unbind":`Unbind`,
"front-console-closeTime":`Close Time`,
"label.service.rest.time":`Remaining Time`,
"label.mr.descreption.condition1":`Enter the scope and rules for finding duplicate records. Click [Find Duplicates] to get qualified duplicate records.`,
"label.group.new":`New Group`,
"vue_label_SMS_sending_please_wait":`Sending, please wait`,
"label.Standardobj.tab":`Standard Object Tabs`,
"label_chatter_pastEvents":`Past activities`,
"label.chatter.priority":`Priority`,
"select.nullvalue":`-None-`,
"setup_layout_group_pagecomponent":`Page Components`,
"label.dataimport.dataerror.check":`Data error, please check the data.`,
"label.permission.detail.app.pagesetting.tip":`Excute Custom Pages Permission Settings`,
"label.knowledge.language.polish":`Polish`,
"label.project.hit.two":`Subtask Expiration Reminder`,
"label.customerapp":`Custom App`,
"label.reportsSubscriptionPage.condition.value":`Value`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Sorry, you don't have the access to operate. Please contact the administrator.`,
"homepage.layout.buttion":`Page Layout Assignment`,
"label.notification.event.overlapEvent":`The delegated user has already been assigned to a {subject} event from {begintime}-{endtime}, do you want to create this event anyway`,
"label.customfields":`Custom Fields`,
"label.data.downpage.e.title":`Data Export Steps`,
"label.notification.serviceappointment.remove":`Your dispatched work order {0} has been cancelled, please arrange your work reasonably.`,
"label.campagin.roi.zhuangtai":`Campaign Status`,
"label.applt.updown":`Download Miniprogram QR Code`,
"label.customfields.new.step1.tip":`Specify the type of information that the custom field will contain.`,
"label.staticresource.upload.limit":`Only files in these formats can be uploaded: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Change User Photo`,
"label.icon.32":`Computer`,
"vue_label_homepage_notice_cantset":`The profile homepage is not configured for this profile, the default homepage of the profile cannot be modified`,
"front-epwechat-module-v1-agree-unbound":`Agree and accept the above unbinding information`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Please choose a tab style.`,
"label.select.an.asset":`Please select an asset.`,
"label.search.sizer.field":`Search Filter Fields`,
"label.emailmerge.mergeFolder.lastone":`Please select a template at least.`,
"label_tabpage_step2":`Step 2 specify filter conditions`,
"label.version.lead.automatic.allocation":`Lead Assignment Rules`,
"label.projectManagement.update.succeeded":`Update Successfully`,
"label_tabpage_bar":`Bar`,
"label.appupload.component.type.tab":`Menu`,
"label.pigeonhole.sel.f":`Choose the folders to archive`,
"homepage.components.status":`Component Status`,
"label.currency.edit.new":`Currency Edit: New Currency`,
"label.input.new.password":`Please enter correct new password`,
"chatter.group.membersName":`MMeMber Name`,
"label.myinfo.modify":`Personal Information Edit`,
"label_tabpage_next":`Next Step`,
"vue_label_homepage_card_closedopportunities":`Closed Opportunities`,
"label.permission.edit":`Edit Properties`,
"message.error.searchfield.objid.null":`The object id required by the query field cannot be empty`,
"label.partnerCloud.productSet":`Product Setup`,
"label.emailtocloudcc.filed.emailto":`Email to`,
"label.service.miniProgram.uploadingImage":`Please upload carousel picture.`,
"label.sso.saml.idp.description1":`Connected Apps`,
"label.event.moveup.10minutes":`10 minutes ahead`,
"label.quote.createby":`Preparer`,
"label.workflow.baseontimeoparate":`Time-dependent Workflow Actions`,
"label.searchall.r":`Search Again`,
"vue_label_homepage_differentprofiles":`Assign different homepages to different profiles`,
"label.campaign.channel.step1":`Step1: Information`,
"label.event.moveup.2hour":`2 hours ahead`,
"font-evaluate-module-v1-cancle-reply":`Cancel autoresponse`,
"message.datalocked.delete":`You can't delete this record because it was locked. If you want to delete it, please contact admin.`,
"label.sso.listOfKey":`Key List`,
"label_chatter_newtask":`New task`,
"label_emailsync_form_seversetting":`Setup`,
"label.partner.new.function":`Feature description`,
"vue_label_notice_homepage_pleaceentername":`Please enter the homepage name`,
"message.please.choose.opportunity":`Please select opportunity`,
"label_file_use_most_user":`Users with the most storage space used`,
"label.htyj.remark2":`so you cannot view contract amounts`,
"label.formula.message":`when the formula is evaluated as false，the prompt for the submit failure`,
"UG_Case_04":`Case assignment`,
"label.displaycolumn":`Showing Columns`,
"vue_label_campaign_selected_member_status":`Update to selected member status`,
"label.workflow.operate":`Workflow Actions`,
"label_chatter_mail":`Mail`,
"label.setup.mini.setting":`Mini-programs Backend Setup`,
"vue_label_chat_invitetojoin":`You invited “{invite}” to join the group chat`,
"setup.object.field.dependency.label.linkedfieldvalue":`Dependent Field`,
"vue_label_email_update_template":`Update Template`,
"label.email.template.private.mail":`Exclusive Email Template Folder`,
"lable.Confirm .potential.customers":`Confirm to recycle lead {name}`,
"vue_label_leadpool":`Lead Pool`,
"label.ems.hostorpost.error":`Server or port configuration error,please check.`,
"label.search.saveok":`Save successfully`,
"label.custom.field.cannot.maping":`Unable to map to this field multiple times`,
"label.projectManagement.dispatched":`Sent`,
"time":`Time`,
"label.choose_socialnetwork":`Choose a social network to start`,
"label.vlidaterule.checkedtrue":`Determine as follows if it is a checkbox field, without adding double quotation marks`,
"label.appointmentconfirmail.wizard.btn1":`Reschedule`,
"front-kefu-moudle-v1-maxchars-input":`Up to {0} characters can be entered`,
"setup.mainpage.label.welcome10":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Object → Object Name → Custom Layout.`,
"label.ems.company.setup.title":`Company Outbox Setup`,
"label.channel":`Channels`,
"label.textmessage.groupsms":`Group SMS`,
"label.asset.deleted.successfully":`Delete asset BOM successfully.`,
"label.knowledgebase.new.workspace":`New Workspace`,
"label.ServiceCloud.diliweizhi":`geolocation`,
"label.private_me":`Private to owner (me)`,
"label.service.miniProgram.imageLink":`Carousel Link`,
"label.area.assigned":`Assigned Users`,
"label.weixin..xsld.name":`Opportunity Name`,
"label.campaign.matchway.select.name":`Name`,
"label.installedsoft":`Installed Packages`,
"label.projectManagement.spare.time":`Available Time`,
"label.user.select.custom.text.sendemail":`Select custom text format to send email directly`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Approve/Reject`,
"startdate.enddate.time.illegal":`Start date should be less than or equal to end date.`,
"label.project.hit.eight":`Daily Task Reminder`,
"message.duplication.label.uncheck":`No-verification`,
"label.allocation.role":`Assign Users`,
"label.sendemail.lead.scoreinfo":`Dear #username:\r\n the system has scored all the leads of the leads views you selected “#viewlabel” based on the lead scoring rules. it takes #timestr.\r\n please login and open the view to check the results.\r\n attention:\r\n if you can not view the score of the leads you have scored, please edit the view and add “lead scoring” to the field to display to see the scoring result.\r\n thanks and best regards!\r\n #orgname\r\n`,
"lable.oppt.jieduan.closejieduan":`Close this opportunity`,
"label.ems.verify":`Verify`,
"message.error.startdate":`Start date must be earlier than the end date`,
"label.campaignmember.main.deletelead":`Remove Members-Existing Leads`,
"label.partnerCloud.financeSetting.account":`After the partner fund activated, the objects of partner fund and fund statement will be added. Partner users can use the account in CloudCC to pay for orders.`,
"message.datalocked":`The record is locked. If you need to edit it, please contact the admin.`,
"lable.opppdt.selPbk.pricebook":`Price Books`,
"label.knowledgebase.restore.article":`Restore Article?`,
"label.object.batchadd":`Batch Add {objName}`,
"label.what_happen":`Page after the Form is Submitted`,
"label.roleandunderling":`Roles and Subordinates`,
"label.knowledge.language.russian":`Russian`,
"front-electronic-signature-explain-first":`Before binding Esignature, it is recommended that you register and certify on the Fadada platform.`,
"component.sendmail.label.subject":`Theme`,
"month":`Month`,
"label_chatter_save":`Save`,
"label.view.sortview.sectiontitle":`The view will be displayed in the selected order`,
"label.mobile.home.page.major.project":`Key Projects`,
"label.weixin.input.filename":`Please enter the file name`,
"label.pagelayout.remark":`This page allows you to create different page layouts to display`,
"label.service.miniProgram.store":`Brand Story`,
"label.recordtype.edit.selected":`Selected Value`,
"message.selectgroupcondition":`Please select conditions to grouping`,
"label.y.axis.cannot.empty":`Y axis cannot be null`,
"label.textmessage.vonage.connected.count":`Count as Contacted`,
"setup.layout.label.readonly":`Read-Only`,
"front-kefu-moudle-service-agent":`Customer Service`,
"message.login.mfaverification.page.invalid":`The page is invalid.Please refresh.`,
"label.central.standard.time":`Central Standard Time`,
"label.processnoticepic":`Attention Image of Approval Process`,
"vue_label_helpcenter_calendar1.2":`Calendar entry display rules: calendar entries will be displayed in the calendar grid, and the grid area where the calendar entry is located represents the time range of the record. Calendar entries that span more than 24 hours will be displayed at the top of the time scale in the day, week, and availability views. If there are multiple calendar entries in a grid in the month view, you can click " More" to view them. The left or right side of the calendar entry is a semicircle, which means that there is no such record in the previous or next day of the grid. The left or right side of the calendar entry is rounded at right angles, indicating that there is still this record on the previous or next day of the grid. <br> Quickly locate the date in the calendar view: You can locate the date range displayed in the calendar view on the left by selecting the time on the small calendar on the right side of the calendar page. You can also click the "<" and ">" icons at the top right of the calendar page to quickly switch dates. If the time of your calendar view is not the current time, you can click the "Today" icon at the top right of the calendar page to quickly switch back to today. <br> List view<br> Switch from calendar view to list view: Click the "calendar" icon at the top right of the calendar view and select "table" to switch to the event list view. <br> Use of list view: To view specific events or multiple events at the same time, open the table view. There are preset list views in the list view. Click the "drop-down button" icon in the upper left corner of the list view to display all the list views you have access to. You can also customize the event list view to meet your needs. <br> 2. My calendar and other calendars<br> My calendar<br> My calendar contains my event calendar and object calendar. <br> My event calendar: Display all event records where the assigned person is yours on the calendar view. My event calendar cannot be removed, edited or changed in color. You can share "My Event Calendar" with your colleagues.`,
"label.approval.end":`End`,
"vue_label_report_notice_cannotdelete":`There are reports in this folder that cannot be deleted`,
"label.sso.saml.idp.loginurl":`ID Provider Login URL`,
"label.emailtocloudcc.filed.port":`Port`,
"label.directdashboard.righttitle":`Sales Analysis Dashboards`,
"label.knowledge.case.suggest.article":`Suggested Articles in Cases`,
"label.version.maxcount":`,beyond the limit.`,
"label.weixin..xsld.yjqyrq":`Close Date`,
"front-project-module-v1-unmarket-is-template":`Unmark Template`,
"label.mobile.quickcreate.default.map":`Map`,
"chatter.click.p":`Click to preview`,
"label.chat.topic.all.topic":`All Topics`,
"label.channel.head":`Channel Supervisor`,
"lable.edit.queue.emaildes":`Enter the name of the queue and the email address to use when sending notifications (for example,when a case has been put in the queue). The email address can be for an individual or a distribution list. When an object is assigned to a queue,only the queue members will be notified.`,
"label.tag.filter":`Tag Filter`,
"label_chatter_filterTimeLine":`Filtering time line`,
"label.dashboard.show.value":`Show values`,
"vue_label_normal_solution_sf":`Solution`,
"label.customfields.location.tip":`Allow users to define the location, including longitude and latitude components that can be used to calculate distances.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com,inc. All rights reserved by CloudCC.com`,
"label.icon.33":`Computer`,
"label.mr.title.opportunityName":`Opportunity Name`,
"template.report.sales.month":`Sales of This Month`,
"chatter.group.lookingForPeople":`Start typing a name`,
"label_tabpage_userz":`Users`,
"label.reportsSubscriptionPage.email.formatselection":`Please select the report format you want to get through email`,
"lable.product.plist":`List Price`,
"label.multilang.activity.monthline":`Week {0}`,
"label.ccchat.whose.name.contains2":`Members of any campaign group`,
"label.mobile.phone.day.report":`Daily Work Notes`,
"label.processsetting.set.files":`Set Fields`,
"label.systemlog.s":`Success`,
"label.tabpage.uploadsz":`Upload`,
"serviceterritory.member.time.conflict":`Within this time range, service resources have become members of other service territory.`,
"label_chatter_startDate":`Start Date`,
"label.search.at.least.two":`Search terms must not be less than 2 characters.`,
"label.approval.ressign.project":`Items to Assign`,
"lable.custom.Previous.CY":`Previous CY`,
"label_chatter_link":`Link`,
"label.weixin.group.name":`Name`,
"label.partnerCloud.basicSetting.domainName":`The operation is irreversible and the domain name cannot be changed after initialized. Are you sure to confirm the operation?`,
"lable.SalesCommitmentKanBan.targetContract":`Target Contract Amount`,
"label.currency.new":`New Corporate Currency`,
"message.passwordPolicy.validate.complexReq3":`Error:Your password must have a mix of numbers and uppercase and lowercase letters, and special characters.`,
"label.icon.127":`Doctors`,
"label.customfields.fieldname.tip":`The Field Name is an internal reference and is used for integration purposes such as the API.`,
"chatter.feed.menutype.feed":`Summary`,
"label.home.standard.dashboard.role":`You do not have role information, so you cannot view the sales commitment dashboard.`,
"label.customfields.fielddependency.button":`Click the button to include or exclude selected values from the dependent picklist`,
"label.recentprojects":`Recent Items`,
"label.appupload.logo.introduce":`The package logo must be smaller than 20KB. Image dimensions should be a maximum of 60 pixels wide by 60 pixels high for best results. Larger images will be resized and may appear distorted.`,
"label.integrations.northamericanleads":`North American Leads`,
"label.sms.balance":`Balance (yuan)`,
"label.ccchat.message.num":`News`,
"label.embed_website":`To embed this form,simply copy and paste the code below into the HTML code on your website.`,
"label.trigger.check.error":`Trigger syntax check failed.`,
"label.bmap.baidu.maps":`Baidu Maps`,
"label.nextapproverauto":`Next Automated Approver Determined By`,
"label.customfields.date.tip":`Allow users to enter a date or pick a date from a popup calendar.`,
"button.partner.back":`Return`,
"label.layout.editcondition.tip":`Select the fields that you want to use as search criteria. Note that you can select up to 10 fields.`,
"label.stacked.area":`Stacked Area`,
"font-evaluate-module-v1-case-closed":`Only when case is closed`,
"label_emailsync_status_log":`Connection Log`,
"label.version.area.and.sales":`Territories Management and Sales Team`,
"label.service.booking.sessions":`Service Appointment Time`,
"label.untransfile":`Untranslated`,
"label.textmessage.sentfail":`Failed to send`,
"label.emailtemplate.detailinfo":`Template Details`,
"setup_mainpage_label_welcome13":`Instructions: Click on the top menu → Reports → New`,
"label.ccchat.error.nullid":`ID cannot be empty`,
"label.partnerCloud.partnerAccount.rebate":`Rebate Revenue`,
"label.appupload.component.type.scheme":`Field`,
"front-kefu-moudle-phonein":`Incoming Call`,
"label.emailmerge.list.description":`Mail merge templates are MicroSoft Word documents with merge fields that reference CloudCC.com fields.`,
"vue_label_commonobjects_detail_select_first":`Please select related items first`,
"label_emailsync_form_action":`Action`,
"label.customfieldrelation":`Custom Fields & Relations`,
"label.ems.other.msg":`Please content CloudCC admin(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>), start the mail synchronization service.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":`Enabled`,
"equal":`equals`,
"label.partnerCloud.financeSetting.merchantInformation":`Access Path: Merchant Platform  Account Center  Merchant Information`,
"vue_label_calendar_displayed_field_name":`Name of the Displayed Field`,
"UG_opportunity_002":`Define your sales cycle, configure stage`,
"label.tag.addtags.button1":`Save`,
"label.explain":`Instructions`,
"label.icon.166":`Pavilion`,
"label.exchange.sync.setting.use":`Enable Exchange Sync`,
"label.chatter.assignPerson":`Assigned  To`,
"lable.PowerProcess.event.condition":`Conditions of Milestones`,
"label.addattachment.step1":`Step 1 Select the file`,
"label.account.fiscal.quarter.timeerror":`The Fiscal Quarter Start Date or Fiscal Quarter End Date is in between of history fiscal quarters, please check and reset`,
"label.URL":`URL to reference`,
"label.icon.134":`Data`,
"label.forecast.customforecast.foredis.sq":`Thousands`,
"label.custom.field.number.decimal":`Wrong number of digits.`,
"label.version.history.track.error":`Your version only supports to select <=5 fields, cannot select more fields.`,
"label.log.os":`Operating System`,
"label.partner.workspace.tab.option":`Available tabs`,
"label.partnerCloud.partnerAccount.accountWater":`Fund Statement`,
"setup_layout_label_norelatedlist":`No related lists`,
"label.import.page1.nextstep":`Next`,
"label.emailobject.view.attached":`Emails with Attachments`,
"label.SalesCommitmentKanBan.allTask":`Total Task Amount`,
"label.eastem.daylight.time":`Eastern Daylight Time`,
"label.create_engaging":`Create an attractive post to connect to the world.`,
"label.area.adduser":`Add Or Delete User`,
"label.timezone.importtimezone.user":`Use login user timezone`,
"label.passwordPolicy.setup.pwdremember1":`1 password remembered`,
"label.query.detail.openpartneruser":`Enable as Partner User`,
"label.senduser":`From`,
"Pagelayout_Setup_001":`Please select the related lists which would be displayed on hover layout.`,
"label.mobile.parameter.setup":`Mobile App Settings`,
"message.device.not.bound.mfa":`Unbound MFA Devices`,
"setup.layout.label.buttonarea":`Button Area`,
"chatter.email.reply.like":`Comments on an item I like`,
"label.chatter.day":`Day`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat reply the post liked`,
"label.field.remark2":`page.`,
"label.ggReleaseRange.release":`Publish Range`,
"lebel.alreadyback":`Recalled`,
"label.appupload.install.appname":`App Name`,
"label.selectnewadeckertag":`Select the label for new hierarchy field`,
"label.cliententrancewebsiteadmin":`Customer Portal Administrator`,
"label.checkbox.checked":`Selected`,
"UG.Case.03":`Automatic case upgrading`,
"vue_label_dashboard_group":`Please select a group`,
"label.import.index.preparedata":`Prepare the data you want to import`,
"vue_label_member_notice1":`You can upload JPG, GIF or PNG files, the maximum file size is 2M`,
"message.modify.success":`Modification successful.`,
"label.userquotas":`Quotas`,
"label.appointmentpage.wizard.subtitle3-1":`Name`,
"label.import.index.maxdata2":`2、Before importing, please make sure to import all records related to it first. For example, if there is a lookup relationship between the object you are currently importing and the contacts, please import those contacts first, and then import your data. If you need to get the corresponding Record ID and other information, you can create a report and set the record name and record ID as a group column, and then export the report.`,
"label.pc.sectionpart":`PC Section`,
"template.chart.wcldqzkh":`Unprocessed Leads`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Do you want to save the block pricing information of the current price book?`,
"label.partnerCloud.financeSetting.payments":`Allowing Online Payment`,
"lable.account.ThisWeek":`This Week`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`Select Background Color`,
"label.planned.work":`Planned Jobs`,
"label.passwordPolicy.setup.nolimit":`No Limit`,
"label.vlidaterule.s":`If you deactivate the currency used by the user, the currency of the user will be set to the Corporate Currency.`,
"label.paging.totalofrecords":`A total of {0} records`,
"label.customobjects.behaviour":`Actions`,
"vue_label_ccchat_notice_deletecommentsuccess":`Comment deleted successfully`,
"label.lock.record.dele":`The record is locked, you can not delete it.`,
"label.data.expnode.e.desc3":`3、Template Create: user can make the template according to the fields and conditions that will be exported to meet your needs, which is convenient to use next time.`,
"label.button.step3.create.page":`Step 3 Page Generation`,
"label.sharer":`Share from`,
"label.service.cycle.type":`Cycle Type`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Total Receipts Commit Rate`,
"label.formuladate":`Date Format: yyyy-MM-DD hh:mm:ss or MM/DD/YYYYhh:mm:ss, such as: 2007-12-25 12:25:30 or 12/25/2007 12:25:30.You can also use today() Or now();`,
"front-template-V1-addImg":`Add Picture`,
"label.basecontrol":`Basic Access`,
"label.forecast.settings.lable1":`Forecast Data Aggregation`,
"message.error.file.null":`Upload file cannot be empty`,
"label.multiply":`*Multiply`,
"message.duplication.label.targetobject":`Object`,
"label.addattachment":`Add Attachment`,
"vue_label_dashboard_notice_editcertification":`Are you sure you want to edit the component {name}?`,
"label.notification.tip2":`No New Notifications`,
"lable.quote.syncingfrom.firstsync":`Initial Sync: Opportunity to Quote`,
"label.createtasktip":`Create a task to associate with one or more workflow rules, approval processes, or entitlement processes. When changing a task, any modifications will apply to all rules, approvals, or entitlement processes associated with it.`,
"label.leave":`Leave`,
"front-invoice-online-payment-setup-china":`Apply to Chinese Accounts`,
"label.appointment.wizard.subtitle4-1-2":`30 min`,
"label.projectManagement.the.person.not.be.informed":`When you select No, the responsible person cannot be notified!`,
"label.campagin.roi.name":`Campaign Name`,
"label.import.page1.newcreate":`New`,
"label.data.downpage.i.title.num2":`2、Before you start importing, make sure that the field name in the file you want to import matched the object field name in the CloudCC.`,
"label.callcenter.call.in":`Call in`,
"label.weixin.activity.phone":`Activity: Call`,
"label.forecast.customforecast.type.role":`By Role`,
"label.moscow.standard.time":`Moscow Standard Time`,
"label.profile.setcustomobjectrecordtype":`Custom Record Type Settings`,
"lable.edit.queue.new":`New Queue`,
"label.newAPPexchange":`New Application...`,
"message.custom.field.donotdelete.fieldupdate":`This field is referenced by a field update in another workflow or approval process.`,
"label.chatter.state":`Status`,
"label.subject_line":`Subject`,
"template.report.folder.active":`Campaigns and Actions Analysis`,
"label.icon.114":`House`,
"label.assignment.setup.newentries.step3":`Step 3 Select the user to assign to`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Personal-Behavior Overview`,
"label.weixin.optiontwo":`Choice 2`,
"label.sso.saml.idp.config.sp":`Service Providers`,
"System_TimeField_Description":`Allow users to enter a local time. For example, "2:40 PM", "14:40" and "14:40:00" are all valid times for this field.`,
"label.knowledgebase.draft":`Draft`,
"label.chat.topic.no.more.suggestions":`No other suggestions`,
"label.quote.product":`Product`,
"label.cryptographictext":`Encrypted Text`,
"label.custom.unlock":`Unlock`,
"label.assignment.setup.newentries.step2":`Step 2 Select the criteria for this rule entry`,
"label.tabularreport.selectline":`Select the columns that you want to include in the report.`,
"label.exchange.sync.state.contact.m2":`Records synced in the last 60 minutes:`,
"label.codeType":`Code Type`,
"saturday":`Saturday`,
"label.mask.type":`Mask Types`,
"label.schedulejob.setup.schedule.Monthly":`Monthly`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{20}} fields in the file , {{20}} unmapped`,
"label.projectManagement.delete.item":`All related information of this project will be deleted if you delete the project, and the data cannot be recovered. Are you sure to confirm the deletion?`,
"label.page.general.us.and.western.europe":`General US & Western European Languages`,
"label.reportsSubscription.status":`Subscribed`,
"label.discount.baifenbi":`Discount (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Web Evaluation Setup`,
"message.error.searchwork":`Your keywords entered must have 2 or more characters.`,
"label.weixin.option.setting":`Choice Settings (up to 10 choices)`,
"label.lead.score.prompt1":`Score single lead record automatically when creating or editting. But you need manual scoring multiple lead records, when batch importing or creating by interface.`,
"label.exception.must.try.throw":`Exception must be thrown out in a staement block.`,
"label.activity.plan":`Plan`,
"label.partnerCloud.productSet.editor":`Edit Option`,
"label.mobile.quickcreate.default.signinnew":`Sign in`,
"label.summaryreport.2018.step6.new":`Step 6 Select the chart type and the highlight item`,
"vue_label_homepage_owner":`My Homepage`,
"vue_label_dashboard_editfoldersuccessfully":`Edit folder successfully`,
"label.quickbooks.view.overdueinvoices":`Overdue Invoices`,
"label.emailtocloudcc.redmessage4":`Please input port details`,
"label.tabpage.equalz":`Equal to`,
"lable.quote.syncing.firstsync":`Initial Sync: Quote to Opportunity`,
"label.download.CloudCCAPP":`Download CloudCC App`,
"label.icon.6":`Currency`,
"label.list.serial.number":`Serial Number`,
"label.profile.setstandardobjectrecordtype":`Standard Record Type Setup`,
"label.customize.memory.function.sorting.error":`The response time of query is too long and causes page timeout. It may be because the Memory of Header Sorting is activated. Please go to the personal settings and deactivate this function.`,
"message.view.addtoallusers":`Visibility Of Related Users`,
"label.globaloperation.operationtype.record.phone":`Log a Call`,
"lable.opppdt.selPdt.searchresult":`Search Results`,
"label.import":`Import`,
"label.service.gantt.work.based.resources":`Resources Based on Operating Hours`,
"label_partner_template_detailimage":`Picture`,
"label.cpq.product.feature.option.count":`The minimum of product options cannot be greater than the maximum of product options`,
"label.chatter.newtask":`New Task`,
"font-trade-module-v1-invoice-total-price":`Planned Total Payments`,
"setup_mainpage_label_welcome29":`Standard API integration with third-party products`,
"label.data.exportall.all.btn":`Export All Data`,
"front-epwechat-module-v1-unbound-WeChat":`Unbind WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Team-Sales Contract Amount Rankings`,
"label.import.page1.newcreateandupdate":`Update and start new`,
"component.chatter.post.button.file":`Add attachments`,
"label.partnerCloud.orderingPlatform.createOrder":`New Order`,
"label.lookup.multiple.data":`Multiple data found, please select manually`,
"button.partner.save":`Save`,
"label.service.add.timeslot":`Add Time-slot`,
"label.campaign.matchway.select.email":`Email`,
"front-sales-button-fromQB":`Update from QuickBooks`,
"label.icon.108":`Arrow`,
"lable.outlook.edit.efmapping":`Field Mappings Edit`,
"label_tabpage_refreshz":`Refresh`,
"chatter.follow.cancel":`Stop following`,
"label.totals.sum":`Sum Total`,
"label.noRequest":`No Requirement`,
"vue_label_homepage_fixedcomponent":`Please select a fixed component`,
"label.knowledge.delete.case":`Error while deleting case article.`,
"label.weixin..xsld.yjwc":`Expected Revenue`,
"label.customcomponent.page.index.console.btn":`Developer Console`,
"label.sendsms.batch":`Batch SMS`,
"vue_label_chat_onlychosechat":`Only Team users can be selected for chat`,
"label.tabpage.page":`Page`,
"label.cyen.note":`Enable Currency. Note that the action of currency enabled is irreverside.`,
"label.weixin.againsend":`Resend`,
"label.processnumber":`Step No.`,
"label.emailobject.to":`To:`,
"label.event.today":`Today`,
"label.dashboard.dispalyPosition":`Dispalyed Position`,
"message.error.recalculate.dupoperate":`Recalculating, please do not operate frequently.`,
"vue_label_email_linkrecordsuccess":`Successfully associated record`,
"label.updateoutboundnews":`Update Outbound Messages`,
"label_emailtocloudcc_exists2":`This mailbox has been set to Email to Case. Do not repeat settings.`,
"label.tag.addtags.button2":`Cancel`,
"label.stdashbord.xsld.business.role":`This role is taken from the enabled roles in forecasts hierarchies`,
"label.commonnew":`Normal new`,
"label.validate.remark2":`Usage Sample:`,
"label.reportsSubscriptionPage.condition.checkbox":`Add Criteria to This Report`,
"label.globalselect":`Global Options List Value Set`,
"label.partnerCloud.partnerAccount.available":`Available Amount`,
"label_tabpage_nothingz":`Nothing`,
"label.version.webtolead":`Web-to-Lead`,
"label.projectManagement.heat.map":`Heat map`,
"message.error.pleasecorrectdata":`Please review all of the following error messages to correct the data.`,
"label.hight.tip":`When the advanced filter is not enabled, the relationship of different filter conditions is "and", that is, a record that satisfies the common features of 1 and 2.`,
"label.workflow.estimatecondition3":`created or every time it is edited`,
"AssetRelationship.time.limit.error":`The start date shall be earlier than or equal to the due date.`,
"label.multilang.workflow.dayinmonth":`The {1} every {0} month(s)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Daily`,
"label.emailtocloudcc.step1.name":`Choose Function`,
"label.follow_up":`Followup Email`,
"label.price.list.price.cannot.be.empty":`The list price cannot be empty.`,
"label.chatter.link":`Link`,
"label.ccpeak.condition.return.record":`Returns records by condition and support common "where" conditions.`,
"pagecreator.layout.message.canntdelete":`The current layout is not allowed to delete`,
"label.compact.layout.main":`Primary Key Information Layout`,
"label.testandupdate":`Check For Update`,
"button_partner_cancel":`Cancel`,
"label.activity":`Activities`,
"label.knowledge.setting.hint.fourteen":`Get ready to write!`,
"vue_label_commonobjects_view_open_from_list":`Open from the list to get started`,
"front-electronic-export-intro":`2000 records can be exported to Mailchimp for one time`,
"label.chosen.all":`All Fields`,
"label.file.extension":`File extension`,
"vue_label_systemSettings_server_miniprogram":`Service Miniprogram`,
"label.weixin.no.pending.wdgz.qin.today":`No work schedule for today.`,
"label_tabpage_issuez":`Issue`,
"label.staticresource.tip":`Use static resources to upload content that you want to reference in a custom page, including .zip, images, stylesheets, JavaScript and other files.`,
"label.approvalstep":`Approval Steps`,
"label.china.standard.time":`China Standard Time`,
"label.appexchange.download.tiaoguo":`Ignore`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Unable to submit! The required items are not filled in or do not conform to the rules.`,
"label.appointment.wizard.title1":`Define Availability`,
"label.chat.remove.bookmark":`Remove Bookmark`,
"label.tabpage.advancedsearch":`Advanced search`,
"batch.ranf.f":`Batch transfer records failed`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Accounts`,
"component.chatter.link.label.url":`Link url`,
"label_emailtocloudcc_redmessage8":`Parameter error, please contact administrator.`,
"label.object.create.two.number.field":`Up to 2 custom Auto-Number fields can be created per object.`,
"label.salecommit.not.roleinformation":`You have no roles and cannnot view the sales commitment dashboards.`,
"label.defautline.cannot.less":`The default number of lines should not be less than 1.`,
"label.selectedproducts":`Number Of Selected Products`,
"label.productsales.today.notskadd":`There are no expiring tasks, you can click “ ” in the upper right corner to add new task.`,
"lable.account.year.stadate":`Fiscal Year Start Date`,
"label.mobile.phone.month.plan2":`This Month's Tasks`,
"label.ccpeakfolder":`Class Folders`,
"setup_mainpage_label_welcome21":`The CloudCC cloud platform provides user-defined email template function, which is convenient for users to use and improve work efficiency.`,
"label.modify.layout":`Edit Layout`,
"report.label.folder":`Folders`,
"label.tianyancha.businessverify.rewritename":`Backfill account name`,
"lable.currencyAdv.dao":`to`,
"label.mobilelayout":`Mobile layout`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`The current model is activated and not editable.`,
"label_partner_all_disable":`Disable`,
"label.ownerapproverfield":`Approver Field of Owner`,
"label.emailobject.template.message4":`Some of the inserted fields in the message are null, please edit and resend!`,
"label.productsales.today.notsk":`There are no expiring tasks.`,
"label.multilang.document.upload.success":`{0} files have been uploaded successfullt and {1} files are failed`,
"label.manageAll.sta3":`Rejected`,
"vue_label_calendar_week_view":`Calendar- Week View`,
"setup_layout_label_nocustompage":`No custom pages`,
"label.weixin.wdyj.jxdcl":`Personal-Performance Achievement Rate`,
"label.donot.update":`You have no permission to modify!`,
"setup.mainpage.label.welcome14":`Process management of workflow customization, approval`,
"UG_Campaign_002":`Plan, execute and monitor the effectiveness of market activities.`,
"label.layout2":`Layout Two`,
"label.app.looup":`Find apps`,
"label.projectManagement.selectitem":`Please select project`,
"label.field.relating.rule":`Assoication Rules of Lookup Fields`,
"vue_label_commonobjects_detail_selectname":`Please select a name first`,
"front-email-payment-Invoice-select-pay":`Select Pay By:`,
"label.customfields.formula.numberexample":`Fahrenheit = 1.8 * Celsius__c 32`,
"component_event_label_enddate":`*End Time`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Credit Limit`,
"label.chatter.newpost":`Lasted Post`,
"label.report_dashboard":`This report will be saved to your reports. You can also add it to a dashboard.`,
"label.assigned":`Assigned To`,
"Homepage_News_002":`The news component is not available currently.`,
"label.approval.select.relatedobj":`To select the relevant item, it must choose a type`,
"label.service.miniProgram.isTop":`Pin to Top`,
"message.error.object.datatoolang":`Data length is too long, maximum {!length} characters.`,
"label.importsourcetip":`Importing is designed to accept the files produced from our Export process. If you have not done an export, please go to the export page now.`,
"label.select.deadlineplease.deadline":`Please select deadline.`,
"vue_label_account_equityrelationship":`Equity Relation`,
"label.account.Calendar.month":`Calendar Month`,
"label.appointment.wizard.subtitle3-4":`Thursday`,
"font-evaluate-module-v1-smaller-500":`The file shall be less than 500KB`,
"label.reportsSubscriptionPage.email.tome":`Only to Me`,
"label.ccchat.person.invite.existpers":`Already tracking:`,
"label.appointment.wizard.subtitle1-3":`30 min`,
"front-kefu-moudle-connected":`Connected`,
"label.campaignmember.main.duplicatelist.tip":`System will find duplicate leads and campaign members based on the settings here.`,
"label.visualpage.such.tags.double":`These tags will appear in pair`,
"label.sendsms.batch.step2.introduce":`Please select an SMS template.`,
"Account_News_Setting_002":`Use the account settings below to specify default account behavior for your organization.`,
"message.encryptchange.alert":`You are about to convert {{!fieldapi}} from an Encrypted Text field(Storage Encrypted) to an Encrypted Text field(Display Encrypted), after successful conversion, this field will be stored in clear text in the database, which can be displayed in clear text or encrypted text according to profile settings. Fields are searchable.\\r This operation is irreversible, do you want to continue?`,
"label.mainpageset.description":`Configure your organization-level homepage based on your actual business needs.<br>Components in default configuration that are not relevant to your business can be disabled or turned off.<br>Enable: enabled components are displayed on the homepage of all members.<br>Disable: disabled components are not displayed on the homepage of all members, nor will they display in the list of “Configure My Homepage” in app.<br>Turn off: turned off components do not display on all members’ homepages by default, and users can turn on them by “Configure My Homepage” in app.`,
"label_tabpage_linknamez":`Link name`,
"label.companyname":`CloudCC.com Ltd. Co`,
"label.currency.current":`Current Corporate Currency`,
"label.campaignmember.main.duplicatelist.html.title":`Setting of the duplicates removing by scanning code`,
"label.sendsms.batch.step3.plan":`Delivery Date Plan`,
"label.profile":`Profile`,
"label.canceluploadfile.step":`Click the Cancel button to cancel all files showed in the upper area`,
"message.newreport":`New Report`,
"label.service.newBuildDialog.date.selection":`Select Date`,
"label.lookup":`Lookup`,
"label.file.editinfo":`Edit file details`,
"component_assistant_label_nodata":`No event today, please check later.`,
"label.tianyancha.businessverify.msg4":`This function uses third-party services and it is currently available to users for free.but CloudCC does not guarantee that third party will always provide the service to users for free. if third party charges a fee, CloudCC has the right to charge or stop the user from using this function.`,
"label.noequal":`!=Not Equal`,
"vue_label_metric_column":`The table must have at least 1 evaluation column.`,
"label_reportType_chose_and_form":`Select the report data source and a report format`,
"vue_label_pool_reasondescription":`{0} reason description`,
"label.isusing":`Active`,
"label.passwordPolicy.setup.pwdremember5":`5 passwords remembered`,
"label.cancel":`Cancel`,
"vue_label_helpcenter_detail1.1":`activities, and dynamics of each record, and fold or unfold the corresponding information in the upper right corner of the module. You can also view and manage the data associated with the record through the related list.<br> 1. View and manage a single piece of data<br>You can edit, copy, delete, or share data for other personnel through the buttons in the upper right corner.<br>View the user's detailed information, and you can directly edit some fields on the page to change the owner or record type of the data.<br>View and manage the data associated with the record through the related list. In the file related list, upload the recorded file, or click the file name to download and view the corresponding file.<br> 2. Related lists<br>Quickly connect through the related list, and use the floating window to view up to 10 related records. Click to enter the list view, view all related records, and edit inline.<br>Use card layout to view and manage related records below.<br> 3. Activities<br> On the recorded details page, the Lightning version does not display the two related lists of "unprocessed activities" or "activity history". Instead, the activity timeline is displayed.<br>Activity timeline displaying content<br> The activity timeline can display all the activities that from future to past in the current record. Overdue tasks and upcoming tasks and events are displayed in the "Overdue and Coming" module of the event timeline. Past or currently completed tasks, events, recorded calls, emails, and text messages will be displayed in the corresponding month.<br>`,
"registration.page.preview":`Preview Registration Page`,
"label.quickbooks.search":`Search`,
"label.setup.mobile.bottombutton.tab.show":`Tab display on the bottom`,
"lable.want.to.delete.tem":`Are you sure you want to delete the service report template {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Modify {0} from {1} to {2}`,
"vue_label_pool_return":`Return`,
"vue_label_calendar_failed_to_share_calendar":`Failed to share calendar`,
"label.less":`< Less Than`,
"label.email.form.html":`Html`,
"label.tag.nodata":`No records`,
"label.setarticlecon":`Specify Entry Criteria`,
"label.searchlayout.displayrow":`Columns to Display`,
"label.change.task":`Task View`,
"lable.quote.editqtpdt.title":`Quote Line Items Edit`,
"label.appointment.wizard.subtitle4-4":`How far in the future can someone book you?`,
"label.custom.page.button.css":`Button CSS`,
"label.input.documentmessage":`Enter details`,
"vue_label_commonobjects_detail_email_address":`Recipient Address`,
"label.chatter.filterTimeLine":`Filtering time line`,
"label.must.select.twoorthree.records":`You must select two or three records to merge`,
"label.mobile.setup":`Mobile App Settings`,
"vue_label_commonobjects_detail_key_field":`Key Fields`,
"label.chatter.relateitem":`Related To`,
"label.customobjects.tip":`Once you have created a custom object, you can create a custom tab, custom related lists, reports, and dashboards for users to interact with the custom object data. You can also access custom object data through the API.`,
"label.sso.saml.idp.config":`Identity Provider`,
"label.knowledgebase.affect.article.version":`Will the modification affect the existing translation? If so, you can mark precious translation as "Expired" and generate a list of pendign for translation for the translation suppliers.`,
"message.error.record":`The corresponding record was not found!`,
"message.duplication.label.fieldname":`Target Field`,
"setup.layout.button.cancel":`Cancel`,
"label_radar_map_function":`Use radar charts with multiple metrics to measure the role of contacts in the sales decision chain.`,
"label.campagin.roi.fss":`Num Sent`,
"label.emailobject.template.giveup":`Cancel`,
"label.apiname.exists":`API name already exists.`,
"message.failtoreaddata":`Read data failed`,
"label.file.versionedit":`Content Modifier`,
"template.report.lost.business.opportunity":`Lost Opportunities`,
"label.ccchat.group.allowgd":`Allow groups to archive`,
"label.fieldaccesslimit":`Field Accessibility`,
"label_target_model":`Target Model`,
"message.validation.isnoturl":`Invalid URL`,
"servicecrew.member.time.conflict":`Within this time range, service resources have become members of other service teams.`,
"label.knowledgebase.delete.details":`It will delete any assignment information.`,
"vue_label_normal_bottom":`Bottom`,
"label.custombutton.editerror":`Edit failed`,
"label.dashboardSetup.showdw.d6":`Automatic`,
"message.error.field.decimalPlaces":`Decimal input format error.`,
"label.tabpage.busoppnamez":`Opportunity Name`,
"label.insertfield.intro":`Please select a field, and click "Insert". With the ">" means click to view more available fields.`,
"setup.layout.label.nocustompage":`No custom pages`,
"front-gantt-module-project-has-only":`This project has only {n} milestones`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Connected Email Account`,
"label.customcomponent.check.name.same":`This name already exists.`,
"label.validate.function.funcFormat.HOUR":`HOUR(date)`,
"label.approvepagelayout4":`Copy previous page layout`,
"label.knowledge.category.hint.nine":`Activate Category Group`,
"label.report.sorting.column":`Column Sort`,
"label.hours":`Clock`,
"label.email.clearAllemail":`Do you want to empty all synced Emails in the mailbox?`,
"font-evaluate-module-v1-satisfaction":`Satisfied Evaluation`,
"label.service.hide.more.info":`Hide More Info`,
"label.area.list.intro":`You can edit territory information on this page.`,
"label.sendemail.chat.addPostat":`Dear #name:\n\n hello! #userName mentioned you in a post.`,
"label.data.newtemplate.e_seltype.desc":`There are two kinds of derived data</li><li class="titledesc1">1.one is the CSV format(the default)</li><li class="titledesc1">2.the other one is compression format. Compression format mode is divided into two kinds</li><li class="titledesc1">2.1.one kind is the automatic generation of compressed files password,automatically generated password will be sent to the user after successful data export mailbox</li><li class="titledesc1">2.2.another is to manually enter the compressed files password,manual input password will not be sent to the user's mailbox,so the need for users to remember the password.If you do not enter,the default is no password.`,
"message.passwordPolicy.validate.minlengths":`Error: Your password must be at least`,
"message.save":`Are you sure you want to save?`,
"label.marketsea.notfollowdays1":`After obtaining`,
"label.app.step1":`Step 1 Select Type`,
"message.error.pageid.null":`Facebook social media ID cannot be empty!`,
"label.weixin.input.lookupfield":`Enter keywords to find the matching micro vote`,
"label.whChatAccount":`WeChat Account`,
"label.tabpage.groupingitem":`Grouping item`,
"label.callboard.introduce":`All announcements of your company are listed below.`,
"label.financial.services.seminar":`Financial Planning Seminar`,
"label.data.file.i_title.num1":`1. The imported file must be a file in CSV format. The file must contain a title and cannot be imported without title.`,
"label.visualpage.filename.exist":`The file name already exists.`,
"front-kefu-moudle-v1-new-chats":`New Agent`,
"label.console.step5.tab":`Open Menu`,
"vue_label_opportunity_contactrole_edit":`Edit Contact Roles`,
"label.projectManagement.delete.return":`It will return to the previous page after deleting the last data.`,
"registration.page.designs":`Appearance Setting for Registration Page`,
"label.console.step6.heigth":`Heigth`,
"label.objectRelationshipAtLeast":`have one record at least related to`,
"label.knowledge.delete.viewstat":`Erroe while deleting browsing data of knowledge article`,
"label.direct.dashboard.month.report":`New Monthly Work Note`,
"label_tabpage_lookatmorez":`SEE MORE`,
"label.setup.rights.management":`Entitlement Management`,
"label.campaign.channel.clear.img":`Clear Image`,
"label.calendar":`Calendar`,
"label.biaoqingfaxian.username":`Account`,
"label.weixin.wdyj.jxht":`Personal-Sales Performance-Contracts`,
"label.emailtocloudcc.exists1":`This mailbox has been set to Email to Lead. Do not repeat settings.`,
"label.emailtocloudcc.filed.password":`Password`,
"label.what_create":`Which kind of form do you want to create?`,
"vue_label_report_onlydisplaypart":`Up to 50 pcs of data. All data are displayed after running.`,
"label.up":`Up`,
"label.addattachment.edit":`Attachment Edit`,
"label.ccchat.message.search.desc5":`Search words cannot be less than 2 characters`,
"label.chose.nonotice":`Please select the record that no longer reminds you`,
"UG_activity_06":`Want to follow up with accounts`,
"label.set_contactsmarketing":`Set as Campaign Contact`,
"pagecreator.layout.button.horizontal":`Lateral disassembly`,
"label.brief.opportunity2":`Opportunities Expected to Close`,
"label.ems.nomsg":`Not setup`,
"label.fieldupdate.tip":`Field updates allow you to automatically change a field value to one that you specify. Field updates are actions associated with workflow rules and approval processes.`,
"label.sso.saml.sp.federationid":`Federation ID`,
"label.import.page2.suited":`Mapped`,
"message.error.appexchange.integrity":`Ensure the integrity of the components in the upload package.`,
"label.fielddatatype":`Field Data Type`,
"message.approval.cannotsubmit.detail2":`The record must meet the following criteria or the formula evaluates to true, otherwise the approval request cannot be submitted, please resubmit ot after modification.`,
"vue_label_commonobjects_detail_cloud_as_a_user":`Login Partner as User`,
"label.summaryreport.selectlinetogroup":`Select the column on which the report grouping is based`,
"label.tabpage.norecordtypez":`Unusable record type`,
"label.icon.141":`Currency`,
"label.addattachment.step3.intruduce":`If you are uploading, this will cancel the ongoing upload.`,
"label.trigger.recursive.call.three":`Triggers can be called interatively, the number of loops is limited to 3 times, if more than 3 times the system will have an error prompt.`,
"maintenanceplan.workorder.type.asset.workorder":`Please choose "One work order for each asset" as the generation type of work order.`,
"label.emailtocloudcc.select1":`Please choose`,
"label.system.log":`Configuration Audit Log`,
"vue_homepage_dashboard_not_support_fullscreen":`Sorry, your browse does not support fullscreen.`,
"label.projectManagement.nodata.resource":`Not yet involved in any projects. Add 'My' project information to the members to view the time allocation of team members.`,
"label.exchange.sync.state.contact":`Contacts`,
"label.field.type":`Field Type`,
"label.selected.object":`Selected Object`,
"label.customfields.new.step2":`Step 2 Enter the Details`,
"label.monitorsys.delete.style":`Operation Types`,
"label.projectcondition":`Entry Criteria`,
"potential.customers.field.default":`Default setting of leads`,
"message.password.nosame":`The passwords do not match.`,
"label.validate.function.funcExplain.MONTH":`Returns the month, which is a number between 1 (January) and 12 (December)`,
"label.project.user.project.count":`Number of Projects that Users Participated In`,
"chatter.to":`to`,
"vue_label_commonobjects_detail_activity_owntask":`owned task`,
"label.generate.mobile.page":`Mobile page is completed.`,
"label.escalation.setup.newentries.step1":`Step 1 Set the order in which this rule entry will be processed`,
"label.email_footer":`Email Footer`,
"label_partner_workspace_member_profile":`Available profiles`,
"label.loginhis.between":`Start date distance end date cannot exceed 2 months`,
"label.user.verficationcode.error":`Wrong verification code.`,
"label.email_notifications":`Send email notification of submission`,
"APPIntegration_Dropbox_01":`Select files from Dropbox`,
"label.projectManagement.Selectweek":`Select Week`,
"wednesday":`Wednesday`,
"message.atleastonereceiver":`Please select one recipient at least`,
"label.applt.link.text":`We have linked your company to the portal mini program. Copy the portal address of the mini program dedicated to your company, place the mini program address in the jump link to your company's official accout menu, then customers can click on the menu to use the mini program. (Official account custom menu < Jump to mini program< Mini program path)`,
"label.wait.for.a.moment":`Please wait for a moment while setting the language...`,
"vue_label_chatter_only_group_members_look":`Only group members have access to view, you can try to apply to join the group`,
"label.knowledgebase.last.release":`Last Published`,
"component.setup.label.pagesize":`Items per page`,
"label.paging.totalofpages":`A total of {0} pages`,
"label.globaloperation.successmessage":`Success message`,
"label.logout":`Logout`,
"label.partner.common.enable":`Enable Partner Cloud`,
"label.permission.objectpermission.goback":`Back to List: Permission Sets`,
"label.approvalstep5.required":`Required`,
"component_chatter_label_to":`To`,
"message.please.choose.role":`Please select role`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`You must select the contract line item under the service contract associated with the maintenance plan.`,
"label.projectManagement.Resource.usage.view":`Resource Utilization Chart`,
"label.smsmainbody":`Message Text`,
"label.ccchat.error.nullname":`Name is required`,
"label.appupload.upload.version":`Version Number`,
"label.data.setok.t_desc2":`Back to Data Template Page`,
"vue_label_pool_allocationstatus":`Allocation status`,
"label.tianyancha.orgapprovedinstitute":`Org approved institute`,
"label.quickbooks.searchlist.startdate":`Start Date`,
"label.setapp":`App Settings`,
"chatter.about":`About Me`,
"label.layoutname":`Page Layout Name`,
"label.icon.160":`Earth`,
"label.tabpage.Rolesz":`Roles and Subordinates`,
"label.console.step5.introduce":`Choose how to display the following items`,
"label.customfields.totalsummary.gettogetherfield":`Field to aggregate`,
"message.appexchange.addtopackage.profile":`Only one profile component can be added in a package!`,
"vue_label_file_user_header_pic":`Avatar`,
"font-trade-module-v1-invoice-detail-price":`Detailed Payments`,
"homepage.components.three":`Step 3 Enter the contents of the custom components display`,
"nine":`Nine`,
"label.marketsea.button.restore":`Restore`,
"label.forecast.editshrepage.desc2":`Individual sharing can only be used to grant greater access to data, not to restrict access.`,
"label.cloudccsite.list":`Sites`,
"label.icon.35":`Cloud`,
"vue_label_pricebook_price":`Add Standard Price`,
"label.version.sum.addressfield":`Address field(s)`,
"label.projectManagement.Gotomilestone":`Turn to Milestone`,
"label.dataimport.name.length":`Error: The length of name is too long.`,
"label_alculation_method":`Caculation Method`,
"label.uploadfile":`Upload File`,
"label.ems.otheraccount":`Other account`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Are you sure to join this Team`,
"message.error.chatter.img.nodata":`Error: The image file does not exist and cannot be captured.`,
"component.chatter.file.button.files":`Select a document`,
"label.salescloud.teamrole.optionlist.choose.null":`Role name is required`,
"label.yourexportsuc":`Your export request has been processed, please view your email.`,
"pagecreator_systemstyle_label_modifycolor":`Edit color`,
"label_partner_setup_title":`Settings`,
"label.chat.topic.topic":`Topic`,
"file.error.nottype":`Error: Invalid type. File types that can be uploaded are txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`All Time`,
"homepage_componet_approval_label":`Items to Approve`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Pay Merchant No.`,
"label.user.resetpw":`Reset Password`,
"label.exchange.sync1":`After setting up a service account with impersonation permissions for the users in Microsoft©Exchange, enter the service account credentials to allow CloudCC communicate with the Exchange server.`,
"label.import.index.editfield":`Edit Field Mapping`,
"and":`And`,
"label.partnerCloud.cloudInfrastructure":`Partner Cloud Basic Setup`,
"label.escalation.setup.newentries.createdate":`When case is created`,
"Pagelayout.Setup.002":`You have selected 3 related lists, and adding more related list will affect the page layout.`,
"label.customfields.file.tip":`Allow users to upload files between 1 and N.`,
"label.tianyancha.businessverify.accname":`Real-time customer name query`,
"label.Additional.Conditions":`Filter service appointment according to additional conditions.`,
"label.emailtocloudcc.filed.type":`Provider`,
"vue_label_homepage_fixedcomponents":`Standard Component`,
"label.visualpage.delerror":`Delete failed, please try again later.`,
"label.tabpage.filetypez":`File Type`,
"label.emailobject.search.input":`Search`,
"label.createprocessstep2":`Step 2 Specify Entry Criteria`,
"label.weixin.inhead":`Processing`,
"component.recdetail.label.title":`Detailed information`,
"label.weixin.telephone":`Phone Number`,
"label.web.link":`Web link`,
"label.partnerCloud.paySuccess":`Paid successfully`,
"label.case.adress.link":`Web of Customer Service Portal`,
"label.emailobject.view.connectopp":`Emails Connected with Open Opportunities`,
"front-kefu-moudle-think-again":`Let Me Think Again`,
"label.Button":`Button`,
"chatter.pt.most":`Maximum file size is 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Days before level date`,
"label.ems.relatedobj":`Related object`,
"label.notification.insert.approval":`[提交人] submits [对象] for your approval`,
"label.setting.codeSet":`Code Set`,
"vue_label_report_rowlevelformula":`Row-level formula`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`Copyright © 2008-2023 CloudCC Inc. All rights reserved.`,
"component.setup.button.save":`Save`,
"label.emailsync.button.sure":`Confirm`,
"label.multilang.dupicatecheck.getdatalist":`The {0}-th group of duplicated data, has a total of {1} records:`,
"label.ccchat.person.invite.tochat":`Invite people to CCChat`,
"label_partner_all_maxNum":`Maximum data of partner cloud:`,
"label.checkfield":`Field Settings For Finding Duplicates`,
"label.sales.dashboard.income":`Revenue Goal`,
"label.setup":`Setup`,
"label.dashboardSetup.center":`Medium`,
"lable.quote.syncing.finished":`Sync Completed`,
"vue_label_helpcenter_dashboard1":`In order to help you display statistical data more intuitively, CloudCC Sales Cloud Lightning dashboard provides you with powerful chart production capabilities.<br> CloudCC Sales Cloud Lightning version dashboard has the following characteristics<br>Able to use different data sources: you can select the original data in a view under the object as the data source, or you can select the data after the report is processed as the data source<br>As many as 13 kinds of chart templates for you to choose: support sales funnel, pointer meter, pie chart, secondary grouped histogram, etc. <br> Freely drag and drop to change the size and position of the chart: the dashboard can distinguish important data and auxiliary data by placing the position and size of different charts, which are completely up to you<br>Dashboard overall filtering: The dashboard supports filtering the built-in chart data with filter fields set by time range and user<br>Data caching: Dashboard chart data can be cached when it is first created, reducing secondary loading time. <br>Component penetration: You can jump to the corresponding report details or the record list in the corresponding view of the object by clicking the component<br>Component linkage: In the same dashboard, a component can set up other components of the same data source to interact with itself. By clicking on the data area in the component, other components can be set to re-count the data according to the filtering conditions of this data area<br> 1. Create a new dashboard<br> As a sales representative or manager of the sales department, you can display your sales data by making dashboards. The Lightning version of CloudCC Sales Cloud provides rich capabilities to make dashboards<br>Note: The data of the Lightning version of the dashboard and the old version of the dashboard are not interoperable. <br> Click the "Dashboard" tab, click "New Dashboard", fill in the dashboard name and select the folder you want to save this dashboard to. You can enter a new dashboard.`,
"label.layout.availabletab.trackrecord":`Track Records`,
"label.campaignmember.main.deletecontact":`Remove Members-Existing Contacts`,
"lable.outlook.mcto.emaltoc":`When emails are sent to CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`Offline cache settings have been saved sucessfully.`,
"label.timezone.default":`Default Time Zone`,
"label.noRules.have.been.enabled":`No enabled rules`,
"label.ccchat.person.invite.existsend":`Some of the email addresses you entered match existing users.`,
"label.work":`Work`,
"actualstarttime.actualendtime.time.illegal":`The actual start time of the service appointment should be less than or equal to the actual end time.`,
"lable.product.stsp":`Setup Standard Price`,
"vue_label_normal_account_sf":`Account`,
"label.finishpic":`Generated Charts`,
"label.h5.similar.opportunity.step3":`Step 3 Select Fields to Display for Similar Opportunities`,
"label.relateobjDefault":`Default Record`,
"label.customcomponent.check.tag.endwith":`Component must end with the label`,
"label.related.organization":`Related Opportunity`,
"label.recordtype.edit.selectvalue.orderby":`Option List Value Sort`,
"vue_label_homepage_enter_name":`Please enter a name`,
"label.permission.group":`Permission Groups`,
"label.emailobject.send":`Send`,
"label.ralateuser":`Related Users`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`Select the fields to be displayed on homepage tab.`,
"setup_mainpage_label_welcome3":`Forms creation in the CloudCC cloud platform relies on custom databases (object), user-defined objects are database tables that store data specific to your organization. Table-to-table relationships can be easily established without any program development.`,
"label.user.notallowed.login.scope":`You are not allowed to log in within the time frame or your IP is restricted.`,
"label.tel.ten.case":`You can enter up to 10 phone numbers to receive notifications, each number is separated by ",".`,
"front-kefu-moudle-v1-user-info":`User Information`,
"label.aboutme":`About Me`,
"label.setfieldediting.tip":`When you define approval steps, you can assign approval requests to different users. One of your options is to use a user field to automatically route these requests. If you want to use this option for any of your approval steps, select a field from the picklist below. Also, when a record is in the approval process, it will always be locked-- only an administrator will be able to edit it. However, you may choose to also allow the currently assigned approver to edit the record.`,
"label.existing_dashboard":`Add to existing dashboard`,
"label.sendemail.spotsign":`Dear #name: the campaign member #customer you have invited to #activity has arrived and signed in,please note that.`,
"UG_solution_01":`Provide the solution`,
"label.tianyancha.estiblishtime":`Estiblish time`,
"label.pc.lightningpage":`Lightweight application (beta)`,
"label.saveAndSync":`Save And Synchronize`,
"label.state.end":`Completed`,
"label.sendemail.queue.assigninfo":`Queues:[#queueName] has assigned #objectName: #recordName`,
"label.approvalprocessname":`Approval Process Name`,
"label.view.conditions.message":`Filtered by {!conditions}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Alipay Business Account`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Please configure at least one online payment account`,
"label.step1.total6":`Step 1 of 6`,
"label.appointment.wizard.subtitle4-1-3":`45 min`,
"label.emailobject.markasread":`Mark as Read`,
"message.error.orgid.null":`orgid cannot be null!`,
"label.emailtemplate.mergefield":`Merge Field Value`,
"label.weixin.recent.list":`Recently Viewed Lists`,
"label.emailsync.form.email":`Email`,
"label.funnel":`Funnel`,
"label.logintime.clear":`Clear Time`,
"label.chatter.followed":`Followed`,
"label.ccpeak.function.field.spack":`Fields in a function must have sapces on both sides.`,
"label.setup.mobile.offlinecache.remark":`After enabling this function, members of organization can create, edit, and delete records while offline with mobile devices`,
"label.product.function":`Package Categories`,
"label.icon.14":`Hammer`,
"message.report.nodata":`No data was returned.`,
"label.please.ChooseMin":`Please choose at least {a} product options`,
"label.tabpage.releaseTourz":`Publish guide`,
"vue_label_chat_opportunity":`Opportunity Team`,
"vue_label_chatter_refucecertification":`Are you sure to refuse "{name}" to join the team chat?`,
"label.version.unlimited":`Unlimited`,
"label.processsetting.enable.prompt":`After enabled, the path to the settings will be in the details page corresponding to the lightning version. You can also save the settings first and enable later.`,
"label.page.display.property":`Display Properties`,
"label.service.appointmentList.thisOption":`Unchecked`,
"label.register.date":`Registration Date`,
"label.brief.contract.amount":`Contract Amount`,
"setup.object.field.dependency.label.actionfieldnotnull":`Please select a controlling field first.`,
"UG_homepage_009":`Access CRM`,
"label.icon.98":`Folder`,
"label.weixin.datacount":`Total`,
"label.mobile.hasbind":`This mobile number has been used. The last binding will be freed if you continue to bind.`,
"label.emailtemplate.choosemorecontacts":`Select more recipients`,
"setup_layout_button_deleteitem":`Remove the selected items`,
"vue_label_account_collection_plan":`Unprocessed Collection Plan`,
"label_chatter_maturiyDate":`Expire date`,
"label.emailtocloudcc.license":`License`,
"vue_label_checkduplicate_complete_check_rules":`Please complete duplicate checking rules`,
"chatter.up.type":`You can upload a jpg, gif or png file.`,
"label.attendance.nocheckout":`Not Check-Out`,
"label.setup.mobile.offlinecache.remark2":`The selected tabs will be enabled on the mobile devices of all users in your organization as the default offline cache tabs.each user can disabled the offline cache tabs of organizational settings, or enable other tabs as offline cache tabs depending their needs.`,
"template.report.count.marketing.activities":`Total Campaign`,
"label.multilingual.tip4":`If multilanguage is disabled, the default company language will be set to Chinese or English based on the company address, and the language of all users is set to the default company language.`,
"label.settings_area":`Settings area`,
"label_assessment_content":`Appraisal Content`,
"label.top":`Top`,
"UG.Account.06":`Create an account`,
"label.emailtocloudcc.step1.case2":`Once configured, mails received in this mailbox will be automatically logged as case records in CloudCC. According to the outbox matchng contact and account, relate case to the correspongding contact and account, so as to facilicate the acceptance and tracking of cases.`,
"label.forecast.forehistory.best.remark":`Best Case Notes`,
"label.project.problem.date":`The issue date must be within the date range of the milestone or project to which it belongs.`,
"label.forecast.customforecast.foredis.wzs":`Complete Numbers`,
"message.setup.field.name.value.notexists":`The team role list value you entered does not exist, please re-enter.`,
"label.salescloud.teamrole.opportunity.organization":`Team members may have greater access to this opportunity than default opportunity access settings of your organization.`,
"label.sms.message.input":`Please enter the message`,
"label.document.type.not.allow":`This document type cannot be uploaded!`,
"label.customfields.totalsummary.tip":`A Read-Only field that displays the sum, minimum, or maximum value of a field in a related list or the record count of all records listed in a related list.`,
"label.tabpage.filesizez":`File size`,
"label.import.page2.filedname":`File name`,
"label.same.analyze":`My Similar Opportunity Analysis`,
"label.service.gantt.refreshData":`Update data after refresh the page.`,
"label.sendsms.batch.step2.sendbycontext":`Send by custom SMS content`,
"UG_Account_05":`Contact structure diagram`,
"label_emailtocloudcc_step1total3":`Step 1 of 3`,
"label.weixin.no.history":`No history records`,
"label.datamanage.queryfield.error":`Query field error.`,
"label.emailmerge.mergeFolder.emailmerge":`Mail Merge Templates`,
"label.workflow.estimatecondition":`Evaluation Criteria`,
"label.autonumberfield.wrong":`Please enter a number from 0-{0}`,
"label.data.setok.t.desc1":`If you need to use this template derived data,please click`,
"label.data.downpage.i.title":`Data Import Steps:`,
"label.data.downpage.i_list.desc2":`After importing the data, you will receive an email reminding you of the import successfully.`,
"label.opportunity.jieduan":`Current Stage`,
"vue_label_commonobjects_view_sumby":`Aggregate method`,
"label.knowledge.setting.hint.three":`We can prepare you for operation. Here's what you need to set up:`,
"page.activity.history":`Activity History`,
"label.cancelQuoteLineGroup":`Cancel quote line group`,
"label.addattachment.batch.step3":`Step 3 click button to finish.`,
"label.chat.topic.follow":`Follow`,
"label.import.page1.uploadcsvfiled":`Drag or click to upload CSV file`,
"label.batchtransfer.datetype.tip":`For date fields, enter the value in following format:`,
"vue_label_systemSettings_application_util":`Application Management Console`,
"label.partner.workspace.member.selectedpermission":`Selected permission set`,
"label.service.appointmentList.plansToEnd":`End Plan`,
"label.industrialandcommercialverification.contactinformation":`Call for purchase or questions 400-642-2008`,
"chatter.del.p":`Delete this post`,
"label.forecast.customforecast.replacefirst":`Overridden by me`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Scoring Rule Name`,
"label.weixin.appr.applicant":`Submitted By`,
"component_event_label_calendar":`View calendar`,
"step":`Step`,
"label.attendance.setting.position.alert":`Office Worker must set the localtion of landmark.`,
"label.end":`Completed`,
"label.mobile.change.owner.success":`changed to the new owner`,
"label.chinese":`Chinese`,
"label.textmessage.vonage.account":`Account Information`,
"front-console-no-related-contact":`Please associate with contact first`,
"label.dashboardSetup.seltype":`Optional Component Type`,
"chatter.follow.user":`Follow this user`,
"label.textmessage.sentsuccess":`Sent successfully`,
"label.australian.gentral.standard.time":`Australian Central Daylight Time （South Australia）`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`Signed`,
"label.processsetting.basic.settings":`Basic Setup`,
"label.escalation.setup.newentries.ifcondtions":`Run this rule if the`,
"label.lookup.nofound.data":`The value does not exist or does not match the filter.`,
"vue_label_commonobjects_view_chart_chartname":`Chart Name`,
"label.dashboard.show.percent":`Show %`,
"label.sso.saml.sp.userid":`User ID`,
"label_tabpage_minutesagoz":`minutes`,
"vue_label_chatter_comment_content":`Please enter comment content`,
"label.campaign.channel.step6.mobilepc":`Generate Mobile and PC Page`,
"vue_label_homepage_editprofilepage":`Edit Name`,
"label.tabpage.crecordtypez":`Change record type`,
"label.social.posts.type.null":`The post type cannot be empty`,
"label.projectManagement.groupbyuser":`Group by User`,
"vue_label_email_new_template":`Save as a new template`,
"label.ems.close":`Cancel`,
"label.ccdocument.noauthority.folder":`You have no permission to operate this folder.`,
"message.filterconditionerror":`<strong>Error: </strong> Your filter misquoted filter conditions:`,
"label.User.Interface":`User Interface`,
"label_tabpage_greaterz":`Greater than`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Select And Continue`,
"vue_label_commonobjects_detail_influence":`Influence`,
"label.total.have.priority":`is prior`,
"label.manageAll.sta4":`Recall`,
"label.setup.mobile.offlinecache.setup":`Mobile-side offline cache settings`,
"vue_label_chatter_cancel_adding":`Cancel`,
"vue_label_lead_select_existing":`Select Existing`,
"front-epwechat-module-v1-contacts-sync":`Sync WeCom Contacts`,
"label.appupload.component.type.recordtype":`Record Types`,
"label.layout.hint":`This page is not available for preview. Please save and view in the foreground page.`,
"label.change":`Change`,
"setup_layout_label_detailpage":`Detail Page`,
"label.imgfield.use.tip":`img(docid,width,height), this function is used to output images, "docid" is the document ID, "width" sets the width of the picture (Integer type can be null), "height" sets the height of the picture (Integer type can be null).`,
"pagecreator.systemstyle.button.edit":`Edit style`,
"label.delete_externalpage":`The ' ' you want to delete cannot be withdrawn, please confirm again. The form is not used on any login page, but may be used elsewhere. For example, you may have used the embed code to insert it into an external page.`,
"font-evaluate-module-v1-open-case":`Reopen case:`,
"label_not_adjust":`No Adjustment`,
"vue_label_title_ordernow":`Subscribe Now`,
"label.notification.serviceappointment.allocation":`You have been dispatched a new work order {0}, please check it.`,
"label.objectRelationshipDescription2":`. You may define which related records from other objects are returned in report results by choosing a relationship to another object.`,
"vue_label_calendar_notice_createfail":`Failed to create calendar`,
"label.ems.step1":`Step 1`,
"label.ems.password":`Password`,
"label.icon.143":`Piggy Bank`,
"label.select.year":`Select Year`,
"label.termsforusage.dialog":`Terms of Use (New window)`,
"label.tag.addtags.create":`Create`,
"label.emailobject.groupemail.msg4":`will not send due to an invalid email address.`,
"label.version.sum.autonumberfield":`auto-No. field(s)`,
"label.projectManagement.unallocated.time":`Unassigned time`,
"PageLayout.Search.MultiSearch.002":`Enable customized search box (Single Field Search)`,
"label.icon.150":`VR`,
"label.SMS.edit":`SMS Notification Edit`,
"Opportunity.Detailed.Phase.Label.003":`Change Stage`,
"vue_label_helpcenter_all":`1. Global Search<br>Global search is a tool to help you quickly find what you need. <br>Enter keywords in the search input box in the navigation bar at the top of the page. During the input process, the system will recommend relevant content for you in real time according to your input content; <br>Click "Search" or directly press the keyboard Enter key to open the search results page; <br>In the results page, you can filter the object on the left to view the list of search results under that object. Up to 10 records were recommended for you in the result list. You can click "View More" to enter the list page of this object to view more search results; <br>Note: The system search for "quotation", "customer", "lead", "business opportunity", "marketing activity", "contract", "product", "service request", "task" and "event" by default. <br>2. Quick Create<br>    Click " " in the navigation bar, and you can select the object you want to create in the drop-down window. <br>3. My Center<br>    Click on the avatar on the right side of the navigation bar to open My Center window. The following functions are provided: <br>Quickly enter the personal settings page, batch import and recycle bin entrance; <br>If you are in the trial period, click "Order Now" to quickly enter the Cloud CC order page; <br>Click on a version to switch quickly; <br>Sign out. <br>4. Menu<br>Some menu objects are recommended for you in the menu bar. You can click on a menu to quickly enter the page. You can also view all the menus and set the frequently used menus to be displayed in the menu bar.<br>All Menus: Click "More", and click "All menus" at the bottom of the drop-down box; <br>Customize My Menu: Click the button on the right side of the menu to open the custom menu window and set the common menus you need to display in the menu bar in all menus. <br>5. Application Launcher center<br>Click the icon on the right side of the menu bar to quickly switch to the system administrator to configure other application services for you. <br>NOTE: An application is a collection of a series of functional modules (such as lead management, business opportunities, contract management, etc.) that can be used to meet specific business needs.`,
"label.summaryreport.2018.step5.new":`Step 5 Select report criterias`,
"label.weixin.id":`Number`,
"chatter.pu.mess":`post(s)`,
"label.weixin.lookup.record":`Find Records`,
"label.ServiceCloud.statistics.by.address":`Statistics by Address`,
"label.jixiaoswitchoff":`Collapse`,
"label.savealipay.failure":`Failed to save information of Alipay merchant`,
"template.chart.khdqfb":`Accounts Regional Distribution`,
"front-email-payment-immediate-payment":`Pay Now`,
"label.dashboard.unit5":`Unit: 100 million`,
"label.tabpage.greaterz":`Greater than`,
"vue_label_calendar_stop_sharing_calendar":`Stop sharing calendar`,
"label.projectManagement.allhours":`All (hours)`,
"label.currency":`Currency`,
"label_vue_create_edit_obj_create_event_dialog_title":`Repetitive Schedules Reminder`,
"front-template-V1-templateSetting":`Template Setup`,
"label.dashboard.away.condition":`Collapse Condition`,
"label.replacelayout":`Replace Page Layout`,
"label.permission.detail.system.setting.tip":`Execute the operation applied to the apps. For example: modify permissions for all data`,
"label.customfield.delete.prompt":`Custom Field Label`,
"label.add":`Add`,
"label.deputationalsoapprove":`Delegated Approver also can approve this request`,
"label.leave_nosave":`After leaving, the current data will not be saved.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Restore`,
"chatter.feed.menutype.feed.markcom":`Bookmark Post`,
"label.query.data.error":`Failed in querying related lists`,
"label.pc.ui.2018.unpin":`Unpin`,
"label.partner.template.memo":`Title`,
"label.weixin.cannot.gain.userinformation":`Unable to obtain user information.`,
"label.stdashbord.xsld.department":`Department`,
"label.service.ganttBaiduMap.scheduled.starttime":`Planned Start Time`,
"label.documentforms":`Documents`,
"label.operator.insert":`Insert Operator`,
"label.processsetting.select.five.fields":`Up to 5 fields can be selected.`,
"label.weixin.password":`Password`,
"vue_label_chatter_share_followers":`Share with followers`,
"label.brief.baifang":`Visits`,
"label.emailobject.track.unopen":`Unopened`,
"label.sendmail.immediately":`Send now`,
"label.partnerCloud.payTheAmount":`Payment Amount`,
"label.integrations.mailchimp.connect":`Connect CloudCC to your account`,
"label.datamove.record.sucessfully":`record(s) sucessfully transfered.`,
"lable.outlook.edit.allocation":`Assign Users and Profiles`,
"label.chosesubject.talk":`Schedule A Talk`,
"label.escalation.setup.entrydetail.escalation.time":`Escalate At`,
"label.projectManagement.must.be.less.than.24.hours":`Less than 24 hours`,
"setup_mainpage_label_welcome15":`CloudCC Cloud Platform workflow rules automate the support process for your sales, marketing, and more. Depending on a predefined set of rules, records can be automatically assigned to users or converted from one user to another. The main benefit of workflow management is to improve work efficiency by eliminating many unnecessary operations when updating records, and to improve business processing levels and optimize control processes by standardizing work methods and reducing operating costs. It supports unlimited infinity approval for any object, and can trigger reminder email, SMS reminder, task, field update and other functions.`,
"label.mobile.phone.week.plan2":`This Week`,
"label.add.newAsset":`New Asset`,
"vue_label_salesadvance_losts":`Loss Number`,
"vue_label_report_editcolumn":`Edit column`,
"vue_label_homepage_assignedtasks":`Assigned tasks`,
"label.posting_from":`Published By`,
"year":`Year`,
"label.autoRegister.changepwd.setpwd.tip.letter":`At least one letter`,
"label.version.nonsupport.feature.staticresource":`This feature is not supported temporarily. Please wait for the upgrade before using.`,
"label.toleadmyclientandlinkman":`Import My Accounts and Contacts`,
"label.appupload.install.processcrash":`Deal with the conflicts`,
"label.profile.setstandardtab":`Standard Menu Setup`,
"template.chart.khhyfx":`Account Industry Analysis`,
"label.reportTypcrtC":`Associated object (c) please click to select related object`,
"vue_label_report_mayormaynothave":`The parent object may or may not have records related to this object`,
"label.service.gantt.plan.recommendation":`Recommended Schedule`,
"label.version.sum.lookupfield":`lookup relation fields`,
"label.builder":`Page Builder`,
"label.sharerule.remark":`Specify the sharing of this record. You can share the records and related data with the user, role, role and subordinates, users in a territory, users in the territory and sub territory.  Individual sharing can only be used to grant broader access to data, not to restrict access.`,
"vue_label_email_benn_added":`The mailbox has been added`,
"label.version.allow.sum":`,has reached the upper limit.If necessary,please upgrade CloudCC version.`,
"label.icon.130":`Currency`,
"label.custom.new":`New`,
"label.see_allfields":`View All Fields`,
"front-marketing-module-v1-share-poster":`Share Poster`,
"label.service.one":`Your filter references undefined filter conditions:`,
"lable.outlook.edit.alprec":`Always Preferred CloudCC.com`,
"Account_News_Setting_001":`Account Setting`,
"label.mr.caption.opportunity.result":`Find Duplicates and Merge: Results for querying duplicates of Opportunities`,
"label.forbidden":`Deactivate`,
"label.query.detail.openpartner":`Enable as Partner User`,
"label.session_date":`Session Date`,
"label.forecast.customforecast.submit.deyuce":`Forecast`,
"label.emailtocloudcc.filed.server":`Server`,
"label.emailtocloudcc.tip2":`After deleting, you will be not able use Email to CloudCC, are you sure you want to delete?`,
"pagecreator_layout_message_delete_fail":`Layout deletion failed`,
"front-lightning-module-v1-dashborad-export-PDF":`Export PDF`,
"lable.quote.syncing.syncingto":`Quote line items have been synchronized to opportunity products`,
"message.error.view.lastview.update":`Cannot delete the last public list view</br>You cannot change the visibility of the last public list view from "Visible to all users" to "Visible only to me"<br><br>`,
"label.weixin.select.one":`Select at least one`,
"label.projectManagement.Pleaseenterprojectname":`Please enter the name of project...`,
"label.data.downpage.e_list.desc1":`This page displays successfully exported files. Please dowmload the exported files in time addording to the download link in your email.`,
"label_tabpage_notexceed25":`The selected record must not exceed 25`,
"label.campaign.channel.step5.remark":`You have finished setting up the registration page.`,
"label.setup.mobile.bottombutton.profile.prompt":`Tips:customized bottom menu of profile will override the company bottom menu unified settings`,
"label.stdashbord.xsld.business.knx":`Probability`,
"label.setemailtip":`Create an email alert to associate with one or more workflow rules or approval processes. When changing an email alert, any modifications will apply to all rules or approvals associated with it.`,
"report.button.go":`Go to`,
"lable.the.united.arab.emirates":`Records have been recieved.`,
"label.writer. name.file":`Please fill in the quote file name`,
"label.validate.function.funcExplain.ADDMONTHS":`Add the num months to the date, using the last date of the month if date is the last day of the month or adding num months has fewer days.`,
"vue_label_chatter_enter_shared_content":`Please enter shared content`,
"message.lookup.condition":`Search criteria must enter more than one character`,
"vue_label_commonobjects_detail_customers":`Customers who permanently deactivate external users will ban all external users associated with the customer and remove them from all communities, groups, teams, permission sets, and sharing rules associated with them. At the same time, the roles and groups associated with the account will be permanently deleted and will not appear in the recycle bin. Are you sure?`,
"label.emailobject.view.all":`All Emails`,
"vue_label_file_size_limit_new":`Upload failed. The attachment exceeds {size}M.`,
"front-gantt-module-please-reorder-milestones":`Please enter a valid number to reorder milestones`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`Email`,
"label.namespaceprefix":`Namespace Prefix`,
"label.ems.delete.success":`Delete successfully`,
"label.partnerCloud.financeSetting.setWechatPay":`Set Up WeChat Pay`,
"front-epwechat-module-v1-input-token":`Please enter Token`,
"setup_object_field_dependency_button_setdependency":`Field Dependency Settings`,
"chatter.group.request01":`Request(s)`,
"message.error.field.number.length":`The length of the format you entered error.`,
"label.tabpage.lessz":`Less than`,
"vue_label_notice_uploadavatar_format":`The uploaded avatar image can only be in JPG/PNG/GIF format`,
"label.project.hit.thirteen":`Daily Milestone Reminder`,
"frame_personinfo_label_usethisimage":`We will use variations of this thumbnail image around the application.`,
"label.startuploadfile.step":`Otherwise not successfully upload files will be displayed in the upper area,need to be removed,then choose a new file.`,
"component_assistant_label_overduetask":`Opportunities with Overdue Tasks`,
"label.partnerCloud.financeSetting.information":`How to set up subscription information of Alipay?`,
"label.appupload.install.package.component":`Package Components`,
"label.emailobject.emaildetail.nextactivity.task":`Add Task`,
"vue_label_chatter_edit_post":`Edit Post`,
"label.appupload.upload.logo":`Icon`,
"label.role.selecteduser":`Selected Users`,
"label.letter.assign":`Specify the content of the invitation`,
"label.forecast.shrepage.title":`Forecast Sharing Details`,
"lable.Generate.service.appointment":`Service appointments generated by work order line item`,
"label.productsales.nodata":`No Data`,
"vue_label_email_Please_select_at_least_one_email":`Please select at least one email`,
"label.data.downpage.i_title.num4":`4. If you have a lookup relationship field and a master-detail relationship field in the object you want to import, the value for that field must be ID, otherwise it is invalid.`,
"label.new.exchagecurrency":`New Exchange Rate`,
"label.layout.listtip":`The table below shows the page layout assignment for different profiles.`,
"label.icon.2":`Wallet`,
"label.chat.topic.delete.prompt3":`Are you sure to delete this topic?`,
"UG_Lead_008":`Business card scan code`,
"label.multilang.databatchadd.fail":`{0} data are failed to be added：`,
"front-kefu-moudle-v1-chzx-confirm":`Are you sure you want to delete the agent?`,
"label.import.page1.matchlabel":`Match By {{$store.state.labelName}}`,
"label.dashboardSetup.showdw.d3":`Million`,
"label.version.ifnecessary":`If necessary, please upgrade your CloudCC version.`,
"label.confirm.delete.default.tab":`Are you sure you want to delete the default logging tabs?`,
"label.emailtemplate.mergefields.tip":`When users edit the email contents, they can add merged fields to replace text in the email content. When emails are sent, the system replaces them with text. For example, {!Contact.name} in your email will become the contact name.`,
"vue_label_chatter_decline_members_join":`Refuse members to join the group`,
"label.role.no":`No Roles`,
"label.service.gantt.resources":`resources`,
"label.knowledge.language.simplified":`Simplified Chinese`,
"label.eidt.queue.length.cannot.than":`Name length cannot exceed 50 charecters.`,
"label.mobile.quickcreate.default.tasks":`Tasks`,
"label.discount.yuan":`Discount (Yuan)`,
"message.error.delete.pending":`The record is pending for approval, you can not delete it.<br>Click <a href='javascript:history.back();'>here</a> to return.`,
"chatter.show.mostnews":`Show More`,
"label.optionlist":`Picklist`,
"template.chart.cpdj":`Product Pricing`,
"label.user.usernamepassword.error":`Please check your username and password.`,
"label.file.sharetype.check":`Viewer`,
"label.completed.generated.page":`PC page is completed`,
"label.martrixcross":`Matrix Cross`,
"label_tabpage_entercusnamez":`Please enter the customer name`,
"lable.account.NextwDays":`Next 30 Days`,
"label.list.userinterface.dashboard.hint":`New dashboard charts quickly shown on mobile phones,tablets, etc..`,
"message.fieldtrack.operatecreate":`Created`,
"label.service.gantt.available.plan":`Time scales that can be scheduled:`,
"label.activity.setting":`Activity settings`,
"label.tag.manage.record":`Number of records`,
"label.customcomponent.page.edit.title":`Edit Custom Components`,
"label.import.index.creationrecord":`Create a record`,
"label.tabpage.printz":`Print`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Discount Unit:`,
"label.weixin.micro.message.profile.associated":`WeChat official account associated with the company profile`,
"label.cpq.opportunity.pricebook.change":`This opportunity has been linked to a primary quotation and the price book cannot be changed`,
"vue_label_opportunity_business_opportunity":`Results of closed and customer-winning business opportunity contain records with one or more of the same fields as the current business opportunity.`,
"message.standardreport":`Standard Reports`,
"vue_label_account_outstanding_business":`Transfer unprocessed opportunities of others`,
"vue_label_commonobjects_detail_field":`Select filter field`,
"pagecreator_page_button_delete":`Delete`,
"label.leadconvers.permisson":`No {!operator} permission for the {!objectname}, please contact the admministrator!`,
"vue_label_systemSettings_customcode":`Custom Code`,
"button.partner.cancel":`Cancel`,
"label.whChatBindingState":`WeChat Binding Status`,
"label.appointmentconfirmail.wizard.subtitle6":`Phone`,
"label.recycle.dis.tip2":`Click Clean Recycle Bin or Clean All to empty the recycle bin of users or organization . This will take some time, when the emptying is conplete, you will be notified by email.`,
"batch.transfer.succ":`data of successful batch transfer`,
"label.chat.add.bookmark":`Bookmark`,
"label.mr.object.contact":`Contacts`,
"component_setup_label_parentobject":`Superior object`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Tuesday`,
"vue_label_report_list":`Select fields as the list headers`,
"label.checkbox.false":`No`,
"label.chatter.followers":`Be followed`,
"label.mr.loadReDate":`Load the Selected`,
"label.versiontype.Essential":`Essential`,
"front-project-module-v1-input-actual_working_hours":`Please enter the actual work hours`,
"label.visualpage.staticresource.p2":`2. Note that the supported static resource file types are png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Please choose the line items to clone`,
"component.assistant.label.30daysnoact":`30 days without any campaign`,
"label.tianyancha.businessverify.relation":`Has been mapping`,
"vue_label_email_havent_received_the_email_yet":`No mail received now`,
"label.isEnableVisualpage_new.title":`Enable Custom Page Access`,
"lable.SalesCommitmentKanBan.allContractAmount":`Total Contract Amount`,
"label.searchall":`Search All`,
"label.h5.similar.opportunity.select.all":`Select All`,
"label.area.tree.intro":`You can view the hierarchy of the territories here.`,
"label.select.up.three.fields":`Attention: A maximum of three fields can be selected.`,
"label.leadscore.doing":`Scoring has begun,please do not repeat scoring`,
"message.choosereportobj":`Please select report objects`,
"button_partner_start":`Start using`,
"label.quote.print":`Print Quote`,
"label.workflowoperateselect":`Step 3 Specify Workflow Actions`,
"label.greate":`> Greater Than`,
"lable.setting.qrcodeOrbarcode.rule":`Rules Settings of QR Code/Bar Code Generation`,
"label.partnerCloud.orderingPlatform.discounts":`Discount Schedule`,
"label.ems.save2draft":`Save as Draft`,
"vue_label_homepage_editname":`Edit Homepage Name`,
"label.ccdocument.save.error":`Save failed and the error code is`,
"label.samoa.standard.time":`Samoa Standard Time`,
"label.tianyancha.businessverify.msg7":`3. service scope`,
"vue_label_commonobjects_view_up_to_data":`The operation supports up to 200 data`,
"label.manage":`Manage`,
"label.tooltip":`report data source has been used, you can not edit the object relationship!`,
"vue_label_calendar_edit_calendar":`Edit Calendar`,
"label.attendance.keywords":`Please enter the keywords`,
"label.otherinfo":`Other Information`,
"System_TAB_SeeViewAmount":`View Totals`,
"label.recordtype.remark":`Description`,
"label.object.cannot.delete":`The object cannot be deleted because it is associated with the following relationships with other objects`,
"label.setup.mobile.bottombutton.saveprompt":`Please select 4 first-level pages`,
"label.department.lastpage":`It's the last page`,
"label.emailtemplate.mergefield.use":`Copy and paste merge field values into the email`,
"vue_label_salesfunnel_notice8":`Proportion of successful conversions from this stage to the next stage`,
"lable.opppdt.addpdt.table.product":`Products`,
"vue_label_helpcenter_report2.2":`Step 2: Select how you want to summarize the columns: Total, Average, Max, Min. <br>? Sort the data in the report in ascending or descending order<br> Click the ↑ or ↓ symbol next to any field in the preview report header. The data in the report will be sorted in ascending and descending order according to this field. <br>? <br>Show or hide detail rows<br> After grouping, you can show or hide detail rows by previewing the "Detail Row" switch at the top right of the report. The "Detail Row" is off by default. <br>? Turn on or off automatic update preview<br> The "Automatic update preview" at the top right of the preview report allows you to turn on or off automatic update preview. When turned on, the impact of each step you take on the data is automatically displayed in the preview report. ? To filter the report records, click the filters<br>The filters are divided into standard filters and field filters. <br>The standard filters include the Role filter, the Show Me filter, and the Date filter. <br> A. The "Role" filter divides data by current role and immediate subordinate roles, and you can switch between roles by clicking on the role name. <br> B. The "Show to Me" filter divides the data by "Show to Me" and "Show to All", with "Show to Me" shows data where the owner is the current user, and "Show to All" shows all data where the current user has viewing privileges. <br> C. The "Date Range" filter divides data by date over a range of time, such as "Create Date", "End Date". <br> The Field filter includes both a field filter and an advanced filter. <br>`,
"label.validate.function.funcFormat.YEAR":`YEAR(date)`,
"label.service.gantt.timeScale":`Choose time scale in Gantt`,
"label.data.dataexptemplate.desc1":`1. Data export files have two formats: CSV format and compressed format. Default to CSV format.`,
"template.chart.btjbkhqk":`Different levels of customers`,
"label.role.assign.select":`Remove a user from <b>Selected Users</b> list and assign the user to the selected role above.`,
"label.event.lookupmulti.assigner":`Assigned To`,
"label.appexchange.fieldupdata":`Workflow Field Updates`,
"label.lookup.page.notexists":`The page does not exsit.`,
"label.appupload.install.error.choice3":`Merge conflicting components into one component`,
"vue_label_commonobjects_detail_team":`Team Management`,
"label.approvereqiest":`Approval Request`,
"message.error.id.replace":`The calendar information corresponding to {0} was not found`,
"font-evaluate-module-v1-general":`The type of evaluation is Neutral`,
"vue_label_report_whatweek":`Day of Week`,
"vue_label_chatter_img_upload":`You can upload JPG, GIF or PNG files, the maximum file size is 2M`,
"label.checkbox":`Checkbox`,
"label.visualpage.component.n5":`5.Example. Call:`,
"chatter.updat":`Update`,
"label.ems.emailaccount":`Email Account`,
"label.autoRegister.changepwd.setpwd.tip1":`Set password to CloudCC account`,
"label.import.step1.matchway":`Match {labelNameshow} By`,
"label.manageAll.sel.one4":`Items I Rejected`,
"label.tabpage.lookatmorez":`SEE MORE`,
"label_tabpage_addadvancedoptions":`Add advanced options`,
"message.validation.accept":`Invalid format`,
"label.handlingnooperate":`Data is being processed, please do not do anything else, otherwise processing will fail.`,
"label.mobile.buttom.homepage":`Homepage`,
"lable.account.LastaDays":`Last 7 Days`,
"label.user.notexists":`The user is not exist.`,
"front-electronic-signature-isclose":`Inactive`,
"label.optional.groups":`Optional Quote Line Groups`,
"pagecreator.layout.label.layoutname":`Layout name`,
"label.error404":`The page you are trying to view is not here, please try again later.`,
"label.eventtrigger":`Event Triggers`,
"label.projectManagement.next.page":`Next page`,
"vue_label_SMS_chosen":`Chosen`,
"label.part.cannot.empty":`Field cannot be null`,
"label.call.center.jilu":`Call history`,
"front-kefu-moudle-v1-tenant-reinput":`Please enter lessee ID`,
"label.projectManagement.you.want.to.delete.this.data":`Are you sure you want to delete this record?`,
"label.projectManagement.nocharge":`Free`,
"System_TAB_SeeViewPageAmount":`View Pages`,
"label.password.query.error":`User query error.`,
"message.chooseatleastone":`Select a value at least.`,
"label.sortasc":`Ascend`,
"label.stdashbord.xsld.business.jinezhb":`Amount Proportion`,
"label.attendance.add":`Add Attendances`,
"vue_label_account_invoices":`Transfer all invoices of the customer owner`,
"label_delete _model":`Deleting a model will also delete the associated target data and is irreversible. Do you want to confirm the deletion?`,
"label.folder.sort。discreption":`The folders will be output in the selected order.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Acces Path: Merchant Platform  Account Center  API Safety  API SecretＫey`,
"label.equal":`=Equal`,
"lable.PowerProcess.Workorder":`Work Order`,
"front-docusign-setting-error-tips":`Please choose the custom field`,
"template.report.lead.status":`Leads Status`,
"label.create.remark":`Add Note`,
"font-evaluate-module-v1-one-points":`Negative Mark: 1 point`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Return a year, month, day and GMT time value(Date/Time Field)`,
"label.report.select.group.mode":`Select Grouping Mode`,
"label.h5.editmydetails":`Edit my details`,
"front-epwechat-module-v1-authorize":`Authorized Callback Domain`,
"label.tabpage.kanban":`Viewboard setup`,
"label.emailobject.emaildetail.button.addtocontact":`Add to Contacts`,
"lable.opppdt.selPbk.description":`Select a price book for this opportunity. You can only add a product from a single price book, and changing the selected price book will remove all existing products from the opportunity.`,
"component.event.button.save":`Save`,
"vue_label_homepage_homepage_assigned_success":`Homepage assigned successfully`,
"message.duplication.label.blankmatch":`Match Blank Fields`,
"label.icon.24":`First Aid Kit`,
"label.mobile.same":`The new phone numbner is same as the old phone number`,
"label.file.library.managemembers.addmember":`Add Members`,
"chatter.sp":`Show Posts`,
"label.user.notlogin.range":`Outside login time range.`,
"label.step3.total7":`Step 3 of 7`,
"label.user.fullname":`Full Name`,
"label.button.menubar":`Menu Bar`,
"#label.importfilestep3":`Step 3 Select and upload your file(s)#`,
"label.appointment.wizard.subtitle6":`Description`,
"message.lostnextapprover":`If you want to submit the approval request, please fill in the "Relevant User" field to define the next approver. That is the "Relevant User" field cannot be empty. Any other questions, you can contact admin.`,
"label.sso.saml.sp.logoutUrl":`Identity Provider Single Logout URL`,
"label.weixin.isgoon":`Your membership information already exists. If continue, WeChat ID who binds this mobile phone number before will not be able to use AidMax WeChat Official account. Are you sure you want to continue?`,
"vue_label_notice_homepage1":`Please enter the correct target value within 12 digits`,
"label.umeng.activity.event.will":`will`,
"label.insertURL":`Insert URL`,
"label.partnerCloud.orderingPlatform.administrator":`No available price book. Please contact the administrator.`,
"vue_label_systemSettings_emailtemplate":`Email Tamplate`,
"template.dashboard.market.analysis":`Campaign Analysis`,
"message.deleteapproval.tip":`You can only delete the approval process which no data or records associated with.`,
"pagecreator_page_message_delete":`Do you delete the current selected page?`,
"component.telerecord.label.message":`Comment`,
"front-email-payment-Invoice-preview-opening":`Please contact the system administrator to activate the online payment function and configure the corresponding payment method parameters.`,
"noless":`Greater than or equal to`,
"label_emailtocloudcc_button_back":`Cancel`,
"lable.Please.select.a.template":`Please choose an existing template.`,
"front-lightning-module-v1-details-page-chart-relevant":`· When the associated objects of the selected report containing the current object, you can futrther filter data of the report according to the current record; Set up whether allow users to manually refresh the cashe data.`,
"label.object.page.head":`Page Header`,
"label.notification.time1":`in a few seconds`,
"label.weixin.optionnine":`Choice 9`,
"label.approval.content.tolang":`The content you entered is too long, please re-enter.`,
"label.leadconvers":`Lead Conversion`,
"label.compact.layout.frame.tabseq":`Display tab page order:`,
"label.permission":`Permission Sets`,
"vue_label_notice_new_success":`Created successfully`,
"label.money":`Currency`,
"label.ccchat.person.invite.unsuppem":`The email address you entered does not support {0}`,
"message.profile.del":`This profile is a administrator profile and cannot be deleted!`,
"vue_label_report_savelocation":`Save Location`,
"label.knowledgebase.select.lighting.target":`Please choose Lightning target`,
"label.visualpage.labelname":`Page Label Name`,
"label.notification.ccchat2":`【点赞用户名】liked your post.`,
"label.htyj.wanchenglv":`Percentage`,
"label.weixin.report.generatedchart":`Chart Generated`,
"label.customer.tab.please.label":`Please the tab label`,
"label.template.lookup":`View Template`,
"label.attendance.setting.wucha":`Deviation within 200 meters`,
"vue_label_opportunity_product_addproduct":`Add Product`,
"label.data.setok.t.desc3":`, Operation.`,
"label.emailobject.template.public":`Public`,
"label.setsubmit":`Submission Setup`,
"chatter.feed.menutype.feed.companycom":`All Posts`,
"label.Generate.Document":`Generate document`,
"label.knowledge.setting.hint.six":`Organize articles by data classification.`,
"label.dashboard.show.total":`Show total`,
"attachment.select.warning.001":`The attachment is archived and Archive button is not available, please re-select an attachment.`,
"message.schedulejob.error.delete":`An error occurred while deleting the Job base.`,
"setup.layout.group.pagecomponent":`Page Components`,
"label_partner_new_step3_meno":`Not sure what to enter? do not worry, you can change it later any time.`,
"label.partnerCloud.orderingPlatform.mutex":`Exclusion`,
"label.subtotalrely":`Subtotal Bases`,
"label.file.library.selectFile2Lib":`Add Files`,
"label.lock.record":`There are( records locked`,
"label.multilang.addcustomreporttypestage2.description":`This data source will generate a report on {0}. By choosing an object that is related to it,
you can define which related records in other objects will be returned to the data source results.`,
"message.duplication.errorinscript.greaterthan10":`You can select up to 10 records to merge.`,
"label.encd":`Display Encrypted`,
"UG.Account.03":`Proactively check and merge the duplicated accounts`,
"label.salescloud.teamrole.main2":`Major`,
"label.email.to":`Receipient`,
"label.members.sign.notify":`Notify the supervisor`,
"template.report.individual.case.priority":`Case Priority`,
"vue_label_report_selectfolder":`Select Folder`,
"label_partner_all":`All partner cloud`,
"lable.custom.year":`Custom Years`,
"label.ispigeonhole":`Archive`,
"label.campaignmember.selectmember.steptotal":`Step 2 of 2`,
"label.userphoto.save":`Save`,
"label.knowledgebase.published.version.online":`Published versions are still online till you publish this draft.`,
"template.report.customer.level.statistics":`Account Level Statistics`,
"label.mobile.phone.day.plan":`Tomorrow`,
"label.icon.95":`Teaching`,
"label.recordphone":`Log a Call`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`Disabling advanced currency management will discontinue the use of all dated exchange rates for your organization. Conversions of currency fields on opportunities, opportunity products, and reports associated with these objects will no longer be mapped to a date range - all currency conversions will use the static exchange rate.`,
"label.service.gantt.is.candidate":`Candidate of`,
"label.ruleofchecktask":`Task Validation Rules`,
"label.whole.page.show":`Full Page Dispaly`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expression)`,
"label.ccdocument.template.set":`Template set function`,
"label.icon.103":`Schedule`,
"lable.no.products.to.assets":`No product can be transfered to asset.`,
"label.fristname":`First Name`,
"label.appointmentconfirmail.wizard.subtitle5":`Organizer`,
"label.partner.workspace.myspace":`My workspace`,
"label.tabpage.optionsz":`Options`,
"component_chatter_link_button_save":`Publish`,
"label.validate.function.funcFormat.NOW":`NOW()`,
"label.discountPlanEditor":`Discount Schedule Editor`,
"label.weixin.fmu.pm":`{0} PM`,
"front-gantt-module-milestone-sorting":`Milestone sorting`,
"label.partnerCloud.maximumNumber":`The maximum of partner sites:`,
"label.mobile.place.record.interval.setup":`Location Sharing Interval`,
"label.visiblelinenumber":`Visible Lines`,
"front-kefu-moudle-nopower-calluser":`No permission, please contact the administrator`,
"label.field":`Fields`,
"label.projectManagement.groupbydate":`Group by Date`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`scheduled`,
"label.operation.monitoring.history":`Job Monitor History`,
"label.data.dataexpalltype.all_desc1":`1. You can shoose to automatically generate and manually enter the password of the exported compresses file. The automatically generated password will send to the mailbox of the users when the data is exported successfully. The manually entered password will not send to the mailbox, so users need to remember the password they entered. If not entered, default to no password.`,
"front-web-module-v1-detail-comment-proposal":`Looking forward to your valuable suggestions`,
"label_partner_workspace_member_selectedpermission":`Selected permission set`,
"vue_label_helpcenter_view1":`In the view of lighting version, you can intuitively and flexibly view and manage the data that you have access to. Through the view, you can realize basic functions such as data classification view, data display in multiple ways, adding, modifying, and deleting data, and you can also conveniently view reports and charts for further data analysis.<br> 1. Manage view<br> In the drop-down menu in the upper left corner of the view, select the view you want to view, and select the default view through fixed settings. <br> Use the list view control menu to create, edit, delete, or sort views. At the same time, use the filter function on the upper right to quickly edit and create new views. <br> 2. View data through multiple views<br> You can view the data in different ways. In the upper right corner, you can switch the list, Kanban, and split screen to view the data. <br>In the list view, some types of fields can directly modify a single or multiple data. Double-click the cell to be edited, or click the edit button, you can directly edit the data in the pop-up window. To edit multiple pieces of data, just select multiple pieces of data first, and then select "Apply to selected data" in the editing pop-up window. <br> In the list view, you can directly edit the column to be displayed in the upper left corner, click the header at the table header to sort, or select the column to be locked through the drop-down floating window. <br> After setting the Kanban view, you can view the data in groups, and view the summary value of each group. In the Kanban view settings, you can edit the grouping basis, summary basis and summary method of the Kanban view, and you can also select up to four fields to display. You can quickly change the grouping of data by dragging and dropping. <br>`,
"component.task.label.priority":`Priority`,
"label.datamanage.field.error":`Query object field error.`,
"label.console.step3":`Step 3. Select the image source for the console`,
"label.ems.emailsyncsetup":`Email synchronization setting`,
"label_tabpage_placeenterz":`Please enter`,
"label.getontocolumn":`Jump to Column:`,
"label.file.down.e":`The current file type is not allowed to be downloaded`,
"vue_label_notificationcenter_unreadonly":`Unread Only`,
"label.login.access.change":`Change`,
"label.globaloperation.operationtype.send_e-mail":`Send Email`,
"label.dashboard.refresh.hint":`Click Refresh to load the latest data into the dashboard. It will take some time to run the data source, are you sure you want to refresh?`,
"front-kefu-moudle-open-free":`Enable (Trial)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Manage Your Subscription`,
"label.chatter.maturiyDate":`Expire date`,
"message.mobilechooseatmostthree":`The tab for Mobile App can select up to three fields.`,
"label.customfields.formula.tip":`A read-only field that derives its value from a formula expression you define. The formula field is updated when any of the source fields change.`,
"lable.PowerProcess.start.time":`Please select start time.`,
"label.mr.title.button.group2":`set(s) of duplicate records,a total of`,
"label.atlantic.standard.time":`Atlantic Standard Time`,
"label.account.LengthofTime":`Duration`,
"label.ccchat.message.search.desc2":`messages`,
"label.pigeonhole.desc":`Archive attachment is valid only for unarchived attachments.<br/>Once an attachment is archived, it will not be deleted.`,
"label.partnerCloud.orderingPlatform.sure":`Switch {alias} will empty the cart. Are you sure to confirm the operation?`,
"label.default.value.is.positive.integer":`The default value must be a positive integer`,
"label.partnerCloud.selectOne":`Select at least one menu`,
"label.dashboard.more.condition":`More Conditions`,
"component.event.label.enddate":`*End Time`,
"label.forecast.settings.type":`Forecast Type`,
"com.cloudcc.login.error.message.licensenotstart":`The license does not start`,
"lable.list.queue":`Queues`,
"label.mobile.app.isdisablum":`Disable selecting photos from mobile album upon check-in`,
"label.service.gantt.filter":`When filtering by skills, , only resources with the selected skill will be displayed on the Gantt chart`,
"label.potentialcustomeronline":`Web-to-Lead`,
"label.campaignmember.main.deletecontactdesc":`Mass remove all contacts from this campaign`,
"label.list.desc1":`Using Web to CloudCC, you can capture contact and profile information from users and automatically generate new leads in CloudCC.com`,
"label.generatepage.title.desc3":`The name must be unique, and the name must begain with a letter.It must contain only uppercase and lowercase letters,numbers,and underscore.It must not be longer than 30 characters.`,
"label.emailtocloudcc.step2total3":`Step 2 of 3`,
"label.movablemenu":`Activity Buttons`,
"label.partnerCloud.partnerAccount.topUp":`Top Up`,
"label.data.standobject":`Standard Objects`,
"label.frequency":`Frequency`,
"label.schedulejob.setup.schedule.end":`End`,
"label.chat.topic.following":`Following`,
"label.martrixreport.2018.step2":`Step 2 Summarize information by:`,
"label.event.moveup.11hour":`11 hours ahead`,
"label.forecast.customforecast.directorcommit":`Commit of Direct Subordinates`,
"vue_label_homepage_card_view":`Card View`,
"vue_labenl_applauncher_notice_closecertification":`Data will be lost after turning it off. Are you sure to do so?`,
"component_setup_button_weburl":`External url`,
"label_emailtocloudcc_button_addemailaddress":`Add Enterprise Mailbox`,
"vue_label_campaign_added_campaign_members":`Successfully added campaign members`,
"label_tabpage_rtemptyz":`Record type cannot be empty`,
"label.martrixreport.2018.step5":`Step 5 Select the chart type and the highlight item`,
"label.moverecord":`Transfer Record`,
"pagecreator_layout_label_layoutdesc":`Layout description`,
"label.knowledge.setting.data.nine":`Yes, I want to delete this category group and the categories under this group.`,
"label.icon.90":`People`,
"label.weixin.micro.research.name":`Micro Survey Name`,
"label.ccchat.micropost.allowedit":`Allow users to edit posts and comments`,
"vue_label_homepage_fixed_components":`Standard Component`,
"label.version.document":`Document Library`,
"label_assessment":`Appraisal (Opportunities - Amount)`,
"label.appupload.component.type.lookuplayout":`Search Layout`,
"label_chatter_loadmore":`Load more`,
"component_setup_tabs_label_memo":`Set tab tag name`,
"label.icon.167":`Compass`,
"vue_label_chatter_enter_content_sharing":`Please enter the sharing content and sharing group`,
"vue_label_notice_modify_success":`Successfully modified`,
"label.sharerules":`Sharing Rules`,
"label.field.api.exists":`This field API name already exist.`,
"label.icon.83":`Paint`,
"label.file":`File`,
"vue_label_report_foldernameisrequired":`Folder name is required`,
"label.emailobject.wizard.btn2":`Connected, go to send email`,
"label.data.downpage.i_title.num3":`3. Before importing, make sure to import all related records. For example: if there is to lookup relationship between the objects you are currently importing and the contacts, you should import the contacts first and then import your data.`,
"label.email.original.content":`Reference Content`,
"vue_label_campaign_add_to_campaign":`Add to Campaign`,
"label.dashboard.new":`New Dashboard`,
"label.console.detail":`Console Detail`,
"label.view.desc":`The date field can be equal to"yesterday", "today", "tomorrow", "last month", "this month", "next month", "last week", "this week", "next week" or "YYYY-MM-DD、MM/DD/YYYY".`,
"label.emailobject.template.insert.continue":`Continue`,
"label.notification.appointment.overlapEvent":`The selected time is being scheduled, please select another time.`,
"label.console.step6.top":`Fixed to the top and the lists are always visible.`,
"label.data.file.the_trigger":`Execute Trigger`,
"message.report.error.operation":`Action failed, please reset the report`,
"vue_label_helpcenter_detail3":`<br>    Liking and unliking<br>   You can like a comment on a micro-post or just a micro-post. After liking, you can view the number of likes for the post, and you can also unlike it. <br>? Edit and delete posts<br>    The publisher of a post can re-edit or delete the post. <br>    Step 1: Click the button to the right of the post and select Edit or Delete in the drop-down box<br>   Step 2: Open the Edit/OK to delete pop-up<br>    Step 3: Click Save/OK to complete the operation<br>5. Approval History<br>? Submit for Approval<br>    The "Submit for Approval" button appears when a new record is created, an approval request is called back, or an approval is ultimately denied. <br>    Step 1: Click on "Submit for Approval". The system determines whether the record and the submitter meet the project and initial submitter conditions set by the approval process, and if all of these conditions are met, the submission is successful. <br>    If the next approval step in the approval process configuration requires manual selection of the approver, then step 2 is executed after "Submit for Approval".<br>   Step 2: Select the next approver and complete the submit operation. <br>? Approval History<br>    A. Before submitting:<br>    Click on "Approval Process Preview", the system will determine if the record and the submitting operator meet the items set in the approval process and then if all of these conditions are met, the approval process is displayed. <br>    B. After submission:<br>   In the approval history you can not only view the approval history steps and the current approval status of the record, but also preview the next approval process. <br>? Pull back approval requests<br>    If this approval process is set up to pull back approval requests, they can be withdrawn at any time after you submit them. <br>    Step 1: Click "Pull Back Approval Request" on the record details page <br>   Step 2: Open the Pull Back Approval Request page and click "Call back approval request" to complete the operation`,
"Opportunity_Detailed_Phase_Label_004":`day(s)`,
"PageLayout_Search_MultiSearch_001":`Select up to 3 fields.`,
"vue_label_systemSettings_set_business":`Set up the layout and fields of objects to fit your business.`,
"label.compact.layout.frame.select":`Please select a page layout frame`,
"label.tabpage.rolez":`Role`,
"label.weixin.appr.currentauditor":`Assigned To`,
"label.knowledgebase.verification.status":`Verification Status`,
"UG_Case_05":`Create a case`,
"label.service.marking.completed":`Mark as Completed`,
"label.notification.ccchat1":`【发出@的用户名】mentioned you.`,
"label.knowledgebase.no.action.available":`No available action`,
"label.tabpage.newlybuildz":`New`,
"label.appupload.install.error.choice2":`Rename the local components that conflict with the package`,
"label_tabpage_as":`As`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Start Date of Current Stage`,
"vue_label_homepage_singlepage":`Add up to 10 components to a single page`,
"font-evaluate-module-v1-fair-and-bad":`When the type of evaluation is Neutral and Negative`,
"label.partnerCloud.orderingPlatform.orderInformation":`Order Confirmation`,
"label.custom.lead.conversion.notice":`Convert Lead Reminder`,
"label.re.upload":`Re-upload`,
"label.knowledgebase.top.window":`Top Window`,
"label.h5.allmarkedasread":`All marked as read`,
"vue_label_SMS_open_record_from_start_activation":`Open the record from the list to activate.`,
"label.customer.tab.step2":`Step 2 Add to Profiles`,
"label.campaign.channel.input.owner.select2":`Solicitation Person of This Marketing Channel`,
"component.task.button.save":`Save`,
"front-kefu-moudle-v1-phone-type":`Phone Type`,
"label.wedge-shapearrows":`Wedge Arrow`,
"vue_label_homepage_todaysevent":`Today's Events`,
"label.data.exp.way.sel":`Select the export mode`,
"label.setting.intergrationlist.status1":`This integration is not currently installed.`,
"button_partner_workspace_disable":`Cancel activation`,
"label.customfields.reference":`May be referenced by other fields such as formulas, picklists, lookup fields, and so on.`,
"label.publicgroups.new":`New Pubilc Group`,
"label.data.setok.e_desc3":`， download your exported data.`,
"vue_label_commonobjects_view_chart_countmode":`Count Mode`,
"label.service.appointmentList.earliest.allowedStart":`Earliest Start Date`,
"label.data.choses.e.desc":`According to your needs, you can export all data or export data from a object.`,
"label.multilang.common.fieldlist.fieldremark":`Apply to the fields showing on the page of {0}.`,
"label.umeng.activity.event":`event`,
"label.project.hit.ten":`Issue Update Reminder`,
"label.c_d_least":`Each "C" record must have at least one related "D" record.`,
"label.emailobject.wizard.btn1":`Connect Personal Mailbox`,
"lable.product.pricebooks.info":`Price Book Details`,
"component_telerecord_label_message":`Comment`,
"lable.total.of.estimates":`0 estimates in total`,
"label.stdashbord.xsld.business.oppcounts":`Quantity of Opportinities`,
"vue_label_commonobject_duplicatewith":`Duplicate {1} in {0}`,
"label.setpicandreport":`Chart Settings`,
"label.category.2":`General`,
"label.emailtocloudcc.reauthorization":`Reauthorization`,
"label.chatter.vote":`Poll`,
"label_emailtocloudcc_edit":`Edit`,
"label.pleaseinput":`Input`,
"vue_label_homepage_user_particular_application":`The homepage when the user uses a particular application, assignments will override the standard homepage`,
"label.allianceID":`Aliance ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":`Profile homepage is not configured for this profile. It is not available for Mobile App`,
"label.appointmentpage.wizard.notif2":`Name is required!`,
"label_emailsync_status_email":`Action Performed Email`,
"label.icon.179":`People`,
"UG_Contract_03":`Create contract`,
"label.cy.new":`New Currency`,
"label.version.setup.controllist":`Control List Of Setup`,
"label.vlidaterule":`Validation Rules`,
"label.customer.tab.name":`Tab Name`,
"label.recentview.seloption1":`Recently Viewed`,
"vue_label_report_notice_nameisrequired":`Report name is required`,
"label.createapproveprocessstep":`<li>1.Read the help topics</li><li>2.Create email templates</li><li>3.Create SMS templates</li><li>4.Create an approval process using either the Jump Start or Standard Wizard</li><li>5.Add "Approval History" Related List to all page layouts</li><li>6.Activate the process to deploy to your users</li>`,
"label.gotocalendar":`Go To Calendar`,
"label.import.page1.pleaseselectobj":`Please select object first`,
"label_tabpage_messagez":`Please enter comment`,
"vue_label_homepage_profilepage":`Profile Homepage`,
"label.tabpage.choose":`Select`,
"label.campaignmember.setup.lead.field":`Fields of leads`,
"label.setalipay.null":`Required information for configuring Alipay are empty.`,
"label.custom.Current.and.NextCQ":`Current and Next CQ`,
"label.knowledgebase.needto.publish.articles":`Resotre archived article will create a draft version. Do you want to publish the article?`,
"pagecreator.layout.message.save.success":`Layout saved successfully`,
"homepage.componet.approval.label":`Items to Approve`,
"label.last_submission":`Last Submitted Time`,
"lable.outlook.detail.prefo":`Exchange always wins`,
"label.projectManagement.new.subtask":`New Subtask`,
"label.service.appointmentList.checkThe":`Checked`,
"message.error.searchlayoutselectdefields":`Cannot be deleted and must be the first field in the search layout.`,
"label.ems.normal":`Normal`,
"vue_label_notice_pleaseselectobject":`Please select an object`,
"component.sendmail.button.send":`Send`,
"label.relevant.records":`Related Records`,
"label.weixin.login.CloudCC":`Log In`,
"label.tag.addtags.private":`Private`,
"label.appointment.disable.remark":`Sorry, the function is currently deactivated. If you want to reschedule or cancel the meeting, please contact the person in charge at {邮箱地址}`,
"label.campaignmember.main.addMember1":`Add Members`,
"message.error.objectnofound":`Object undefined`,
"label.employeenum":`Employee Number`,
"label.search.applyfilter":`Apply Filter`,
"label.version.history.track.nonsupport":`Only the infinite version supports the field tracking history function.`,
"label.ccpeak.direction.for.use.time":`Instruction For Scheduled Classes [Version 2.0]`,
"label.ems.settings":`Settings`,
"label_tabpage_arecordtypez":`Available record type`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Instruction For Custom Components [ version 2.0]`,
"label.appupload.appname":`Package Name`,
"label.cpq.order.status.no.active":`Only orders with active status can generate contracts`,
"label.dashboard.maxlength":`You can enter up to 255 characters`,
"label.customize.memory.function.sorting.title2":`Memory of Header Sorting`,
"label.report.chose.obj":`please select object relationship and report data source`,
"label.partner.step3":`Step 3 Basic information`,
"message.report.type.error.fail":`Invalid report data source.`,
"pagecreator.page.message.publish.fail":`Page publishing failed`,
"label.minimun":`Minimum`,
"label.state":`Status`,
"label.customcomponent.referencetype":`Reference Type`,
"label.nameandemailtemplate":`Enter a name for your process in the box below and then select an email template to notify the approver (optional).`,
"label.customobjects.track.introduce":`This page allows you to select the fields you want to track on the`,
"label.campaign.matchway.label":`Matching Method`,
"label.redistribution":`Reassign`,
"label.groupmanage":`Organization Management`,
"label.icon.157":`Camera`,
"label.quickbooks.viewlist.total":`TOTAL`,
"label.file.copy.file.fail":`Copy failed,please manually copy`,
"label.outline.selectfield":`Selected fields in summary:`,
"label.datetime.maxsize":`The cycle of a query cannot be longer than three months.`,
"label.dashboard.CustomDashboardMyHomePage":`Customize My Homepage Dashboards`,
"label.data.customobject":`Custom Objects`,
"vue_label_SMS_noselected":`No record selected`,
"label_tabpage_value":`Value`,
"label.quote.qianming":`Signature`,
"label.view.source":`View Source Code`,
"label_popup_infoz":`Prompt`,
"label.emailtocloudcc.redmessage8":`Parameter error, please contact administrator.`,
"label.tianyancha.Search.business":`Search business registration information`,
"vue_label_systemSettings_server":`Service`,
"vue_label_homepage_dashboard_components":`Dashboard Component`,
"label.search.listview":`List View`,
"label.service.gantt.distribution.success":`Assigned successfully`,
"label.icon.4":`Wallet`,
"label.partnerCloud.orderingPlatform.calculate":`Calculate Price`,
"label.forecast.edittotal.ycyx":`Forecast Priorty`,
"vue_label_commonobjects_detail_to_precise_search":`Accurate search`,
"label.order.number":`Order`,
"setup.mainpage.label.welcome7":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Object → Object Name → Custom Field.`,
"label.weixin.user.binding":`User binding`,
"label.custom.canvas.size":`Canvas Size`,
"label.projectManagement.recent.projects":`Recent Project`,
"vue_label_helpcenter_lead":`Track and manage your leads through Cloud CC. Use the configured rules to score and assign leads, and convert them into customers, contacts, and corresponding business opportunities at the right time.<br>Score<br> In the upper right corner of the view, use the batch scoring button to score leads in the view.<br>distribution<br> When creating or editing a lead, select Assign at the bottom of the page to assign the lead to the corresponding personnel for processing according to the existing rules.<br>Conversion<br> At the right time, you can convert leads into customers and contacts by clicking the conversion button in the upper right corner of the details page. At the same time, you can create corresponding business opportunities and tasks to facilitate the continued follow-up of transaction opportunities.`,
"label.enabledprocess":`Active Approval Processes`,
"label.emailobject.noemail":`No mail yet, go and send one!`,
"label.validate.remark3":`Determine whether a field is required based on the value of another field`,
"vue_label_salesadvance_retention":`Retention`,
"label.product.managep":`Manage Price Books`,
"font-evaluate-module-v1-not-report":`Do not reopen`,
"label.emailmerge.mergepage.step1":`1.Choose the records to merge:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC provides the integration with WeCom, combining the powerful features of WeCom with the light H5 version of CloudCC system,<br /> helping you to conveniently manage customer relationships, operate private domain traffic, and improve enterprise revenue.`,
"label.partner.template.detailimage":`Picture`,
"label.recycle.clearall":`Empty Recycle Bin of Your Organization`,
"chatter.error.nottype":`Error: Invalid file type. Please upload JPG, GIF or PNG files.`,
"pagecreator.button.cancel":`Cancel`,
"front-market-form-quired-ziduan":`Required Fields on the Registration Page`,
"vue_label_report_columnname":`Column name`,
"message.notdelete.type":`You cannot delete this record type, because the following profiles use this record type as the default value.`,
"label.ccpeak.folder.all.time":`All Scheduled Class Folders`,
"label.quickbooks.searchlist.total3":`There are {0} unlinked estimates for a total value of {1}`,
"label.forecast.detailforecast.quantity":`Quantity Forecast`,
"label.knowledge.language.british":`British`,
"label.vlidaterule.example.messagelocation":`This error message can either appear at the top of the page or below a specific field on the page`,
"front-kefu-moudle-chf-success":`Split successfully`,
"vue_label_jihui_yi":`Opportunity 1`,
"label.import.step1.null":`No options available`,
"label.console.step5.tab.subtab":`As a subtab of`,
"batch.edit.permission":`No permissions to edit`,
"label.weixin.fmu.before.min":`{0} mins ahead of schedule`,
"chatter.up.file":`File upload takes some time, depending on the size of the uploaded file, please wait.`,
"setup.layout.group.field":`Fields`,
"label.chat.unlike":`Liked`,
"vue_label_dashboard_updatefrequency":`Update Frequency`,
"label.trigger.folder.new":`Trigger Pages: New Folder`,
"label.process.des.app":`Click the right link to view details of the current record.`,
"vue_label_pool_assignselect":`Choose member to assign`,
"label.lookup.user":`Search Colleagues`,
"label.mobilescreentablayoutedit.remark2":`Select the filter fields displayed on tab home page in Mobile App.`,
"label.data.exp.objtemp":`You will create the template to export data of this object as follows cretira`,
"label.weixin.moreselect.error":`Only 10 records you can select`,
"label.icon.25":`Bandage`,
"lable.sample.text":`Sample Text`,
"label.most.setup.obj":`Up to 10 objects can be set.`,
"label.weixin.coming":`Coming`,
"label.editdescription":`Note Edit`,
"label.multipleactivity.multiple":`Multi Users`,
"label.sso.saml.idp.entityid":`Entity ID`,
"label.SMS.pho.filed":`Phone Field`,
"message.serviceabsence.violation":`Assignment period violation: it's in conflict with absence record.`,
"label.forecast.settings.type.clist":`Use Product Families`,
"label.state.noend":`Incomplete`,
"label.sourcetemp":`Source`,
"vue_label_chatter_name_link":`Please fill in the name and link`,
"label.emailobject.attach":`Attach`,
"label.everyother":`Every Other`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`You haven't activated a chat account yet. Do you want to activate now?`,
"pagecreator_layout_button_delete":`Delete layout`,
"label.transfer.temporarily":`Call`,
"label.service.dispatchingUnits.search.services":`Search Service Appointment`,
"customer.message.fail.chat":`Failed to get message records, please contact administrator for help`,
"label.apiname.toolong":`API name is too long.`,
"label.empty.filter":`Clear Filters`,
"label_tabpage_personalCenterz":`Personal center`,
"label.minutes":`Minute`,
"label.multipleactivity.atasks":`Task(s)`,
"label_tabpage_deleteview":`Delete View`,
"pagecreator_layout_message_save_success":`Layout saved successfully`,
"label.reportlineorder":`Report Columns Order`,
"label.total.forecast.have.priority":`any prediction is prior, but the ones which accept other subpreditions is prior`,
"label.custom.quarter.subtitle":`Custom Quarter`,
"label.icon.79":`Print`,
"label.hiddenoperate":`Hide Actions`,
"label.project.hit.six":`Task Assignment Notice`,
"label.visualpageaction.errordesc":`You do not have the permission to excute the operation you requested. Please contact the record owner or your administrator.`,
"label.chat.unmute":`Cancel "do not distrub"`,
"label.zhaiyao":`Abstract`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`API Version`,
"UG.quota.06":`Create a quotation`,
"label.icon.152":`Robot`,
"label.partnerCloud.partnerAccount.account":`Username`,
"label.file.sharewith":`Sharer`,
"label.data.dataexptemplate.desc2":`2. The compression format is divided into two types: one is to automatically generate the compressed file password, the other is to manually enter the compressed file password.`,
"vue_label_dashboard_newfoldersuccessfully":`Create new folder successfully`,
"label.campaignmember.main.importmember":`Batch Mass import campaign members`,
"label.htyj.completed":`Completed`,
"label.reportTypeLabel":`Report Type Label`,
"label.customer.tab.label":`Tab Label`,
"label.dashboard.component":`Components`,
"label.safetystatement.dialog":`Security Statement (New window)`,
"label.forecast.settings.data":`Forecast Date`,
"label.knowledgebase.modifiedby":`Modified By`,
"label.batchadd.remark":`Add Multiple Records`,
"button.partner.delete":`Delete`,
"Pagelayout_Setup_005":`Name has to be put on the first place.`,
"label.forecast.edit.wcpxl":`No Product Families`,
"lable.PowerProcess.seq.input":`Please input an order.`,
"pagecreator.layout.message.delete.fail":`Layout deletion failed`,
"label.emailobject.edit":`Edit`,
"label.weixin.million":`Ten thousand yuan`,
"setup.mainpage.button.manageobject":`Objects Management`,
"label.weixin.participants.perfect.information":`Participants are required to improve information`,
"vue_label_campaign_campaign_members":`Add Campaign Members`,
"label.ccchat.person.invite.emplaceholder":`Enter email addresses, and separate by semicolons`,
"label.mobile.phone.new":`New`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Miniprogram Evaluation Setup`,
"UG.opportunity.005":`Multiple sales process`,
"vue_label_report_polymerization":`Aggregate`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`The {0} line condition is incorrect, the field type does not match!`,
"label.knowledgebase.delete.draft":`Delete Draft?`,
"label.mr.descreption.condition3":`Rule-exact match: check this item and find duplicate records by the same characters of field. If cheked, find duplicates by the first few characters will invaidate.`,
"Lead.Auto.Scoring.Setting":`Lead Scoring Setting`,
"label.marketing.channel.default":`Marketing Channel (Enabled by default)`,
"front-project-module-v1-select-projecttemplate":`Select Project Template`,
"front-email-payment-select-area":`Please enter the district`,
"lable.PowerProcess.message":`Information of Entitlement Process`,
"label.weixin.free.get.captcha":`Get Verification Code Free`,
"label.projectManagement.please.select.task.or.question":`Please select Task/Issue`,
"label.pacific.daylight.time":`Pacific Daylight Time`,
"label.sendsms.batch.step1.introduce":`Select one of the following views (which contains the recipients of this SMS)`,
"label.same.analyze.account.name":`Account Name`,
"Homepage.Contract.FieldMissed.DoesntSupport":`There are no "qdrq" and "htje" fields on the contract object, so the data can not be showed.`,
"label.partnerCloud.orderingPlatform.noProduct":`No configuration of product option under this product required.`,
"label.totalsummary":`Roll-Up Summary`,
"label.partner.workspace.tab":`Menu`,
"label.entitlement.process.name.unique":`This name already exist. Please enter again.`,
"report.label.norole":`You have no permission to do this, please contact your administrator.`,
"label.password.old.error":`Old Password incorrect, please re-enter.`,
"lable.account.quarter.stadate":`Fiscal Quarter Start Day`,
"label.salescloud.contactrole.choose.correct":`Duplicate contacts selected, please correct.`,
"label.schedulejob.setup.schedule.day":`Day`,
"label.communalusergroup":`Public Groups`,
"label.Display.Fields":`Fields on the Service Apoointment List`,
"label.marketsea":`Pool`,
"label_partner_setup_address":`Partner Cloud Address:`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`Data Export and Template Create`,
"label.pc.ui.2018":`Vertical`,
"label.version.free":`Free Edition`,
"label.dataimport.contact.length":`Error: The length of the contact name is too long`,
"label.cy.vlidate":`The action of currency enabled is irreversideare. Are you sure you want to enable Currency Management?`,
"label.recycle.all":`All Recycle Bins`,
"label.message.changeaccount.isnot":`Contact has enabled partneruser,cannot change account`,
"label.searchlayout.exactsearch":` Tip: Check the checkbox behind the search field to perform an exact search for that field`,
"label.file.size.limit":`Note: The maximum file size is 10M.`,
"label.mobileapp.modelsetting1":`Mobile Standard Module Settings`,
"template.report.overall.sales.opportunities":`Overall Sales Period (By Opportunity Type)`,
"label.password.update.success":`Password changed successfully.`,
"label.import.page3.gobackhome":`Back Homepage`,
"label.phone":`Phone`,
"label.detail.vlidaterule":`View Validation Rules`,
"label.weixin.input.usernames":`Please enter your username`,
"label.icon.85":`Transformer`,
"vue_label_systemSettings_partner":`Partner`,
"label.processsetting.new.process":`New Process`,
"Lead_Scoring_Setting_Rule_Setup_01":`Lead Scoring Rule List`,
"setup.layout.component.area":`Area`,
"label.createnewpwdinformuser":`Generate a new password and notify the user immediately`,
"label.pwinfo":`Password Details`,
"label.imgfield.type.url":`Reference Image`,
"label.attendance.sxccheckincy":`Campaign Members Check-In`,
"lable.PowerProcess.condition.input":`Please select condition.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Topup fialed`,
"label.document.size.too.long":`Document size exceeded`,
"label.link":`Access Link`,
"label.partnerproduct.sort.repeat":`The name of product family is taken.`,
"label.data.setok.e_desc2":`Export Data List Page`,
"front-project-module-v1-plase-input-project-name":`Please enter project name`,
"label.export":`Export`,
"label.icon.45":`Boiler`,
"label.autoRegister.changepwd.title":`Set your login password`,
"label_clear_adjust":`Clear Adjustment`,
"front-kefu-moudle-return-visit":`Review`,
"label.ems.compose":`Compose`,
"Pagelayout_Setup_002":`You have selected 3 related lists, and adding more related list will affect the page layout.`,
"label.service.gantt.skill.screening":`Use Skill Filter`,
"label.partnerCloud.basicSetting.enable":`The Partner Cloud will be deactivated. Login and edit actions in your organization will be turned off automatically by the system.`,
"label.workbanch.setup.description":`You can setup the follwing views to show in My Workbanch.`,
"label.category.1":`All`,
"label.foldername":`Folder Name`,
"label.forecast.settings.shuliang":`Quantity`,
"label.emailmerge.newtemplate.word":`Please upload Microsoft Word documents.`,
"message.error.type":`type cannot be empty, you need to pass public public type or personnel private!`,
"label.manualallocation":`Manually Assign`,
"label.addattachment.step2":`Step 3 Click Upload File to upload the file`,
"label.company":`Company`,
"label_emailsync_status_export":`Export as Excel_csv format file`,
"label.eventreminder":`Event Reminder`,
"label.emailtemplate.lookup":`View Email Templates`,
"label.customsetting.touse.getCustomSetting":`Query the "hierarchy" type of customized settings, return the corresponding apiName and permistions (ID is profile ID or User ID ), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Recource Usage`,
"label.appointment.wizard.subtitle4":`Buffer and Time Settings`,
"label.donot.close.your.browser":`During this process, please do not click another link or close your web browser.`,
"label.multilang.customforcast.target":`Target of {0}：`,
"setup_layout_label_newarea":`New Area`,
"component.timeline.button.more":`More steps`,
"label.appointmentdetail.wizard.title3":`Duration`,
"label.help.new.features.pc":`Pc-side new features operation guide`,
"label.mr.record":`Record`,
"label.trigger.wgd":`Unfiled Triggers`,
"label.icon.72":`Toolbox`,
"setup.layout.label.detailpage":`Detail Page`,
"frame.personinfo.label.usethisimage":`We will use variations of this thumbnail image around the application.`,
"label.multilingual.confirm.open":`Are you sure to enable? Multilanguage can be used after enabling.`,
"label.recordcreater":`Created By`,
"label.afterfinish":`When finished, click Save`,
"label.companyinformation":`Company Information`,
"step1":`Step 1`,
"label.sales.page.dashboard.add":`Add to Homepage Dashboards`,
"label.processsetting.process.enabled.failed":`Failed to delete the path!`,
"label.document.history.date":`Date`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`All users can access this folder`,
"april":`April`,
"label_emailsync_form_disconnect":`Cancel Conncet`,
"label.appointment.wizard.subtitle4-2-6":`2 Days`,
"vue_label_notice_follow_success":`Followed`,
"label.startuploadfile.success":`When you click the "Start Upload", if the progress bar reaches 100%, the file is uploaded successfully and disappears in the upper area.`,
"message.accesstoken.acquisition.failed":`Failed to get access token!`,
"label.quickbooks.fieldlabel.fistname":`First name`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`You have no permission to view this record, please click to return to previous step.`,
"label.batchaddattachments":`Batch Add Attachments`,
"label.ems.next":`Next`,
"label.quote.zhekou":`Discount`,
"lable.product.notdel":`Because it is still in the manual with other price book record.The related records are as follows.`,
"label.ems.action":`Action`,
"message.error.chart.type":`Chart types cannot be empty.`,
"label.conditiontag.lookup.value":`Value`,
"label.chatter.allactivity":`All activities`,
"label.summaryreport":`Summary Reports`,
"label.textmessage.vonage.action":`Action`,
"label.ccpeak.must.result":`Must use as followed by aliases to fetch from the result`,
"label.data.newtemplate.savetemp.desc":`Please enter the template name and description carefully to facilitate your use.`,
"label.projectManagement.search.for.users":`Search for user`,
"component.milestones.label.title":`Milestones`,
"vue_label_applauncher_description_accountpool":`Use the Account Pool to conveniently manage the follow-up status within the organization and motivate personnel to complete the transaction.`,
"label.import.index.startimport":`Start Import`,
"page.field.masterinput2":`Master-Detail Input`,
"label.mobile.change.owner.permission":`The new owner must have "Read" permissions on this type of record.`,
"label_partner_common_enable":`Enable Partner Cloud`,
"label.log.browser":`Browser`,
"label.app.step4":`Step 4 Choose the Tabs`,
"lable.quote.syncing.opportunity":`Opportunities`,
"label.forecast.customforecast.foredis.jqz":`Exact Value`,
"label.forecast.forecastroleuserpage.title":`Forecasts Manager Assignment`,
"label.starting.quarter":`Starting Quarter`,
"label-combination-record":`Record {index}`,
"label.here":`HERE`,
"label.weixin.underfind.error":`Unknown error`,
"label.cloudccclass.list.tip.time":`Allow developers to develop scheduled classes on the CloudCC.com platform, that can be used for scheduled programs.`,
"label.data.setok.t_desc1":`If you need to use this template derived data,please click`,
"label.service.gantt.break.rules":`Rules Breaking`,
"label.weixin.no.pending.ywjh.qin":`No opportunities for the next 30 days`,
"label.view.atleastone":`List cannot be empty.`,
"label.attendance.sxccheckin":`Campaign Attendance`,
"label.custom.split":`Split`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Are you sure you want to delete this template?`,
"label_chatter_theme":`Topics`,
"label.partner.new.step1":`Step 1 Choose template you like`,
"vue_label_commonobjects_view_settings":`Kanban View Settings`,
"UG_Contract_02":`The contract is a written agreement between the parties. Many companies use contracts to define terms of doing business with other companies. Use CloudCC to establish and document your existing contracts with your accounts and business opportunities. Track the contract through the approval process. Use workflow reminders to remind you of the contract rollover.`,
"label.setup.mobilesetup.isenableh5newandedit":`Enable new and edit of H5 in your mobile app.`,
"label.attendance.edit":`Attendance Edit`,
"label.service.miniProgram.fillImageLink":`Please fill in the link of carousel.`,
"label.b.c.without":`B records may or may not have related "C" records.`,
"label.sso.key":`Authorization Code`,
"label.star_click":`Click to clear`,
"vue_label_SMS_name_or_phone_number_lookup":`record name search`,
"label.case.copre.text":`You can also download a web portal QR code dedicated to your company and place it on your website or device, then customers can scan the QR code to use the web version of the customer portal.`,
"label.salescloud.forbidden.confirm":`Are you sure you want to deactivate opportunity team?`,
"vue_label_chat_conformactivation":`Confirm activation`,
"label.emailtocloudcc.redmessage9":`Database error, please contact administrator.`,
"label.sahreto":`Share with`,
"label.recordtype.sort":`Record Types are displayed in the order in which they are saved.`,
"label.allreport":`All Reports`,
"front-gantt-module-drag-and-drop-subtask":`Drag (put it into a task) to make it as a subtask!`,
"label.permission.objlist.nopermission":`No Access`,
"label_file_num":`Quantity`,
"chatter.mostword":`Your comment is more than 500 words, please delete and re-enter.`,
"label.h5.chatter.comment":`Comment on the body`,
"vue_label_calendar_notice_havecreated":`You have created a calendar`,
"label.tabpage.loadz":`Page loading, please wait…`,
"chatter.w.p":`Work Phone`,
"label.chat.topic.name.desc":`You can only change the case and spacing of topic names.`,
"label_partner_template_name":`Template name`,
"label.mobile.phone.required.examines.people":`The Revised By is required.`,
"message.error.view.notexists":`View does not exist.</br> Or the view may have been modified by someone else, click <a href='javascript:history.back();'> here </a>to back.`,
"label.custom_time":`Custom Time`,
"label_partner_workspace_member_all":`All`,
"lable.custom.year.name":`Custom Year Name`,
"label.account.previous.M":`Last Month`,
"vue_label_commonobjects_detail_locking":`Lock`,
"label.brief.lead":`Leads`,
"label.linkedin.setting.appsecret":`Password of Secret Key`,
"label.query.detail.closepartner":`Deactivate Partners`,
"label.isEnableVisualpage_new.rightlist":`Active Custom Pages`,
"front-epwechat-module-v1-unbound-item3":` data of authorized information`,
"label.exchange.sync.setting.info":`After setting up a service account with impersonation permissions for the users in Microsoft©Exchange, enter the service account credentials to allow CloudCC communicate with the Exchange server. If the service account credentials have been saved, but the user is still unable to sync the records, please make sure that you have set up the Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`CloudCC group email send failed email address`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`The upper bound for editing each level of discount shall be larger than the lower bound.`,
"label.visualpage.list.vpname":`Custom Page Name`,
"label.mask.length.error.message":`Encrypted text field can not be more than 255 characters`,
"label.h5.approval.actorname":`Submitted By`,
"label.knowledgebase.view.translation":`View Translation`,
"label.ems.edit":`Edit`,
"vue_label_commonobjects_view_reset_width":`Reset Column Width`,
"label.version.feature.controllist":`Function Limit List`,
"label.setuppagelayout":`Page Layouts`,
"vue_label_commonobjects_view_new_view":`New View`,
"label_tabpage_queuez":`Queue`,
"label.direct.dashboard.wait.me.approval":`Items to Approve`,
"message.report.error.noRelatedField":`No related fields with the report. They may have been deleted, please contact your administrator.`,
"label.ccchat.person.invite.notme":`You cannot send invitations to your own email address.`,
"label.weixin.jieduan.finish":`Mark Current Stage as Completed`,
"vue_label_commonobjects_detail_?enter_subject":`Please enter subject`,
"label_starting_month":`Starting month`,
"label.address_linetwo":`Address Line 2`,
"message.error.select.contiguous.item":`Selection of relevant items with`,
"vue_label_pricebook_enterbookname":`Please enter the name of the price list`,
"label.cycleworkflowoperate":`Periodic Workflow Actions`,
"label.ems.withoneday":`Today`,
"component.todaytask.label.notask":`There is no expiry task today, take a coffee.`,
"label.tianyancha.id":`Company id`,
"label.user.illegal.login":`Illegal login`,
"label.withgathercondition":`By Summarized Criteria`,
"label.foldervisitlimit":`Access Permissions`,
"label.ccchat.search.conversation":`Search this conversation`,
"lable.annual.project.report":`Number of Projects for Accounts This Year`,
"template.chart.qzkhzhfx":`Lead Conversion Analysis`,
"label.my":`My`,
"label.sendsms.batch.chosetemplate":`Batch SMS: Select a template or edit the content`,
"label.callcenter.enterprise.number":`Enterprise No.`,
"label_last_modified_by_time":`Last modifier & time`,
"message.fieldtrack.operaterecord":`Changed <b>operatefield</b> from <b>operateold</b> to <b>operatenew</b>`,
"label.mobile.more.openin":`Open In...`,
"label.multilingual.tip2":`You can activate or deactivate multi-language.`,
"label.datamanage.lead.novalue":`Note: The lead name field is null,the contact records will not be imported.`,
"label.custom.revoke":`Undo`,
"label_chatter_leaveword":`Comment`,
"vue_label_ccchat_group_deletedgroup":`The group has been deleted`,
"label.tabpage.operationz":`Field, operation cannot be empty`,
"label.user.organization.permit.overdue":`Your organization license has espired, please contact the administrator!`,
"label.log.datetimeoruser.value":`Please enter the query time and username.`,
"lable.product.stsp.noavailable":`No standard price available`,
"label.appservice.cannot.delete.app":`You cannot delete this custom app, because some profiles are using this custom app as the default app.`,
"component.event.label.newevent":`New Event`,
"label.view.sortview.exportview":`Export View`,
"label.uploadfilemaxsize":`The file upload maximum value allowed is`,
"label.event.weekview":`Week View`,
"label.conversion_rate":`Conversion Rate`,
"label.partnerCloud.partnerAccount.useWechat":`Use WeChat to scan and pay`,
"UG_Forcast_05":`Forecast settings: step {0}/{1}`,
"label.service.gantt.jobresour":`Show Work Resorces Only`,
"vue_label_campaign_fromopprotunities":`From {dsrjine} Ongoing Opportunities`,
"label.app.skyblue":`Sky Blue`,
"label.chinacloudcc":`Cloud Computing China`,
"label.connectOtherFinalNumber":`Object Limit Reached<br/>You can associate up to four objects to a custom report data source.`,
"label.redistributionrequest":`Reassign the approval requests`,
"label.knowledge.category.button.one":`Add Sub-category`,
"label.campagin.pcandmo":`PC and Mobile`,
"label.project.milestone.date":`The milestone date must be within the date range of the project to which it belongs.`,
"assetbom.transfer.notpermission":`You don't have the authoity to graft asset BOM. Please contact the administrator.`,
"label.marketing.setting1":`Marketing Channels`,
"label.select.file":`Select File`,
"message.error.object.contactadministrators":`The system is abnormal, please contact the system administrator for help.`,
"label.custom.quarter.title":`Custom Quarter`,
"label.knowledge.case.settings":`Cases Setting`,
"front-service-cloud-transfer-title":`Transfer Asset BOM Owner`,
"label.group.search.searchthisfeed":`Search this feed`,
"label.report.action.addtodashboard5":`Add to New Dashboard`,
"label.mobile.side.tab.remark2":`When setting the slider, you can put the most commonly used items in the front position. call history, menu item can only be userd for android version of CloudCC on mobile-side.`,
"contain":`Include`,
"label.select.template":`Select Template`,
"label.addattachment.step3.weixin":`Step 3 Click "Complete" button and back to previous page.`,
"lable.Order.successfully":`Transfer order to asset successfully.`,
"label.user.title":`Title`,
"label.weixin.check.agreement":`Please check the relevant agreement`,
"label.SMS.pfi":`Phone Number Field`,
"label.weixin.micro.research":`Micro Survey`,
"label.projectManagement.assigned.work":`Assigned Work`,
"label.document.login.error":`Login failed, please try again.`,
"label.mobile.phone.examines.people":`Revised By`,
"label.safetyset":`Security Settings`,
"label_function_tip":`This feature is not currently supported for Chinese mainland users. We appreciate your understanding!`,
"label.app.sort":`Sort apps`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Title`,
"label.event.moveup.3day":`3 days ahead`,
"label.condition":`Conditions`,
"label.description.message":`Maximum of 500 characters.`,
"label.ems.detailedsettings":`Detailed settings`,
"label.repeat.condition.field.prompt":`Please fill in a number in the "According to the length of characters" Filed！`,
"label.validate.function.funcExplain.OR":`Check that any parameters are true and returns TRUE or FALSE. Returns FALSE only if all parameters are false.`,
"label.salecommit.allow.prediction.query":`You cannot view the sales commit dashboards because you did not check the option Allowing Forecasts from Setup-My Personal Information-Personal Settings.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`View`,
"front-gantt-module-quick-create-task":`Create task quickly`,
"label.all_forms":`All Forms`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Statistical Dimension`,
"label.forecast.settings.data.chanpin":`Product Date`,
"label.appointment.wizard.subtitle4-2-7":`3 Days`,
"front-web-module-v1-detail-comment-please":`Please enter the feedback`,
"label_chatter_nextSevenday":`Next 7 days`,
"homepage.components.desctiption":`This page allows you to create and edit components that may be shown on one or more homepage layouts.`,
"label.customcomponent.page.index.table.namespace":`Namespace Prefix`,
"label_emailtocloudcc_exists":`The Email already exists.`,
"label_tabpage_save":`Save`,
"label.mergeRechecking":`Check Duplication & Merge`,
"vue_label_helpcenter_view2":`In the split screen view, you can quickly switch to view the detailed information of each data. <br> 3. Quickly analyze sales data<br> In the upper right corner of the view, you can open the chart in the view to perform a simple visual analysis of the data in the view. At the same time, you can view the dashboard and report list related to the view data for further analysis. <br>?Click the chart button in the upper right corner, you can view, create, edit simple charts created with view data, or view dashboards related to the current view. <br> Step 1: Click the chart button in the upper right corner to expand the chart on the page. You can view and manage the existing charts according to the permissions, and view the list of dashboards related to the view data. <br> Step 2: Click the Settings button, you can create, edit, and delete charts according to permissions. You can create four styles of charts, vertical column chart, horizontal column chart, pie chart and funnel chart. <br>?Click the report button to view the reports related to the current view. <br> 4. Manage data in the view<br>?In the view, according to your authority, you can add, edit, delete, and change the owner of the data through the buttons at the top right of the view, or next to each piece of data. <br>?Use tags to assist your data management. Use the button on the right to expand the tag management list, and you can filter the data in the view based on tags. After clicking Manage tags, you can also maintain and manage your tag library. After selecting the data, use the Add Tag button in the upper right corner to add tags to the data in batches.`,
"label.app.ismobile":`Displayed on mobile app`,
"chatter.group.changeTheGroupPicture":`Change The Group Photo`,
"label.mr.descreption.reDataList2":`records of repeated`,
"vue_label_chatter_agree_join":`Agree to join`,
"label.planned.nextrun":`Run In Next Scheduled`,
"Homepage.News.003":`Unable to display news without accounts data, please create a new account and the related news will be shown.`,
"label.summaryreport.selectpictype":`Select the chart type and other graphics options`,
"label.app":`Applications`,
"label.trigger.name":`Trigger Name`,
"vue_label_email_private_template":`Private template`,
"label.appointmentpage.wizard.subtitle1":`Choose date and time Inviter's Time Zone is {0}`,
"label.partnerCloud.orderingPlatform.payment":`Order Payment`,
"label.stdashbord.xsld.title":`Sales Funnel`,
"vue_label_pool_poolname":`Name of Account Pool`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Service Appointment Distribution Map`,
"front-lightning-module-v1-dashborad-target-value":`Target Value`,
"label.reportsSubscriptionPage.email.keywords":`Searching after entering keyword`,
"label.appointmentconfirmail.wizard.subtitle1":`Event name`,
"label.limited_scanning":`The admission ticket is only for scan to registrate on site`,
"label.weixin.nomore":`No more`,
"february":`February`,
"label.view.filterbyowner":`Filter By Owner:`,
"label.contentType":`Document Extension`,
"label.customobjdel.master.hsiang":`The Master-Detail Relationship Field is created in this object, so you cannot delete it.`,
"lable.Removal.succeeded":`Removed successfully.`,
"label.weixin.end.incorrect":`Invalid end date`,
"label.email.cc.recipients":`Cc recipients`,
"label.taskevent.list":`Activities List`,
"label.formula":`Formula`,
"label.h5.new.errorheader":`Review the errors on this page.`,
"label.emailobject.template.private":`Private`,
"label.visualpage.component.n4":`4.Variable. You can use variables directly, and be careful not to have single quotes.`,
"label.newemailnotice.step1":`Step 1 Select object`,
"label.chatter.file":`File`,
"vue_label_checkduplicate_rules":`Set duplicate check rules`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Custom Report Data Source`,
"vue_label_email_with_accessories":`Emails with Attachments`,
"label_efine_assessment_cycle":`Set Evaluation Period`,
"label_emailtocloudcc_button_sure":`Confirm`,
"label.forecast.userenablepage.isusing":`Enabled Users`,
"lable.goal.description":`Indicator Description`,
"message.error.serviceresource.relatedrecordid":`Each user can only be added as one service resource of type {0}`,
"label.weixin.addbus.information":`Add Vehicle Information`,
"label.emailtocloudcc.button.view":`View`,
"label.detail.workflow":`View Workflows`,
"label.standardfilter":`Standard Filters`,
"label.mobile.phone.results":`Performance`,
"chatter.feed.unavailabled":`Unenable`,
"label.view.sortview":`Sort Views`,
"label.availabilityobject.wizard.title":`Availability`,
"Main_Menu_Mobiledownload":`GET IT ON`,
"chatter.sticker":`Tracked`,
"label.workflow.intruduce":`Configure organization workflow by creating workflow rules. Each workflow rule consists of:`,
"label.customfields.richtext.tip":`Allow users to enter formatted text, add images and links.Up to 32,768 characters on separate lines.`,
"label.new.cy.select":`Pick a new currency from the available list.`,
"template.chart.schdzqzkhzhqk":`Leads Conversion in Campaigns`,
"label.forecast.customforecast.cpxl":`Product Family`,
"front-electronic-signature-open-service":`Enable the Esignature`,
"label.datamanage.import.field":`Import Fields`,
"chatter.email.sendMessageToMe":`Sends me a message`,
"message.cannotusebefore":`Please note that you will not be able to use this approval process until it has been activated.`,
"label.textmessage.vonage.api.secret":`API Secret`,
"label_chatter_newEvent":`New event`,
"label.ji.year":`{a} year`,
"label.sendmail.step2":`Step 2 Select an email template`,
"label.console.step5.record":`Open Rrcords`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Please select field to aggregate`,
"vue_label_commonobjects_detail_current_recorder":`The new owner will also become the owner of the records related to this project, and these records are owned by the current recorder`,
"label.SMS":`SMS Notification`,
"label.reconfigure.bundle":`Reconfigure the Package`,
"front-kefu-select-region":`Please select the area where the instance is located`,
"chatter.feed.deletefeeds":`Are you sure you want to delete this post and its comments?`,
"label.customsetting.manage.introduce.h":`If the custom setting is a hierarchy, you can add data for the user, profile, or organization level. For example, you may want different values to display depending on whether a specific user is running the app, a specific profile, or just a general user.`,
"label.product.name":`Product Name`,
"vue_label_commonobjects_view_saveas":`Save as`,
"label.group.my.archived":`My Archived Groups`,
"vue_label_pool_coflictmethods":`Conflict with current sales mode`,
"label.appupload.upload":`Upload`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Signed Task Completion Rate`,
"label.dashboardStandard":`Standard Dashboards`,
"label.niboer.time":`Nepal Time`,
"label.emailtocloudcc.filed.email":`Email`,
"market.name.social.post":`Social Posts`,
"evaluation.detail.notfound":`Comment detail is not found`,
"label.layoutoftestobj":`Test Object Layouts`,
"label.example":`Examples`,
"label.campaign.channel.step6.remark6":`please visit here`,
"chatter.emailLike":`Likes`,
"label.knowledge.category.button.two":`Edit Category`,
"label.alluser":`All Users`,
"addadvancedconditions":`Add Advanced Conditions`,
"message.selectgsummarycondition":`please select the summary criteria`,
"message.duplication.label.sectionremar2":`Note: All related records including any notes, attachments and activities will be associated with the new merged record.`,
"vue_label_helpcenter_product&pricebook":`Products are your basic catalog for all items and services you sell and their standard prices. The price list allows you to create a customized collection of product and associated list prices for specific users.`,
"message.duplication.label.isprofile":`By Permission`,
"component_setup_label_milestonesfield":`Milestone field`,
"setup_layout_label_required":`Required`,
"component_chatter_label_title":`Latest post`,
"label.assignment.setup.detail.order":`Sort Order`,
"vue_label_pool_unassigned":`Unassigned`,
"UG_Lead_007":`Google sync`,
"label.knowledge.record":`No relavent data exist!`,
"label_tabpage_filetypez":`File Type`,
"label.ccpeak.if.error.message":`If an error returned: use`,
"label.intialsubmitter":`Initial Submitters`,
"label.wei.icon":`Icon`,
"label.mask.show.last.4":`Mask last four characters`,
"lable.PowerProcess.time.trigger":`Time Trigger (min)`,
"july":`July`,
"label.usestandardwizard":`Use Standard Setup Wizard`,
"label.two.quarter":`Second Quarter`,
"label.size":`Size`,
"label.integrations.mailchimp.massage4":`Mailchimp is not currently installed. Please install Mailchimp in "Integrations"`,
"label_emailtocloudcc_step2total3":`Step 2 of 3`,
"vue_label_chat_customer_group_strategy":`Account Team`,
"label.searchvalue":`Find Values`,
"label.sendemail.birthday.title":`Birthday Reminder`,
"label.projectManagement.planned.days":`Planned Days (Day)`,
"label.service.gantt.workhours":`Based on labor-hour`,
"label.notification.approval5":`Delegated approval：【提交人】is requesting the 【对象】approval`,
"label.service.miniProgram.bindAddressDesc":`CloudCC Official Customer Service Mini Program Portal:`,
"chatter.error.wt":`Error: Invalid file type.`,
"vue_label_calendar_my_calendar":`My Calendar`,
"label.customername":`Account Name`,
"label.salescloud.salesdashboard.huikuan.rankings":`Team-Payment Rankings`,
"message.query.opportunity.contactrole.error":`Querying business opportunity contact default role failed, please contact administrator!`,
"noequal":`not equal to`,
"label.document.searchcustominfo":`Enter keywords to find matching documents.`,
"label.account.PreviousFQ":`Previous FQ`,
"label.file.f":`Files`,
"label.dashboard":`Dashboards`,
"label.report.folder":`Folders`,
"batch.edit.permission.list":`No permission to edit the data list`,
"label.file.orderbyowner":`Sorted by owner`,
"label.exchange.sync.account.password":`Service account password:`,
"pagecreator.button.publish":`Publish`,
"label.modify":`Edit`,
"label.exchange.sync4":`States`,
"label.remark.information":`Description Information`,
"label.service.without.major.event":`No important event to be displayed`,
"label.knowledgebase.release.status":`Publish Status`,
"label.tabpage.ok":`Confirm`,
"label_screening_assessment_content":`Filter appraisal content`,
"label_partner":`Partner Cloud`,
"label.user.detail":`View Users`,
"front-kefu-moudle-or-this":`or, like this?`,
"label.unselect.object":`Optional Object`,
"label.quote.contactfax":`Fax`,
"label.weixin.appmanage.alert":`Press {0} to remove app from My Apps, Press {1} to add app to My Apps.`,
"vue_label_dashboard_thisfolder":`Add Public Dashboard to This Folder`,
"label.delete":`Delete`,
"label.appexchange.installedpage.message1":`You can view and download applications directly in CloudCC App Store and install them into your CloudCC.com environment.`,
"label.mobile.phone.required.summary":`Summary is required`,
"label.batchadd.newbatchpage.addtr":`A maximum of 30 records can be added.`,
"label.partnerCloud.partnerAccount.lockLine":`Locked Amount`,
"label.emailsync.status.connectstatus":`Connection Status`,
"label.campaignmember.main.importmember.lead":`Import Members-Leads`,
"message.username.isnull":`You must enter a value for the username.`,
"label.forecast.tree.enableuser":`Enable User`,
"label.multilang.view.viewmessage":`This view has been applied to the mobile device. A maximum of 10 fields can be chosen, there are now {0}:`,
"friday":`Friday`,
"label.sendemail.activity.neweventtitle":`New event notification`,
"label.page.addtabto.user":`Append the tab to existing personal customizations`,
"front-kefu-moudle-v1-connect-phone":`Associate Phone Number`,
"label.wei.pollis":`Vote for`,
"lable.opppdt.editPdt.title":`Edit Opportunity Products`,
"label.permission.objectpermission.recordfenpei":`Record Type Assignment`,
"pagecreator.layout.message.delete.success":`Layout deleted successfully`,
"label.dataimport.isdupecatcher":`Execute Filters`,
"label.deletelayout.tip":`In order to delete a page layout, you must select another one to replace it with.`,
"label.projectManagement.No.matching.data":`No matching data.`,
"pagecreator_page_message_delete_success":`Page deleted successfully`,
"label_tabpage_equalz":`Equal to`,
"label.ems.emailsetup":`Email Setup`,
"label.decimaldigits":`Decimal Places`,
"component.chatter.button.delete":`Delete`,
"label.isallowreport":`Allow Reports`,
"label.view.appliedMobile.message":`Check this item, Step 3. Select the fields to display, and you can select up to 6 fields`,
"label.must.positive.integer":`The number must be an integer.`,
"label.preview.print.template":`Preview of Print Template`,
"label.schedulejob.setup.schedule.start":`Start`,
"UG.Case.04":`Case assignment`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Enable Hover Details`,
"vue_label_email_alltemplates":`All templates`,
"label_report_chose_obj":`Please select object relation and report data source`,
"label.partnerCloud.productSet.del":`Delete Item`,
"label.quote.shrdz":`Recipient address`,
"page.approval.history":`Approval History`,
"lable.outlook.detail.prefc":`Always Preferred CloudCC.com`,
"label.translation.unable.display.view":`Unable to display view`,
"label.encrypt.change":`Convert Encrypted Type`,
"button.partner.workspace.login.logo.upload":`Upload image`,
"label.batchadd.mustinput2":`is required. The record cannot be saved if the required information is empty.`,
"label.dataimport.update.error.check":`An error occurred in the update the data. Please examine this data carefully.`,
"label.staticresource.name.already.exists":`The unique name of the static resource already exists!`,
"label.appupload.upload.install.success":`Installed successfully`,
"label.conditiontag.lookup.true":`TRUE`,
"label.quickbooks.viewlist.customer":`CUSTOMER`,
"label.field.edit.change2":`The highest score is at least 1`,
"label.fianalrejectoperate":`Final Rejection Actions`,
"label.ccpeak.wgd":`Unfiled Classes`,
"label.reportsSubscriptionPage.condition.emailreport":`Summary   report`,
"label.detailinf":`View more`,
"label.eastem.standard.time":`Eastern Standard Time`,
"chatter.group.manager":`Manager`,
"label.manage_columns":`Manage Header`,
"label.daylight.time":`Daylight Time`,
"label.weixin.mycar.information":`My Vehicles`,
"label.ccpeak.help":`Help for Classes`,
"lable.outlook.detail.match":`Matching Criteria`,
"label.version.nonsupport.approval":`Approval Processes are not supported temporarily.`,
"label.custom-tailor":`Customize`,
"label.showoperate":`Show Actions`,
"label.view_edit":`View and Edit`,
"label.lead.score.prompt2":`Please select the range of scoring, click [Lead Scoring] button, and the system will score the selected leads according to the active Lead Scoring Rule.`,
"label.datamanage.savetemplate.error":`Template save failed.`,
"label.source":`Source`,
"label.multilang.customfieldsetup.reference":`This field is referenced by {0}`,
"chatter.poll.option7":`Choice 7`,
"label.login.access.day":`day(s)`,
"label.icon.66":`Equipment`,
"label.tabpage.kanbansetup":`Viewboard setup`,
"label_emailtocloudcc_step1_lead2":`Once configured, mails received in this mailbox will be automatically logged as lead records in CloudCC. Ensure that no deals are missed.`,
"label.partnerCloud.partnerAccount.numericValue":`The topup amount shall be a numerical value.`,
"label.permission.detail.app.object.tip":`Objects, Fields and Tabs Access Settings`,
"label.emailobject.template.subject":`Subject`,
"template.report.month.customer":`Accounts of This Month`,
"label.weixin.formerly":`In the past`,
"label.contract":`Contracts`,
"label.help":`Help`,
"vue_label_homepage_setdefault":`Set as Default Homepage`,
"label.icon.52":`Power Generation`,
"label.customfields.file.count":`The number of files`,
"UG_Account_07":`Import account`,
"label.addattachment.ntko":`Edit Online`,
"label.service.ganttBaiduMap.assign.service":`Assing service appointment to this person`,
"vue_label_file_my_file":`My File`,
"label.custom.page.hide":`Hide`,
"label.addexistoperate":`Add Existing Operation`,
"label.already.startdate":`Started Time`,
"label.partnerCloud.financeSetting.alipay":`You need to open Alipay business account. Only business account is supported to be as receipt account. Transaction fees will be charged by Alipay to the payee.`,
"label.dashboard.summary.editPageFooter":`Edit Footer`,
"label.category.8":`Consumer Goods`,
"label.forecast.customforecast.foretype.best":`Best Case`,
"message.validation.isnull":`Please enter a value`,
"label.savewxpay.failure":`Failed to save information of WeChat payment merchant`,
"label.file.stop.sharing.desc1":`Stop sharing with`,
"label.opportunity.setting.showstage。read.info":`The opportunity stages cannot be modified manually after ticking`,
"UG_Campaign_003":`Create a campaign`,
"label.edit.field.select.showoptions":`Show all options`,
"message.inputplatformpwd":`Enter Admin Password`,
"vue_label_systemSettings_mobel_set":`Mobile App Setup`,
"label.projectManagement.thefirstone":`This is the first record`,
"label.data.newtemplate":`Create Data Export Template`,
"label.monitorsys.delete.log":`Key Operation Audit Log`,
"label.template":`Templates`,
"Lead.Auto.Scoring.Setting.001":`Automatically score when editing or saving (Except the leads which are batch imported or created via interface )`,
"label.operatesuccess":`Operation Succeeded.`,
"label.send":`Send`,
"chatter.yp":`Hide Feed`,
"label.overall_responses":`Overall Response`,
"vue_label_systemSettings_server_report":`Service Report`,
"label.icon.113":`House`,
"label.partnerCloud.basicSetting.domainSet":`Set Up Domain Name`,
"label.login.access.text":`To help with supporting, you can grant the administrator the access to login and visit your data.`,
"vue_label_report_addrowlevelformula":`Add row-level formula`,
"message.duplication.label.mergeTitle":`Merge My`,
"label.event.add":`Add Event`,
"vue_label_homepage_bigscreen_light":`Light`,
"setup.chatter.enabled":`Unavailable, please contact Administrator to enable CCChat.`,
"label.inputreceiver":`You can enter up to five (5) email addresses to be notified. Each email address is separated by ";".`,
"label.custom.page.custom.page":`Custom Pages`,
"label.data.exp.csv":`CSV format`,
"label.searchlayout.view.example":`View example`,
"label_tabpage_fullscreenz":`Full screen`,
"label.tabpage.last":`Previous Step`,
"lable.outlook.mcto.accepemail":`My Available Email Addresses`,
"front-electronic-signature-isopen":`Active`,
"vue_label_commonobjects_detail_earlier":`View Earlier`,
"label.name.cannot.greater.str":`Name can enter up to 255 characters.`,
"label.weixin.activity.email":`Activity: Email`,
"label.tabpage.unequalz":`Unequal to`,
"label_calendar_year":`Calendar year`,
"label.appupload.upload.installor":`Installed By`,
"label.jixiaoswitchon":`Expand`,
"label.user.congratulations.send.finish":`Congratulations, completed mass email.`,
"label.customsetting.touse.getListCustomSetting2":`Query the "list" type data of custom settings, return single data corresponding to API Name. Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`The master record type cannot be assigned to the profile that already has been assigned a record type.`,
"label.tippage.li3":`So that any dashboard components based on the report of the failure has been removed`,
"label.weixin.no.name":`No subject`,
"label.tabpage.viewz":`Print current view`,
"label.create_contacts":`Create List of Contacts`,
"vue_label_homepage_operationitem":`Please Select Button`,
"label.pc.ui.2018.switch.version":`Switch Version`,
"label.salescloud.teamrole.main":`Major Contact`,
"label.reportsSubscription.format.report":`Formatted report (Excel format .xlsx)`,
"label.forecast.customforecast.total":`Amount`,
"label.quickbooks.fieldlabel.lastname":`Last name`,
"label.appointment.wizard.title2":`Meeting Details`,
"label.project.template.one":`Creating project from project template requires 2~3 minutes. Thank you for your patient waiting.`,
"label.timetrigger.workflow":`When the workflow is active.`,
"label.projectManagement.creator":`Creator`,
"label.customfields.formula.selectreturnfieldtype":`Please select the formula return type`,
"label.list.userinterface.dashboard.enable":`Enable New Dashboard Components`,
"label.email.delete.html.format":`All html formats will be deleted. are you sure?`,
"label.appupload.install.modifyapi":`Modify the conflicting api name:`,
"label.chat.add.topics":`Add a topic`,
"label.savepartner.fail":`Failed to save settings for Partner Cloud`,
"label.pc.query.new":`View your latest`,
"message.duplication.label.editfiltertitle":`Find Duplicate Filter Edit`,
"label.task":`Tasks`,
"label.emailobject.emaildetail.title.toaddress":`To:`,
"label.setup.mobile.bottombutton.select":`Select the 4 first-level pages you want to show on the mobile app`,
"label.loginip.pagecue.invalido":`Invalid Internet Address`,
"label_tabpage_listshow":`The list shows`,
"component.newrecords.label.10records":`10 records`,
"label_chatter_file":`File`,
"pagecreator.systemstyle.label.detailcolor":`Detail text color`,
"label.forecast.userenablepage.title":`Forecasts Users`,
"front-project-module-v1-actual_working_hours":`Actual Work Hours`,
"vue_label_systemSettings_Security":`Security Containment`,
"label.processsetting.two.select.key.fields":`Step 2: Select key fields for each step in the process and provide guidance`,
"label.page.display1":`records per page`,
"label.appointmentpage.wizard.subtitle1.2":`Inviter's Time Zone is {0}`,
"label.ggReleaseRange.searchTeam":`Search public group`,
"chatter.group.searchGroup":`Type a Group Name...`,
"label_card_type":`Card Layout`,
"label.appupload.managed.tip":`Being controlled means that you can only edit certain attributes.`,
"label.changemyshow":`Change My Display`,
"label.custom.CustomQuarter":`Custom Quarter`,
"label.tobedelete":`To Be Deleted`,
"label.newPage.unuse":`Your page is lost.`,
"label.product.pricebooks":`Price Books`,
"label.mobile.layout":`Mobile Page Layout`,
"label.multilang.file.items":`{0} projects:`,
"label.app.step4.tabused":`Selected Tabs`,
"label_ccchat_create_account":`Create an account`,
"message.startusingprocess":`After activating this approval process, you can not add or remove approval steps. Also, some approval step attributes will not be editable. Are you sure you want to continue?`,
"vue_label_email_please_add_a_theme":`Please add a theme before saving as a template`,
"label.please.create.a.target.record.first.":`Please create an indicator record first`,
"label.processsetting.set.objandfile":`Step 1: Select objects and fields that you want to set the process`,
"label.newreport.group.data":`group（s）`,
"label.notcreatenew":`Do not create a new opportunity upon conversion.`,
"lable.custom.CurrentandPreviousCY":`Current and Previous CY`,
"front-epwechat-module-v1-input-androidschema":`Please enter Android schema`,
"label.projectManagement.unfinished.quantity":`Uncompleted Number`,
"label.visualpage.idandname":`Page ID and Page Name is:`,
"label.approvingprojects":`Items to Approve`,
"label.partnerCloud.financeSetting.weChat":`WeChat service need to be opened and the collecting service agreement with Tencent is required. Transaction fee will be charged by Tencent to the payee.`,
"label.quickbooks.viewlist.view":`View`,
"label.knowledge.category.hint.ten":`Deactivated Category Group`,
"report_type_label_productPricebooks":`Products and Price Books`,
"label.fenbeitong.description":`Check and enable FenBeiTong travel application form to assist employees in business travel application and reimbursement of travel
expenses`,
"label.ccchat.upload.change":`What has changed? (optional)`,
"label.emailsync.status.log":`Connection Log`,
"label.addnew":`Add New`,
"UG_contact_05":`Create a contact`,
"label.appupload.componet.queryerror":`An error occurred while searching the omponent. Please contact your administrator.`,
"label.salescloud.setting":`Group Sales Setup`,
"label.recurrencetimetriggeroperate":`Periodic Time Trigger Actions`,
"label.event.moveup.4day":`4 days ahead`,
"No.Hisitory.Activity":`No historical activity`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(date)`,
"label.recentview.seloption3":`Recently Modified`,
"label.login.access.nopermission":`--No Access--`,
"label.taskmenuandlink":`Task Buttons and Links`,
"label.forecast.customforecast.foredis.sbw":`Millions`,
"lable.PowerProcess.created.event":`create milestone`,
"label.stdashbord.xsld.funnelchat":`Sales Funnel Chart`,
"label.step1.total7":`Step 1 of 7`,
"label.sendsms.batch.chosepersion":`Batch SMS: Select the recipients`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Score`,
"label.ccdocument.isdel.folder":`Are you sure you want to delete this folder?`,
"label.discard_change":`Yes, discard changes`,
"label.knowledgebase.assign":`Assign`,
"PersonalInfo_LoginHistory_001":`Broswer validates the registration link in your mailbox`,
"label.globalselect.deletedvlaue":`Deleted Global Value Set`,
"label.ems.lookup2":`Search`,
"label.dataimport.system.unable.determine":`,the system cannot determine loss the`,
"label.weixin.invitation.consultant":`Invited consultant`,
"label.salescloud.salesdashboard.phone.rankings":`Dialing Rankings`,
"label.knowledgebase.plan.release":`Plan to Publish`,
"label.integrations.first.half":`The current view in total`,
"label.icon.123":`First Aid Kit`,
"label.leadscore.isactivity":`Active`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`New Account`,
"front-lightning-module-v1-details-page-chart-tittle":`You can insert chart and diagram modules in the detail page, and upt to 10 report charts can be inserted. For example, you can add a report chart module for a record with record type as Agent in the Accounts object, add charts of sales amount of agent order and agent quarterly sales report to the module, and filter by the account name to view related data directly on the agent account's detail page.`,
"label.customobjects.fieldsrelation":`Custom Fields & Relation`,
"label.dashboardSetup.left":`Left`,
"label.mobile.app.sectionpart":`Mobile App Section`,
"setup.mainpage.label.welcome25":`Instructions: Click on the menu on the left side of this page → Manage Settings → Security Control → Sharing Settings.`,
"label.custombutton.edit.error":`Error: The name is already in use or has been previously used, please choose a different name.`,
"label.icon.48":`Exhaust Fan`,
"label.tabularreport.step2":`Step 2 Select the column of the report`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Two`,
"UG_quota_01":`Manage account quotes`,
"label.customcomponent.btn.usewhere":`Where is this used?`,
"label.quickbooks.searchresault.email":`Email`,
"label.emailobject.appointment.urltext2":`book a time here`,
"label.tianyancha.field.relation.error":`Please set the mapping relationship between the tianyancha field and the customer field first`,
"APPIntegration_Social_facebookerror":`You must enter a valid URL for facebook.com`,
"label.notification.arketsea.transfer":`{5} transferred {0}：{1} from {2} to {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Total Receipts Task Completion Rate`,
"UG.Account.04":`Passive query account filtering`,
"this.week":`This Week`,
"label.email.track.attachment.num.control1":`Number of files uploaded exceeds 10,and cannot be uploaded`,
"label.exchange.sync.state.event":`Events`,
"vue_label_systemSettings_websitesetting":`Web Setup`,
"vue_label_file_replace_reason":`Reason for replacement`,
"label.version.feature":`Features`,
"E":`Email`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Template`,
"label.chosesubject.meet":`Have A Meeting`,
"UG.ST.003":`You do not have permission to create {0}, please contact the administrator, click confirm to go directly to the {0} interface.`,
"label.authorization.failure":`Authorization failed. Please re-authorize!`,
"label.newprocessstep3":`Step 3 Specify Approver Field and Record Editability Properties`,
"lable.outlook.mcto.mostrecord":`Record With The Most Activities`,
"vue_label_normal_select":`Select`,
"label.partner.workspace.login.buttontext":`Button text`,
"template.chart.ydschdtj":`Monthly Campaign Statistics`,
"label.ServiceCloud.zichanmingcheng":`Asset Name`,
"label.productsales.oppor.nooverdue":`Good job, no overdue opportunities.`,
"label.appointment.wizard.subtitle3-5":`Friday`,
"label.payment.the.current.version":`Current Subscription Edition`,
"label.reportlist.top":`Set to Top`,
"label.emailobject.emaildetail.prompt":`Prompt`,
"label.weixin.endst":`End Time Cannot Be Before Start Time.`,
"report_label_knowcreatehighlevelreport":`How to create a advanced report?`,
"label.quickbooks.view.openestimates":`Open Estimates`,
"label.url.cannot.empty":`URL can not be null!`,
"label.emailnoticetemplate":`Email Notification Templates`,
"calendar.tips.task":`No task today`,
"label_partner_all_operate":`Operation`,
"message.duplication.label.cancelbutton":`Cancel`,
"vue_label_SMS_addcontact":`Add contact`,
"label.martrixreport.setsumfield2":`Select the field that used as summary column in your matrix report`,
"approval_request_email_body":`The following items are requesting approval: \n click the link below to approve: \n`,
"label.emailobject.emaildetail.field.record":`Record`,
"label.tab.page":`Page`,
"label_tabpage_prepagez":`Display on every page`,
"label.iran.daylight.time":`Iran Standard Time`,
"label.event.nextweek":`Next Week`,
"fliter.lastmonth":`Last Month`,
"label.group.no.recent.search":`There are no matching recently viewed groups.`,
"label.h5.act.confirm":`Confirm`,
"label_tabpage_mypotentialcustomers":`My leads`,
"label.tabpage.queuez":`Queue`,
"label.batch.edit.description":`Select to the fields you want to edit,select at least one field and up to 5.`,
"label.batchadd.newbatchpage.deltr":`Keep on line at least.`,
"label.industrialandcommercialverification.instructions2":`The version you are using is free, and the maximum number of queries is 10,000 times per day. If you need to expand the number of queries, it is recommended to purchase service. After you purchase the service, you will get the token from the vendor, set it up on this page. The vendor will continue to provide you the corresponding paid service.`,
"label.rejectrequestbehaviour":`Perform all rejection <strong>and</strong> all final rejection for this step. (Final Rejection)`,
"label.batchCopy":`Batch Clone`,
"label.service.two":`Some filters are defined but not referenced in Advanced Filters.`,
"label.data.import.setup.detail.remark":`If you check the following options,is performed in the import data.`,
"vue_label_file_delete_lib":`Delete file library`,
"label.integerdigit":`The number of digits to the left of the decimal point`,
"label.profile.standardobjcontrol":`Standard Object Permissions`,
"label.reportrecords":`Records`,
"label.noplan":`You have no events scheduled for the next 7 days.`,
"label.visualpage.ytype":`Dashboards`,
"label.branch":`;`,
"label.knowledgebase.new.article":`New Article`,
"label.Addressbook":`Contacts`,
"label.delete.reward.groups":`Delete Quote Line Group`,
"label.appexchange.uninstallpage.message1":`Permanently delete all components in this package （listed below）`,
"chatter.group.everyone":`All Users`,
"label.cooperation":`Cooperation`,
"label.uploadfail":`Upload Failed`,
"to":`to`,
"button_partner_delete":`Delete`,
"attachment_select_warning_001":`The attachment is archived and Archive button is not available, please re-select an attachment.`,
"label.step4.total4":`Step 4 of 4`,
"label.login.access.avalid":`Expires Today`,
"label.defaultview2":`Pined list`,
"vue_label_commonobjects_detail_style":`Buying style`,
"label.selectfield":`Select Field`,
"label.report.select.column.collect":`Select the column to summarize`,
"lable.currencyAdv.newdaterate.existeddate":`The date is already being used for HKD.Please specify a different Start Date.`,
"pagecreator_systemstyle_button_new":`New style`,
"label.ccchat.person.invite":`Colleague Invitation`,
"label.sendemail.recycle.clear":`Clean Recycle Bin`,
"label.usermanage.view.notexist":`The view does not exist`,
"setup_chatter_enabled":`Unavailable, please contact Administrator to enable CCChat.`,
"UG.Contract.01":`Manage contract`,
"label.martrixreport.2018.step4":`Step 4 Select report criterias`,
"message.errorinscript":`Execution script issues.`,
"label.knowledgebase.modification.date":`Modified Date`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Up to 10 digits can be entered for cost`,
"label.list.isActiveNewApproval":`Enable New Approval Page`,
"label.mobile.main.page.icon.setup":`Mobile App Icon Setup`,
"label.select.customer":`Select Account`,
"label.sharerule":`Sharing Settings`,
"label.fiscal.FY":`Fiscal Year`,
"label.appupload.component.type.customfield":`Custom Field`,
"label.emailobject.emailsend.sendindividually":`Send Individually`,
"label.new_formname":`New Form Name`,
"label.appointment.wizard.notif1":`End time should not be earlier than the start time`,
"front-console-conversation-evaluate-desc":`Evaluation response from {evaluateInfoName}`,
"homepage.components.lasttime":`Last Modified Date`,
"vue_label_commonobjects_view_chart_deletechart":`Delete Chart`,
"label.multilang.document.upload.fail":`{0} files have been uploaded successfullt and {1} files are failed`,
"UG_contact_03":`Track contacts in one place, sales signals`,
"label.marketsea.istoseafromother":`Allow transfer from other pools`,
"label.datamanage":`Data Administration`,
"label.globaloperation.operationtype.create.data":`Create record`,
"label.customer.tab.step2.see":`Tab Visibility`,
"label.wtd.changefields.desc":`After users submit the form, they will be taken to the specified return URL on your website, such as a "thank you"page.`,
"label.ems.eamilinfo":`Email information`,
"label.recordtypeselect.new":`New Record Type`,
"vue_label_report_output":`Formula output type`,
"label.emailnotice":`Email Notification`,
"label.icon.196":`Toilet Paper`,
"label.emailsync.status.disabel":`Inactive`,
"label.tabpage.isdeleterecord":`If delete the selected record`,
"message.selectoneoftypes":`Please select one of the following types`,
"label.import.index.createid":`Create ID`,
"vue_label_systemSettings_social2":`Social Media Account Setup`,
"label.ccpeak.sel.time":`Scheduled Classes in This Folder`,
"label.data.downpage.i_list.desc1":`During the import, data that is not successfully imported because the data is incorrectly formatted, or because the trigger or validation rule fails, generates the CSV file to be displayed on the current page. The data successfully imported will not be displayed on the current page.`,
"label_adjust_forecast":`Adjust forecast`,
"vue_label_normal_lead_sf":`Lead`,
"vue_label_report_notice1":`The report contains unsaved changes. If you close the report, these changes will be lost. Click below "Save and close" button to save the changes.`,
"label.notfiledpublicreport":`Unfiled Public Reports`,
"one":`One`,
"UG.Lead.008":`Business card scan code`,
"label.archived":`Archived`,
"label.standardabstractfield":`Standard Summary Fields`,
"vue_label_notice_add_fail":`Add failed`,
"label.sendemail.registIMUser.addresserror":`the email address of the recipient is incorrect`,
"label.ccdocument.toolbar.switch":`Toolbar Switch`,
"first":`The First`,
"label.icon.147":`Mouse`,
"vue_label_jihui_er":`Opportunity 2`,
"label.ccchat.micropost.isedit":`Modification of Feeds and Comments`,
"label.department.next":`Next Page`,
"front-kefu-moudle-confirm-disable-phone-user":`Are you sure to disable the dialout for the user {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`The start and end date does not meet the subscription frequency!`,
"lable.account.NextpDays":`Next 120 Days`,
"UG_opportunity_007":`Contact role`,
"label.encrypt":`Encrypted`,
"label.knowledge.category.hint.three":`Delete or replace existing category, which removes all catetogies associated with article.`,
"label.customcomponent.usewhere.info":`The following are all references to this component. Click the reference label to view the definition.`,
"vue_label_import_addandupdate":`Add and Update`,
"label.email.all.members":`Send to all group members by email`,
"component_task_button_save":`Save`,
"label.file.deleted.unavailable.desc":`File is deleted,unexsit or unavailable now.`,
"label.emailsync.status.viewlog":`View Log`,
"label.marketsea.othersetup":`Other Settings`,
"label.data.exp.newtemppage":`Template Creating Page`,
"vue_label_lead_score_successsful":`Scored successfully`,
"label.sendemail.activity.newtask":`Dear #belongtoidccname, hello:\r\n your colleague #createbyidccname has assigned you a new task in #createdate, which reads as follows:\r\n subject:#subject\r\n due date:#expireDate\ r\n related item: #relatedstr\r\n content: #remark\r\nfor more details, please visit this link:\r\n #path\r\n #orgNameCRM system`,
"component.event.label.soon":`Immediately`,
"label.forecast.shrepage.getlist":`Back to Forecast Hierarchy`,
"UG.solution.02":`The solution is an internal solution of institution to the problem that accounts encounter.`,
"label.weixin.data.approval":`The record is under approval`,
"label.build.pagelist":`Page Builder List`,
"label.customsetting.type.hiberarchy":`Hierarchy`,
"label.forecast.ccfh":`Best Case`,
"label.Current.Window":`Displaye in Existing Window`,
"label.appointmentdetail.wizard.title20":`Sunday Plan`,
"label.emailaddress":`Mail Address`,
"label.qetting_notifications":`Not getting our emails? Make sure that you've added CloudCC email addresses to your allowlist and turned on your export notifications.`,
"Homepage.News.001":`News`,
"label.runreport":`Run Report`,
"label.customer.tab.step3":`Step 3 Add to Custom Apps`,
"label.dashboard.snapshot.refresh":`Refresh`,
"label.approvepagelayout3":`Approve Page Layout`,
"vue_label_SMS_send_messages":`Send Messages`,
"label.executestate.old":`Executed`,
"label.approvalstep3":`Step 3 Select Assigned Approver`,
"label.step3.total6":`Step 3 of 6`,
"front-kefu-moudle-v1-delete-templete":`Delete Template`,
"label.data.downpage.e.title.num3":`3、Users can create export templates according to their needs and select the item "Export By Template", which can make export operation more convenient.`,
"label.attendance.outer":`Mobile Worker`,
"setup_layout_button_selectall":`Select All`,
"chatter.photo.img":`Maximum file size is 2 MB.`,
"front-dynamiclayout-module-v1-required":`The field of {required} is set as required.`,
"label.mytask":`My Tasks`,
"label.edit.customerinfo":`Company Profile Edit`,
"label.processsetting.process.explain":`Setting up and using the process allow users to focus on the most important items and show them keywords and tips at the right time to help them complete the process.`,
"label.emailobject.subject":`Subject`,
"label.mobileapp.scansetting.message":`Select whether to save the scanned cards in the image format to the related list of "Notes and Attachments" according to your actual usage scenario. <br>Activate: the scanned card is automatically saved to the attachment while the record is being saved. <br>Deactivate: save the record only.`,
"front-epwechat-module-v1-android-autograph":`Android App Signing`,
"label_component_helper_potentialcustom":`Leads assigned to you today`,
"label.projectManagement.nodata.week.work":`Let's add tasks to better organize this week's work.`,
"label_tabpage_rolez":`Role`,
"label.importsourcestep4":`Step 3 Import your files`,
"label.icon.50":`Compass`,
"lable.service.prompt":`Unable to create new field，the number of fields reached limit.`,
"label.campaign.channel.input.page":`Specify a Web page, generally setting the campaign homepage as a thanks page.`,
"UG.homepage.001":`Win more deals in less time`,
"label.step4.total6":`Step 4 of 6`,
"label.partner.required":`Error: The domain can not be empty`,
"label.tag.manage.title":`Manage- {0}`,
"label.data.downpage.i_title.num1":`1. The system only supports the common CSV format.`,
"label.custom.quarter.end":`Custom Quarter End Date`,
"label.layout.distribute":`Page Layout Assignment`,
"label.version.allsms":`Mass SMS`,
"label.tolead":`Import`,
"label.texttemplate.usemergefields":`Use incorporate fields in SMS template.`,
"label.emailobject.sure":`Sure`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Enable H5 creating and editing on mobile`,
"label.tabpage.messagez":`Please enter comment`,
"label.mobile.phone.write.day.report":`New Daily Work Notes`,
"label.data.setok.e.desc2":`Export Data List Page`,
"label.emailsync.message":`Prompt`,
"label.sales.page.mubiao":`Target Performance`,
"label.ccdocument.list":`View your latest document`,
"label.tabpage.userGuidez":`User guide`,
"label.report.fields":`Available Fields For Reports`,
"vue_label_checkduplicate_at_same_time":`Match All Simultaneously`,
"label.sms.phone":`Service Phone`,
"UG_ST_004":`You do not have the data management - "data import permission, please contact the administrator, click confirm and go directly to the {0} interface.`,
"label.mobile.nobindmobile":`This mobile number doesn't exist now. Please bind mobile number from user information`,
"label.partnerCloud.basicSetting.intro":`CloudCC supports to set up multiple sites for partners of different types and configure login page, menus, and permissions separately. For example, retailors can create various sites for local agents and advertisement partners.`,
"label.trigger.targetobject":`Target Object`,
"label.ems.emailsyncperiod":`Email synchronization period`,
"lable.Transformation.mode":`Transformation Mode`,
"label.emailobject.new.template":`Add New Template`,
"label.System.Setting":`System Settings`,
"label.emailtocloudcc.button.addemailaddress":`Add Enterprise Mailbox`,
"lable.a.total.of.invoices":`0 invoice in total`,
"label.multilang.customforcast.forecasthistory":`Forecast history of {0}：`,
"label.role":`Roles`,
"advancedconditions":`Advanced Filter Conditions`,
"label.tabpage.beginz":`Begin`,
"label.campagin.roi.khzhsl":`Quantity Of Account Conversion`,
"chatter.poll.option5":`Choice 5`,
"label.weixin.horse.club.registered":`Registration of Aid-Max users`,
"frame_personinfo_label_resizeimage":`To make adjustments to your thumbnail image, drag and resize the dotted lines in your profile photo above.`,
"label.file.share.select.warning":`It has been set up for sharing!`,
"label.event.this.week":`This Week`,
"label.data.import.object.label":`Object Labels`,
"label.visualpage.folder":`Unfiled Page Folders`,
"vue_label_report_saveandclose":`Save & Close`,
"label.newdashboardpage.saveto":`Save to`,
"label.partnerCloud.financeSetting.developerIDTwo":`Developer ID`,
"lable.PowerProcess.created.ago.please":`Before creating a process, please`,
"label.chatter.myfollowers":`My followers`,
"label.campaignmember.main.duplicatelist.title":`Campaign Memebers: Scan Code to Find Duplicate Settings`,
"label.group.no.recent2":`Find groups to join`,
"label.icon.110":`Book`,
"label.merge.my.account":`Merge My Accounts`,
"setup.layout.button.quicksave":`Quick Save`,
"pagecreator.page.message.canntdelete":`The current page is not allowed to delete`,
"label.report.printable.view":`Printable View`,
"ccchat_fieldtrack_fieldchange":`Change from {0} to {1}`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Identity Provider Certificate`,
"label.step2.total2":`Step 2 of 2`,
"lable.product.pricebooks.isn":`Active Price Books`,
"labal.emailtemplate.namemassage":`The unique name of the mail template already exists, please re-edit`,
"only.one.field":`Only one field can be selected.`,
"label.weixin.appr.audittime":`Approval Date`,
"pagecreator.page.button.delete":`Delete`,
"front-kefu-moudle-v1-Session-start-time":`Session Starts at:`,
"label_chatter_state":`Status`,
"vue_label_systemSettings_lightningcustom":`Custom UI in Lightning`,
"label.searchs":`Search`,
"label.mobile.phone.not.read":`Unrevised`,
"label_chatter_allweather":`All-weather`,
"label.enter.number":`Please enter an integer between 0-6.`,
"front-epwechat-module-v1-addressbook-desc":`When enabled, contacts and departments in WeCom will be synced to CloudCC users and roles`,
"label.emailfield":`Email Fields`,
"pagecreator_button_next":`Next step`,
"label.more.select.merge.records":`You can only select up to 3 data to merge`,
"lable.edit.queue.selobjct":`Selected Objects`,
"label.reportsSubscription.editsubscribe":`Edit Subscription`,
"label.selectfieldtoautotransmit":`Select Field Used for Automated Approval Routing`,
"label.ccpeak.need.topass":`Need to pass into`,
"label.checkfield.merge":`Merge`,
"front-lighting-module-v1-detail-file-downlaodInfo":`The record is locked and not available for downloading files. Please contact the admin for unlock.`,
"vue.please.enter.a.chart.name":`Please enter the name of chart.`,
"label.data.dataexptemplate.desc3":`3. The export mode is valid only for the ecported data and is not valis for the export template. The file format for the export template is CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Homepage Swift Function Setup`,
"label.ems.connect.success":`Email test succeeded`,
"label.applet.text":`A case record can be generated in the system for a repair request submitted through the mini program. Please select the user as the creator of the case record. The selected user needs to have the creation permission for case object. And after changing the owner, you need to log in the mini program again and submit the report form to take effect.`,
"label.knowledgebase.parent.window":`Parent Window`,
"label_file_size":`Space Used`,
"label.allocation.department":`Assign Users`,
"label.browser":`Browser`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Wednesday`,
"label.integrations.description1":`Export the data in current view`,
"label.project360":`Project 360`,
"label.choose_formtype":`Choose Form Type`,
"label_emailsync_status_connectstatus":`Connection Status`,
"label.bmap.beijing.city":`Beijing`,
"label.mask.encryption.scheme":`Encrypted Format`,
"label.imgfield.type":`Image Type`,
"label.person.target.responsible":`Select Target Supervisor`,
"label.appexchange.installedpage.installdate":`Install Date`,
"label.partnerCloud.orderingPlatform.partnerUsers":`This feature is only available for partner users.`,
"label.profile.customfieldsafety":`Security Settings (for custom objects)`,
"label.no.target.models.available.":`No available target models. Please create a target model or contact the administrator.`,
"label.process.execute.tip":`Your request has been processed, mass approve or mass reject will take some time, and the system will inform you by mail when the processing completed.`,
"label.app.step2.introduce":`Enter the following fields to define the custom app`,
"label.loginip.cue":`No IP range is specified and users from any IP address are allowed to log in.`,
"label.step1.select.tablayout":`Step 1 Choose Tab Layout`,
"mainpage.setup.chosecomponent.leastone":`You must select one component at least on the homepage.`,
"label.custom.quarter.name":`Custom Quarter Name`,
"chatter.ptup.link":`Post a link`,
"label.compact.layout.frame.error2":`Detailed information and related list must be on the left screen`,
"vue_label_salesfunnel_notice7":`Number of opportunities with a probability of 100%/Number of opportunities with a probability of 0% or 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`The length of the title is &nbsp;{0}&nbsp;, but the length of the data is &nbsp;{1}&nbsp;, the system cannot determine which &nbsp;{2}&nbsp; fields are redundant.`,
"label.owner.notnull":`The owner cannot be empty`,
"label.logintime.pagecue.invalidt":`Start time cannot be greater than end time.`,
"vue_label_file_checked_num_limit":`The number of selected files exceeds the limit`,
"front-email-payment-repayments":`Pay Again`,
"template.report.today.prospects":`Leads of Today`,
"label.weixin.appr.status":`Status`,
"label.knowledge.language.japanese":`Japanese`,
"label.event.reminder.lead.time":`Reminder`,
"lable.custom.dep":`Click the New button to define a new custom year.`,
"Dashboard_View_Createdbyme":`Dashboards I Created`,
"label.file.upload.fail":`Upload file failed`,
"label.manager":`Manager`,
"label.stdashbord.xsld.business.jine":`Amount`,
"label.tag.manage.tag":`Tag`,
"chatter.nlk":`Unlike`,
"label.file.search.people":`Search people`,
"message.error.domain.format":`Domain names can only consist of English and arrays`,
"label.firstisdefault":`Use first value as default value`,
"label.discount":`Discount`,
"label.mobile.phone.have.read":`Revised`,
"label.field_selected":`This field has been selected`,
"label.payment.renew.now":`Renew Now`,
"label.multilang.lookfiltercondition.notsetup":`The {0} line condition is incorrect, no operator is set!`,
"label.projectManagement.Selectionday":`Select Day`,
"label.user.organization.permit.licensenotstart":`Your organization's license has not been activated, please try again after the license is enabled`,
"label.download.save.attachment":`Download and save to attachment`,
"lable.outlook.mcto.must":`Must be in email format.`,
"vue_label_notice_unfollow_success":`Unfollow successfully`,
"label.taskinfo":`Step 2 Configure Task`,
"label.other.SMS":`Other Phone Numbers`,
"label_partner_workspace_login_logo":`Header logo`,
"label.weixin.data.lock":`The record is locked.`,
"label.Yaxis":`Y-Axis`,
"lable.edit.queue.selobjdes":`Select the objects you want to assign to this queue. Individual records for those objects can then be owned by this queue.`,
"label.campagin.roi.dcfezb":`Attendance Rate`,
"label.marketseamemset.maximum":`Maximum`,
"label.owner":`Owner`,
"label.reportsubscribe.error.noview":`Please fill out which user you want to run this report as in "Running as"`,
"label.icon.133":`Folder`,
"vue_label_file_share_files":`shared documents`,
"label.searchlayoutfilterfields.remark":`Select the filter field columns to dispay during homepage sidebar searching and tab home page searching.`,
"vue_label_help_contract":`Contract & Collection Plan`,
"component.chatter.button.message":`Comment`,
"label.marketsea.recyclereminddays2":`Day reminder (must be less than the number of days without follow-up after obtaining)`,
"label.webtocloudcc.input.information":`The information is required.`,
"vue_label_chatter_exit_group":`Leave the group`,
"vue_label_lead_notcreatetask":`Do not create task`,
"front-lightning-module-v1-dashborad-date-dimension":`Date Dimension`,
"setup.layout.label.fieldlist":`Available Fields`,
"label.leadscore.charname":`Field Name`,
"label.forecast.customforecast.mybest":`My Best Case`,
"setup_mainpage_label_welcome24":`The CloudCC cloud platform provides security access settings for all object data in the system. Data sharing and access rights can be controlled by setting various rules and conditions.`,
"label.queue":`Queues`,
"label.icon.159":`Chip`,
"label.path":`Path to reference`,
"label.app.message.failtoget":`Failed to get application list`,
"label.returntoprocess":`Back to List: Approval Processes`,
"vue_label_commonobjects_detail_more_data":`No more data`,
"label.number":`Number`,
"label.product.find":`Find Price Books`,
"label.legend":`Legend`,
"label.partner.workspace.member.profile":`Available profiles`,
"label.service.gantt.sum.appointments":`Completed service appointments/All service appointments`,
"label.partnerCloud.financeSetting.paymentAllowed":`Allowing Online Topup`,
"label.integrations.upgrate":`Upgrade`,
"label.timzone.tip.info3":`When you use the calendar class to process dates, you should set the time zone for the calender instance, and you can select either of the following two methods to get the calendar objects: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Add email account`,
"label.partneruser":`Partner User`,
"label.validate.globalvariable.user.roleId":`Role ID`,
"pagecreator.layout.button.mergecell":`Merge cells`,
"label.evacuantvalue":`Exclude Values`,
"label.setup.mini.msg":`Brand Story/Message Setup`,
"label.icon.178":`People`,
"vue_label_pricebook_notice_cantbedeleted":`Price list entries cannot be deleted because there are already records applied to the price list. You can mark price list entries as inactive instead.`,
"vue_label_appstore_application_recommendation":`Hot Apps`,
"label.version.createlimit":`Your current CloudCC edition is {0}, and you can create {1} {2}. Now, the number of {2} is exceeded the maximum of your plan of subscription, please update your CloudCC edition.`,
"message.duplication.label.sectionremar1":`Select the values that you want to retain in the merged record. Highlighted rows indicate fields that contain conflicting data. The Master Record selected will retain read-only and hidden field values.`,
"label.icon.1":`Cloud`,
"label.salescloud.salesdashboard.sales.performance":`Overall-Sales Contract Results`,
"System_AddressFieldType_Post":`Zip Code`,
"setup_object_field_dependency_label_mustone":`You must select 1 value of the dependent field at least.`,
"label.appointmentdetail.wizard.title6":`Location`,
"label.layout.testobj2":`Test Object 2`,
"label.searchlayout.dupcacher.field":`Click the Find Duplicates and Merge link to view the duplicate fields.`,
"label.attendance.persons.title":`Suitable Users`,
"template.report.product.sales":`Products Sales`,
"label.editCustomReportType":`Custom Report Data Source Edit`,
"label.multilang.ui.setup.profile.alltime":`All times are {0}`,
"label.service.dispatchingUnits.noservice.booking":`No service appointment`,
"label.validate.remark4":`Ensure that the number is within a specific range, such as the discount less than 30%`,
"front-kefu-moudle-v1-Waiting-time":`Waiting Time:`,
"label.weipagelayout.remark":`Used in the mobile app or WeChat page`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Please enter the password for {user}, and make sure it contains at least`,
"message.error.user.data.null":`User information cannot be empty!`,
"chatter.like.p":`Like this post`,
"label.page.double.column.style.cloudcc":`2 column style provides useful CloudCC.com functions, like Search and Recent Items, on the same page as your embedded content.`,
"label.h5.iscloseaccount":`Are you sure you want to log out?`,
"label.dataimport.insertdata.id.error":`Format error, please use a combination of letters and numbers.`,
"label_tabpage_sum":`Total`,
"front-epwechat-module-v1-addressbook-sync":`Sync Contact Book`,
"label.setup.mobile.offlinecache.mostsave":`Platform can set the default enabled mobile side offline tab up to 10`,
"label.weixin.quickcreate":`Quick Create`,
"label.forecast.edittotal.de.mubiao":`Quota`,
"label.icon.144":`Guarantee`,
"label.icon.155":`Image`,
"label.In.the.search":`Searching`,
"message.validation.isnotdateISO":`Invalid Date (ISO)`,
"label.service.appointmentList.send.successfully":`Dispatch Successfully`,
"label.dynamicpage.error.exist":`Dynamic page layout data does not exist`,
"vue_label_SMS_otherpeople":`and {0} others`,
"label.cloudccsite.url":`Site URL`,
"label.tabpage.contactsz":`Contacts`,
"vue_label_commonobject_notice_clickthename":`If you need to download the uploaded file, please click the file name`,
"vue_label_file_new_lib":`New File Library`,
"label.chatter.card":`Card`,
"chatter.feed.menutype.user.allusercom":`All Colleagues`,
"label.exchange.sync2":`Settings`,
"template.report.year.income":`Revenue of This Year`,
"label.partner.template.detail":`Function Description`,
"label.setup.service.template":`Service Report Template`,
"label.dataimport.insertdata.id.length":`Format error,please check this record and modify it. Please note that the length less than 20 characters.`,
"label.partnerCloud.financeSetting.collaborator":`Cooperator ID`,
"label.processskipwizard":`Approval Process Jump Start Wizard`,
"label.weixin.inputbusnumber":`Please enter the license plate number`,
"label.dashboardSetup.d1":`Breakpoint 1`,
"template.report.conversions.number.industry":`Number of Leads Conversions (By Industry)`,
"vue_label_chat_group_chat":`group chat`,
"label.file.publicview.error":`The file is deleted or is not exist or can not preview`,
"label.customfields.location.locationHelpText":`Please enter a location name,such as “headquarter".please be descriptive and specific,and keep in mind that a record may have multiple locations such as "west coast sales office" and "east coast sales office".`,
"message.duplication.label.blankmatchtip":`Set the field blank to match, the default is False`,
"message.appexchange.addtopackage":`Choose one or more components to add to this package!`,
"label.ems.return2query":`Return to the query page of added email accounts`,
"label_model_name":`Model Name`,
"label.apiname.retainapi":`Name is the system reserved name,please use a different field API name.`,
"lable.Cancel.the.search":`Cancel Search`,
"label.custom.viewport":`Viewpoint`,
"label.weixin.polls.type":`Type`,
"label.opportunity.setting.showstage.label":`Auto promotion`,
"label_component_helper_businesschange_expiredtask":`Opportunities with Overdue Tasks`,
"label.operator":`Operator`,
"label.ccpeak.use.class.time.listmap":`Access by passing in the List<Map> collection`,
"component_timeline_label_past":`Past activities`,
"label.mobile.phone.submit":`Submitted By Me`,
"message.recordtype.new.subtip":`Enter a name and description for the new record type. The new record type will include all the picklist values from the existing record type selected below. After saving the new record type, you will be able to customize the picklist values.`,
"UG_product_05":`Import product`,
"label.validate.globalvariable.user.id":`User ID`,
"label.umeng.activity.distribute":`you assign to`,
"label.weixin.avote":`Vote`,
"label.weixin.already.sign":`Already signed in.`,
"label.emailmerge.mergepage.generator":`Generate`,
"label.batchtransfer.transferto":`Transfer to`,
"label.tianyancha.industry":`Industry`,
"label.addattachment.name":`File Name`,
"label.customfields.formula.date.tip":`To calculate a date, for example, add days to other dates or subtract days from other dates.`,
"label.partnerCloud.orderingPlatform.noPayment":`Not to Pay`,
"label.emailobject.failedtosend":`Failed to send`,
"label.knowledge.setting.data.three":`A maximum of {count} data of category groups can be selected.`,
"label.weixin.input.maxlength.langtext":`Please enter here, up to 32000 characters`,
"vue_label_calendar_delete_calendar":`Delete Calendar`,
"vue_label_commonobjects_detail_filter":`Collapse filter`,
"setup.layout.group.custompage":`Customize Page`,
"component_sendmail_label_subject":`Theme`,
"label_tabpage_maxfilez":`The maximum file size is`,
"label.logintime.pagecue":`Select the date and time that users with this profile can log in. Note that the exact time of the specified time zone is used for all times. Even if the user is in different time zones, these exact times are used for login time.`,
"label.salescloud.salesdashboard.datetime":`Close Date`,
"label.format":`Format`,
"label.newfoundland.daylight.time":`Newfoundland Daylight Time`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Copy and paste merge field value into the SMS content`,
"message.chooseatleastoneforshare":`Please select at least one user to share`,
"label.multilang.datamanage.importobjfield":`Column {0}`,
"label.denglu":`Login`,
"label.popup.infoz":`Prompt`,
"label.schedulejob.setup.schedule.onday":`On every month`,
"label.appointmentdetail.wizard.title16":`Wednesday Plan`,
"label.userphoto.dragtoadjust":`Drag to adjust thumbnail`,
"label.product.series":`Product Family`,
"message.view.kanban.not.set.group.summary.field":`The view dashboard does not set the group summary field`,
"page.un.activities":`Not Started Activities`,
"label.exchange.sync3":`Configurations`,
"label.login.activityExpired":`The user active period has expired, please contact the system administrator.`,
"component_chatter_file_button_files":`Select File`,
"message.onlydelete.type":`You can delete the inactive record types only. So you can disable the record types first if you want to delete them.`,
"message.recordtype.selectlayouttouse":`Page Layout to Use`,
"label.knowledgebase.unable.restore.draft":`You cannot recover deleted drafts.`,
"label.shangqing.name":`Business Information`,
"label.weixin.target.payment":`Target Payment`,
"label.chatter.sendEmailToGroupMember.check":`View Posts`,
"front-kefu-moudle-v1-input-single-login-area":`Please enter the single signon domain name`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Hair Dryer`,
"label.quickbooks.fieldlabel.company":`Company`,
"vue_label_email_are_you_sure_to_delete":`Are you sure to delete the mail?`,
"Pagelayout.Setup.005":`Name has to be put on the first place.`,
"label.object.name.two":`Object Name 2`,
"label.tabpage.completez":`Mark the selected status to complete`,
"label.setup.mobile.bottombutton.saveerror":`Failed to save first-level page settings`,
"label.report.action.addtodashboard8":`Select Dashboard Folder`,
"label.data.downpage.i_list.desc3":`Users can view the reason of the import failed in the last column of the file after downloads.`,
"label.layout":`Layout`,
"label.marketsea.button.assign":`Assign`,
"UG.solution.03":`Create a solution`,
"label.ccchat.person.invited":`Invite colleagues`,
"label.ccchat.person.invite.address":`Recipient`,
"label.displaytype1":`Detail Page Link`,
"label.tianyancha.h5.ziranrengudong":`Natural person shareholder`,
"lable.SalesCommitmentKanBan.targetReceipts":`Target Receipts`,
"message.error.getitems.type":`getItems:type cannot be empty`,
"label.addattachment.list":`The following files have been uploaded`,
"label.datamanage.export.false":`An error occurred while exporting.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Button text`,
"label.emailtocloudcc.redmessage1":`Invalid email address`,
"label.weixin.polls.closed":`The vote is closed, deadline is`,
"label.icon.165":`Hat`,
"vue_label_report_detailsonly":`Details Only`,
"component.salesperformance.label.100finish":`Ended`,
"november":`November`,
"label.data.file.generatejwd":`Generating the latitude and longitude service according to the address`,
"label.salescloud.opportunity.access":`Opportunities Access`,
"label.isremider.remider":`Reminder`,
"vue_label_total":`Total`,
"label.email.prompt.using.lightning.link":`Set the email link in system notifications to be in consistent with Lightning links.`,
"label.knowledgebase.cancel.attached.articles":`Cancle Attached Article`,
"label.version.custom.xslc":`Customizable sales process`,
"component_setup_button_save":`Save`,
"label.ems.cc":`Cc`,
"label.edit.user":`Users Edit`,
"label.emailtocloudcc.select2":`Please choose type`,
"label.industrialandcommercialverification.fieldnumber":`No. of Mapped Fields:4`,
"label.ccchat.havenot.joined.group":`You are not in any active groups`,
"pagecreator_page_label_pagename":`Page name`,
"setup.layout.button.save":`Save`,
"label.campaignmember.main.updatestatus":`Batch Update Campaign Members Status`,
"label.tab.web.edit":`Web Tab Edit`,
"label.ring_chart":`Doughnut Chart`,
"label.usermanage.resetpwd.error":`Password reset failed and the user does not exist.`,
"label.Xaxisscope":`X-Axis Scope`,
"label.app.new":`New Custom App`,
"message.modifythereport":`The dashboard uses this report. Changes may invalidate the dashboard that references this report.`,
"label.component.helper.businesschange.0activity":`30 days without any activity`,
"label.weixin.fmu.noon":`{0} PM`,
"label.enter.rule.name":`Enter the name of rules`,
"lable.Confirm.recovery.potential.customers":`Confirm to recover lead {name}.`,
"lable.PowerProcess.type.created":`What type of entitlement process do you want to create?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Orthogon Size`,
"label.projectManagement.new.service.appointment":`New service appointment`,
"label.multilang.totalpage2":`A total of`,
"pagecreator.systemstyle.label.styledesc":`Style description`,
"chatter.up":`Uploading`,
"2018UI_Homepage_DataDeleted_Info":`The data you want to view has been deleted, please click to return to previous step.`,
"label.knowledge.draft.recordid":`Draft ID cannot be null!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`View all integration`,
"vue_label_file_num_limit_tip":`The number of files exceeds the preset number. If you need to replace files, please delete the uploaded files first`,
"vue_label_commonobjects_view_refreshat":`Refreshed at {timeInterval} ago`,
"laebe.data.exp.save.success":`If you need to use this template to export data, please return to the "Export By Template" to operate.`,
"label.mr.caption.contact":`Find Duplicates and Merge: Coditions for querying duplicates of Contacts`,
"label.webtocloudcc.submit.error":`Submission failure`,
"label.multilang.datadelete.delmessage":`Locked records ({0}) are not allowed to delete:`,
"label.quickbooks.searchlist.total2":`There are {0} unlinked payments for a total value of {1}`,
"label.createnew":`Create New...`,
"component.milestones.label.choicestate":`Confirm this status`,
"lable.outlook.edit.exist":`This field name already exists. Enter a unique field name.`,
"vue_label_dashboard_eachother":`Only views from the same report or the same list view can interact with each other`,
"label.new.role":`New Role`,
"message.error.operationType":`The operation is not defined when calling a service.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Please select the recipients to send`,
"label.attendance.thanks":`Thanks for your participation!`,
"label.invoice.message.statusupdatefailed":`Invoice status update failed, please try again later.`,
"template.chart.yzhqzkhlyfx":`Source Analysis of Converted Lead`,
"chatter.feed.menutype.user.alluser":`All Colleagues`,
"UG_Forcast_04":`Start trial`,
"label.appupload.upload.tips.profile":`Note: the "profile" component has been added to this package and cannot be added again (up to one profile component per package is allowed to add).`,
"lable.PowerProcess.leave.the.process":`{describeName} Exit Process`,
"template.report.sales.cycle.opportunities":`Sales Cycle Duration (By Opportunity Type)`,
"vue_label_calendar_please_fill_in_the_calendar":`Please fill in the calendar name`,
"label.salescloud.unit.wanyuan":`unit ( Chinese Yuan)`,
"label.fileAPI":`Document Unique Name`,
"label.weixin.link":`Related To`,
"label.service.seconds":`secs`,
"label.encd.visible":`Encrypted field visible`,
"label.tianyancha.regstatus":`Operating status`,
"label.event.moveup.18hour":`18 hours ahead`,
"label.upper.bound":`Upper Bound`,
"label.please.insertURL":`Please enter the URL to be inserted.`,
"label.approval.notallowed.reject":`Rejection Not Allowed`,
"label.permission.fieldpermission":`Field Permission Settings`,
"label.customcomponent.page.index.title":`Custom Components`,
"label.quickbooks.viewlist.number":`NO.`,
"lable.list.queue.sendemail":`Email Members`,
"label.productsales.today.noevtadd":`There are no open events, you can click “ ” in the upper right corner to add new event.`,
"label.report.line.daixuan":`Pending report column`,
"label.reportsSubscription.select.start.endtime":`Please select start time and end time!`,
"template.chart.schdyscb":`Budgeted Cost of Campaigns`,
"label.sendemail.chat.addPostatsubject":`I was mentioned in the CloudCC CCChat post`,
"label.RelatedList":`Related Lists`,
"label.knowledgebase.delete.translation.associated.with.draft":`Existing draft translation will be linked to the last published version of master language article . If no published version exists, all translations will be deleted.`,
"vue_label_chatter_submitted_review":`You have submitted an application to join, please wait for the administrator to review`,
"label.layout.list2":`List 2`,
"label.manage.area":`Manage Territories`,
"label.manageapproveprocess":`Manage Approval Processes For`,
"workflow.action.tasks.assignortype.created":`Created By`,
"label.custombutton.nonsupport.operation":`The current version does not support the operation of standard buttons and links.`,
"label.ip":`IP Address`,
"label.chat.topic.desc.error.info":`Theme description cannot exceed 1000 characters. Try using a shorter topic description.`,
"label_tabpage_cue":`Information reminder`,
"label.integrations.mailchimp1":`By integrating CloudCC with Mailchimp, your users will be able to import selected leads and contacts from your CloudCC account to Mailchimp.`,
"label.email.track.required":`Required Information`,
"label.set.case":`Please set the case owner first.`,
"label.weixin.newspaper.coverage.number":`Risk Sheet Number`,
"vue_label_approve_submitreason":`Reason for submission`,
"message.oppdt.noenabledpricebook":`No Active Price Books`,
"label.partner.workspace.setup":`Settings`,
"label.version.nonsupport.feature":`This feature is not supported temporarily.If necessary,please upgrade CloudCC version.`,
"com.cloudcc.login.error.message.licenseexpired":`The license has expired`,
"label.emailsync.form.signin":`Login`,
"label.campaign.channel.input.to.chooselanguage":`Please select a language`,
"label.tabpage.gotit":`Got it`,
"front-console-no-contact-tip":`No data. Please contact relevant person and view.`,
"label.approval.apiname":`The unique name used by API and Managed packages must begin with letter, and use alphanumeric characters and underscores only. Names can not end with an underscore or have two consecutive underscores.`,
"label_emailtocloudcc_filed_ssl":`Secure Connection`,
"component_sendmail_label_fromuser":`Sender`,
"front-kefu-moudle-v1-new-online-chats":`New Online Agent`,
"label.searchlayout.merge.duplicated.results":`Enable to find duplicates and merge`,
"label.weixin.input.maxlength.remark":`Please enter here, up to 500 characters`,
"component.telerecord.label.related":`Related items`,
"label.note":`Notes`,
"message.duplication.label.nletters":`characters`,
"label.productsales.payment.phb":`Payment List`,
"label.forecast.editshrepage.desc":`Forecast:Specify the sharing of this record. You can share this record and related data with a user, the users in a particular role, or the users in a particular role plus all of the users in roles below that role.`,
"vue.dashboard.setPenetrationSuccessful":`Successfully set up penetration!`,
"label.tabpage.noOperationz":`This content is a fixed item and cannot be operated!`,
"label.email.jump":`Redirecting to a third-party web site...`,
"label.appointmentpage.wizard.btn1":`Confirm Booking`,
"label.umeng.approval.pass":`#approver has approved your approval request #obj.`,
"label.project.hit.twelve":`Milestone Expiration Reminder`,
"two":`Two`,
"label.approvedinfo":`Approval Information`,
"label.import.step1.choosecsv":`Please select csv file`,
"vue.please.select.the.expansion.method":`Please select expanding way.`,
"UG.homepage.005":`Sales intelligence`,
"Account.News.Setting.003":`General Settings`,
"label.quickbooks.button.actions":`Actions`,
"lable.list.queue.email":`Queue Email`,
"label.name.lastname":`Last Name`,
"message.confirm":`Are you sure?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Close Date of Current Stage`,
"label.knowledge.setting.title":`Knowledge Settings`,
"label.helptocreateprocess":`To Create a new approval process, click "Create New Approval Process" then select "Use Jump Start Wizard" to set up your approval process in a few short steps. Or, select "Use Standard Wizard" to configure all approval options.`,
"label.batcheditor.remark":`Multiple records can be edited.`,
"label.page":`Page`,
"label.newfolder":`Create New Folder`,
"label.version.interceptor.api":`Interface API`,
"label.sms.toaddress":`received an SMS`,
"front-kefu-moudle-noopen-callcenter":`The organization has not activated the call center function, please contact the administrator`,
"label.data.exp.zip":`Compressed Format`,
"lable.account.LastcDays":`Last 60 Days`,
"label.import.index.starttime":`Start Time`,
"label.dashboardall":`All Dashboards`,
"label.create_socialpost":`New Post`,
"label.searchlayoutedit.remark":`Select the fields and buttons displayed when you click sidebar search on homepage or click tab search.`,
"message.servicecrew.violation":`Violation of resources allocation: service resources are team members in this period.`,
"label.email.attrach.file":`Attachment`,
"report.label.folderandreport":`Reports and Folders`,
"label.list.userinterface.sales.setup":`Sales Homepage Setup`,
"label.martrixreport.2018.step1":`Step 1 Create a grouping`,
"label.campaignmember.selectmember.memberstatus":`Campaign Member Status`,
"label.textmessage.vonage.api.key":`API Key`,
"label.tabpage.next":`Next Step`,
"UG_Lead_006":`Website visitor`,
"label.salescloud.salesdashboard.visit.rankings":`Visit Rankings`,
"label.myevent":`My Events`,
"label.activity.history":`History`,
"label_tabpage_kanban":`Viewboard setup`,
"label.weixin.allapp":`All Apps`,
"label.query.clone.detail.choose.choosed":`Selected Line Items`,
"message.error.view.errvalid":`Error: The view unique name field can only contain underscores and alphanumeric characters. It must be unique, begins with a letter, excludes spaces, cannot end with an underscore, and cannot contain two consecutive underscores.`,
"label.customfields.searchrelation.dependobject.tip":`Select another object associated with this object`,
"label.appointment.wizard.subtitle4-4-3":`3 weeks`,
"label.setup.mobile.offlinecache.saveerror":`Mobile offline cache setting does not saved.`,
"label.planned.started":`Started`,
"label.page.step4.of.step5":`Step 4 of 5`,
"label.tabpage.value":`Value`,
"label.reportlist.allfolder":`All Folders`,
"label.callcenter.sure.disable.center":`Are you sure to deactivate the current call center?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Go to Calendar`,
"label.setup.mobile.bottombutton.recovery.default":`Restore Default`,
"label.appointmentdetail.wizard.title15":`Tuesday Plan`,
"label.icon.15":`Repair Order`,
"component_sendmail_label_touser":`To`,
"template.report.all.owner":`Owner of Leads`,
"front-Partner-email-tips":`Please enter email for the username`,
"vue_label_systemSettings_mobelhomepagesetting":`Mobile App Homepage Setup`,
"label.service.newBuildDialog.aswellas":`and`,
"label.name":`Name`,
"label.tag.search.taglist":`Tag List`,
"label.partnerCloud.priceOfManual.theOnly":`It it recommended to set up the only price book for each partner user. Or they nned to choose one from multiple price books while ordering. Standard price book is applied if no specifi price book was set.`,
"label.knowledge.field.update":`{1} is changed from {2} to {3}`,
"label.emailobject.save":`Save`,
"label.top.changeVersion":`Horizontal`,
"label.recordtype.edit.unselected":`Existing Values`,
"label.knowledgebase.additional.articles":`Attach Article`,
"label.lead.score.confirm":`Please select the range of scoring, click[Lead Scoring] button, and the system will score the selected leads according to the active Lead Scoring Rule.<br><br>This can take several minutes. You will receive a confirmation email once completed.<br><br>`,
"label.projectManagement.pleaseselectadate":`Please select date`,
"label.appointment.wizard.subtitle5":`Meeting name`,
"label_setup_failed":`Setup failed`,
"label.chatter.collect":`Bookmark`,
"label.appointment.cancelappointment":`Cancel`,
"front-console-response":`Response Time`,
"message.delete":`Are you sure you want to delete?`,
"label.dataimport.type.selected":`Select Importing Type`,
"label.new.target":`New Target`,
"vue_label_report_autoupdatepreview":`Auto-update Preview`,
"label.knowledgebase.guidance":`Guidance`,
"label.chatter.mail":`Mail`,
"label.login.verification.scan.code.acquisition":`Scan code to get:`,
"label.customsetting.changefieldtype":`Change Field Type`,
"label.data.dataexpalltype.all_desc2":`2. It takes some time to export all data. When the export is complete, you will receive a reminder email that the data export was successful.`,
"label.opportunity.contactisnull":`No customer information, cannot display.`,
"pagecreator_layout_button_upload":`Upload layout`,
"label.dashboard.noRecord":`No Records`,
"label.SMS.template":`SMS Template Name`,
"label.c.d.without":`C records may or may not have related "D" records.`,
"UG.Case.05":`Create a case`,
"front-epwechat-module-v1-edit-selfapp":`Edit Seflcreated App`,
"label.role.createrole.tip":`You can build on the existing role hierarchy shown on this page. To insert a new role, click <b> Add Role</b>.`,
"label.grouping":`Group By`,
"vue_label_email_upload_new_file":`Upload new file`,
"label.notification.event3":`Your event 【事件名】 starts at 【开始时间】`,
"labe_benchmark_objects":`Reference Object`,
"component.chatter.button.collect":`Bookmark`,
"front-QBtoCC-sinchronies":`Synchronizing...`,
"message.submitpage.sms":`Congratulations. SMS sent successfully.`,
"label.imgfield.width":`Width`,
"label.send_email":`Send submission email notifications to`,
"label.queue.list":`Queue List`,
"label.tabpage.fieldoptions":`Record type field, option list field, and option list (multiple choice) field. it is recommended to enter at most 10 keywords, separated by commas to achieve “or relationship”, such as: "New York, Toronto, Tokyo".`,
"component.chatter.post.button.save":`Publish`,
"chatter.group.groupDescriptionInformation":`Group Description`,
"label_setup_mobilesetup_isenableh5newandedit":`Enable new and edit of H5 in your mobile app.`,
"lable.Confirm.recallpotential.customers":`Confirm to recycle {num} leads.`,
"label.knowledge.setting.hint.seven":`Select a name from the following and grant write access to contribute your efforts.`,
"label.emailtocloudcc.redmessage2":`Please input correct email password`,
"message.validation.equalTo":`Enter the same values.`,
"vue_label_help_golbal":`Global Navigation`,
"vue_label_chatter_delete_group_title":`Delete group`,
"label.user.login.success":`Login Success`,
"label.chatham.standard.time":`Chatham Standard Time`,
"label.vlidaterule.example.percent":`Discount percent cannot exceed 30%`,
"label.group.field":`Specify grouping field`,
"label.trigger.operation.sharetab":`Trigger Actions Shared Form:`,
"label.mobile.phone.write.month.report":`Monthly Work Notes`,
"label.statusofconvers":`Converted Status`,
"label.version.emailtemplate.track":`Email Template`,
"label.customobjects.onlytrackforupdate":`Track changes only`,
"label_tabpage_enterviewname":`Step 1 please enter the view name`,
"label.processsetting.three.enable":`Step 3: Activate`,
"label.service.show.more.info":`Show More Info`,
"front-epwechat-module-v1-input-iosschema":`Please enter iOS schema`,
"label.dataimport.datatype.error":`Data type error, please carefully check whether the data and title match one by one.`,
"label.staticresource":`Static Resource`,
"label.weixin.customize":`Customize`,
"label.product.edit.sel":`Edit Selected`,
"label.appointmentpage.wizard.notif5":`Invalid phone format`,
"label.marketsea.basicsetup":`Basic Settings`,
"label.workflow.supplyintruduce":`1.Criteria that cause the workflow rule to run.<br/> 2.Immediate actions that execute when a record matches the criteria. For example, CloudCC can automatically send an email that notifies the account team when a new opportunity is created.<br/>3.Time-dependent actions that queue when a record matches the criteria, and execute according to time triggers.`,
"label_report_line_tuozhuai":`Please drag and drop, or double click to select the report column and adjust their orders`,
"label.add.new.rule":`Add Generation Rules`,
"label.marketing.setting2":`Setting`,
"vue_label_chatter_delete_some_group":`Are you sure you want to delete the group "{groupInfoList}"`,
"label.appupload.uploading.wait":`Please wait`,
"label.linecondition.error":`Row condition error, field type mismatch!`,
"chatter.group.request":`Request`,
"label.recordtype.tabname.remark":`Use this page to create and maintain record types for your organization. You can display different page layouts and picklist values based on record types. To use record types, add the Record Type field to your page layouts.`,
"setup_mainpage_label_welcome4":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Object.`,
"vue_label_salesadvance":`Advance Sales Stage`,
"vue_label_campaign_of_existing_campaign_members":`Please set the status of existing campaign members`,
"label.report.object.detail.no.permission":`The report type is changed or moved. Please contact the administrator for help.`,
"label.weixin.untreated":`Open`,
"label.service.miniProgram.bindSetOwnerDesc":`A case record can be generated in the system for a repair order submitted on the mini program.  Please select a user as the creator of the case record. This user must have the creation authority to create records in case object. And after changing the creator, log in to the mini program again and submit the report request to take effect.`,
"label.autoassigntoapprover":`Auto-assign to approver(s)`,
"label.marketseamemset.containself":`Contains self-built records`,
"vue_label_report_drill":`Drill`,
"label.order.products.to.assets":`Convert Order Product to Asset`,
"label.recordtype.list":`Existing Record Type`,
"lable.outlook.detail.conflict":`Conflict Behavior`,
"pagecreator.page.label.layoutpreview":`Layout preview`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`Agent chatting is supported by Easemob. Please purchase Easemob account first.`,
"label.convers":`Convert`,
"serviceappointment.worktype.isnot.father.worktype":`The work type associated with its parent record must be selected for this service appointment.`,
"lable.tianyancha.h5.relatedcom":`Relavant companies`,
"label.reportsSubscriptionPage.schedulereport":`Schedule Report`,
"label.workbanch.setup.showinworkbanch":`Display on my workbanch`,
"label_emailsync_connectaccount":`Connect Email Account`,
"label.usermanage.license.not.qualified":`The system detected that this is a non-compliance license, please contact the vendor to get licensed again!`,
"component_setup_label_displayfield":`Field Display`,
"setup_layout_label_buttonarea":`Button Area`,
"label.weixin.input.content":`Please enter the content`,
"label.operatedata.importsuc":`Successful import, you can check the import result by clicking the tab of object.`,
"label_tabpage_yes1z":`Yes1`,
"front-electronic-signature-describe":`Access to Esignature, sign a contract anywhere and anytime. Sign with one click, secure and efficient!`,
"label.event.this.month":`This Month`,
"label.document.replaces":`Replace`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Feed Tracking`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Please add chart`,
"label.cpq.main.quote.transfer.order":`Only the primary quotation can generate orders.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Top up successfully`,
"label.appexchange.uninstallpage.uninstall":`Uninstall`,
"label.campagin.roi.channel":`Channels`,
"label.multilang.versioncontrol.checkversion":`Your current CloudCC version is {0} which allows you to create {1} {2} that have reached the limit! If necessary, please upgrade the CloudCC version!`,
"label.emailobject.my.template":`My Templates Only`,
"label.edittimetrigger":`Time Trigger Edit`,
"label.setup.mobile.homepageshortcuts.saveerror":`The mobile homepage swift function settings is not saved.`,
"label.address.street":`Street`,
"label.workflow.estimatecondition2":`created`,
"label.wei.expiresdate":`Expire Date`,
"label.quickbooks.viewlist.date":`DATE`,
"label.page.select.field.type":`Select Field Type`,
"label.tabpage.mypotentialcustomers":`My leads`,
"label.file.library.editlib":`Edit Libray Details`,
"label.weixin.message.operateexception":`Prompt`,
"label.visualpage.staticresource.p1":`1.Call method.Refference selected static resources by referencing static resource buttons`,
"label.icon.175":`Air Tickets`,
"chatter.edit.r":`Write a comment...`,
"label.examinationandapproval.flow":`Approval Processes`,
"label.mr.descreption.reDataList5":`sets of data.`,
"label.edit.field.select.showstyle":`Display Style`,
"label.reportsSubscriptionPage.condition.and":`AND`,
"label.please.associations":`Please choose associated object.`,
"label.service.dispatchingUnits.displays.service.appointments":`Show service appointments that are not associated with a territory`,
"label.addcurrent":`Add Existing`,
"label.search.change":`Searchable Objects Setup`,
"message.schedulejob.error.modify":`Based on a configured schedule, the given job will never be triggered. Check the data and resubmit.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} published links for all in {1}`,
"label.weixin.micro.oldid":`Original ID of WeChat Official Account`,
"label.employees.only.invitation.code":`The system will generate a unique invitation code for employee, which can be used to make invitations and can be counted as individual performance. Please note that the lead owner will be the current marketing campaign owner or marketing channel inviter. You can reallocate the leads through the lead allocation rules. For alloacation rules`,
"lable.PowerProcess.event.msg":`You can add time-dependent workflow actions that occur at each step (milestone) in the entitlement process. For example, you can set up actions to send an email to the case owner one hour before a milestone expires, or to automatically update specific case fields when the first response to a milestone is completed.`,
"label.file.share.email.content2":`Premission: #sharerole`,
"label.querydetailservice.datalayout.notexist":`The corresponding layout of the record does not exist.`,
"label.group.items":`Group item`,
"label.istouse":`Available`,
"front-electronic-signature-explain":`Fadada Esignature Description:`,
"label.partner.template.thumbnail":`Thumbnail`,
"registration.page.selected.fields":`Required Fields on Registration Page`,
"label.reportTypeCategoryLabel":`Data Source`,
"vue_label_email_You_have_not_activated_the_mailbox":`You have not activate the mailbox`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Task Completion Rate`,
"label.forecast.detailforecast.program":`Forecast Items`,
"label.page.display":`Display`,
"label.passwordPolicy.setup.minute":`minutes`,
"label.emailtocloudcc.step1total3":`Step 1 of 3`,
"label.file.title":`Title`,
"label.callcenter.private.key":`Secret Key of Private Access`,
"com.cloudcc.login.error.message.loginerror":`Your id or your password is incorrect`,
"UG_Lead_004":`Web form`,
"label_tabpage_recordsz":`Record`,
"label.shangqing.discovery":`Business Information Discovery`,
"vue_label_notice_change_success":`Changed successfully`,
"label.ems.other":`Other`,
"loading":`Loading...`,
"label.committedtoapprove":`The Submitted Approval Requests`,
"label.category.4":`Financial`,
"template.report.folder.customer.situation":`Analysis of Accounts Situation`,
"label.quickbooks.searchresault.phone":`Phone`,
"label.ccpeak.ccobj.save":`To save CCObject to the database, the call method is`,
"label.knowledge.delete.linked":`Error while deleting associated article`,
"label.forecast.settings.future2":`Future 2 cycles`,
"message.error.displaytype.detail":`Display type can't be empty, Day: day, Month: month, Week: week, Availability: availability!`,
"front-template-V1-search-template-name":`Enter object name and find`,
"label.sendsms.batch.step3.introduce":`Store activities of each SMS`,
"UG.Forcast.08":`Previous step`,
"label.inputnameandintro":`Enter Name and Description`,
"label.redistributioned":`Reassigned`,
"label.service.dispatchingUnits.left.right.total":`{left}-{right} records , {totalCount} records in total.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Please enter actual working hours`,
"label.exporttemplate":`Export The Template`,
"label.data.downpage":`Data Download Page`,
"message.please.choose.contact":`Please select a contact`,
"message.error.dataformat.error":`Data format error`,
"label.customsetting.changefieldtype.losevalue":`Changing to the selected data type will cause all existing data in the field to be lost.`,
"label.sendemail.chat.chattype":`The type of main post:`,
"label.ccdocument.upload.error":`Error uploading document.`,
"label.quickbooks.view.all":`All`,
"label.data.downpage.e_title":`Data Export Steps`,
"lable.data.lock":`The data is locked, if you need to edit please unlock it firstly.`,
"label.locked":`Locked`,
"label.customfields.beforedeletedata":`In order to preserve a record of data for future reference, run a data export before deleting custom fields by clicking Setup | Data Management | Data Export.`,
"label.productsales.oppor.noapproach":`No opportunities with an expected contract date of less than 30 days`,
"label.input.notmore.than.number":`Please enter a number less than or equal to {0}`,
"label.list.userinterface.isenable":`Enable Inline Editing`,
"label.listofshare":`Share Information List`,
"label.emailsync.status.role":`Role`,
"label.staticresource.useful.realtion":`Where is this static resource used`,
"label.sharerule.tip":`This page displays sharing settings of your organization. These settings specify the access level to other users data.`,
"label.qrcodelogin.message.expired":`QR Code has expired`,
"label.marketing.setting3":`Marketing Channels Setting`,
"vue_label_statistical_field":`Statistical field`,
"message.view.addtomyhomepage":`Add To My Homepage Workbench`,
"label.customfields.percent.tip":`Allow users to enter a percentage number, for example, "10" and automatically adds the percent sign to the number.`,
"component_newrecords_label_10records":`10 records`,
"Lead_Scoring_Warning_001":`Score single lead record automatically when creating or editting. But you need manual scoring multiple lead records, when batch importing or creating by interface.`,
"label.project.planing":`Planned Work Hours VS Actual Work Hours of the Year`,
"label.data.exp.pwdverif":`Passwords are allowed only for letters and numbers.`,
"coderules.notEnable":`Please contact the administrator to activate the rules for generating QR code and bar code.`,
"label.weixin.wdyj.jxhk":`Personal-Sales Performance-Payments`,
"label.data.expnode.e_desc3":`3. Template Create: user can make the template according to the fields and conditions that will be exported to meet your needs, which is convenient to use next time.`,
"chatter.group.join":`Join`,
"vue_label_systemSettings_monitoring":`Monitor`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Are you sure to delete this folder?`,
"label.exchange.sync.state.info":`Check system status to ensure that records are synchronized between Exchange and CloudCC.`,
"lable.outlook.mcto.emaildes":`Enter all email addresses of leads and contacts you used to send email, and separated by commas. only email sent from the email address below can be added to the Activity History if the related records.`,
"label.ems.save":`Save`,
"vue_label_dashboard_maximumvalue":`Please enter the maximum value`,
"label.passwordPolicy.setup.norestriction":`No restriction`,
"label.multilang.customforcast.total":`Accumulation of {0}：`,
"label_partner_all_memo":`The list shows all partner clouds in your organization. Click URL to login.`,
"Account.News.Setting.002":`Use the account settings below to specify default account behavior for your organization.`,
"label.essential":`required`,
"label.nonotice":`No more reminders`,
"vue_label_calendar_calendar_deleted_successfully":`Calendar deleted successfully`,
"message.huanxinagent.disable":`Inactive Agent`,
"label.goto":`Jump to`,
"label.chat.topic.add.favorite":`Add to Bookmarked`,
"label.trigger.targetobj":`Target Object`,
"label.form_fields":`Form fields`,
"this.month":`This Month`,
"vue_label_homepage_select_view":`Select View`,
"label.weixin.input.subject":`Please fill in the subject`,
"label.ems.emailType":`Mailbox Type`,
"vue_label_file_safe_type_file":`Please confirm that the file does not contain sensitive information. Please consider sharing files with specific users or records`,
"label.version.case.automatic.upgrade":`Case Escalation and Assignment Rules`,
"label.input.invalid.credit.card.number":`Please enter the valid credit card number`,
"component_timeline_label_future":`Next Step`,
"label.emailtemplate.cannotsupporthtml":`HTML type not supported currently`,
"label.appupload.install.error.info2":`{1} '{0}' conflicts with existing components.`,
"label.custom.field.maping":`to this field.`,
"encd":`Encrypted Text(Display Encrypted)`,
"label.service.newBuildDialog.filter.logic":`Filter Logic`,
"label.customerinfo":`Company Profile`,
"vue_label_applauncher_notice_activepoolsuccess":`Successfully activated the lead pool`,
"label.partner.workspace.member.choicepermission":`Select permission set`,
"front-gantt-module-this-task-of-other-tasks":`This task exists as a subtask and cannot be a subtask of another task!`,
"label_chatter_publish":`Publish`,
"label.forecast.settings.mrfw":`Starting on`,
"label.Named.Filter":`Name the filter`,
"label.department.email":`Email Address`,
"label.updatingfield":`Field to Update`,
"label_partner_template_detail":`Function Description`,
"front-epwechat-module-v1-unbound-item":` binding of all enterprises`,
"vue_label_file_lib_name":`File Library Name`,
"label.notification.arketsea.distribution":`{5} assigned {2}{0}：{1} to you`,
"vue_label_norm_removecomponent":`remove component`,
"component.event.label.begindate":`*Start Time`,
"chatter.note":`comment(s) received`,
"label.forecast.settings.type.all":`Overall Forecast`,
"label.compact.layout.frame.full":`Fullscreen Display`,
"label.approvalstep3intro":`Using the options below, specify the user to whom the approval request should be assigned.`,
"label.notification.approval6":`【被委派人名称】approved the 【提交人】 is approval request of 【对象】【对象名称】for you.`,
"setup.object.field.dependency.label.actionfieldvalue":`Controlling Field`,
"label.multilang.page2":`Page`,
"vue_label_email_submitted":`Submitted`,
"label.Standard.button":`Standard Buttons`,
"vue_label_report_emailchoose":`Email Option`,
"page.field.masterinput.list":`Master-Detail Input Data List`,
"label.martrixdown":`Matrix Down`,
"vue_label_helpcenter_opportunity":`In the upper right corner of the view, click the sales funnel icon to jump to view the sales funnel.<br>Through the intuitive progress bar, track the progress of each business opportunity, and click the button to mark the completion of the current stage, or adjust the current stage. If you encounter obstacles in advancing business opportunities, you can also expand the progress bar to view the information and some warm tips that should be paid more attention to at the current stage.<br>Through the related list of the opportunity team, the opportunity data can be shared with other people who do not have access to view it, so as to facilitate collaborative work.<br>On the contact role related list under the business opportunity, quickly add the role in the opportunity to the contact in the corresponding customer, and then view the related contact’s superior and subordinate relation through the relationship network, and use the radar chart to evaluate the current contact The value of opportunities, follow up, locate key people, and check contacts. Role, visit status, relation degree, purchase style and visit times<br>Through the related list of opportunity products, you can add products in the same price list for the opportunity, and edit the price and quantity of the products.`,
"label.sso.ssoKeyMan":`Single Sign-On Key Management`,
"label.forecast.edit.desc":`Set a user's quota for the following period`,
"label.weixin.newspaper.coverage.time":`Risk Date`,
"label.pleaseselectpro":`Please select products`,
"label.bottonandlink":`Buttons and Links`,
"label.donot.know.error":`An unknown error occurred, please contact the administrator.`,
"label.account_noordab":`Your account has 0 custom reports and 2 dashboards.`,
"label.partnerCloud.orderingPlatform.toPay":`Pay by Partner Fund`,
"label.many.dayline.nextday":`Next Day`,
"lable.showmorerecords":`Show more`,
"front-lightning-module-v1-details-page-chart-record-type":`Please select record type`,
"label.ccpeak.query.record":`search for the records`,
"pagecreator.systemstyle.message.save.fail":`Style save failed`,
"label.weixin.share.file":`Share File`,
"errormessage.email.relatedorreceivermusthaveone.z":`You must select one recipient or a related subject at least.`,
"chatter.save.f":`Save Failed`,
"button.partner.create":`New`,
"label.marketseamemset.lead.title2":`Please set an upper limit on the number of leads that affect all members. The limit has nothing to do with the high seas pool`,
"label.service.major.event.new":`New Milestone`,
"label.version.custom.site":`Custom Site`,
"label.permission.visualpagepermission":`Assigned Custom Pages`,
"lable.product.zongjia":`Total Price`,
"label.viewchart":`View Charts`,
"label.alaska.daylight.time":`Alaska Daylight Time`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Let more user to become agents and serve visitors, enhance customer service.`,
"component_assistant_label_todaylead":`The leads assigned to you today`,
"label.sendemail.chat.addComentsfavorite":`Dear #name:\n\n ; hello! #userName replied to your bookmarked post.`,
"label.smstemplate.tip":`All SMS templates in the selected folder are listed below. Click the New" button to create a new text or HTML SMS template. You can use these SMS templates when sending messages. Click the role link to view more detailed information"`,
"label.documentname":`Document Name`,
"label.icon.162":`Landscape`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Record type field, picklist field and picklist ( multi-select) field, it is recommended to enter up to 10 keywords, separated by commas. Such as "New York, Toronto, Tokyo".`,
"label.searchlayout.lookup.newfield":`Lookup Dialogs that pop up when you click the new button on Lookup fields.`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`This is the first page.`,
"vue_label_appstore_crm_used_companies":`CRM used by listed companies`,
"label.document.replace":`Replace`,
"label.assignment.setup.newrule.title":`New Case Assignment Rule`,
"component.chatter.label.mygroup":`My group`,
"lable.currencyAdv.exchangedate":`Date Range`,
"label.quickbooks.button.viewinqb":`View In QuickBooks`,
"UG.homepage.004":`Automation`,
"label.currencyName":`Currency Name`,
"Homepage_News_001":`News`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Show Refresh Button`,
"label.list.projectSetting.isenable":`Enable project timer (Include: Milestone, task, sub-task, problem)`,
"setup.layout.message.relatedlistbutton":`Select standard buttons to display on the`,
"vue_label_homepage_homepageassignment":`Application Homepage Assignment`,
"label.pending":`Pending`,
"component.timeline.label.today":`Today`,
"front-kefu-moudle-free-hasexpire":`Your free trial has expired`,
"homepage.layout.customlayout":`Custom Homepage Layout`,
"label.service.miniProgram.content":`Please fill in the content.`,
"label.defaultline.must.int":`The default number of lines can only be positive integers.`,
"label.mirror_issues":`If the form doesn't mirror what you see on your side, please read our aticle on how to troubleshoot common display issues.`,
"label.edit.select.two":`Exclusive Choice List Box`,
"label.emailmerge.mergeFolder.tip":`Merge templates take some time, during merge, please do not click on other links, close your web browser or refresh the page.`,
"label.ServiceCloud.zichan.distributionMap":`Assets Distribution Map`,
"label.selectfile":`Select File`,
"vue_label_account_equitymanage":`Manage equity relation`,
"label.email.clearAll":`Clear All`,
"label.selecting.parent.assets":`Choose Parent Asset`,
"component.setup.tabs.label.delete":`Delete`,
"label.visualpage.top.must.is":`The first line of the oage header must be:`,
"label.SalesCommitmentDashboard":`Sales Commit Dashboards`,
"chatter.group.changeTheRole":`Change The Role`,
"label.dataimport.insertdata.error":`An error occurred while inserting new data. Please check this data carefully.`,
"label.partner":`Partner Cloud`,
"label.process.async.execute.tip":`Your request is under processing. Approval takes certain time and the result will be shown on the detail page. Please wait.`,
"label.service.newBuildDialog.additional.conditions":`Additional conditions`,
"label.name_copy":`You're about to clone this existing form. Please enter a name for the copy.`,
"label.integrations.install":`Install`,
"label.edit.ccpeakfolder.time":`Scheduled Classes: Folder Edit`,
"label.knowledgebase.filing.time":`Archived Time`,
"vue_label_chatter_success_exit_group":`Successfully exit the group`,
"font.market.module.v1.save.name":`Please fill in the meeting name`,
"label.a.b.without":`A records may or may not have related "B" records.`,
"label.chat.topic.desc":`Description`,
"label.field.editoptionlist.introduce":`Enter the name of the picklist value. Select the checkbox and use this value as the default value.`,
"label.versiontype.Enterprise":`Enterprise`,
"message.selectrulecondition":`Pleasse specify the rule criteria`,
"label.custombutton.unknown.operation":`Invalid Actions`,
"label.pricecannotnull":`Price is required`,
"component_salesperformance_label_target":`Target`,
"pagecreator.page.message.delete.success":`Page deleted successfully`,
"label.help.new.features":`New Features of CloudCC`,
"label.weixin.vehicle.owner.information":`Vehicle Owner Details`,
"label.exchange.sync.state.user.info":`Check the sync status of a user to ensure that records are synchronized between Exchange and CloudCC. If the user has an issue synchronizing between Exchange and CloudCC, you can reset the synchronization process. Resets information that CloudCC for Exchange uses only and does not delete data from your Microsoft Exchange server or CloudCC.`,
"label.batcheditor":`Batch Edit`,
"report.label.knowcreatehighlevelreport":`How to create a advanced report?`,
"label.dataimport.title.length":`The length of the title is`,
"label_model_description":`Model Description`,
"label.tabpage.ctbtsftcz":`Click the back to search for the content`,
"label.channel.activity.member.owner":`Owner of Campaign Member`,
"label.ems.serverinfo":`Server Information`,
"tjinvilid":`Illegal conditions`,
"label.nameofreport":`Report Name`,
"label.ifapproverreject":`What happens if the approver rejects this request?`,
"label.wtd.changefields.title.desc2":`If you need a record on the Mobile App "Web to CloudCC" to associate a lead, you need to create a field of the current object to lookup the lead, and the field API name is " lead_wtd".`,
"label_emailsync_form_connecttime":`Related Time`,
"label.visualpage":`Custom Page`,
"label.customlink":`Custom Links`,
"label.lead.score.doing.remark":`Your request has been processed and it will take a certain time for lead scoring. and the system will inform you by email when completed.`,
"label.h5.act.details":`Activity details`,
"label.profile.setrecordtype":`Record Type Settings`,
"label.processsetting.process.enabled.successfully":`Enable path successfully!`,
"label.campaign.url.overtime":`The link has expired.`,
"label.structureChart.notFiled":`Not Filled`,
"label.h5.chatter.something":`You say something`,
"label.pm":`PM`,
"template.chart.rwlx":`Task Type`,
"label.icon.42":`Cloud`,
"label.project.hit.one":`Subtask Assignment Notice`,
"label.martrixreport.2018.step3":`Step 3 Choose column headers`,
"label.wtd.changefields.newmo":`Generate Mobile Page`,
"label.downloadTheTemplate":`Download Template`,
"label_chatter_assignPerson":`Assigned person`,
"label_emailtocloudcc_license":`License`,
"label.willdeletedlayout":`Page Layouts You Want To Delete`,
"label.projectManagement.delete.question":`Issue and all related information of this issue will also be deleted if you remove the issue, and the data cannot be recovered. Are you sure to confirm the deletion?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Enable Validation Rules when using Scan`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Note：double click on the blank contacts，can add a blank record`,
"label.step6.total6":`Step 6 of 6`,
"label.knowledge.setting.hint.one":`Knowledge allows customer and service personnel to make full use of the Knowledge articles.`,
"label.usefieldautoassign":`Auto-assign an approver by a standard or custom hierarchy field:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Order Amount:`,
"chatter.fieldtrack.operateupdate":`changed a`,
"chatter.del.com":`Delete this comment`,
"report.reportdatasource.label":`Report Data Source`,
"label.text":`Text`,
"label.marketsea.select.member":`Optional Members`,
"label.typeofreceivers":`Recipient Type`,
"label.knowledgebase.affect.existing.translations":`Yes, my modifications will affect the existing translation. Mark as "Expired"`,
"label.marketing.invitationmail":`Welcome to our activity, your invitation link is:`,
"label.version.quotation.management":`Quotation Management`,
"label.dataimport.insertdata.error.unique":`$fieldName$ violates the uniqueness constraints when inserting new data.`,
"label.emailmerge.list.newtemplate":`New Template`,
"label.salescloud.salescloud.allteam":`All Groups on Opportunities`,
"vue_label_commonobjects_detail_record_changes":`Field record changes`,
"label.file.delete.info":`Delete files`,
"vue_label_calendar_name":`Calendar Name`,
"label.version.support":`Support`,
"label.event":`Events`,
"label.searchlayout.lookup.searchdialog":`Lookup Dialogs that pop up when you click the lookup icon on Lookup fields.`,
"label.data.downpage.e_list.desc2":`After completing, you will receive an email reminding you that the data has been exported successfully.`,
"label.partnerCloud.productSet.delIsTrue":`Do you want to delete this product?`,
"label.tianyancha.businessverify.msg2":`This agreement is an agreement between you (hereinafter referred to as the user) and CloudCC regarding the use of business data verification function. this agreement describes the rights and obligations of the use of business data verification function and related services between CloudCC and user. this agreement may be updated by CloudCC at any time. the updated terms of the agreement once published, it will replace the original terms of the agreement without prior notice.`,
"label.customobjects.cancleselectallfield":`Cancel All Selected Fields`,
"image.up.maxsize":`The uploaded file is too large, please do not exceed 2M.`,
"label.icon.8":`File`,
"label.donot.delete":`You do not have permission to delete`,
"label.version.profile.and.layoutpage":`Profiles and Page Layouts`,
"chatter.coll.s":`Remove this bookmark`,
"label.icon.163":`Earth`,
"label_chatter_myfollowers":`My followers`,
"label.multilang.customforecast.refuse":`Reject any predictive priority of {0}, but accept predictive priority from other subordinates`,
"label.tabpage.findz":`Search`,
"label.smstemplate.detailinfo":`Details of SMS Template`,
"label.knowledge.setting.hint.nineteen":`Let's get started`,
"label.mr.tip":`Please complete the rules in line {0}.`,
"label.icon.132":`Guarantee`,
"label.customobjects.track.introduce2":`History related list. Whenever a user modifies any of the fields selected below, the old and new field values are added to the History related list as well as the date, time, nature of the change, and user making the change.`,
"label_emailtocloudcc_redmessage5":`Unknown staus, please contact administrator.`,
"label.must.select.field":`Line condition error, you must select a field.`,
"label.tag.manage.modifiedby":`Last Modified By`,
"label.translation.start1":`Select a language (if you are a translator).`,
"label.ccchat.topic.searchs":`Search Topic`,
"label.mask.custom.example":`{AAAA}{****}{AAAA} represents encrypted display from fifth to eighth characters.`,
"setup_object_field_dependency_label_addtolist":`Add the selected values`,
"label.view.total.record":`Total selected 0 record.`,
"label.service.without.right":`No associated entitlement`,
"template.chart.wxqzkhyy":`Reasons for Invalid Leads`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Please enter a breakpoint 1 value`,
"message.pleaseinputmouthdistance":`Please enter the valid month interval.`,
"label.forgetPsd.tip":`Forget password, contact administrator.`,
"label.projectManagement.planned":`Scheduled`,
"lable.Product.conversion.asset.operation":`Transfer Product to Asset`,
"label.search_forms":`Search for Forms`,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat homepage message`,
"label_tabpage_viewNamez":`Please enter the view name`,
"label_chatter_addresser":`Sender`,
"Opportunity_Detailed_Phase_Change_Text_001":`Change Opportunity Stage`,
"label.what":`Page`,
"vue_label_systemSettings_set_android":`Set up menus and features for Android and IOS to make it suitable for business users.`,
"label.sell":`Sale`,
"template.report.folder.case":`Cases Analysis`,
"label.customfields.profilefieldsafety":`Field-Level Security of Profile`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`Completed`,
"label.sendmail.step3.introduce1":`You currently have`,
"vue_label_calendar_other_calendars":`Other Calendar`,
"label.donot.know.validate.field":`Invalid validation fields`,
"label.exportdetail":`Export Details`,
"label.step.filter":`Specify filter conditions`,
"label.campaignmember.main.hasMember":`Existing Members`,
"label.updown.suess":`Download successfully`,
"label.ems.browse":`Browse`,
"front-email-payment-Invoice-login-account-describe":`Click "Continue" to complete invoice payment by scanning QR code of Alipay or login Alipay.`,
"label.copyCustomReportType":`Clone Custom report data source`,
"label.visualpage.write.class":`Edit Class code in the page with the same syntax as Java.`,
"label.setsharerule.tip":`<br>Use sharing rules to make automatic exceptions to your organization-wide sharing settings for defined sets of users.<br>Note: "Roles and subordinates" includes all users in a role, and the roles below that role.`,
"label.report.action.addtodashboard9":`Dashboard List Page`,
"label.cloudccsite.remark":`Site Description`,
"label_tabpage_noz":`No`,
"chatter.up.limit":`The uploaded file is too large, please do not exceed`,
"label.leadmarketsea.grouplist.title":`Lead Pool Group Settings`,
"label.pc.user.help":`User Guide`,
"label.partnerCloud.orderingPlatform.relyOn":`Dependency`,
"label.appointmentpage.wizard.subtitle2":`Choose Time`,
"label.deleteoneormore":`Delete one or multiple`,
"january":`January`,
"label.delete.profile":`Delete Profile`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Cosmetic`,
"vue_label_file_already_in_lib":`Already exists in this file library`,
"label.icon.151":`VR`,
"label.withvalue":`By Value`,
"label.tianyancha.businseeverify.opererror":`Failed to open business data. please try again or contact your system administrator!`,
"label.tabpage.individual":`Individual choice`,
"label.layout.editdistribute":`Edit Assignment`,
"label.smstemplate.lookup":`View SMS Template`,
"pagecreator.systemstyle.button.delete":`Deleting style`,
"label.customer.tab.step2.same.option1":`Default On`,
"label.knowledgebase.no.results.knowledge":`No result in Knowledge`,
"label.data.exp.newtemporexp":`Select the method the data is exported or create a new template`,
"vue_label_chatter_refuse_join":`Refuse to join`,
"Homepage.News.002":`The news component is not available currently.`,
"label.log.requesttype":`Request Method`,
"vue_label_dashboard_generatefromreport":`Generate from Report`,
"label.knowledge.create.version":`Create Version`,
"label.emailtocloudcc.description2":`Connect Your Enterprise Mailbox`,
"label.partnerCloud.partnerAccount.recharge":`Topup amount needs to be between 0.1 and {upperlimit}.`,
"label.customobjects":`Custom Objects`,
"label.schedulableprg.endtime":`End date must later than the current date of the system`,
"message.error.viewreport.confirmdelete":`There are charts that useing the current view/report as data source. Do you want to also delete the chart?`,
"label.marketing.social.seting":`Social Media Setup`,
"chatter.follow.stop":`Stop following this user`,
"label.notification.arketsea.return":`{5} returned {0}：{1} to {2}`,
"label.conditionsofnextapprover":`There is one or more next specified approcer in your selected approval request. Please use the following lookup box to specify the next approver.`,
"label.partner.all.state":`Status`,
"mobel_web_closed":`Closed`,
"label.icon.65":`Equipment`,
"label.stdashbord.xsld.business.jinehj":`Total Amount`,
"label.selectobject":`Select Object`,
"label.account.CurrentFQ":`Current FQ`,
"label.workflow.estimaterule":`Evaluate the rule when a record is:`,
"label.list.userinterface.shownewrecordssetup":`Recently Record Setup`,
"label.tianyancha.businessverify.msg3":`1. charge`,
"label.weixin..xsld.jieduan":`Stage`,
"label.first.quarter":`First Quarter`,
"Opportunity.Detailed.Phase.Label.002":`{0} day(s) in current stage`,
"label_tabpage_page":`Page`,
"label_emailsync_status_time":`Time`,
"label.pleaseselectaapprover":`Please select an approver`,
"label.emailtocloudcc.redmessage5":`Unknown staus, please contact administrator.`,
"label.four.quarter":`Fourth Quarter`,
"label_chatter_relateList":`Relevant list`,
"label.customfields.new.step2.opration.exid.info":`Set this field to a unique record identifier for an external system`,
"label.projectManagement.nodata.overdue.tasks":`Great! No overdue task`,
"label.sendemail.activity.task.statuscompleted":`Dear #createbyidccname Hello! \r\n The task you assigned to #belongtoidccname on #createdate is as follows: \r\n Subject: #subject\r\n Duetime: #expireDate\r\n Related Items: #relatedstr\r\n Content: #remark\r\n Please visit the linkfor more details: \r\n #path\r\n Please note: #belongtoidccname is marked as completed. \r\n #orgNameCRM System`,
"label.sso.saml.idp.config.issuer":`Issuer`,
"label.cannot.delete":`items) are not allowed to delete`,
"label.pigeonhole.sel_f":`Choose the folders to archive`,
"label.customfields.text.tip":`Allow users to enter any combination of letters and numbers.`,
"message.error.user.service.common":`Operations failed, please contact administrator for help.`,
"label.datamanage.account.information":`Account Information`,
"vue_label_homepage_deleteprofilepage":`Delete profile homepage`,
"label.sendmail.step3.introduce3":`recipient(s) selected to receive this SMS.`,
"label.pc.ui.2018.recentitem":`Recent Items`,
"label.report.loading":`LOADING...`,
"vue_label_globalsearch_adjustment":`Adjusting method`,
"label_report_line_yixuan":`Selected report column`,
"label.h5.similar.opportunity.only.view":`Display only`,
"label.marketactivitymember":`Campaign Members`,
"label.recycle.execute.tip":`Your request has been processes and it will take some time to clear the recycle bin. You will be notified by emial when completed.`,
"label.permission.detail.system.setting":`System Permission Settings`,
"label.RecordType":`Record Types`,
"label.custom.error.between":`The Custom Year Start Date or Custom Year End Date is in between of history custom years, please check and reset`,
"vue_label_dashboard_selectview":`Select View`,
"label.tianyancha.businessverify.cancel":`Disable business data verification`,
"label.partnerCloud.financeSetting.MD5":`MD5 Secret Key`,
"label.multilang.messagedetail.new.error":`We cannot find a Chat user with any name with {0}:`,
"label.callcenter.pleaseenter.private.key":`Please enter the private access secret key`,
"label.umeng.activity.youdistribute":`You assigned to`,
"label.weixin.nickname":`Nickname`,
"label.customerinfo.mailusername":`Email Username`,
"label.partnerCloud.orderingPlatform.discountPlan":`Discount Schedule Name:`,
"lable.account.year":`Fiscal Year`,
"T":`Time`,
"System.Email.Template.Title":`Welcome to CloudCC CRM platform`,
"label.login.type":`Login Types`,
"label.notification.evaluation":`{0} left comment of {2} for case {1}`,
"label.turntolist":`Jump to Lists`,
"label.sort":`Reorder`,
"vue_label_commonobject_notice_clickcross":`If you need to replace the uploaded file, please click the [X] button and upload again`,
"label.Select.maximumecords.operate":`Up to 200 records can be selected to process.`,
"label.submission_rate":`Submission Rate`,
"label.datadelete.record.sucessfully":`record(s) successfully!`,
"label.version.standard.dashboard":`Standard Dashboards`,
"label.task.postunsolve":`Overdue Tasks`,
"label.Receivables.name":`Receivable Name`,
"label_tabpage_noOperationz":`This content is a fixed item and cannot be operated!`,
"label.attendance.onrecord":`Select one record at least`,
"label.partner.error2":`Error: The domain name can only contain number or letter.`,
"label.account.map":`Account Map`,
"label.dashboardSetup.reference.legend":`Diagram Reference`,
"label.Yaxisscope":`Y-Axis Scope`,
"label.hierarchy.tree.tip":`Select a record in the lookup field of each tab to create a hierarchy. And the hierarchy is as follows:`,
"label.permission.objlist.columnsize":`Total Field Number`,
"label.setup.mobile.bottombutton.savesuccess":`First-level page settings saved`,
"label.mobile.side.tab.selected":`Already selected`,
"label.partner.donotdel.cause":`Beacause it has related with the following partner cloud`,
"label.ccchat.message.new.error4":`Reminder:`,
"vue_label_systemSettings_setorganization":`Set up applications for your organization, customize different menus for various functional divisions.`,
"label.umeng.approval.approvalmes4obj1":`Please review the approval in time`,
"UG_opportunity_010":`Create a transaction`,
"label.tag.addtags.public":`Public`,
"System.TAB.SeeViewPageAmount":`View Pages`,
"label.filterconditions":`Filter`,
"front-personalEmailBox-module-v12-clear-not-associated":`Cancel connection will clear all unassociated emails, are you sure to cancel connection?`,
"label.assign":`Assign`,
"label.layout.clone.tip":`You may select an existing layout to clone`,
"label.choose.relatedlist":`Select the related list you want to transfer`,
"label_chatter_recordcall":`Recorded call`,
"label.product.proofOne":`In {0}, please choose up to {1} product options.`,
"label.layout.availablefield.relatedlist":`Available Fields / Related Lists`,
"label.campaignmember.main.updateleadstatus":`Update Status-Existing Leads`,
"label.custom.buttonandlink":`Custom Buttons`,
"label.view.manage":`View Management`,
"label.search.exp":`Select the objects for which you want to enable the following features and click Save:`,
"vue_label_appstore_apply_to":`Apply to`,
"label.dashboard.message.refreshfail":`Dashboard refresh failed`,
"UG_Case_02":`Cases allow you to respond to and resolve account issues. Cases are a powerful record in Cloud CC that not only tracks account issues, but also displays a complete view of the account.`,
"label.project.hit.three":`Daily Subtask Reminder`,
"label.tianyancha.businessverify.tip":`The function of business data verification is enabled to help users enter the correct customer business registration information when they enter the enterprise customer data.`,
"label_emailsync_status_disconnect":`Cancel Conncet`,
"label.rule.disabled.successfully":`Deactivate the rules successfully`,
"label.custombutton.queryerror":`Query failed, please reoperate.`,
"label.customfields.deletecannotresume":`The corresponding data will be permanently deleted and cannot be recovered.`,
"label.account.current.M":`This Month`,
"label.under.approve.data":`the records is being checked(`,
"vue_label_title_remainingdays":`Remaining days`,
"label.partnerCloud.orderingPlatform.refundable":`Available Rebate`,
"label.lookup.iscover":`Allow sync when editing`,
"label.recordtype.detail.selectlist":`Picklists Available for Editing`,
"label.sso.isActiveYes":`Yes`,
"label.service.appointmentList.canceltheSuccess":`Successfully Canceled`,
"label.escalation.setup.newentries.createfirst":`When the case is created, and disable after case is first modified`,
"label.new.ccpeakfolder":`Class : New Folder`,
"lable.currencyAdv.exchagecurrency.after":`and after`,
"label.majoranddetailrelation":`Master-Detail Relation`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Work hours`,
"label.forecast.customforecast.button.forehistory":`Forecast History`,
"label.mymasterplate":`My Templates`,
"component.setup.tabs.label.memo":`Set tab tag name`,
"label.customfields.longtextarea.tip":`Allow users to enter up to 32,000 characters on separate lines. You can create up to 10 Text(Long) field per object.`,
"label.service.miniProgram.fillJumpLink":`Please fill in the jump link.`,
"label.british.summer.time":`Greenwich Mean Time`,
"label.nogreate":`<=Less Than or Equal`,
"label.assignment.setup.detail.sameuser":`Same User`,
"mesage.error.profile.delate.user":`Unable to delete profile because the user is assigned to the current profile.`,
"label.tabpage.cownerz":`Change owner`,
"label.multilang.dupicatecheck.processedcount":`Duplicated data，{0} groups have been treated，{1} groups of data have not been treated：`,
"vue_label_report_notice_leavecertification":`Are you sure to leave this page-the data you entered may not be saved`,
"label.master.required":`You have required detail information incomplete.`,
"label.chatter.follow":`Follow`,
"label.dataimport.insertdata.error.repeat":`The record duplicates the data in the original database and the record has been ignored import.`,
"label.sms.cgid":`Gallery Number`,
"label.knowledge.article.rator":`Unable to archive this article for associated draft exists.`,
"label.datamanage.object.field":`Object Fields`,
"label.forecast.editshrepage.quanxian":`Sharing Peimission Access Level`,
"label.weixin.interactive.log":`Interaction Log`,
"label.batchedit.remark":`Edit multiple records`,
"label.user.permissions.message":`No permissions to set user information.`,
"label.mobile.phone.month":`month`,
"chatter.sel.u":`Select the users you want to @ mention, or type the Username you want to @`,
"label.service.gantt.assigned.work":`Assigned Work`,
"UG_ST_001":`Prompt`,
"label.edit.select.one":`Drop-down List`,
"label.forecast.shrepage.desc0":`This page lists the users, roles, and zones that have shared access to {0}.`,
"label.multilingual.confirm.close":`Are you sure to deactivate? Multilanguage cannot be used after deactivating and user's language will be changed to the default language.`,
"label.setting.intergrationlist.integration":`Integration`,
"label.leadscore.rule.list":`Lead Scoring Rules List`,
"component_telerecord_button_save":`Save`,
"label.weixin.save.log":`Save Log`,
"label.validate.function.funcExplain.DAY":`Returns a day of the month, you must enter a number between 1 and 31.`,
"label.appointmentdetail.wizard.title1":`Name`,
"label.multilang.feedtrack.dealkey":`Modify {0} from {1} to {2}`,
"label.optional.features":`Optional Features`,
"vue_label_email_no_email":`No email`,
"label.sendemail.chat.messagecontent":`The content of the message:`,
"label.tabpage.lessequalz":`Less than or equal to`,
"setup.layout.label.setupfield":`Field Propertities`,
"label.approved.receiveApprovalEmail.option1":`If I am an approver or delegated approver`,
"label.chatter.relateList":`Relevant list`,
"component.sendmail.label.fromuser":`Sender`,
"label.projectManagement.problem.status":`Issue status`,
"label.weixin.fmu.before.hour":`{0} hour(s) ahead`,
"chatter.feed.menutype.feed.mark":`Bookmarked`,
"label.addQuoteLineGroup":`Add Quote Line Group`,
"label.report.action.addtodashboard6":`Add`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`Current and Previous CQ`,
"label.tabpage.emptyz":`Empty`,
"less":`Less than`,
"label.h5.selectmostphotos":`Maximum nine photos can be selected`,
"UG.activity.04":`Outlook/Gmail mailbox, record mail`,
"template.chart.qbhtje":`All Contract Amount`,
"label.tabpage.endz":`End`,
"label.partner.workspace.member":`Member`,
"label.filter.error.filedvaluetoolong":`Error: Field value exceeds maximum limit.`,
"label.months":`Month's`,
"button.partner.workspace.disable":`Cancel activation`,
"label.visualpage.checkpinyin.grammar":`Please check the spelling and grammar.`,
"label.dashboardSetup.geshihua":`Formatting`,
"label.belongto":`Belong To`,
"label.upload.cannot.empty":`You must select a file to upload.`,
"label.number.MaxCheck":`The maximum of {0} is {1}. Please modify the quantity and save changes.`,
"pagecreator.page.message.save.fail":`Page save failed`,
"label.edit.SMS":`Edit SMS Notification`,
"UG_Lead_002":`There are many ways to identify “leads” for your product or service.`,
"label.quickcreate.active.quickcreate":`Enable Quick Create`,
"label.recordtypeselect.tip":`To skip this step in the future, set up default record types.`,
"label.form_content":`Form`,
"workflow.action.tasks.assignortype.related":`Related User`,
"vue_label_allsearch_set_more_items":`You can set more search items in the drop-down box on the left side of the search box to continue searching`,
"label.tianyancha.businessverify.title":`Business verification`,
"label.errormessage.batchedit.norecord":`No data.`,
"label.permission.appname":`App Name`,
"label.report.action.addtodashboard7":`Cancel`,
"label.generated.transfer.product":`Generate asset according to the way of Asset Conversion.`,
"vue_label_commonobjects_detail_you":`You`,
"label.user.captcha":`Verify your identity`,
"label.notification.event4":`The event 【事件名】 you assigned to 【被分配人】 starts at 【开始时间】`,
"label.version.setup":`Setup`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Please select the layout and record type`,
"label.role.add":`Add Role`,
"label.versiontype.Unlimited":`Unlimited`,
"label.partnerCloud.financeSetting.developerID":`Please enter developer ID.`,
"front-invoice-online-payment-setup-global":`Apply to Global Accounts`,
"vue_label_commonobjects_view_basis":`Sorting Basis`,
"label.decimaldigits.tip":`The number of digits to the right of the decimal point`,
"vue_label_commonobjects_detail_selected":`Mark as Current Stage`,
"label.data.export.page":`Go to the Export Page`,
"message.error.serviceresource.servicecrewid":`Each service crew can only be added as one service resource record of the crew type.`,
"label.loginttime.alltime":`All time is`,
"label.requiredinfo":`Required Information`,
"label.forecast.edit.di":`FY`,
"vue_label_calendar_failed_to_remove_calendar":`Failed to remove calendar`,
"pagecreator_systemstyle_button_delete":`Deleting style`,
"label.import.page3.continueimport":`Continue to import`,
"label.page.width":`Full Page Width`,
"label.campaignmember.selectmember.addmember":`Add members from`,
"label.finalreject":`Final Rejection`,
"label.isend":`Is Finished`,
"front-console-conversation":`Conversation`,
"label.mr.theLastGroupOfThisPage":`This is the last set of data on this page.Click [Back to Duplicate Data List] to view more duplicate data.`,
"label.data.dataexpalltype.all_desc":`Export data of all objects that the current user is accessed to read.`,
"label_emailtocloudcc_redmessage7":`Configuration error, please contact administrator.`,
"label.forecast.shrepage.classdes.all":`Full Access - Users can view and override forecast data and extend access to other users by sharing.`,
"market.contacts":`Market Contact`,
"label.weixin.polls.voter":`List of Voted By`,
"template.report.industry.distribution.customers":`Industry Distribution of Accounts`,
"front-electronic-signature-setup":`Contract Info Autofill and Backfill Setup`,
"vue_label_chatter_removecertification":`Are you sure you want to remove the member "{name}"?`,
"label.appointment.wizard.subtitle1-2":`15 min`,
"label.sso.saml.idp.config.custattr":`Custom Attribute`,
"label_tabpage_totalTeamz":`A total of groups`,
"lable.outlook.detail.assigned":`Assigned Users and Profiles`,
"label.department.user.delete":`Delete`,
"label.customcomponent.check.label.same":`This label already exists.`,
"label.partner.error1":`Error: The domain length is too long`,
"label.escalation.setup.entrydetail.escalation.notify":`Notify`,
"component_todaytask_label_choicestate":`Select status`,
"label.customfields.fielddependency.new.step1":`<b>Step1: </b> Select a controlling field and a dependent field. Click Continue when finished.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Everyone can see and apply to join this group`,
"label.custom.pixel":`pixel`,
"label.quicksave":`Quick Save`,
"label.approved.persion":`Delegated Approver`,
"lable.info.queue.member":`Queue Members`,
"label.addattachment.step2.weixin":`Step 2 Click Upload to upload files`,
"label.forecast.customforecast.title":`Forecasts`,
"mainpage_setup_chosecomponent_leastone":`You must select one component at least on the homepage.`,
"label.appointmentconfirmpage.wizard.title2":`A calender invite has been sent to your email.`,
"label.useallselectedapprover":`Requires that All Selected Approver <strong> Unanimously </strong>Approved`,
"label.ccpeak.current.line.return":`Returns from the current line and it is no longer executed down.`,
"label_new_target_model":`New Target Model`,
"label.saving":`Saving...`,
"label.mobile.phone.write":`Write`,
"label.applt.updown.text":`You can also download the QR code of a mini program portal dedicated to your company and place the QR code inside a web page or public article, and customers can scan the QR code to use the mini program.`,
"label.partner.common.manageSetup":`Partner Cloud Adminstrative Setup`,
"label.quickbooks.new":`New Customer`,
"message.error.color":`color cannot be empty!`,
"label.project.template.two":`There can be only one set of configurations under each record type per object!`,
"label.approval.input.des1":`Review progressively, the maximum of the hierarchy is:`,
"label.x.axis.cannot.empty":`X axis cannot be null`,
"label.solomon.isiands.time":`Solomon Is. Time`,
"label.login.access.duedate":`Access Duration`,
"label.service.dispatch.booking.order":`Assign Service Appointment`,
"label_shareme_forecast":`Shared forecast with me`,
"label.custom.page.cuspage.height":`Height(Pixels)`,
"label.quote.line.group.":`Are you sure to delete the quote line group of {groupName}? Quote lines in this group will also be deleted after the operation.`,
"label.data.downpage.i_title.num6":`It is recommended that you import a test file containing 5 records before importing the data to ensure the data you want to import is correct.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Contract Management`,
"label.document.history.user":`Users`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Please enter the correct amount, up to two decimal places.`,
"label.weixin.target.contract.jine":`Target Contract Amount`,
"lable.common":`￥0 in total`,
"front-kefu-moudle-sendemail-success":`The email has been sent and sales staff will contact you as soon as possible`,
"label.service.no.operation.time":`The current record has no associated operation time!`,
"label.info":`Information`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Rule Entry Edit`,
"label.weixin.report.timeline":`Date Field`,
"UG.quota.04":`Print quotation`,
"label.social.user.exception":`Abnormal user cinformation of social.`,
"label.import.index.failed":`Failed`,
"label.common.settings":`General Settings`,
"label.nullvalue":`Null Value`,
"PageLayout_Search_MultiSearch_002":`Enable customized search box (Single Field Search)`,
"message.myselfreport":`My Personal Custom Reports`,
"label.productsales.today.noevttskaddtsk":`There are no open events and expiring tasks, you can click “ ” in the upper right corner to add new task.`,
"lable.oppdt.noconditionrecrods":`No records to display`,
"label.campaignmember.selectmember.deletelead":`Campaign: remove members from leads`,
"label.marketingactivity":`Campaigns`,
"vue_label_pool_self-built":`Self-built`,
"message.textareamaxlength":`The length chould not exceed 4000 characters`,
"label.valadate.must.value":`Must enter a value`,
"label.tabpage.groupsVisiblez":`Selected user groups`,
"component.button.cancel":`Cancel`,
"label.emailobject.list.inbox":`Inbox`,
"label.app.step1.error.labelexist":`Error: The Label already exists.`,
"front-calendar-V1-Unable-to-display":`The record cannot be displayed in the calendar for the end field of one or more than one records is earlier than the start field.`,
"label.forecast.settings.prompt1":`You must select one Forecast Measurement at least:Revenue or Quantity.`,
"front-kefu-moudle-callout-missphone":`Calling out missed calls`,
"label.tabpage.editz":`Edit`,
"vue_label_chatter_label_new_team":`New group`,
"label.version.formulafield":`Formula Field`,
"label.partner.step1":`Step 1 select template`,
"label.weixin.perfect.url":`Enter URL details`,
"label.appointmentconfirmail.wizard.subtitle4":`Description`,
"label.step7.total7":`Step 7 of 7`,
"setup.object.layout.label.selectedprofile":`Selected Profiles`,
"label.payments.paytip5":`Please enter the correct number of users!`,
"label.visualpage.open.type":`is open customized page style`,
"lable.Sort.field.tips":`Customize the recording order in the related list by selecting fields to be sorted. You can order on the basis of any numeric or date fields of objects.`,
"label.nosharerules":`No sharing rules specified.`,
"label.service.miniProgram.bindSetOwner":`Set Cases Owner`,
"report_label_highlevelreport":`Advanced reports allow you create the relationships between up to 4 objects.`,
"S":`Text`,
"label.lastmodifyby":`Last Modified By`,
"label.customerinfo.mailaddress":`Email Address`,
"vue_label_pool_converted":`Converted`,
"UG.ST.004":`You do not have the data management - "data import permission, please contact the administrator, click confirm and go directly to the {0} interface.`,
"label.view.application.mobile.terminal.filed":`This view has been applied in the mobile app. A maximum of 10 fields are available; are selected.`,
"chatter.feed.limitentity500":`You can follow 500 colleagues and records.`,
"label.starttime":`Start Time`,
"chatter.emailToMe":`Remind me when someone:`,
"label.custom.Current.and.PreviousCQ":`Current and Previous CQ`,
"label.my.logout":`Me`,
"label.quickbooks.searchlist.enddate":`End Date`,
"label.ccservice.validate.length":`The length of the corresponding value {2} of the field {1} under the object API {0} is exceeded. Please reset it!`,
"label.integrations.installed":`Installed`,
"label.integrations.mailchimplist":`Mailchimp List`,
"label.checkfield.matchothers":`Match Other Records`,
"label.umeng.activity.event.distributewillbegin":`The event #event you assigned to #name starts in #time.`,
"pool.notice.gotolightning":`Please go to Lightning Menu if you want to use this feature.`,
"label.batchtransfer.pleaseselecttransferreddata":`Select data you want to transfer`,
"label.mr.title.mailingAddress":`Mailing Address`,
"vue_label_approve_no_response":`No response`,
"component.event.label.title":`Upcoming events`,
"label.mobile.setup.confirm":`You are changing the location of the default tab icon in the mobile app. After the change is successful, all previous configuration of the mobile tab icon will be cleared, you need to reset the tab icon used in mobile app. If you don not select, the system will select randomly in your setting catalogue.`,
"label.tianyancha.approvaltime":`Approval date`,
"label.download_merge_file":`Download Merged File`,
"label_display_quota":`Show Quotas`,
"label.publishreadonly":`Public Read-Only`,
"label.campagin.roi.query.roi":`Campaign ROI`,
"label.dashboardSetup.lookup":`Find Dashboards`,
"vue_label_notificationcenter_nomessages":`No unread messages`,
"label.create.object":`Create Object`,
"label.social.campaign.null":`Campagin information cannot be empty`,
"label.console.step6.left":`Fixed to the left and the lists are always visible.`,
"label.line":`Column`,
"label.bottonandlink.introduce":`Here is a list of buttons and links. Add buttons or links, please edit layout.<br/>Buttons and links can be added to the detail page, related list and list view.<br/>`,
"label.layout.list1":`List 1`,
"label.mr.title.customerName":`Account Name`,
"label.user.text":`Text`,
"label.nolastestrecord":`No lastest record`,
"label.emailobject.appointment.urltext1":`See my schedule and`,
"label.chat.topic.my.favorites":`Bookmarked`,
"label.select.dashboar.cd0":`The grouping field cannot be empty`,
"label.data.downpage.e_title.num2":`2. If you choose to export data of a single object, you need to select how the data is exported:custom export, export by template and export template.`,
"message.error.user.service.login.unconn":`Network busy, try again or contact administrator.`,
"label.escalation.setup.newentries.title":`Rule Entry Edit`,
"label.import.step1.above2000":`When the trigger is executed, a maximum of 2000 records can be imported at a time. Please split into multiple files and import them in batches.`,
"label.ccchat.person.allowinvite":`Allow colleagues to invite`,
"label.input.number.between":`Please enter a number between {0} and {1}`,
"label.forecast.shrepage.wpfmanager":`Delegated Forecast Manager`,
"label_server_is_time_out":`The server is time-out. Please try again later.`,
"label.indochina.standard.time":`India Standard Time`,
"label.cpq.quote.sync.opportunity.failure":`Only primary quotation can be synced with opportunity. Olease check the box of primary quotation, then start to sync.`,
"label.emailobject.send100emails":`Sorry, you can only send 100 emails a day, please re-select!`,
"label.dashboard.snapshot.end":`As Of`,
"label.jiandangfenpei.rightlist":`Assigned Profiles`,
"label.input.string.length.between":`Enter a string which length is between {0} and {1}`,
"label.multilang.lookfiltercondition.select":`The {0} line condition is incorrect. You must select a field!`,
"label.datamanage.lead.namenull":`Note: If the lead name fiels is null, the record will not be imported.`,
"label.forecast.detailforecast.button.saveandfresh":`Save`,
"label.venezuela.time":`Venezuela Time`,
"label.same.analyze.miaoshu1":`If you need more rules,please use "`,
"label.twomb":`Only jpg/png file is allowed to upload with a maximum size of 2MB.`,
"label.event.moveup.7hour":`7 hours ahead`,
"label.weixin.forgot.password":`Forgot Your Password?`,
"label.import.page1.diledsizelimited":`2. The maximum allowed file size is 100M`,
"label.file.foldername":`Folder Name`,
"label.multilingual.open":`Multilangiuage management is enabled.`,
"label.dashboard.snapshot.refresh.failed":`Dashboard snapshot refresh failed`,
"label.marketsea.memberfieldselectone":`View fields and members can view fields Please select at least one field`,
"label.trigger.createdate":`Created Date`,
"label.ccpeak.operation.sharetab":`Operate on sharing form:`,
"label.partner.message.admin.access":`Only administrators can log in`,
"label.emailsync.status.email":`Action Performed Email`,
"chatter.error":`Error: Please select a file to upload!`,
"label.role.viewinlist":`Show in list view`,
"label.tag.addtags.title":`Tag`,
"setup.mainpage.label.welcome6":`Users can create various types of fields in all objects of the CloudCC system without any programming knowledge or code development. The field types include: search relationship, single-selection field, dual-item selection, formula, automatic numbering. , URL, phone, fax, email, checkbox, date, time, number, text, text area, option list (single/multiple selection), currency, etc.`,
"label.delete.rule.successfully":`Delete the rules successfully`,
"label.field.duplicate.error.msg6":`Duplicated field value. The value exsits in record:`,
"label.stdashbord.xsld.business.jhzsl":`Total Opportunities (Quantity)`,
"label.compact.layout":`Key Information Layout`,
"label.checkfield.merge.introduce":`Select the value that you want to keep in the merged record.`,
"earlieststarttime.duedate.time.illegal":`The actual start time of the service appointment should be less than or equal to the actual end time.`,
"label.dataimport.validate.prompt":`Validation Rule Prompt`,
"message.setuptip":`You are allowed to delete the packages you created.`,
"template.report.customer.collection.statistics":`Account Payment Statistics`,
"vue_label_homepage_dashboardcomponents":`Edit Dashboard Component`,
"setup.mainpage.label.welcome30":`The CloudCC platform is a true cloud computing platform. The platform's open attributes, standard integration methods, and flexible customization are applicable to all industies, integrating third-party software, realizing real-time unification of enterprise management data, and maximizing the comprehensive and in-depth management needs of our customers. The CloudCC platform can be integrated with any enterprise application or system, including third-party software such as SAP, Kingdee, and UF. The standard Web Service method under the flexible SOA architecture does not have any destructive, technical dependencies or vendor lock-in.`,
"label.SMS.new.det":`Create a SMS notification to associate one or more workflow rules, approval processes. If the SMS notification is changed, any changes are applied to all rules and approvals associated with it.`,
"lable.product.page.previous":`Back to Previous`,
"label.recordtype.labelname":`Record Type Label`,
"message.error.system.service.failure":`Service execution failed, please contact administrator.`,
"label.visualpagefolder":`Page Folders`,
"label.username":`Username`,
"label.data.downpage.i.title.num5":`5、Please check the accuracy of the data.`,
"label.permission.manage":`Manage Assignments`,
"label_emailsync_status_user":`Users`,
"label.weixin.voting.least.two":`There are at least two voting options.`,
"label.tabpage.thisrecord":`This record`,
"label.icon.119":`Blackboard`,
"label.partner.common.webSit":`Domain`,
"label.email.form.html2":`[switch to text-only]`,
"label.appupload.upload.noversion":`No uploaded versions`,
"label.appointmentpage.wizard.subtitle1_2":`Inviter's Time Zone is {0}`,
"MR":`Lookup Relation (Multi-Select)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Available Balance`,
"label.schedulejob.setup.schedule.st3":`The 3rd`,
"label.reportsSubscriptionPage.email.general":`General`,
"label.setsharerule.step4":`Step 4 Select the level of access for the users`,
"front-epwechat-module-v1-info-desc":`Please get information from the backend of WeCom and fill in here`,
"message.duplication.label.isactive":`Active`,
"pagecreator_systemstyle_label_linkcolor":`Link color`,
"label.import.page1.alertfiledsize":`The files loaded must not exceed 100MB!`,
"tomorrow":`Tomorrow`,
"label.publicdashboard":`Unfiled Public Dashboards`,
"label.knowledgebase.same.taborworkspace":`Same Tab or Workspace`,
"homepage.layout":`Homepage Layouts`,
"label.emailobject.trackemailopening":`Track Email Opening`,
"label.unlock.tip":`Unlock the records to allow editing`,
"lable.account.NextzDays":`Next 90 Days`,
"vue_label_report_throw":`Discard`,
"label.icon.102":`Schedule`,
"label.payments.paytip2":`You have upgraded to our paid edition, click Confirm to close the window and refresh your CRM system.`,
"label.customfields.email.tip":`Allow users to enter an email address, which is validated to ensure proper format. If this field is specified for a contact or lead, users can choose the address when clicking Send an Email. Note that custom email addresses cannot be used for mass emails.`,
"label.test_visitors":`Test how your form should look when viewed by visitors.`,
"label.workflow.immediatelyoperate":`Instant Workflow Actions`,
"label.approvalstep4.tip":`The approval page is where the approver actually approves or rejects the request. use the following options to select the fields to display on this page.`,
"label.ccchat.person.invite.failsend":`The following invitation failed to send. please contact the administrator.`,
"label.import.index.obj":`Object`,
"label.multilang.leadscore.countnum":`{0} times:`,
"label.report.error.typefind":`No report type found by grouping information`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`No grouping data available!`,
"lable.Create.new.template":`New Service Report Template`,
"label.knowledgebase.display.error":`Show {a} Mistakes`,
"label.emailobject.template.message2":`The field inserted in the current email does not match the associated record, which may cause null values.`,
"label.productsales.today.taskcomplete":`Set to completed`,
"label.emailobject.selectone":`Please select at least one record as the recipient of the email`,
"button_partner_workspace_saveas_memo":`Save the current partner cloud as a "template."`,
"vue_label_help_detail":`Record Details`,
"label.tabpage.minutesagoz":`Minutes`,
"label_tabpage_characterz":`Beginning character`,
"message.error.accesstoken.null":`Token cannot be empty!`,
"label.textMessageObject.send100":`Sorry, you can only send 100 text messages a day, please re-select!`,
"vue_label_commonobjects_detail_record_call":`Log a Call`,
"label.campaignmember.main.addlead":`Add Members-Existing Leads`,
"setup_mainpage_label_welcome30":`The CloudCC platform is a true cloud computing platform. The platform's open attributes, standard integration methods, and flexible customization are applicable to all industies, integrating third-party software, realizing real-time unification of enterprise management data, and maximizing the comprehensive and in-depth management needs of our customers. The CloudCC platform can be integrated with any enterprise application or system, including third-party software such as SAP, Kingdee, and UF. The standard Web Service method under the flexible SOA architecture does not have any destructive, technical dependencies or vendor lock-in.`,
"label.file.library.deleteprompt":`Remove {0} from Asset Library ?`,
"label.wtd.changefields.title":`Web to CloudCC Setup`,
"label.sendmail.step1":`Step 1 Specify the recipients to include`,
"label.cpq.newquote.createorder.checkbox.selected":`The checkbox of Create Order cannot be selected while creating a new quotation.`,
"label.emailtocloudcc.name":`Name`,
"message.error.object.nullbinding":`binding is empty`,
"B":`Checkbox`,
"label.pc.endtime":`Your license will expire in less than 30 days. please renew in time to ensure continued use.`,
"label.visualpage.section.start":`Use the tag at the beginning`,
"label.partnerCloud.basicSetting.available":`The domain name is available.`,
"label.data.exportall.all_desc":`Exports all data for all objects that the current user has permission to view.`,
"label.editor.layout":`Edit Search Layout`,
"label.send.chatter":`Send Chatter`,
"label.h5.chatter.reply":`The quick reply`,
"component_chatter_post_button_file":`Add attachments`,
"label.emailobject.emaildetail.button.reply":`Reply`,
"label.eidt.queue.title.desc":`The name must be unique, and the name must begain with a letter. It must contain only uppercase and lowercase letters,numbers,and underscore.It must not be longer than 40 characters.`,
"label.campaign.channel.input.url":`5.Set up the information that the users will see after signing up, which can be a thanks page, a leaflet or a ticket`,
"label.compact.layout.assign.tip":`This table shows the key information layout assignments for different record types.`,
"vue_label_fall":`Descend`,
"label.trigger.save.failed":`Save failed, the data cannot be null`,
"label.appupload.upload.tips.report":`NOTE: The reports and old reports in My Custom Reports" and "Unfiled Public Reports" cannot be added to packages and will not be display in this folder."`,
"label.tianyancha.businessverify.rewriteall":`Backfill all data`,
"label.campaign.channel.step6.remark4":`Note that, the lead owner may be the owner of the current campaign or the solicitation person of the current marketing channel.`,
"front-kefu-moudle-called-num":`Dialed Number`,
"label.approvalstep4":`Step 4 Select the fields to display on the approval page layout`,
"label.login.verification.please.scan":`Please scan the code using the MFA application on your smartphone`,
"label.invoice.message.statusupdated":`Invoice status updated`,
"label.pc.ui.2018.subject":`Theme`,
"label.area.notexist.userinfo":`The User Group does not exist.`,
"label.newuser":`New User`,
"label.chat.micropost.share":`Share the post`,
"label.locatedupcurrentvalue":`The value above the current one`,
"vue_label_systemSettings_course":`Lightning Path Setup`,
"chatter.group.public":`Public`,
"label.reportsSubscription.entrance":`Subscribe`,
"front-kefu-moudle-v1-online-at":`Online Agent`,
"label.rejectbehaviourselect":`Perform <strong>only</strong> the rejection of this step and send the approval request back to the most recent approver.(Back To Previous Step)`,
"vue_label_commonobjects_view_currentviewset":`To cancel the setting of the current default view, you can set another view as the default view.`,
"lable.currencyAdv.and":`and`,
"label.appexchange.installedpage.publish":`Published By`,
"label.tab.profile.ismobile":`Apply to mobile app`,
"label.data.setok.t.desc2":`Back to Data Template Page`,
"label.email_required":`The email is required.`,
"label.tabpage.fullscreenz":`Full screen`,
"chatter.sticker.set":`Feed Tracking`,
"label.mobile.phone.year":`year`,
"label.projectManagement.next.page.before":`Previous page`,
"pagecreator_button_pcpage":`PC end`,
"label.dashboard.xsld.percent":`Percent`,
"label.ccpeak.service.checkerror":`Syntax check failure.`,
"label.icon.26":`Folder`,
"label_partner_common_webSit_memo":`Default domain name:`,
"label.unselectfile":`No Files Selected`,
"label.take.notice":`Notice`,
"message.error.filename.null":`fileName cannot be empty!`,
"vue_label_SMS_nophone":`No phone number`,
"label.area.assignuser":`Assign Users`,
"label.icon.176":`Prompt`,
"label.icon.21":`Currency`,
"message.error.system.service.deletedeny":`Dada is associated and cannot be deleted.`,
"label.compact.layout.main.tip":`Select the layout of key information to use when this record appears as a list item in CloudCC.`,
"label.emailtocloudcc.delete":`Delete`,
"label.dashboardSetup.showdw.d2":`10 Million`,
"front-kefu-moudle-hqyyjlsb-admin":`Failed to get voice recording, please contact the administrator for help`,
"label.partnerCloud.basicSetting.userCounts":`Total Roles of Partner`,
"front-kefu-moudle-calling-num":`Calling Number`,
"label.alldocument":`All Documents`,
"coderules.nullvalue1":`Failed to generate. Please enter the value for 【{0}】 used in the generation rules.`,
"lable.automatically.shared":`Automatically Shared`,
"label.batchadd.newbatchpage.save.emptyselect":`Please check if there are required options not selected.`,
"vue_label_homepage_card_30dayswithout":`No-contact Opportunities for 30 Days`,
"label.multilang.dupicatecheck.onegroupnote":`Please choose at least two data, click the button [Load selected information] to enter the page of data combination. Currently in the {0}-th group of enterprise data,There are a total of {1}records. :`,
"UG.activity.03":`Reserve a schedule`,
"label.pc.oldpage":`Old Page`,
"label.exchange.sync.state.task.m2":`Records synced in the last 60 minutes:`,
"label.setmovable":`Activity Settings`,
"label.sendemail.send.loginfail":`Failed to login to mailbox, please reset your email information.`,
"label.copy.quote.lines":`Clone quote line`,
"label.copying.reward.to.groups":`Copy to Quote Line Groups`,
"label.ems.connect.error":`Server connection failure,please check.`,
"lable.account.Tomorrow":`Tomorrow`,
"label.manageAll.sta2":`Approved`,
"label.create_form":`New Form`,
"label.ems.saveDetail.error.msg":`Save failure.please check mailbox account and password`,
"label.service.gantt.distribution.recommendation":`Assign Suggested`,
"label.email.track.attachment.size.control2":`The size of the file uploaded exceeds 10m,and cannot be uploaded`,
"lable.product.pricebooks.add":`Add to Price Book`,
"label.login.time":`Login Time`,
"label.tabpage.yes1z":`Yes1`,
"label.SalesCommitmentKanBan":`Sales Commit Dashboards`,
"label_partner_workspace_myspace":`My workspace`,
"chatter.like":`like(s) received`,
"lable.PowerProcess.number.input":`Please enter an integer.`,
"chatter.coll":`Bookmark`,
"label.campaign.channel.img.remark":`Remark: Image size should not exceed 2M`,
"label.field.duplicate.error.msg7":`Duplicated Data`,
"vue_label_pool_discard":`Discard`,
"label.service.gantt.total.planned.duration":`Sum of planned duration for service appointments`,
"label.weixin.click.loadmore":`Click to load more`,
"label.help.new.features.yd":`Mobile-sade new interface operation guide`,
"label":`Label`,
"label.quickbooks.viewlist.total1":`There are {0} invoices for a total value of {1}`,
"front-kefu-moudle-v1-input-publicKey":`Please enter the shared key`,
"label.approval.allowed.reject":`Rejection Allowed`,
"label.visualpage.folder.notdel":`You cannot delete this folder, because some files in it.`,
"label.projectManagement.charging":`Billing`,
"label.ccservice.validate":`The format of the corresponding value {2} of the field {1} under the object API {0} is incorrect. Please enter the correct number!`,
"message.unbind.mfadevice.no.permission":`You have no perimssion to unbind MFA devices.Please contact your administrator.`,
"label.partner.new.step3.meno":`Not sure what to enter? do not worry, you can change it later any time.`,
"label.import.page3.importsucceedtip":`Start import successfully. After the import, an email will be sent to your associated mailbox`,
"label.customsetting.visible.protect":`Protected`,
"label.publishreadandwrite":`Public Read/Write`,
"vue_label_file_add_most_once":`Add at most once`,
"label.salescloud.teamrole.optionlist.group":`Assign roles to opportunity team members and account team members.`,
"label.appointment.wizard.subtitle7":`Location`,
"label.task.dateminus":`Minus`,
"label.data.exp.zippwd":`Manual Enter Compressed File Password`,
"UG_Forcast_09":`Next step`,
"message.duplication.label.allselectlink":`[Select All]`,
"label.file.ccchat.selectfromcloudcc":`Select a file from CloudCC`,
"label.ems.addaccount3":`Add Account`,
"front-epwechat-module-v1-schedule-sync":`Sync Schedules`,
"label.h5.manage":`Manage applications`,
"setup.layout.label.nobutton":`No available buttons`,
"label_component_hotdeal":`Hot deals`,
"template.dashboard.contract.analysis":`Contracts and Receivables Analysis`,
"vue_label_dashboard_editcomponent":`Edit component`,
"label.quotationInformation":`Quote Information`,
"label.data.file.validation_rules":`Execute Validation Rules`,
"label.ccpeak.construction.shareobj":`To construct a sharing form object of an object, you must pass in the API name and sharing mark.`,
"label.wei.pollinformation":`Micro Voting Details`,
"label.quickbooks.viewlist.total3":`There are {0} payments for a total value of {1}`,
"label.paging.totalofpagesnoid":`A total of {0} pages`,
"label.unlock":`Unlock`,
"front-invoice-online-payment-information":`Invoice Information`,
"label.permission.systempermission":`Assigned System Permissions`,
"message.error.object":`When calling a service, it is found that the object is not defined.`,
"font-trade-module-v1-invoice-intro":`Please enter the invoice No. or invoice name`,
"label.userinfo.pwdexpired":`The current password has expired. For security reasons, you must change your password now.`,
"label.userphoto.photo":`Photo`,
"label.tabularreport.filterrecord":`Select tge criteria for determining which records to display`,
"label.partnerCloud.orderingPlatform.rechargeIt":`Your account balance is not enough, please top up.`,
"label.icon.120":`Computer`,
"label.projectManagement.select.new.type":`Select creating type`,
"vue_label_commonobjects_detail_customer_details":`Loading customer details`,
"label.ems.status":`Status`,
"label.validate.function.description":`Any function that conforms to the java syntax can be used in the validation rule, and the expression needs to return a Boolean value.<br>You can also use a specific function provided by CloudCC.
For example, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() returns an object, it needs to be converted to the corresponding field type.`,
"label.escalation.setup.newaction.step2":`Step 2 Select the user to auto-reassign cases`,
"label.forecast.customforecast.searchforecast":`Find the forecast`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`Upper bound of each level shall be greater than the lower bound when pricing by blocks.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Faild to delete data with record id {0}，failed reason: {1};`,
"page.field.masterinput.remark":`Enabled Master-Detail Input is used to create related list records on tab page.`,
"lable.SalesCommitmentKanBan.contractName":`Contract Name`,
"front-gantt-module-add-milestone":`Add Milestone`,
"label.callcenter.save.error":`Please do not save again`,
"label.workflow.selectobj":`Step 1 Select object`,
"label.validate.function.category.all":`-- All Function Categories --`,
"label.multilang.uploadifupage.select":`You have totally chosen {0} files:`,
"label.weixin.dragsort":`Drag the icons in My Apps to sort them.`,
"N":`Number`,
"label.knowledge.article.translation.completed":`Article translation completed`,
"label.weixin.myapp":`My Apps`,
"label.icon.138":`Currency`,
"vue_label_chat_create_discussion_now":`Create discussion now`,
"label.knowledge.recover.article":`Restore Article`,
"label.ccpeak.use.class.time.map":`Access By Passing In The Map Collection`,
"front-email-payment-error-tips":`Interface error`,
"label.service.gantt.ziyuan":`Only for`,
"label.upload.error":`Failed`,
"label.staticresource.upload.error":`Error uploading static resources!`,
"com.cloudcc.login.error.message.loginfail":`Operation failed, please contact the admin`,
"pagecreator_button_back":`Previous Step`,
"label_tabpage_skip":`Skip to`,
"label.pw.old":`Please enter the old password`,
"pagecreator.layout.label.modifylayout":`Layout editor`,
"vue_label_chatter_share_group":`Share with the group`,
"label.app.edit":`App Edit`,
"label.user.Email.repeat":`Email duplicate. This user is not supported for binding with agent`,
"label.field.quilt":`This field is`,
"label.projectManagement.Groupuser":`Group by User`,
"label.deleteall":`Delete All`,
"label.appexchange.download.tiaoguo.mes":`Ignore to install the following conflicting components:`,
"label.sendemail.recycle.operatehello":`#username hello:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`You can select up to 20 templates!`,
"label.campaignmember.main.deleteleaddesc":`Batch remove all leads from this campaign`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Days in Current Stage`,
"vue_label_file_no_title":`No title`,
"label.data.dataexpalltype.all.desc":`Export data of all objects that the current user is accessed to read.`,
"label.dashboard.unit2":`Unit: million`,
"label.list.userinterface.isrelatedlist":`Enable Related List Hover Links`,
"label.role.tree":`Role Hierarchy of your organization`,
"label.campagin.roi.zcsl":`Enrolment`,
"message.error.forecast.setupchange":`The data you tried to access could bot be found. It could be deleted by other users or changed.`,
"label.sendemail.changeowner.dataname":`Document name is: #dataname file`,
"label.salescloud.opportunity.contactrole.optionlist":`Opportunity Contact Roles Picklist Values`,
"setup_mainpage_label_welcome1":`Need corresponding permission`,
"UG_activity_02":`Assign tasks`,
"label.tabpage.erraddressz":`Incorrect format of email address, please enter email address correctly`,
"label.weixin.nicheng":`WeChat Nickname`,
"label.forecast.settings.mrsz":`Forecast Measurement`,
"label.campaign.channel.download.size3":`Small Size: 300*300 pixels`,
"label.icon.73":`Machine Tool`,
"label.ServiceCloud.suoxuchanpin":`Products Required`,
"label.escalation.setup.newrule.description":`Enter the rule name and active it. Activating this rule will deactivate the current case escalation rule. To disable automatic case escalation, deactivate all case escalation rules.`,
"label.data.import.setup.whichfield.cloudccid":`CloudCC ID`,
"label.validate.function.funcExplain.PRIORVALUE":`Returns object type, the corresponding field type needs to be converted.`,
"Lead.Scoring.Warning.001":`Score single lead record automatically when creating or editting. But you need manual scoring multiple lead records, when batch importing or creating by interface.`,
"label.tianyancha.businessverify.msg9":`The power of interpretation of this agreement shall be vested in beijing shenzhou yundong science and technology co., ltd.`,
"label.compact.layout.tip":`The key information layout is used to display the key field of the record details on the details page.`,
"label.visualpage.btype":`Reports`,
"label.textmessage.vonage.settings":`Settings`,
"label.field.not.exites":`not exist`,
"label.payment.switch.version":`Switching to the new edition`,
"label.ems.hour":`Hour`,
"label.weixin.cannot.edit":`The file type cannot be edited`,
"chatter.pt.limit":`The maximum file size is`,
"label.quote.detailinfo.add":`Add Quote Line Items`,
"component.setup.label.displayfield":`Field Display`,
"vue_label_report_reportfolder":`Report folder`,
"label.gbkencoding":`Chinese (GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Transfer to {TransferName}`,
"label.file.stop.sharing.desc2":`Share`,
"label.textmessage.messageCannoutuse":`Unavalible,please contact Administrator to enable Text Messages.`,
"component_newrecords_label_type":`Storage type`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`New Price Book`,
"vue_label_newfile":`New File`,
"label.reportTypcrtB":`Associated object (b) please click to select related object`,
"label.knowledgebase.type":`Category`,
"label.report.select.format":`Select Report Format`,
"component.todaytask.label.title":`Today`,
"message.undelete":`Are you sure you want to cancel delete?`,
"label.ccdocument.trace.retention":`Trace Retention Function`,
"label.publicgroup.tip":`A public group is a set of users. It can contain individual users, other groups, the users in a particular role or territory, or the users in a role or territory plus all of the users below that role or territory in the hierarchy.`,
"label.forecast.settings.lable2":`Configure the Default Forecast Display`,
"label.projectManagement.positive.integer":`Please input a positive integer within 0-24.`,
"label.projectManagement.one.work.list":`Please fill in at least one work list!`,
"label.or":`||Or`,
"label.projectManagement.no.person.in.charge":`No Supervisor`,
"vue_label_commonobjects_detail_an_email":`an email`,
"front-electronic-signature-field-mapping":`Add Field Mapping`,
"label.marketsea.name.error":`The name of the lead pool cannot be empty`,
"component.setup.button.appurl":`System URL`,
"label.mr.title.button.group1":`The`,
"chatter.contact":`Contact`,
"vue_label_pool_hasfixed":`fixed cooperation channels`,
"lable.list.queue.des":`Queues allow groups of users to manage a shared workload more effectively.A queue is a location where records can be routed to await processing by a group member. The records remain in the queue until a user accepts them for proessing or they are tran are transferred to another queue. You can specify the set of objects that are supported by each queue, as well as the set of users that are allowed to retrieve records from the queue.`,
"label.reportsSubscriptionPage.condition":`Conditions`,
"label.transwork":`Translation Workbench`,
"label.batch.batchopration.resel":`Please re-select the data you want to transfer, and click "OK" to jump to the view list page.`,
"label.cloudccsite.new":`New Site`,
"label.button.select.page.required.field":`Select the required fields to include on your page:`,
"label.pagelayout":`Page Layouts`,
"label.weixin.trace.record":`Track Records`,
"label.emailtocloudcc.clear":`Clear`,
"label.checkfield.find":`Find Duplicates`,
"message.view.count.title0":`Current page summary`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Frequency`,
"setup.mainpage.label.welcome5":`Custom field`,
"label.implementation.details":`Execute Details`,
"label.attendance.history":`Attendance History`,
"label.is.pigeonhole":`Archive`,
"lable.account.CurrentandPreviousFYt":`Current and Previous 2 FY`,
"label.forecast.customforecast.tab.opportunity":`Opportunities`,
"label.version.business.track":`Opportunities Tracking`,
"label.profilelayoutedit.selectrecordtype.tip":`Select the record type for this profile of users. You need to add the record type field to the page layout associated with this profile so that it can be displayed on the detail pages and the edit pages.`,
"label.campagin.roi.zclzb":`Registration Rate`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(date)`,
"label.view.sort.message":`Sorted by {!sort}`,
"page.field.masterinput.sort":`Master-Detail Inputs are displayed in the order in which they are saved.`,
"label.selected.field":`Selected Search Fields`,
"label.product.proofTwo":`In {0}, please choose at least {1} product options.`,
"vue_label_report_filtercondition":`Filter Condition`,
"label.forecast.shrepage.desc1":`This page lists the users,roles and territories that have sharing access to`,
"label.file.copy.link":`Copy link`,
"vue_label_chat_movedto":`{name} moved {label} to {newField}`,
"label.layout.new.built":`New Section`,
"label_tabpage_crecordtypez":`Change record type`,
"label.report.searchcustominfo":`Enter the keywords to find matching custom reports`,
"chatter.feed.menutype.user":`Colleagues`,
"label.recordtypeselect":`Select Record Type`,
"label.partner.new.step3":`Step 3 Enter name and url`,
"label.newCustomReportType":`New Custom Report Data Source`,
"label.service.gantt.day.timescale":`Time Scale on Day View:`,
"label.displaytype3":`List Button`,
"label.weixin.discharge.rate":`Exhaust Volume`,
"label.weixin.menu.message":`Menu`,
"label.mask.show.all.characters":`Mask displays all characters`,
"label.quickbooks.fieldlabel.billingaddress":`Billing Address`,
"Dashboard.View.All":`All Dashboards`,
"setup_mainpage_label_welcome22":`Instructions: Click on the menu on the left side of this page → Manage Settings → Newsletter Template → Email Template.`,
"chatter.group.groupInformation":`Group Information`,
"front-epwechat-module-v1-input-secret":`Please enter Secret`,
"lable.Set.value.prompt":`Or, filter records displayed in the related list. Choose the checkbox, or picklist fields and the values you'd like to filter. If enter the values manually, please seperate with commas.`,
"label.appupload.upload.from":`By`,
"label.weixin.postunsolve":`Overdue`,
"label.cooperation.all":`All Cooperation`,
"lable.PowerProcess.close.time":`Based on the closing time of {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Please select a field at least.`,
"label.emailtocloudcc.help":`Please enter the correct email password or authorization code. If your email server needs to turn on the IMAP/SMTP service to login by a third-party account, you must login to the email account settings to enable the service first, and copy the approproate authorization code to this password enter box.`,
"label.attendance.offwork.time":`End of Day`,
"front-gantt-module-v1-project-gantt":`Project Gantt Chart`,
"label.chuangming.description":`Configure the information of the Chuangming to meet the needs of your organization's SMS sending and receiving services.`,
"label.custom.lead.notice.account.name":`There is a lead who, was converted, specify that you are the owner of account, contact and opportunity. Account Name:`,
"label.emailobject.failedtosend1":`Send failed: Email authentication is invalid, please reconnect！`,
"vue_label_ccchat_notice_updaterecordsuccess":`This record has been updated`,
"label.dayinmonth":`Months'`,
"label.sendemail.chat.follow":`Dear #name:\n\n hello! #userName follows you.`,
"label.emailsync.form.emialpassword":`Password`,
"component_task_label_subject":`Theme`,
"label.projectManagement.please.enter.a.positive.integer":`Please enter a positive integer.`,
"lable.account.NexteDays":`Next 7 Days`,
"label.appupload.upload.managed":`Maximum one controlled package can be created!`,
"label.data.dataexpalltype.all.desc1":`1、You can shoose to automatically generate and manually enter the password of the exported compresses file. The automatically generated password will send to the mailbox of the users when the data is exported successfully. The manually entered password will not send to the mailbox, so users need to remember the password they entered. If not entered, default to no password.`,
"label.step1.total3":`Step 1 of 3`,
"label.escalation.setup.detail.section":`Rule Detail`,
"front-gantt-module-drag-task-sorting":`Drag tasks to order`,
"label.isEnableVisualpage.new.title":`Enable Custom Page Access`,
"label_tabpage_yesz":`Yes`,
"label.emailobject.emaildetail.button.replyall":`Reply all`,
"label.knowledge.setting.data.one":`This cannot add more subcategory.`,
"label.manageAll.sel.one3":`Items I Approved`,
"UG_contact_01":`How to make the most of your contacts?`,
"font-trade-module-v1-invoice-name":`Invoice Name`,
"label.central.daylight.time":`Central Daylight Time`,
"label.chatter.pastThirtyday":`The past 30 days`,
"vue_label_commonobjects_detail_activity_ownevent":`Available event`,
"label.user.modify":`Edit User`,
"label.uploadTemplate":`Upload Template`,
"setup_mainpage_label_welcome14":`Process management of workflow customization, approval`,
"label.workmate":`Colleagues`,
"label.displaycolumns":`Display Columns`,
"label.emailnoticeintro":`Email alerts are the emails that workflow rules send when triggered.`,
"label.knowledge.category.button.five":`Delete Category`,
"template.report.business.opportunities.type":`Opportunities by Types`,
"vue_labenl_applauncher_moreapp":`More Apps`,
"label.captcha.expired":`The verification code is expired, please verify again.`,
"template.chart.bnqzkhslmb":`Target Number of Leads for the Year`,
"chatter.up.user.pic":`Upload User Photo`,
"label.timezone.importtimezone.gmt":`Use gmt timezone`,
"label.step.type":`Select the member type you want to search`,
"Dashboard.View.RecentlyView":`Recently Viewed`,
"label.reportinthisfolder":`Reports in This Folder`,
"label.product.vies":`Product Views`,
"pagecreator_systemstyle_message_delete_fail":`Style deletion failed`,
"label.multipleactivity.singleUser":`Single User`,
"vue_label_email_enter_subject":`Enter subject`,
"label_tabpage_alltabs":`All tabs`,
"label.publicgroup.groupname":`Group Name`,
"template.report.sales.performance":`Performance of Salesmen`,
"label.newWindow":`New Window`,
"label.forecast.editopp.forecastedit":`Forecast Edit`,
"label.data.import.setup.whichfield":`Which field would you like to use for matching?`,
"label.noadd_dashboard":`Don't add to dashboard`,
"label.subtotal":`Subtotal`,
"front-email-payment-weichat":`Please use WeChat "Scan"`,
"label.attendance.position.alert":`Please select the mask first`,
"chatter.follow.me":`Follow me`,
"label.mobile.more.details":`Edit File Detail`,
"Dashboard_SelectBoardToDisplay":`Please select the dashboards you want to shown on dashborad tab page`,
"front-gantt-module-v1-search-project":`Search your project...`,
"label.paging.totalofpagereport":`A total of {0} pages({1})`,
"label.from.phone":`From`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`Marketing Channels ROI`,
"label.tabpage.selectcontentz":`Please select content`,
"label.multilang.lookfiltercondition.valuetypenotmate":`The {0} line condition is incorrect, the value type does not match!`,
"label.interfaceconstraint.disabled":`The interface has been disabled, please contact with your system administrator.`,
"third":`The Third`,
"label.quickbooks.viewlist.status":`STATUS`,
"label.emailtocloudcc.select3":`Please select record owner`,
"label.projectManagement.week.work":`My work for this week`,
"vue_label_pool_nodemand":`No demand`,
"label.version.two.developapi":`Secondary Develop API`,
"label.icon.82":`Printer`,
"label.batchadd.newbatchpage.suclist":`piece(s) data added successfully`,
"label.checkfield.chooseatlast":`Please select two at least`,
"label.quotation.deleteTip":`Please select quote lines to be deleted`,
"label.generatepage.title.desc2":`Click Save to generate the Web page and the Web URL link which can be accessed.`,
"label.licence.total":`Total Licenses`,
"Y":`Lookup Relation`,
"label.wuzibiekesitan.time":`Uzbekistan Time`,
"label.component.hotdeal.nodata":`No data related to opportunityies`,
"label.data.exp.save":`Save the template`,
"label.appupload.upload.tips.dashboard":`NOTE: The dashbords in My Custom Dashboards" and "Unfiled Public Dashboards" cannot be added to packages and will not be shown in this list. The related old reports cannot be uploaded."`,
"lable.PowerProcess.new.PowerProcess":`New Entitlement Process`,
"label.loginhis.search.download":`Only history records within 2 months can be downloaded`,
"label.tabpage.deleteview":`Delete View`,
"label.chatter.recently":`Recently`,
"label.industrialandcommercialverification.title":`Industrial and Commercial Verification`,
"message.nextapproverlost":`The next specified approver is null.`,
"front-kefu-moudle-v1-mfsysy-time":`Remaining days for free trail`,
"label.role.assign.tip":`Choose a user on the Available Users list and add them to the Selected Users list to assign users to the role`,
"label.addattachment.step2.intruduce":`Repeat Step 1 and Step 2 to add multiple files.`,
"vue_label_pool_returnreasondiscription":`Reason Description of Return`,
"label.weixin.report.range":`Range`,
"label.wei.weiresearchtab":`Micro-poll Choice`,
"vue_label_report_setdrill":`Set Drill`,
"page_404_button_back":`Back to Previous Step`,
"label.customfields.autonumber.tip":`A system-generated sequence number that uses a display format you define. The number is automatically incremented for each new record.`,
"label.ccpeak.return.allrecords":`Return all records`,
"label.ccchat.notmember.active.group2":`You are not in the name with`,
"label.uniquename":`Unique Name`,
"label.emailtocloudcc.filed.ssl":`Secure Connection`,
"chatter.emailFollowMe":`Follows me`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Copyright. All Rights Reserved. Customer Service Hotline`,
"label.projectManagement.actualworkinghours":`Actual Working Hours`,
"label.quickbooks.fieldlabel.taxresale":`Tax Resale`,
"label.icon.12":`Service`,
"label.data.exp.dataexptemp":`Data Export Templates`,
"component_setup_tabs_label_add":`Added`,
"label.appointmentdetail.wizard.title10":`Start Date`,
"label.multilingual.close":`The multilanguage management is not enabled.`,
"message.error.username.notexist":`Invalid Username, please re-enter.`,
"label.batchadd.newbatchpage.des2":`If the field type is Auto Number, the number is automatically incremented for each new record without manual enter.`,
"vue_label_SMS_search":`Search for leads or contacts`,
"label.appupload.successWithUrl":`Your package is now available for install using the installion URL below.`,
"UG_Forcast_06":`Please select the users who are allowed to forecast`,
"vue_label_dashboard_secondarygroup":`Please select secondary group`,
"label.weixin..xsld.total":`Total Amount In Sales Funnel`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Failed to restore default`,
"label.addrecurrencetimetrigger":`Add Periodic Time Trigger`,
"label.emailsync.connectaccount":`Connect Email Account`,
"label_fiscal_years":`Fiscal year`,
"label.icon.164":`Coach`,
"label.batchadd.mustinput":`Field with`,
"message.newtabpage.nokeywords":`Your search term must have 1 or more characters. Or you can add advanced search criterias.`,
"label.login.verification.mfa.desc3":`If your account has been shared by multiple people, other unbound MFA people will not be able to login after you have successfully bound MFA. The solution is to have someone else install the MFA application and scan the QR code for this page, or save the QR code image for subsequent scanning by others. However, in terms of security best practices, we recommend that you cancel multiple shared accounts.`,
"label.partnerCloud.basicSetting.initialize":`You are not able to change the domain name after initialization.`,
"label.address.county":`County`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`Add Keys`,
"label.myusergroup":`My User Groups`,
"label.import.index.time-consuming":`Time`,
"label_tabpage_systems":`There are * systems`,
"batch.sendemail.s":`, Mail sent successfully.`,
"label.appointment.wizard.subtitle4-1-1":`15 min`,
"label.projectManagement.delete.milestone":`All related information of this milestone will also be deleted if you delete this milestone, and the data cannot be recovered. Are you sure to confirm the deletion?`,
"label.umeng.chatter.praise":`liked your post.`,
"font-evaluate-module-v1-evdetails":`Evaluation Detail:`,
"label.group.filter.resources.and":`Choose method for filtering resource, AND relation.`,
"label_emailtocloudcc_description":`Connect your enterprise email account, such as sales@company.com, info@company.com, support@company.com. Automatically log emails you recieved as leads and cases records in CloudCC to ensure timely follow-up of customer's letters.`,
"label.chat.topic.delete.prompt2":`Please note that topics of the same name in other communities will not be deleted.`,
"message.error.group.authorization":`You do not have access to set up this group`,
"label.attendance.wz":`Location`,
"vue_label_activity_notice_logacal_success":`You logged a call`,
"label.emailtocloudcc.step1.case1":`Email to Case`,
"label.h5.chatter.praisenum":`Received praise`,
"label_time_statistics_basis":`Time Basis`,
"label.onlyadmincanedit":`Administrators <strong>ONLY</strong> can edit records during the approval process.`,
"label.fieldtoolongmassage":`Field`,
"label.sales.team.shared":`Opportunity team sharing`,
"label_emailsync_status_department":`Department`,
"label.mobile.quickcreate.default.sellingfunnel":`Sales Funnel`,
"label.tabpage.closez":`Close`,
"homepage.components.two":`Step 2 choose the location where the custom components displayed`,
"label.everyday":`Everyday`,
"lable.Product.to.asset.BOM":`Product to Asset BOM`,
"label.appointment.wizard.subtitle4-3":`The invitee is able to choose a start in every`,
"label.customobjects.standardfieldslist":`Standard Fields List`,
"label.customfields.suretodelete":`Yes, I want to delete the custom field.`,
"component.chatter.label.to":`To`,
"label.emailsync.form.seversetting":`Setup`,
"label.service.gantt.enabled.resources":`Activated Resource`,
"label.tianyancha.h5.weibo":`Microblog`,
"template.chart.dddje":`Amount of Lost Orders`,
"label.pc.trigger.apiname":`The API name already exists, please try again.`,
"label.icon.34":`Set Up`,
"label.schedulejob.setup.schedule.prgname":`Application Name`,
"label.weixin.free.registration":`Sign Up for Free`,
"label.placeholder":`Quick Find`,
"label.emailobject.manage.template":`Manage templates`,
"label.knowledge.article.existsdata":`Other unqualified data exist.`,
"label.campaign.channel.lookup.ticket":`Check the Ticket`,
"label.searchlayout.relation.searchfield":`Search Filter Fields for related lists.`,
"label.recordid.cannot.empty":`Record ID cannot be null`,
"label_partner_workspace_member_choice":`Select profile`,
"vue_label_campaign_amount":`Income`,
"label.niue.time":`Niue Time`,
"front-homepageobject-module-v1-workload-ranking":`Workload Ranking`,
"message.error.datainvalid":`Error: Invalid data.`,
"vue_label_helpcenter_salesfunnel":`Use the new version of the sales funnel to analyze the follow-up of business opportunities and provide data references for your sales process.<br> In the upper left corner, records will be filtered according to conditions such as role or owner, and all visible business opportunities under the corresponding conditions will be viewed and analyzed. Click on the stage of the sales funnel chart to view all the records under that stage.`,
"vue_label_transferownernotice":`The owner of the record associated with this item will also be changed`,
"label.monitorsys.operator":`Acted By`,
"label.please.codeNorm":`Please choose code standard.`,
"label.campaign.channel.step6.remark2":`Enable employee solicitation`,
"market.potential.customers":`Market Lead`,
"label.customfields.phone.tip":`Allow users to enter any phone number. Automatically formats it as a phone number.`,
"label.currency.edit":`Currency Edit: Change Corporate Currency`,
"label.emailobject.emaildetail.button.markasunread":`Mark as unread`,
"label_partner_template_memo":`Title`,
"label.chat.message.search.all":`Search all information`,
"label_tabpage_hoursagoz":`hours`,
"label.customcomponent.developer.help":`Custom Components Developer Help`,
"setup_mainpage_label_welcome":`Welcome to CloudCC PaaS platform, the main functions of the platform are as follows:`,
"label.h5.similar.opportunity.list":`Results include closed-won opportunities that have one or more fields in common with your opportunity. Bookmarking opportunities adds them to the Similar Opportunities related list on your opportunity detail page.`,
"vue_label_record_count":`Record count`,
"label.icon.29":`Demo`,
"pagecreator.page.label.pagelayout":`Page Layout`,
"label.ggReleaseRange.searchRole":`Search a role`,
"label.campagin.member.field.setup":`Campaign Member Field Settings`,
"augest":`August`,
"label.salescloud.massloss.content":`Deactivating sales teams will irreversibly remove existing teams from opportunity and delete default opportunity teams of users.`,
"label.customfields.new.step2.opration.unique.info":`Duplicate values are not allowed.`,
"vue_label_email_optional_members":`Available Members`,
"label.emailobject.attachment.download":`Download`,
"label.recordamount":`Records`,
"front-kefu-moudle-call-recorder":`Call Recording`,
"label.more.info":`Details`,
"vue_label_commonobjects_view_secondsbefore":`{seconds} seconds`,
"label.emailsync.status.action":`Action`,
"label.customfields.totalsummary.collectedfields":`Summarized Object`,
"label.knowledge.setting.hint.two":`Attention: You cannot disable the Knowledge once enabled.`,
"label.login.access.yujidao":`Exp.`,
"label.assignment.setup.detail.description":`Add rule entries that specify the criteria used to assign leads to users automatically.`,
"message.error.marketsea.null":`Lead Pool does not exist`,
"lable.account.Current.CY":`Current CY`,
"vue_label_salesadvance_lost":`Loss`,
"label.file.ownedbyme":`Owned by me`,
"label.component.helper.nodata":`Nothing needs your attention right now. please check back later.`,
"label.weixin.appr.pending.auditor":`Submitted By`,
"UG_opportunity_004":`Multi-service type`,
"label.leadscore.setup":`Leads Scoring Settings`,
"label.addtimetrigger":`Add Time Trigger`,
"label.mr.title.match":`If exact match`,
"label.projectManagement.Newmilestone":`New Milestone`,
"label.preview":`Preview`,
"label.tabpage.issuez":`Issue`,
"label.img.max.size":`Uploaded image is too large, and the maximum size of uploaded image is 500K, please re-upload.`,
"label.mainpageset":`Configure Homepage Components`,
"label.user.login.false.lock":`Login attempts exceeded. The account is locked`,
"UG_solution_02":`The solution is an internal solution of institution to the problem that accounts encounter.`,
"vue_label_approve_put_away":`Collapse`,
"label.profile.existing":`Existing Profile`,
"label.ems.logininfo":`Login information`,
"label.weixin.location.service":`Objects that support location services`,
"label.multilang.datamoveaction.totaldata":`There is a total of {1} records satisfying the condition，maximum 100 records can be transferred at one time！：`,
"label.ccdocument.cannot.update.set":`This document does not belong Word or Excel or PPT type of the file,not uploaded to the red folder template.`,
"vue_label_fliter_addfliter":`Add Fliter`,
"label.custom.page.or.trigger":`(Custom Pages or Triggers)`,
"label.tag.filter1":`Filter out records that contain all selected tags`,
"UG.homepage.006":`360-degree visibility into your account activity through surveys, live chats, emails, work orders, social media posts, and even sales activities (such as leads, service support, and activities).`,
"SCORE":`Score`,
"label.file.library.managemembers2":`Manage Library Members`,
"label.email.template.public.SMS":`Public SMS Template Folder`,
"label.leadscore.donot":`Unable to score leads`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Preview`,
"UG_contact_04":`Or`,
"label.ccchat.person.invite.eminfo":`{0} has invited you to join {1} on CCChat.With ccchat you can chat with your colleagues, create teams for your projects, and share files.`,
"setup_object_field_dependency_label_actionfieldvalue":`Controlling Field`,
"lable.Product.options":`Product Options`,
"front-electronic-signature-add-autofill-field":`Add Auto-fill Field`,
"label.customfields.totalsummary.selectcollectedfields":`Select Object to Summarize`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Up to 10 digits can be entered for contract amount.`,
"label.forecast.shrepage.pagetitle":`Users, Roles and Territories Sharing`,
"label.login.access.mark":`To assist with support issues, you may grant your administrator or support personnel the ability to login as you and access your data.`,
"lable.outlook.edit.zdyout":`Custom Exchange Field Mapping`,
"label.approveoperate":`Approval Actions`,
"label.tabpage.linknamez":`Link name`,
"label.report.error.deletehavedashboard":`This report has a new dashboard and cannot be deleted`,
"label.summaryreport.2018.step1":`Step 1 Create a grouping`,
"label.campaignmember.main.leadtomember.title":`Field mapping configuration`,
"label.select.dashboar.type":`Please Select the Dashboard Type`,
"message.setup.field.picklist.valueexists":`This picklist value already exist.`,
"label.loading":`Loading...`,
"label.payments.paytip1":`Your current subscribed edition is not free edition, please click Confirm to refresh or re-login.`,
"label.view.appliedMobile":`Apply to The Mobile App`,
"label.multilang.forcast.financialyear":`{0} fiscal year：`,
"front-web-module-v1-detail-comment-opinion":`Feedback`,
"UG_Forcast_10":`Complete`,
"label.optionlistset":`Picklist Options`,
"label.visualpage_list.vpname":`Custom Page Name`,
"vue_label_calendar_failed_to_delete_calendar":`Failed to delete calendar`,
"label.json.string.null":`Empty`,
"message.serviceappo.time.violation2":`The available time violation of service appointment: The arranged end time of the appointment is earlier than the due date of the service appointment`,
"label.productsales.today.noevttsk":`There are no open events and expiring tasks.`,
"label_tabpage_emptyz":`Empty`,
"front-kefu-moudle-no-create":`Not created`,
"label.wedge.shaped.tail.arrow.cannot.empty":`Wedge tail arrow cannot be null`,
"label.continue.shopping":`Continue Shopping`,
"label.turntomain":`Jump to Master Content`,
"component.assistant.label.nodata":`No event today, please check later.`,
"label.payments.paytip4":`Please enter the number of users！`,
"label.appupload.upload.versionName":`Version Name`,
"label.chatter.endData":`End Date`,
"front-kefu-moudle-buytr-tip":`We hope you can have a great experience with CloudCC's call center, and that you can purchase an official call center account and we will provide better service.`,
"label.repw":`Retype Password`,
"label.tabularreport.intro":`Tabular report is one of the simplest and fastest ways to list data.`,
"label.selectoperatetype":`Select Action Type`,
"setup.layout.label.required":`Required`,
"label.default.designee":`Default Dispatched Peron`,
"label.ccdocument.cannotdel.folder":`You can not delete this folder because some files in this folder.`,
"label.escalation.setup.newentries.inputentries":`Enter the rule entry`,
"label.emailobject.addnewtemplate":`Add new template`,
"label_chatter_content":`Content`,
"label.htyj.mubiao":`Targets`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Friday`,
"label_tabpage_fieldoptions":`Record type field, option list field, and option list (multiple choice) field. it is recommended to enter at most 10 keywords, separated by commas to achieve “or relationship”, such as: "New York, Toronto, Tokyo".`,
"label.mobiletablayoutedit.remark2":`Select the fields displayed on tab home page in Mobile App.`,
"label.sendemail.chat.addComentsat":`Dear #name:\n\n #userName mentioned you in comment.`,
"Z":`Formula`,
"label.multilang.batchdeleteaction.movesuccess":`A total of {0} records have been deleted successfully！：`,
"label.textmessage.vonage.message2":`By setting up Vonage API accounts, users enable CloudCC to access their Nexmo API account to send and receive text mesages.`,
"label.file.use.document":`Storage space usage`,
"UG.Lead.011":`Create a clue`,
"label.view.name":`View Name`,
"label.data.downtemplate":`Download Template`,
"vue_label_appstore_get_now":`Get it now`,
"label.controlfield":`Controlling Field`,
"label.dataimport.type.insert":`Insert`,
"label.customfields.multiselect.tip":`Allow users to select multiple values from a list you define.`,
"label.weixin.approval.qxzjl":`Please select the record`,
"component.salesperformance.label.70finish":`Ended - unprocessed (>70%)`,
"Lead_Auto_Scoring_Setting":`Lead Scoring Setting`,
"pagecreator_layout_message_canntdelete":`The current layout is not allowed to delete`,
"vue_label_report_exprotpage":`Exporting Page: Page {page}`,
"label.campaign.channel.step4":`Step4: Select the required fields to display on marketing channel registration page`,
"label.app.launcher":`Application Launcher`,
"vue_label_campaign_selectedmember":`{member} campaign members selected`,
"label.mobile.quickcreate.default.approvals":`Approvals`,
"label.view.step4":`Step 4 Restrict Visibility`,
"label.exchange.sync.state.user":`User Sync Status`,
"label.forecast.customforecast.tab.forecast":`Forecasts`,
"label.theUserLoginForTheFirstTime":`User first login.`,
"label.workflowoperate.tip":`Specify the workflow actions that will be triggered when the rule criteria are met.`,
"font-evaluate-module-v1-ten-points":`Positive Mark: 10 points`,
"label.knowledge.delete":`Error while deleting knowledge`,
"front-console-see-contacts":`Identified {num} contacts`,
"label.h5.similar.opportunity.add.to.favorites":`Add To Bookmarked`,
"front-epwechat-module-v1-install-app":`Install in WeCom`,
"setup_layout_message_relatedlistbutton":`Select standard buttons to display on the related list.`,
"label.salescloud.massloss.title":`Could lead to large data loss.`,
"front-console-conversation-btn1":`Ring Back`,
"label.custom.canvasScale":`Canvas Scale`,
"label.lead.score.doing":`In the process of lead scoring`,
"message.approval.step.validation.invalid.number":`Invalid Number`,
"chatter.lk":`Like`,
"label.dashboardSetup.showmaxval":`Max Displayed`,
"label.keywords":`Keywords`,
"vue_label_helpcenter_SMS":`Turn on SMS function<br> If the countrycode of the CRM system you purchased is USA, then the SMS function is available in your organization's system. The organization administrator can enter the phone number purchased by your organization in the vonage system in the vonage gateway in the background integration application, and then use the SMS function in the menu of the sales cloud application.<br>SMS box<br> The SMS box is divided into two parts. On the left is the record of leads or contacts with SMS. After clicking a record, the sending and receiving details will be displayed on the right. You can view the records of yourself and your subordinates.<br>send group message<br> You can send group text messages in the SMS menu, the list of leads or contacts, and the button to send SMS messages on the members of the campaign. You can only send text messages to potential customers or contacts in CRM. After editing the text message, select "Send", and a group record will be generated regardless of the number of recipients, or you can select "Send separately" to send the text messages separately Separate SMS messages support showing the merged fields inserted in the SMS template.`,
"label.emailobject.createnewavailability":`Create new availability`,
"front-kefu-moudle-buytr-send-email":`You have not yet associated with the system mailbox. Please send an email to support@cloudcc.com and write your intention, company name and contact information, sales staff will contact you as soon as possible.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Collapse Chat Details`,
"label.marketseamemset.lead.maxuser":`Maximum Leads of Members`,
"label.forecast.forecastroleuserpage.shre.manager":`Only administrators can share this forecast`,
"label.file.noselect":`No file are selected`,
"label.notification.task3":`【被分配人】 change the Status of the task you assigned to 【新状态】`,
"label.dependfield":`Dependent Field`,
"lable.SalesCommitmentKanBan.receipts":`Receivables`,
"label_partner_workspace_member_search":`Search`,
"label.share.originally.posted":`Initial poster`,
"label.autonumber":`Auto-No.`,
"label.view.sortview.name":`View Name`,
"label.h5.add.activity":`Add activity`,
"label.textmessage.vonage.phone.number":`Phone Number`,
"label.partnerCloud.financeSetting.enterApiKey":`Please enter API secret key`,
"label.industrialandcommercialverification.enablestatus":`Enable Status`,
"label.reportTypeFocusD1":`Specify what type of records (rows) will be the focus of reports generated by this report data source.`,
"vue_label_report_four-levelseriesobjecttree":`Four-level Objects Tandem`,
"label.mobile.default.catalogue":`Default Catalogue`,
"label.partnerCloud.partnerAccount.again":`Recharge`,
"label.summaryreport.step2.new":`Step 2 Select the grouping method of summarized data`,
"label.tabpage.cancel":`Cancel`,
"label.multilang.datamovelist.datamove":`Transfer several {0} from a user to another user:`,
"label.conferloginandvisitlimit":`Granted Login Access`,
"vue_label_help_viewhelpcenter":`View CloudCC Help Center`,
"label.leadscore.norule":`No lead scoring rules,please create a lead score rule or active an exsiting rule`,
"label.tabpage.exitz":`Exit`,
"label.DeploymentStatus":`Deployment Status`,
"label.layout.saving":`Saving Layout...`,
"label.emailobject.emaildetail.field.object":`Object`,
"label.customfields.searchrelation.fieldtag.tip":`Enter the labels to use on display view, page layout view, report view and list view.`,
"message.huanxin.bindtenant.notfound":`Unbound Agent`,
"label.referpersonalias":`Submitted By`,
"label.icon.31":`Computer`,
"label.appupload.upload.install.thispackage":`This package`,
"label.appointment.wizard.subtitle1-1":`Custom`,
"pagecreator_page_message_save_fail":`Page save failed`,
"label.lastset":`Finally According`,
"label.version.support.limited":`Support Limited`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Edit Search Layout`,
"template.dashboard.customer.analysis":`Accounts Analysis`,
"label.continue_editing":`Continue Editing`,
"label.version.sum.customtab":`custom tab(s)`,
"label.validate.function.funcExplain.TIMEVALUE":`Returns the local time value without the date`,
"label.import.page1.selectobjfromdata":`Select objects to import data`,
"label.partnerCloud.basicSetting.success":`Initialize successfully`,
"label.customfields.fielddependency.cannotcreat":`The field you select depents directly or indirectly on itself, so you cannot create a denpendency.`,
"label.umeng.activity.youhaveatask":`You have a new task.`,
"label.file.folder.create":`New Folder`,
"vue_label_campaign_member_status":`Member status`,
"lable.opppdt.addpdt.table.date":`Date`,
"label_partner_workspace_login_buttontext":`Button text`,
"label_other_mistakes":`Other Errors`,
"label.must.be.configured":`Must Be Configured`,
"label.customize.memory.function.sorting.enable":`Activate Memory of Header Sorting`,
"setup.layout.label.areaname":`Section Name`,
"label_chatter_pastThirtyday":`The past 30 days`,
"setup_mainpage_label_welcome25":`Instructions: Click on the menu on the left side of this page → Manage Settings → Security Control → Sharing Settings.`,
"label.ccchat.person.invite.succsend":`An invitation to join the CCChat is sent to`,
"label.select.time.range":`Please choose time range`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Add products to the cart, where you can adjust the quantity and view the price.`,
"label.manageAll.sta1":`Pending`,
"label.cy.select":`Pick a new currency from the available list.`,
"chatter.lam":`Comment`,
"label.partner.setup.title":`Settings`,
"component.setup.label.displaybutton":`Display button`,
"component.salesperformance.label.target":`Indicators`,
"label.campagin.channel":`Please enter the channel value`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(field)`,
"UG.homepage.009":`Access CRM`,
"label.file.item":`Project`,
"label.file.library.addmembprompt":`The following are already members.`,
"label.bmap.releasePosition":`Location`,
"setup_object_layout_label_selectedprofile":`Selected Profiles`,
"label_emailsync_message":`Prompt`,
"label.view_submissions":`View Submissions`,
"lable.tianyancha.repeated":`Repeated selection`,
"label.import.index.introduce":`Import your data into the system in three simple steps`,
"label.time.operation.new":`New Scheduled Job`,
"label.projectManagement.Pleaseentersettlementtype":`Please enter settlement type`,
"label.icon.169":`Tour Car`,
"vue_label_commonobjects_detail_related_listview":`List`,
"label.view.step1":`Step 1 Enter View Name`,
"label.summaryreport.intro":`Summary reports show both data subtotal and other summary information.`,
"vue_label_file_input_correct_name":`Please fill in the correct name`,
"System_Email_Template_Title":`Welcome to CloudCC CRM platform`,
"label.tianyancha.province":`Provincial abbreviation`,
"label.deleteall.sure":`Are you sure you want to delete all?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Must mix numbers and uppercase and lowercase letters`,
"front-lightning-module-v1-details-page-chart-select":`Choose object and display`,
"setup_mainpage_label_welcome8":`Drag-and-drop interface customization`,
"lable.outlook.edit.lastupc":`Last Updated Contact`,
"label.weixin.registered":`Sign Up`,
"vue_label_file_history_version":`Revisions`,
"vue_label_campaign_earned":`Amount to be collected`,
"label.staticresource.useful.realtion.tip":`Below is a list of all CloudCC.com pages references to this static resource.`,
"vue_label_file_libraray":`Libraries`,
"label.department.phone":`Mobile Number`,
"label.emailtemplate.edit":`Edit Email Template`,
"label.processsetting.key.information.tips":`Key Information and Tips`,
"label.summaryreport.step7":`Step 7 Select the chart type and the highlight item`,
"label.chat.topic.remove.favorite":`Delete from Bookmarked`,
"label.campagin.roi.ksrq":`Start Date`,
"label.data.downpage.e_title.e_btn":`Go to the Export Page and Start`,
"label.approvaldatamove.dname":`Current Approver`,
"lable.Partial.attributes":`Partial Attribute`,
"template.report.enabled.products":`Activated Products`,
"lable.outlook.detail.cto":`CloudCC.com to Exchange`,
"label.sendemail.activity.newtasktitle":`New task notification`,
"label.validate.function.funcFormat.DAY":`DAY(date)`,
"label.log.datetime.value":`Please enter query time`,
"label.import.index.updaterecord":`Update record`,
"label.registration.page.invitation":`Registration page invitation`,
"pagecreator_systemstyle_label_detailcolor":`Detail text color`,
"label.tabname.cannot.empty":`Tab name cannot be null`,
"label.data.newtemplate.savetemp":`You can save as a template and use the fields and criterias for this data export as data export templates. Please enter the template name and description carefully to facilitate your use.`,
"label.ems.body":`Body`,
"enc":`Encrypted Text(Storage Encrypted)`,
"label.profile.mobile.setup.commonSaler":`General sales`,
"label.continueselectproduct":`Continue To Choose Products`,
"label.event.new":`New Event`,
"label.renametabandtaglib":`Rename Tab and Label`,
"label.qrcodelogin.message.exception":`Server exception, please contact your administrator.`,
"label.service.gantt.locationToGantt":`Gantt Chart`,
"label.mr.theLastGroup":`This is the last group. Click "Back to view the duplicate records list" to view duplicate records.`,
"label.report.export.format.content":`Export current report header, groups and details. The maximum number of details can be exported is`,
"label.version.accountandcontact":`Accounts and Contacts`,
"label.partnerCloud.financeSetting.enterMd5Key":`Please enter MDS secret key.`,
"label.login.access.quater":`Week`,
"vue_label_commonobjects_view_searchthisview":`Search this list`,
"label.import.step1.allobj":`All objects`,
"front-efficient-project-management":`Project Cloud provides full lifecycle management from project kickoff, planning, execution, control to closure, optimizing the project management process according to your business needs and helping you manage projects efficiently.`,
"label.includedvalue":`Include Values`,
"label.service.newBuildDialog.past.days":`days past`,
"vue_label_report_sortup":`Ascending Sort`,
"label.appointment.wizard.subtitle3-2":`Tuesday`,
"label.dashboard.trend":`Tendency`,
"label.schedulejob.setup.schedule.st2":`The 2nd`,
"label.view.sortview.number":`Number of records`,
"lable.Please.enable.order":`The order is not activated, please activate.`,
"label.datamanage.immediately.import":`Import`,
"label.delete.condition":`Clear`,
"label.dashboard.chooseDispalyOnTheHomePage":`Select the homepage to display`,
"asset.accountid.contactid.required":`Each asset needs to be associated with an account or contact.`,
"label.mask.character":`Mask Character`,
"lable.account.Previous.FY":`Previous FY`,
"chatter.attachment":`Add Files`,
"label.view_only":`View Only`,
"label.tianyancha.name":`Company name`,
"label.service.gantt.avg.traveltime":`Average trip time of service appointments`,
"vue_label_pool_move":`Move`,
"label.import.index.beforeexport":`2、Before importing, please make sure to import all related records. For example, if you are importing contact records and you want to fill in the account field, which is a lookup field, you need to create the account record you are filling in first, then import the contact record and fill in the account field with name or ID of the corresponding customer.`,
"label.view.delete":`Delete`,
"template.detail.info.link":`Details Link`,
"label.sendemail.send.setfail":`The email information setting failed, please fill in the correct email information.`,
"label_emailtocloudcc_redmessage11":`authentication of SMTP fiailed. Please check that the Email address and password are correct.`,
"label.campaigns.memberalert":`Please select a member at least`,
"label.schedulejob.setup.schedule.frequency":`Frequency`,
"component.newrecords.label.all":`View all`,
"label.mr.caption.opportunity":`Find Duplicates and Merge: Coditions for querying duplicates of Opportunities`,
"chatter.group.onlyMembers":`Only members can see this group. And only the group owner has permission to add team members.`,
"label.recordtype.edit.selectvalue.show":`Picklist values are displayed in the order in which they are saved.`,
"message.textmaxlength":`Length ghould not exceed 255 characters`,
"label.reportsSubscriptionPage.visibility":`Running as`,
"label.umeng.chatter.addcoments":`Your cloud post has 1 new reply`,
"chatter.up.f":`Upload Failed,unknown error.`,
"label.icon.146":`Keyboard`,
"lable.custom.CY.Ago":`2 CY Ago`,
"label.tabpage.step3":`Step 3 select the fields to display`,
"label.checkfield.introduce":`Set the fields of the object that can be used to check for duplicates, and find the dupilcates in record list by the fields you set.`,
"label.tag.addtags":`Add Tags`,
"label.service.newBuildDialog.characterlimit":`The name exceeds the limit of 25 characters.`,
"font-evaluate-module-v1-evquestions":`Evaluation question`,
"label.knowledge.only.update.draft":`Only update draft`,
"label.partnerCloud.basicSetting.defaultCounts":`Default roles number for adding partner account`,
"label.chat.topic.delete":`Delete`,
"label.workflow.contentcondition":`criterias are met`,
"vue_label_commonobjects_view_sortby":`Sort by {field}`,
"label.passwordPolicy.setup.pwdremember24":`Remeber (0) password`,
"front-kefu-moudle-free-account":`Trial Account`,
"label.marketsea.isautorecycle":`Enable automatic recycling`,
"label.addattachment.view":`View Files`,
"vue_label_helpcenter_contact":`In the detailed information, click the tree diagram button next to the contact, you can view the contact hierarchy diagram, understand the leader-member relations of related contacts, and view some field information of each contact.`,
"label.taskevent":`Activities`,
"label.industrialandcommercialverification.message":`Run out of today's free enquiries`,
"label.object.already.delete":`The object deleted`,
"label.project.hit.four":`Subtask Update Notice`,
"label.taskpagelayout":`Task Page Layouts`,
"label.version.sum.locationfield":`Geolocation fields`,
"front-sales-button-toQB":`Sync to QuickBooks`,
"label.app.oceanblue":`Ocean Blue`,
"label.operating":`Operating...`,
"label.customfields.formula.dateexample":`Reminder Date = CloseDate - 7`,
"label.happen_delete":`What happens if I delete a form?`,
"label.service.appointmentList.plansToStart":`Start Plan`,
"label.persmets.operate.licence":`Permission`,
"label.mobile.quickcreate.default.activities":`Calendar`,
"label.australian.eastem.standard.time":`Australian Eastern Daylight Time （New South Wales）`,
"label.emailobject.remove":`REMOVE`,
"label.weixin.vote":`Vote`,
"label.reportsSubscriptionPage.condition.aggregate":`Aggregate`,
"front-kefu-moudle-has-unbind":`You Have Been Unbound`,
"chatter.group.newGroup":`New Group`,
"label.tabpage.systems":`There are * systems`,
"label.textmessage.vonage.connect":`Connect to Vonage`,
"label.campaign.channel.input.ticket":`Send Entrance Ticket`,
"label.ccpeak.query.sharetab":`Search Sharing Forms`,
"label.reporttype":`Report Data Source`,
"message.duplication.label.isprofiletip":`If checked, the data that the current user can see is verified when find duplicates. Otherwise, verify all data.`,
"label.tianyancha.businessverify.xieyi":`CloudCC user license agreement`,
"font-evaluate-module-v1-select-person":`Please select customer service staff`,
"vue_label_chatter_all_groups":`All Groups`,
"label.recordtype.profile.setdefault":`Set as Default`,
"label.mr.descreption.nocondition":`No duplicated data meeting the conditions.`,
"label.tabpage.askz":`What would you like to ask`,
"label.marketsea.selectMember":`Select Member`,
"template.report.stage.possibility.analysis":`Stage Possibility Analysis`,
"label.data.selectderivedobject":`Select the object to export`,
"label.customfields.formula.explain":`Description: currently supports the number, percentage, and other fields of the four principles, as well as carry values of the lookup field. For example: number calculate: unit*unitprice&nbsp;&nbsp;&nbsp;&nbsp;lookup field carry value:contact__r.address`,
"vue_label_notice_change_fail":`Change failed`,
"label.customobjects.trackoldandnewvalues":`Track old and new values`,
"label.h5.leftprompt":`You have some edited content which has not sent, are you sure to leave?`,
"label.select.field":`Available Fields`,
"label.customobjects.layoutedit":`Page Layout Assignment`,
"label.false":`FALSE`,
"UG_Forcast_07":`Allow Forecast`,
"vue_label_chatter_team_member":`group member`,
"label.tabpage.retypez":`When the record type is changed, the existing option list values will not be automatically changed. we recommend to update the existing options list value of the record in the same place.`,
"front-epwechat-module-v1-single-desc":`Single Sign On other ends of CloudCC through WeCom; Swift switch among all ends.`,
"label.closeandconverted":`Closed-Converted`,
"label.service.confirmed":`Confirmed`,
"label.partner.workspace.member.cloudcc":`CloudCC profile`,
"label.star.click":`Click to clear`,
"label.icon.135":`Currency`,
"button_partner_workspace_login_logo_upload":`Upload image`,
"message.error.sql.constraint.recordnotsingle":`External ID set up successfully. Reason: this field in the original data has duplicate data.`,
"label.ccchat.person.invite.errorpwd":`Use at least 8 characters and include a combination of numbers and characters`,
"label_tabpage_isdeleterecord":`If delete the selected record`,
"label.weixin.prompt.message":`Prompt Message`,
"vue_label_chatter_view_original_post":`View original post`,
"label.multilingual.tip3":`Enabling multilanguage allows each user in the organization to configure languages you enabled.`,
"label.dataimport.error.datetime":`Error: Data and time format is incorrect`,
"label_tabpage_addcondition":`Add Criteria`,
"label.query.detail.manageexcludeuser":`Manage External User`,
"label.tianyancha.creditcode":`Unified social credit code`,
"label.cy.enter":`Enter the conversion rate from your corporate currency to this new currency.`,
"label.textmessage.vonage.message1":`By integrating with Vonage, users can send and receive text messages on CloudCC Platform via Vonage. However, users should register Vonage accounts and buy phone numbers before they can send text messages.`,
"front-marketing-module-v1-share-invitation":`Share Staff Invitation`,
"label.file.items":`item(s)`,
"label.otherwise":`Otherwise`,
"label.permission.detail.system":`System`,
"message.success.task.emailsend":`Save and send email message successfully`,
"label.the.reward.group":`Quote Line Group`,
"setup.layout.label.relatedlistsetup":`Related List Settings`,
"label.empty":`Clear`,
"label.weixin.cloudcc.user.binding":`CloudCC User Binding`,
"label.file.what.change":`What changed?(optional)`,
"label.search":`Search`,
"label.mobile":`Mobile`,
"template.report.month.potential.customer":`Leads of This Month`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Enable Validation Rules when using Card Scan`,
"lable.outlook.list.des":`Exchange Sync configuration defines the settings for CloudCC for Exchange to apply to a specific user group.`,
"label.appupload.install.error.info":`{0} "{1}" has been used by {2}, please rename the existing {0}.`,
"label.tabpage.addoptionsz":`Add options`,
"label.arabian.standard.time":`Arabia Standard Time`,
"label.thefirst":`The 1st Column`,
"label_partner_workspace_login_footertext":`Footer Text`,
"lable.Disabled.successfully":`Deactivate successfully.`,
"label.confirm.del":`The pending approval records, are you sure you want to delete?`,
"vue_label_normal_reregister":`Login again`,
"label_file_img":`Image`,
"label.salescloud.salesdashboard.sales.behavior":`Sales Activities`,
"label.startdate":`Start Date`,
"label.field.duplicate.error.msg5":`Please check all errors bellow, retry after modification.`,
"setup.main2018.label.managesetup":`Administration Settings`,
"label.forecast.editshrepage.title":`New Sharing`,
"UG.solution.01":`Provide the solution`,
"label.knowledgebase.data.recovery.successfully":`Recover {a} data successfully`,
"label.pc.ui.2018.myccchat":`My CCChat`,
"label.attachement":`Notes`,
"message.mobilechooseatmostten":`Select up to 10 fields`,
"label.campagin.roi.bhzeywjh":`Total Opportunities`,
"label.autoresponserule":`Auto-Response Rules`,
"label.attendance.yuyue":`You do not have an appointment. Do you want to regist now?`,
"label.insert":`Insert`,
"label.service.ganttBaiduMap.shutDown":`Do you want to close?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Zone violation: zone of resources is not matched with service zone of appointment.`,
"label.appointment.disable.function":`Disabled Functions`,
"lable.currencyManage.manageexchangeRate.dis":`To manage dated exchange rates for your organization, click Manage Dated Exchange Rates. Dated Exchange Rates are used in opportunities, opportunity products, and the reports associated with these two objects.`,
"vue_label_file_upload_tip_newmsg":`Less than {size} MB file is recommended to upload, or slowly loading problems can result.`,
"label.event.next.week":`Next Week`,
"label.datamanage.import.contactfield":`In the following table, select the fields in the imported file that should be imported into each contact. Then click Next:`,
"label.projectManagement.time.allocated":`Assigned time`,
"label_tabpage_isdeleteview":`Are you sure to delete this view?`,
"label.pc.ui.2018.search":`SEARCH...`,
"label.role.createrolelevel":`Create Role Hierarchy`,
"label.tabpage.editview":`Edit View`,
"label_partner_common_manageSetup":`Partner cloud adminstrative settings`,
"label.service.gantt.noservice.resource":`No service resources were found available under the selected service territory.`,
"message.numbertoolarge":`The number is too large`,
"label.sendsms.success":`The text has been sent successfully`,
"UG.opportunity.009":`Or`,
"label.ccpeak.construction.dataobj":`to build a data object, the API name of the object must be passed in`,
"front-lighting-module-v1-detail-file-uploadInfo":`The record is locked and not available for uploading files. Please contact the admin for unlock.`,
"label.import.page2.newnotmatchfiled":`A total of {{ csvfiledlength }} fields in the file. {{this.csvfiledlength - this.selectlength}} unmapped.`,
"label.ems.inputmailss":`Receive email server`,
"label.knowledgebase.data.published.successfully":`Publish {a} data successfully`,
"label_emailtocloudcc_position":`Position`,
"label.data.exp.customexp":`Custom Export`,
"component_chatter_post_button_user":`Add people`,
"label.new.visualpagefolder":`Custom Page : New Folder`,
"label.forecast.shrepage.classdes":`Description of Access Levels`,
"label.task.overdue.unfinished":`Overdue Unprocessed Tasks`,
"label.ccchat.micropost.isedit.setting.info":`The author of the post or comment, the owner of the record, the CCChat moderator, and the moderator of this community all have permission to modify this text.`,
"label.recordname":`Record Name`,
"label.posted_your":`and posted in your`,
"label.globaloperation.operationtype.custom.page":`Custom page`,
"label_tabpage_busoppnamez":`Opportunity Name`,
"front-epwechat-module-v1-schedule-desc":`Sync WeCom schedules and CloudCC events`,
"label.escalation.setup.newentries.lastmodifydate":`Based on last modification time`,
"setup_layout_label_nofield":`No available fields`,
"label.sendemail.registIMUser.logininfo":`The partner cloud portal you can login is as below:<br>`,
"label.weixin..xsld.kehu":`Accounts`,
"label.display_thank":`Show Thank You Page`,
"label.group.no.my.group":`There are no matching my group.`,
"label.partnerCloud.newBuildSite.enterDomain":`Please enter the domain name`,
"label.step1.total2":`Step 1 of 2`,
"label.ccpeak.delete.record":`Delete the records:`,
"label.customer.tab.step1.introduce":`Choose the custom object for this new custom tab. Fill in other details.`,
"label_tabpage_newInterfacez":`The new interface`,
"setup.mainpage.label.manageuser":`Users Management`,
"label.partnerCloud.partnerAccount.completed":`Payment completed?`,
"label.projectManagement.kanban":`Task Kanban`,
"label.operate":`Action`,
"label.service.dispatchingUnits.selected.time.range":`Display service appointments within the selected time range.`,
"component_setup_label_pagesize":`Numbers displayed at every page`,
"font-evaluate-module-v1-email-evaluation-settings":`Email Evaluation Setup`,
"label.service.dispatchingUnits.skills":`Skill`,
"label.editrecurrencetimetrigger":`Periodic Time Trigger Edit`,
"vue_label_file_edit_lib":`Edit file library`,
"label.campaignmember.selectmember.deleteconc":`Campaign: remove members from contacts`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Monday`,
"front-detail-module-v1-by":`by`,
"label.mobile.home.page.date.signed":`Close Date`,
"label.apply.send.success":`Send successfully`,
"label.app.choseimg":`Choose Logo`,
"label.customsetting.visible":`Visibility`,
"label.sendemail.activity.task.distributetaskcompleted":`The task you assigned to #belongtoidccname has completed.`,
"label.dashboard.snapshot.refreshing":`Refreshing`,
"label.document.name.already.exists":`This Document Unique Name already exists.`,
"label.ccchat.person.invite.needlastname":`Enter your last name`,
"pagecreator_page_button_copy":`Copy`,
"label.appointmentpage.wizard.subtitle1-2":`Previous Week`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(date)`,
"label.profile.allowtocreateview":`Create Views`,
"message.error.recordid":`Record id cannot be empty`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Back to Superior Role`,
"label.translation.start3":`If necessary,select an object. For example, a workflow task has an object(Account, Contact, etc.) to filter for translatable terms.`,
"label.ccpeak.send.email":`Send an email to notice:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`No expiration date`,
"label.permission.objectpermission.objpermission":`Object Permission Settings`,
"label.version.custom.report":`Standard Reports(Custom Page)`,
"label.title.qrcodeOrbarcode":`Generate Bar Code/QR Code`,
"label.emailtocloudcc.step2.name":`Configue Email Attribution`,
"label.reportsSubscription.edited.successfully":`Edit report subscription successfully!`,
"label_tabpage_kanbansetup":`Viewboard setup`,
"label.tianyancha.regcapital":`Registered capital`,
"front-epwechat-module-v1-web-single":`Web Single Sign On:`,
"label.visualpage.display.top":`display header, false-do not display header`,
"label.customfields.fielddependency.selectcell":`Select at least one cell from the list below`,
"label.paging.addmember.totalofpages":`A Total of {0} item(s)`,
"label.email.saveing":`Data is saving...`,
"label.userinfo.doublepwd.notnull":`You must repeat your password.`,
"label.appointment.wizard.subtitle4-4-2":`2 weeks`,
"label.chatter.BCC":`Bcc (blind courtesy copy)`,
"label.emailtocloudcc.description":`Connect your enterprise email account, such as sales@company.com, info@company.com, support@company.com. Automatically log emails you recieved as leads and cases records in CloudCC to ensure timely follow-up of customer's letters.`,
"label.sendemail.send.atlastone":`You must select one recipient at least.`,
"label.mobile.phone.subordinate":`Include the subordinates`,
"label.data.choses.e_desc":`According to your needs, you can export all data or export data from a object.`,
"chatter.new":`News`,
"vue_label_help_back":`Back`,
"label.skipwizardintro":`The Jump Start Wizard creates a one-step approval process for you in just a few minutes.`,
"label.weixin.fmu.before.week":`{0} week(s) ahead`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat liked your post`,
"lable.currencyAdv.andafterdate":`and after`,
"label.sometoprocess":`If only certain types of records should enter this approval process, enter that criteria below. For example, only expense reports from employees at headquarters should use this approval process.`,
"label.campaignmember.main.updateleaddesc":`Update all leads status at once`,
"label_partner_common_roleSetup":`Partner Cloud Roles and Users Setup`,
"label.console.step5.no":`Choose How Records Display`,
"label.salescloud.teamrole.optionlist.account":`Add member of account team to`,
"Report.Delete.Confirm.Title":`Please Confirm`,
"label.onclick":`Click`,
"label.weixin.input.identifying.code":`Please enter the verification code`,
"label.knowledge.translate":`Only knowledge article of principal edition in the status of Draft or Published can be translated.`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Check in Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Additional Emails`,
"label.icon.104":`Schedule`,
"label.partnerCloud.exceedTwo":`The profile photo uploaded cannot exceed 2MB!`,
"label_tabpage_thevalurofz":`The value of`,
"front-lightning-module-v1-details-page-chart-maximum":`Up to 50 characters can be entered.`,
"label.data.downpage.i.title.num6":`It is recommended that you import a test file containing 5 records before importing the data to ensure the data you want to import is correct.`,
"label.ccpeak.update.record":`Modify Records`,
"label.dataimportandexport":`Data Import And Export`,
"label.tabpage.notexceed25":`The selected record must not exceed 25`,
"label.starting":`In Progress`,
"label.knowledge.language.spanish":`Spanish`,
"label_emailtocloudcc_set":`Set Mailbox Information`,
"message.oneormoreneedsreport":`dashboard use this report.Please delete the reference instrument panel assembly for the report,and then try again.`,
"label.attendance.xccheckin":`Check In`,
"label.emailmerge.editfolder.title":`Mail Merge Template Folders`,
"template.report.year.customer":`Leads of This Year`,
"label.partner.common.webSit.memo":`Default domain name of partner cloud of your organization:`,
"label.partnerCloud.financeSetting.onlinePayment":`Online Payment`,
"Pagelayout.Setup.001":`Please select the related lists which would be displayed on hover layout.`,
"front-kefu-moudle-time-length":`Duration`,
"label.deleteObject":`Object is deleted.`,
"label.setup.mobile.homepageshortcuts.select":`Select 4 swift fucntions to show on the top area of __the homepage`,
"setup.mainpage.label.welcome26":`Data Management - Batch Processing`,
"label.ServiceCloud.yuyuebainhao":`Service Appointment No.`,
"label.emailobject.emaildetail.button.addtolead":`Add to Leads`,
"label.event.single.view":`Single User View`,
"lable.product.pricebooks.ustand":`Choose Standard Price`,
"label.emailtocloudcc.department":`Department`,
"component_assistant_label_30daysnoact":`30 days without any campaign`,
"label.weixin.no.pending.qzkh.qin":`Sorry, no leads to show.`,
"label.vlidaterule.formula":`Error Condition Formula`,
"label.tianyancha.h5.contact":`Contact information`,
"label.button":`Buttons`,
"message.checkemail":`<strong>Error:</strong> There is an error in the entered email, please check.`,
"lable.account.previous.CY":`Previous CY`,
"label.icon.13":`Service`,
"chatter.coll.c":`Remove Bookmark`,
"label.knowledge.category.hint.four":`Data Category Allocation`,
"label.tianyancha.phonenumber":`Phone number`,
"label.tablayoutedit.remark":`Select the fields and custom pages displayed on tab home page.`,
"label.shareusers":`Sharing Users`,
"label.endtime":`End Time`,
"label.length":`Length`,
"label.umeng.activity.event.begin":`begin after`,
"label.tabpage.alltabs":`All Menu`,
"label.exact.query":`Refined Lookup`,
"label.weixin.skip":`Jump To`,
"label.ems.cancel":`Cancel`,
"label.trigger":`Triggers`,
"label.exchange.sync.setting":`Exchange Sync Setup`,
"label.product.pricebooks.name":`Price Book Name`,
"label.relation.list.total":`Selected`,
"label.step2.total7":`Step 2 of 7`,
"label.martrixreport.2018.step6.new":`Step 6 Select the chart type and the highlight item`,
"label.standard.buttonandlink.override":`Override Width`,
"front-console-conversation-btn4":`Separate as New Case`,
"vue_label_dashboard_range":`Range`,
"label.app.sort.show":`The application is displayed in the saved order.`,
"label.salescloud.teamrole.choose.correct":`Duplicate users selected, please correct`,
"label.schedule_post":`Publish Post`,
"front-kefu-moudle-server-request-num":`Service Request List No.`,
"label.h5.logout":`Log out`,
"label.weixin.horse.club.member.message":`Aid-Max members information`,
"label.field.addoptionlist.introduce":`Enter one or more picklist values below,with each value separated by a new line.`,
"setup_layout_label_setupfield":`Field Propertities`,
"label.chatter.nextStep":`Next Step`,
"label.quickbooks.searchlist.total1":`There are {0} unlinked invoices for a total value of {1}`,
"label.tianyancha.h5.regcapital":`Registered capital`,
"label.icon.184":`Advisory`,
"label.dashboard.message.refreshtoomush":`The dashboard snapshot is refreshed too frequently, please refresh later`,
"label.umeng.approval.reject":`#approver has rejected your approval request #obj.`,
"label.h5.chatter.newmessage":`Enter a new message`,
"message.error.relationid":`relationid cannot be empty!`,
"label.setup.mobile.offlinecache.selectdefault":`Select the tabs as default offline cache tabs`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Please select 4 swift functions.`,
"label.projectManagement.Selectmonth":`Select month`,
"label.version.ultimate":`Ultimate Edition`,
"label.validate.remark5":`The mandatory date fields are in the correct order, for example: the start time must be less than the end time`,
"label.version.nowis":`Your current CloudCC version is`,
"front-kefu-moudle-CRM-set":`CRM Setup`,
"label.mr.title.customerAddress":`Account Address`,
"label_emailtocloudcc_step1_name":`Choose Function`,
"label.time.operation.edit":`Modify Scheduled Jobs`,
"label_tabpage_operationz":`Field, operation cannot be empty`,
"label.translation.start4":`Double click in the translation column to enter new values.`,
"vue_label_systemSettings_request":`Request for Batch Transfer`,
"label.maintenance.notice":`Maintenance Notice`,
"label.customfields.txet.textlength.tip":`Please enter the maximum length for a text field below and the maximum length is 255 characters.`,
"label.ccdocument.select.template.open":`Please select the template to open.`,
"vue_label_display_date_field":`Show Date Fields`,
"label_partner_workspace_tab":`Menu`,
"lable.account.LasthDays":`Last 120 Days`,
"chatter.using.sticker":`Enable Feed Tracking`,
"message.save.dataerror":`Error: Save error caused by long data length or other problems. Please modify the data and resave.`,
"vue_label_commonobjects_view_chart_newchart":`New Chart`,
"label.chat.micropost.a.group":`Group`,
"lable.currencyManage.advcurrencyunEnabled":`Advanced Currency Management is not enabled`,
"label.appexchange.workflow":`Workflow Rules`,
"vue_label_calendar_show_details_and_add_events":`Show details and add events`,
"label.salescloud.optionlist.inputname":`Please enter the picklist value name`,
"label.dashboard.folder":`Folders`,
"label.knowledgebase.permanently.remove.articles":`Deleting archived article will cause other relavent versions also be deleted permanently.`,
"label.emailtocloudcc.titel":`Email to CloudCC`,
"label.visualpage.sel":`Custom Pages In This Folder`,
"label.planned.all.work":`All Planned Jobs`,
"label.weixin.agree.agreement":`Agree to the relevant agreement`,
"label.forecast.customforecast.qsn":`Start Year`,
"label.appupload.managed":`Controlled`,
"template.report.folder.sale.index":`Analysis of Sales Indicators`,
"UG_opportunity_011":`Import transaction`,
"label.validate.function.funcFormat.SECOND":`SECOND(date)`,
"UG_homepage_005":`Sales intelligence`,
"label.clicktoreturn":`Click here to back`,
"label.collectionofview":`s View Sets`,
"com.cloudcc.login.error.message.nonuser":`Your id does not exist`,
"vue_label_systemSettings_emailsetting":`Email Setup`,
"vue_label_email_mark_as":`Mark As`,
"label.tabpage.customernamez":`Customer name`,
"label.appupload.install.apicannotsame":`The new api name cannot be the same as the original value`,
"label.task.all.undealt":`All Overdue Unprocessed Tasks`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Statistical Index`,
"UG.quota.02":`Change opportunity stage`,
"label.approve":`Approve`,
"vue_label_calendar_remove_calendar":`Remove Calendar`,
"label.mr.title.contactName":`Contact Name`,
"label.projectManagement.resource":`Resourced management`,
"label.rejectbehaviour1":`Allow approver to manually choose back to step number.  (return to previous Step N)`,
"label.publicgroup.relationship":`Group Membership`,
"Lead.Scoring.DetailedPage.Popup.Title":`Lead Insight`,
"label.owner.edit":`Owner Edit`,
"label.campaign.channel.ticket.mark":`NOTE: Save the QR code to the photo album by using the mobile phone screenshot or save it to the mobile phone and enter the campaign with the QR code.`,
"label.opportunity.setting.showstage.info":`Whether to show opportunity stage on the CloudCC app.`,
"label.emailobject.wizard.desc3":`Save time by using email templates`,
"label.cpq.quote.no.product.add":`No products added in the quotation. Please add product before generating orders.`,
"label.customer.tab":`Custom Tabs`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Close Date of Current Stage`,
"component_telerecord_label_name":`Names`,
"label_component_helper_nodata":`Nothing needs your attention right now. please check back later.`,
"label.dashboardSetup.d2":`Breakpoint 2`,
"setup.mainpage.label.welcome4":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Object.`,
"label.step4.total5":`Step 4 of 5`,
"label.payment.the.remaining.days":`Your license expires in {0} days`,
"label.encoding":`Encoding`,
"label.setting.intergrationlist.status2":`This integration is currently installed.`,
"label.new":`New`,
"label.search.searchsetup":`Search Settings`,
"label_tabpage_printz":`Print`,
"report.type.label.customService":`Customer Support`,
"label.notification.addEmailObject.message":`You have received an email from {!fromaddress}, click to see more detail`,
"label.icon.68":`Machine`,
"UG.Lead.003":`Social`,
"label_mobile_default_field_service_home":`Service Cloud Homepage`,
"label.select.one.group":`Please choose at least one quote line group.`,
"front-kefu-moudle-trkey-nopower":`Tianrun's key pair doesn't have assigned permissions`,
"label.chatter.cancel":`Cancel`,
"label.weixin.report.optiondisplay":`Show`,
"front-kefu-moudle-v1-System-version":`System Version:`,
"lable.product.pricebooks.editall":`Edit All`,
"label.group.no.recent3":`or`,
"label.knowledge.article.delete":`Error while deleting the knowledge article.`,
"label.relateobj":`Related To`,
"workflow.action.tasks.assignortype.type":`Type`,
"label.layout.selectedfields":`Selected Fields`,
"label.role.assign.operate":`Assign other users to this role:<ul><li>Click the drop-down list to view all available users.</li><li>Select a user on the left "Available Users" list and add them to the "Selected Users" list.</li></ul>`,
"label.field.insert":`Insert Field`,
"label.icon.11":`People`,
"label.group.no.recent4":`start a group.`,
"front-epwechat-module-v1-input-corpid":`Please enter Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Please select a controlling field first.`,
"setup.mainpage.label.welcome19":`Instructions:  Click on the menu on the left side of this page → Manage Settings → Manage Users → Users, Roles, Profiles`,
"label.escalation.setup.list.rulename":`Rule Name`,
"label.ems.addaccount":`Add Account Now`,
"label.reportsSubscription.details.only":`Details Only (Excel format .xlsx)`,
"vue_label_commonobjects_view_groupby":`Group by`,
"label.email.form.text":`Text-only`,
"label.weixin.loginname":`Login Name`,
"label.forecast.settings.sr":`Revenue`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} published posts for all in {1}`,
"label.ccchat.enter.subject":`Please enter the vote subject`,
"label.customer.tab.introduce":`The appearance and function of custom object tabs are similar to the standard tabs provided with CloudCC.`,
"message.login.mfaverification.wrong":`Security Code error.`,
"component.newrecords.label.name":`Name`,
"label.salescloud.opportunity.addandedit.contactrole":`Add and Edit Contact Roles`,
"label_emailtocloudcc_button_next":`Next`,
"label.console.step5":`Step 5 Choose How Records Display`,
"setup.main2018.label.norole":`You do not have the administrative permissions`,
"template.chart.ywjhqd":`Business Opportunity Stage`,
"label.instrumentPanel.breakpointOneLabelname":`This value should be greater than the minimum value.`,
"label.qrcode":`QR Code`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`The cycle of a query cannot be longer than {c} months.`,
"label.console.step7":`Step 7 Assign Profile`,
"label.australian.central.standard.time":`Australian Central Standard Time （Northern Territory）`,
"label_tabpage_deleteviewfailed":`View delete failed`,
"vue_label_commonobjects_view_searchview":`Search in this view`,
"message.error.object.notexists":`Object does not exist.`,
"label.tablecell":`Cells`,
"vue_label_notice_edit_success":`Edit successfully`,
"label.customer.language":`Default Language`,
"label.csrf":`Activate csrf Security Protection`,
"label.forecast.customforecast.submit.zhi":`to`,
"label.sso.saml.idp.config.desc2":`Click Enable Identity Provider to enable your CloudCC.com organization as an identity provider.`,
"label.export_data":`Export Data`,
"component.todaytask.label.all":`View all`,
"label.h5.chatter.record":`Track record`,
"front-vew-email-verification":`View email and verify account. You can only log in after comfirming the email.`,
"laber.marketsea.del.error":`The lead pool is occupied and cannot be deleted`,
"vue_label_notice_homepage_entername":`Please enter the modified name`,
"UG.Forcast.01":`Forecast`,
"front-email-payment-tips":`The invoice amount is empty. Please initiate online payment after filling the invoice amount.`,
"setup.mainpage.label.welcome2":`Custom database (object)`,
"APPIntegration.Social.facebookerror":`You must enter a valid URL for facebook.com`,
"label.profile.mobile.setup.stand":`Standard Homepage`,
"label.custom.CY":`Custom Year`,
"label.knowledgebase.publishing.conditions":`Pulish {a} data failed, they are off the publish criteria!`,
"label.tianyancha.description":`Enable TianYanCha to check the industrial and commercial data verification. This service supports the business data registered in mainland China.`,
"label.appexchange.uninstallpage.title":`Uninstall the package will\:`,
"label.currencyRate":`Conversion Rate`,
"setup_layout_label_areashow":`Display Section Header On`,
"label.setup.case.setting":`Mini-program to Case`,
"vue_label_commonobjects_view_fixed_at_most":`Only three columns can be fixed at most`,
"template.report.month.income":`Revenue of This Month`,
"label.sms.companyname":`Company Name`,
"label.sendemail.registIMUser.waitmessage":`Unfortunately, you do not have a partner cloud portal you can login. please wait, our administrator will notify you later. you can visit the specified address to enter the login page. use the username and password above to login.`,
"label.custom.field.task.object":`A task assigned to you. Task sbject:`,
"message.pleaseselectdayinweek":`Please select a day of the week.`,
"label.chat.topic.favorites":`Bookmark`,
"UG.Campaign.004":`Import campaign`,
"label.approval.preview":`Process Preview`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Choose target language and assign article to person in concerned or queue. Translation export usually is assigned to a queue, and internal translated articles goes to a person.`,
"pagecreator_systemstyle_message_save_success":`Style saved successfully`,
"label.outline":`Outline`,
"label.read.only.field":`Readonly Fields`,
"front-gantt-module-v1-early-warning":`Early Warning`,
"label.file.ccchat.selectfrompc":`Select a file from your computer`,
"vue_label_systemSettings_social":`Social Media`,
"label_report_year_last_year":`Year on Year`,
"lable.PowerProcess.Meet.the.conditions":`The following criteria must be met:`,
"label.changemydisplay.list.title":`Display`,
"UG_Forcast_03":`Start planning and execute business strategies. <br>We wish you a pleasant forecast!`,
"label.sendemail.chat.sendmessage":`Dear #name:\n\n hello! #userName has sent you a message.`,
"label.huanxinconfig.secretid.lost":`secretid cannot be empty`,
"label.icon.49":`Power Generation`,
"chatter.feed.button.publish":`Share`,
"label.power":`^Power`,
"label.partnerCloud.financeSetting.informationThree":`3. After entering secret keys management page, click mapi Gateway Product Key, and acquire partner ID and MDS secret key.`,
"label.emailtocloudcc.step1.lead2":`Once configured, mails received in this mailbox will be automatically logged as lead records in CloudCC. Ensure that no deals are missed.`,
"label.knowledgebase.delete.draft.succeeded":`Delete draft successfully`,
"label.dashboardSetup.title":`Component Editor`,
"label.trigger.operation.email.template.map":`Return to template information, Email subject: m.get("subject"); Email content: m.get("context"); whether Email type is text: m.get("istext")`,
"label.dependencesearchfilter":`Related Lookup Filters`,
"label.selected.search.length":`No more than 10 selected search fields`,
"label.profile.commonusercontrol":`General User Permissions`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`App`,
"label.customsetting.manage.position":`Location`,
"vue_label_systemSettings_bindweb":`Bind Web`,
"label.loginservice.license.notexist":`The license does not exist.`,
"label.icon.43":`Bells`,
"UG_homepage_003":`360 degree view`,
"label.file_format":`File Format`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Sunday`,
"vue_label_chatter_post_has_delete":`Post has been deleted`,
"report_label_searchresult":`Search Results`,
"label.tabpage.justsz":`Just`,
"Lead_Scoring_Setting_LevelSetting":`Lead Popularity Setting`,
"setup.object.field.dependency.label.selectedfieldvalue":`Available Field Values`,
"label.search.morelistview":`More list view`,
"vue_label_homepage_won":`Closed`,
"label.notification.last30days":`Last 30 Days`,
"vue_label_helpcenter_pool":`Use the lead pool and account pool to manage your sales data.<br>Set up account pool<br> Create the account pool in the background, set up the account pool administrators and members, and configure the overdue automatic recycling rules, which is convenient to manage the opportunity follow-up situation within your team and encourage team members to actively follow up.<br>Manually manage data<br> The administrator of the account pool can perform operations such as distribution, recycling, discard, and transfer of records in the account pool, and manage the records in the account pool in a unified way;<br> Members of the account pool can receive unallocated records or view the records they are responsible for.`,
"label.emailsync.status.export":`Export as Excel_csv format file`,
"label.service.miniProgram.slideshowTitle":`Carousel`,
"label.service.miniProgram.slideshowName":`Carousel Name`,
"label.fieldupdate.selectobj":`Define the object associated with the field update, then click Next. Field Updates can only be associated with workflow rules and approval processes of the same type.`,
"label.ccpeak.take.notice.sharetab":`Notice: the fields in the expression of the shared form do not require the addition of "__c".`,
"label.log.startdate.after.endate":`Start time must not be later than the end time.`,
"label.rememberme":`Remember Me`,
"label.partner.all.maxNum":`Bigest data of partern clouds:`,
"component.setup.iframe.label.inputurl":`Enter the url address`,
"label.h5.systemmessage":`System message`,
"label.delete.date":`Delete Date`,
"front-email-payment-select-month-tips":`Please choose MM`,
"front-kefu-moudle-bind-userinfo":`Bind User Information`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`The number of lead digits cannot be greater than the number of mapped field digits.`,
"label.event.dayview":`Day View`,
"label.replace":`Replace`,
"label.knowledgebase.search.knowledge.articles":`Search Knowledge Article`,
"component_event_label_soon":`Immediately`,
"label.imgfield.upload":`Upload Image`,
"message.printable.view":`Printable View`,
"vue_label_notice_uploadavatar_notice1":`The size of the uploaded avatar image cannot exceed 2MB`,
"label.visualpage.developer.help":`Custom Page Developer Help`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`Single Sign-On Setup`,
"vue_label_calendar_step_1":`Step 1: Name the object calendar.`,
"component.telerecord.button.save":`Save`,
"setup_mainpage_button_manageobject":`Objects Management`,
"label.marketingactivityinfluence":`Campaign Influence`,
"label.quote.bjjsxx":`Quote acceptance information`,
"label.appupload.upload.install.retry":`Reinstall`,
"label.layout.assignrules":`Assignment Rules`,
"UG.Lead.006":`Website visitor`,
"label.workmate.searchs":`Search colleagues`,
"label.visualpage_list.no":`No permissions to access the custom pages`,
"label.service.miniProgram.slideshowintroduce":`Carousel name is only used to identify multiple ad entries and is not displayed in the ad.`,
"label.multilang.messagedetail.search.desc":`We cannot find a message with {0}:`,
"label.mobile.phone.read.note":`Please enter the notes here`,
"label.passwordPolicy.setup.isUsingGotp":`Enable Login Secondary Verification`,
"message.datetypeerror":`<strong>Error: </strong> Invalid Date.`,
"label.searchlayout.listview.button":`Buttons displayed in list views.`,
"label.sectionpart":`Section`,
"label.partnerCloud.basicSetting.userSetting":`Roles and Users Setup`,
"System_Data_Import_Warning_MaxCount":`Your organization can only import {0} pieces of data at a time, which is now out of the limit, please adjust and re-import.`,
"label.datamove.qualified.record":`qualified record(s),each time can transfer 100 records at most`,
"component_task_label_priority":`Priority`,
"vue_label_report_me":`Me`,
"label.college.duplicate.option":`Options cannot be repeated!`,
"label.pw.letter":`Letters`,
"label.file.sharedwithme":`Shared with me`,
"label.translation":`Translate`,
"lable.currencyAdv.exchagecurrency.before":`and before`,
"label.file.share":`Share`,
"label.page.next":`Next`,
"label.autoRegister.changepwd.setpwd.notmatch":`Two passwords are inconsistent`,
"label.tabpage.include":`Included`,
"front-email-payment-thanks":`Thanks`,
"vue_label_help_helponthispage":`Help on this page`,
"label.approvepagelayout":`Approval Page Layout`,
"vue_lightning_help_zero_distance_communication":`Get started with online support. Contact CloudCC service experts with zero distance.`,
"vue_label_normal_case_sf":`Case`,
"label.report.line.tuozhuai":`Please drag and drop, or double click to select the report column and adjust their orders`,
"template.dashboard.management":`Operation Management`,
"label.customcomponent.params.info.n1":`The value "args" of the "args" in the "component" tag is in "json" format, for example: args="name:'zhang',age:26", In cc code block ,use: String myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Signed Commit Rate`,
"label.add.status":`Add Status`,
"label.loss.customers":`Closed / Account Lost`,
"vue_label_chatter_involving_me":`Involved`,
"label.update.input":`Please correct the input`,
"label.import.step1.commonobj":`General objects`,
"label.appupload.upload.tips.document":`Note: documents in "my personal folders" and "templates red folders" cannot be added to the package, nor can they be displayed in this list.`,
"label.appupload.install.complete":`Complete`,
"label.console.edit":`Console Edit`,
"setup.object.field.dependency.label.removefromlist":`Remove selected values`,
"label.textmessage.groupsms.no.phone":`No Mobile`,
"label.account.Current.and.NextFQ":`Current and Next FQ`,
"label.sso.saml.sp.idtype.userid":`Assertion contains the User ID from User object`,
"label.data.import.setup.operate.update":`Update existing records, do not insert new records`,
"front-kefu-moudle-v1-jcaws-call-serve":`Call Center Integrated with AWS (Amazon Web Service) to Provide More Comprehensive SaaS Services`,
"label.version.bacheditordel":`Batch Edit/Delete/Transfer`,
"lable.even.higher":`Higher`,
"label.datetime.error":`Date format is incorrect`,
"vue_label_commonobjects_detail_customer_hierarchy":`Account Hierarchy`,
"label.startuploadfile":`Start Upload`,
"label.appointment.wizard.subtitle3-1":`Monday`,
"label.weixin.relevance":`Associated Opportunity`,
"label.datamanage.field.mapping.information":`Setup Field Mapping`,
"label.brief.lastweek":`Last Week`,
"label.nextstep":`Next Step`,
"label.listtoshow":`A list of both active and inactive approval processes for {0} is displayed below.`,
"label.partner.ishave":`Error: The domain already exists`,
"label.service.miniProgram.name":`Please fill in the name.`,
"label.view.filterbyaddition":`Filter By Additional Fields (Optional):`,
"label.projectManagement.nodata.task":`No records for tasks. Let's add task information!`,
"label.chooseemailtemplate":`Select Email Template`,
"label.page.step4.add.profile":`Step 4 Add to profiles`,
"label.ems.mailtype":`Mail type`,
"label.weixin.no.pending.projects.vg":`Good job, no pending approval items`,
"label.tabpage.saveviewfailed":`View save failed`,
"label.chat.file.upload.cancel":`Cancel upload`,
"com.cloudcc.login.error.message.notenabled":`Your id not enabled`,
"label.data.import.setup.operate.insertandupdate":`Update existing records and insert new records`,
"label_target_type":`Indicator Type`,
"label.notification.event2":`【被分配人】 viewed the event you assigned`,
"chatter.feed.menutype.feed.news":`I Followed`,
"label.import.page1.suitedwayofcustomer":`Client matching style`,
"label.import.page2.CloudCCfiled":`CloudCC Field`,
"label.custom.quarter.start":`Custom Quarter Start Date`,
"label.page.including.tab":`Including Tabs`,
"label.mobile.phone.day.plan2":`Today`,
"template.report.lead.conversion.statistics":`Conversion Statistics of Leads`,
"label.show.type":`Display Type`,
"label.weixin.no.pending.wdgz.qin.week":`No work scheduled for this week.`,
"2018UI.Homepage.DataDeleted.Info":`The data you want to view has been deleted, please click to return to previous step.`,
"label.vlidaterule.message":`Error Message`,
"label.approval.remark":`Approval Opinion`,
"label.field.duplicate1":`Uniqueness`,
"label.batchtransfer":`Batch Transfer`,
"label.quickbooks.view.allinvoices":`All Invoices`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Mark as Current Status`,
"label_home_page_source":`Please select data source.`,
"front-kefu-moudle-v1-opencall-please":`Please enable the call center and then set up`,
"setup_layout_label_asc":`Ascending`,
"label.use_tikect":`Use Admission Ticket?`,
"label.tag.setup":`Tag Settings`,
"label.existinglayout":`Existing Page Layout`,
"label.productsales.today.noevt":`There are no open events.`,
"message.error.view.date.validerr":`Please enter the valid date format(YYYY-MM-DD、MM/DD/YYYY) or special date characters`,
"label.mr.descreption.oneGroupReData3":`has to deal with the`,
"label.tianyancha.businessverify.msg1":`With the commercial data verification function enabled, users should carefully read and fully understand the terms of this "user license agreement" (hereinafter referred to as the "agreement"), including the exemption from liability of beijing shenzhou yundong customer co., ltd. (hereinafter referred to as "CloudCC") and the restrictions of user’s right. please read it carefully and choose to accept or not this agreement.`,
"label.custom.CQ":`Custom Quarter`,
"label.version.custom.dashboard":`Standard Dashboards(Custom Page)`,
"vue_label_commonobjects_detail_dragtoupload":`Drag your file here, or <em>choose file to upload</em>`,
"label.tabpage.addadvancedoptions":`Add advanced options`,
"front-kefu-moudle-v1-Launch-page":`Landing Page:`,
"label.emailobject.tabname":`Email`,
"label.weixin.addmore":`Add More`,
"message.error.view.operator.validerr":`Invalid Operator`,
"label.another_page":`Redirect to Another Page`,
"label.reportTypeFocusD2":`Example: If reporting on "Contacts with Opportunities with Partners," select "Contacts" as the primary object.`,
"label.icon.47":`Barometer`,
"label.task.today":`Today`,
"label.service.gantt.weekend.highlight":`Highlight the Weekend`,
"label.customcomponent.referencetagname":`Tab Name`,
"label.senderemail":`Email Address Of Sender`,
"label.defaultvalue":`Default Value`,
"label_tabpage_Sdfez":`days`,
"pagecreator.page.label.pagename":`Page name`,
"vue_label_report_pagenumber":`Page number in range`,
"label.emailsync.connectaccount.description":`Add your personal mailbox here, and the CloudCC will automatically match leads and contacts in the system according to their email addresses, sync the contents of the email to the records to facilitate tracking and communication.`,
"label.schedulableprg.chooseweek":`Please select date of every week`,
"lable.edit.queue.membercanuse":`Available Members`,
"lable.Quick.find":`Quick Look`,
"label.daynuminmonth":`Day(s) of Month(s)`,
"message.error.state":`state cannot be empty!`,
"label.introduction.the.form":`Description`,
"label.batchtransfer.pleaseselectcomefromuser":`Transfer From`,
"front-dashboard-module-implemented":`Realized`,
"label.custombutton.newerror":`New created failed`,
"label.version.allow.size":`,beyond the limit.If necessary,please upgrade CloudCC version.`,
"label.weixin.account.loginpage":`Account Security Login Page`,
"message.pleaseselectfieldtype":`Please Select Field Type`,
"component.setup.label.parentobject":`Superior object`,
"System.TAB.SeeViewAmount":`View Totals`,
"label.event.lastmonth":`Last Month`,
"label.taskrecordtype":`Task Record Types`,
"label.layout.selectedpages":`Selected Pages`,
"label.appointmentdetail.wizard.title19":`Saturday Plan`,
"label_chatter_endData":`End Date`,
"label.appupload":`Packages`,
"label.knowledgebase.article.link":`Linked Article`,
"label.licence.enddate":`Expiration Date`,
"chatter.fieldtrack.record":`record`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Weekly`,
"label.forecast.editshrepage.title2":`Sharing Edit`,
"label.attendance.onwork.time":`Start of Day`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Upload layout`,
"label.input.notless.than.number":`Please enter a number greater than or equal to {0}`,
"setup.mainpage.label.welcome13":`Instructions: Click on the top menu → Reports → New`,
"label.forecast.settings.data.opp":`Opportunity Close Date`,
"vue_label_display_checkbox_field":`Show Checkbox Fields`,
"label.summaryreport.2018.step5":`Step 5 Select the chart type and the highlight item`,
"front-lightning-module-v1-dashborad-one-statistic":`Please choose at least one statistical value and statistic type`,
"label.home.standard.dashboard.forcase":`You are not allowed forecast and cannot view the sales commitment dashboard.`,
"page.field.track":`Field Tracking History`,
"label.dataimport.format.datetime.error":`Format error, please use yyyy/MM/dd HH:mm:ss or yyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Choose Price Book`,
"pagecreator_systemstyle_label_stylename":`Style name`,
"label.projectManagement.nodata.project":`No related data. Why not create projects related to me?`,
"label.start_below":`Start sharing your form with contacts. Your form has been securely published and ready to use at the web address below.`,
"label.campaignmember.main.delete":`Batch Remove Campaign Members`,
"label.modifyall":`Modify All`,
"label.homepage":`Homepage`,
"vue_label_pool_adoptedbyme":`I Collected`,
"label.email.clearItem":`Only Emails with no associated items are cleared.`,
"label.callcenter.login.Amazon.connect":`Log in to Amazon Connect`,
"label.import.page1.selectimportfiled":`Select the file to import`,
"message.error.id":`id cannot be empty!`,
"label.ggReleaseRange.searchUsers":`Search partner user`,
"label.changemypwd":`Change My Password`,
"label.ccpeak.reference.parameters":`The parameters that can be references directly are:`,
"chatter.share.success.tip":`Success! you have shared this post to`,
"label.message.checkfailed":`Syntax checking failed, the class name exists.`,
"label.shangqing.introduction":`Integrate and analyze the recent hot events of leads or customers to help salesperson understand customers more comprehensively`,
"label.allemailnotice":`All Email Alerts`,
"vue_label_report_copy":`Copy report`,
"label.exchange.sync.state.setting":`Configuration Settings`,
"label.merge.result.error1":`The following record is locked,and no "merge" operation is allowed`,
"label.process.des":`Click the left link to view details of the current record.`,
"label.textmessage.vonage.create.lead.setting":`Create new leads when receive text from numbers not in the system`,
"label.views":`Views`,
"label.notification.tip1":`No Notifications`,
"label.forecast.detailforecast.returnforecast":`Back to Forecasts`,
"label.knowledgebase.target.framework.name":`Target Frame Name`,
"label.brief.close.opportunities":`Closed Opportunities`,
"label.appointment.wizard.subtitle4-2":`The shortest time to notice you`,
"vue_label_systemSettings_set_record":`Set up the dispaly mode of related list, trying to switch between Card Mode and List Mode.`,
"pagecreator_page_message_publish_fail":`Page publishing failed`,
"vue_label_homepage_name":`Homepage Name`,
"label.weixin.no.pending.wdgz.qin.month":`You have no scheduled this week.`,
"label.campagin.register.page":`Campaign Member Register Page`,
"label.campaign.channel.edit":`Campaign: Edit Marketing Channel`,
"label.folder":`Folder`,
"label.umeng.chatter.follow":`followed you.`,
"label.sso.theKeyToEdit":`Key Edit`,
"label.deletelayout":`Delete Page Layouts`,
"label.same.analyze.miaoshu":`The relationship between above conditions is: Opportunity Name" or "Account Name" or ("Contact Mobile" and "Contact Email");`,
"label.ccpeak.sel":`Classes in this folder`,
"label.tabpage.addtoworkbench":`Add to homepage workbench`,
"label.forecast.shrepage.classdes.r":`Read Only - Users can read forecast data.`,
"homepage.custompagename":`Custom Homepage Name`,
"label.sendemail.batchapprovalinfo":`Hello #name:\r\nThe batch approval operation you performed was successful, with a total of #successnum successfully approved and #errornum failed.`,
"front-email-payment-Invoice-alipay-describe":`Secure and reliable payment`,
"setup.object.field.dependency.label.configured":`Page Layouts Assigned to Profile`,
"label.potentialcustomers":`Leads`,
"label.timetrigger.button":`Add time trigger button is not available in the following cases:`,
"label.category.10":`Lawyer`,
"label.selectall":`Select All`,
"message.field.id.not.null":`The field ID can not be empty.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Please input`,
"label.author":`Author`,
"label.import.step1.csvonly":`1. Only csv format file is supported, and up to {recordnumlimit} records can be imported for one time. Up to 2,000 records can be imported if you need to execute trigger. Records that exceed the limit will be automatically ignored by the system. If you want to import more data, please split it into multiple files first and import them at different times. .`,
"label.assignment.setup.newrule.name":`Rule Name`,
"label.campaignmember.selectmember.chosestatusdesc":`Please select the campaign you want add members to, and edit the Campaign Member Status. Create a new campaign, you must exit this process.`,
"label_tabpage_operation":`Operation`,
"label_tabpage_datatyoez":`Data Type`,
"UG_product_04":`Create product`,
"label_emailtocloudcc_step1_case2":`Once configured, mails received in this mailbox will be automatically logged as case records in CloudCC. According to the outbox matchng contact and account, relate case to the correspongding contact and account, so as to facilicate the acceptance and tracking of cases.`,
"workflow.action.tasks.assignortype.role":`Role`,
"vue_label_notice_refreshi_success":`Refresh successfully`,
"label.notification.arketsea.abandon":`{5} discarded {2} {0}：{1}`,
"label.icon.36":`Computer`,
"chatter.group.cancelToJoin":`Cancel To Join`,
"label.publicgroups.edit":`Edit Public Group`,
"message.duplication.label.letternum":`Matching Character bits`,
"label.brief.lost.opportunities":`Lost`,
"setup.layout.label.nofield":`No available fields`,
"label.dataimport.isSharingRule":`Execute Sharing Rules`,
"vue_label_opportunity_contactrole_synctocontacts":`Sync Info to Contact`,
"attachment_button_massdownload":`Batch Download`,
"label.weixin.agreement.remark":`This WeChat service is the assistant tool of Aid-Max consulting service to clients, it is not the ultimate basis for insurance companies to settle claims, and the customers' claims should be settled according to the actural requirements of the insurance companies.`,
"label.partnerCloud.basicSetting.introTwo":`Edit part of the unique URL. CloudCC.com provides the first part of URL and the later part only contains number or letter. It is recommended to use the name of your company or its variant, e.g. "mycpmpanypotal".`,
"pagecreator_layout_funcpath":`/ builder / layout library`,
"label.ccdocument.online.edit":`Document Online Edit`,
"label.partner.setup.Enable":`Verify`,
"label.log.state":`Action Status`,
"label.lower.bound":`Lower Bound`,
"label.timezone.isenable":`Enable user multiple time zone, then allow user to set time zone, and display date/time by user's time zone.`,
"label.martrixreport.setrowtitle":`Specify Column Headers`,
"label.bottom":`Bottom`,
"label.multilang.ccchat.groupnotcontainsname":`You are not a member of any compaign group that has {0} in its name`,
"label.step1.of.step5":`Step 1 of 5`,
"message.report.error.FieldListIsAmbiguous":`There is a formula filed was referenced in the report, that causes an exception, please remove the filed:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Change from {0} to {1}`,
"label.report.export.print.content":`Export current report headers, groups and first 2000 records`,
"message.thanksusing":`Thanks for using CloudCC.com`,
"label.reportexport.allobject":`Export All Objects`,
"label.projectManagement.working.hours.per.day":`Daily working hours`,
"label.partnerCloud.financeSetting.enterCollaborator":`Please enter cooperator ID`,
"label.defineReportRecords":`Define Report Records Set`,
"greate":`greater than`,
"label.sure_discard":`Are you sure to give up the changes?`,
"label.escalation.setup.newaction.notifyowner":`Notify Case Owner`,
"label.icon.28":`Doctor Hat`,
"lable.PowerProcess.see.page":`View Milestones`,
"message.error.object.relogin":`Login failed, please try to log in again`,
"label.chatter.activity":`Activities`,
"label.query.clone.detail.choose.canChoose":`Available Line Items`,
"chatter.using.object":`Enable feed tracking for objects so users can follow records of that object type. Select fields to track so users can see feed updates when those fields are changed on records they follow.`,
"UG.opportunity.001":`How do you monitor your sales?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Service Resources Distribution Map`,
"vue_label_email_current_email":`Inserting this template will overwrite the current email`,
"label.h5.approval.page.layout":`You can set approval page layout\uff1a<br>Setup->Create->Workflow&Approval->Approval Processes<br>select this approval process \uff0c click the approval name\uff0c<br>click Edit->set the approval page layout from Approval Page Layout\u3002`,
"component.hots.label.title":`Hot deals`,
"mail.foldername.notOnly":`This file already exists`,
"label.customer.tab.step1":`Step 1 Enter the Details`,
"label.delete.persion":`Deleted By`,
"chatter.changed0":`Change {0} from {1} to {2}`,
"homepage.components.type":`Component Type`,
"label.norfolk.isiands.time":`Norfolk Time`,
"label.product.pricebooks.view":`Price Book Views`,
"label.forecast.customforecast.director":`Direct Subordinates`,
"label.emailtocloudcc.step3total3":`Step 3 of 3`,
"label.cloudccsite.end":`Inactive Site Homepage`,
"label.login.verification.mfa.device":`Verify The Virtual MFA Device`,
"chatter.follow":`Follow`,
"label.month's":`Month's`,
"label.sendmail.step1.introduce":`Select a view below that contains the recipients to be included in this email.`,
"label.shangqing.title":`Business Information Setting`,
"label.rejectrecords":`Rejected Records`,
"label.selectupdatevalue":`Value Changing From`,
"vue_label_pricebook_disabled":`Price list is disabled`,
"component.chatter.label.title":`Latest post`,
"label.partner.all.workspace":`Workspace`,
"label.querydetailservice.delete.message":`Data deleted or does not exist.`,
"label.objectRelationshipWithout":`with or without related records`,
"nocontain":`does not contain`,
"label.partnerCloud.financeSetting.accountSettings":`Partner Fund Setup`,
"label.file.sharetype.owner":`Owner`,
"label.open.multilingual":`Enable Multilanguage`,
"label.searchresult.field":`Search Result Fields`,
"label.tabpage.selectdate":`Select a date`,
"label.h5.logouting":`Log out`,
"label.quickbooks.fieldlabel.payment":`Payment`,
"label.chatter.leaveword":`Comment`,
"label.customfields.majoranddetailrelation.tip":`Create a special parent-child relationship between this object (child or details）and another object (parent or master), where: <br>● the relationship fields for all details records must be filled in. <br>● Once the value of the relational field is saved, it cannot be changed. </li><br>● the ownership and sharing of the detail record is determined by the master record. </li><br>● when the user deletes the master record, all details are deleted. </li><br>● you can create cumulative summary fields on the master record to summarize detailed records. </li><br>The relationship field allows the user to click the find icon to select a value from the pop-up list. The primary object is the source of the value in the list. "`,
"label.batchapproveorrefuse":`Batch Approve/Reject`,
"label.copy.success":`Copy successfully`,
"vue_label_show_record_count":`Show Record Count`,
"label.ems.delete.false":`Failed to delete`,
"label.new.Product.Goals":`New Product Goal`,
"label_chatter_BCC":`Bcc (blind courtesy copy)`,
"label.knowledgebase.data.archived.successfully":`{a} data archive successfully`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`Your {0}:{1} has been recycled to {2} by {5}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Payment Amount:`,
"label.martrixreport.2018.step5.new":`Step 5 Select report criterias`,
"label.testing":`Checking...`,
"chatter.poll.option4":`Choice 4`,
"lable.outlook.detail.otc":`Exchange to CloudCC.com`,
"label.startuploadfile.batch.step2":`Step 2 Click the "start upload" button,upload files`,
"lable.outlook.edit.outdes":`Enter the custom fields that you have already created in Exchange. Before mapping this custom Exchange field to a CloudCC.com field, CloudCC.com will verify the existence of the Exchange field upon the first synchronization.`,
"hour":`Hour`,
"label.appointmentpage.wizard.notif4":`Invalid email format`,
"label.import.index.state":`Status`,
"label.integrations.mailchimp.massage6":`The selected data shown on current page will be able to export to your Mailchimp list`,
"label.file.share.email.subject":`#sharedBy has shared a file with you on #orgname`,
"label.assignment.setup.newentries.noassignment":`Do Not Reassign Owner`,
"label.dashboard.unit1":`Unit: 10,000`,
"label.forecast.customforecast.foretype.commit":`Commit`,
"label.type":`Type`,
"label.partner.workspace.login.logo":`Header logo`,
"pagecreator_systemstyle_button_edit":`Edit style`,
"label.displaytype2":`Detail Page Button`,
"email.one":`Dear user: <br/>Welcome to CloudCC. You requested to reset your password at {!operatetime}, please login with the verification code below within 15 minutes.<br/>Random Verification Code: <b>{!authcode}</b><br/> Click the link below to reset your password: <b>{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}</b><br/><br/> <b>Important: </b><br/>If you did not request this,or you think this message should not reach out to you, please contact your administrator immediately!`,
"label.partnerCloud.orderingPlatform.unavailable":`No Available Products`,
"vue_label_email_save_the_signature_successfully":`Save the signature successfully`,
"label.reportsSubscriptionPage.email.detailed":`Detailed`,
"chatter.group.query":`Query`,
"label.translation.unsupported.format":`Unsupported format, multi-languages import support only Property format`,
"message.operateexception":`Prompt(Please Contact Your Administrator).`,
"label.sendemail.chat.praiseFeedcomment":`Dear #name:\n\n hello! #userName liked your comment (#href).`,
"label.recycle.clearmy":`Clean Recycle Bin`,
"label_tabpage_choose":`Select`,
"#label.importstep2tip":`If you want to upload moren than one file, you can compress all the files together and import them.`,
"label.batchedit":`Batch Edit`,
"label.integrations.mailchimp.export":`Export to Mailchimp`,
"label.cloudccsite.name":`Site Name`,
"serviceterritory.serviceappointment.iscontain.contain":`You cannot delete the service territory for it is associated with a service appointment. You can disable this service territory.`,
"label.sum":`Sum`,
"setup.mainpage.label.welcome29":`Standard API integration with third-party products`,
"label.tabpage.nothingz":`Nothing`,
"label.weixin.actual.contract.jine":`Actual contract amount`,
"label.tabpage.emailaddressz":`From?Address`,
"label.dashboard.unit4":`Unit: 10 million`,
"label.dashboard.data.labels":`Data Labels`,
"label.import.page2.oneonone":`One CloudCC field can only correspond to fields in one file.`,
"homepage.components.name":`Component Name`,
"template.report.task.theme":`Task Subject`,
"component.setup.label.setupsaveok":`Component settings saved successfully`,
"front-epwechat-module-v1-add-selfapp":`Add Seflcreated App`,
"label.to.save.the.current.page.information.button.":`If you want to save the information of the current page, please click "Quick Save" button.`,
"vue_label_file_not_support_preview":`The file does not support preview, please download and view`,
"label.object.reached.limit":`The number of the objects you can create reach the upper limit.`,
"label.partnerCloud.basicSetting.online":`Activate Online Payment`,
"label.app.step1.error.nameexist":`This Group Name already exists or has been previously used. Please choose a different name.`,
"label.workflowandapprove":`Workflow and Approvals`,
"label.recordtypeselect.change.tip":`When you change the record type of a record, the existing picklist values do not automatically change. It is recommended that you update the existing picklist values of the record in the same place.`,
"label.summaryreport.step6":`Step 6 Select report criterias`,
"Pagelayout.Setup.004":`Up to 4 fields can be set`,
"label.file.attached":`Attached`,
"front-invoice-online-payment-setup-configure":`Click "Configure Now", configure the interface of {name} payment.`,
"label.approvaldatamove.submitdate":`Date Submitted`,
"label.emailobject.time.from":`From:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`The $schemefield_name$ field in the record already exists in the database and is no longer is inserted. The record has been ignored import.`,
"assetbom.copy.notpermission":`You don't have the authority to clone asset BOM. Please contact the administrator.`,
"lable.outlook.mcto.autoallocation":`Assign them to related CloudCC.com records automatically.`,
"label.dataimport.but.datalength":`,but the length of the data is`,
"label.setuserstocommit":`Using the options below, specify which users are allowed to submit the initial request for approval.`,
"component_telerecord_label_related":`Related Items`,
"front-lighting-module-v1-detail-file-lockInfo":`The record is locked and not available for adding files. Please contact the admin for unlock.`,
"pagecreator_layout_button_edit":`Edit layout`,
"label.app.step3.tabcanuse":`Available Tabs`,
"label.ems.delete.sure":`Are you sure to delete this email account information?`,
"label.email.show":`Show`,
"label.checkbox.unchecked":`Unselected`,
"message.error.operation":`Operation failure, please contact administrator.`,
"label.template.set.folder.only.upload.type.file":`The red marked folders in template can only be used to upload files of the type of Word,Excel and PPT.`,
"label.knowledgebase.select.publish.status":`Please choose a publish status`,
"label.recordtype.tabname.edit":`Enter the new name for the selected record type, and then click "Save"`,
"label.tabpage.exportview":`Export View`,
"label.dataimport.insert.sharetab":`Failed to insert sharing form`,
"vue_label_dashboard_penetrateto":`Penetrate to`,
"label.weixin.group.member":`Personnel`,
"vue_label_systemSettings_customadd":`Custom Extension`,
"UG_Account_03":`Proactively check and merge the duplicated accounts`,
"label.singapore.standard.time":`Singapore Standard Time`,
"label.weixin.captcha":`Verification Code`,
"Account_News_Setting_004":`Enable News`,
"label_emailtocloudcc_select1":`Please choose`,
"label_ring_ratio":`Month on Month`,
"label.industrialandcommercialverification.button.save":`Save`,
"label.approvalstep5.tip":`The approval page is where the approver actually approves or rejects the request. use the following options to select the editing properties of the fields to display on this page.`,
"label.import.page1.maxrecord{{30000}}":`1. You can import {{30000}} records once`,
"setup_object_layout_label_profileoptions":`Available Profiles`,
"label.emailtemplate.type":`Template Type`,
"label.searchlayout.tab.field":`Fields displayed on tab.`,
"chatter.news":`Messages`,
"label.pw.small.letter":`Lowercase`,
"label.notification.group3":`Your application to join the public group was rejected`,
"label.ccchat.day.before.yesterday":`The day before yesterday`,
"component.chatter.post.label.title":`Publish`,
"label.tianyancha.type":`Legal representative type`,
"label.detail.searchlayout":`View Search Layout`,
"vue_label_pool_deleteconfirm":`Are you sure you want to delete the (1) record(s) selected?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Only supports csv format files, the maximum support is {{100}}mb, and a maximum of {{30000}} records can be imported once; please split into multiple files and import them in stages if the limit is exceeded,`,
"label.h5.similar.opportunity.lookup":`Find Similar Opportunities`,
"template.report.customer.list.opportunity":`Account List with More Opportunities`,
"component_setup_iframe_label_memo":`Click the settings icon and enter the embedded url address.`,
"label.version.allemail":`Batch Email`,
"lable.product.editp":`Price Edit`,
"label.weixin.plate.number":`Plate Number`,
"font-evaluate-module-v1-disabled-successfully":`Successfully disabled evaluation option "Neutral"`,
"label.multilingual.tip1":`Use this page to define the language of your organization.`,
"label.japan.standard.time":`Japan Standard Time`,
"lable.product.notdel.use":`Delete attempts,Because it is still associated with the following records.In this case,it is recommended that you disable.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Edit`,
"label.partnerCloud.financeSetting.informationTwo":`2. In the Merchant Center, Click Account Management  Merchant Management  Product PIDIKEY  Secret Key Management`,
"label.partnerCloud.partnerOrdering.permission":`Partner Ordering Permission`,
"vue_label_commonobjects_detail_company_hierarchy":`Company hierarchy`,
"label.forecast.settings.sl":`Quantity`,
"label.partner.workspace.tab.memo":`Select tabs for this partner cloud. either standard tabs or customized tabs can be selected.`,
"label.mr.mainRecord":`Primary Record`,
"setup_mainpage_label_welcome20":`Mail, SMS template`,
"front-email-payment-select-date-tips":`Please choose YY`,
"label.dependencelisttag":`Related List Label`,
"label.umeng.activity.eventof":`event of`,
"label.sales.dashboard.collection":`Receipts Goal`,
"report_label_folder":`Folders`,
"label.assignment.setup.newentries.step1":`Step 1 Set the order in which this rule entry will be processed`,
"label.quote.shrname":`Recipient name`,
"label.newreport.group.sum":`The number of grouping`,
"label.number.MinCheck":`The minimum of {a} is {0}. Please modify the quantity and save changes.`,
"label.chatter.save":`Save`,
"vue_label_email_all_email_templates":`All email templates`,
"message.summaryconditionnototal":`Roll-up fields cannot be used in summarized conditions!`,
"label.callboard":`Announcements`,
"label.step2.total5":`Step 2 of 5`,
"vue_label_homepage_custom_homepage_page":`Custom Homepage`,
"label.data.newtemplate.e_seltype":`Select the data export method`,
"label.data.dataexpalltype.all.desc2":`2、It takes some time to export all data. When the export is complete, you will receive a reminder email that the data export was successful.`,
"lable.account.CalenderYear":`Calender Year`,
"message.error.data":`The passed data cannot be empty, please check the passed parameters`,
"label.from_user":`From User`,
"label.parentdepartment":`Superior department`,
"template.dashboard.product.analysis":`Products Analysis`,
"label.tabpage.unpacketz":`No grouping data available!`,
"label.icon.107":`Communication`,
"label.monitorsys.operator.username":`Users`,
"label.serchreport":`Search Reports`,
"label.payment.upgrade":`Upgrade`,
"setup_layout_button_ok":`Confirm`,
"label.please.select.channel":`Please select channel supervisor.`,
"template.chart.txdrw":`Task Reminder`,
"chatter.group.accept":`Accept`,
"pagecreator_systemstyle_message_canntdelete":`The current style is not allowed to delete`,
"label_tabpage_ctbtsftcz":`Click the back to search for the content`,
"label.datamanage.select.accountfield":`(Select the fields corresponding to the imported account)`,
"label.schedulejob.setup.list.title":`Scheduled Jobs`,
"label.visualpage_list.title":`Active Custom Page Access`,
"label.mr.selectTwoData":`Please select at least two records to be merged.`,
"label.customer.tab.step2.different":`Apply a different tab visibility for each profile`,
"label.mobile.side.tab.can":`Available`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`CloudCC account has been bound, if continue, WeChat which previously bound to this CloudCC account will not be able to use the micro CloudCC system. Do you want to continue?`,
"label.applet.to.case":`Miniprogram Customer Service Portal`,
"lable.outlook.detail.cmaping":`Map Contact Fields`,
"label.theUserActiveTime":`User active period`,
"label.event.moveup.9hour":`9 hours ahead`,
"vue_label_pool_other":`other`,
"label.fieldname":`Field Name`,
"vue_label_notice_add_success":`Added successfully`,
"label.conditiontag.lookup.insertbutton":`Insert Selected`,
"label.identifying":`Identification`,
"label.tabpage.uploadingz":`Uploading`,
"label.view.introduce":`Edit View`,
"vue_label_dashboard_sortingmethod":`Please select sorting method`,
"label.quote.number.introduce":`Enter the number ofand discounts, and click Save.`,
"front-kefu-moudle-which-missphone-case":`Create Cases for Which Calls Were Missed`,
"label.sendemail.chat.response":`Reply of CCChat:`,
"label.productsales.refreshTime":`Last Update`,
"lable.SalesCommitmentKanBan.phase":`Stage`,
"label.version.sum.object":`object(s)`,
"label.defineReportStep2":`Step 2`,
"message.duplication.label.returnDuplications":`Back to Duplication Filter List`,
"label.lookover":`View`,
"label.quickbooks.button.copy2":`Copy CloudCC Detials To QuickBooks`,
"label.checkbox.true":`Yes`,
"label.profilename":`Profile Name`,
"label.finalapproveoperate":`Final Approval Actions`,
"label.SMS.detailed":`SMS alerts are sent by workflow rules when they were triggered.`,
"label.lasttimemodifier":`Last Modified By`,
"label.sso.summary":`Summary`,
"label.customfields.encd.tip":`Allow users to enter any combination of letters and numbers and store them in clear text form which can be encrypted and searched.`,
"vue_label_report_formulacolumn":`Row-level formula column`,
"vue_label_systemSettings_transfer":`Batch Transfer Records`,
"lable.product.ecm":`line,Please enter the correct amount.`,
"label.partner.setup":`Partner Cloud Settings`,
"label.same.analyze.miaoshu2":`function`,
"label.mobile.phone.day.summary":`Daily Summary`,
"label.ccchat.person.error.illdomain":`Error: The domain format is incorrectl`,
"label.knowledgebase.edit.as.draft":`Edit as Draft`,
"message.duplication.label.newfilterule":`New Duplicate and Matching Rule`,
"vue_label_salesfunnel_notice1":`Opportunity Summary`,
"label.partnerCloud.partnerAccount.order":`Order No. :`,
"label.account.Current.and.PreviousFQ":`Current and Previous FQ`,
"label.customfields.formula.dateandtimeexample":`Next = NOW() 1`,
"label.area.unassign":`Unassigned Users`,
"label.at.my":`Content I Mentioned (@)`,
"vue_label_calendar_notice_stopsharingfail":`Failed to stop sharing`,
"label.data.file.validation.rules":`Execute Validation Rules`,
"label.escalation.setup.entrydetail.escalation.hour":`Hours`,
"vue_label_ccchat_notice_pleaseentercontent":`Please enter the content and options`,
"label.forecast.edit.error1":`Error: Inactive Currency`,
"label_emailtocloudcc_exists1":`This mailbox has been set to Email to Lead. Do not repeat settings.`,
"label.trigger.send.email":`Email Notifications via Triggers`,
"label.setmysafetysignagain":`Reset My Security Token`,
"label.callcenter.pleaseenter.access.keyID":`Please enter the secret key ID`,
"chatter.poll.option10":`Choice 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Unified Bottom Menu Setup`,
"label.quickbooks.searchs":`Search`,
"label.section":`Segment`,
"label.customfields.fielddependency.new.tip":`Create a dependent relationship that causes the values in a picklist or multi-select picklist to be dynamically filtered based on the value selected by the user in another field.<ul ><li>The field that drives filtering is called the "controlling field." Standard and custom checkboxes and picklists with at least one and less than 300 values can be controlling fields. </li><li>The field that has its values filtered is called the "dependent field." Custom picklists and multi-select picklists can be dependent fields.</li></ul>`,
"label.customobjects.track.introduce3":`Please note: only part of the fields diaplyed are tracked and "Edited" will be shown when traking fields.`,
"front-kefu-moudle-all-hidden-phone":`Hide phone number globally`,
"vue_label_calendar_share_calendar_with_others":`Share Calendar with Others`,
"label.case.copre":`Download Web Portal QR Code`,
"label.conditiontag.lookup.pagetitle":`Select Picklist Values`,
"UG.opportunity.004":`Multi-service type`,
"label.event.moveup.1day":`1 day ahead`,
"label.industrialandcommercialverification.enablestatus1":`Enable Industrial and Commercial Data Verification`,
"label.ccpeak.newrecord.getorpost":`New Record: there are two ways to construct a CCObject using CCObject.`,
"frame.personinfo.label.resizeimage":`To make adjustments to your thumbnail image, drag and resize the dotted lines in your profile photo above.`,
"label.optional.searchresultfield":`Available Search Result Fields`,
"UG.Contract.02":`The contract is a written agreement between the parties. Many companies use contracts to define terms of doing business with other companies. Use CloudCC to establish and document your existing contracts with your accounts and business opportunities. Track the contract through the approval process. Use workflow reminders to remind you of the contract rollover.`,
"label.group.activity":`Active Groups`,
"label.tabpage.characterz":`Beginning character`,
"label.globalsearch.tip":`Please enter the search content`,
"label.campaign.channel.download.size2":`Medium Size: 500*500 pixels`,
"label.step3.total4":`Step 3 of 4`,
"label.partnerCloud.payForFailure":`Payment failed`,
"label.ggReleaseRange.editSuccess":`Edit successfully`,
"label.summaryinforelyon":`Summarized Data By`,
"label.productsales.htyj":`Contract Performance`,
"label.newpagelayout":`New page layout`,
"front-gantt-module-input-task-name":`Please enter task name！`,
"label.c_d_without":`"C" records may or may not have related "D" records.`,
"label.licence":`Licenses`,
"setup.layout.button.selectall":`Select All`,
"label.app.step1.error.appnameexist":`ERROR: The app name already exists.`,
"label.cpq.quote.item.no.record":`Only order products with records can be transfered to contracts.`,
"label.knowledgebase.noaffect.existing.translations":`No, my modifications will not affect the existing translation.`,
"label.schedulejob.setup.schedule.editjob":`Scheduled Job Edit`,
"lable.PowerProcess.Tips":`The entitlement process is a customizable timeline containing all the steps (milestones) that could support customer service and other staff to complete all steps in order to resolve a supported case or work order record. After the setup is complete, it can be applied to the entitlement.`,
"label.campaignmember.selectmember.step2":`Step 2 Select the members you want to add`,
"vue_label_calendar_stopsharing":`Are you sure to stop sharing calendar`,
"vue_label_notice_savemenu_fail":`Menu save failed`,
"message.error.getitems.id":`getItems: id cannot be empty`,
"label.return.currencylist":`Back to List: Currency Management`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Publish Now`,
"label.appupload.install.explain":`Install Instructions`,
"label.visualpage.folder.all":`All Page Folders`,
"message.passwordPolicy.validate.complexReq2":`Error:Your password must have a mix of uppercase and lowercase letters and numbers.`,
"label.umeng.chatter.at":`mentioned you.`,
"label.mobile.phone.month.report":`Monthly Work Notes`,
"label.describableEditeSelectedFields":`Select the fields that displays in the report columns by default when you create a new custom report.`,
"component.event.label.subject":`Theme`,
"label.knowledgebase.edit.draft":`Edit Draft?`,
"label.customer.tab.step1.selectoneobject":`Select an existing custom object`,
"label_partner_step2":`Step 2 confirm template`,
"label_starting_annual":`Starting year`,
"X":`Text Area`,
"label.customer.tab.style":`Tab Style`,
"vue_label_commonobjects_detail_book":`A Standard Price Book`,
"chatter.email.referredToMe":`Mentions me in a post`,
"label.enable.both.barcode.qrcode":`Activate bar code and QR code`,
"front-market-form-quired-choose":`Required Fields`,
"noinclude":`excludes`,
"label.sms.template.select":`Please select the SMS template`,
"label.weixin.optionten":`Choice 10`,
"message.duplication.label.matchlastletters":`Last N Characters`,
"label.webtocloudcc.submit.success":`Successful submission`,
"label.sales.dashboard.number":`No.`,
"label.custom.field":`Map this custom field`,
"label.dataimport.of.field":`field(s)`,
"label.view.new":`New View`,
"UG_activity_03":`Reserve a schedule`,
"label.customfields.image.tip":`Allow users to upload pictures.`,
"label.startexport":`Start Export`,
"vue_label_commonobjects_view_chart_verticalbar":`Vertical Bar Chart`,
"label.ccchat.person.invite.allexist":`Everyone you invite is already using CCChat`,
"label.fielddependence":`Field Dependencies`,
"label.scan.tip":`Please use IE7, IE8, Chrome or Firefox browser, and it is recommended to use a resolution of more than 1024×768.`,
"label.wei.weiactor":`Voted By`,
"label.service.miniProgram.quantity":`Up to 20 carousel records can be created~`,
"vue_label_homepage_new_homepage_page":`New Homepage`,
"label.apply.telphone.validate.error":`Wrong validation number.`,
"component.assistant.button.newevent":`New Event`,
"System_TimeField_Format_Warning":`Unvalid Time`,
"chatter.feed.publishfeed":`Post`,
"label.setting.intergrationlist":`Integration`,
"label.object.prefix":`Object Prefix`,
"label.tippage.confirmed":`Yes, I want to delete the custom report data source and all dependent reports.`,
"label_emailsync_form_signin":`Login`,
"label.delete.cancel":`Undelete`,
"label.dashboard.myHomePage.des":`Select the dashboard to diaplay in each app.`,
"lable.account.FY.Ago":`2 FY Ago`,
"label.umeng.approval.reassign":`#approver has reassigned your approval request #obj.`,
"label.data.exp.zippwd2":`Automatically Generate Compressed File Password`,
"label.tabpage.contentz":`Please enter content`,
"label.callcenter.batch.add.number":`Add Numbers in Batch`,
"label.tabpage.deleteviewsuccess":`Delete view successfuly`,
"setup_layout_group_field":`Fields`,
"label.appupload.component.addobj.scheme.label.suoshu":`Object`,
"front-project-module-v1-market-is-template":`Mark as Template`,
"label.service.gantt.one.esource.types":`and one of the following resource types`,
"label.emailtocloudcc.search":`Search`,
"label.mobile.home.page.myyj":`My Performance`,
"vue_label_normal_invoice_sf":`Invoice`,
"label.permission.detail.app.fenpei.tip":`Specify which applications are visible on the application menu.`,
"label.login.access.month":`Month`,
"label_tabpage_retypez":`When the record type is changed, the existing option list values will not be automatically changed. we recommend to update the existing options list value of the record in the same place.`,
"label.ems.private.company.message":`Private cloud versions do not support online editing the email box of company.`,
"label.dataimport.length.check":`Length over 18 bits, please carefully review the record and modify.`,
"label.batchtransfer.type1":`Transfer the open oppertunities that do not belong to current account owner`,
"vue_label_calendar_are_you_sure_to_remove":`Are you sure to remove this calendar`,
"label.icon.117":`School Bag`,
"vue_label_systemSettings_downloadapp":`Download Mobile App`,
"label.approval.project":`Items to Approve`,
"template.organization":`Organizational Level`,
"label.weixin.return.research":`Back to Micro Survey Detail Page`,
"label.ccchat.person.invite.addsay":`Add an optional message…`,
"UG.Case.02":`Cases allow you to respond to and resolve account issues. Cases are a powerful record in Cloud CC that not only tracks account issues, but also displays a complete view of the account.`,
"label_emailtocloudcc_step1":`Step 1`,
"workflow.action.tasks.assignortype.owner":`Owner`,
"label.data.import.page":`Go to Importing Page`,
"label.cache":`Cache`,
"label.custom.page.cuspage.width":`Width(Pixels)`,
"label.customcomponent.referencetag":`Reference Label`,
"label.tabpage.search":`Search`,
"label.knowledge.searcharticle.casefields":`Fields of cases for searching suggested articles`,
"setup_layout_message_relatedlistfield":`Select fields to display on the related list. You can also re-order the selected fields.`,
"label.relationobject.type":`Related Object Type`,
"UG_Account_02":`Some companies provide services to other companies, some directly collaborate with end users, and others serve NGOs.`,
"UG_homepage_006":`360-degree visibility into your account activity through surveys, live chats, emails, work orders, social media posts, and even sales activities (such as leads, service support, and activities).`,
"chatter.poll.option1":`Choice 1`,
"label.ccdocument.fieldforld":`Name of the folder documents belongs to`,
"label.wei.result":`Result`,
"label.recentview.new":`Latest`,
"label.martrixreport.setsumfield":`Select the field to use as the summary row in your matrix report`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Monday`,
"label.marketsea.button.recycle":`Recycle`,
"label.standard.buttonandlink.info2":`Select the custom CloudCC.com custom Page to use in place of the CloudCC.com URL for this standard button or link.`,
"label.reportsSubscription.select.two.months":`Please select a date range within two months for this frequency!`,
"label.standard.buttonandlink.page":`CloudCC Classic`,
"vue_label_commonobjects_view_chart_horizontalbar":`Horizontal Bar Chart`,
"label.Remove":`Remove`,
"label.mobile.phone.receivable":`Receivables`,
"label.appupload.uploaddetail.goback":`Back to Package`,
"label.select.role":`Please choose a role`,
"label.file.sharetype":`Share type`,
"label.app.chosetab":`Select Tabs`,
"label.case.other.phone":`Other Mobile Number`,
"chatter.edit.cancel":`Your changes have been canceled.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Failed to get auth2cn!`,
"message.error.system.service.permissiondeny":`Sorry, you are not allowed to be served this service, please contact your administrator.`,
"label.chatter.mygroups":`My groups`,
"label.umeng.approval.approvalpass":`Approval request for the #obj is approved. #objname`,
"label.chatter.owner":`Owner`,
"vue_label_commonobjects_view_kanban_view":`Kanban View`,
"message.please.choose.group.role":`Please select group role`,
"label.icon.136":`Currency`,
"label_tabpage_selectdate":`Select a date`,
"chatter.emailInformation":`General Information`,
"front-lightning-module-v1-dashborad-bubble-size":`Bubble Size`,
"label.stdashbord.xsld.business.wan":`myriad`,
"label.datamanage.field.notexist":`The field corresponding to the object does not exist.`,
"UG.Forcast.04":`Start trial`,
"UG.contact.02":`Engage contacts through multiple channels, call, email, social`,
"vue_label_pool_selecttransferinto":`Select the lead pool to transfer into`,
"label.quote.xingming":`Name`,
"label.customerinfo.userlicencenum":`User Licenses`,
"label.group.no.my.archived":`No matching archived groups found.`,
"label.weixin.add.activity.tel":`Add Activity Call`,
"label.partner.setup.address":`Partner Cloud Address:`,
"label.data.file.i_title.num3":`3.The system pre-reads the data file to the server, then starts the back-end mass importer, the results of which will be notified to users by mail, and you will not have to wait on this page.`,
"label_sum_up":`SUM`,
"label.searchall.title":`Global Search`,
"label.bind.chooseone":`Choose Owner`,
"label.campaign.channel.input.owner.select1":`Current Campaign Owner`,
"front-kefu-moudle-v1-Expand-chat":`Expand Chat Details`,
"label.component.hotdeal":`Hot deals`,
"component_event_label_title":`Upcoming events`,
"No.planed.activity":`No planed activity`,
"label.searchlayout.result.field":`Search Results Columns for search and tagging.`,
"label.leadscore.value":`Value`,
"vue.dashboard.linkage.is.set.successfully":`Linkage set up successfully!`,
"PersonalInfo.LoginHistory.001":`Broswer validates the registration link in your mailbox`,
"front-gantt-module-v1-problem-number":`Issues`,
"label.page.step5.of.step5":`Step 5 of 5`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat message alert`,
"label.Linkedin_accounts":`LinkedIn Account`,
"label.qrcode.useful.life":`QR Code Expiry Date`,
"deleterow":`Remove Row`,
"label.forecast.settings.future1":`Future 1 cycle`,
"message.error.group.operation":`Group filing error`,
"label_tabpage_loadz":`Page loading, please wait…`,
"label.brackets.left":`(Open Parenthesis`,
"label.source.code":`View source code`,
"setup_layout_label_areasetup":`Section Properties`,
"component.assistant.label.todaylead":`The leads assigned to you today`,
"label.qrcode_signin":`QR Code is limited to applications that require onsite code scanning and signin`,
"label.calendarshare":`Calendar Sharing`,
"IMG":`Image`,
"label.use.rule.when.both":`Apply this rule when enabling bar code and QR code at the same time.`,
"label.ccpeak.addshare.record":`New shared form records:Recently Added Records`,
"label.enable.email.tracking":`Enable email tracking`,
"label.top.plsinput":`Search this list...`,
"vue_label_helpcenter_case":`Cases are customer questions, feedback or issues. Supporting agents can review cases to understand how to provide better service. Sales representatives can use cases to understand the impact on the sales process. Responding to individual cases can satisfy your customers and enhance your brand image.`,
"label.useonly":`Private`,
"label.displaytype":`Display Type`,
"label.most.user.group":`Users can join up to 100 User Groups,and you have already joined the 100th User Groups.`,
"label.umeng.activity.yourevent":`Your event`,
"label.forecast.shrepage.classdes.w":`Read/Write - Users can view and override forecast data.`,
"label.defaultaccess":`Default Access`,
"label.partner.new.step2":`Step 2 confirm template`,
"component_setup_iframe_label_title":`Customize page`,
"label.sso.saml.sp.idenitytype":`SAML Identity Type`,
"label.dashboard.this.folder":`Dashboards in This Folder`,
"label.data.newtemplate.e.seltype.desc":`There are two kinds of derived data</li><li class`,
"label.forecast.customforecast.submit.tip1":`Submit your forecast from:`,
"label.version.workflow.and.approval":`Workflow and Approval Process Automation`,
"label.tianyancha.tip":`The input text is incorrect, please re-enter!`,
"label.report_details":`Report details`,
"template.report.folder.contract.product":`Contract and Product Analysis`,
"label.all":`All`,
"label.version.area.long.rich":`{0} rich text or long text area fields`,
"label.enc":`Encrypted Storage`,
"vue_label_pricebook_enterproductname":`please enter the product name`,
"label.edit.quote.line":`Edit Quote Line`,
"label.edit":`Edit`,
"M":`Master-Detail Relation`,
"front-kefu-phonenumber-exists":`Seat No.{a} already exists`,
"label.standardplatformuser":`Standard Platform Users`,
"label.custom.page.configuration":`Edit Custom Console Component`,
"url.error.contact.null":`Microservice address is empty.`,
"label.sethelp":`Help Settings`,
"setup.mainpage.label.welcome23":`Security settings`,
"label.sales.page.dashboard.fenxi":`Sales Analysis Dashboards`,
"label.limit":`Access`,
"maintenanceasset.asset.contractlineitem.illegal":`You must select the asset on the contract line item before you associate the contract line item with the maintenance asset.`,
"UG.contact.04":`Or`,
"Opportunity.Detailed.Phase.Label.004":`Day(s)`,
"label.emailobject.receive":`To`,
"label.brief.new":`Recently New`,
"label.marketsea.button.adopt":`Collect`,
"label.select.up.to.three.fields":`A maximum of three fields can be selected.`,
"vue_label_allsearch_noresults":`We've searched by your customized search settings, no matching result found with {userInput}`,
"Report_CantDelete_Info":`{0} report is the data source for the {1} dashboard and cannot be deleted!`,
"label.chile.summer.time":`Chile Summer Time`,
"label.partnerCloud.menu.selectedMenu":`Selected menu (checked menus will sync to the mobile)`,
"vue_label_report_onlysummary":`Summary only`,
"front-template-V1-Applicable-object":`Please choose applicable object.`,
"label.invoice.message.sendfailed":`Invoice failed to send, please try again later`,
"front-kefu-moudle-v1-use-free":`TRY FOR FREE`,
"label.rule.updated.successfully":`Update the rules successfully`,
"label.owner.lastone":`Maitain one condition at least`,
"label.appointment.wizard.subtitle1":`Meeting Duration`,
"template.report.opportunities.closed.month":`Closed Opportunities of This Month`,
"label.tabpage.choosecontent":`Select the value content`,
"template.chart.jbnddxl":`Order sales in the past half year`,
"label.fieldsecurity.detail":`Field Security Details`,
"label.knowledgebase.data.deleted.successfully":`{a} data deleted successdully`,
"label.sso.saml.idp.config.nameidfmt":`Name ID Format`,
"label.emailobject.prompt":`Prompt`,
"label.marketsea.isgetbyself":`Allow members to collect by themselves`,
"label.winxin.cancelprompt":`Are you sure to exit? your current operation is not saved.`,
"label.appexchange.installedpage.message2":`Apps and components are installed in packages. Any custom apps, tabs, and custom objects are initially marked as "In Development" and are not deployed to you users.This allows you to test and customize before deploying. You can deploy the components individually using the other features in setup or as a group by clicking Deploy.`,
"vue_label_import_importtype":`Import type`,
"label.data.importef.des":`Files that failed to import will be saved on the server for 48 hours and will be automatically deleted after 48 hours.`,
"chatter.email.reply":`Comments on my posts`,
"label.stdashbord.xsld.business.sdl":`Lost Rate`,
"labal.emailtemplate.namemessage":`The unique name of email template exists, please re-enter.`,
"vue_label_email_Please_select_file":`Please select file`,
"label.event.modify":`Event Edit`,
"label.projectManagement.isnmber":`Please enter a number with up to one decimal.`,
"lable.outlook.detail.emailst":`Email Settings`,
"label.partnerCloud.priceOfManual.isUsed":`This setting determines whether or not partners can use this price book for ordering.`,
"setup_mainpage_label_welcome26":`Data Management - Batch Processing`,
"label.file.version":`Version`,
"pagecreator_systemstyle_label_bordercolor":`Border color`,
"label.approval.isallowed.reject.prompt":`Do you want to allow rejection when approving single data?(Mass approval can always be rejected.)`,
"label.myinfo":`Personal Information`,
"front-template-V1-fontSize":`Font Size`,
"lable.outlook.edit.alpreo":`Always Preferred Exchange`,
"front-email-payment-card-number":`Card Number`,
"label.cpq.quote.pricebook.no.change":`Once the price book for a quotation has been determined, it cannot be changed. Please create 1 new quotation record for using a new price book.`,
"vue_label_file_size_limit_tip":`File size exceeds limit`,
"lable.PowerProcess.worktime":`Working Time of Entitlement Process`,
"label.monthly.month.report":`Monthly YoY and MoM Report`,
"front-kefu-moudle-v1-sydq-buyuser":`Your trail is due. Please purchase the Easemob to keep use`,
"label_tabpage_Rolesz":`Roles and Subordinates`,
"chatter.f.n":`Follow this record`,
"UG.Forcast.02":`Forecasts are estimates of expected sales for a given period, and forecasting models can help you determine product demand and sales revenue in a certain period. Managers can use forecasts to set goals and measure team progress. The organization's overall forecast can reflect the summary of all sales by sales representative (regardless of the stage of completion of sales from the pipeline stage to the closed stage).`,
"label.productsales.contract.phb":`Contract List`,
"label.umeng.insert.approval.submit":`#applyer submits #obj for your approval`,
"message.duplication.label.matchfirstletters":`First N Characters`,
"label.partnerCloud.partnerAccount.toPay":`Go to Pay`,
"label.model.un":`Model No.: UN6786`,
"label.save.c1":`The name of "Web to CloudCC" must be unique.`,
"week":`Week`,
"Pagelayout.Setup.003":`The Name field must be selected`,
"label.query.detail.openpartnermessage":`Once the account is enabled as a partner, a record will appear in the reports and list views filtered on the isPartner field. In addition, partner users can be created from contacts associated with this account. Are you sure to enable?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(date)`,
"label.apply.send.false":`Send failure`,
"label.recordtype.edit.selectvalue":`Picklist Values`,
"label.chosesubject":`Select a subject below`,
"label.validate.function.funcExplain.YEAR":`The year of the return date is a number between 1900 and 9999`,
"component.chatter.button.more":`See more details`,
"label.top.class.smallest":`The minimum level of the hierarchy is 1.`,
"label.startingvalue":`Starting Number`,
"label.multi.layout.remark":`Layout that applies to front Master-Detail Input and Mass Add`,
"label.role.availableuser":`Available Users`,
"label.weixin.iebrowser":`The browser version you are currently using is IE6, which was released by Microsoft in 2001. Since the browser version is too low for CloudCC to be developed using new technology, it is not guaranteed that all functions will be used properly. Please doenload and update your browser in time.`,
"Homepage_News_004":`No recently news.`,
"vue_label_normal_task_sf":`Task`,
"label.version.nonsupport.trigger":`Triggers not supported for the time being.`,
"pagecreator_page_label_pagelayout":`Page layout`,
"label_tabpage_step3":`Step 3 select the fields to display`,
"label.canOnlyUploadCSVFormatFile":`Upload only files in CSV format`,
"label.b.c.least":`Each "B" record must have at least one related "C" record.`,
"label.list.userinterface.sales.enable":`Enable to Access Sales Leaderboard Data`,
"label.umeng.approval.approvalreject":`Approval request for the #obj is rejected. #objname`,
"vue_labenl_normal_notice_share_fail":`Sharing failed`,
"label_emailtocloudcc_tip":`Prompt`,
"label.h5.touchselect":`Click to select`,
"label.tabularreport":`Tabular Report`,
"label.app.defaulttab":`Default Tabs`,
"label.validate.function.category.Datetime":`Date and Time`,
"vue_label_pricebook_editdetail":`Edit price list entries`,
"vue_label_commonobjects_view_no_selected_record":`No record selected`,
"chatter.changed":`Changed`,
"label.asset.bom.based":`Generate asset BOM according to product structure of the order`,
"label.appointmentdetail.wizard.title8":`Start in Every`,
"label.area.query.user.error":`The user data corresponding to the query territory failed, and the territory ID was empty.`,
"page.field.masterinput":`Set Master-Detail Input`,
"chatter.selads":`Select Recipients`,
"label.data.exp.please.savebutton":`Please check "Save as Template".`,
"label.members.activity":`Activity Member`,
"label.weixin.click.searchs":`Click to search record`,
"label.input.least.two":`Please enter two characters at least`,
"label.marketing.seting":`Marketing Cloud Settings`,
"label.approveprocess.tip":`Approvals are complex business processes that require information gathering and planning before implementing. It is recommended that you follow the instructions below before getting started.`,
"front-email-payment-Invoice-login-account":`Login Account`,
"label.selectmulti.mes":`Too many recipients selected.`,
"label.workflow.gotolist":`Back to List: Workflow`,
"label.profile.fieldsafety":`Field-Level Security`,
"front-project-module-v1-no-selectemplat":`No available template`,
"label.sendemail.queue.assigntitle":`The email of queue assign object notification`,
"label.approval.mobile.comments.placeholder":`Please enter a comment here, up to 1000 words`,
"vue_label_report_given":`specific`,
"vue_label_dashboard_groups":`Please select group`,
"label.service.gantt.popoverTip":`Travel Distance/Travel Time`,
"label.mr.title.characters":`According to the length of characters`,
"label.passwordPolicy.setup.day":`days`,
"label_tabpage_personvisible":`Visible to relevant personnel`,
"ct":`Multi-currency`,
"label.chatter.newEvent":`New Event`,
"vue_label_systemSettings_id":`Login Identity`,
"label.page.preview.web.tab":`Preview Web Tab`,
"label_emailsync_button_sure":`Confirm`,
"front-template-V1-Modification-time":`Modification Time`,
"vue_label_homepage_edit_fixed_components":`Edit Standard Components`,
"label.apply":`Apply`,
"Main.Menu.Mobiledownload":`GET IT ON`,
"vue_label_salesfunnel_notice6":`The total amount of opportunities with a probability of 100%`,
"label.chosesubject.sendemail":`Send Email`,
"label.changemydisplay.chagetab.des":`Choose the tabs that will display in each of your apps.`,
"label.attendance.setting.checkUser":`already exists in other attendance.`,
"label.list.projectSetting.setup":`Project Management Settings`,
"label.app.introduce2":`You can customize existing apps to match the way you work, or build new apps by grouping standard and custom tabs.`,
"label_emailsync_form_emialpassword":`Password`,
"label.Lightning.Setting":`Lightning Settings`,
"label.print.preview":`Printable View`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Do you still want to create the event in this timeframe?`,
"label.mobile.phone.report.type":`Report Type`,
"lable.account.CalenderWeek":`Calender Week`,
"label_emailtocloudcc_step3total3":`Step 3 of 3`,
"label_tabpage_emailaddressz":`Email Address Of Sender`,
"label.data.is_woking":`Operating`,
"label.knowledge.cancelattach.case":`Cancel Attach to Case`,
"label.sendemail.chat.chatcontent":`The content of main post:`,
"label.timezone.set":`Territory Setup`,
"label_tabpage_uploadingz":`Uploading`,
"front-epwechat-module-v1-home-url":`Homepage URL:`,
"label.reportsSubscription.select.subscription.frequency":`Please select subscription frequency!`,
"label.validate.function":`Function`,
"label.partnerCloud.orderingPlatform.quantity":`Quantity`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Configure single sign-on in order to authenticate users in CloudCC from external environments.`,
"label.ccchat.message.new.error1":`We cannot find any chat user with {0} in their name.`,
"label.file.share.email.content3":`For details, please log in to the CloudCC CRM system.`,
"label.file.cancel.sharing":`Cancel sharing`,
"label.changemydisplay.showalltabs.add":`Add Tabs to Your Default Display`,
"label_chatter_incident":`Event`,
"label.file.folder.delete3":`Are you sure you want to delete {foldername}？`,
"label_tabpage_delsuccessz":`Delete successfully`,
"label.view_contact":`View Contact`,
"label.deactivate":`Deactivate`,
"label.Horizontal.Date":`Filter service appointments according to leve date`,
"label.forecast.tree.title":`Forecasts Hierarchy`,
"vue_label_dashboard_dategruop":`Please select date grouping basis`,
"label.version.nonsupport.custompage":`Custom pages are not supported temporarily.`,
"label.tabpage.personvisible":`Visible to relevant personnel`,
"message.error.unknown":`Unknown Error`,
"label.down":`Down`,
"label.multilang.customforcast.financialyear":`{0} fiscal year：`,
"label.dataimport.type.error":`Type error, please check the record and modify.`,
"label.batchadd.newbatchpage.save.num":`Incorrect numerical format`,
"front-Dev-V12.2.8-calendar-endField":`End Field`,
"label.tabpage.rtemptyz":`Record type cannot be empty`,
"vue_label_dashboard_maximum":`Please enter the maximum`,
"label.expiredate":`Due Date`,
"label_emailtocloudcc_button_view":`View`,
"label.event.future":`Future Events`,
"label.mobile.app.layout":`Mobile App Layout`,
"label.emailobject.contacts":`  contact(s)`,
"label.approvalstep2.tip":`Specify whether a record must meet certain criteria before entering this approval step.`,
"label.usefollowtoset":`Using the options below, specify the user to whom the approval request should be assigned.`,
"label.dashboard.summary.editPageHeader":`Edit Header`,
"label_partner_workspace_tab_memo":`Select tabs for this partner cloud. either standard tabs or customized tabs can be selected.`,
"front-lightning-module-v1-details-page-chart-title-supports":`· The Title supports to insert a record name with a format of {recordname}, such as "Opportunity Amount of {recordname}". If the current record name is CloudCC, then it will be displayed as "Opportunity Amount of CloudCC".`,
"label.enable.generate.location.service":`Enable the service of generating latitude and longitude data based on customer address`,
"label.loginsystem":`Login`,
"label.email.template.edit.template":`Edit Template`,
"vue_label_commonobjects_detail_share":`Revenue share`,
"label.icon.142":`House`,
"label.maintype":`Master`,
"label.step2.total4":`Step 2 of 4`,
"label.select.intended.tablayout":`Choose the page layout of the web tab you wish to create.`,
"label.custom.unit":`Unit`,
"label.mr.title.phone":`Phone`,
"label.compact.layout.frame.showtype":`Display method:`,
"label.associations":`Associated Object`,
"label.potentialcustomers.name":`Lead Name`,
"label.edit.profile":`Edit Profile`,
"label.tabpage.allvisible":`All users are visible`,
"label.login.verification.confirmation.enabled":`Comfirm to enable`,
"vue_label_norm_recordselected":`{selectNum} record(s) selected`,
"label.partner.workspace.member.selectedprofile":`Selected profile`,
"label.divide":`/Divide`,
"label.version.case.control":`Case Management`,
"label.attendance.nocheckin":`Not Check-In`,
"vue_label_helpcenter_report2.1":`2.Remove row grouping: <br> A. After finding the "row grouping" field you want to remove in the "group row" list on the left, click the "×" on the field box. <br> B. Or find the "row grouping" field you want to remove in the header of the preview report on the right, click the "drop down button", and click "delete group row".<br> Remove column grouping: <br> A. After finding the "Column Grouping" field you want to remove in the "Group Columns" list on the left, click "×" on the field box. <br> 1. B. Or find the Row Grouping field you want to remove in the table header of the preview report on the right, click the drop-down button, and click Delete Group Row. <br> To remove a column grouping:<br> A. Find the Column Grouping field you want to remove in the Group Columns list on the left, and click the "x" on the field box. <br> B. Or find the Column Grouping field you want to remove in the table header of the preview report on the right, click the drop-down button, and click Delete Group Column. <br>? Customizing Date Granularity for Grouping Records<br> Step 1: After grouping by date fields, you can also customize the date granularity. First, select the date field you want to group the report by. Then click the Dropdown button next to this field in the preview report header and click Date Grouping Basis. <br> Step 2: Select how you want to group: Day, Month, Year, Accounting Quarter, Accounting Year, Custom Quarter, Custom Year. <br>? Step 1: After finding the column you want to summarize in the header of the preview report, click the "drop-down button" and click "Summary". <br>`,
"label.payment.renew":`Renew`,
"vue_label_file_wrong_type":`'There is an error in the file upload type, the file format you are uploading now is {type}!`,
"UG_opportunity_005":`Multiple sales process`,
"label.knowledge.language.korean":`Korean`,
"label.customobjects.inputrecordtagandformat":`Enter Record Name Label and Format`,
"label.h5.chatter.commentednum":`Receive a response`,
"label.quickbooks.button.unlink":`Unlink`,
"label.step5.total5":`Step 5 of 5`,
"label.projectManagement.Selweek":`Select Week`,
"label.optional.searchfield":`Searchable Fields`,
"label.mobile.quickcreate.default.signin":`Check in`,
"label.visualpage.unable.parse":`Unable to resolve marker.`,
"mesage.error.role.delete":`You cannot delete the role which the child role has been assigned to.`,
"label.role.user":`Users in the Role`,
"button_partner_workspace_saveas":`Save as`,
"label.file.no.public.link.created":`No public link created`,
"label.login.access.shenyu":`Remaining`,
"label.ccchat.group.section":`Group`,
"label.weixin.object.notnull":`Theme can not be empty`,
"label.accmarketsea.add.title":`New Account Pool`,
"label.sales.funnel.layout":`Sale Funnel Layout`,
"pagecreator.page.button.edit":`Edit`,
"label_tabpage_entercontent":`Please enter content`,
"component_event_label_begindate":`*Start Time`,
"label.file.versionhref":`Switch to the new version of the page`,
"label_chatter_send":`Send`,
"setup_layout_label_buttonlist":`Select buttons`,
"label.custom.Current.and.NexttCQ":`Current and Next 3 CQ`,
"pagecreator_page_label_pagedesc":`Page description`,
"label.appupload.upload.uploader":`Uploaded By`,
"label.console.step5.tab.primary":`As a primary tab`,
"vue_label_globalsearch_expandlist":`Expand list`,
"label.forecast.edit.userqu":`Target`,
"label.step1.total5":`Step 1 of 5`,
"label.multilang.dupicatecheck.onegroupredata":`Progress of the verification of duplicate and the combination：a total of {0} groups：`,
"vue_label_systemSettings_repeat":`Manage Duplications`,
"label.mobile.side.tab.error1":`Please select the commong fuctions and application tabs that need to be displayed.`,
"label.knowledgebase.reduction":`Restore`,
"label.standard.buttonandlink.override.usedefault":`No Override(use default)`,
"dateandtime":`Date/Time`,
"label.group.activate.info":`Activate group`,
"label.triggertotask":`Task Triggers`,
"label.emailobject.save.template":`Save draft as a template`,
"label.audit.objInfo":`Approval Process Detail`,
"label.callcenter.successfully.logged.account":`Logged in successfully!`,
"label_new_customer_target":`New Account Target`,
"label.campaign.channel.step5":`Step 5: Preview the marketing channel registration page and source code.`,
"label.log.type":`Operation Types`,
"front-template-V1-noTemplate":`No available templates were found under the switched object.`,
"label_report_line_daixuan":`Pending report column`,
"label.tianyancha.businessverify.relation.tip":`Write the fields returned by tianyancha to fields of customer`,
"label.default.value":`Use this value as the default value for the master picklist`,
"label.weixin.campaign.attendance":`Campaign Attendance`,
"message.duplication.label.check":`Check`,
"label.salescloud.salescloud.yes2forbidden":`Yes, I want to deactivate Group Sale.`,
"lable.currencyAdv.exchagecurrency.rate":`Exchange Rates for:`,
"lable.Hide.title":`Hide titles`,
"label.finishedreport":`Generated Reports`,
"vue_label_account_business":`Transfer closed business opportunities of customer owners`,
"vue_label_pool_assigned":`Assigned`,
"label.report.export.error":`The export operation encountered an exception. Please try again.`,
"label.layout.availablefield":`Available Fields`,
"label.licence.remainder":`Remaining Licenses`,
"label.approval.idea.required":`Approval opinion is required.`,
"front-kefu-moudle-needhand-createcase":`Manual confirmation is required before creating case`,
"label.dashboard.snapshot.Data.change":`Data source changed,please reconofigure`,
"label.partner.workspace.login.footertext":`Footer Text`,
"vue_label_chatter_upload_link_type":`Selected upload link-type post`,
"front-dialog-module-v1-error-detail":`Error Details`,
"label.emailobject.sendgroupemail":`Group Email`,
"lable.newtabpage.allviews":`All Views`,
"label.khdd":`Account Location`,
"vue_label_dashboard_sortfield":`Sort Field`,
"label.form.sample":`Sample Form`,
"component_setup_button_cancel":`Cancel`,
"vue_label_salesfunnel_notice5":`Number of opportunities with a probability of 1% - 99% * probability`,
"pagecreator_systemstyle_label_modifystyle":`Style editor`,
"UG_homepage_001":`Win more deals in less time`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Lightning version`,
"label.knowledge.category.hint.two":`Use this page to select the group for Lightning after creating category group.`,
"label.south.africa.standard.time":`South Africa Standard Time`,
"label.service.gantt.reservation.number":`Order Number`,
"label.weixin.report.period":`Period`,
"label.leadtomap.exp":`Use the tabs to map each of your organization's custom lead fields to one of your custom account, contact, or opportunity fields. These mappings are used when you convert leads to accounts, contacts, or opportunities.`,
"label.currency.d":`You can change your corporate currency to another one of your organization's supported currencies. All currency conversion rates already defined in CloudCC.com will be modified appropriately to reflect the change.`,
"label.forecast.detailforecast.oppyclb":`Opportunity Forecast Categories`,
"label.reportsSubscriptionPage.email.selected":`Selected Members`,
"vue_label_homepage_componentname":`Please enter the component name`,
"lable.account.Previous.FYt":`Previous 2 FY`,
"label.appupload.success":`Upload Complete`,
"label.customer.newtab":`New Custom Page Tab`,
"label.value.notnull":`You must enter a value.`,
"label.case.miniprogram.layout":`The page layout of the applet report page is the page layout used for the service request that submitted from the applet end, and this page layout can only be edited and cannot be deleted.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Please enter in correct format.  Two decimals can be kept.`,
"UG.Lead.004":`Web form`,
"label.umeng.activity.event.eventwillbeginnew":`Event notification: #event starts at #begintime`,
"label.projectManagement.subtasks":`Subtasks`,
"vue_label_checkduplicate_repeat_conditions":`Identify Duplicate Criterion`,
"label.subject":`Subject`,
"label_search_otherusers_forecast":`Search for other users' forecasts`,
"label_tabpage_namemandatory":`The view name is required`,
"label.timezone.importtimezone":`Timezone Setup for Data Import`,
"label.mobile.buttom.team.init":`Team User Initialization`,
"label.checkfield.choosefield":`Select the fields to find the duplicates`,
"label.b_c_least":`Each "B" record must have at least one related "C" record.`,
"label.knowledge.setting.hint.five":`Select a Knowledge author`,
"label.h5.similar.opportunity.step2":`Step 2 Specify Match Criteria`,
"label.page.style.imbedded.cloudcc":`Full page style gives you maxmium screen real estate for the content you embed in the CloudCC.com window.`,
"label.sendemail.marketactivity.invitecode":`The invition code of the campaign #campaignname`,
"label.block.pricing":`Pricing by Blocks`,
"message.error.field.number.zero":`Length format entered error, cannot be 0.`,
"pagecreator.systemstyle.message.save.success":`Style saved successfully`,
"pagecreator_systemstyle_label_styledesc":`Style description`,
"APPIntegration_Dropbox_setting_01":`Enable`,
"label_emailtocloudcc_redmessage2":`Please input correct email password`,
"label.user.special.operations":`Only used in operating, can not be used temporarily, please contact the administrator!`,
"pagecreator_page_label_layoutpreview":`Layout preview`,
"APPIntegration_Dropbox_setting_03":`Enable Dropbox to let you select files from Dropbox and add them as attachments.`,
"label.sure_leave":`Are you sure to leave?`,
"label.applt.copylink":`Copy Miniprogram Link`,
"label_tabpage_allpotentialcustomers":`All leads`,
"label.rulestrikedate":`Rule Trigger Time`,
"label_tabpage_justsz":`Just`,
"label.customize.memory.function.sorting.title":`Customize My Memory Function of Sorting`,
"message.duplication.label.mergebutton":`Merge`,
"chatter.group.cancelRequest":`Cancel Request`,
"label.campaign.channel.step6.remark":`If you have confirmed the registration page, click Generate button to generate the registration page.`,
"label.appupload.upload.install.abort":`Cancel Install`,
"label.emailobject.proposetimes":`Propose times`,
"label.probability.cannot.empty":`You must enter a number in your opportunity posibility.`,
"vue_label_homepage_editkanban":`Edit Kanban`,
"lable.Related.template":`Relevant Templates`,
"label.cloudccclass.list.cls.time":`Scheduled Classes`,
"component.task.label.enddate":`Expire date`,
"label.sendmail.step3":`Step 3 Review and confirm`,
"label.projectManagement.Gridview":`Grid View`,
"label.emailobject.time":`Time`,
"label.applt.address":`Customer Service Portal of Miniprogram`,
"label.searchfield":`Search Fields`,
"vue_label_calendar_please_enter_the_name":`Please enter the name`,
"label.list.userinterface.default.page.setup":`System Default Page`,
"label.detail.2018":`Details`,
"label.webtocloudcc.success":`Your information has been submitted successfully. Thank you very much for your participation, we will serve you wholeheartedly.`,
"component_telerecord_label_title":`Record phone`,
"label.setting.sureDelete.rules":`Are you sure you want to delete this rule?`,
"vue_label_email_current_theme":`Inserting this template will cover current Email subject.`,
"lable.Order.product":`Order Product`,
"UG_product_02":`Products refer to products or services that are sold or purchased.`,
"label.appexchange.task":`Workflow Tasks`,
"label.selectprocesscondition":`Specify Conditions for the Step`,
"label.mobile.quickcreate.default.scan":`Scan`,
"label.tabpage.prepagez":`Display on every page`,
"label.query.error":`Query error.`,
"label.tabularreport.2018.step1":`Step 1 Choose the columns of the report`,
"pagecreator.systemstyle.label.modifystyle":`Style editor`,
"label.app.step3":`Step 3 Choose the Image Source for the Custom App Logo`,
"label_tabpage_rowsz":`Delete rows`,
"label.validate.function.funcExplain.SUBSTITUTE":`Substitutes new_text for old_text in a text string. Use SUBSTITUTE when you want to replace specific text in a text string.`,
"vue_label_checkduplicate_select_data_to_merge":`Select Data and Merge`,
"vue_label_commonobjects_view_chart_displaymode":`Display Mode`,
"label.industrialandcommercialverification.servicesetiings":`Service Settings`,
"label.refresh":`Refresh`,
"label.taskfield":`Task Fields`,
"label.notification.approval4":`【提交人】 is requesting approval for 【对象】`,
"label.group.isusing":`Activate`,
"label.language.settings":`Language Setting`,
"front-kefu-moudle-please-login":`Please Login First`,
"label.page.double.line.cloudcc":`2 Columns With CloudCC.com Sidebar`,
"folder.error.delete":`1. The current folder contains reports and cannot be deleted! 2. The current folder contains hidden reports and cannot be deleted! Hidden report is a report created based on a logically deleted object (settings-creation-deleted objects under the object), because the object is not really deleted, so the report is hidden`,
"eight":`Eight`,
"label.marketseamemset.user":`Member`,
"label.recordnum":`Record Number`,
"page.404.button.back":`Back to Previous Step`,
"label.mobile.phone.month.plan":`Next Month Plans`,
"label.marketseamemset.account.title2":`Please set an upper limit on the number of customers that affect all members. The limit is unrelated to the lead pool`,
"vue_label_chatter_current_avatar":`Current avatar`,
"label.mobile.side.tab.remark3":`Hold down the shift button, click or click drag to select a series of adjacent items. hold down the ctrl button and click to select multiple non-adjacent items.`,
"component.sendmail.label.touser":`Recipient`,
"label.homeitems.noobject":`No Subjects`,
"template.report.overall.sales":`Overall Sales Period (By Lead Source)`,
"label.partner.donotdel":`cannot delete`,
"label.service.miniProgram.bindCopyDesc":`After binding your organization to your company's official aacount or mini program, you can use this address as your own customer service portal by one-tap copying and jumping to this address.`,
"UG_Contract_01":`Manage contract`,
"UG_quota_06":`Create a quotation`,
"vue_label_report_deletereport":`Delete report`,
"front-epwechat-module-v1-input-appname":`Please enter application name`,
"label_tabpage_deleteviewsuccess":`View delete success`,
"component_chatter_label_mygroup":`My group`,
"label.campagin.roi.leixing":`Campaign Type`,
"label.dashboard.myHomepageDashboard":`My Homapage Dashboards`,
"UG_solution_04":`Import solution`,
"label.knowledge.setting.hint.four":`Activate Knowledge`,
"label.campaign.channel.add.field":`Click button to add fields`,
"label.eastem.european.time":`Eastern European Time`,
"label.partner.workspace.member.partner":`CloudCC partner profile`,
"label.campaignmember.main.backtocampaign":`Back to Campaigns`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Absolute`,
"label.task.unsolve":`All Open Tasks`,
"label.multilang.chatterservice.vote":`{0} ticket(s)`,
"label.console":`Console`,
"label.emailsync.message1":`If you cancel the connection, you will not be able to sync the contents of the mailbox to the leads and contacts, are you sure you want to cancel?`,
"pagecreator.systemstyle.label.stylename":`Style name`,
"setup_mainpage_label_welcome16":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Workflow, Approval Process, Tasks, Email Notification, Field Update, and more.`,
"message.duplication.label.editfilterule":`Find Duplicate Filter Rules`,
"Account.News.Setting.004":`Enable News`,
"label_tabpage_saveviewsuccess":`View saved successfully`,
"label.forecast.forehistory.replacecommit":`Commit Override`,
"pagecreator_button_cancel":`Cancel`,
"label.knowledge.article.nomatch":`Unable to archive this article for associated draft exists. Please delete draft and try again.`,
"vue_label_combined_field":`No fields to sum.`,
"label.batchadd.save.prompt":`record(s)`,
"label.tabpage.summaryway":`Summary By`,
"label.check.input.condition.two":`SQL is not supported`,
"mail.apiCode.notOnly":`The only name already exists`,
"UG.quota.01":`Manage account quotes`,
"label.approved.receiveApprovalEmail.option3":`Only if I am a delegated approver`,
"label.stdashbord.xsld.business.img5":`Total Amount of Probability 0%`,
"vue_label_chat_movedfromto":`{name} moved {label} from {oldField} to {newField}`,
"label.customfields.new.step2.opration":`General Options`,
"label.dashboardSetup.isurl":`Add Links`,
"label.forecast.settings.mrfwqj":`Forecast Cycle`,
"label.campaign.channel.field":`Fields`,
"label.weixin.optionthree":`Choice 3`,
"label.safetystatement":`Security Statement`,
"label.useskipwizard":`Use Jump Start Wizard`,
"label.projectManagement.completion":`Completion Status`,
"label.customfields.fielddependency.new.step2":`<b>Step 2: </b> On the following page, edit the filter rules that control the values that appear in the dependent field for each value in the controlling field.`,
"setup.mainpage.label.welcome8":`Drag-and-drop interface customization`,
"label.emailobject.list.outbox":`Outbox`,
"label.app.default.login.tab":`Default Login Tab`,
"label.follow_emails":`Follow-up email is a great way to quickly and easily contact your visitors once they submit forms.`,
"vue_label_homepage_application_page":`Application Homepage`,
"label.confirm.template":`Confirm`,
"lable.product.not":`Could not be complete delete`,
"label.multilang.feedtrack.dispalyinfo":`You can choose maximum {0} fields:`,
"label.weixin.plz.inputsrhkey":`Please enter a search keyword`,
"label.projectManagement.service.appointment":`Service Appointment`,
"label.list.userinterface.watermark.enable":`Enable watermarks in homepage, views, detail pages, reports, and dashboards on PC and mobile app.`,
"label.confirmDelete":`Are you sure you want to delete these data?`,
"label.sso.description":`Users can access the CloudCC.com system without login according to username and authorization code.<br>Click URL below to access the CloudCC.com system: http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Use the links above,'http://localhost:8080' please replace your organization's access to the link.'admin@dev.com' please replace your user name of the organization.<br>'dcc5c192facd7c08e124fbe93d8950b9' please replace your authorization code of the organization.`,
"errormessage_email_atleastonereceiver_z":`You must select or edit a receive address.`,
"C":`Roll-Up Summary`,
"label.service.major.event.edit":`Edit Milestone`,
"label.icon.9":`Service`,
"label.visualpage.notvalidate.check":`Invalid custom pages, please refer to the Help Text to check the page.`,
"label.audit.todo.from":`from`,
"label.directboss":`This role reports to`,
"label.manageAll.selpage":`Page`,
"label.console.step6.all":`Full screen, unfixed and the lists are visible only when the navigation tab is selected.`,
"vue_label_pool_expiredate":`Expire date`,
"lable.no.matching.record":`No Matching Record`,
"label.standard.redirecterror":`Jump to custom page through standard buttons failed.`,
"label.Platform.Setting":`Platform Settings`,
"lable.outlook.edit.havenewc":`Contacts with recently created activities`,
"label.partnerCloud.partnerAccount.choosePayment":`Please select a payment method`,
"label.weixin.optionsix":`Choice 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`Learn More`,
"label.customfields.number.tip":`Allow users to enter any number. Leading zeros are removed.`,
"label.import.index.processimport":`Importing`,
"label.quote.phone":`Phone`,
"label.insert.approval":`Insert Approval`,
"label.tabpage.printview":`Print View`,
"lable.product.price":`Price`,
"front-kefu-moudle-call-detail":`Call Details`,
"label.umeng.approval.apply":`apply`,
"label.background.the.form":`Form Background`,
"chatter.f":`Followers`,
"label.quickbooks.searchresault.company":`Company`,
"vue_label_systemSettings_platformutils":`Platform Tool`,
"front-quotation-v1-nofilles-tocreate":`Please click Generate Quote and send after the generation.`,
"label.category.6":`Medical Treatment`,
"label.attendance.choose.positon":`Select Landmarks`,
"label.batchadd.newbatchpage.save.pho":`Invalid phone format`,
"UG.Account.01":`Who is your account?`,
"label.marketseamemset.addspecialuser":`Add Special Members`,
"label.query.detail.forbidpartneruser":`Forbid Partner User`,
"label.stdashbord.xsld.business.ydzhl":`Won Rate`,
"vue_label_SMS_mymessagebox":`My Message Box`,
"label.knowledgebase.data.publishing.failed":`Publish {a} data failed. Please choose article with status equals to Draft to publish.`,
"label.wholestate":`Overall Status`,
"label.selectedline":`Selected Columns`,
"label.validate.function.funcExplain.LEFT":`Returns the specified number of characters from the start of a text string`,
"label.emailmerge.edittemplate.detail":`Mail Merge Template Details`,
"vue_label_checkduplicate_checkduplicate":`Check Duplicate`,
"label.knowledgebase.assign.articles":`Assing Articles`,
"label.tabpage.recordsz":`Record`,
"label.field.img.validate.error":`The variable name after $User is misspelled or an illegal $User reference, please check the spelling.`,
"workorderlineitem.worktype.isnot.father.worktype":`The work type associated with its parent record of this work order item must be selected.`,
"label.ccchat.group.name.noexist":`The group name you entered does not exist, please re-enter.`,
"label.weixin.sign.type":`Sign in (out) type error.`,
"label.nowvaluereplace":`Replace with Existing`,
"report_label_report":`Reports`,
"label.knowledge.setting.plus":`Plus Settings of Knowledge`,
"label.event.moveup.2day":`2 days ahead`,
"label.translation.start":`To get started in the Translation Workbench:`,
"lable.PowerProcess.created.time":`Based on the creation time of {detailInterestType}`,
"label.ems.step2":`Step 2`,
"label.tabpage.groupingemptyz":`Grouping items cannot be empty`,
"pagecreator.layout.button.new":`New layout`,
"label.tabpage.listshow":`The list shows`,
"label.partnerCloud.productSet.optionName":`Item Name`,
"label.service.without.cycle":`No Cycle`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} published votes for all in {1}`,
"label_target_model_dimension":`Dimension of Indicator Model`,
"component.task.label.subject":`Theme`,
"label.custom.field.login.query.information":`Please enter the system and view the details.`,
"label.validate.function.funcExplain.NOT":`Change FALSE to TRUE or change TRUE to FALSE`,
"pagecreator_layout_button_horizontal":`Lateral disassembly`,
"lable.Returned.to.successful":`Return Successfully`,
"label.campaign.channel.ticket.title":`Admission ticket`,
"label.ruleName.supportMaximum.50Characters":`A maximum of 50 characters is supported for the name of rules.`,
"label.email.track.attachment.size.control1":`Total attachment size exceeds 20m, can not be uploaded`,
"template.report.folder.opportunities":`Opportunities Analysis`,
"label.knowledge.setting.data.eight":`You are going to delete the {flzmc} category group and its categories. This category will not be available for assignment to records. You have 15 days to cancel the deletion of the category group. After 15 days, it will be permanently deleted and cannot be recovered. Are you sure you want to delete this category group and its categories?`,
"mail.id.notNull":`The ID cannot be empty when deleting the template`,
"vue_label_normal_product_sf":`Product`,
"vue_label_report_superiortothisrelationship":`Relation between the primary object and this object`,
"label.leadscore.operation":`Operator`,
"label.customfields.formula.percentexample":`Discount = (Amount - Discount_Amount__c) / Amount`,
"component.setup.iframe.label.inputurlmemo":`Please enter the url of the page to be imported`,
"label.icon.177":`Logo`,
"label.tabpage.myz":`My`,
"label.leadmarketsea.add.title":`Create Lead Pool`,
"label.partnerCloud.partnerAccount.thePage":`Page {skippageNum}`,
"label.visualpage.some.size":`Code capacity: maximum support for 300KB characters, approximately 300,000 bytes.`,
"label.setwxpay.null":`Required information for configuring WeChat payment are empty.`,
"label.icon.74":`Machine Tool`,
"font-evaluate-module-v1-evbad":`The type of evaluation is Negative`,
"System.TimeField.Format.Warning":`Unvalid Time`,
"label.captcha":`Random Verification Code`,
"label.payment.assessment":`Check Out Other Editions`,
"message.error.not.taskevent":`Non task event object`,
"font-evaluate-module-v1-evaluation":`Evaluation`,
"vue_label_commonobject_view_updatedago":`Updated {timeInterval} ago`,
"label.sendemail.birthday.newevent":`Dear {!ownerName}：\r\n {!objectLable} {!recordName}'s birthday will be in 3 days. Please be aware！\r\n {!orgName}`,
"label.laststep":`Previous Step`,
"message.duplication.label.matchoption":`Matching Option`,
"label.setupmultplerecordtype":`Multiple Record Types`,
"vue_label_account_unprocessed_oppprtunities":`Unprocessed opportunities`,
"KeyInformationLayout.DefaultLayout.Name":`System Default`,
"label.partner.all":`All parter cloud`,
"label.datamanage.export.error":`Export failed`,
"label.standard.buttonandlink":`Standard Button or Link`,
"label.reportsSubscriptionPage.email":`Email Report`,
"message.nogrammarfaultinformula":`No syntax errors.`,
"front-kefu-moudle-nofind-instance":`No instance found`,
"label.is.delete.data":`The records you want to delete contains the records are requesting approval, are you sure you want to delete?`,
"label.partner.error":`Error: The domain format is wrong`,
"label.notification.time2":`{0} minutes ago`,
"label.ccchat.person.invite.needfirstname":`Enter your name`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`No Records.`,
"label.readwrite":`Read/Write`,
"label.partnerCloud.orderingPlatform.orderPayment":`Order Payment`,
"label.accesslimittype":`Access Level`,
"label.preciew_tab":`Preview link in new tab`,
"label.attachment":`Attachment`,
"label_tabpage_helpNavigationz":`Help and navigation`,
"label.dataimport.select":`Check this information,perform the import data`,
"chatter.en.info":`Enter information so people can learn more about you.`,
"label.ccservice.validate.date":`The format of the corresponding value {2} of the field {1} under the object API {0} is incorrect.Please enter the correct date or time format!`,
"label.social.posts.send":`Failed to post`,
"label.emailobject.time.to":`To:`,
"label.defineReportStep1":`Step 1`,
"savefail":`Save failed`,
"label.mr.descreption.title":`Merge duplicate data`,
"label.share.info.by":`By`,
"label.list":`List`,
"label.event.select":`Selected`,
"message.accountmap.cannotfind":`The address of the account could not be found, please update the account address.`,
"label.choosefield":`Approval Page Fields`,
"label.forecast.settings.title":`Forecasts Settings`,
"label.setup.log.datetime":`Download behavior logs within searched time range (.xls files)`,
"button_partner_new":`New partner cloud`,
"label.umeng.approval.dlsp.reject":`#approvalname rejected the #actorname''s approval request of #objAPIName #recordname for you.`,
"label.tabpage.totalTeamz":`A total of groups`,
"label.lead.score.prompt3":`This can take several minutes. You will receive a confirmation email once completed.`,
"label.schedulejob.setup.schedule.name":`Job Name`,
"vue_label_report_advanced":`When the advanced filter is enabled, manually write the filter condition into the advanced filter box below, the format is shown in the figure.`,
"label.emailsync.form.connecttime":`Related Time`,
"front-gantt-module-v1-project-status":`Project Status`,
"label.field.for.example":`For Example`,
"label.marketsea.manager.notnull":`Administrator can't be empty.`,
"label.click.here":`&lt&lt Click here to back`,
"UG.solution.04":`Import solution`,
"label.validate.function.funcExplain.IF":`Whether the condition is true or not, and if the condition is TRUE returns one value and the condition is FALSE, another value is returned.`,
"label.profile.settab":`Menu Setup`,
"front-email-payment-weichat-tips":`Scan QR Code to Pay`,
"label.task.next.week":`Next Week`,
"label.operatedata.selectobjectfields.tip":`Select the fields yo want to export, and you must select at least on field to export.<font color="red">Attention:Text Area(Rich) can not be export.</font>`,
"label.recalculate.alert":`Please select the sharing rule you want to recalculate.`,
"label.marketsea.noopportunitydays":`days without new opportunities (need to be greater than the number of days without follow-up after obtaining)`,
"label.chat.likeperson":` Person(s)`,
"label.selectedFields":`Available Fields`,
"label.App":`Applications`,
"label.file.type":`File Type`,
"permissionService.error1":`Insufficient application license.`,
"front-detail-module-v1-chart-display":`Chart Display`,
"label.audit.status":`Approval Status`,
"UG.activity.05":`Recording phone`,
"label.connectOtherObject":`( Click to relate another object )`,
"lable.currencyManage.unEnabledadvcurrency":`Disable Advanced Currency Management`,
"label.ccpeak.getthree.function":`There are three functions, and`,
"label.weixin.new.weitoupiao":`Please create a new micro vote, users can participate in voting and access to voting results in micro events on the WeChat.`,
"label.tag.manage.prompt":`Tag already exsits！`,
"label.goon":`Continue`,
"label.addworkflowoperate":`Add Workflow Action`,
"label.weixin.click.search":`Click to search record`,
"vue_label_report_deletecolumn":`Delete column`,
"label.ordercondition":`Sort By`,
"message.error.group.notallow":`Group does not allow archiving`,
"label.unread":`Unread Emails`,
"vue_label_report_notice_namerequired":`Column name is required`,
"label.tabpage.entercontent":`Please enter content`,
"label.schedulejob.setup.schedule.startdate":`Start Date`,
"component_assistant_button_newtask":`New task`,
"vue_label_report_notice_filter1":`You have to manually fill out the advanced filter(s) below as shown in the picture when you enable the advanced filter`,
"value":`Values`,
"label.icon.70":`Service`,
"label.knowledgebase.delete.draft.t":`Delete Draft`,
"label.setup.mini.bind":`Bind Mini-programs`,
"component_timeline_button_more":`More steps`,
"label_emailtocloudcc_redmessage4":`Please input port details`,
"label.field.input.number":`Please enter the valid numbers`,
"front-invoice-online-payment-setup-title":`Start Online Payment`,
"front-kefu-moudle-called-user":`Called Person`,
"label.currency.disable":`Inactive Currencies`,
"label.user.alias":`Alias`,
"UG_quota_04":`Print quotation`,
"label.chatter.delete":`Delete`,
"label.addtocurrentcustomer":`Attached To Existing Accounts`,
"message.error.recordid.null":`recordid cannot be empty!`,
"label.merge.records":`Merge records`,
"report_label_norole":`You have no permission to do this, please contact your administrator.`,
"label.pqrs":`.`,
"label.email.attach.button":`Click the "attach" button`,
"label.tabpage.selrecordtypez":`Select Record Type`,
"label.ServiceCloud.purchase.date":`Purchase Date`,
"label.customreporttype.delete.prompt":`Please delete the following report before excuting the delete operation`,
"label.brief.total.page":`A total of {total} page(s)`,
"label.reportsSubscription.unsubscribe":`Unsubscribe`,
"label.ccpeak.take.notice.exp.order":`Notes: must add "__c" after the API name of the fields in the exp and ordering conditions.`,
"report_type_label_quote":`Quotes`,
"label.file.norecord":`No items to display`,
"vue_label_checkduplicate_all_processed":`All data has been processed`,
"label.next":`Next`,
"label.icon.10":`Folder`,
"label.lanxin.title.setting":`Integrated Information`,
"label.h5.chatter.business":`Associated opportunities`,
"lable.are.you.sure.to.delete.this.view":`Do you want to delete this view?`,
"vue_group_no_operation_permission":`No permission to operate!`,
"label.knowledge.archive.article":`Archive Article`,
"vue_label_lead_":`No active scoring rules available, please contact the system administrator`,
"label.fiscal.error.between":`The Fiscal Year Start Date or Fiscal Year End Date is in between of history fiscal years, please check and reset`,
"label.stdashbord.xsld.business.qdzje":`Total Amount(Closed-Won Opportunities)`,
"label.calendar.day.view":`Day View`,
"label.emailtocloudcc.tip":`Prompt`,
"label.schedulejob.setup.schedule.st1":`The 1st`,
"label_tabpage_addtoworkbench":`Add to homepage workbench`,
"label.umeng.approval.waitapproval":`wait approval`,
"label.justcheckingwebsite":`Verify Website Only`,
"homepage.components":`Homepage Components`,
"label.audit.remark":`Approval Notes`,
"label.searchs.labelname":`Search {fieldlabelName}`,
"label.remarkofreport":`Report Note`,
"label.weixin.isno":`whether`,
"label.currencyCode":`Currency Code`,
"label.service.resources":`Resources`,
"label.clone_form":`Clone Form`,
"label.weixin.view.information":`View Details`,
"UG_activity_05":`Recording phone`,
"chatter.feed.menutype.user.recentuser":`People who recently viewed`,
"label.marketsea.notfollowdays2":`Days no follow-ups`,
"label.tabpage.namemandatory":`The view name is required`,
"message.demo.nosupport":`This feature will be rolled out in the next release.`,
"label.mail.merge.template":`Merging the email templates......`,
"label.sendemail.marketactivity.sign":`Campaign sign notification`,
"setup_layout_group_relatedlist":`Related Lists`,
"label.pc.ui.2018.all.tabs":`All Menu`,
"label.field.lost.right.bracket":`Close bracket is lost`,
"label.datamanage.contact.novalue":`Note: The contact name field is null,the contact records will not be imported.`,
"label.version.unlimited.edition":`Unlimited Edition`,
"vue_label_dashboard_selectsortfield":`Please select sorting field`,
"label.partnerCloud.productSet.instructions":`You can set hierarchy for product family. Filter the hierarchy to view while adding products according to functions. A maximum of 10 levels can be set up.`,
"front-kefu-moudle-v1-canuse-obj":`Visible To`,
"thursday":`Thursday`,
"label.nextapprover":`Next Approver`,
"setup_mainpage_label_manageuser":`Users Management`,
"label.saveandcontinue":`Save`,
"label.top.userCenter":`Personal Center`,
"component.chatter.file.button.save":`Publish`,
"label_emailsync_setting":`Personal Email Settings`,
"label.usableshareuser":`Available Sharer`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Display values alphabetically, not in the order entered`,
"label.list.button":`Profile Assignment`,
"chatter.up.m":`Error: The uploaded file is too large. Maximum file size is 20 MB.`,
"label.knowledgebase.filters":`{a} filters`,
"label.sso.saml.sp.idtype.username":`Assertion contains the User‘s CloudCC username`,
"vue_label_file_size_limit":`The file size should not exceed {size}Mb`,
"label.appupload.install.error.choice4":`Skip conflicting components, do not install conflicting components`,
"label.currencyDecimalDigits":`Decimal Places`,
"label.weixin.customer.details":`Account Details`,
"component.timeline.label.7daysahead":`7 days before`,
"label.sendsms.batch.step1":`Step 1 Specify the recipients to include`,
"label.brief.opportunity1":`Opportunities`,
"label.datamanage.click.importbutton":`Click <b>Import</b> and the data will be imported into CloudCC system.`,
"label_filter_benchmark_objects":`Filter reference object`,
"label.area.record.notexist":`The record does not exist.`,
"label.event.overdue.unfinished":`Overdue Events`,
"label.file.publicview.errortype":`The file type dos not support preview`,
"label.setup.mobile.bottombutton.profile.setting":`Customize bottom menu of profile`,
"label.campaignmember.main.addleaddesc":`Add all existing leads to this campaign`,
"vue_label_approve_actual_operator":`Actual operator`,
"label.version.essential":`Essential edition`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`Past activities`,
"vue_label_calendar_choose_calendar_type":`Choose Calendar Type`,
"label.service.dispatchingUnits.batch.send":`Batch Dispatch`,
"chatter.poll.option8":`Choice 8`,
"label_tabpage_summaryway":`Summary method`,
"front-kefu-moudle-trindex-copy-num":`Please copy the enterprise No. in the homepage of Tianrun system`,
"lable.quote.syncing.syncfinish":`Sync Completed`,
"label.home.task.finish":`Completed task`,
"label.toleadfield":`Map Lead Fields`,
"label.everyone":`Everyone`,
"label.multilang.databatchadd.success":`{0} data have been added successfully：`,
"label.quote.createdate":`Date Created`,
"email.template.nopermission":`Only administrators can edit templates in this folder`,
"label.report.action.addtodashboard2":`Add Dashboard`,
"label.campaign.name":`Campaign Name`,
"label.check.input.condition":`Syntax error, please check the filtering criteria you entered`,
"front-epwechat-module-v1-upload-file":`Upload Credit Document:`,
"label.batchadd.newbatchpage.button.add":`Add a Line`,
"label.partnerCloud.footer":`Footer`,
"lable.Enter.template.name":`Please enter the tamplate name.`,
"label_tabpage_last":`Previous Step`,
"label.setup.mobile.bottombutton.setting":`First-level Page Setup`,
"label_emailtocloudcc_filed_emailto":`Email to`,
"label.data.downpage.e_title.num3":`3. Users can create export templates according to their needs and select the item "Export By Template", which can make export operation more convenient.`,
"startwith":`Starts with`,
"vue_label_normal_cancel":`Cancel`,
"label.reportTypcrtD":`Associated object (d) please click to select related object`,
"label.globalselect.disabledvalue":`Invalid value`,
"vue_label_commonobjects_view_notice_deletecertification":`Are you sure you want to delete the { selectNum } record(s) selected?`,
"front-epwechat-module-v1-bound-role":`Bound Roles`,
"label.partnerCloud.financeSetting.gaofilter":`Advances Filter Conditions (e.g. 1 And 2 Or 3 )`,
"label.quote.sprname":`Billing name`,
"lable.asset.successfully":`Transfer product to asset successfully.`,
"label.projectManagement.service.appointment.work.noedit":`Unable to edit labor-hour of service appontment`,
"lable.tianyancha.h5.inputandsearch":`Enter keywords to search relevant companies`,
"label.customcomponent.check.tag.firstrow":`The first line must be`,
"label.knowledgebase.published.translations":`Published translations will also be archived and the translation in Draft status will be deleted.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Step 3 of 3`,
"label.stdashbord.xsld.business.img6":`Total quantity of opportunitie stages with probability 100%/(Total quantity of opportunitie stages with probability 100% Total quantity of opportunitie stages with probability 0%)`,
"component_button_cancel":`Cancel`,
"label.delete.false.not.exists":`Delete failed, because the data does not exist.`,
"label.appupload.install.error.choice1":`Please do not install`,
"label.Days.After.Horizontal.Date":`Level date after`,
"setup_layout_button_additem":`Add the selected items`,
"UG.contact.05":`Create a contact`,
"label.form.title":`Form Title`,
"label.horizontalbar-group":`Horizontal Lines-Row Grouping`,
"component_sendmail_label_title":`Send email`,
"label.passwordPolicy.setup.neverexpires":`Never expires`,
"label.sso.saml.idp.config.desc1":`Enable CloudCC.com as an identity provider so you can use single sign-on with other web sites`,
"label.chat.topic.desc.null":`Learn some information on this topic? In the upper right corner drop-down menu, select edit details.`,
"label.movablecustomerfield":`Acitivity Custom Fields`,
"label.trigger.folder":`Unfiled Trigger Folders`,
"label.selectuploadfile":`Please select a file to upload.`,
"front-email-payment-card-tips":`Please enter the card number`,
"label.tabpage.addcondition":`Add Criteria`,
"label.number.MinAndMaxCheck":`The minimum of {0} is {1}, maximum is {2}. Please modify the quantity and save changes.`,
"vue_label_dashboard_dashboard":`Successfully renamed the dashboard`,
"label.objectDeleteList":`Delete list of objects`,
"lable.service.gantt.and":`AND`,
"label.emailtocloudcc.step2":`Step 2`,
"label.chatter.postup":`Post Up`,
"label.personalsetting":`Personal Settings`,
"message.please.choose.permission":`Please select access`,
"label.mobile.move":`Mobile App`,
"label.Choose":`Choices`,
"label_chatter_vote":`Poll`,
"label.weixin.user.select.one":`Select a user`,
"pagecreator.page.label.modifypage":`Page editor`,
"label.select.partOrField":`Choose sections or fields to be controlled`,
"vue_label_helpcenter_chat":`1. Instant messaging<br>    Team can replace corporate WeChat, etc., allowing you to send text messages, files, etc. to your company colleagues while working in the CRM system. When each department of the organization needs to establish a departmental discussion group, the department leader can initiate a group chat in the Team and add department members to the group chat.<br>2. Create group chats for account and opportunity records<br>    Open the customer or business opportunity record details page and click the "Team" button in the upper right corner to create a group chat about this record in the Team. If the group chat is not created by the record owner, the record owner will also be automatically pull into the group chat. Others can enter the group chat by clicking the "Team" button in the upper right corner of the record details page or after being added by the group owner.<br>3. Track records in group chat<br>    Create a group chat for customers and business opportunity records according to the method in 4.2, and you can track the dynamics of the records in the group chat by sending cards. If the user has the access to view the records on the card, when the user clicks on the card, he can directly jump to the detailed information page of the corresponding object.<br>    Track record field changes in group chat<br>    When the record is configured with the "Field Tracking" related list and the fields that need to be tracked are configured, when the tracked field changes, the group strategy assistant in the group chat will send a card with the field change information to the group .<br>    Keep track of all changes in group chats<br>    When the record owner changes, the group strategy assistant in the group chat will send a card with the owner's change information to the group.<br>    Track activities in group chats<br>    After the record group chat is created, if a new task or event about this record is created, the group strategy assistant in the group chat will send a card with basic information about the task or event to the group.<br>    Track and record the new record of the related list in the group chat<br>    After the record group chat is created, when the record related list record is added, the Team assistant in the group chat will send a card with the basic information of the newly added record to the group. For example: when a new contact is added to the contact list of customer records, a "New Contact" card will be received in the customer group chat, and the basic information of the new record can be seen on the card.`,
"label.tianyancha.business":`Business registration information`,
"chatter.group.groupMembersToFind":`Group Member Lookup`,
"label.pc.ui.2018.pin.top":`Pin to Top`,
"label.forecast.forehistory.submitor":`Submitted By`,
"vue_label_email_send_emails_separately":`Successfully send emails`,
"vue_label_homepage_select_display_field":`Select Field`,
"label.partnerCloud.partnerAccount.accountBalance":`Balance`,
"label.sendemail.template":`Select Email Template`,
"label.service.violated":`Violated`,
"label.manageAll.title":`Approval Center`,
"label.forecast.settings.qy":`Enable Forecast Sharing`,
"label.detailofshare":`Sharing Rule Details`,
"label.multilang.passwordpolicy.chechlength":`Error: The password must not be less than {0} characters long:`,
"label.visualpage.filesave.error":`File saved failed, please try again.`,
"vue_label_campaign_please_select_member_status":`Please select member status`,
"homepage.components.sort":`Order the components`,
"label.brief.thismonth":`This Month`,
"label_emailsync_connectaccount_description":`Add your personal mailbox here, and the CloudCC will automatically match leads and contacts in the system according to their email addresses, sync the contents of the email to the records to facilitate tracking and communication.`,
"label.sms.csid":`Signature Number`,
"label.ccdocument.remark":`Document description`,
"label.forecast.customforecast.disdw":`Display Unit`,
"label_tabpage_field":`Field`,
"label.logintime.all":`All Day`,
"UG_Account_06":`Create an account`,
"label.login":`Login`,
"label.dupicate.data.error":`Find duplicate records and merge error, please check.`,
"label.monitorsys.recent.logs":`The latest 200 logs are displayed by default.`,
"message.chooseatleastonefield":`Choose one field at least`,
"lable.PowerProcess.name1":`Entitlement Process Name`,
"label.processdetail":`Process Definition Details`,
"label.upload.file.size.limit":`The files loaded must not exceed 2MB!`,
"label.forecast.userenablepage.desc":`Users enabled for Forecasts appear in the Enabled Users list. To enable available users, add them to the Enabled Users list. To disable users, remove them.`,
"label.visualpage.type.detailembed":`Usage instruction of custom page (page style is "detailEmbed")`,
"label.textmessage.vonage.configurations":`Configure`,
"label.report.select.chart.and.item":`Select the chart and the highlight item`,
"label.data.downpage.i.title.num1":`1、The system only supports the common CSV format.`,
"label.mobileapp.scansetting":`Mobile App Scan Fuction Setup`,
"chatter.emailFollow":`Follows`,
"label.weixin.businformation":`Vehicle Details`,
"label.import.index.recentrecord":`Recent import record`,
"label.case.update":`Update`,
"label.isEnableVisualpage.new.desc":`Select an available custom page from Availble Custom pages and add it to the Selected Custom Pages, click Save. Then the users with this profile has access to the active custom pages.`,
"label.emailobject.wizard.title":`Connect Your Email`,
"vue_label_ccchat_notice_deletepostsuccess":`Successfully deleted post`,
"label.deleteQuoteLine":`Delete Quote Line`,
"label.integrations.export.failed.Mailchimp":`The export failed, please check your network connection and try again later`,
"label.increase":` Plus`,
"label.setup.mobile.homepageshortcuts.setunable":`The module does not show on homepage`,
"label.ccchat.person.invite.toolong":`You cannot enter text that exceeds 255 characters`,
"label.knowledge.setting.help":`Customer Self-service Help`,
"label.is_pigeonhole":`Archive`,
"message.atleastonecommitter":`At least one submitted by whom`,
"label.emailobject.wizard.desc4":`Insert a propose time to make it easier for multi people appointment`,
"APPIntegration_Dropbox_setting_02":`Deactivate`,
"template.report.open.opportunities":`Unclosed Opportunities`,
"label.goonwork":`Continue to Work`,
"label.isiands.time":`Isiands Time`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Enabled Rules (each object only supports one QR Code or Bar Code)`,
"label.summaryreport.2018.step2":`Step 2 Summarize information by:`,
"pagecreator.systemstyle.message.delete.success":`Style deleted successfully`,
"label.standarduser":`Standard Users`,
"label.reportsSubscription.succeeded":`Subscribe report successfully!`,
"lable.Select.a.template":`Select an existing service template as the base of the new template.`,
"label.file.library.addfile2libsuccess":`{0} file(s) uploaded!`,
"label.searchfield.instruction":`Search field is a field that is used to global search or search a single object.If no selected by default, search by selected search results field is selected search result fields.`,
"U":`URL`,
"label.Time.slot.overlap":`One or multiple time slots have overlapping time ranges. Please update to a time slot that does not overlap.`,
"vue_label_chat_opportunity_details":`Opportunity details`,
"label.knowledge.category.hint.seven":`Selected Category Group`,
"label.chatter.list":`List`,
"front-email-payment-Invoice-preview":`Invoice Preview`,
"label_emailsync_message1":`If you cancel the connection, you will not be able to sync the contents of the mailbox to the leads and contacts, are you sure you want to cancel?`,
"label.summaryreport.step5":`Step5 Specify the order of columns in report`,
"component_newrecords_label_name":`Name`,
"label.appointment.wizard.subtitle4-4-5":`2 months`,
"component_salesperformance_label_title":`Sales performance`,
"label.ccchat.person.invite.says":`Say:`,
"label.fax":`Fax`,
"label.knowledge.modify.article":`Modify Article`,
"label.componenteditor.Limit.number.components":`Up to 15 components can be added in a single page.`,
"label.multilang.forecast.shrepage.desc":`This page will list the users, roles, and regions that have shared access to {0}.`,
"label.chat.micropost.write.comment":`Write comments`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Active`,
"label.ccpeakfolder.time":`Scheduled Class Folders`,
"label.partnerCloud.financeSetting.filter":`Filter Conditions:`,
"label.knowledge.delete.topicassignment":`Error while deleting the subject assignment`,
"label.file.orderbyname":`Sort by title`,
"vue_label_chat_activelater":`Active later`,
"chatter.reply":`comment`,
"label.setup.profile.accordtext":`According to the text`,
"label.encd.plaintext":`Show Clear Text`,
"label.h5.approval.cannotreassignmark":`Delegated approval projects cannot reassign,please reselect approval projects`,
"label.version.area.lookup":`{0} text area or lookup relation (multi-select) fields`,
"approval.request.email.body":`The following items are requesting approval：\n click the link below to approve：\n`,
"label.user.mass.emails.select":`Batch Email: Select the Template`,
"lable.quote.syncing.title":`Sync Quotes and Opportunities`,
"vue_label_dashboard_dashboardaccess":`Dashboard Access`,
"label_emailtocloudcc_filed_owner":`Owner`,
"label.brief.page":`Page`,
"label.isEnableVisualpage_new.desc":`Select an available custom page from Availble Custom pages and add it to the Selected Custom Pages, click Save. Then the users with this profile has access to the active custom pages.`,
"label.service.shift.view":`Work Shifts View`,
"label.emailsync.addnewaccount":`Add new account`,
"label.forecast.settings.prompt":`Disable forecast sharing will remove all manually shared access.`,
"front-electronic-signature-explain-second":`When binding the electronic signature, please prepare the Enterprise Business License photo and the unified social credit code.`,
"label.emailtocloudcc.redmessage3":`Please input server address`,
"message.confirmgiveupedit":`If you leave this page, you will lose all unsaved changes. Do you want to continue?`,
"label.gantt.plan.success":`Successfully scheduled`,
"label.monitorsys.type.error":`Please select the search type.`,
"label.industrialandcommercialverification.button.setup":`Set up`,
"today":`Today`,
"label.attendance.setting.position":`Set Landmarks`,
"chatter.mynews":`My Messages`,
"label.recycle.dis.tip1":`The system will keep tha data in the recycle bin for 15 days, and the records will be permanently deleted 15 days after the records are entered into the recycle bin.`,
"label.icon.81":`Refrigeration`,
"label.customer.tab.page.prompt":`Please configure one page at least!`,
"label.globalselect.use":`Use global option list value set`,
"template.report.customer.sales.order":`Sales Order of Accounts with Different Levels`,
"vue_label_dashboard_lastruntime":`Last Running Time`,
"label.edit.ccpeakfolder":`Classes：Folder Edit`,
"vue_label_lead_be_converted":`Has been converted and cannot be converted`,
"label.tabpage.filenamez":`File name`,
"label.please.click.add.products.":`Please click "Add Product" to add product to the price book.`,
"label.followup_emails":`Once a visitor has submitted a form, following up with an email is a你easy way to quickly connect with them`,
"label.indochina.time":`Indochina Time`,
"message.error.task.email":`Mail task anomaly`,
"label.dynamic.copy":`Synchronously clone layout rules`,
"label.log.d":`Download audit log within search time range(Excel.csv file)>>`,
"pagecreator_layout_label_layoutname":`Layout name`,
"template.chart.htsktj":`Contract Collection Statistics`,
"label.appointment.wizard.subtitle4-2-5":`1 Day`,
"label.view_form":`View Form`,
"label.tablet":`Tablet`,
"label.campaignmember.main.addcontact":`Add Members- Existing Contacts`,
"message.get.userinfo.error":`Failed to get user information`,
"label.department.username":`User Name`,
"label.ems.verifysuccess":`Email account successfully verified!`,
"label.batchedit.copyValue":`Apply to this column`,
"label.trigger.triggerVersion":`Version`,
"label.mr.descreption.oneGroupReData5":`groups of data not processed.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Description`,
"label.weixin.inbetween":`Multi-Select`,
"label.salescloud.contactrole.relatelist.customnize":`You cannot customize this list`,
"label.data.exp.please.nameanddes":`Please enter the template name and description.`,
"label_partner_workspace_login":`Login Page`,
"label.notification.approval7":`【被委派人名称】rejected the 【提交人】's approval request of 【对象】【对象名称】for you.`,
"message.send.posts.image.error":`Post picture upload failed!`,
"message.fieldtrack.operateupdate":`Changed`,
"label.sharerule.grantuselevelconstructureaccess":`Grant Access with Hierarchies`,
"label.translation.setup":`Multilanguage Setup`,
"PageLayout.Search.MultiSearch.003":`Select one field at least.`,
"label.ccchat.person.emaildomain":`Company email domain`,
"pagecreator.systemstyle.label.bordercolor":`Border color`,
"label.submit":`Submit`,
"UG.Lead.001":`How to introduce clues?`,
"label.icon.172":`Map`,
"label_chatter_owner":`Owner`,
"vue_label_systemSettings_Currency":`Currency Management`,
"page.layout.binfo":`Essential Information`,
"label.version.date":`{0} date fields`,
"label.data.is.woking":`Operating`,
"label.customfields.searchrelation.dependobjectDefault.tip":`You can select a record in the related item as the default value for this field`,
"label.partnerCloud.orderingPlatform.configuration":`Confugure Products`,
"lable.currencyManage.Enabledadvcurrency":`Enable Advanced Currency Management`,
"label.event.moveup.3hour":`3 hours ahead`,
"label.reportexport.object":`Export Objects`,
"front-dialog-module-v1-requestid":`Request ID`,
"label.pw.symol":`Symbols`,
"label_group_field":`Specify grouping field`,
"label.recallapprove":`Recall Approval Request`,
"vue_label_pool_deal_done":`Closed deal`,
"label.shangqing.description":`This is a description of the business situation`,
"label.view.allcansee":`Visible to <b>all users</b>`,
"chatter.poll.addOption":`Add More`,
"label.icon.112":`Food`,
"label.ignorecase":`Consider "ABC" and "abc" as duplicate values (case insensitive)`,
"label.email.track.edit":`Edit Email`,
"label_tabpage_erraddressz":`Incorrect format of email address, please enter email address correctly`,
"label_tabpage_viewz":`Print current view`,
"component.timeline.label.future":`Next Step`,
"label.b_c_without":`"B" records may or may not have related "C" records.`,
"label.version.autonumberfield":`Auto-No. Field`,
"label.appointmentdetail.wizard.title5":`Invitation URL`,
"label.weixin.addoption":`Add Option`,
"label.b.c":`B to C Relation`,
"chatter.group.complete":`Complete`,
"label.must.numeric.value":`The cost must be numeric.`,
"lable.edit.queue.memberdes":`To add members to this queue,select a type of member, then choose the role or user from the "Available Members" and move them to the "Selected Members". If the sharing model for all objects in the Queue is Public Read/Write/Transfer,you do not need to assign users to the queue,as all users already have access to the records for those objects.`,
"label.staticresource.chose.limit":`Files in this format are not supported temporarily. Please look forward to improving this function.`,
"vue_label_commonobjects_view_kanban_unset":`Please select the grouping basis in the Kanban view settings`,
"label.appexchange.download.merge.mes":`The following conflicting components are installed through a merge:`,
"label.sharerule.baseofowner":`Based on record owner`,
"label.email.template.manage.SMS":`Manage SMS Template`,
"label.imgfield.example.tip":`The green icon means approved and the red icon means rejected.`,
"template.report.potential.customer.industry":`Leads Industry`,
"component_hots_label_title":`Hot deals`,
"label_file_use_document":`Storage space usage`,
"label.input.path":`Enter the path of the file`,
"label.partnerCloud.financialSetup":`Partner Financial Setup`,
"label_tabpage_myz":`My`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`After deleting, you will be not able use Email to CloudCC, are you sure you want to delete?`,
"label.customfields.fielddependency.sure":`The controlling field does not include the value of the dependent field. Do you want to continue?`,
"label.project.task.date":`The task date must be within the date range of the milestone to which it belongs.`,
"Report.CantDelete.Info":`{0} report is the data source for the {1} dashboard and cannot be deleted!`,
"label.assignment.setup.title":`Assignment Rules`,
"image.pt.most.maxsize":`Maximum file size is 2 MB.`,
"label.appupload.introduce":`A package contains components such as apps, objects, tabs, triggers, or pages.These packages can be posted on CloudCC App Store to share publicly.The list below displays all packages created by your organization. To create a new package, click New.`,
"label.import.page2.confirm":`Confirm`,
"label.console.step2.introduce":`Fill in the fields below to define the console.`,
"label.extendsfather":`Controlled by Parent`,
"front-homepageobject-module-v1-year":`This Year`,
"front-grasp-sales-opportunities":`CRM helps you accurately master sales opportunities, acquire more leads, provide quick quotes and close more deals, while achieving omnichannel marketing and continuously improving corporate ROI.`,
"label.tab.oldpage":`Old Version Page`,
"label.service.miniProgram.intro":`Introduction`,
"label.data.import.setup.operate.insert":`Do not update the existing records, just insert new records.`,
"label.ccpeak.direction.for.use":`Description of the Use of CloudCC Platform [Version 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat micropost reply`,
"label.campaignmember.main.importmember.contacts":`Import Members-Contacts`,
"setup.mainpage.label.welcome20":`Mail, SMS template`,
"label.newbatcheditor.remark":`For different records, there are different record types. By default, the row layout if the record type of the first record is used as the pafe layout for mass editing.`,
"label.step4.total7":`Step 4 of 7`,
"label.campagin.roi.tzhbl":`Return on Investment`,
"label.emailmerge.mergepage.step3":`Log an Activity`,
"label.marketsea.isrecyclecreatebyself":`Do you want to recycle self-built account`,
"message.mobilechooseatmost.five":`A maximum of 5 fields can be selected in the menu on mobile devices.`,
"label.icon.171":`Guest House`,
"label.saveandnext":`Save & Next`,
"label.import.page1.selectcodingtype":`Choose Encoding Type`,
"label.searchlayout.displaybutton":`Buttons Displayed`,
"label.approvalstep5":`Step 5 select the editing properties of the fields to display on the approval page layout`,
"label.passwordPolicy.setup.enforcePswHis":`Enforce password history`,
"vue_label_commonobjects_detail_contact_hierarchy":`Contact hierarchy`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Intelligent Service Call Center`,
"label.select.statistical.indicators":`Please choose statistical index`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Libraries`,
"lable.completion.rate.color.setting":`Color setting of completion rate`,
"label.name.firstname":`First Name`,
"setup_layout_label_readonly":`Read-Only`,
"label.chatter.recordcall":`logged a call`,
"label.service.appointmentList.service.empty":`The service appointment list is empty.`,
"component_milestones_label_choicestate":`Confirm this status`,
"label.approved.receiveApprovalEmail.option2":`Only if I am an approver`,
"label.marketseamemset.account.title":`Members Setup of Account Pool`,
"label.changemydisplay.list.custom":`Customize My Tabs`,
"label.emailtemplate.selecttype":`Choose the type of email template you would like to create.`,
"component_timeline_label_title":`Timeline`,
"chatter.group.addRemoveMembers":`Add/Remove Members`,
"label.console.step6.width":`Width`,
"pagecreator.systemstyle.message.delete.fail":`Style deletion failed`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}products，{totalCount} pieces, original price：{currency} {originalPrice}，discount：{currency} {Reduction}`,
"label.h5.share":`Share`,
"label.schedulejob.setup.list.tip":`Setup cheduled jobs to be performed automatically at weekly or monthly intervals.`,
"message.intheapproving":`The record is requesting approval and unable to resubmit.`,
"vue_label_commonobjects_detail_real_time":`After joining, the Team will be displayed in your team list, and the team dynamics will be posted to you in real time.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Too short`,
"label.salescloud.forbiddenteamsales":`Deactivate Group Sales`,
"component.chatter.link.label.title":`Link`,
"label.layout.editsearchdistribute.page":`Select the custom pages should include in tab home page`,
"label.dashboard.show.value.percent":`Show values or show %, please choose at least one`,
"label.everymonth":`Per Month`,
"label.campaign.channel.download.size1":`Large Size: 1000*1000 pixels`,
"permissionService.error2":`Failed to add application license permissions.`,
"button.partner.workspace.manage.memo":`Manage your partner cloud and configure partner cloud properties.`,
"label.forecast.forehistory.commit.remark":`Notes of Submission`,
"six":`Six`,
"label.datamanage.donot.export.object":`Objects that are not allowed to export data.`,
"label.schedulejob.setup.schedule.execute":`Execute`,
"lable.account.CurrentandPreviousCY":`Current and Previous CY`,
"label.temp.SMS":`SMS Templates`,
"label_partner_all_state":`Status`,
"label.editdocument":`Edit Properties`,
"front-epwechat-module-v1-ios-single":`iOS Single Sign On`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`All templates`,
"label.allfolderreport":`All Report Folders`,
"label.layout.alltab":`All Menu`,
"lable.account.Yesterday":`Yesterday`,
"label.formula.to.evaluate":`Formula Evaluation`,
"component_setup_label_setupsaveok":`Component settings saved successfully`,
"pagecreator_page_message_canntdelete":`The current page is not allowed to delete`,
"label.tab.message.failtotp":`Failed to top the Tab`,
"label.h5.chatter.location":`Insert the location`,
"vue_label_commonobjects_view_chart_gotodashboard":`Go to Dashboard`,
"label.data.exp.conf":`Are you sure you want to export data?`,
"label.currency.e":`Currency Type Edit`,
"message.matrixReportSetupStage.column":`Please select 【Specify Column Headers】 subtotal basis, and you must select one subtotal basis at least in two subtotal bases.`,
"font-evaluate-module-v1-have-comment":`Left an evaluation`,
"chatter.feed.dao":`To`,
"label.import.index.notice":`Note:`,
"label.weixin.information":`Details`,
"label.multilingual.tip5":`The multilanguage status is incorrect. Please refresh and try again!`,
"label.appointment.wizard.subtitle3-7":`Sunday`,
"label.emailobject.groupemail.fail.content":`Dear{0},\r\nThe following is the email address that failed to be sent.{1}\r\n CloudCC`,
"vue_label_notice_uploadavatar_fail":`Failed to upload avatar`,
"chatter.group.myGroup":`My Groups`,
"label.ccpeak.object.fieldapi.name":`is the field API name of the object`,
"lable.activeCurrency":`Active Currencies`,
"label.file.save.to.send":`Save & Send`,
"label.emailmerge.list.editfolder":`Folder Edit`,
"label.Path.Setting":`Path Setup`,
"label.validate.function.funcFormat.DATE":`DATE(year,month,day)`,
"message.objapiexists":`This object API already exists.`,
"label.sendmail.batch.confirm":`Batch Email: Confirm`,
"message.approval.cannotsubmit.detail":`This record does not meet the conditions or initial submission for any valid approval process. Please contact your administrator for assistance.`,
"setup.layout.button.deleteitem":`Remove the selected items`,
"label.end.loginipIP":`End IP Address`,
"component_event_label_subject":`Theme`,
"message.500":`Server internal error occurred`,
"label.wei.polltype":`Types`,
"vue_label_norm_duplicate":`Duplicate`,
"label.addcycletrigger":`Add Periodic Trigger`,
"DetailedInfo.Activity.EmailMessage.01":`{0} send an email to {1}.`,
"No.Activity":`No Activity`,
"label.chat.topic.add.topic":`Click to add a topic`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Your changes have been saved.`,
"label.setsharerule.step3":`Step 3 Select the users to share with`,
"label.tabpage.Sdfez":`Days ago`,
"label_submit_forecast":`Submit Forecast`,
"label.version.sum.formulafield":`formula fields`,
"lable.weixin.you.invitation":`Your invited`,
"label.stacked.horizontalbar":`Stacked-Horizontal Lines`,
"label.file.anyone.can.link":`Anyone with the link can view and download the file.`,
"label.campaignmember.main.importmember.lead.desc":`Import leads from files.`,
"UG_activity_01":`How do you track your records to interact with your accounts/teams?`,
"label.reason":`Reason`,
"label.version.free.createmax":`Allows 2000 records to be created, the upper limit has been reached.`,
"label.brief.thisweek":`This Week`,
"label.deleteobjinapprove":`Please enter the comment before you can delete this object from the approval process.`,
"calendar.tips.event":`day(s) without events`,
"label.customerinfo.mailinfo":`Organization-Wide Email Address`,
"lable.electronic.signature":`Esignature`,
"label_emailsync_addnewaccount":`Add new account`,
"label.layout.exampleoftesgobj":`Test Object Example`,
"label.happen_submit":`What should happen after a visitor submits this form`,
"label.forecast.customforecast.button.submit":`Submit`,
"label_right_click_notice":`Attention: Email of <Email to CloudCC> must not be the same email as the one bounded by system user to prevent invalid leads or cases.`,
"font-trade-module-v1-invoice-no-price":`To Be Repaid`,
"lable.opppdt.selPdt.morecondtions":`More filters`,
"label_invalid_token":`Invalid token`,
"label_chatter_postup":`Post Up`,
"label.escalation.setup.newaction.step1":`Step 1 Specify the time criteria for this rule`,
"label.sendmail.step3.dealoption2":`Store an activity for each message`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Are you sure you want to batch delete templates?`,
"vue_label_appstore_enter_website":`Enter the official website`,
"label.when":`Publish Time`,
"label.linellae":`Lines`,
"label_chatter_detailinfo":`Detailed information`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Receipts Task Completion Rate`,
"vue_label_homepage_dashboard_deleted":`The dashboard has been removed`,
"pagecreator.layout.button.vertical":`Longitudinal disassembly`,
"label.redistribution1":`Select up to 5 items`,
"pagecreator_page_label_modifypage":`Page editor`,
"label.Service.Cloud.Setting":`Service Cloud Settings`,
"setup_layout_label_pagename":`Page Layout Name`,
"label.ems.send":`Send`,
"vue_label_commonobjects_view_kanban_notice1":`Kanban view only displays the first 200 records`,
"lable.outlook.detail.maping":`Field Mappings`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Mobile side slider setting`,
"label.trigger.operation.email.template.param":`Passing parameters: language, Email template ID, and record ID`,
"front-objectTemplate-V1-Select-a-template":`Select an existing template as the base of the new template.`,
"label.email.template.delete.template":`Are you sure to delete this template?`,
"label.reportsSubscription.cancel":`Cancel`,
"lable.quote.syncingfrom.firstsync.description":`Opportunity products will replace quote line items`,
"label.weixin.no.pending.xsld.qin":`Sorry, no sales funnel data to show.`,
"template.dashboard.sales.indicators":`Sales Indicators`,
"label.field.new":`Provide users with evaluation and scoring operations.`,
"label.generatepage.title.desc1":`Generate mobile or PC version of the HTML code based on the selected fields, users can modify the code as needed.`,
"template.report.source.potential.customers":`Leads Source`,
"label.mr.title.queryData":`Find Duplicates`,
"button_partner_workspace_enable":`Enable Partner Cloud`,
"V":`Auto-No.`,
"label.icon.19":`Folder`,
"vue_label_report_summaryformula":`Summary formula`,
"label.appointment.wizard.subtitle2":`Available Date Range`,
"label.stdashbord.xsld.business.bjdzhl":`Stage Conversion Rate`,
"label.forecast.forehistory.deopportunity":`Opportunities`,
"chatter.email.referredToMeLeaveMessage":`Mentions me in a comment`,
"label.dategrouprelyon":`Date Grouping Criteria`,
"label.sendmail.batch.finish":`Batch Email: Completed`,
"label.weixin.allexpired":`All Overdue`,
"label.dashboardSetup.showdw.d4":`10 Thousand`,
"message.duplication.label.masterRecord":`Primary Record`,
"vue_label_calendar_availability":`Availability`,
"vue_label_chat_approval_message":`Approval message`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Please select the options`,
"label.israel.daylight.time":`Israel Standard Time`,
"front-sales-search-QB":`0 data in total, whether to create a new account in the QuickBooks`,
"vue_label_account_change_customer":`Change Account Owner`,
"label.integrations.mailchimp2":`View more about CloudCC and Mailchimp`,
"lable.product.pricebooks.onisu":`Inactive Price Books`,
"front-electronic-signature-backfill-field":`Backfill Field`,
"label.document.myself.folder":`My Personal Folders`,
"label.event.moveup.10hour":`10 hours ahead`,
"report.label.report":`Reports`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`Query failed, the user does not exist.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Please enter EncodingAESKey`,
"label.event.multi.view":`Multi User View`,
"label.h5.similar.opportunity.setup":`Similar Opportunities Settings`,
"label.setting.intergrationlist.button.install":`Install`,
"label.event.monthview":`Month View`,
"label.version.weixin":`WeChat Version`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP authentication failed, please check that the email address and password are correct.`,
"UG.homepage.003":`360 degree view`,
"vue_label_calendar_shared_calendar":`Share Calendar`,
"label.select.hope.merge.num1.record":`Please select the records that you want to merge into one record. Choose a maximum of 3 records at a time.`,
"label.createnewprocess":`Create New Approval Process`,
"font-trade-module-v1-invoice-status":`Payment Status`,
"label.customerinfo.introduce":`Company Information`,
"label.objectname":`Object Name`,
"label.chosen.field":`Selected Fields`,
"label_target_name":`Target Model Name:`,
"label.appointment.wizard.subtitle4-4-4":`1 month`,
"label.emailobject.groupemail.msg1":`No email address`,
"label_component_hotdeal_nopermission":`To see your business opportunity-related data, contact your CloudCC admin.`,
"label.appointmentdetail.wizard.title13":`Description`,
"front-web-module-v1-detail-comment-title":`Please comment on this service`,
"label.visualpage.component.n1":`1.Call method.  `,
"lable.outlook.mcto.erecord":`the earliest created records`,
"label.weixin.del.log":`Deletion Log`,
"setup_mainpage_label_welcome23":`Security settings`,
"label.selectreportline":`Select Columns for the Report`,
"label.chatter.following":`Following`,
"seven":`Seven`,
"message.error":`Error:`,
"label.mobile.phone.reporter":`Submitted By`,
"label.valadate.telphone.false":`Phone number enter error, please re-enter`,
"label.linkedin.setting":`Integrate LinkedIn H5 MiniApp`,
"label.mobile.side.tab.success":`Save the setting of the mobile-side slider successfully.`,
"label.notification.approval3":`Approval request for the 【对象】is reassigned to 【重新审批人】`,
"label.channel.invites.employees":`Inviting staff of this channel`,
"label.assignment.setup.detail.assigner":`Assign To`,
"label.campaignmember.main.updatecontactdesc":`Update all contacts status at one time`,
"label.permission.detail.app.fenpei":`Assign applications`,
"label.copydown":`Copy Down`,
"label_emailsync_status_action":`Action`,
"lable.Please.switch":`Please switch to horizontal or vertical menu to use this function.`,
"label_adjust_remark":`Remark on Adjustment`,
"label.weixin.newspaper.coverage.list":`Risk Sheets`,
"label.datamanage.contact.field":`Contact Fields`,
"label.partner.workspace.login.headerfooter":`Header and Footer`,
"lable.account.quarter.ovdate":`Fiscal Quarter End Day`,
"pagecreator.systemstyle.label.textcolor":`Text color`,
"label.industrialandcommercialverification.fieldmappingsettings":`Field Mapping Settings`,
"component_chatter_button_message":`Comment`,
"label.partnerCloud.enterAddress":`Please enter the address`,
"label.email.template.recently.used":`Recently Used`,
"component.event.label.calendar":`View Calendar`,
"label.setup.mobile.offlinecache.setting":`Mobile-side offline cache settings`,
"label.custom.PreviousCQ":`Previous CQ`,
"lable.total.of.payments":`0 payment in total`,
"label.ccpeak.use.class.time.trigger":`If the trigger calls the class, you can use the methods in the CCService directly.`,
"label_tabpage_addresswrongz":`Mailbox address format is wrong, please correctly enter the mailbox address!`,
"vue_label_homepage_select_components":`Select Component`,
"front-kefu-moudle-v1-secretID-reinput":`Please enter secretID`,
"label.ccdocument.select.template.red":`Please select a template set.`,
"vue_label_email_public_template":`Public template`,
"label.eowechat.openid":`WeCom ID`,
"label.user.ip.notlogin.range":`This IP is not in the IP range.`,
"chatter.email.reply.collection":`Comments on an item I bookmarked`,
"label.integrations":`Integrations`,
"label.permission.modifyAppPermission.selectedapp":`Selected Apps`,
"label.privacystatement":`Privacy Statement`,
"label.specificvalue":`A specific value`,
"label.appointmentconfirmpage.wizard.subtitle2":`Date and time`,
"label.message.ispartner.delete":`Because the contact is already associated with the partner user, the customer cannot be deleted`,
"report_button_go":`Go to`,
"label.h5.similar.opportunity":`Similar Opportunities`,
"UG_Lead_005":`Mailbox`,
"label.num.length.not.overstep":`the length of the value can not exceed 18 bits`,
"label.profile.mobile.setup.CEOandDirector":`Ceo and sales director`,
"label.addfield":`Add Field`,
"template.dashboard.institutional.overview":`Agency Overview`,
"label_tabpage_datefield":`When the date field is equal, it can use "yesterday", "today", "tomorrow", "last month", “this month", "next month", "last week", "this week", "next week" or "YYYY-MM-DD、MM/DD/YYYY" format.`,
"label.category.7":`Tourism`,
"UG_contact_02":`Engage contacts through multiple channels, call, email, social`,
"chatter.feed.menutype.feed.mecom":`New Post To Me`,
"vue_label_systemSettings_calltemplate":`Letter Template`,
"approval_process_errore":`An error occurred during save, please contact administrator.`,
"label.tabpage.choosefilez":`Select File`,
"label.changemydisplay.chagetab.cusapp":`Custom Apps`,
"clearadvancedoption":`Clear Filter Logic`,
"front-epwechat-module-v1-binding-user":`Bound Users`,
"label.customfields.fielddependency.null":`No dependencies defined.`,
"label.enterprise":`Enterprise Edition`,
"font-evaluate-module-v1-five-points":`Neutral Mark: 5 points`,
"lable.Synchronize.from.QuickBook":`Sync from QuickBook`,
"front-gantt-module-v1-task-number":`Tasks`,
"label.currency.edit.newexchagecurrency":`Dated Exchange Rates`,
"label.partnerCloud.partnerSite":`Partner Site`,
"label_tabpage_unequalz":`Unequal to`,
"label.version.solutions":`Solutions`,
"label.setting.intergrationlist.button.installed":`Installed`,
"label.h5.chatter.share":`Share files`,
"front-epwechat-module-v1-unbound-item4":` binding of external accounts`,
"label.textmessage.vonage.accessibility.setting":`Accessibility Setting`,
"font-evaluate-module-v1-evaluation-set":`Evaluation Settings`,
"message.servicecrew.time.violation2":`Out of working time`,
"label.processinfo":`Approval Process Information`,
"label.knowledgebase.last.modified":`Last Modified`,
"label.to.phone":`To`,
"label.baseoffirsttimereply":`Approve or Reject based On<strong> First </strong>response`,
"label.projectManagement.startingEndingTime":`Time`,
"label.licence.enable":`Active`,
"label.partnerCloud.basicSetting.cshua":`Initialize Partner Cloud`,
"APPIntegration.Dropbox.setting.03":`Enable Dropbox to let you select files from Dropbox and add them as attachments.`,
"label.account.contact":`Contact AI`,
"label.many.dayline.tab":`Mark`,
"label.weixin.input.username":`Please enter your name`,
"label.logintime.pagecue.invalido":`The end time must be all day.`,
"label.icon.30":`Book`,
"label_tabpage_advancedscreening":`Advanced Filter Conditions`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Yes, I want to disable Advanced Currency Management.`,
"label.tab.web.new":`New Web Tab`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`Deactivate`,
"error.currencyAdv.deleteprecodedate":`Cannot delete the date exchange rate of a currency.`,
"message.error.view.checkbox.validerr":`Error: Please use TRUE or FALSE`,
"UG_ST_006":`Enter directly`,
"label.dongshifang.title":`DongShiFang SMS`,
"label.data.dataexpalltype.all.desc3":`3、Exported Successful data will generate a compressed file that users can download from the export success list page according to the information in the mail.`,
"vue_label_pool_returnreason":`Reason for return`,
"label.list.userinterface.des":`Modify user interface with the following settings:`,
"label.notification.approval2":`Approval request for the【对象】is rejected by 【审批人】`,
"label.service.dispatchingUnits.the.level":`Level`,
"front-email-payment-Invoice-preview-tips":`All invoice templates are currently disabled. Please contact the administrator to enable the template before generating invoices.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Error: One or more of the fields selected in the component is no longer available in the report. <br>Use the dashboard component editor to select one of the available fields.`,
"label.import.step2.chooseidorother":`2、You can choose to use ID or name to match the record and fill in the lookup field. If you need to acquire the corresponding record ID and other information, you can create a report and set the record name and record ID as group columns, then export the report.`,
"label.customobjects.introduce":`Custom objects are database tables that allow you to store data specific to your organization in CloudCC. You can use custom objects to extend CloudCC functionality or to build new application functionality.`,
"label.visualpage.oldsystem":`Old version`,
"label.icon.94":`Book`,
"label.setup.log.desctiption":`You can download the behavior trace of your organization (Excel.xls)`,
"label.dynamicpage.layout":`Layout Rules`,
"lable.list.queue.objct":`Supported Objects`,
"label.customfields.placeholder.tip":`Sample text will be displayed in the input box and will disappear after gaining focus`,
"label.ems.activationtime":`Activation time`,
"label.detailinfo":`Details`,
"label.icon.17":`Report`,
"label_emailtocloudcc_button_complete":`Finish`,
"label.visualpage.component.n2":`2. Note that the "component tags" cannot be nested inside "<cc>tags".`,
"label.object.name.one":`Object Name 1`,
"label.summaryreport.step2":`Step 2 Choose the summarized data`,
"thisisanew":`New!`,
"label.query.detail.editpartneruser":`Edit Partner User`,
"label.tabpage.newview":`New View`,
"label.partnerCloud.productSet.addNew":`New Item`,
"label.appupload.upload.new.remark":`This is a new component`,
"label.case.ptext":`We have linked your company to the website version of the portal. Copy the web version address of the customer service portal dedicated to your company and add the portal on your official website.`,
"lable.PowerProcess.name":`Entitlement Process`,
"label_tabpage_choosefilez":`Select File`,
"homepage.components.place":`Component Position:`,
"lable.Synchronization.failure":`Failed to Sync`,
"label.dashboard.snapshot.get.data":`Get your data`,
"label.input.invalid.format":`Please enter the valid format`,
"label.quickbooks.view.openinvoices":`Open Invoices`,
"label.weixin.seating":`Seating`,
"label.searchlayout.remark":`Search layouts allow you to select the standard and custom fields that are displayed in the following search features:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Assign To`,
"vue_label_calendar_availability_view":`Calendar-Availability View`,
"label.country":`Country`,
"label.campagin.roi.zl":`Overview`,
"lable.currencyManage.advcurrencyEnabled":`Advanced Currency Management is enabled`,
"label.projectManagement.project.task":`Project Tasks`,
"label.appointmentpage.wizard.subtitle3-2":`Email`,
"label.input.invalid.date":`Please enter the valid dates`,
"vue_label_chatter_my_followers":`My followers`,
"label.setupdevelop":`Develop`,
"label.sendemail.send.checksend":`Check wether the email has been sent successfully`,
"label.eventfield":`Event Fields`,
"label.ccpeak.ccobject.put":`use put to assign to CCobject, for example:`,
"label.campaignmember.main.addMemberDesc":`You can search the existing leads and contacts, add them to this campaign, or manage the existing campaign members.`,
"label.knowledge.setting.hint.eleven":`Enter Data Category`,
"label.knowledge.category.button.four":`Add Sibling Category`,
"label.icon.27":`Learn`,
"vue_label_chatter_certification":`Are you sure you want to {isStatus} "{titleName}"?`,
"label.data.downpage.i.title.btn":`Go to Importing Page and Start`,
"label.campaign.channel.step6.pc":`Generate PC Page`,
"label.mr.caption.rule":`Rules:you must select one or more rules for finding duplicates`,
"label.service.gantt.resourcestype":`Resource Type`,
"label.searchfitconditions":`Find that match the following criteria:`,
"label.partner.template.name":`Template name`,
"setup.mainpage.label.welcome15":`CloudCC Cloud Platform workflow rules automate the support process for your sales, marketing, and more. Depending on a predefined set of rules, records can be automatically assigned to users or converted from one user to another. The main benefit of workflow management is to improve work efficiency by eliminating many unnecessary operations when updating records, and to improve business processing levels and optimize control processes by standardizing work methods and reducing operating costs. It supports unlimited infinity approval for any object, and can trigger reminder email, SMS reminder, task, field update and other functions.`,
"vue_label_commonobjects_view_chart":`Chart`,
"label.salescloud.teamrole.choose":`Please select team role`,
"lable.outlook.mcto.emailrel":`Email Associations`,
"front-invoice-online-payment-setup-describe":`Fast access, oneclick access. Simple, safe and swift online payment service.`,
"label.korean.standard.time":`Korea Standard Time`,
"label.lord.howe.standard.time":`Lord Howe Daylight Time`,
"setup_layout_group_button":`Buttons`,
"label.editdefaultshare":`Edit Default Sharing Rules`,
"label_fiscal_year":`Fiscal Year`,
"label.appointmentdetail.wizard.title2":`Owner`,
"label.email":`Email`,
"label.city":`City`,
"label.knowledgebase.data.recovery.failed":`Recover {a} data failed`,
"setup_mainpage_label_welcome6":`Users can create various types of fields in all objects of the CloudCC system without any programming knowledge or code development. The field types include: search relationship, single-selection field, dual-item selection, formula, automatic numbering. , URL, phone, fax, email, checkbox, date, time, number, text, text area, option list (single/multiple selection), currency, etc.`,
"label_emailtocloudcc_button_enable":`Active`,
"label.account.custom":`Custom Fiscal Quarter`,
"label.custompublish_time":`Customer Publish Time`,
"label.dashboardSetup.selwz":`Displayed Position`,
"component_todaytask_label_all":`View All`,
"label.service.resource.group.tip":`Service resources that pertain to crew types shall use the crew type.`,
"label.tianyancha.legalpersonname":`Legal person name`,
"component.setup.label.titlefield":`Title field`,
"label.email.template.public.mail":`Public Email Template Folder`,
"front-template-V1-DeleteTempalte":`Are you sure to delete "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Layout description`,
"vue_label_file_singel_upload":`Only one file can be uploaded. If you need to replace the file, please delete the uploaded file first`,
"label.view.hierarchy":`View Hierarchies`,
"label.file.owner.settings":`Owner settings`,
"label.sales.dashboard.name":`Name`,
"label.offfer.filer.name":`Quote File Name`,
"label.quickbooks.view.recentlypaid":`Recently Paid`,
"label.step1.select.merge.records":`Step 1 select the records to merge`,
"message.recordtype.assignprofile.tip":`Select the Enable for Profile checkbox to make the new record type available to a profile. Users assigned to this profile will be able to create records of this record type, or assign this record type to existing records. To make the new record type the default for a profile, select the Make Default checkbox.`,
"label.appointmentdetail.wizard.title9":`Travel Time`,
"label.group":`Groups`,
"label.deltorecycle":`Delete to Recycle Bin`,
"label.import.index.numlimit":`1. Only csv format files are supported, and up to 30,000 records can be imported for one time (<span style="color: red">up to 2,000 records can be imported if you need to execute trigger</span>). Records that exceed the limit will be automatically ignored by the system. If you want to import more data, please split into multiple files first and import them at different times. .`,
"label.file.delete.desc":`Deleting a file will also remove it from any additional records or posts.`,
"UG_activity_04":`Outlook/Gmail mailbox, record mail`,
"label.event.all.undealt":`All Unprocessed Events`,
"label.appupload.upload.install.error":`This application cannot be installed. please end the installation or modify the system api and reinstall it!`,
"template.chart.yqydcpsl":`Number of Activated Products`,
"label.import.index.advancepreparation":`Preliminary preparations`,
"label.eowechat.epdeptnamee":`WeCom Department Name`,
"front-kefu-moudle-please-input-servernum":`Please enter the service request list No.`,
"label.lookup.autocmp.nodata":`No match data`,
"vue_label_pool_assign":`Assign`,
"label.knowledge.timing.publish":`Timed publish is failed`,
"label.selected.groups":`Selected Quote Line Groups`,
"front-epwechat-module-v1-removesele-desc":`After the deletion, all setup of this application will be removed. Are you sure to delete?`,
"label.batchtransfer.type2":`Transfer Closed Oppertunities`,
"label.richtext":`Text Area (Rich Text)`,
"label.icon.174":`Aircraft`,
"vue.please.select.grouping.basis":`Please select Group By options.`,
"label.matrixreport":`Matrix Report`,
"label.jiandangfenpei.leftlist":`Unassigned Profiles`,
"label_chatter_card":`Card`,
"label.file.enter.title":`Please enter the title`,
"label.the.record.is.locked.and.cannot.be.selected.":`This record is locked, not selectable.`,
"label.partner.success":`Success! The domain is available`,
"label.selectreporttype":`Select Report Data Source`,
"report.type.label.productPricebooks":`Products and Price Books`,
"label.texttemplate.mergefields.tip":`Add incorperate fields while editing SMS content. When the SMS is sent, incorporate fields can be replaced by corresponding text. For example, {!Contact.name} can be replaced by the contact name when sending the SMS.`,
"label.publicgroup.detail.showallusers":`View all users`,
"label.brief.follow":`Follow Up`,
"label.forecast.settings.qijian.p":`Forecast Quarterly`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Customize Page`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`sent you a message`,
"label.pc.layout":`PC Layout`,
"label.currency.v":`Enter decimal places ( number of digits to the right of decimal point ) allowed when displaying data in this new currency. It must be an integer with value between 0 and 6.`,
"label.projectManagement.kanbantask":`Kanban Task`,
"component_recdetail_label_title":`Detailed information`,
"label.isremider":`Reminder`,
"front-epwechat-module-v1-input-home-url":`Please enter homepage URL`,
"label.usefullife":`Expiry Period`,
"label.visualpage.ptype":`Common`,
"label.quote.name":`Quote name`,
"vue_label_report_addtocomponent":`Are you sure you want to add { name } to the component library?`,
"label.dashboardSetup.showdw.d1":`100 Million`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical2,...)`,
"label.component.helper.potentialcustom":`Leads assigned to you today`,
"label.autoRegister.changepwd.setpwd.tip.number":`At least one number`,
"label.data.setok.e.desc3":`， download your exported data.`,
"label.data.downpage.e.title.num4":`4、 The export files have two formats: CSV format and the compression format. The compression format is divided into two types: one is to automatically generate the compressed file password, the other is to manually enter the compressed file password.`,
"lable.quote.editqtpdt.description":`Select a price book for this quote. You can only add a product from a single price book, and changing the selected price book will remove all existing products from the quote.`,
"front-kefu-moudle-edit-userinfo":`Edit User Information`,
"label.please.ChooseMinAndMax":`Please choose at least {0} product options, and up to {1} can be selected.`,
"label.knowledgebase.archive.an.article":`Archive an Article?`,
"label.multilang.customforcast.submit":`Do you submit a forecast from {0}fiscal year{1} to {2}fiscal year{3}?`,
"label.import.index.filename":`File name`,
"front-console-no-reco-contact":`Contact cannot be identified`,
"label.quantity.greater.than0":`The quantity must be greater than 0.`,
"label.codeNorm":`Code Standard`,
"label.average":`Mean`,
"label.multilang.page1":`Page`,
"label.data.exp.save.ok":`Save template successfully`,
"message.error.delete.record":`The record to be deleted was not found!`,
"label.newvaluereplaceoldvalue":`Globally replace an existing value in a picklist with a new value. Make sure you have created the new value on the picklist field first.`,
"label.tabpage.saveviewsuccess":`View saved successfully`,
"label.partnerCloud.productSet.parentOptions":`Parent Item`,
"label.emailtemplate.availablemergefields":`Availble Merge Fields`,
"label.data.import.setup":`Data Import Setup`,
"label.escalation.setup.entrydetail.escalation.action":`Escalation Actions`,
"System.TimeField.Description":`Allow users to enter a local time. For example, "2:40 PM", "14:40" and "14:40:00" are all valid times for this field.`,
"front-additional-products":`Buy Other Products`,
"label.appointment.wizard.subtitle4-4-1":`1 week`,
"label.chatter.colleagues.list":`Colleagues`,
"label.log.invalid.data":`Invalid date`,
"label.file.preview.unconvert":`No preview information is generated,please click preview details`,
"label.customer.detailed":`Choose the page for this new tab. Enter other details.`,
"label.sendsms.content":`Content is as follows:`,
"label.exported_to":`The exported file will be emailed to`,
"label.attendance.checkin":`Check In`,
"Dashboard.NoAccessRightToSee.Warning":`You have no permission to view the dashboads {0} which are set as defualt open, please reset.`,
"message.choosedelete":`Please select data you want to delete`,
"label_tabpage_choosecontent":`Select the value content`,
"label.no_responses":`No responses`,
"report_type_label_customService":`Customer Support`,
"label.report.select.condition":`Conditions`,
"label.umeng.activity.distributeevent":`assigned you a event.`,
"label.knowledge.language.portuguese":`Portuguese`,
"label.knowledgebase.published":`Published`,
"UG_opportunity_001":`How do you monitor your sales?`,
"label.mr.caption.scope":`Scope: query all data if not selecting`,
"message.login.mfaverification.to.pclogin":`Your organization has enabled the secondary login verification, the first login requires binding to the mobile device, please use the PC side for login binding`,
"vue_label_dashboard_pleaseenterthecolorrange":`Please enter the color range`,
"label.emailsync.status.time":`Time`,
"chatter.putup":`Share a file`,
"vue_label_report_drillcondition":`Drilling Condition`,
"label.emailobject.list.myemail":`My Email`,
"label_tabpage_andz":`And`,
"label.share_link":`Share Link`,
"label.emailtocloudcc.exists2":`This mailbox has been set to Email to Case. Do not repeat settings.`,
"label.icon.89":`Advisory`,
"front-kefu-moudle-v1-qdygbzx-chat":`Are you sure to turn off online chatting?`,
"label.approval.selectone":`Please select one action at least.`,
"chatter.group.groupName":`Group Name`,
"label_chatter_relateitem":`Related To`,
"label.file.folder.delete1":`Delete folder?`,
"Pagelayout_Setup_003":`The Name field must be selected`,
"setup_mainpage_label_welcome2":`Custom database (object)`,
"pagecreator.systemstyle.label.linkcolor":`Link color`,
"label.task.this.week":`This Week`,
"message.custom.field.donotdelete.report":`The field is referenced by the report`,
"pagecreator.layout.button.delete":`Delete layout`,
"label.reportsSubscriptionPage.condition.operator":`Operator`,
"label.location.display.type.degrees":`Degrees,minutes,seconds`,
"label.appupload.upload.url":`Installation URL`,
"label.logical.relation":`Logical relation`,
"label.knowledge.publish.article":`Publish Article`,
"vue_label_commonobjects_detail_activity_commingtask":`have upcoming task`,
"vue_label_pool_reason":`{0} reason`,
"front-gantt-module-subtasks-cannot-subtasks":`Subtasks cannot appear under subtasks!`,
"label_tabpage_filesizez":`File size`,
"label.customfields.formula.returntype.monry.tip":`Calculate a dollar or other currency amount and automatically format the field as a currency amount.`,
"label.tabpage.allapplications":`All applications`,
"message.duplication.label.matchcontainletters":`Contain`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Please choose "One work order line item for each asset" as the generation type of work order.`,
"label.preview_post":`Preview Post`,
"chatter.p.data":`Post Date`,
"label.isnot.right.number":`Invalid number`,
"label.contentsource":`Content Source`,
"message.groupandsummaryconditionsame":`Conditions used to grouping cannot be the same as summary conditions`,
"label.weixin.wdyj.nodata.qin":`Sorry, {0} has no data.`,
"chatter.vote":`Vote(s)`,
"label_partner_workspace_tab_option":`Available tabs`,
"chatter.changeVote":`Change Vote`,
"label.data.file.i_title.num2":`2. It is recommended that the data be exported when the data is imported, so that the export document is used as a template to collate the data to be imported, and then import. (If the imported data contains a comma, replace it with the @ symbol.)`,
"label.relation.list.error":`Error`,
"label.validate.function.funcExplain.MILLISECOND":`Return millisecond of day (From Date/Time fields)`,
"label.emailobject.emaildetail.button.relateto":`Related to`,
"label.dashboard.dataSource":`Show Data Source`,
"label.marketseamemset.lead.title":`Members Setup of Lead Pool`,
"label.appupload.addobj":`Add to Package`,
"lable.outlook.mcto.domain":`Add my domain (gmail.com) to the list of excluded domains.`,
"label.input.right.url":`Please enter the valid URL`,
"label.newprocessstep5.tip":`The approval page is where an approver will actually approve or reject a request. Using the options below, choose the fields to display on this page.`,
"label.schedulejob.setup.schedule.st4":`The 4th`,
"label.emailsync.status.user":`Users`,
"front-kefu-moudle-v1-jymm-reinput":`Please enter a 12digits password, combining two or more of capital, lowercase, numeric, and characters`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Scoring Rule Name`,
"label.mr.title.fieldName":`Field Name`,
"label.data.deriall":`Export All`,
"label.tianyancha.businessverify.step2":`Enable business data verification step 2`,
"label.submissions":`Submissions`,
"vue_label_calendar_removed_successfully":`Calendar removed successfully`,
"label.eventrecordtype":`Event Record Types`,
"lable.outlook.detail.syndire":`Sync Direction`,
"label.mobile.bind.fail":`Failed to bind, Please try again later`,
"label.notification.task2":`【被分配人】 viewed the task you assigned`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Pay By:`,
"label.escalation.setup.newaction.step3":`Step 3 Select the user to notify`,
"label.summaryreport.selectsum":`Choose the summarized data and summarized type`,
"label.components.setup":`Component Setup`,
"label.taskevent.introduce":`Your Activities List`,
"label.assignment.setup.detail.conditon":`Criteria`,
"front-lightning-module-v1-details-page-chart-select-statements":`Select Report`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`formula evaluates to true`,
"label_partner_common_setup":`General setting`,
"label_chatter_dateRange":`Date Range`,
"label.partner.workspace.tab.mobile.using":`Display on the mobile app`,
"message.servicecrew.time.violation1":`Violation of assignment time: there is a team member.`,
"report_label_projectcount":`items, sort by report name`,
"label.file.uploadfile":`Upload Files`,
"vue_label_commonobjects_detail_correct_email_address":`Please input the correct email address`,
"lable.account.CurrentandNextCQr":`Current and Next 3 CQ`,
"setup.layout.label.order":`Sort By`,
"label.service.major.event.independent":`Independent`,
"label.icon.38":`Positioning`,
"label.knowledge.draft.record":`The record you are trying to delete is not found.`,
"label_quota_percentage":`Show Completion Percent of Quotas`,
"label.escalation.setup.entrydetail.escalation.minute":`Minutes`,
"label.knowledgebase.edit.article.category":`Edit Article Category`,
"Homepage_News_003":`Unable to display news without accounts data, please create a new account and the related news will be shown.`,
"label.mr.descreption.oneGroupNote3":`records.`,
"label.customsetting.touse.getListCustomSetting":`Query the "list" type data of custom settings, return all the data corresponding to API Name. Map map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Error: You must enter a value`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Friday`,
"message.error.view.badprevilege.qin":`Sorry, you do not have access to {1}, so no data shown</br>`,
"label.dashboard.distribution":`Distribution`,
"label.field.value.save":`Always need a value in this field to save the record.`,
"label_custom_year":`Custom year`,
"label.code.error":`The code contains commands or functions that are not permitted as following:`,
"label.appexchange.uninstallpage.message2":`Permanently remove all your custom settings for these components`,
"label.global.search.obj":`Global Search Object`,
"label.emailobject.from":`From`,
"lable.opppdt.selPdt.byconditions":`By Field`,
"chatter.p.note":`Notes of this post`,
"label.hiddenformulaedit":`Hidden Formula Editor`,
"label.editQuotation":`Edit Quotation`,
"label.notification.arketsea.collection":`{5} collected{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`When it comes to saving java. util.Date type data （insert and update）in a database, for example, When it comes to database saving (insert and update) of type java.util.Date, for example, TpSysTask task=new TpSysTask () ；task.setBeginTime (new Date () ）；......dbman.insert (task) or dbman.update (task); you should change new date () to call TimeUtil.getNowDate (userInfo), so the relevant statement in the example above should be changed to task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Convert`,
"front-kefu-moudle-IP-phone":`IP Phone`,
"label.emailobject.list.draft":`Drafts`,
"label.tianyancha.businessverify.readandconfirm":`I read the agreement and i agree with it`,
"label.win.customers":`Closed-Won Accounts`,
"vue_label_commonobjects_view_switch_display":`Your records are grouped by record type, you can click the corresponding record type name to switch display.`,
"pagecreator_systemstyle_label_textcolor":`Text color`,
"label.autosearch.keywords":`Complete Keyword Search Automatically`,
"label.knowledge.setting.data.six":`You are going to delete category {lbmc}, are you sure to continue?`,
"front-console-sort-field":`Case No.`,
"label.bangladesh.time":`Bangladesh Time`,
"label.dashboardSetup.number":`Numerical Values`,
"lable.account.LastbDays":`Last 30 Days`,
"label.layout.searchdialog":`Lookup Dialogs`,
"label.newprocessstep4.tip":`Select the email template that will be used to notify approvers that an approval request has been assigned to them. Note that this template will be used for all steps for this process.`,
"label.nousing":`Inactive`,
"vue_label_report_detailline":`Details Line`,
"label.emailobject.template.message3":`The maximum of mail templates is reached!`,
"label.c.d":`C to D Relation`,
"message.report.error.fail":`Load failed, please try again`,
"label.edit.ccdocument.content":`modified the attechment.`,
"label.textmessage.exceeded":`The number of your text templates has exceeded the limit!`,
"label.saveas":`Save As`,
"label.visualpage.an.inline.style":`Embed custom page type to detail page and tab home page`,
"label.pagelayout.remark2":`data. After creating page layouts, click the Page Layout Assignment button to control which page layput users see by default.`,
"label.notification.approval1":`Approval request for the【对象】is approved by【审批人】`,
"label.h5.chatter.image":`The uploaded image format is incorrect`,
"vue_label_dashboard_displayunit":`Please select a display unit`,
"label.knowledge.default.language":`Default Language of Knowledge`,
"label.chatter.publish":`Publish`,
"label.companyprofile.serveraddress":`This synchronization only synchronizes the current server.`,
"label.chatter.groups":`Group`,
"label_set_successfully":`Successfully set!`,
"label.quote.zongjia":`Total price`,
"label.project.notice.endingdatelater":`The end date should be later than or equal to the start date.`,
"label.customfields.fielddependency.info":`This page allows you to define dependencies between fields (e.g., dependent picklists).`,
"vue_label_lead_successful_conversion":`Convert successfully`,
"label.icon.93":`Book`,
"shift.serviceresource.illegal":`The service resource is not pertain to member of service territory or the shifting date is not within the range of membership.`,
"label.integrations.action.addnewlead":`Add New Leads`,
"label_display_all_zeros":`Show all rows with zero values`,
"canlendaryear":`Calendar Year`,
"label_tabpage_selrecordtypez":`Select Record Type`,
"vue_label_commonobjects_view_chart_funnel":`Funnel Chart`,
"label.layout3":`Layout 3`,
"label.logintime.cue":`No login time specified.`,
"label.service.miniProgram.lastDate":`Last Modified Date`,
"label.emailobject.view.fromcrm":`Emails from Contacts/Leads`,
"pagecreator.button.mobilepage":`Mobile-side`,
"lable.oppt.jieduan.signcur":`Marked as the current stage`,
"label.fullaccess":`Full Access`,
"homepage.layout.pagename":`Page Layout Name`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Please select at least one record.`,
"label.view.sortview.closepage":`Close Window`,
"label_forecast_type":`Type of forecast`,
"all.day":`All Day`,
"label.view.sortview.printpage":`Print This Page`,
"message.integration.configure":`The integrated configuration is empty!`,
"label.forecast.customforecast.foretype.close":`Closed`,
"label_chatter_like":`Like`,
"template.report.folder.customer.potential":`Leads Analysis`,
"label.umeng.approval.dlsp.approve":`#approvalname approved the #actorname''s approval request of #objAPIName #recordname for you.`,
"vue_label_normal_movedown":`Move down`,
"chatter.group.groupAccessPermissions":`Group Access`,
"label.visualpage.tip":`You can create your own page here`,
"message.validation.isnotdate":`Invalid Date`,
"label.icon.173":`Sailboat`,
"label.icon.124":`Injection`,
"label.import.page2.csvfiled":`CSV Field`,
"setup_layout_component_area":`Area`,
"label.visualpage.workability.standard":`Available Standard Classes On the Page`,
"label_emailtocloudcc_redmessage9":`Database error, please contact administrator.`,
"label_tabpage_contactsz":`Contacts`,
"label.multilang.workflow.everydayinmonth":`{1} days every {0} months`,
"APPIntegration.Social.linkedinerror":`You must enter a valid URL for linkedin.com`,
"button_partner_workspace_manage_memo":`Manage your partner cloud and configure partner cloud properties.`,
"template.chart.bnsrmb":`Revenue target for the year`,
"chatter.follow.now":`Following`,
"label.entitlement.process.condition.repeat":`Set milestone repetition`,
"label.relationobject.isdl":`Delegate`,
"label.lasttimemodifieralias":`Last Modifier Alias`,
"vue_label_commonobjects_detail_task_name":`Edit task name`,
"vue_label_homepage_quarterlyperformance":`Quarterly Performance`,
"pagecreator.layout.message.delete":`Do you delete the current selected layout?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Enable signature`,
"label.partnerCloud.financeSetting.create":`Create fund for eligible users automatically when new partners activated.`,
"label.data.file.i.title.num1":`1. The imported file must be a file in CSV format. The file must contain a title and cannot be imported without title.`,
"label_efine_assessment":`Appraisal Cycle`,
"message.duplication.label.sectionTitle":`Select the value to retain`,
"front-electronic-export-buttonExport":`Continue to Export`,
"message.submitpage.email":`Congratulations, email sent successfully.`,
"after":`After`,
"label.version.nonsupport":`Unsupport`,
"label.icon.105":`Schedule`,
"label.quickcreate.titledesc":`Enable Quick Create let users create records from within the lookup dialog.`,
"label.quote.number":`Enter the quantity`,
"label.view.sortview.setdefault.prompt":`Pin this view list`,
"label.refertime":`Date Submitted`,
"frame.personinfo.label.minipic":`Thumbnail Image`,
"label.mobile.home.page.newopp":`Recently Created Leads`,
"label.address":`Address`,
"front-pay":`Pay`,
"label.chat.serviceAppointment":`Service Notice`,
"label.umeng.activity.eventviewed":`The event you assigned to #name is viewed`,
"label.validate.function.funcExplain.DATE":`Create date through year, month and day`,
"label.commiterselectapprover":`Allow the submitter to choose approver manually`,
"label.appointmentconfirmpage.wizard.subtitle3":`Location`,
"vue_label_display_text_field":`Show Text Fields`,
"label.salescloud.teamrole":`Team Role`,
"maintenanceplan.workorder.generate.limit":`The work order shall be within the range of maintenance plan.`,
"label.campaignmember.selectmember.description":`selcet a view, then add the members to the Campaign, and the Campaign Menmeber Status is`,
"label.ismodify":`Allow Editing`,
"label.height":`High`,
"label.tabpage.thevalurofz":`The value of`,
"label.create_successful":`Create form successfully`,
"front-invoice-online-payment-setup-configure-dialog":`Configure Payment Interface`,
"label.customerinfo.smsEid":`SMS Gateway EID`,
"label.visualpage.list.no":`No permissions to access the custom pages`,
"look.trigger.in":`View Instructions`,
"label.setting.disable":`Deactivate`,
"chatter.group.name":`Groups`,
"label.solutionadministrator":`Solutions Manager`,
"label.vlidaterule.top":`Top of Page`,
"pagecreator.layout.message.save.fail":`Layout save failed`,
"label.partnerCloud.orderingPlatform.noZero":`The quantity cannot be 0.`,
"label.customfields.suretodeleteprompt":`Confirm the prompts of custom field deletion`,
"button_partner_viewdetail":`View`,
"label.icon.122":`House`,
"label.customer.tab.step2.introduce":`Choose the user profiles for which the new custom tab will be available. You may also examine or alter the visibility of tabs from the detail and edit pages of each profile.`,
"label.task.delegated":`Delegated`,
"vue_label_salesadvance_averageamount":`Per Customer Transaction`,
"vue_label_chat_invitedtojoin":`{invite} invited you to join the group chat`,
"label.data.downpage.e_title.num1":`1. Select the objects you want to export,or choose to export all.`,
"label_display_options":`Display Options`,
"vue_label_chatter_more_comments":`More comments`,
"label.ggReleaseRange.publish":`Publish List`,
"label.valuetype.notmate":`Line condition error, the value type does not match.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Last Synced activity:`,
"label.dataimport.duplication.filter":`Find Duplicate Filter Prompts`,
"label.appdownload.uninstall":`Uninstall`,
"message.error.task.add":`New task anomaly`,
"UG.Account.07":`Import account`,
"label_tabpage_lastone":`Select at least one operation`,
"front-console-holdTime":`Lag Time`,
"label.emailobject.schedule":`See my schedule and book a time here.`,
"label.lookup.locked.data":`This record is locked, not elective`,
"label.assignment.setup.newentries.ifcondtions":`Run this rule if the`,
"label.magadan.time":`Pietro Pavlov Time`,
"message.error.serviceterritorymember":`Please define the selected service resource as a member of service territory within the time range of service appointment plan.`,
"label_chatter_delete":`Delete`,
"label.partner.workspace.member.permission":`Available permissions set`,
"label.notification.task5":`Your task has been overdue`,
"mary":`May`,
"label.homepagemodule":`Homepage Components`,
"label.compact.layout.frame.error1":`Right screen cannot have no content`,
"chatter.error.refresherror":`Refresh failed,please try again.`,
"label.login.rememberPsd":`Remember Me`,
"Lead.Scoring.Setting.Rule.Setup.01":`Lead Scoring Rule List`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Sunday`,
"label.visible":`Visible`,
"label.console.new":`New Console`,
"label.mr.descreption.reDataList4":`milliseconds. per page.`,
"vue_label_notice_uploadavatar_notice2":`The uploaded avatar image can only be in JPG/PNG/GIF format`,
"label.operation.error":`Operation failed, please try again.`,
"label.sendsms.context":`SMS Content`,
"label.least.show.line":`(display 4 lines at least)`,
"label.tabpage.newWizardz":`New added function wizard`,
"label.tippage.li2":`Delete all reports based on custom report data source`,
"label.customfields.new.step2.opration.unique":`Unique`,
"label.listofshare.remark":`Following users can view this record`,
"label.address_information":`Address Information`,
"label.projectManagement.overdue.tasks":`Overdue Task`,
"lable.account.PreviousCQ":`Previous CQ`,
"label.service.miniProgram.advertising":`The ad name is only used to identify multiple ad entries and is not displayed in the ad.`,
"label.integrations.mailchimp.exportlead":`Export selected leads to Mailchimp`,
"label.payments.paytip3":`Please select a billing address`,
"label.mobile.phone.screen":`Filter`,
"label.h5.tome":`About me`,
"label.mobile.side.tab.remark1":`Add the CloudCC tab and object to the navigation menu of the mobile-side slider.`,
"vue_label_calendar_choose_a_custom_color":`Custom a Color for This Calendar`,
"label.lastname":`Last Name`,
"vue_label_dashboard_selectreport":`Please select report`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Export the report as displayed in Cloud CC, including the report header, group and filter information.`,
"label_chatter_default":`Default`,
"label.globalSearch.info":`Search for all selected objects`,
"label.integrations.mailchimp.massage2":`Exporting the selected leads to Mailchimp and you will be able to view the leads in the Mailchimp list later`,
"label.tabpage.addresswrongz":`Mailbox address format is wrong, please correctly enter the mailbox address!`,
"label.mobile.phone.customer.call":`Visit Client`,
"vue_label_email_linkrecordfail":`Record unlinked`,
"lable.account.LastfDays":`Last 90 Days`,
"label.cpq.order.status.delete":`This order is active and cannot be deleted`,
"label.ccchat.notmember.active.group":`You are not member`,
"label.savepayset.failure":`Failed to save the online payment account`,
"label.version.createlimitbyobject":`Your current CloudCC edition is {0}, and you can create {1} {2} for each object. Now, the number of {2} is exceeded the maximum of your plan of subscription, please update your CloudCC edition.`,
"approval.process.errore":`An error occurred during save, please contact administrator.`,
"label.stdashbord.xsld.business.reportanalysis":`Chart Analysis`,
"label.login.verification.please.enter":`Please enter the security code you get from the MFA application`,
"label.tabpage.cue":`Information reminder`,
"vue_label_salesadvance_converserate":`Convert Ratio`,
"label.marketsea.recyclereminddays1":`Before autorecycle`,
"label.import.page1.update":`Update`,
"label.document.folder":`Document Folders`,
"label.h5.similar.opportunity.feature":`This feature allows a user to search for opportunities that share common fields with the opportunity. Once enabled, a Similar Opportunities related list appears on the opportunity record.`,
"label.myanmar.time":`Myanmar Time`,
"monday":`Monday`,
"vue_label_account_shareholder":`Shareholder`,
"button.partner.search":`Inquire`,
"label.partnerCloud.partnerAccount.topUpAmount":`Topup Amount`,
"label.tabpage.refreshz":`Refresh`,
"lable.PowerProcess.complete":`Milestone Completion Mins`,
"front-kefu-moudle- normal-phone":`General Phone`,
"label.user.unauthorized.organization":`Unauthorized organization, please contact the administrator.`,
"label.area.canot.save.nulldata":`Cannot save the null data`,
"label.version.role.management":`Roles Management`,
"label.recordtype.batchaddattachments.batch.remark":`Step 1 Chose file, Step 2 Click the "start upload" button,upload files, Step 3 Click button to finish.`,
"label_tabpage_contentz":`Please enter content`,
"label.partner.workspace.member.all":`All`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Please select at least one lead or contact`,
"label.appupload.install.error.choice5":`Stop the installation immediately and output conflicting components`,
"label.version.lookupmdfield":`Master-Detail Relation Field`,
"setup.layout.label.desc":`Descending`,
"vue_label_report_addsummaryformula":`Add summary formula`,
"label.done":`Done`,
"label.input.samevalue":`Enter the same value`,
"label.SMS.next":`Select the objects for the SMS notifications and click "Next". SMS notifications can only be associated with the same type of workflow rules and approval processes.`,
"label.role.allunselectuser":`All Unassigned Users`,
"label.loginhistory":`Login History`,
"vue_label_report_addpublicreportstofolder":`Add public reports to this folder`,
"label.email.track.no.attachment":`No Attachment`,
"label_network_connection_failure":`Network connection is failed.`,
"vue_label_file_delete_lib_member":`Delete file library member`,
"label_partner_step1":`Step 1 select template`,
"label.password":`Password`,
"label.select.the.fields.around.code":`Choose fields to be displayed around the QR code/Bar code.`,
"label.file.share.limit":`Beyond the share limit, no new share can be added!`,
"label.desktop":`Desktop`,
"label.sendmail":`Send Email`,
"label.quote.detail":`Quote Line Items`,
"label.approvalstep2":`Step 2 Specify Step Criteria`,
"label_component_hotdeal_nodata":`No business opportunity related data.`,
"lable.reset":`Reset`,
"label.eventpagelayout":`Event Page Layout`,
"label.icon.100":`Stationery`,
"UG.quota.03":`Quote template`,
"label.calendar.week.view":`Week View`,
"component_chatter_file_button_save":`Publish`,
"label.as":`As`,
"template.chart.yqxypjz":`Average Expected Response`,
"UG.Contract.03":`Create contract`,
"label.projectManagement.gantt":`Gantt Chart`,
"label.forecast.edit.error0":`Error: You must select one orporate currency at least.`,
"label.ccpeak.delete.sharetab":`Delete the sharing form`,
"label.account.contact.goback":`Back to Accounts`,
"vue_label_email_insert_field":`Please select insert field`,
"setup_object_field_dependency_label_fieldvalueoptions":`Available Field Values`,
"label.salescloud.opportunity.contactrole.optionlist.main":`The following is the main list of options list values for the contact roles field on opportunities`,
"label.huanxinconfig.tenantid.lost":`tenantid cannot be empty`,
"label.mask.show.last_4":`Mask last four characters`,
"label.targer.name":`Target Name`,
"vue_label_commonobjects_detail_unlocksuccess":`Successfully unlocked`,
"front-kefu-moudle-length-min":`Length (minutes)`,
"label.chat.topic.my.favorite":`My Bookmarked Topics`,
"chatter.upload":`Upload`,
"message.cannotapproveit":`The approval request can not be processed.`,
"label.weixin..xsld.order.by.jine":`Sort By Contract Amount`,
"label.projectManagement.wait.test":`Waiting for testing.`,
"template.report.customer.contact.list":`Contact List of Accounts`,
"label.empty.recycle.bin":`Clean Recycle Bin`,
"label.detail.approveprocess":`View Approval Processes`,
"label.appexchange.uninstallpage.message4":`Permanently delete all reports, views and custom tabs of the custom objects in this package`,
"label.weixin.linkreport":`Related to→Report`,
"label.tianyancha.orgnumber":`Organization code`,
"Q":`Picklist (Multi-Select)`,
"pagecreator_systemstyle_message_save_fail":`Style save failed`,
"label.partner.new":`Partner cloud: new`,
"label.ems.accounttype":`Account type (a)`,
"label.weixin.next":`Next`,
"label.weixin.coach.interpret":`Aid-Max reserves the right of revision and final interpretation within the scope of the WeChat service law.`,
"label.some":`record(s)`,
"label.currency.rate":`Currency Edit: Conversion Rates`,
"label.emailobject.template.name":`Template Name`,
"UG.Campaign.001":`Planning campaigns`,
"label.mr.descreption.reDataList3":`groups of data,query time`,
"label.project.hit.nine":`Daily Issue Reminder`,
"lable.PowerProcess.golist":`<<Back list：Entitlement Process`,
"label.viewbuttonedit.remark":`Select the standard and custom buttons displayed on foreground view.`,
"label.component.helper":`Assistant`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Signed Payment`,
"chatter.group.userName":`Username`,
"label.mobile.phone.business":`Opportunities`,
"label.quickbooks.payments":`PAY`,
"label.step6.total7":`Step 6 of 7`,
"label.forecast.detailforecast.revenue":`Revenue Forecast`,
"vue_label_commonobjects_view_chart_displayas":`Display As`,
"label.recordeditoption":`Record Editability Properties`,
"label.sendemail.send.sendfailstandby":`Email sending failed, please contact your administrator(spare outbox).(error code:`,
"label.knowledgebase.reset.filter":`Reset Filter`,
"label.icon.111":`Food`,
"label.standard.buttonandlink.firstsetting":`Override Properties`,
"front-filter-module-v1-filter-description":`Flash filter cannot be saved. It applies only to the current operation without any influence on views or other users.`,
"label.showmore":`View More`,
"UG_Lead_001":`How to introduce clues?`,
"label.exchange.sync.state.setting.m1":`Miscrosoft Exchange service account provided:`,
"label.please.enter.channel.name":`Please enter the channel name.`,
"label.emailtocloudcc.edit":`Edit`,
"label.layout.tabdialog":`tabs`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Completed Tasks`,
"label.tabpage.enterviewname":`Step 1 please enter the view name`,
"label.mobile.phone.not.to.choose":`None Selected`,
"label.datamanage.contact.namenull":`Note: Note: If the contact name fiels is null, the record will not be imported.`,
"LT":`Geolocation`,
"label.exchange.sync.state.task.m3":`Records synced in the last 24 hours:`,
"lable.SalesCommitmentKanBan.contractOwner":`Contract Owner`,
"vue_label_chatter_write_review":`Write a comment`,
"label.h5.approval.enter.content":`Please enter approval notes`,
"label.location.display.type":`Latitude and longitude display methode`,
"label.numberscannotnull":`Number cannot be empty`,
"label.icon.3":`Currency`,
"setup_object_field_dependency_label_linkedfieldvalue":`Dependent Field`,
"label.task.future":`Upcoming Tasks`,
"label.look.more.record":`Show More`,
"vue_label_account_cases":`Transfer all cases of customer owners`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Set History Tracking`,
"ObjectDetailed.ViewKeyInformation.Layout":`Edit Key Information`,
"label.layout.editsearchdistribute.tip":`Select the fields to include in this search layout. Note that your choices only determine the display of search results and do not affect the fields that are actually searched.`,
"label.emailtoall":`Send emails to all users.`,
"label_partner_new":`Partner Cloud: New`,
"label.direct.dashboard.me.not.approval":`My Items to Approve`,
"label.platform.customize.customizeui":`Custom UI`,
"label.userinfo.pwderror.againinput":`The password entered twice is not the same. Please re-enter.`,
"label.customsetting.introduce":`Use custom settings to create and manage custom data at the organization, profile, and user levels. Custom settings data is stored in the application cache. This means you can access it efficiently, without the cost of repeated queries.`,
"label.file.owner":`Owner`,
"label.icon.7":`People`,
"label.document.query.button":`Click browse to find the file`,
"label.tabpage.turnoffsz":`Closed - Converted`,
"message.error.appid.appsecret.failed":`Failed to get the secrest keys!`,
"vue_label_commonobjects_view_to_display_fields":`Select up to 15 display fields`,
"label.martrixreport.setlinetitle":`Specify Row Headers`,
"vue_label_chatter_applycertification":`Agree "{name}" to join the group chat?`,
"front-electronic-export-success":`Export successfully, please check it in the Mailchimp list`,
"label.emailsync.status.enable":`Active Connect`,
"label.c_d":`C to D Relation`,
"PageLayout_Search_MultiSearch_003":`Select one field at least.`,
"label.tabpage.newInterfacez":`The new interface`,
"label.cutomsummaryfieldedit":`Custom Summary Field Edit`,
"label.usermanage.view.field.notexist":`The field corresponding to the view does not exist.`,
"label.list.userinterface.dashboard.setup":`Dashboard Setup`,
"label.knowledgebase.delete.article":`Delete Article`,
"label.dataimport.type.update":`Update`,
"label.marketsea.new":`New Pool`,
"label_tabpage_newlybuildz":`New`,
"vue_label_helpcenter_report1":`1.Build a report<br> The Lightning report in Cloud CC sales management system is a powerful data analysis tool. Many sales problems can be solved by grouping, filtering and summarizing records. For example: "How much revenue did the company's new business opportunities create in the last quarter?" Report charts can be added on the basis of completing the data overview. After the report is completed, click Run to view the complete results of the data. <br> Step 1: From the report tab, click "New Report";<br> Step 2: Select the report data source, and then click "Next";<br> The report data source you choose can determine which records or fields can be used in the report. Select or search for an object as the main object. You can select up to 4 objects that have corelation with the main object, and you can select the relation between the objects. <br> Step 3: Enter the report editing page and display the preview data<br> In the edit mode, you can customize the report, add fields as columns to the report, group rows and columns, and use filters to filter report data until the data you need is displayed accurately<br>Add or remove columns and adjust the order<br> Add column: In the report editing mode, click the "Column" input box in the "Summary" on the left side of the page, and add report columns after searching the field or scrolling the drop-down list of fields and selecting the target field. <br> Remove column: <br> A. After finding the "column" you want to remove in the "column" list on the left, click the "×" on the field box. <br> B. Or find the "column" you want to remove in the header of the report preview view on the right, click the "drop-down button", and click "delete column".<br> Removing the column from the report does not delete the field. If you want to restore the column after removed it, just add it again. <br> Adjust the column order: Drag the "Column" field in the "Column" list on the left up and down to adjust the "Column" arrangement order. <br>Add and remove row grouping and column grouping<br> Add row grouping: Click the "Group row" input box in the "Summary" on the left side of the page, and add report row grouping fields to filter data after searching the field or scrolling the drop-down field list and then selecting the target field. <br> Without adding column grouping, you can add up to three row groupings. <br> Add column grouping: when row grouping exists, you can add column grouping. Click the "Group Column" input box in the "Summary" on the left side of the page, select the field after searching or scroll the drop-down list of fields and select the desired field Ways to add report column grouping fields to filter data. <br> You can add up to two column groups. In the case of adding column groups, you can add up to two row groups. Fields added as row groups cannot be added as column groups. <br>`,
"label.notification.event1":`【分配人】 assigned you a event`,
"chatter.field":`Field(s)`,
"chatter.feed.menutype.feed.newscom":`All I Follow`,
"label.attendance.range":`Attendance Range`,
"vue_label_calendar_deleteconfirm":`Are you sure to delete calendar {name}`,
"label.ems.createTask":`New {taskName}`,
"label.visualpage.wgd":`Unfiled Custom Pages`,
"label.multilang.product.deleterederect1":`Your attempt to delete <font style="font-weight:bold;">{0}</font> could not be completed because it is still associated with the following record. In this case, we recommend disabling it.`,
"label_emailtocloudcc_filed_servertype":`Email Server`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname submits #objAPIName#recordname for your approval`,
"label.tabpage.queue":`Queue`,
"label.approval.step":`Approval steps`,
"label.approvaldatamove.approvalprocessname":`Process Name`,
"label.actualapprovedpeople":`Actual Approver`,
"label.systemlog.f":`FAILURE`,
"front-template-V1-addText":`Add Text`,
"label.chat.like":`Like`,
"label.userinfo.oldpwd.notnull":`Old password can not be empty.`,
"label.service.all.done.major.event":`You have completed all milestones.`,
"label_chatter_to":`To`,
"message.toomuchlinecannotoutput":`Too many report columns are selected and the report cannot be output.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`The maintenance plan has been assigned to asset. Please do not to assign repeatedly.`,
"lable.quote.syncing.firstsync.description":`Quote line items will replace opportunity products`,
"lable.outlook.mcto.saveemail":`Be sure to save the email attachments`,
"label.passwordPolicy.setup.pwdremember2":`2 passwords remembered`,
"label.project.hit.five":`Task Update Notice`,
"label.linkedin.setting.appid":`Secret Key`,
"label.dataimport.error.name.notnull":`Error: name cannot be null`,
"label.knowledge.case.field.selected":`Selected Case Fields`,
"label.version.datetime":`{0} date/time fields`,
"Dashboard_NoAccessRightToSee_Warning":`You have no permission to view the dashboads {0} which are set as defualt open, please reset.`,
"label.login.access.permission":`Grant Access To`,
"label.operatedata.import.tip":`1. The imported file must be a file in CSV format. The file must contain a title and cannot be imported without title. 2. It is recommended that you export before importing, collate the data you want to import for the data template with the export document, and then import.`,
"workflow.action.tasks.assignortype.rolename":`Role Name`,
"vue_label_account_quotations":`Transfer all quotations of the customer owner`,
"lable.account.CurrentCQ":`Current CQ`,
"label.user.database.error":`Database error!`,
"label_emailtocloudcc_titel":`Email to CloudCC`,
"label_file_content":`Text content`,
"label.button.behavior":`Behavior`,
"message.recordtype.new.tip":`Enter the details`,
"label.ccchat.message.new.error3":`Error: You cannot select more than 9 recipients`,
"vue_label_commonobject_notice_lessthanwords":`The file name should be less than {FILE_NAME_COUNT} words!`,
"label.stacked.verticalline":`Stacked-Vertical Columns`,
"vue_label_SMS_messagebox":`Message Box`,
"label.appexchange.installedpage.message3":`</b>Depending on the links next to an installed package, you can take different actions from this page. To delete a package, click <b>Uninstall</b>. To manage package licenses, click <b>Manage Licenses</b>.`,
"label.unusedapproveprocess":`Inactive Approval Processes`,
"label.onlywithspecificconditions":`Only records meeting certain criteria should be included in the calculation`,
"lable.outlook.mcto.formaterror":`Format error`,
"label.area.parent":`Parent Territory`,
"vue_label_chat_activesuccess":`Activated successfully`,
"label.setting.intergrationlist.button.upgrade":`Upgrade`,
"label.page_hidden":`Hiden Fields for Registration Page`,
"label.customsetting.manage.belong":`Setup Owner`,
"label.appointment.wizard.subtitle4-2-8":`7 Days`,
"template.chart.ydywjhxsje":`Monthly Business Opportunity Sales Amount`,
"label.multilang.currencylist.after":`After {0}`,
"vue_label_commonobjects_view_chart_countby":`Count By`,
"label.week":`Week`,
"label.emailtemplate.name":`Template Name`,
"label.umeng.sign":`signed in`,
"label.appupload.upload.details":`Details`,
"label.file.loading":`Loading`,
"label.newdetail.orgTitle":`Contact Roles`,
"label.salescloud.field.addoptionlist":`Add Picklist Values`,
"pagecreator.page.funcpath":`/ builder / page list`,
"Account.News.Setting.001":`Account Settings`,
"label.marketsea.getnoconversiondays":`Days not converted (must be more than the number of days without follow-up after obtaining)`,
"message.error.event.add":`New event anomaly`,
"front-electronic-export-choseChimp":`Please select the exported Mailchimp list`,
"vue_label_report_personothers":`Others`,
"label.hierarchy.diagram":`Hierarchical Structure`,
"label.stdashbord.xsld.business.yqsr":`Expected Revenue`,
"label.chat.topic.max.count":`You have reached the maximum number of topics.`,
"label.sendemail.send.sendfail":`Email sending failed, please contact your administrator.`,
"registration.page.body.title":`Registration Page`,
"label.userphoto.back":`Back`,
"label.service.without.timeslot":`There doesn't seem to be any time slots, let's add!`,
"label.processsetting.remaining.quantity":`Up to 255 characters can be entered, remaining:`,
"label.sure.delete":`Confirm to delete`,
"front-epwechat-module-v1-callback":`Callback Configuration`,
"front-email-payment-failed":`Sorry, payment failed!`,
"label.icon.67":`Machine`,
"UG_Forcast_01":`Forecasts`,
"label.escalation.setup.newentries.step3":`Step 3 Specify how escalation times are set`,
"lable.account.NextCY":`Next CY`,
"report.type.label.quote":`Quotes`,
"label.area.name":`Territory Name`,
"component.setup.label.object":`Objects`,
"label.customsetting.type":`Setting Type`,
"label.showdetail":`Show Details`,
"label.department.prev":`Previous Page`,
"label.select.data.source.report":`Please Select Data Source Report`,
"UG_homepage_002":`Manage your clues, leads, sales transaction funnels, and account information with integrated business tools`,
"vue_label_report_notice_exprot1":`Only the detail rows are exported. Use this data for more calculations or upload to other systems. Paged export, up to 5000 items on one page`,
"message.error.task.phonecreate":`Phone task creation anomaly`,
"label_chatter_day":`Day`,
"label.setinitialcommiter":`Step 6 Specify Initial Submitters`,
"message.huanxinconfig.notfound":`Easemob configuration is not found`,
"label.customfields.file.count.tip":`Please enter the number of files that can be entered in this field, the default is 1`,
"label.weixin.appmanage":`App Management`,
"label.approverautoconfirm":`Automated Approver Determined By`,
"vue_label_CCChat_followers":`Followers`,
"label.usermanage.notselect":`No users are selected.`,
"label.item":` item(s)`,
"label.sendemail.chat.linkurl":`The URL of link:`,
"label.sendmail.step3.deliveroptions":`Delivery Options`,
"homepage.components.creationtime":`Created Date`,
"label.pc.ui.2018.ccchat.setting":`CCChat setting`,
"label.knowledge.search.result.highlight":`Highlight Relevant Articles in the Search Results`,
"label.data.downpage.e.title.num2":`2、If you choose to export data of a single object, you need to select how the data is exported:custom export, export by template and export template.`,
"label.field.duplicate.error.msg1":`Here are duplicated data, please check the duplicated first, and then setup unique property.`,
"label.campaign.channel.input.number.error":`Number format error`,
"label.goto.dashboard":`Go to Dashboards`,
"com.cloudcc.login.error.message.invalid.ip":`Your IP is not in the IP range.`,
"label.selectnewfieldvalue":`Specify New Field Value`,
"label.appointmentdetail.wizard.title11":`End Date`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Start Date of Current Stage`,
"front-dynamiclayout-module-v1-readonly":`The field of {required} is set as Read Only.`,
"vue_label_calendar_start_field":`Field for Start`,
"label.weixin.recalculate.shared.failed":`Object sharing rule recalculation failed.`,
"label.sendmail.step3.dealoptions":`Processing Options`,
"setup_layout_label_modifypage":`Edit Page Layout`,
"homepage.components.select.wide":`Select Wide Components to Show`,
"label.import.page1.laststep":`Previous`,
"label.weixin.donot.permission":`You do not have permission to perform this operation.`,
"message.error.name.null":`name cannot be empty!`,
"label.salescloud.teamrole.optionlist":`Team Role Picklist Values`,
"component_setup_label_titlefield":`Title field`,
"vue_label_commonobjects_detail_have_been":`You have been`,
"label.textmessage.vonage.setup":`Vonage Setup`,
"label.recordtype.profile.enableit":`Activate for Profile`,
"UG.product.04":`Create product`,
"label.knowledge.No.related.articles":`No related article...`,
"label.chat.muted":`Do Not Disturb`,
"registration.page.field.selection":`Select Field for Registration Page`,
"label.project.hit.eleven":`Issue Assignment Notice`,
"lable.newtabpage.advsearch":`Advanced Search`,
"label.report.share.roleandsub":`Roles and internal subordinates`,
"component.salesperformance.label.nodata":`Add your business opportunity and return here to view the performance graph.`,
"label.submitted_on":`Submitted on`,
"label.file.create.link":`Create link`,
"label.contact":`Contacts`,
"label.tab.message.failtoopenleft":`The merge operation failed to open the left column`,
"label.replaces":`Replace`,
"label.customcomponent.check.tag.startwith":`Component must begain with the label &lt;cc:component&gt;.`,
"label.tab.web":`Web Tabs`,
"message.success.task.add":`Successfully save the new task information`,
"label.chatter.addresser":`Sender`,
"label.mobile.homepage":`Homepage`,
"label.data.imp.su.ok":`Importing`,
"label.knowledge.category.hint.one":`Category group is the hierarchy of data categories. For example, a category group named as "Location" may contains the geographical hierarchy of continent, country, region and state. Use this page to manage category groups and sub-categories.`,
"label.schedulejob.setup.schedule.weekly":`Weekly`,
"label.tag.manage.description":`All the tags of {0} are as follows. You can rename or delete available tags.`,
"label.tabcontrol":`Tabs`,
"label.field.duplicate3":`Consider "ABC" and "abc" as duplicate values (case insensitive)`,
"label.customsetting.type.list":`List`,
"lable.account.ovdate":`Fiscal Quarter End Date`,
"label_chatter_pastSevenday":`The past 7 days`,
"front-kefu-moudle-v1-lxndxsdb-free":`Please contact your sales rep and enable free agent servicer`,
"label.termsforusage":`Terms of Use`,
"label.forecast.settings.qijian.m":`Month Forecast`,
"label_tabpage_viewname":`View name`,
"label.report.action.addtodashboard1":`Add to Dashboard`,
"label_vue_create_edit_obj_create_event_dialog_desc":`The user you assigned is already engaged in schedules:`,
"vue_label_report_standardfilter":`Standard Filter`,
"label.umeng.approval.submit":`#applyer submitted a record #obj for approval.`,
"label.tab.mobile.sign":`Icon on Mobile`,
"vue_label_commonobjects_detail_check_the_content":`There is a verification error, please check the content`,
"UG_Campaign_001":`Planning campaigns`,
"chatter.group.baseInformation":`Basic Information`,
"label.sendemail.send.noreceiver":`No recipient or recipient address is empty.`,
"template.chart.yskje":`Receivable Amount`,
"label.textarea":`Text Area`,
"vue_label_statistics_value":`Statistical Value`,
"font-evaluate-module-v1-select-img":`Select Image`,
"label.totalof":`You are a total of`,
"label.hangye":`Industries`,
"label.partner.common.setup":`Common settings`,
"label.icon.78":`Agriculture`,
"lable.outlook.detail.addemail":`Add Email`,
"label.ServiceCloud.fuwuquyu":`Service Territory`,
"label.gb2312encoding":`Chinese (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 min`,
"label_emailtocloudcc_reauthorization":`Reauthorization`,
"label.approval.message":`Approval opinions can be entered up to 1000 characters.`,
"label_component_helper":`Assistant`,
"label.editRate":`Edit Exchange Rate`,
"label.setuptemplate":`Automation Templates`,
"label_emailsync_button_cancel":`Cancel`,
"label.marketseamemset.account.maxuser":`Maximum number of accounts`,
"label.someerror":`For security reasons,your CloudCC session is about to run out of time.<br><br>What are you going to do next?`,
"label_person_in_charge":`Supervisor`,
"label.visualpage.reference.standard.style":`Invoke the standard style of Platform, customize-custom style`,
"errormessage_email_relatedorreceivermusthaveone_z":`You must select one recipient or a related subject at least.`,
"label.insert.field.empty.continue":`Records with void value of 【{resDataField}】 exist, so the code cannot be generated. Do yo want to continue generating?`,
"component.newrecords.label.title":`Recent Records`,
"template.detail_info_link":`Details Link`,
"component_setup_tabs_label_default":`Default page`,
"label.emailobject.template.name.null":`Mail template name cannot be empty！`,
"label.knowledge.field.changed":`{1} is changed`,
"homepage.components.select.narrow":`Select Narrow Components to Show`,
"label.mobile.phone.week":`Week`,
"component_chatter_button_like":`Like`,
"label.brief.won":`Won`,
"label.setup.profile.replaceme":`Replace the things about me`,
"label.knowledge.setting.enable.lightning":`Activate Lightning Knowledge`,
"label.middle":`Medium`,
"label.icon.109":`People`,
"vue_label_normal_activity_sf":`Activity`,
"chatter.poll.option6":`Choice 6`,
"label.lanxin.setting":`Integrate Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Total Opportunities`,
"label.emailobject.emaildetail.promptbutton1":`Confirm`,
"Opportunity.Detailed.Phase.Label.001":`Stage`,
"label.customcomponent.params.info":`How to use parameters.`,
"label.emailtocloudcc.button.next":`Next`,
"front-email-payment-billing-date":`Invoice Date`,
"label.ems.with3day":`Within 3 days`,
"label.project.subtask.date":`The sub-task date must be within the date range of the task to which it belongs.`,
"label.role.allunselectanduseduser":`All Unassigned And Active Users`,
"front-kefu-moudle-yes-wantbuy":`Yes, I Want to Purchase`,
"label.looking_for":`Did you get what you were looking for?`,
"page.404.label.noresource":`Sorry, the resource you want to access does not exist.`,
"vue_label_ccchat_notice_deletecommentcertification":`Are you sure you want to delete this comment?`,
"label.data.setok.e.desc1":`Export success, you will receive a system message alerts,derived data is temporarily stored in the server, the system only for you to save 48 hours, please as soon as possible to`,
"label.weixin.confirm.delete":`Are you sure you want to delete this data?`,
"A":`Text Area (Rich Text)`,
"template.report.sales.cycle":`Sales Cycle Duration`,
"label.service.shift":`Work Shifts`,
"label.visualpage.display.side.bar":`display sidebar,false-do not display sidebar`,
"label.list.userinterface.chatter.showall":`CCChat Homepage shows all posts by default`,
"vue_label_systemSettings_set_course":`Set up the path by adding tips for each stage to guide users step by step.`,
"label.icon.156":`People`,
"label.marketsea.button.move":`Move`,
"front-email-payment-select-email":`Please enter the Zip Code`,
"front-electronic-signature-service-provider":`Service Provider`,
"label.h5.add.checkin":`Check in`,
"vue_label_amount_total":`Total Amount`,
"label.campaign.channel.new":`Campaigns: New Marketing Channel`,
"label.knowledgebase.restore.creates.draft":`Restore will generate a draft from the current version. You need to publish the draft for all to see.`,
"UG_Case_01":`Case`,
"label.validate.function.funcExplain.CONTAINS":`Check if the text contains a specific character, and if so return TRUE, otherwise return FALSE`,
"label.data.exp.savetemp":`Save as Template`,
"front-project-module-v1-template-newcreate":`Create Project from Project Template`,
"label.field.default.count":`Default Rows Number`,
"page.note.acc":`Notes`,
"label.close":`Close`,
"label.app.detailbeforeedit":`Custom app details below. Click "Edit" to modify custom apps.`,
"label.profile.standardfieldsafety":`Security Settings (for standard objects)`,
"vue_label_report_notice_deletefilter":`Please delete the advanced filter first`,
"label.multilang.datamoveaction.movesuccess":`A total of {0} records have been transferred successfully!：`,
"label.emailmerge.edittemplate.descirption":`Enter information about your mail merge template.Note that the description displays in CloudCC.com only, not in Word.`,
"label.visualpage.at.the.end":`Use the tag at the end`,
"label.exchange.sync.state":`Exchange Sync State`,
"label.newdashboardpage.new":`Add a Line`,
"label.querydetailservice.profile.notsetup":`The profile for your account is not set.`,
"label.escalation.setup.detail.description":`Add rule entries that specify the criteria used to escalate cases. You can reorder rule entries on this page after you create them.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Enable H5 creating and editing on mobile`,
"vue_label_file_upload_tip_msg":`We recommend recommend that the uploaded file is less than 30MB, otherwise it may cause the page to load slowly`,
"label.eowechat.epdeptid":`WeCom Department ID`,
"label.adminorapprover":`Administrators <strong>OR</strong> the currently assigned approver can edit records during the approval process.`,
"label_emailtocloudcc_email":`Email`,
"setup_main2018_label_norole":`You do not have the administrative permissions`,
"label.onlyone":`Unique`,
"label.sso.saml.idp.config.nameidtype":`Subject Type`,
"vue_label_normal_campaign_sf":`Campaigns`,
"label.icon.61":`Crane`,
"label.datatype":`Data Type`,
"label.mobile.home.page.today.work":`My Jobs`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat liked your comment`,
"chatter.sel.p":`0 selected.`,
"label.b_c":`B to C Relation`,
"label.tabcontrolnameandtaglib":`Tab Names and Labels`,
"label.globaloperation.tip":`Create, edit and view global operation, which can be used for detail pages.`,
"R":`Record Types`,
"label.initcommiteoperate":`Initial Submission Actions`,
"front-kefu-moudle-v1-Operation-without0-permission":`No permission to operate this record, please contact the administrator`,
"button_partner_create":`New`,
"label.document.name.length.cannot.than":`The length of the document name cannot exceed 255 charecters.`,
"label.area.donot.delete":`Cannot delete this territory, because the current territory has a sub-territory.`,
"label.currency.activation":`Activate`,
"label.connect":`&Concatenate`,
"button.partner.viewdetail":`View`,
"setup_object_field_dependency_label_mustsetup":`Please setup the field dependency first and save.`,
"label.SalesCommitmentKanBan.task":`Receivables Task Amount`,
"lable.quote.syncing.finishbutton":`Done`,
"label.weixin.group.type":`Access type`,
"vue_label_commonobjects_detail_relationship":`Degree of Relation`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Available Field Values`,
"label.sso.lookAtTheKey":`View Key`,
"UG.opportunity.008":`Opportunity Team`,
"label.customfields.new.step1":`Step 1 Choose the field type`,
"lable.qrcodeOrbarcode.rule":`Generate QR Code/Bar Code Rules`,
"vue_label_notice_nopermission_delete":`Sorry you don't have the access to delete this record, please contact the administrator.`,
"label.customerobj.tab":`Custom Object Tabs`,
"com.cloudcc.login.error.message.nolicens":`The license does not exist`,
"label.sendsms.batch.confirm":`Batch SMS: Confirm`,
"label.forecast.settings.sos":`Revenue and Quantity`,
"label.calendar.addevent.notice.opencalendarfirst":`Please open my calendar or other calendars before adding events`,
"message.success.task.phonerecord":`Save phone records successfully`,
"label.knowledgebase.create.new.subtab":`New Sub-tab`,
"label.knowledge.article.recordid":`The ID of knowledge article cannot be null`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Days in Current Stage`,
"homepage.layout.nowpage":`Existing Page Layout`,
"template.chart.khslph":`Number of Accounts Ranking`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`You cannot delete the service resource for it has been assigned a service appointtmen. You can disable this service resource.`,
"label.email.only.display.info":`Only contacts or colleagues with stored email addresses are displayed in the box below`,
"label.weixin..xsld.yjhtje":`Expected Contract Amount`,
"label.permission.delete.permsets.error.prompt":`The permission set can't be deleted because it has users assigned to it.`,
"label.ccchat.enter.two.choices":`Please enter at least two choices`,
"label.edit.field.select.style2":`One option per line`,
"vue_label_email_please_enter_email_subject":`Please enter email subject`,
"batch.sendemail.f":`, mail failed.`,
"label.sms.senderr":`SMS sending failed`,
"label.batchadd.newbatchpage.save.em":`Invalid email format`,
"label.icon.96":`Compass`,
"message.recordtype.deleterecord.tip":`Use this page to replace all existing pecord types with new record types. Select the record type below to repalce any records that contain the deleted record types. If you just want to delete the record type from an existing record types without replacing it with a new record type, please select "None".`,
"label.field.edit.max":`Maximum Score`,
"label.partnerCloud.orderingPlatform.preferential":`Discount`,
"label.callcenter.login.later":`Log in Later`,
"batch.change.owner":`Please select the owner`,
"label.version.allow.upload.size":`edition,maximum allowable upload file`,
"setup.mainpage.label.welcome17":`Permission settings`,
"label.tag.sectionname":`Tag Information`,
"label_partner_workspace_setup":`Settings`,
"label.managecontrol":`Administrative Permissions`,
"label.timetrigger.condition":`Evaluation condition is set to each time the record is created or edited.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Week`,
"front-verkoop-bywerking-error":`Update failed`,
"label.allowcommittercallback":`Allow submitters to recall approval requests`,
"vue_label_commonobjects_detail_lead_finishistatus":`Mark Status as Complete`,
"message.error.object.lookupmd":`Mater-Detail Relation Field is created in this object`,
"label.stdashbord.xsld.business.img7":`Number of Stages with Probability 0% / (Number of Stages with Probability 100%   Number of Stages with Probability 0%)`,
"label.checkruleofevent":`Event Validation Rules`,
"front-epwechat-module-v1-single":`Single Sign On`,
"label.tabpage.save":`Save`,
"label_emailtocloudcc_search":`Search`,
"label.tianyancha.h5.registeredPlace":`Registered place(shortening)`,
"label.field.addoptionlist":`Add Picklist Value: Picklist`,
"label.schedule_anotherpost":`Plan other Posts`,
"label.customfields.searchrelation.tip":`Create a relation that links this object to another object. The relation field allows users to click on the Lookup icon to select a value from the popup list. The other object is the source of the values in the list.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Account Topup`,
"label.projectManagement.view.details":`View details`,
"label.sendemail.chat.praiseFeed":`Dear #name:\n\n hello! #userName liked your micropost.`,
"label.validate.function.category.Text":`Text`,
"component.task.label.newevent":`New Task`,
"label.data.import.setup.operate":`What do you want to do if you find the existing record?`,
"label.salescloud.salesdashboard.clear.option":`Clear Options`,
"lable.account.PreviousCY":`Previous 2 CY`,
"label.appointment.wizard.subtitle8":`Company Name Visible for the Invitee`,
"label_emailsync_status_viewlog":`View Log`,
"message.duplication.label.filtertitle":`Find Duplicate Filters`,
"label.custom.quarter.description":`This page allows you to define and edit custom quarter. The date of the custom quarter will be generated based on the choices you make below.`,
"label_tabpage_filenamez":`File name`,
"lable.currencyAdv.andbefordate":`and before`,
"label.version.nonsupport.sharerule":`Sharing Rules are not supported temporarily.`,
"front-epwechat-module-v1-unbound":`Unbind`,
"label.division":`Division`,
"label.data.import.setup.repeat":`Do you want to prevent duplicate records from being created?`,
"label.callcenter.makesure.Amazon.connect":`Note: Make sure you have created an instance of Amazon Connect`,
"label.version.lead.control":`Lead Management`,
"label.copying.reward.groups":`Clone Quote Line Group`,
"#label.severalorone":`Zip or individual file#`,
"label.mailinginfo":`Mailing Address`,
"component.telerecord.label.title":`Log a Call`,
"label.godocumentlist":`Back to List: Documents`,
"APPIntegration.Dropbox.setting.01":`Enable`,
"label.tianyancha.website":`Website`,
"label_tabpage_greaterequalz":`Greater than or equal to`,
"vue_label_campaign_influencedopportunity":`Influenced Opportunity`,
"message.save.param.null":`Parameter is empty, save failed`,
"front-epwechat-module-v1-domain":`Trusted Domain NameJSSDK：`,
"label.allowreport":`Allow Reports`,
"label.service.major.event":`Milestones`,
"label.import.index.selectobjectandfiles":`Select Object and File`,
"label.chatter.task":`Task`,
"label.knowledge.setting.hint.twelve":`Enter Data Category`,
"lable.account.CurrentandPreviousFY":`Current and Previous FY`,
"label.martrixreport.step3":`Step 3 Select the summarized data`,
"front-console-select-cases":`The case number selected cannot exceed 10`,
"label.partnerCloud.partnerAccount.backHome":`Back to Homepage`,
"label.me.assign":`Assigned By Me`,
"label.appointment.wizard.subtitle3":`Meeting Time`,
"label.edit_columns":`Edit Columns`,
"label.partnerCloud.orderingPlatform.useRebates:":`Use Rebate:`,
"label.projectManagement.enter.up.to.10.digits":`Up to 10 digits can be entered.`,
"label.integrations.description.mailchimp":`By integrating CloudCC with Mailchimp, you will be able to import selected leads and contacts from your CloudCC account to Mailchimp and send the email to the intended recipients.Your users will also be able to track results in Mailchimp.`,
"label.ccchat.person.error.requiredomain":`Error: At least one domain required`,
"label.projectManagement.Pleaseselectitem":`Please select project`,
"label.netaccess":`Network Access`,
"vue_label_SMS_searchobject":`Search Object`,
"label.role.viewintree":`Show in tree view`,
"lable.SalesCommitmentKanBan.accountName":`Account Name`,
"label.please.contact.your.administrator":`Please contact the administrator to activate the rules for generating QR code/Bar code`,
"label.sso.saml.sp.idenitysource":`SAML Identity Location`,
"label.queue.delete":`Delete`,
"label.service.miniProgram.jumpLink":`Jump link`,
"label_set_ forecast_scope":`Set Forecast Range`,
"label.weixin.success.sign":`Has successfully signed in,please know.`,
"front-dialog-module-v1-error-code":`Error Code`,
"label.projectManagement.nodata.problem":`Great! No tricky issues need to be solved.`,
"label.myhomepage":`My Homepage`,
"label.exchange.sync.state.task.m1":`Last Synced activity:`,
"label.pw.config":`Please confirm your password`,
"front-console-new-contact":`New Contact`,
"label.customfields.fielddependency.editexplain":`<li>Double click on a cell to toggle its visibility for the Controlling Field value shown in the column heading.</li><li>To change multiple cells at once, select multiple cells and then click the Include Values or Exclude Values button to change the visibility of all selected cells at once.</li><li>Use SHIFT   click to select a range of adjacent cells. Use CTRL   click to select multiple cells that are not adjacent.</li><li>Use the Preview button to test the results.</li>`,
"setup_mainpage_label_welcome7":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Object → Object Name → Custom Field.`,
"message.validation.sum":`There are too many fields shown on the approval page, you can select up ti 190 fields.`,
"label.knowledge.attach.case":`Attach to Case`,
"front-electronic-signature-custom-field-type":`Custom Field Types`,
"vue_label_pricebook_activated":`Price list is activated`,
"vue.schedule.pre":`This is my schedule, please`,
"Lead_Tools_BatchScoring":`Batch Score Leads`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filter By`,
"label.report.no.recently":`No recent record.`,
"label.service.gantt.dangerous.sum":`Number of service appointments in danger.`,
"label.main.field":`Primary Field`,
"label.weixin.optionfive":`Choice 5`,
"homepage.wide":`Wide (Right) Column`,
"vue_label_notice_confirmdelatehomepage":`Are you shure to delete homepage?`,
"vue_label_report_exportpages":`Export pages: No.`,
"label.select_compaign":`Choose a Campaign`,
"attachment.button.massdownload":`Batch Download`,
"label.chatter.incident":`Event`,
"label_partner_new_step1":`Step 1 Select the template you like`,
"button.partner.workspace.saveas.memo":`Save the current partner cloud as a "template."`,
"vue_label_pricebook_edit":`Edit Price List`,
"label.weixin.privacy.rights":`Privacy Permissions: Approximate location(web-based),Precise location(GPS).`,
"label.please.codeType":`Please choose code type.`,
"label.approveorrefuserequest":`Approve / Reject`,
"message.error.sharemember":`The passed sharemember cannot be empty, please check the passed parameters!`,
"label.file.folder.edit":`Edit Folder`,
"label.data.import.setup.repeat.yes":`Yes-Prevent duplicate records from being created. Note: If want to update an existing record, you must select this opition.`,
"label.approveBeforeTheOperation":`Actions before Approval`,
"vue_label_file_already_checked_file":`{CheckedWork} files have been selected, up to 10 files can be added at a time`,
"vue_label_hidden_record_count":`Hide Record Count`,
"UG_product_01":`List products/services`,
"label.tabpage.clearoptionsz":`Clear advanced options`,
"label.partnercloud.num.overstep":`Maximum number of partner cloud exceeded.`,
"label.tianyancha.businessverify.msg8":`At present, this function only supports querying enterprises registered for business in china mainland, and it has certain delay.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Lead Insight`,
"label.emailtocloudcc.email":`Email`,
"vue_label_pool_highcost":`High product cost`,
"label.callcenter.enterprise.configuration":`Please copy the key pair in Enterprise ConfigurationSystem Interconnection in Tianrun's system`,
"label.view.edit.search.prompt":`Please enter the keywords`,
"label.ems.sms":`Send A Text`,
"label.emailobject.list.new":`Compose`,
"label.salescloud.forenableteamsales":`Enable Sales Team`,
"pagecreator.systemstyle.funcpath":`/ builder / branded style library`,
"label.partnerCloud.basicSetting.domain":`Toplevel domain cannot be empty`,
"label.projectManagement.Posttask":`Post-task`,
"label.tianyancha.businessverify":`Enable business data verification`,
"label.tianyancha.h5.info":`Basic information`,
"september":`September`,
"chatter.poll.option9":`Choice 9`,
"label.department.firstpage":`It's the first page`,
"label.reportsSubscriptionPage.condition.button":`Add Condition`,
"label.exchange.sync.state.task":`Tasks`,
"pagecreator.layout.button.splitall":`Split all`,
"vue_label_calendar_please_select_the_start":`Please select the field for start`,
"label.tab.message.failtogettop":`Failed to get the top tab`,
"label.sharerule.organizationscopesetshare":`Organization-Wide Defaults`,
"label.delete.rules":`Delete Rules`,
"label.recordtype.tabname.detail":`Click "Edit" to change the properties of this record type. Select the available picklist values for this record type by clicking edit link in the picklist values related list.`,
"label.knowledge.setting.hint.ten":`Uncertain of the orgnization mode? No problem. You can execute later.`,
"vue_label_norm_undone":`This operation cannot be withdraw`,
"label.trigger.line":`line:`,
"lable.info.queue.reason":`Reason For Becoming A Member`,
"label.validate.function.funcExplain.HOUR":`Reutrn Returns hour of day(From Date/Time fields), ranging from 0 -11`,
"label.update.document.content":`motified the document content`,
"lable.Existing.template":`Available Templates`,
"label.summaryreport.step3":`Step 3 Select the grouping method of summarized data`,
"label.emailmerge.list.filetype":`Document Type`,
"label.customfields.helptext.tip":`The text is displayed in the detail page and edit page when the user hovers over the information icon next to this field.`,
"label.setting.intergrationlist.description":`CloudCC integrations allow you to view and share data between business applications without leaving your CRM. Some of the integrations, like QuickBooks and Zapier, require permissions to make them available to your users. Other integrations, like Gmail, Outlook may be configured by each individual user on their own account.`,
"component_milestones_label_title":`Milestones`,
"label.custom.AntiRevocation":`Cancel Undo`,
"label.mobile.app.new.task":`Allow creating tasks and events on mobile App`,
"vue_label_opportunity_related_chooseproduct":`Choose at least one product`,
"label.standardguest":`Standard Guest`,
"label.icon.125":`Instrument`,
"label.skipsomeset":`Because this is the Jump Start Wizard, CloudCC automatically chooses some settings for you.`,
"label.forecast.shrepage.fmanager":`Forecast Manager`,
"label.mobile.quickcreate.default.work":`Office`,
"label.projectManagement.nodata.team.members":`Cannot find My Project Member`,
"label_social_media_account_settings":`Social Media Account Setup`,
"UG.quota.05":`Bisync with Opportunities`,
"label.partner.workspace.tab.selectedoption":`Selected tabs`,
"front-kefu-moudle-v1-clientID-reinput":`Please enter clientID`,
"label.mobile.home.page.contract.value":`Expected Contract Amount`,
"december":`December`,
"label.campagin.roi.dcrs":`Attendance`,
"label.currency.edits":`Currency Edit`,
"label.currency.company":`Corporate Currency`,
"label.customfields.newformula.nogrammererror":`No syntax errors in merge fields or functions.`,
"label.version.nonsupport.api":`Interfate API is not supported temporarily.`,
"label.data.file.i.title.num2":`2. It is recommended that the data be exported when the data is imported, so that the export document is used as a template to collate the data to be imported, and then import. (If the imported data contains a comma, replace it with the @ symbol.)`,
"front-console-conversation-title":`Service Evaluation`,
"front-kefu-moudle-call":`Call`,
"vue_label_systemSettings_pagefooter":`Footer Setup`,
"label.newRule.successfully.added":`New rules added successfully.`,
"label.trigger.direction.for.use":`Instructions for Platform Triggers [Version 2.0]`,
"label.instrumentPanel.maxLabelname":`This value should be greater than the minimum value, the breakpoint 1 value and the breakpoint 2 value.`,
"label.same.month.report":`YoY and MoM Report`,
"label.knowledge.language.american":`American`,
"label.paging.totalof":`A Total of {0}`,
"label.tianyancha.businessverify.enable.error":`Obtaining whether the verification of the business data is enabled fails, please contact the system administrator!`,
"vue_label_commonobjects_detail_email_template":`Use email template`,
"message.error.save.failed":`Save failed！`,
"advancedoptions":`Add Filter Logic...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Please select the layout and record type`,
"label.sendemail.recycle.operatesuccess":`you have successfully emptied your recycle bin, deleting #size data.`,
"J":`Text Area (Long)`,
"message.validation.isnotmail":`Please enter the invalid email address.`,
"label.timetrigger.before.lasttime":`1 hour earlier than Last Modified Date`,
"label.tabpage.arecordtypez":`Available record type`,
"label.reportoption":`Report Options`,
"pagecreator.button.next":`Next step`,
"assetbom.transferowner.notpermission":`You don't have the authority to transfer asset BOM. Please contact the administrator.`,
"label.toptitle.lightning":`Lightning`,
"label.copy.target":`Clone Indicator Value`,
"label.productsales.oppor.approach":`Impending Opportunities`,
"label.email.template.select":`Please select an email template.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`The lower bound for editing each level of discount is required.`,
"label.tabularreport.step3":`Step3 Define the column order in the report`,
"label.multilang.cchttpservice.signin":`Dear {0}, your invited guest {1} of {2} has been successfully registered.`,
"label.appexchange.uninstallpage.message3":`Permanently delete all data of the custom objects in this package`,
"label_tabpage_ownedz":`Totally`,
"label.tabularreport.2018.step2":`Step 2 Select report criterias`,
"label.object":`Object`,
"template.report.contracted.customers":`Industry Analysis of Contracted Accounts`,
"label.field.remark3":`Note that deleting a custom field will remove all filters that applied on the custom field. It may also change the result of Assignment or Escalation Rules that rely on the custom field data.`,
"label.eventview.issms":`SMS Notice`,
"label.knowledge.language.brazilian":`Portuguese (Brazil)`,
"vue_label_norm_viewfilter":`Apply a Filter`,
"label.forecast.settings.qijian":`Forecast Period`,
"label.startuploadfile.step.intruduce":`Click "Select File" to find the file and display the selected files in the lower region.`,
"label.smstemplate":`SMS Template`,
"vue_label_chatter_no_permission":`You do not have access to view this file`,
"label.callcenter.Incorrect.data.filling":`There is an error filling in the data`,
"label.tag.search.button":`Search by tags`,
"label.multiplyselectoptions":`Checkbox Options`,
"lable.outlook.detail.mutual":`Bidirectional Sync`,
"label.workflow.estimatecondition1":`created, and any time it's edited to subsequently meet criteria`,
"label.validate.globalvariable.user.profileId":`Profile ID`,
"UG.Campaign.003":`Create a campaign`,
"label.validate.function.funcExplain.ISNULL":`The expression is null and returns TRUE, Otherwise, it contains a value and returns FALSE.`,
"label.setting.intergrationlist.status0":`INTEGRATION STATUS`,
"label.copy_error":`Failed to copy`,
"label.connectOtherNone":`The selected object has no further relatable objects.`,
"label.bmap.beijing":`Beijing`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob is deleted. Please reconnect!`,
"label.wei.pollsubject":`Vote Subject`,
"APPIntegration_Social_twittererror":`You must enter a valid URL for twitter.com`,
"label.appupload.install.apicannotuse":`The api name is still not available`,
"label.returntolist":`Back to List`,
"label.translation.start2":`Select a setup component.`,
"lable.edit.queue.alter":`Select the objects you want to assign to this queue.`,
"label.campaign.channel.step3":`Step3: Select fields to display on marketing channel registration page`,
"label.data.newtemplate.e.seltype":`Select the data export method`,
"front-kefu-moudle-hangup":`Hang up`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Administrators and the forecast managers can share this forecast`,
"label.knowledgebase.mark.as.new.version":`Mark as New Release`,
"label.conditiontag.lookup":`Lookup`,
"label.import.page3.importsucceed":`Import successfully`,
"label.stdashbord.xsld.condtion":`Condition Settings`,
"label_emailtocloudcc_redmessage10":`The information has expired, please login again.`,
"label.event.moveup.1hour":`1 hour ahead`,
"label.chat.topic.page.add.favorite":`Save as bookmarked on CCChat page`,
"label.icon.88":`Advisory`,
"page_404_label_noresource":`Sorry, the resource you want to access does not exist.`,
"label.quickbooks.refresh":`Refresh`,
"front-kefu-moudle-which-getphone-case":`Rules for Creating Cases after Answering a Call`,
"label.objecttab.edit":`Edit Object Tab`,
"label.data.file.the.trigger":`Execute Trigger`,
"frame.personinfo.label.personimage":`Profile Photo`,
"label_tabpage_turnoffsz":`Turn off - converted`,
"label.sendmail.batch.chose":`Mass Email: Select Recipients`,
"label.data.downpage.i_title":`Data Import Steps:`,
"label.recycle.clearconfirm":`Are you sure?`,
"chatter.using":`This userd`,
"label.batchadd.newbatchpage.list":`Batch Add Data List`,
"pagecreator.systemstyle.button.new":`New style`,
"label.notification.serviceappointment.changestate":`Status of {1}{0} changed to{2}{3}`,
"label.weixin.weipollname":`Micro-poll Name`,
"label.tabpage.skip":`Skip to`,
"label.edit.field":`Edit Fields`,
"label.edit.new.rule":`Edit Generation Rules`,
"label.approved.receiveApprovalEmail":`Receive Approval Request Emails`,
"label.dashboard.refreshNow":`Refresh now`,
"label.lookup.introduce":`Please enter at least 1 character to fuzzy search.`,
"homepage.components.newdes":`Make sure the HTML code entered below is valid and well-formed. Writing inappropriate HTML code in a component ay cause the entire home page tab to display incorrectly.`,
"label.role.giveuserrole":`Assign roles to users`,
"lable.opppdt.selPbk.subtitle":`Price Book`,
"setup_mainpage_label_welcome19":`Instructions:  Click on the menu on the left side of this page → Manage Settings → Manage Users → Users, Roles, Profiles`,
"setup.mainpage.label.welcome22":`Instructions: Click on the menu on the left side of this page → Manage Settings → Newsletter Template → Email Template.`,
"label.tianyancha.h5.zipcode":`Zip code`,
"label_tabpage_allapplications":`All applications`,
"label.chatter.like":`Like`,
"label.licence.noremainder":`Insufficient number of licenses`,
"lable.outlook.edit.dataset":`Data Settings`,
"D":`Date`,
"label.detail":`Read`,
"label.globaloperation.operationtype.custom_page":`Custom page`,
"label.addattachment.down":`Download the file`,
"label.data.exportall.all_btn":`Export All Data`,
"label.recordtypeselect.current":`Current Record Type`,
"label.tabpage.entercusnamez":`Please enter the customer name`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`Next Week`,
"vue_label_report_everyday":`Everyday`,
"label.weixin.broadcasting":`Sending...`,
"label.input.search.string":`Please enter the searching string`,
"label.picandreporttype":`Chart Type`,
"label.setmulti":`Transfer multiple`,
"label.visualpage.component.t":`How to use components?`,
"label.knowledge.designate":`Only knowledge article with a status of Draft can be assigned.`,
"label.enable.barcode.only":`Only activate bar code`,
"vue_label_commonobjects_detail_a_group_strategy":`This data lacks owner and cannot create a Team`,
"setup.layout.group.button":`Buttons`,
"label.mini.layout.remark":`is the layout used in hovering window on page.`,
"setup.mainpage.label.welcome3":`Forms creation in the CloudCC cloud platform relies on custom databases (object), user-defined objects are database tables that store data specific to your organization. Table-to-table relationships can be easily established without any program development.`,
"label.knowledge.draft.status":`The post status of knowledge articles shall be Draft!`,
"label.manageAll.sel.one1":`Items to Approve`,
"label.campagin.roi.bhydkhywjh":`Quantity Of Closed-Won Opportunities`,
"label_partner_template_thumbnail":`Thumbnail`,
"label.loginip.setup":`Login IP Range`,
"label.data.downpage.e.title.e.btn":`Go to the Export Page and Start`,
"vue_label_appstore_project_management":`Project Management`,
"assetbom.delete.notpermission":`You don't have the authority to delete asset BOM. Please contact the administrator.`,
"vue.dashboard.setdrill.inThe":`subject to`,
"label.mobile.more.savephoto":`Save Photo`,
"label.customerinfo.PageTriggerFag":`Sync`,
"label.commonobjects.Nopermission":`Sorry, you don't have the permission to edit this data, please contact the system administrator.`,
"label.searchlayout.opperationtab.xsldfield":`The fields displayed when you click the Sales Funnel link on the opportunities tab home page.`,
"label.emailsync.form.disconnect":`Cancel Conncet`,
"label.document.nofile.upload":`No file upload.`,
"label.appointmentpage.wizard.subtitle3-3":`Phone`,
"message.custom.field.donotdelete":`Field is used and cannot be deleted.`,
"chatter.using0":`{0}ms has been used at this point`,
"label.tabpage.multiple":`Multiple choice`,
"label.attendance.setting.sy.alert":`You must select the suitable users for the attendance.`,
"label.refuse":`Reject`,
"label.log.button":`search by username`,
"component_chatter_link_label_title":`Link`,
"template.report.contract.collection":`Contract Payment`,
"label.campaignmember.selectmember.step1":`Step 1 Select campaign and campaign members status`,
"label.datamanage.warn.owner":`Warning: if you continue this import, all records will be imported with you as the record owner.`,
"label.a.b":`A to B Relation`,
"label.app.step3.homeisfrist":`Homepage must be the first.`,
"UG_Lead_003":`Social`,
"label.partner.workspace.member.choice":`Select profile`,
"lable.outlook.detail.emaping":`Map Event Fields`,
"label.service.appointmentList.gantt.chart.shows":`Show Date of Gantt`,
"label.mr.caption.account.result":`Find Duplicates and Merge: Results for querying duplicates of Accounts`,
"vue_label_chatter_approve_members_join":`Approve members to join the group`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Day`,
"pagecreator.systemstyle.label.modifycolor":`Edit color`,
"label.tabpage.yesz":`Yes`,
"label.fieldtoolongmessage":`Field exceeds limit`,
"lable.account.year.name":`Fiscal Year Name`,
"label.mini.layout":`Hover Layout`,
"label.icon.97":`Teaching`,
"vue_label_chat_smart_assistant":`Smart Assistant`,
"label.marketingmanagementuser":`Marketing User`,
"label_emailtocloudcc_description2":`Connect Your Enterprise Mailbox`,
"label.campaign.channel.input.name":`1.Please enter marketing channel name`,
"UG.homepage.007":`From sending follow-up emails to automating sales campaigns, from creating workflows using our Blueprint technology to triggering custom macros, automate daily tasks and focus more on building relationships.`,
"label.share":`Share`,
"label.step2.total6":`Step 2 of 6`,
"label.sendemail.chat.addComentspraise":`Dear #name:\n\n hello! #userName replied to the micropost you liked`,
"label.icon.20":`File`,
"label.service.gantt.absenteeism":`Absenteeism`,
"message.error.color.nagatice":`Number of current pages cannot be negative.`,
"chatter.group.applyToJoin":`Apply To Join`,
"pagecreator_layout_message_delete":`Do you delete the current selected layout?`,
"label.multilang.viewlist.count":`A total of {0} records：`,
"message.notdesable.type":`This record type cannot be deleted because the following profile uses this record type as the default value.`,
"label.standard.time":`Standard Time`,
"label_chatter_newpost":`Lasted post`,
"front-epwechat-module-v1-binding":`Bind WeCom`,
"label.recent":`Recent`,
"label.globaloperation.createfeeditem":`Create a summary project`,
"label_partner_common_roleNum":`Number of roles`,
"front-template-V1-quikSearch":`Enter field name and find`,
"label_tabpage_haschangedz":`This lead has been converted`,
"label.service.work.order.line":`Work Order Items`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`General Settings`,
"label.event.moveup.15minutes":`15 minutes ahead`,
"vue_label_all_selected_objects":`All`,
"label.visualpage.an.inline.style.relatedlist":`Embed custom page type to related lists`,
"label.umeng.approval.approvaling":`#applyer is requesting approval for #obj #objname #owner`,
"lable.SalesCommitmentKanBan.digital":`Digit`,
"label.appupload.img.max.size":`The image you uploaded is too large, the maximum size of image should not exceed 20K, please upload again.`,
"vue_label_normal_top":`Top`,
"label.knowledge.language.traditional":`Traditional Chinese`,
"homepage.layout.edit":`Edit Home Layout`,
"label.campagin.qrcode":`Campagin QR Code`,
"label.emailmerge.merge.emailmerge":`Email Merge`,
"label.icon.18":`Clock`,
"vue_label_homepage_taskview":`Task View`,
"label.search.related.record":`No records were found.`,
"label.report.reports":`Reports`,
"label.appointment.wizard.subtitle4-3-2":`15 min`,
"label.forecast.condition":`Forecasts Criteria`,
"label.westem.indonesia.time":`West Indonesia Time`,
"front-epwechat-module-v1-callback-desc":`Copy the following information to the backend of WeCom.`,
"label.version.group":`Team Edition`,
"label.allReportType":`All Custom Report Data Sources`,
"label.trigger.lastmodifydate":`Last Modified Date`,
"message.layout.unique.sectionfield":`The uniqueness constraint of the field in the page layout has been violated. Please check and save it again.`,
"vue_label_systemSettings_mobelbottonsetting":`Bottom Menu Setup for Mobile App`,
"label.recordtype.selectonefield":`Select one field at least that you want to add`,
"label.notification.group1":`【申请人】 is applying to join your public group`,
"component_todaytask_label_title":`Today`,
"label.assignment.setup.list.description":`Automatically assign leads to users based on criteria you define. You can create multiple rules with different conditions.`,
"label.project.resource.data":`This service resource has been assigned to a service appointment, please do not add repeatedly.`,
"label.emailmerge.newtemplate.file":`File`,
"label.notification.task1":`【分配人】 assigned you a task`,
"label.ServiceCloud.Overlapping":`Display Overlap Dispatchs`,
"label.globalselect.used":`The position of the use of field`,
"setup_layout_button_layoutprop":`Propertities`,
"label.quickbooks.retrivingdata":`Retrieving Data...`,
"component.button.ok":`Confirm`,
"message.pleaseinputformula":`Please enter formula`,
"label.h5.whatifollow":`Followed`,
"label.new.crew.target":`New Personnel Target`,
"label_chatter_task":`Task`,
"label.knowledge.setting.data.four":`A maximum of {count} categori groups can be selected.`,
"label.rule.not.enabled":`Disabled Rules`,
"label_in_scope":`Within the range`,
"label.partnerCloud.orderingPlatform.bundle":`Package`,
"label.emailtocloudcc.redmessage10":`The information has expired, please login again.`,
"label.knowledgebase.data.assignment.succeeded":`{a} data assigned successfully`,
"vue_label_commonobjects_view_nokanban":`No kanban view has been created yet`,
"label.knowledgebase.article.cancelled.attaching.case":`The article {name} has been canceled to attach to case！`,
"label.brief":`Summary`,
"label.version.sum.app":`applications`,
"label.commoninfo":`Common Information`,
"vue_label_SMS_nodata":`No data`,
"label.icon.153":`Information`,
"label.conditiontag.lookup.false":`FALSE`,
"label.emailobject.view.unread":`Unread Emails`,
"label.staticresource.useful":`Where is this used?`,
"label.ems.connect.test":`Test`,
"vue_label_chat_group_assistant_notification":`Group assistant notification`,
"label.multipleactivity.total":`A total of`,
"vue_label_report_addtocomponentlibrary":`Add to component library`,
"font-evaluate-module-v1-following-personnel":`Notify following users when receiving evaluation less than 3:`,
"label.setup.mobile.bottombutton.change.fail":`Failed to change`,
"front-epwechat-module-v1-unbound-item5":`and data cannot be retrieved, are you sure to unbind?`,
"label.customerinfo.smsUid":`SMS Gateway UID`,
"label.list.isOpenApprovalQueue":`Activate Approval Queue (not abvailable under Manual Select Approver)`,
"label.leadscore.setup.scorenumber":`Time(s)`,
"label.workflow.selectobj.introduce":`Select the object to which this workflow rule applies.`,
"label.visualpage.label.for.example":`Page labels such as:`,
"label.appointmentdetail.wizard.title17":`Thursday Plan`,
"label.projectManagement.timeFrame":`The start time and end time of the task should be within the time range of the milestone.`,
"lable.product.pricebooks.list":`Price Book is a product list with a special price and defined currency. Price Book can be set for multiple currencies. When entering a prodcut into a price book, the opportunities or quotes can only include products in a single price book. To edit the product in the price book, click the price booh name.`,
"font-trade-module-v1-delete-invoice":`Verify Invoice`,
"vue_label_salesadvance_winamount":`Gross Amount of Won`,
"component.salesperformance.label.nopermission":`To view business opportunity related data, contact your system administrator.`,
"vue_label_report_formatreport_desc":`Export the report with report headers, groups, and filter settings.`,
"label.enable.qrcode.only":`Only activate QR code`,
"label.smstemplate.edit":`Edit SMS Template`,
"label.qrcodeSetting.detailed.information":`QR code can store more data than bar code and linear scanning is not required. So QR code is widely applied including product tracking, item identification, documentation management, and marketing, etc.`,
"label.event.moveup.1week":`1 week ahead`,
"label.customize.memory.function.sorting.disable":`Deactivate Memory of Header Sorting`,
"label.icon.195":`Bathtub`,
"label.compact.layout.assign":`Key Information Layout Assignment`,
"label.icon.183":`House`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Integrate seat online chatting from Easemob to provide more comprehensive SaaS service.`,
"label.mycontact":`My Contacts`,
"label.tabularreport.2018.step3":`Step 3 Select report criterias`,
"chatter.group.uploadGroupPicture":`Upload Group Photo`,
"label.total.forecast.setup":`forecast at first and set it to be`,
"label.weixin.group.description":`Note`,
"label.edit_emailfooter":`Edit Email Footer`,
"label.ems.create":`New`,
"label.weixin.optionseven":`Choice 7`,
"font-evaluate-module-v1-continue-work":`Your evaluation encouraged us! We will continue efforts to do better!`,
"label.close.multilingual":`Deactivate Multilanguage`,
"component.chatter.post.button.user":`Add people`,
"label.use_QRcode":`Use QR Code`,
"label.operatedata.exportsuc":`The export is successful. Please view the email to get the download link. Please download your exported files within 48 hours. It is recommended that yo should delete the email that contains the download link of your exported files.`,
"label.page.step2.define.content":`Step 2 Define Content and Display Properties`,
"label_tabpage_groupingitem":`Grouping item`,
"label.customfields.placeholder":`Fill in the sample`,
"vue_label_commonobjects_detail_enter_subject":`Please enter theme`,
"label.multilang.workflow.everyotherdayinmonth":`{1} days every {0} months`,
"label.knowledgebase.data.archiving.failed":`{a} data archive failed`,
"vue_label_notice_nopermission_view":`Sorry you don't have the access to view this record, please contact the administrator.`,
"vue_label_calendar_calendar_view":`Calendar view`,
"lable.outlook.edit.des":`If an Exchange contact matches multiple CloudCC.com contacts, sync it with a CloudCC.com contact that meet the following criteria.`,
"label.custom.NextCQ":`Next CQ`,
"label.emailsync.form.stutas":`Status`,
"label.nameandintro":`Name and Description`,
"label.dashboardSetup.showdw":`Display Unit`,
"label.tianyancha.actualcapital":`Received capital`,
"front-kefu-moudle-info-delete-calluser":`The information has been modified, please contact the administrator`,
"label.emailobject.list.all":`All`,
"label.campaign.channel.step7.send":`Please select the users to recieve email`,
"label.formulafield.type":`Formula Return Type`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Thursday`,
"label.chosesubject.eat":`Schedule Dinner`,
"label.back":`Back`,
"label.h5.allcompany":`All cloud posts`,
"label.location.display.type.digital":`Digital`,
"label.datamanage.error.csv":`Invalid file format, the system only supports the common CSV format, please try again.`,
"label.emailobject.mark":`Mark`,
"setup_mainpage_label_welcome9":`Users can realize the classification display and layout adjustment of all page elements and the setting of read-only and required fields of the fields on the page by dragging and dropping the mouse without code development.`,
"label.icon.56":`Measuring Instrument`,
"label.forecast.edit.fwcd":`Range Length`,
"vue_label_email_Please_select_related_items_first":`Please select related items first`,
"label.icon.87":`Book`,
"label.knowledgebase.recovery.was.successful":`The recovery was successful`,
"label.emailobject.emaildetail.promptcontent":`Are you sure you want to delete this email？`,
"label.delete.role":`Delete Roles`,
"label.multiselect":`Picklist (Multi-Select)`,
"label.customerinfo.mailisnull":`No company email address set up.`,
"label.waitforamoment":`Page loading, please wait...`,
"lable.edit.queue.tip":`Enter the name of the queue and the email address to use when sending notifications (for example, when a case has been put in the queue).The email address can be for an individual or a distribution list. When an object is assigned to a queue,only the queue members will be notified.`,
"lable.custom.y.d":`This page allows you to define a custom year record. Dates for the custom year will be generated based on the choices you make below.`,
"chatter.feed.content.user.searchbutton":`Search`,
"label.data.downpage.i.list.desc3":`Users can view the reason of the import failed in the last column of the file after downloads.`,
"label.tag.manage.createdby":`Created by`,
"label.h5.similar.opportunity.last.months3":`Last 3 months`,
"chatter.group.members":`Members`,
"label.knowledgebase.data.translation.failed":`Translate {a] data failed`,
"label.log.look":`Check Settings audit clues`,
"label.service.gantt.week.timescale":`Time Scale on Week View:`,
"label.userLicence":`User License`,
"label.file.library.managemembers.permission":`Access`,
"label_emailtocloudcc_name":`Name`,
"label.mr.mrSuccess":`Merger complete`,
"vue_label_commonobject_view_notice_selectadd":`Please select the data to add`,
"vue_label_commonobjects_detail_level":`Level`,
"CloudCCCRM_ST_Info_TypeIn_001":`Please input`,
"label_chatter_list":`List`,
"label_tabpage_optionsz":`Options`,
"UG_homepage_008":`Understand current business status (sales briefings, leaderboards, sales funnels, etc.), view business opportunities that may be problematic, predict future performance, timely accept and assign important issues, and make informed decisions.`,
"label.myselfdashboard":`My Personal Dashboards`,
"label.globaloperation.operationtype.record_phone":`Record phone`,
"label.field.standard":`Standard Fields`,
"label.changemydisplay.appedit.check":`Overwrite personal settings of the custom app`,
"label.tianyancha.h5.legalpersonnames":`Legal representative`,
"label.tabpage.sorttypez":`Sort type`,
"label.newdashboard.folder":`New Dashboard Folder`,
"label.campaign.channel.step6":`Step 6: Generate marketing channel registration page`,
"label.ems.composeemail":`Send email`,
"label.app.step4.tabcanuse":`Available Tabs`,
"label.sendmail.batch":`Batch Email`,
"label.process.execute.title":`Pending`,
"lable.outlook.detail.lastup":`Last Updated`,
"label_emailtocloudcc_delete":`Delete`,
"lable.opppdt.selPdt.leastone":`Please select at least one row`,
"label.customfields.new.step2.opration.exid":`External ID`,
"label.assignment.setup.newrule.description":`Enter the rule name, and then select the enabled checkbox to use this rule for automatic assignment. Enabling this rule will disable the current assignment rule.`,
"label.campaign.channel.input.to.isactivity":`7.Active the marketing Channel`,
"label.document.return":`Back to Documents`,
"label.data.downpage.i_title.num5":`5. Please check the accuracy of the data.`,
"label.taskinto":`Tasks are the templates that workflow rules use when automatically assigning tasks to users.`,
"label.customfields.formula.textexample":`Full Name = LastName`,
"label.appointmentpage.wizard.subtitle1-1":`Next Week`,
"label.weixin.radio":`Exclusive Choice`,
"vue_label_file_replace_reason_check":`Reason for replacement (optional)`,
"label.sendemail.recycle.operateexception":`empty your recycle bin failed, please try again.`,
"label.vlidaterule.formulaerror":`Display an error if Discount is more than 30%`,
"vue_label_campaign_existing_member_status":`Keep existing member status`,
"label.service.miniProgram.fillSlideshowName":`Please fill in the name of carousel.`,
"label_partner_workspace_login_headerfooter":`Header and Footer`,
"label.quickbooks.viewlist.total2":`There are {0} estimates for a total value of {1}`,
"chatter.viewingResults":`See Results`,
"label_tabpage_allvisible":`All users`,
"label.quote":`Quotes`,
"label.changemydisplay.list.des":`Customize Tabs on Needs`,
"label.leadscore.notimes":`No more times to score leads`,
"label.icon.51":`Power Generation`,
"component.assistant.label.title":`Assistant`,
"label.emailobject.emailsent":`Email Sent！`,
"label.group.nofile":`No file have been sent to this group.`,
"label.foldervisitlimit2":`All users cannot access this folder`,
"label.dataoperate":`Data Operation`,
"label.addattachment.size":`Size`,
"label.not.double":`Duplicate values are not allowed.`,
"label.customfields.formula.number.tip":`Calculate a numeric value.`,
"lable.opppdt.addpdt.table.description":`Line Description`,
"label.sms.isactivity":`Active`,
"label.campaign.channel.input.owner":`4.Who will be this channel's leads owner:`,
"label.visualpage.notfound.error":`An unknown error occurred, please contact the administrator.`,
"label.mr.title.button.group3":`records`,
"label_tabpage_beginz":`Begin`,
"label_tabpage_queue":`Queue`,
"label.tabpage.advancedscreening":`Advanced Filter Conditions`,
"nogreate":`less or equal`,
"chatter.fields":`Fields`,
"button_partner_workspace_manage":`Management`,
"label.partnerCloud.orderingPlatform.search":`Search products`,
"message.password.isnull":`Please enter your password.`,
"label.fenbeitong.title":`FenBeiTong Setting`,
"label.salescloud.contactrole.message.chooseatleastone":`Please select a contact at least.`,
"label.knowledge.delete.election":`Error while deleting data category selection`,
"front-console-status-hoided":`Lay Up`,
"label.lastmodifydate":`Last Modified Date`,
"vue_label_chat_deleting_chat":`After deleting, the chat history will be cleared and removed from the Team list. When receiving a new message, it will appear in the Team list again.`,
"label.timeframe":`Time Frame`,
"UG.opportunity.002":`Define your sales cycle, configure stage`,
"label.templates.merge":`Please select templates to be merged. A maximum of 20 can be selected.`,
"label.generatepage.c2":`Maximum length is 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 passwords remembered`,
"button.partner.workspace.enable":`Enable Partner Cloud`,
"vue_label_pool_nopool_notice":`You have not yet joined any pool, please contact the administrator to create or join a pool.`,
"label.layout.required.field.select":`Selected Required Fields`,
"label.loginhis.date":`Type the start date and end date.`,
"vue_label_commonobjects_detail_and_overdue":`Upcoming & Overdue`,
"label_tabpage_advancedsearch":`Advanced search`,
"label.custom.field.login.home.query":`Please go to the homepage and view task details.`,
"page":`Page`,
"label_tabpage_onlymevisible":`Me only`,
"label.weixin.optionfour":`Choice 4`,
"label.confirm.to.remove":`Confirm to remove`,
"label.event.moveup.30minutes":`30 minutes ahead`,
"label.mail.merge.template.finish":`Merge email templates completed`,
"label.multilang.currencylist.before":`Before {0}`,
"label.goback":`Go Back`,
"label.unknown.prefix":`Invalid prefix, please re-enter.`,
"lable.account.CurrentandPreviousCYt":`Current and Previous 2 CY`,
"label.product.dent":`Enter your keyword and filter criteria,then click Search to begin your search.Click More filters to use more than one filter.Search results include all records that match both your keyword and filter entries.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Operation`,
"label.knowledge.setting.hint.eight":`Keep everything in pefect order!`,
"label.sso.saml.sp.idtype.fid":`Assertion contains the Federation ID from User object`,
"vue_label_chat_voice":`voice`,
"label.config.pw":`Confirm New Password`,
"lable.newtabpage.closesearchresult":`Collapse Search Results`,
"lable.account.NextWeek":`Next Week`,
"label.ems.username":`Username (u)`,
"vue_label_email_emails_from_potential":`Emails from leads and contacts in your CRM, and emails containing them in recipients, will be categorized here`,
"lable.approval.shared":`Approval share`,
"label.tabpage.allz":`All`,
"label.file.uploadfiles":`Upload Files`,
"label.emailobject.text":`Text:`,
"label.version.allow.create":`Allow create new`,
"label.empty.field":`The field cannot be empty.`,
"label.emailsync.status.department":`Department`,
"label.pw.str":`5 characters`,
"label.attendance":`Attendances`,
"label_mobile_buttom_team":`Team`,
"label.campaignmember.main.addcontactdesc":`Add all existing contacts to this campaign`,
"label.search.result":`Search Results`,
"label.weixin.activity.account":`Activity guests`,
"label_tabpage_clearoptionsz":`Clear advanced options`,
"UG.activity.01":`How do you track your records to interact with your accounts/teams?`,
"serviceappointment.new.status.limit":`Failed to create a new service appointment with a status of scheduled or dispatched.`,
"label.notice.higher":`Send Email To Manager`,
"label.passwordPolicy.setup.gletters":`character(s)`,
"label.data.exportsf.des":`Successfully exported files will be automatically deleted after 48 hours of saving on the derver.`,
"label.view.onlymecansee":`Visible only to<b> me</b>`,
"UG.Lead.005":`Mailbox`,
"label.umeng.approval.approvalfail":`submitted faild.`,
"label.huanxinconfig.clientid.lost":`clientid cannot be empty`,
"label.campaignmember.main.updatecontactstatus":`Update Status-Existing Contacts`,
"component_chatter_button_delete":`Delete`,
"label.weixin.no.pending.projects.qin":`No items to approve.`,
"front-electronic-signature-auto-fill-field":`Autofill Field`,
"message.resetpw":`Are you sure you want to reset your password?`,
"label.service.ganttBaiduMap.service.resourname":`Name of Service Resources`,
"vue_label_pricebook_deleted":`Price list deleted`,
"label.icon.193":`Bathtub`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`City`,
"label.pc.ui.2018.searchs":`SEARCH...`,
"label.yard":`Invitation Code`,
"label.data.downpage.i_title.btn":`Go to Importing Page and Start`,
"label.useablereceivers":`Available Recipients`,
"label.cloudccsite.name.length":`Allows users to enter up to 255 characters`,
"label.secrecy":`Confidential`,
"label.campagin.roi.ydkhywjhzz":`Total Amount of Closed-Won Opportinities`,
"vue_label_report_conditiondesc_one":`Except for subscription, you can set conditions for this report. You will be notified if all conditions are met. This is optional`,
"label.datamanage.select.contactfield":`(Select the field corresponding to the import contact)`,
"label.emailtocloudcc.filed.action":`Action`,
"label.smstemplate.new":`New SMS Template`,
"label.mobile.side.tab.app":`Apps Setup`,
"label.icon.118":`Clock`,
"label.customfields.selectcontainfieldlayout.tip":`The field will be added as the last field in the first 2-column section of these page layouts. The field will not appear on any pages if you do not select a layout.To change the location of this field on the page, you will need to customize the page layout.`,
"Lead_Homepage_Tools_BatchScoring":`Batch Score`,
"lable.quote.syncing.quote":`Quotes`,
"pagecreator.button.preview":`Preview`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`No recent record`,
"lable.info.queue.showallmember":`View Queue Members`,
"label.multilang.campaign.selelctmember.desc":`Select a view and select the member to add to the campaign. The member status is {0}`,
"label.notification.ccchat3":`【评论用户名】commented on your post.`,
"UG.product.03":`Multi-currency supported price manual`,
"label.sso.saml.idp.config.pksize":`Key Size`,
"label.defineCustomReportType":`Define the Custom report data source`,
"component.timeline.button.filter":`Filter`,
"label.mr.nextGroup":`Skip This Group and Go Next`,
"label.quote.sprdz":`Billing address`,
"label.total.refuse.forecast.have.priority":`Refuse All Forecast Priorty`,
"lable.product.peep":`Please enter a valid price.`,
"label.file.who.can.access":`Who can access`,
"label.page.last":`Last Page`,
"label.icon.180":`People`,
"font-evaluate-module-v1-enabled-successfully":`Successfully enable evaluation option "Neural"`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`One year`,
"label.login.bound.mfadevice.title":`Enable virtual MFA devices`,
"vue_label_dashboard_statisticalvalue":`Please select statistical value`,
"label.ishistory":`History`,
"component.timeline.label.title":`Timeline`,
"label.page.step3.of.step5":`Step 3 of 5`,
"label.assignment.setup.detail.section":`Rule Detail`,
"label.salescloud.opportunity.nothave.main.contactrole":`No major contacts`,
"label.import.page1.limitedcsv":`CSV format ONLY for uploading files`,
"label.icon.187":`Hammer`,
"label.emailobject.wizard.desc5":`Customize your signature to make your mail look better.`,
"vue_label_report_notice_copy_success":`Copy the report successfully!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`You have not chosen the rule of duplicate checking.`,
"label.componentEditor.upper.limit":`Up to 100`,
"label.validate.function.funcExplain.ISNEW":`Check if the record is new, and returns TRUE if it is new, otherwise, returns FALSE`,
"label.postalCode":`Postal Code`,
"label.dashboard.snapshot.enable.flag":`Enable Dashboard Snapshot`,
"vue_label_file_upload_type_size":`Only {fileType} files can be uploaded, and no more than {size}Mb`,
"label.appointment.wizard.subtitle3-6":`Saturday`,
"homepage.narrow":`Narrow (Left) Column`,
"chatter.addmute.confirm":`Are you sure you want to keep this post “don’t disturb”?`,
"label.lookup.account":`Search Accounts`,
"message.lostthemanager":`This submission requires the approval of the user's manager, and the value of the user's manager is null. Please contact your administrator to know more.`,
"label.exchange.sync.state.contact.m3":`Records synced in the last 24 hours:`,
"label.version.phone.app":`Mobile App`,
"label_tabpage_search":`Search`,
"vue_label_helpcenter_campaign":`In the detailed information, click the tree diagram button next to the campaign to view the hierarchical structure diagram of the campaign and understand the Parent-child hierarchy of the campaign.<br>Manage the contacts or leads involved in the campaign through the related list of campaign members.`,
"front-lightning-module-v1-dashborad-last-year":`Last year`,
"label.campaign.channel.value":`Values`,
"vue_label_opportunity_contactrole_primarycontact_notice":`To select your primary contact, save this step and chose from Management`,
"label.biaoqingfaxian.title":`Bid&Tender Discovery`,
"label.approved":`Approved`,
"label.hong.kong.time":`Hong Kong Time`,
"label.customfields.file.cannotopen":`Cannot open the file`,
"lable.New.tips":`Click "New" to create a new service report template on the basis of a standard template or any selected one. Please activate the template and start to use.`,
"component.setup.tabs.label.add":`Added`,
"label.forecast.forehistory.replacebest":`Best Case Overridden`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Call Center Integrated with TRRT to Provide More Comprehensive SaaS Services`,
"label.workflow.configrule":`Step 2 Configure Workflow Rule`,
"label.dashboard.snapshot.refresh.frequently":`Dashboard snapshots refresh too frequently,please try again later`,
"label.ems.editsetting":`Edit email setting`,
"message.confirmdeleteAPP":`Are you sure you want to delete this app?`,
"label_chatter_activity":`Activities`,
"label.editsharerules":`Sharing Rules Edit`,
"label.loginservice.license.notuse.must":`The license is not currently available,you must`,
"label.import.step2.beforeexport":`1、Before importing, please make sure to import all related records. For example, if you are importing contact records and you want to fill in the account field, which is a lookup field, you need to create the account record you are filling in first, then import the contact record and fill in the account field with name or ID of the corresponding account.`,
"label.chat.mute":`Do Not Disturb`,
"label.icon.128":`House`,
"label.give":`&&And`,
"label.hide":`Do Not Show`,
"label.relationobject.wpr":`Delegated Approver`,
"label.summation":`Sum`,
"label.layout.availabletab.details":`Details`,
"label.circle":`Donut Chart`,
"vue_label_opportunity_contactrole_add":`Add Contact Roles`,
"label.file.library.file2libsuccess":`Added successfully!`,
"label.weixin.report.reportgenerated":`Report Generated`,
"label.icon.91":`People`,
"report.label.pleaseinput":`Enter what you want to search for`,
"label.escalation.setup.newaction.otheremail.tip":`You can enter up to five (5) email addresses to be notified. Each email address is separated by ",".`,
"label.area.donot.have.data":`No data`,
"label.customcomponent.btn.reference":`Component Reference`,
"label.appointmentdetail.wizard.title7":`Reminder Time`,
"label.ccchat.with":`Have`,
"label.file.size":`Size`,
"label.product.sort.beyond":`A maximum of 10 levels can be set !`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Select the columns`,
"label.appointmentpage.wizard.subtitle1_1":`Choose date and time`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Must mix numbers and uppercase and lowercase letters, and special characters`,
"label_chatter_addressee":`Recipient`,
"label.profile.remark2":`If your organization uses Record Types, use the Edit links in the Record Type Settings section below to make one or more record types available to users with this profile.`,
"UG_Account_01":`Who is your account?`,
"label.dataimport.error.contact.notnull":`Error: contact name can not be null.`,
"lable.account.CalenderQuarter":`Calender Quarter`,
"vue_label_commonobjects_detail_empty":`Sales price cannot be empty`,
"label.approveassigntemplate":`Approved to assign Email templates.`,
"label.objectRelationshipDescription1":`This report data source will generate reports about`,
"vue_label_email_insertmergefield":`Insert Merge Field`,
"label.mobile.home.page.check.team":`Team`,
"lable.edit.queue.edit":`Queue Edit`,
"label.campagin.roi.query":`View Campaign ROI`,
"label.dataimport.field.allow.access.to":`Data fields are not allowed to access, please manually delete the corresponding record and try again.`,
"pagecreator.systemstyle.message.canntdelete":`The current style is not allowed to delete`,
"label.searchkey":`Please enter keywords`,
"chatter.showall":`Show All`,
"show":`Show`,
"label.quote.choseproduct":`Select Product`,
"label.report.selected.field":`Selected Fields`,
"label.globaloperation.operationtype.create_data":`Create record`,
"label.knowledge.setting.data.seven":`Delete Category Group: {flzmc}`,
"chatter.email.mentionOrMessage":`Mentions or Messages`,
"label_tabpage_exclusivez":`Exclude`,
"chatter.en.userinfo":`Enter the information about you.`,
"label.log.orgid":`Organization`,
"label.dataimport.insertdata.error.fieldrepeat.update":`The $schemefield_name$ field in the record cannot be found in the database and cannot be updated. The record has ignored import.`,
"vue_label_chatter_add_link_success":`Added link successfully`,
"label.sender_details":`To add new sender details, create a user in your`,
"label.ccpeak.addwhere.condition":`A "where" criteria can be added`,
"label.datamove.total":`Total`,
"label.tianyancha.businessverify.warning":`Please note that this verification only support the business data registered in china mainland.`,
"label.emailmainbody":`Email Body`,
"label.justadmin":`Administrators Only`,
"label.data.downpage.e.list.desc1":`This page displays successfully exported files. Please dowmload the exported files in time addording to the download link in your email.`,
"label.reportsSubscriptionPage.email.value":`Existing Values`,
"message.error.serviceappointment":`Please fill in the scheduled start time and scheduled end time on the service appointment.`,
"label.textMessageObject.selectone":`Please select at least one record as the recipient of the text message`,
"label.schedulejob.setup.schedule.plan":`Schedule`,
"label.assignment.layout.field.isassigned":`Assign according to active assignment rules.`,
"label.captcha.error":`Verification error!`,
"mobel_web_not_more_data":`No more data`,
"label.emailsync.form.emailaddress":`Email Address`,
"label.loginservice.error":`Login error, please contact administrator.`,
"label.integrations.description":`Connect your CloudCC account to other apps`,
"vue_label_homepage_notice_selectone":`Please select at least one lead or contact`,
"label.chatter.default":`Default`,
"label.tabpage.datefield":`When the date field is equal, it can use "yesterday", "today", "tomorrow", "last month", “this month", "next month", "last week", "this week", "next week" or "YYYY-MM-DD、MM/DD/YYYY" format.`,
"front-kefu-moudle-myzdhsc-file":`Recording file not found or not generated`,
"label.createname":`Creator`,
"label.mobile.phone.enter.plan":`Enter your plan`,
"report.label.highlevelreport":`Advanced reports allow you create the relationships between up to 4 objects.`,
"label.edit.select.label":`Editing Mode`,
"label.partnerCloud.financeSetting.deduction":`After activating, the funds will be added to rebate account, rebate income, and rebate expending object. Partner users can use rebate account to deduct the amount to be paid.`,
"message.duplication.label.updateoption":`Action on Update`,
"label.custom.CurrentCQ":`Current CQ`,
"front-kefu-moudle-wait":`Waiting`,
"sunday":`Sunday`,
"label.service.timezone":`Timezone`,
"setup.layout.label.selectfield":`Select fields`,
"label_emailtocloudcc_filed_action":`Action`,
"label.forecast.customforecast.mycommit":`My Commit`,
"label.uploadsuc":`Upload Successful`,
"vue_label_commonobjects_view_notice_atleast1field":`Select at least 1 display field`,
"label.dataimport.khmc.length":`Error: The length of the account name is too long.`,
"label.isemailnotification":`Send Notification Email`,
"label.addAPPexchange":`Add apps from CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Currency:`,
"UG_quota_02":`Change opportunity stage`,
"label.customer.tab.step2.same.option3":`Tab Hidden`,
"H":`Phone`,
"label_tabpage_searchz":`Search`,
"vue_label_homepage_deleted":`Deleted`,
"label.weixin.recent.view":`Recently Viewed Views`,
"template.report.opportunity.sales":`Sales Volume of Opportunities`,
"label.customfields.new.step2.opration.unique.info.v1":`Consider "ABC" and "abc" as duplicate values (case insensitive)`,
"savesuccess":`Saved successfully`,
"label.partner.workspace.member.memo":`All users with selected profile and permission can access this partner cloud.`,
"label.icon.23":`Drug`,
"lable.batchadd.service.cfq.before":`Triggers (Before Insert)`,
"label.instrumentPanel.breakpointTwoLabelname":`This value should be greater than the minimum value and the breakpoint 1 value.`,
"message.selectgsummaryinformation":`Please select the data you want to summary`,
"label.tianyancha.businessverify.msg6":`This function uses third-party services and may have unstable performance or impossible service due to high concurrent usage. CloudCC is not responsible for any liability.`,
"vue_label_helpcenter_report3":`3.A. Click the field search box, select the field you want by searching for it or scrolling down the list of fields, select the field's operator, enter or select a value, click Apply and the field filter takes effect. <br> B. Click the " " sign above the field search box and enter advanced filtering condition consisting of numbers and letters in the "Filter Condition Input Box". For example, (1 and 2) or3.<br>? Edit Filters<br> To edit the filters, include the standard filters, and click on the filters. <br>? Remove filters<br> Click the "x" icon on a filter to remove it. <br>? Run the report<br> Click the Run button in the upper right corner of the edit page to see the full report results. <br>? Save the report<br> Click the "Save" button at the top right corner of the editing page, fill in the report name, select the report folder and save it. <br>2. Create Report Folder<br> Before creating a report folder, the system generates My Custom Report Folder and Unarchived Public Report Folder by default. <br> Step 1: From the Reports tab, click New Reports Folder<br> Step 2: In the New Reports Folder pop-up, you can choose to transfer reports from the Unarchived Public Reports folder to this folder. You can select which users can access this folder and the access rights. <br>3. Viewing Reports<br> Step 1: From the Reports tab, go to the Reports list page and find the report you want to view by toggling "Recently Viewed", "I Created", "All Reports", or the Reports folder. or Reports folder to find the report you want to view. <br> Step 2: Click on the report name to view the report. Or click the drop-down button on the far right of the report and select Run to view the report. <br>If you are an administrator profile, from the Reports tab, go to the Reports list page and click the gear icon next to the New Folder button to select the fields to display in the table header of the report list in each folder. <br>4. Export Reports<br> Step 1: From the Reports tab, go to the Reports list page, find the report you want to export, and click the drop-down button on the far right of the report. <br> Step 2: Select the type<br> Format report: contains report headers, grouping, filtering details. <br> Detail Only Report: Unformatted detail rows. <br> Step 3: Click Export. The details-only report needs to be exported in pages, with a maximum of 2000 data per page.  `,
"label.batchdelete.success":`Batch delete successfully`,
"label.newprocess5.seq":`Order`,
"label.knowledgebase.data.translated.successfully":`Translate {a] data successfully`,
"label_enable_range":`Activated Range`,
"label.ccchat.and":`And`,
"label.assignment.setup.list.norule":`No rules specified.`,
"vue_label_report_summaryformulacolumn":`Summary formula column`,
"label.field.edit.change1":`Maximum score should not exceed 100`,
"syntaxerror":`Syntax error,Please check the criteria you entered.`,
"label.icon.116":`House`,
"lable.asset.BOM.according.to.product":`Generate asset BOM according to product structure`,
"chatter.like.post":`people liked this post`,
"label.trigger.page":`Trigger Pages`,
"vue_label_email_contact_adminstrator":`The system is abnormal, please contact the administrator.`,
"label.workreport":`Work Notes`,
"vue_label_homepage_edit_card_view":`Edit Card View`,
"label_emailsync_status_disabel":`Inactive`,
"label.icon.54":`Excavator`,
"message.error.view.validerr.common":`Verification failed.`,
"label.exchange.sync.account.username":`Service Account Username(Domain Username or UPN):`,
"label.dataimport.error.date":`Error: Date`,
"label.orgname":`Organization`,
"label.weixin.group.owner":`Owner`,
"vue_label_dashboard_colorrange":`Color Range`,
"label.forecast.shrepage.tableth":`Forecast Access`,
"label.related.disabled":`Related lists are not enabled, please contact system administrator to enable related lists in the page layouts.`,
"label.version.product.management":`Products Management`,
"label.knowledge.new.article.published":`The article is published as a new article.`,
"label.sendsms.batch.step4":`Step 4 Your SMS have been submitted.`,
"vue_label_commonobjects_detail_and_tasks":`Congratulations, all events and tasks are processed!`,
"label.salescloud.ci":`time(s)`,
"label.ccpeak.getapi.name.time":`If you want to use the methods in the CCService class, you need to instantiate.`,
"label.escalation.setup.detail.conditon":`Criteria`,
"label.lbs.isUseLbs":`Enable Location Services`,
"front-lightning-module-v1-dashborad-color-depth":`Color Depth`,
"date":`Date`,
"label.select.personnel":`Select Personnel`,
"label.appointmentpage.wizard.notif3":`Email is required!`,
"label.import.page1.pleaseselectwayofdealdata":`Please select processing mode`,
"label.partner.all.memo":`The list shows all partner clouds in your organization. Click URL to login.`,
"label.appointment.wizard.subtitle4-3-3":`30 min`,
"component_telerecord_label_subject":`Subject`,
"label.sendsms.batch.finish":`Batch SMS: Completed`,
"label.login.access.myusername":`My Username`,
"label.weixin.wechatnumber":`WeChat ID`,
"label.eowechat.status":`User Status`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Score`,
"label.appexchange.oldreport.noupload":`Old Reports-Do Not Upload`,
"label.approverfieldediting":`Approver Field and Records Editability`,
"label_tabpage_customernamez":`Customer name`,
"vue_label_dashboard_linkagesettings":`Linkage Setting`,
"vue_label_ccchart_notice_deletecomment":`Are you sure you want to delete this comment?`,
"label.allprofile":`All Profiles`,
"label.campaignmember.main.addMember":`Add Members - Search`,
"label.projectManagement.subtask.list":`Subtask List`,
"label.code.some.size":`Code Capacity: maximum 200KB characters, approximately 20,0000 bytes.`,
"front-custom-service":`Service Cloud provides efficient and agile customized services for customers, shortens service resolution time and increases resolution rates with the intelligent work order system, improves customer loyalty and increases repurchase rates.`,
"label.SMS.det":`SMS Notification Details`,
"setup_layout_label_nobutton":`No available buttons`,
"vue_label_email_Could_not_save_template":`Could not save template`,
"label.imgfield.height":`Height`,
"label.leadscore":`Lead scoring`,
"setup_object_field_dependency_label_removefromlist":`Remove selected values`,
"message.error.code.null":`Authorization code cannot be null!`,
"label.tianyancha.businessscope":`Business scope`,
"vue_label_chat_empty_message":`Empty message`,
"label.total":`Total`,
"label.delerror.list":`Undeleted files List`,
"label.selectedreceivers":`Selected Recipients`,
"label.layout.availablepages":`Available Pages`,
"label.pc.ui.2018.personalinfo":`Personal Information`,
"label.chat.topic.edit.detial":`Edit details`,
"label.mr.descreption.reDataList1":`In the query to meet the conditions of a total of`,
"label.document.value.too.long":`This file size more than 5M!`,
"lable.opppdt.addpdt.table.listprice":`List Price`,
"label.selectoperate":`Select the action`,
"label.icon.5":`Currency`,
"label.icon.126":`Hospital Bed`,
"label.hiddensearch":`Hidden Search`,
"label.view.sortview.exportble":`Exportable`,
"vue_label_homepage_noassignee":`No assignee`,
"label.knowledgebase.close.and.resolve":`Close and Solved`,
"label.licence.used":`Used Licenses`,
"label.newprocessstep5":`Step 5 Select Fields to Display on Approval Page Layout`,
"vue_label_appstore_all_applications":`All applications`,
"label.no.edit.permission":`Cannot select. No permission for editing the selected records.`,
"vue_label_calendar_calendar_added_successfully":`Calendar added successfully`,
"report_line":`Data Field`,
"component.chatter.link.label.name":`Link name`,
"label.data.expnode.e_desc1":`1. Custom Export: users can select fields to export and set filter conditions according to their needs.`,
"label.tabularreport.step4":`Step 4 Choose report criteria`,
"Opportunity.Detailed.Phase.Change.Text.001":`Change Opportunity Stage`,
"label.quickbooks.searchresault.action":`Action`,
"component_timeline_label_today":`Today`,
"label.callboard.remark":`Please enter your company announcement below.`,
"label.campagin.field.choose":`Select the fields to include in campaign member register page`,
"front-gantt-module-rolling-temporary-tasks":`Scroll to unscheduled tasks`,
"label.file.des":`Description`,
"Dashboard_View_RecentlyView":`Recently Viewed`,
"UG_Account_04":`Passive query account filtering`,
"chatter.refresh":`Refresh`,
"label.tianyancha.companyorgtype":`Company type`,
"label.chatter.dateRange":`Date Range`,
"label.campagin.step3":`Step 3: Generate pages`,
"label.appointmentdetail.wizard.title14":`Monday Plan`,
"setup.object.field.dependency.button.setdependency":`Field Dependency Settings`,
"serviceterritorymember.serviceterritory.isactive.notactive":`This service territory is not enabled. You can only add members under an enabled service territory.`,
"template.chart.ygydyj":`Employee Win Order Performance`,
"label.tag.edittags":`Edit Tags`,
"label.clone":`Clone`,
"front-electronic-signature-setting-intro1":`Before binding your account, it is recommended that you first register and authenticate on the DocuSign platform.`,
"label_reach":`Performance`,
"label.tabpage.havez":`Attached`,
"label.email.clearCase":`Only empty Emails unassociated to cases`,
"label.customer.tab.all":`All Menu`,
"label.direct.dashboard.day.report":`New Daily Work Note`,
"label_tabpage_exportview":`Export View`,
"label.passwordPolicy.setup.maxFailTimes":`Maximum invalid login attempts`,
"label.processsetting.complete.enable":`Complete and Activate`,
"label.marketsea.memberfield":`Fields Can Be Viewed By Members`,
"label.report.export.format.title":`Format Reports`,
"label.recycle.execute.title":`Clearing the recycle bin.`,
"label.file.use.most.user":`Users with the most storage space used`,
"report_type_label_systemReport":`System Reports`,
"label.customobjects.majorobject":`Primary Object`,
"label.file.delete.public.link":`Delete public link`,
"front-epwechat-module-v1-id":`WeCom ID`,
"label.partner.common.roleNum":`Number of roles`,
"label.sendtonextapprover":`Sent to Next Approver`,
"label.notification.tip3":`Load 10 More Notifications`,
"label.tabpage.placeenterz":`Please enter?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Please enter the url of the page to be imported`,
"label.umeng.activity.statuschange":`The task status you assigned to #name is changed to #newstatus`,
"label.step3.restricted.visibility":`Step 3 Restrict Visibility`,
"label.multilang.datadelete.approvedata":`Records being approved ({0}):`,
"label.reportsSubscription.save":`Save`,
"label.emailobject.template.visibility":`Visibility`,
"label_partner_step3":`Step 3 Basic information`,
"label.product.across":`Accross Price Books`,
"label.same.analyze.opportunity.name":`Opportunity Name`,
"label.chatter.memotel":`Memo-telephone`,
"label.recentview.seloption2":`Recently Created`,
"label.ccchat.message.search.desc1":`We could not find any news with`,
"label.reportexport":`Export`,
"label.service.gantt.drop.tip":`Permission Denied: You do not have enough permissions to operate. Please contact the administrator.`,
"label.australian.westem.standard.time":`Australian Western Standard Time （Australia）`,
"label.emailobject.email":`Email`,
"Homepage_Contract_FieldMissed_DoesntSupport":`There are no "qdrq" and "htje" fields on the contract object, so the data can not be showed.`,
"label.email.cancel.upload.info":`This will cancel the ongoing upload process`,
"label.page.copy.merged.field.value":`Copy Merge Field Value`,
"UG.ST.006":`Enter directly`,
"label.trigger.service.connot.access":`Inaccessible statement`,
"label.projectManagement.new.tasks":`New Task`,
"lable.SalesCommitmentKanBan.receiptsRate":`Receipts Completion Rate`,
"label.productsales.oppor.overdue":`Overdue Opportunities`,
"vue_label_pool_convertedbyme":`Converted by me`,
"label.loginip.pagecue.invalidt":`Start Internet address is farther than the end Internet address or invalid Internet address.`,
"label.campagin.roi.xyzj":`Total Response`,
"label.visualpage.list.title":`Active Custom Page Access`,
"chatter.feed.searchinitvalue":`Enter the name...`,
"label.export_submission":`Export Submitted Data`,
"this.season":`This Quarter`,
"label.forecast.settings.gx":`Forecast Data Sharing`,
"label.tag.addtags.tagcolour":`Tag Colour`,
"label.api":`API Name`,
"label.bulk.delete":`Batch Delete (Permanently)`,
"label.reportsSubscriptionPage.condition.emailoption":`Email options`,
"vue_label_dashboard_newdashboardsuccessfully":`Create new dashboard successfully`,
"three":`Three`,
"label.prompt":`Prompt`,
"label.same.analyze.contact.phone":`Mobile`,
"label.icon.62":`Pipeline`,
"label.forecast.shrepage.tableth.isnable":`Allow Submitting`,
"label.multilang.polloption.vote":`{0} ticket(s)`,
"label.customfields.totalsummary.selecttotaltype":`Select Roll-Up Type`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Receipts Commit Rate`,
"label.areaAndSub":`Territory and Sub-territory`,
"vue_label_pool_recycle":`Recycle`,
"lable.outlook.detail.synset":`Sync Settings`,
"label.quote.detail.introduce":`Enter the keywords, click "Search" to search, when the search is complete, click "Select" to jump to the next step.`,
"label.profile.customappset":`Application Settings`,
"label.changemylanguage":`Change Language`,
"message.approval.plzcapppor":`Choose Approver`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Public Calendars and Resources`,
"label.wtd.changefields.title.desc1":`Select the fields to include on your Web-to-CloudCC form, enter the specified return URL, then click the "Generate".`,
"label.weixin.voting.not.empty":`Voting options can not be empty`,
"label.campaign.channel.equal":`Equal to`,
"label.emailobject.emaildetail.button.back":`Back`,
"label.ccchat.person.invite.allowemails":`For security, please enter the email address only ended with the below`,
"label.notEdit.message":`Sorry, you don't have the access to edit this data, please contact the system administrator.`,
"label.layout.selectedfields.relatedlist":`Selected Fields / Related Lists`,
"label.weixin.voting.deadline":`Vote Deadline`,
"label.document.upload":`File to upload`,
"label.import.page2.notmatchfiled":`{csvfiledlength} fields in the file in total. {difflength} fields are unmapped.`,
"label.data.exp.selzippwd":`If you do not fill in, there is no compressed password by default.`,
"label.user.step2.select.email.template":`Step 2 Select the email template`,
"label.currency.effective":`Active Currencies`,
"label.version.control.type":`Organization Edition`,
"label.projectManagement.Taskorproblem":`Task/Issue`,
"label.everyweek":`Weekly`,
"label.passwordPolicy.setup.pwdremember4":`4 passwords remembered`,
"label.emailobject.groupemail":`Group Email`,
"label.approvepagelayout1":`Everyone has the same layout`,
"label.integrations.mailchimp.massage5":`Import the selected leads and contacts from your CloudCC account to Mailchimp and send the email to the intended recipients`,
"label.icon.22":`Add To`,
"Dashboard_View_All":`All Dashboards`,
"label.import.page2.example":`Example`,
"label.send.letter":`Send Invitation Letter`,
"label.mobilesectionpart":`Mobile part`,
"component_setup_tabs_label_title":`Tab paging`,
"label.knowledgebase.results":`{a} results`,
"label.field.remark":`This page allows you to specify the fields that can appear on the`,
"vue_label_systemSettings_url":`Domain Setup`,
"vue_label_SMS_failed_find_view_list":`Failed to find view list`,
"setup_layout_label_order":`Sort By`,
"label.customsetting.touse":`Use Custom Settings`,
"label.product.enter":`Enter keywords to find the matching products.`,
"label.email.template.private.SMS":`Exclusive SMS Template Folder`,
"vue_label_homepage_chart_deleted":`The chart or dashboard has been removed`,
"label.conversion_pages":`Conversion Page`,
"label.compact.layout.select":`Select key information layout fields`,
"report_label_folderandreport":`Reports and Folders`,
"label.product.entry":`Price Book List`,
"label.campaignmember.main.manageMember":`Manage Members`,
"front-QBtoCC-changing":`Updating...`,
"vue_label_pool_abandonreason":`Discard Reason`,
"template.report.customer.contract.statistics":`Contract Analysis of Accounts`,
"label.invoice.message.sendsuccessully":`Invoice sent successfully`,
"label.addcurrentoperate":`Add Exsiting Action`,
"label.customerinfo.mailpwd":`Mail Box Password`,
"batch.nochange.owner":`No permission to change the record owner!`,
"label_tabpage_uploadfailez":`Upload failed, please reupload.`,
"vue_label_systemSettings_mobelqrsetting":`Mobile App Scan Setup`,
"label.regular_field":`Form Domain`,
"label.tabpage.delsuccessz":`Delete successfully`,
"label.Days.Before.Horizontal.Date":`Level date before`,
"label.evaluation.general":`Okay`,
"chatter.notlike.p":`Stop liking this post`,
"label.chatter.send":`Send`,
"label.emailsync.button.cancel":`Cancel`,
"label.notification.task4":`Your task is about to expire today`,
"vue_label_helpcenter_detail1.2":`Quickly change task status: tick the check box in front of the task in the "overdue and upcoming" module, and click the refresh button to quickly change the task status to "finished".<br> Before refreshing, cancel the tick and the task status will not change.<br> Tasks with high priority will be marked with a "red flag" icon in the activity timeline.<br>The display sequence of the activity timeline<br> Arrange in reverse order according to the due date of the task, the due date of the recorded call, the start date of the event, the date of sending and receiving emails, and the date of sending and receiving SMS. If the above dates are the same, they will be sorted in the reverse order of the record creation time.<br>?Activity timeline filter<br> Use the filters in the event timeline to narrow the scope of visible items, focus on important items, and find target items. The timeline filter includes three types of filters: date range, activity to be displayed, and activity type.<br> Activities to display: all activities, my activities<br> In the event timeline filter, this option can narrow the display range of the event.<br> My activities: Show the activities you participated in, whether as the owner or participant. For example, you are the owner who sends emails or organizes events. For example, when you are the recipient of the email Cc or Bcc field, it means you are participating in the event.<br>`,
"component_chatter_post_label_title":`Publish`,
"label.data.dataexptemplate.desc":`Data export template created by users is used for exporting data, and it can make the data export more convenient.`,
"label.helptext":`Help Text`,
"vue_label_norm_removecomponent_certify":`Confirm delete component`,
"front-template-V1-Click-new-template":`Click "New" to create a new template. Activate and start to use this template`,
"label.optional_fields":`Optional Fields`,
"label.delete_about":`You are going to delete`,
"chatter.feed.initvalue":`What are you working on?`,
"label.mail.configure":`Configure your personal email address enable to send and receive messages on CloudCC email home page, and sync your email history to leads and contacts.`,
"label.project.hit.seven":`Task Expiration Reminder`,
"label.button.upgrade":`UPGRADE or CHANGE EDITION`,
"lable.PowerProcess.event.name":`Milestone Name`,
"label.weixin.confirm":`Confirm`,
"label.customfields.new.inputformula":`Enter formula`,
"label.standard.buttonandlink.edit":`Override Standard Button or Link`,
"workflow.action.tasks.assignortype.createdtype":`Creator Type`,
"front-email-payment-paypal-describe":`Click "Continue", you can login PayPal website or create a PayPal account to complete the invoice payment.`,
"label.selectexistingoperate":`Select Existing Actions`,
"label.workflow":`Workflow`,
"label.assignment.setup.detail.ruleentries":`Rule Entries`,
"label.data.file.i.title.num3":`3.The system pre-reads the data file to the server, then starts the back-end mass importer, the results of which will be notified to users by mail, and you will not have to wait on this page.`,
"label.use.view":`Use Existing Views`,
"label.forecast.settings.moren":`Default Product Family`,
"vue_label_calendar_add_share":`Add share`,
"label_tabpage_newview":`New View`,
"label.recycle":`Recycle Bin`,
"UG_solution_03":`Create a solution`,
"label.customfields.formula.text.tip":`Create a text string, for example, by concatenating other text fields.`,
"vue_label_file_single_file_size":`One file supports up to`,
"label.a.b.least":`Each "A" record must have at least one related "B" record.`,
"label.validate.function.addtoformula":`Insert Selected Function`,
"label_tabpage_pleaseSelectz":`Select`,
"label.account.NextFQ":`Next FQ`,
"label.project.project.name":`Project name cannot be repeated.`,
"label.emailtocloudcc.filed.owner":`Owner`,
"label.textmessage.template.message2":`The field inserted in the current email does not match the associated record, which may cause null values.`,
"label.icon.92":`Book`,
"label.trailerpage":`Tail Page`,
"component_event_label_noevent":`It looks like you have completed your work today.`,
"label.trigger.tip":`About Triggers`,
"label.knowledge.case.field.usable":`Available Case Fields`,
"label.group.isusing.success":`Activate successfully`,
"label.marketsea.nextnotfollowdays":`Since last follow-up`,
"component.todaytask.label.choicestate":`Select status`,
"label.recordtype.main":`--Master--`,
"label.sendletter.step1":`Step1: Specify invitation recipients`,
"label_tabpage_saveviewfailed":`View save failed`,
"vue_label_report_notiec_selectone":`Each parent object record must have at least one related object record`,
"UG_opportunity_003":`Track your sales channels, create dashboards`,
"#label.importsourcestep4":`Step 4 Import your files#`,
"front-kefu-moudle-v1-trrt-tip":`You need to associate users (customer service agents) with the extensions of TRRT to obtain the function of "Click to Dial".`,
"UG.Forcast.09":`Next step`,
"label.ggReleaseRange.subordinates":`Search role and subordinate`,
"label.log.desctiption":`You can download audit trace which contains more information.(Excel.csv file).`,
"label.submitted":`Submitted`,
"label.validate.function.funcExplain.BEGINS":`Checks if the text begins with a specified characters, and if so return TRUE, otherwise return FALSE.`,
"label.campaign.channel.code":`Marketing Channel QR Code`,
"chatter.group.theLastActivityDate":`Last Active Date`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Please enter a breakpoint 2 value`,
"label.labeltranslation":`Label Translate`,
"label.multilang.product.deleterederect":`Your deletion of {0} could not be completed because it is still associated with records in other price books. The associated record is as follows.`,
"lable.currencyManage.manageRate.dis":`To manage exchange rates for other objects, to add new currencies, to activate or deactivate currencies, or to change the corporate currency click Manage Currencies.`,
"setup.layout.label.modifypage":`Edit Page Layout`,
"label.import.page2.editforname":`Please edit mapping for the field {necessaryName} .`,
"label.searchlayout":`Search Layouts`,
"label.chatter.loadmore":`Load more`,
"label.trigger.folder.all":`All Trigger Folders`,
"label.export_submissions":`Export Form Submissions`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Total Signed Task Completion Rate`,
"KeyInformationLayout_DefaultLayout_Name":`System Default`,
"label.h5.chatter.great":`like(s)`,
"label.call.center.configuration.enable":`Use the following settings to enable your organization Center Call function`,
"label.overdate":`End Date`,
"chatter.poll":`Poll`,
"label.login.input.verification.code":`Please enter the security code:`,
"label.file.sharetype.cooperation":`Collaborator`,
"label.app.step5":`Step 5 Assign to Profiles`,
"front-gantt-module-save-order":`Save the order`,
"label.globalselect.toallrecord":`Add new option list values to all record types that use this global value set`,
"setup.mainpage.label.welcome24":`The CloudCC cloud platform provides security access settings for all object data in the system. Data sharing and access rights can be controlled by setting various rules and conditions.`,
"homepage.layout.desctiption":`This page allows you to create different tab layouts for the homepage.`,
"vue_label_SMS_notice_send_sussess":`SMS Sent`,
"label.projectManagement.overdue":`Overdue`,
"label.assignment.setup.list.lead.description":`Automatically assign leads to users based on lead assignment rules you define.You can create multiple rules with different conditions.`,
"label.list.projectSetting.des":`Do you want to send emails under the settings below:`,
"setup.mainpage.label.welcome18":`CloudCC's enterprise-level permissions settings let you control the usage rights of individual users while working with data and modules. Role-based permission settings also include user positions, groups, roles, data sharing rules, and field-level security controls to enable data sharing between different people and departments of the enterprise.`,
"label.ratio":`YoY and MoM`,
"label.Xaxis":`X-Axis`,
"label.google.map":`Google Map`,
"Dashboard.SelectBoardToDisplay":`Please select the dashboards you want to shown on dashborad tab page`,
"label.data.newtemplate.e_conditions":`Export Conditions`,
"label.emailtocloudcc.description3":`Connect your enterprise email account, such as sales@company.com, info@company.com, support@company.com. Automatically log emails you recieved as leads and cases records in CloudCC to ensure timely follow-up of customer's letters.`,
"label.page.select.profile":`Choose the user profiles for which the new custom tab will be available. You may also examine or alter the visibility of tabs from the detail and edit pages of each profile.`,
"label.chosen.button":`Selected Buttons`,
"front-epwechat-module-v1-info":`Backend Information of WeCom`,
"label.translation.select":`Filter Criteria`,
"ten":`Ten`,
"label.barcode":`Bar Code`,
"lable.product.nextdel":`Continue and delete the displayed record， or click`,
"label.default":`Default`,
"label.chatter.theme":`Topics`,
"vue_label_commonobjects_view_split_screen_view":`Split Screen View`,
"label.ems.myemails":`My emails`,
"label.email.clearPersonalEmail":`Do you want to empty all Emails synced from personal Email box?`,
"label.login.access.admin":`Your Company's Administrator`,
"label.emailobject.wizard.desc":`After connect your email account in CloudCC, you can send email directly from CloudCC while automatically linking them to related leads,contacts and opportunities. Communication history is clearly arranged by timeline.`,
"label.passwordPolicy.setup.minpwdlength":`Minimum password length`,
"choserow":`Choose columns to display`,
"front-epwechat-module-v1-role-binding":`Roles Binding`,
"lable.outlook.edit.newdata":`Has the oldest creation date`,
"label.schedulejob.setup.schedule.enddate":`End Date`,
"label.quickbooks.view":`View`,
"font-evaluate-module-v1-not-inform":`No Notification`,
"chatter.poll.option3":`Choice 3`,
"setup_layout_label_selectfield":`Select fields`,
"label.partner.common.roleSetup":`Partner Cloud Roles and Users Setup`,
"label_partner_new_step3":`Step 3 enter name and url`,
"label.transfer":`Transfer`,
"label.bmap.myaddress":`My Location`,
"label_tabpage_individual":`Individual choice`,
"label.autoRegister.changepwd.setpwd.repassword":`Please enter again the password`,
"vue_label_commonobjects_detail_and_before":`Earlier`,
"front-kefu-moudle-v1-single-Login-area":`Single Signon Domain Name`,
"label.replacedocument":`Replace Document`,
"label.validate.function.category.Logical":`Logic`,
"label.companyprofile.syncsuccess":`Sync Successful`,
"template.chart.rwzthyxj":`Task Subject and Priority`,
"label.product.clearcondition":`Clear Conditions`,
"component_task_label_person":`* Assigned person`,
"label.tabpage.as":`As`,
"message.error.calendar.add":`The calendar has already been added`,
"label.marketsea.isrecycleleadcreatebyself":`Recycle  Self-created Leads`,
"label.icon.57":`Barometer`,
"UG.Lead.010":`Or`,
"setup_object_field_dependency_label_configured":`Page Layouts Assignment`,
"label.tianyancha.regnumber":`Registered code`,
"front-kefu-moudle-v1-Opened-chats":`Enable Chat`,
"label_tabpage_converstatez":`Converted state`,
"label.bmap.beijing.haidianqu":`Shangdi 10 Street, Haidian District, Beijing`,
"label.startimport":`Start Import`,
"label.knowledgebase.application.default.settings":`Lightning App Default Setting`,
"lable.account.year.custom":`Custom Fiscal Years`,
"label.event.nextmonth":`Next Month`,
"label.email.body":`Body`,
"setup.object.field.dependency.label.mustsetup":`Please setup the field dependency first and save.`,
"label_tabpage_multiple":`Multiple choice`,
"label.task.this.month":`This Month`,
"label.customfields.formula.moneyexample":`Gross Margin = Amount - Cost__c`,
"label.tonewemailnotice":`Select the object for this task and click Next. Tasks can only be associated with workflow rules and approval processes of the same type.`,
"setup.mainpage.label.welcome11":`Custom report`,
"label.layout.availabletab":`Available Tabs`,
"label.data.importef":`Import Failed Files`,
"label.appupload.upload.alert":`Please provide details about this package before upload.These settings determine what requirements must be met in order to install this package.`,
"label.sales.accountteam.shared":`Account Team Sharing`,
"lable.currency.addexchageRate":`Add Exchange Rates`,
"label.page.simplified.chinese":`Chinese (Simplified)`,
"label.service.dispatchingUnits.search.service.area":`Search service territory`,
"lable.list.queue.name":`Queue Name`,
"pagecreator.button.save":`Save`,
"label.ccpeak.support.function":`Support all kinds of functions in single form`,
"label.tianyancha.legalpersonid":`Legal person id`,
"label.sendemail.chat.addPostmainPage":`Dear #name:\n\n hello! #userName posts on your CCChat home page.`,
"batch.no.change":`No permissions to transfer the data.`,
"label.the.referenced":`invoked in`,
"label.input.webtab.information":`Fill in information about the web tab.`,
"vue_label_systemSettings_subscription":`Subscription Type`,
"label.login.access.title":`Grant Account Login Access`,
"label.schedulejob.setup.schedule.lastday":`the last day`,
"label.synchronize.department":`Synchronize Users`,
"label_tabpage_lessequalz":`Less than or equal to`,
"label.file.library.successmanagemember":`Save successfully by the administrator`,
"label.service.major.event.oreder":`Sequential`,
"label.desktopintegration":`Desktop Integration`,
"label.a_b":`A to B Relation`,
"every":`Every`,
"label.tabpage.bar":`Bar`,
"label.filecontentsnotnull":`File contents cannot be empty.`,
"label.layout.detailoftestobj":`Test Object Details`,
"label.summaryreport.2018.step3":`Step 3 Choose column headers`,
"UG.Lead.002":`There are many ways to identify “leads” for your product or service.`,
"label_partner_workspace_member_selectedprofile":`Selected profile`,
"label.newdescription":`New Note`,
"vue_label_normal_moveup":`Move up`,
"label.mobile.quickcreate.default.logacall":`Call history`,
"userterritory.serviceterritory.user.unique":`This user has already been assigned this service territory. Please do not reassign.`,
"label.weixin.record":`Record`,
"front-kefu-moudle-connecting":`Connecting`,
"label.monitorsys.recent.operation.log":`Recent Operation Log`,
"lable.outlook.detail.lmaping":`Map Lead Fields`,
"lable.account.year.ovdate":`Fiscal Year End Date`,
"vue.homepage.auditcard.record":`{recordTotal} records`,
"label.processsetting.delete.process.succeeded":`Delete path successfully!`,
"label.customerinfo.smsPwd":`SMS Gateway Password`,
"label.tolead.object":`Import Objects`,
"label.data.downpage.i.list.desc2":`After importing the data, you will receive an email reminding you of the import successfully.`,
"label.sharerule.ruletype":`Rule Type`,
"label.reportsSubscriptionPage.email.toothers":`Send to me and certain groups of users`,
"label.emailobject.templates":`Templates`,
"vue_label_checkduplicate_":`Collision analysis`,
"label.campaign.channel.lookup.example":`View Sample`,
"label.login.verification.please.note":`Please note:`,
"label.version.charge":`Charge`,
"label.ccdocument.show.trace":`Show Trace`,
"label.sendemail.approval.submit":`Hello, #name:\n #actorname the #objLabel-#recordname submitted by #actordate is waiting for your approval. please click the following link or log in to the crm system to enter the approval center for approval:\n #path#appPath/query.action?id=#recordid=&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`The user can complete the report definition by clicking the mouse, without programming, and following the system prompt steps. The system has a list report, a summary report, and a matrix report to choose from. Display options for all fields are also available. Remove unnecessary field information. At the same time, it provides a variety of graphic displays including strips, fold lines, rings, funnels, and cakes, so that users can see at a glance.`,
"UG_contact_06":`Import contacts`,
"message.success.event.add":`Successfully save new event information`,
"report.line":`Data Field`,
"label.approvepagelayout2":`Everyone has a different layout`,
"vue_label_normal_contract_sf":`Contracts`,
"label.tabpage.tpcustomersz":`Convert leads`,
"label.ccchat.message.new.error5":`Error, your message cannot exceed 10000 characters.`,
"label.severalorone":`Iindividual file`,
"pagecreator_systemstyle_label_buttonfontcolor":`Button text`,
"label.customer.tab.step3.introduce":`Choose the custom apps for which the new custom tab will be available. You may also examine or alter the visibility of tabs from the detail and edit pages of each Custom App.`,
"chatter.group.groupEdit":`Group Edit`,
"label.partnerCloud.partnerAccount.spending":`Rebate Expenditure`,
"label.slip":`item)`,
"label.field.master.class":`The relation level of master-detail is beyond level 3`,
"label.sendemail.chat.addComentsmyFeed":`Dear #name:\n\n hello! #userName replied to your micropost.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Select Dispatch Interval`,
"label.knowledgebase.remove.article":`Are you sure to delete the article form archives?`,
"label.appupload.notmanaged":`Uncontrolled`,
"label.report.goto.step":`Go to Step`,
"label.publicgroup.save.mustbeselect":`You must select the members`,
"label.data.expnode.e.desc2":`2、Export by template: users can select the template to export data.`,
"UG.product.02":`Products refer to products or services that are sold or purchased.`,
"label.sendemailtouser":`Are you sure you want to send email to the selected users?`,
"label.knowledge.setting.hint.nine":`If you do not know how will the Knowledge benefit you? Sort similar articles as the only one data category and accumulate to a broader category. Now, let's add a data category. You can add more categories later.`,
"front-asset-module-v1-view-asset-bom":`View Asset BOM`,
"label_partner_all_enable":`Enable`,
"label.processsetting.disable.process.successfully":`Deactivate path successfully`,
"label.call.center.enable":`Enable Call Center`,
"message.recordtype.applyitseparatly":`Apply a different page layout for each profile.`,
"label.weixin.report.customize":`Customize`,
"label.file.mongdb.file.is.not.exist":`File is not exist`,
"label.chat.edit.topics":`Edit topic`,
"label.knowledge.delete.searchterm":`Error while deleting promoted search term`,
"label_emailtocloudcc_redmessage3":`Please input server address`,
"use":`Use`,
"label.batchtransfer.transferfrom":`Transfer from`,
"label.recycle.my":`My Recycle Bin`,
"label_json_string_null":`Empty`,
"label.version.lookupfield":`Lookup Relation Field`,
"lable.tianyancha.h5.searchf":`Not found`,
"label.validate.globalvariable.description":`$User.[Field API] eg: $User.id <br>The values you can use are: id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`Opportunity genius`,
"label.applt.copy":`Clone`,
"chatter.emailMessageOrReply":`Posts and Comments`,
"label.newreport.self":`Selected fields`,
"label.visualpage.checkpinxie":`Please check the spelling of the page.`,
"label.knowledgebase.article.attaching.case":`The article {name} has been attached to case!`,
"label.dialogbox":`Dialog Box`,
"label.summaryreport.step3.new":`Step 3 Selcet the data to summarize`,
"label.confirm":`Confirm`,
"label.mobile.buttom.team":`Team`,
"label.quickbooks.action.link":`Link`,
"vue_label_commonobjects_view_support_to_datas":`The operation supports up to 10 data`,
"vue_label_helpcenter_homepage":`Each user has two homepages from start, a standard homepage and a personal homepage. The administrator can assign a corresponding profile homepage to the user according to the user's profile. Note that the homepage of the Lightning version and the homepage of the old version are not interoperable.<br> 1. Standard homepage<br> The content of the standard homepage is uniform and non-editable. Including quarterly performance component, recently viewed component, approval center component, today's event component, task component, overdue business opportunity component, out of 30 days business opportunity component, and upcoming business opportunity component<br> Quarterly performance component: everyone can set their own quarterly goals<br> Recently Viewed Component: Display the 10 most recently viewed object records<br> 30-day non-contact business opportunity component: Show 5 business opportunities whose non-contact days are greater than 30 days and the probability is not 0 or 100<br> 2. Personal homepage<br> Everyone has a personal homepage, and the content on the personal homepage can be customized to add or delete components, or drag and drop to adjust the position and size of the components<br> There will be a briefing component, approval center component, overdue business opportunity component, and upcoming business opportunity component by default when opening an account on the personal homepage<br> Personal homepage allows up to 15 components<br> 3. Profile home page<br> Administrators can create/edit/delete profile homepages by customizing the homepage, and can assign different homepages to different profiles, so that users with different profiles can see different homepages<br> Up to 15 components per profile homepage<br> 4. Add components<br> Personal homepage and profile homepage can be customized to add components, you can add dashboard components, dashboard chart components and card view components<br> Dashboard component: add the entire dashboard in the system to the homepage. The number of sub-components in the dashboard represents how many components the dashboard component occupies (the homepage supports up to 15 components), and the data of the dashboard component after adding will not be associated with the original dashboard (that is, if the original dashboard is deleted, the dashboard component can still function) <br> Chart component in the dashboard: You can add a specific chart component in the dashboard in the system to the home page, and the linkage function of the component will be invalid at this time<br> Card view component: You can choose to add a certain view of an object as a data source to the home page, and fields and operation items can be customized. But note that if the data source view of the card view is deleted, the card view will have no data`,
"label.usersandlimit":`Users and Permission`,
"label.sendmail.step3.introduce2":`recipient(s) selected to receive this email.`,
"label.setupcustomfield":`Custom Fields`,
"label.layout.last.notdel":`The last one is not allowed to delete the layout.`,
"label.emailtocloudcc.redmessage7":`Configuration error, please contact administrator.`,
"label.includedIn":`Contained in {parentproductname}`,
"label.permission.detail.app.pagesetting":`Custom Page Settings`,
"label.addfile.tips":`{selectedNum} files have been selected. Up to {originNum} files can be added for a single time.`,
"label.fieldinformation":`Field Details`,
"label.campagin.roi.sjcb":`Actual Cost`,
"label.email.all.works.company":`All colleagues of company`,
"label.currencyDesc":`Use this page to define all the currencies used by your organization. Corporate Currency should be set to the currency in which your corporate headquarters reports revenue. If you designate a different currency as corporate, all conversion rates will be modified to reflect the change.`,
"label.file.details":`Details`,
"label.foldervisitlimit3":`Only following users can access this folder:`,
"label.account.next.M":`Next Month`,
"label.oweralias":`Owner Alias`,
"label.projectManagement.entryname":`Project Name`,
"label.customcomponent.page.add.title1":`Component Information`,
"label.projectManagement.PleaseenterCreator":`Please enter a creator`,
"label.multipleactivity.memberselected":`Selected Members`,
"label_chatter_memotel":`Memo-telephone`,
"lable.Confirm.customers":`Confirm to recover {num} leads.`,
"front-email-payment-Invoice-number":`Invoice No.`,
"label.not.appoint.validation":`No objects is specified for the validation rule, please specify.`,
"label.peru.time":`Peru Time`,
"label.setting.intergrationlist.status3":`QuickBooks login required`,
"vue_label_display_number_field":`Show Number Fields`,
"label_productline_count":`Product Family Amount`,
"label.data.downpage.i_title.num2":`2. Before you start importing, make sure that the field name in the file you want to import matched the object field name in the CloudCC.`,
"label.field.duplicate4":`Consider "ABC" and "abc" as different values (case sensitive)`,
"message.approval.step.validation.invalid.levels":`At least 1 level`,
"label.tianyancha.businessverify.step1":`Enable business data verification step 1`,
"label.hidedetail":`Hide Details`,
"UG_Lead_009":`APP call history`,
"label.partnerCloud.newProductSeries":`New Item`,
"label.brief.opportunities":`Total`,
"label.user.mfa.unbind.remind":`You are about to unbind the MFA to the selected users and need to rebind the MFA device after the next login, are you sure?`,
"vue_label_report_grouprow":`Group Row`,
"setup.layout.label.newarea":`New Area`,
"label.nostart":`Not Started`,
"UG_Lead_010":`Or`,
"label.emailmerge.mergepage.record.requeired":`Please select the records you want to merge.`,
"label.appointmentpage.wizard.notif1btn1":`Confirm`,
"UG.Account.02":`Some companies provide services to other companies, some directly collaborate with end users, and others serve NGOs.`,
"label.address.country":`Country/Region`,
"label.userinfo.updatepwd":`Change Password`,
"label.salescloud.teamrole.optionlist.opportunity":`Add opportunity team member to`,
"lable.account.Current.FY":`Current FY`,
"chatter.coll.p":`Bookmark this post`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Atlantic Daylight Time`,
"label.recordslock":`Record Lock`,
"button_partner_search":`Inquire`,
"vue_label_salesfunnel_notice4":`Amount of opportunities with a probability of 1% - 99%`,
"vue_label_report_statistics":`Statistics`,
"label.ccchat.notmember.active.group0":`You are not a member of any activity group with {0} in their name`,
"label.tag.manage.newtag":`New Tag`,
"label.customfileds.formula.dateandtime.tip":`Calculate a date/time, for example, by adding a number of hours or days to another date/time.`,
"label.weixin.mobile.fly.ios":`Share from mobile device (IOS)`,
"vue_label_file_over_file_size":`The file size of file.name  'exceeds the system preset!`,
"label.schedulejob.setup.schedule.last":`last`,
"label.ccchat.whose.name.contains":`of any active group whose name contains`,
"label.project.milestone.name":`You cannot have two milestones with the same name in one project.`,
"message.passwordPolicy.validate.reuse":`Error: You cannot reuse this old password.`,
"label.stdashbord.xsld.business.img3":`The Amount of Probability of 1%-99% * Probability`,
"label.event.view.list":`View List`,
"label.workflow.ruletriggertime":`Rule Trigger Time`,
"label.campaign.channel":`Marketing Channels`,
"label.appexchange.emailnotice":`Workflow Email Alert`,
"label.icon.77":`Agriculture`,
"label.visualpage.display.value":`Enter the values to be displayed, and note that there is no spaces before or after it.`,
"label.forecast.customforecast.type.user":`By User`,
"label_tabpage_lessz":`Less than`,
"label.same.analyze.contact.email":`Email`,
"vue_label_report_range":`Range`,
"lable.product.pricebooks.nr":`You can clone contents from existing price books by selecting from the picklist below.`,
"label_mobile_buttom_team_setUp":`Team Settings`,
"label.email.bcc.recipients":`Bcc recipients`,
"vue_label_ccchat_notice_deletepostfail":`Failed to delete post`,
"label_file_type":`File Type`,
"label.multilang.feedtrack.operateupdate":`An {0} record has been modified：`,
"label.contractmanager":`Contract Manager`,
"front-gantt-module-drag-one-task-sorting":`Tasks can only be sorted within the same milestone!`,
"label.partner.step2":`Step 2 confirm template`,
"front-epwechat-module-v1-again-binding":`Rebind`,
"label.service.miniProgram.imageSize":`No more than 2MB picture can be uploaded!`,
"setup_main2018_label_managesetup":`Administration Settings`,
"component_salesperformance_label_nopermission":`To view business opportunity related data, contact your system administrator.`,
"lable.account.stadate":`Fiscal Quarter Start Date`,
"label.service.gantt.and.resourcestype":`and resource type is`,
"label.ems.attachfiles":`Add Attachment`,
"label.data.expnode.e.desc1":`1、 Custom Export: users can select fields to export and set filter conditions according to their needs.`,
"vue_label_systemSettings_analyse":`Analyze`,
"label.project.all.date":`The end date must be later than or equal to the start date!`,
"vue_label_commonobjects_view_summary_basis":`Aggregation Basis`,
"template.chart.yywjhdschd":`Campaigns with Opportunities`,
"vue_label_pool_notmeet":`Non-conform customer requirement`,
"label.attendance.manager":`Manage Attendance`,
"vue_labenl_normal_current":`Current`,
"label.projectManagement.completed.quantity":`Completion Quantity`,
"label.layout.testfield":`Test Fields`,
"label.customfields.selectcontainrelatelistlayout":`Select the page layouts that should include this related list`,
"label.fiji.time":`Fiji Time`,
"message.error.domain.already.exists":`Domain name already exists.`,
"label.accountandcontact":`Accounts/Contacts`,
"label.dashboardSetup.right":`Right`,
"label.view.appliedMobile.xgry":`Check this item, the relevant users can see the view on the homepage workbench`,
"label.file.share.all":`Any user in your company`,
"vue_label_pool_summary":`Total {0} records(s), refreshed at {1}`,
"label.emailtemplate.new":`New Email Template`,
"label.tag.manage.button1":`Create new tag`,
"label.data.exp.tempexppage":`Data Export Template Page`,
"font-trade-module-v1-invoice-total":`Total Invoice Amount`,
"label.folder.sort":`Sort Folder`,
"label.multilang.campaign.countnum":`{0} time(s)`,
"label.homepagelayout":`Homepage Layout`,
"setup_layout_button_cancel":`Cancel`,
"lable.Search.in.QuickBook":`Search in QuickBook`,
"setup_fielddependency_label_pleaseclick":`Click on Controlling Field value to edit`,
"setup.fielddependency.label.pleaseclick":`Click on Controlling Field value to edit`,
"label.version.sum.field":`custom field(s)`,
"label.form.is.submitted.successful":`Prompt of successful form submition`,
"label.campaignmember.main.batchaddmember":`Batch Add Campaign Members`,
"label.sendemail.activity.newevent":`Dear #belongtoidccname, hello:\r\nyour colleague #createbyidccname has assigned you a new event in #createdate, which reads as follows:\r\n subject: #subject\r\n start time: #begintime\r \n end time: #endtime\r\n related items: #relatedstr\r\n content: #remark\r\nfor more details, visit this link:\r\n #path\r\n #orgNameCRM system`,
"label.knowledgebase.select.target":`Please choose a target`,
"setup.layout.label.buttonlist":`Select buttons`,
"pagecreator.page.label.pagedesc":`Page description`,
"label.version.professional":`Professional Edition`,
"UG.Forcast.10":`Complete`,
"template.chart.schdyqsr":`Expected Revenue from Campaigns`,
"front-filter-module-v1-quick-filter":`Flash Filter`,
"label.notification.group2":`You have successfully joined the public team`,
"label.ServiceCloud.statistics.by.serviceArea":`Statistics by Service Territory`,
"label.validate.function.funcExplain.TIMENOW":`Returns a time representing the current moment`,
"label.brief.lastmonth":`Last Month`,
"label.weixin.member.states":`Member Status`,
"template.chart.ljxsje":`Cumulative Sales Amount`,
"label.eidt.queue.label.hasused2":`This Queue Name already exists or has been previously used.`,
"label.textmessage.nophonenumber":`This contact does not have a cell phone number in record!`,
"label.task.new":`New Task`,
"label.tabpage.grid":`The grid display`,
"label.workbanch.setup.viewname":`View Name`,
"front-gantt-module-temporary-tasks":`Temporary Task`,
"label.reportTypeDescripe":`With custom report data source, you can enable users to create reports from the predefined objects, object relationships, and fields that you specify.`,
"setup_layout_label_fieldlist":`Available Fields`,
"label.ggReleaseRange.searchforRole":`Search partner role`,
"label.datamanage.account.field":`Account Fields`,
"label_tabpage_groupingemptyz":`Grouping items cannot be empty`,
"label.permission.edit.insertinfo":`Enter permission set information`,
"label.back_forms":`Back to Form List`,
"vue_label_calendar_step_2":`Step 2: Create a calendar from a standard or custom object.`,
"lable.outlook.mcto.out":`Excluded Domains`,
"label.workflow.accessnext":`Use this approval process if the following`,
"label.data.exp.temppage":`Data Export and Template Creating Page`,
"label_tabpage_printview":`Print View`,
"vue_label_report_preview":`To view the latest editing, please refresh and preview.`,
"frame_personinfo_label_personimage":`Profile Photo`,
"component.chatter.button.like":`Like`,
"label.ems.drafts":`Drafts`,
"front-lightning-module-v1-details-page-chart-report-name":`Report Name`,
"label.partner.workspace.login":`Login Page`,
"include":`includes`,
"label_length_20":`Confine length to 20 characters.`,
"component_event_button_save":`Save`,
"label.weixin.recalculate.shared.success":`Object sharing rule recalculation success.`,
"message.duplication.errorinscript.lessthan2":`You must select at least two records to merge.`,
"label_my_forecast":`My forecasts`,
"label.ems.to":`Receipient`,
"label_mobile_buttom_team_init":`Team User Initialization`,
"label.sendemail.send.codeerror":`Code conversion failed, please enter the correct encoding.`,
"lable.quote.syncing.and":`and`,
"label.campaignmember.selectmember.step1oftotal":`Step 1 of 2`,
"label.ems.step3":`Step 3`,
"lable.PowerProcess.detail.message":`Information of Milestone Process`,
"chatter.poll.option2":`Choice 2`,
"front-view-module-v12-verify-number":`Error of numeric format. Please check the input data.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`The swift function settings saved.`,
"lable.outlook.edit.zdyoutfi":`Custom Exchange Field Name`,
"label.assignment.setup.newentries.inputentries":`Enter the rule entry`,
"label.customfields.money.tip":`Allow users to enter a dollar or other currency amount and automatically formats the field as a currency amount. This can be useful if you export data to Excel or another spreadsheet.`,
"label.service.appointmentList.cancelThePlan":`Cancel Plan`,
"label.chat.topic.suggest.add.topic":`No suggestion, add your own topic.`,
"vue_label_commonobjects_detail_tips":`Tips`,
"message.error.view.nameexists":`Error: The view unique name already exist.`,
"label_emailtocloudcc_step2_name":`Configue Email Attribution`,
"label.field.validation.apiname":`It must begain with a letter.It must contain only uppercase and lowercase letters,numbers,and underscore.And the maximum length is 50 characters, minimum length is 2 characters. Please note that it cannot be a database keyword.`,
"page.field.masterinput.remark2":`For example, when you create a new order, you need to enable this feature to enter the order line entries in the same page. (this feature is well suited for objects in the master-detail relationship.)`,
"label.rule.enabled.successfully":`Enable the rules successfully`,
"label.role.createrolelist.tip":`Below is a list of the roles for your organization. You can view more information by clicking the role link.`,
"label.multilang.datamanage.dataimport.redundantmsg":`The length of the title is &nbsp;{0}&nbsp;, but the length of the data is &nbsp;{1}&nbsp;, the system cannot determine which &nbsp;{2}&nbsp; fields are redundant.`,
"label.visualpage.staticresource":`Introduce Static Resource`,
"chatter.group.members01":`Members`,
"label.planned.workname":`Job Name`,
"label.service.dispatchingUnits.gantt.data":`Match Gantt Date`,
"label.data.newtemplate.t.conditions":`Template Conditions`,
"label.accmarketsea.edit.title":`Account Pool Edit`,
"label_chatter_priority":`Priority`,
"label_mobile_buttom_team_open":`Enable Team on PC & App`,
"front-gantt-module-no-tasks-available":`No available tasks`,
"component.newrecords.label.type":`Storage type`,
"label.version.ccdocument.and.remark":`Notes & Attachments`,
"label.martrixreport.step2":`Select the grouping mode used to calculate the data you want to roll-up`,
"label.projectManagement.Scheduleinformation":`Timesheet Information`,
"label.emailmerge.mergeFolder.description":`On this page you can create a Microsoft Word document contains your contacts data. Please select mail merge templates, up to 20.`,
"label.autoRegister.changepwd.setpwd.tip":`The password needs to meet the following conditions`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`The cart is empty, please click "Add Products" to add.`,
"label.marketcloud_seminar":`Marketing Cloud Seminar`,
"label.knowledgebase.no.results.knowledge.search":`No results about "{a}" in Knowledge`,
"label.createdate":`Created Date`,
"vue_label_systemSettings_bazaar":`Market`,
"report_type_label_contractPayment":`Contracts and Receivables`,
"label.myemailset":`My Email Settings`,
"label.emailtype":`Email Type`,
"label.appexchange.uninstallpage.message5":`Permanently delete all relationships and related lists associated with the custom objects in this package`,
"label.customerinfo.applicationlicencenum":`Feature Licenses Number`,
"label.product":`Products`,
"lable.opppdt.selPdt.subtitle":`Product Selection For`,
"label_emailtocloudcc_step1_lead1":`Email to Lead`,
"label.multilang.recentview.query":`See your latest {0}`,
"label.cumstom":`Custom`,
"lable.product.pep":`Please enter the price.`,
"label.suggestion":`Ideas`,
"vue_label_email_sentto":`sent`,
"label.email.cancel":`After the association is cancelled, the mailbox cannot be used to send or receive emails. Are you sure to cancel the association?`,
"component_timeline_label_1monthahead":`1 month before`,
"setup_mainpage_label_welcome31":`Instructions: Click on the menu on the left side of this page → Manage Settings → Create → Application`,
"label.weixin.settlement.rate":`Payment Completion Rate`,
"front-lightning-module-v1-details-page-chart-add-report":`· A maximum of 4 charts of report can be added.`,
"label_related_list_types":`Types of Related List in Lightning`,
"label.tabpage.converstatez":`Converted state`,
"label.chatter.ok":`Confirm`,
"lable.SalesCommitmentKanBan.contractRate":`Signed Rate`,
"component.setup.label.setupsavefail":`Failed to save the component settings`,
"label.email.form.text2":`[switch to html]`,
"UG.Lead.009":`APP call history`,
"label.escalation.setup.newrule.title":`Case Escalation Rule`,
"label.field.available.value":`Available Field Values`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Activated fail`,
"label.dashboard.show.total.percent":`Show total or show %, please choose at least one`,
"label.schedulejob.setup.schedule.jobprg":`Job Programs`,
"label.select.email.type":`Please select Email type!`,
"chatter.group.allTheMembers":`All Members`,
"label.webtab.validation.apiname":`It must begain with a letter.It must contain only uppercase and lowercase letters,numbers,and underscore.And the maximum length is 20 characters, minimum length is 2 characters.`,
"label_partner_new_step3_name":`Name`,
"vue_label_chatter_remove_member":`Remove member`,
"label.customobjects.majorobject.tip":`If you select a non principle-detailed relationship object, the summary data does not take permissions`,
"label.forecast.edit.kjjd":`Fiscal Quarter`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Three`,
"label.weixin.senderror":`Send failed`,
"label.visiturl":`Visit URL`,
"label.apply.img.error":`The character input in the gragh is incorrect`,
"label.been.detained":`Reset Discount`,
"vue_label_helpcenter_dashboard2":`<br> In the newly created dashboard, you need to add components first, and select the report data source or list view data source. Then determine the type of chart used and select the corresponding grouping and statistical data to create the chart<br> After adding the components, you can click the "Reorder" button on the dashboard to adjust the position and size of the components. <br> If you need to set time filter conditions for some components, you can click "Filter Condition Settings" to select the component to set the time field that the component needs to filter. After setting, you can filter by time on the dashboard and select the corresponding time range to update the selected data. <br>Note: A dashboard supports up to 10 components. <br> 2. Penetration and linkage of components<br> In the same dashboard, component A can set component B and C from the same data source as its linkage objects. After the setting is completed, click on a data area of component A, component B and component C will simultaneously perform data re-count based on the data area conditions of component A. <br> Note that clicking the data area of component B or component C will not cause component A to re-count. If you need to achieve this effect, you need to set component A as its linkage object on component B/C. <br> For each chart component in the dashboard, the data comes from the view or report. Therefore, a penetration function is provided, that is, clicking the data area of the component can jump to the corresponding report and list view. Note that if the original data source fails, the component will have no data and the penetration function will also fail. <br> Since both penetration and linkage are the component's data area for clicking, they cannot both take effect at the same time. If the component has both penetration and linkage set, then the component can only have one function take effect at the same time, and you can chose function in effect by switch the linkage and penetration states.`,
"vue_label_commonobject_view_notice_delete_false":`Data {0} failed to be deleted, reason is {1};`,
"label.weixin.newspaper.coverage.information":`Risk Sheet Details`,
"label.you.do.not.have.permission.to.operate.":`You don't have the access to operate.`,
"label.checkfield.match":`Match`,
"message.custom.field.donotdelete.ref":`This field is referenced by other fields`,
"label.version.maxsum":`, has reached the upper limit.`,
"System.ChangeUser.Info.001":`Owner changed and click to return to the previous page.`,
"label.target":`Targets`,
"template.dashboard.behavior.analysis":`Actions Analysis`,
"label.login.verification.enter.prompt":`Please enter a 6-digit digital security code`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Allow users to receive CCChat emails when someone follow you, comment on your post, and more.`,
"label.accmarketsea.grouplist.title":`Account Pool Group Setting`,
"label.stdashbord.xsld.business.danwei":`Unit: 10 Thousand`,
"label.app.step1.error.namenull":`You must enter the public group name.`,
"label.login.button.verification":`Submit to verify`,
"label_tabpage_newWizardz":`New added function wizard`,
"label.addattachment.step1.intruduce":`Enter file path or click button to find the file.`,
"pagecreator.layout.funcpath":`/ builder / layout library`,
"fourth":`The Fourth`,
"label.timetrigger.after.lasttime":`One day later than the last modify date.`,
"vue_label_report_showme":`Show Me`,
"label.h5.similar.opportunity.end.date.in":`End date is within the following period`,
"label.turntonextstep":`Turn to Next Step`,
"label.icon.106":`Schedule`,
"label.user.receivenewsbulletin":`Receive News Broadcast`,
"label.mask.card.number":`Credit Card Number`,
"setup.object.layout.label.profileoptions":`Available Profiles`,
"vue_label_systemSettings_obj":`Objects and Fields`,
"label.call.center.history.open":`Automatically open call history page`,
"label.attendance.cityname":`Please enter the city name`,
"label.newemailnotice.tip":`Create an email alert to associate with one or more workflow rules or approval processes. When changing an email alert, any modifications will apply to all rules or approvals associated with it.`,
"label.app.step1.error.labelnull":`Error: Label can not be empty.`,
"front-kefu-moudle-connect-free-account":`Associate CloudCC Users with TRRT's Trial Accounts`,
"label.biaoqingfaxian.description":`With bid&tender discovery enabled, a menu of bid&tender discovery can be added to the front-end, where users can view bid information of relevant industries and convert bid data into leads in the system.`,
"label.filter":`Filter`,
"label.data.downpage.e.title.num1":`1、Select the objects you want to export,or choose to export all.`,
"label.h5.similar.opportunity.last.months12":`Recent 9-12 Months`,
"label.chatter.name":`Name`,
"vue_label_helpcenter_email":`1. Send mail<br> Leaving the system to go to your mailbox to communicate with contacts has been out of date. On Cloud CC, you can link your personal email address to send emails directly from Cloud CC. When you enter the email address or name of the recipient, it can match your contact or leads record for you. You can also associate mail records with related records that have been configured, and the mails you send will be synchronized on the record details page.<br> 2. 4 common functions when sending emails<br> When sending an email, you can use the 4 functions below the text of the email to assist your work.<br>Mail tracking<br> When you turn on email tracking, we will help you monitor the number of times this email has been opened and when it was last opened. You can hover your mouse over the "eye" icon in the outbox list to view it.<br>Upload Attachment<br> Click Upload attachment, you can select the file that has been uploaded to the system, or you can choose to upload the file. You can select multiple attachments, as long as the size of the attachment is less than 20M.<br>Insert merged fields<br> When the email is associated with an object record, you can click to insert the merged field, select the associated object, select the field you want to insert, and enter the replacement text after the comma in the merged field, such as {!Contact.FirstName,Sir or Madam }. When saving the template, the merged fields will be displayed in the email text of the template. Use merged fields to personalize email content. You can add replacement text to any merged field. The replacement text is displayed only when the merged record does not contain the data of the field.<br>Edit and enable signature<br> When you are sending work emails, a signature that can represent your identity will help improve your work professionalism. Click the "Edit Signature" button, you can edit your basic information, and support you to insert pictures. If you check "Enable Signature", your signature will be attached to the body of the message every time you compose an email. You can turn off the signature at any time.<br> 3. Filter the inbox<br> You can filter all unread mails in your inbox to facilitate your work. When you want to download files via email, you can filter all emails with attachments in your inbox, so you can quickly locate the email you need. In addition, you can quickly see the records of customers in the system that you track through emails by screening emails containing open business opportunities or screening emails sent by leads or contacts.<br> 4. Mass mailing<br> There is a button for group mailing in the upper right corner of the list of leads and contacts. You can send bulk mails to potential customers or contact records with email addresses. When you have a record of marketing activities, you can send emails to members of the marketing activities in batches, which is also convenient for you to send event invitations.`,
"front-kefu-moudle-auto-callphone":`Autocreate new cases for connected calls`,
"label.fiscal.FQ":`Fiscal Quarter`,
"label_tabpage_groupsVisiblez":`Selected user groups`,
"UG.product.01":`List products/services`,
"vue_label_commonobjects_view_members":`Available Members`,
"label.organization.id":`Organization ID`,
"label.tyle_preview":`Style Preview`,
"label.campaign.channel.input.to.owner":`6. Please set up whether to notify their owners when the campaign members sign in:`,
"label.appointmentconfirmpage.wizard.notif1":`The appointment has been cancelled!`,
"lable.tianyancha.maping":`Field mapping`,
"front-kefu-moudle-v1-noadd-online-chats":`Online agent is not added`,
"vue_label_commonobjects_detail_group_strategy":`Are you sure to enter the account Team?`,
"vue_label_report_deletegrouprow":`Delete Group Row`,
"lable.account.y.d":`This page allows you to define a custom fiscal year record. Dates for the custom fiscal year will be generated based on the choices you make below.`,
"label.visualpage.lllegal.definitions":`Invalid Definition`,
"label.tabpage.enterrecordnamez":`Please enter the record owner`,
"vue_label_report_howmuchlines":`{length} lines`,
"homepage.components.custom":`Custom Components`,
"label.campaign.channel.upload.img":`Upload Image`,
"UG_Case_03":`Automatic case upgrading`,
"label.approved.receiveApprovalEmail.option4":`Never`,
"System.Data.Import.Warning.MaxCount":`Your organization can only import {0} pieces of data at a time, which is now out of the limit, please adjust and re-import.`,
"label.sent.sms":`sent an SMS`,
"vue_label_dashboard_statistictype":`Statistic Type`,
"label_report_last_year_same":`Same Period Last Year`,
"lable.Examle":`Examples`,
"label.customerinfo.PageTriggerFagTitle":`It takes two hours to synchronize.`,
"label.mobile.phone.read":`Revise`,
"label.product.gopage":`Go to Page`,
"label.a_b_without":`"A" records may or may not have related "B" records.`,
"front-kefu-moudle-callin-missphone":`Calling in missed calls`,
"label.sso.saml.sp.idsource.attrname":`Attribute Name`,
"label.h5.chatter.colleagues2":`Colleagues`,
"label.approveprocess":`Approval Processes`,
"label.dataimport.error.name.null":`Error: name is null`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`When advanced filtering is not enabled, different filtering conditions are "and", that is, records satisfying the common characteristics of 1 and 2 are displayed in the report. For example: 1 is a business opportunity with an amount greater than 1 million, and 2 is an estimated contract date equal to this month, so the report result is more than 1 million business opportunities this month.`,
"front-lightning-module-v1-dashborad-export-picture":`Export Image`,
"label.activity.disabled":`No activity enabled, please contact your system administrator to enable activity history and unprocessed activities on the page layout.`,
"message_chooseatleastonefield":`Please select at least one field to display.`,
"label.case.text":`Service request forms submitted through the website can generate case records in the system. Please select the user as the creator of the case record, and the selected user needs to have creation permission for the case object. The webpage is available for computers and cell phones.`,
"label.sendmail.step3.dealoption1":`BCC me on one message`,
"label.forecast.settings.title.remark":`The best estimated revenue value for users provides a complete business view for users`,
"label.apply.youxiaotime.finish.opperation":`You have 5 minutes to complete the actions. Please ignore this message if the operation is not in person.`,
"label.user":`User`,
"pagecreator.page.button.copy":`Copy`,
"label.userinfo.pwdupdate.or.reset":`Your password was last changed or reset on`,
"label.fieldupdata":`Field Updates`,
"label.sendemail.chat.followsubject":`CloudCC CCChat has someone follow`,
"component_task_label_enddate":`Expire date`,
"label.campaign.channel.step6.remark5":`You can reassign it through Lead Assignment Rules. Know more about Lead Assignment Rules.`,
"label.mr.title.mobilePhone":`Mobile`,
"label.notice":`Reminder`,
"message.serviceappo.time.violation":`Available time violation of service appointment: The aranged start time of the service appointment is later than the earliest available start time.`,
"label.account":`Accounts`,
"front-kefu-moudle-callcenter-user":`Call Center Users`,
"label.usermanage.query.notexist":`The query user does not exist.`,
"label.forecast.userinfo.isnable":`Allow Forecast`,
"label_partner_workspace_member":`Member`,
"vue_label_dashboard_penetrationsetting":`Penetration Setting`,
"chatter.fieldtrack.operatecreate":`created a`,
"label_tabpage_tpcustomersz":`Convert leads`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP authentication failed, please check that the email address and password are correct.`,
"label.customfields.file.upload":`Upload`,
"label.forecast.isforecast":`No Forecast enabled`,
"label_benchmark":`Reference`,
"label.exchange.sync.state.system":`System Sync Status`,
"UG.opportunity.003":`Track your sales channels, create dashboards`,
"label.campaign.matchway.select.error":`To update the data, please select the matching method`,
"vue_label_dashboard_located":`Dashboard Folder`,
"front-electronic-signature-enter-object":`Please enter the object`,
"vue_label_systemSettings_mobelquick":`Mobile Applications Quick Setup`,
"lable.outlook.list":`Exchange Sync Configurations`,
"label.sendemail.approval.dlsp":`Hello, #dlspr:\n #actorname#objapiname-#recordname submitted by #actordate has been set as your proxy approver by the original approver #spr and is waiting for your approval.\nplease click on the link below or login to the crm system to enter approval center for approval:\n#url\n thanks! \n#orgname`,
"label.service.deleteCustomView.wanttoremove.filter":`Are you sure you want to remove the "{name}" filter?`,
"component_task_label_newevent":`New task`,
"vue_label_commonobjects_view_chart_groupby":`Group By`,
"front-kefu-moudle-v1-edit-chats":`Edit Agent`,
"pagecreator_page_message_delete_fail":`Page deletion failed`,
"label.file.search":`Search Files...`,
"label.projectManagement.Addpredecessors":`Add pre-task`,
"label_tabpage_norecordtypez":`Unusable record type`,
"label.come.recycle.bin":`Go to Recycle Bin`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relative`,
"label.customfields.address.tip":`Allow users to select province, city, and county fields, and enter specific address information that can be used to calculate latitude and longitude.`,
"label.weixin.optioneight":`Choice 8`,
"label.recordtypeselect.modify":`Edit Record Type`,
"label.forecast.settings.future3":`Future 3 cycles`,
"label.rename":`Rename`,
"label.emailtocloudcc.button.complete":`Finish`,
"chatter.new.at":`Most Recent Activity`,
"component.setup.label.milestonesfield":`Milestone field`,
"vue_label_commonobjects_detail_email_newaddress":`Send To`,
"lable.PowerProcess.big.event":`Milestone:`,
"label.appexchange.uninstallpage.confirm":`Yes, I want to uninstall this package and permanently delete all associated components`,
"label_mobile_buttom_homepage":`Homepage`,
"label.sso.saml.idp.config.logouturl":`Single Logout URL`,
"lable.quote.pdf.button.savetoquote":`Save To Quote`,
"label.page.select.application":`Select the custom apps in which you want to use the new custom tabs. You can also view or modify whether a tab appears on the detail page and edit page of each custom app.`,
"chatter.down":`Download`,
"label.tabpage.searchz":`Search`,
"label.emailsync.form.action":`Action`,
"label.campaignmember.setup.campaignmember.field":`Fields of campaign members`,
"label.version.remark":`Note: Free Edition only allow create 5 users, 2000 records and you cannot import or export data.`,
"label.selectoperateobject":`Select the object.`,
"label.appointmentdetail.wizard.title12":`Book Time`,
"label.submitforapproval":`Submit for Approval`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`The lower bound for editing each level of discount shall equals to the upper bound of the last level.`,
"label.appupload.install.component.view":`Views Components`,
"label.profile.customobjcontrol":`Custom Object Permissions`,
"label.customfields.configprofilefieldsafety.tip":`Select the profiles to which you want to grant edit access to this field via field-level security. The field will be hidden from all profiles if you do not add it to field-level security.`,
"label.service.gantt.service.resources":`Service Resources`,
"label.input.right.emailaddress":`Please enter the invalid email address.`,
"label.ccdocument.folder.notedit":`The folder is not editable.`,
"label.data.choses.i.desc":`According to your needs, import data from a single object.`,
"label.icon.75":`Car`,
"label.summaryreport.step4":`Step 4 Choose the columns of the report`,
"label.appupload.upload.install":`Install`,
"label.reportlist.newfolder":`New Report Folder`,
"label.projectManagement.myproject":`My Project`,
"label.true":`TRUE`,
"label.tabpage.reallproplez":`Record Owner`,
"label.change.lead.share.error":`No right for editing customer`,
"F":`Date/Time`,
"lable.account.CurrentandNextCQ":`Current and Next CQ`,
"UG.activity.06":`Want to follow up with accounts`,
"UG.contact.03":`Track contacts in one place, sales signals`,
"label.field.duplicate.error.msg2":`Unique property setting failed`,
"label.sales.dashboard.reality":`Actual Payments`,
"lable.PowerProcess.type":`Type of Entitlement Process`,
"batch.selected.data":`Selected Data:`,
"#label.importsourcefilestep2":`Step 2 Compress your file(Optional)#`,
"label.emailtemplate.select":`Please choose the Email template you want to use.`,
"chatter.most.w":`You can enter up to 500 characters`,
"vue_label_calendar_new_object_calendar":`New Object Calendar`,
"label.aggregated_formsdata":`Aggregate Forms Data`,
"label.knowledge.language.french":`French`,
"label.customfields.enc.tip":`Allow users to enter any combination of letters and numbers and store them in encrypted form. And they can not be searched.`,
"label.icon.158":`Cloud`,
"font-evaluate-module-v1-bad-review ":`When the type of evaluation is Negative`,
"UG_quota_03":`Quote template`,
"label.eidt.queue.label.hasused":`The label is already in use`,
"label.lookupfilter":`Search Filters`,
"label.callcenter.Instance.name":`Instance Name`,
"label.commitertype":`Submitter Type`,
"vue_label_checkduplicate_any_one":`Match Any One`,
"label.campaign.channel.input.img":`Please select the image from your local computer as a thanks page`,
"vue_label_dashboard_pleaseenterafoldername":`Please enter a folder name`,
"label.tianyancha.look":`View`,
"label.tabpage.lastone":`Select at least one operation`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} is waiting for your approval`,
"label.chat.topic.delete.prompt1":`Deleting a topic takes time, the topic will continue to be preserved in posts and records until the process is complete.`,
"component_setup_label_displaybutton":`Display button`,
"label.partnerCloud.backgroundImage":`Background Image`,
"label.mobile.phone.time.range":`Date Range`,
"label.page.url.address.remark":`Enter the web page address in the "Link URL" field. You can enter a simple URL just as it appears in the browser address bar, or you can use one or more merge fields to insert organization-specific data from CloudCC.com into URL parameters. Some sites may not work in a Web tab because of browser security settings, or because the site has prevented itself from being displayed in a frame.`,
"label.h5.copyemail":`Email has been copied`,
"label.view.step3":`Step 3 Select Fields to Display`,
"label.quickbooks.view.moneyreceived":`Receivables`,
"label.emailobject.attachment.preview":`Preview`,
"label.selectapprover":`Select Approver`,
"vue_label_normal_opportunity_sf":`Opportunity`,
"label_emailtocloudcc_filed_port":`Port`,
"mesage.errorinsaving":`An error occurred during save. Please contact your administrator.`,
"label.partnerCloud.partnerCloudName":`Please enter the name of partner cloud`,
"lable.edit.queue.checkemail":`Error: Invalid Email Address.`,
"label_builder":`Page Builder`,
"component_setup_label_setupsavefail":`Failed to save the component settings`,
"label.icon.76":`Car`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Monthly`,
"message.nopermession":`No Permissions`,
"label.view.groupscansee":`Visible to <b>certain groups of users</b>`,
"label.leadscore.rule.new":`Lead Scoring: New Rule`,
"label.new.ccpeakfolder.time":`Scheduled Classes: New Folder`,
"label.record":`Records`,
"message.error.flabel":`The field labels you provided cannot contain English single or double quotation marks.`,
"label.emailobject.emaildetail.promptbutton2":`Cancel`,
"label.h5.phone":`Phone`,
"label.visualpage.error.deal.with":`An error occurred, please contact your administrator`,
"label.button.step1.select.field":`Step 1 Select fields`,
"label.setsharerule.step1":`Step 1 Select your rule type`,
"component.chatter.file.label.title":`File upload`,
"front-epwechat-module-v1-appname":`App Name`,
"chatter.error.notsel":`Error: Please select an image to upload.`,
"label.updatevalue":`Value Changing To`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} posted documents for all in {1}`,
"label_tabpage_grid":`The grid display`,
"homepage.components.standard":`Standard Components`,
"label.movable":`Activities`,
"label.report.selected.field.cannot":`Selected fields cannot exceed 50.`,
"label.projectManagement.distribution.by.excess":`Over Allocated by`,
"addrow":`Add Row`,
"label.approvaldatamove.p":`Use the following options to manage multiple approval requests. Click "Find" to filter approval request. When the results are displayed in a list view, please specify the action.`,
"label.passwordPolicy.setup.title":`Password Policies`,
"label.appointmentpage.wizard.title1":`{0} ({1}) is inviting you to`,
"label.tippage.li1":`Permanently delete custom report data source`,
"label.campagin.roi.dcl":`Attendance Rate`,
"label.h5.new.errorbody":`These required fields with * must be completed.`,
"label.cy.enable":`Enable Currency`,
"label.currency.rate.e":`Edit the conversion rates for your organization's currencies.`,
"or":`Or`,
"lable.custom.Previous.CYt":`Previous 2 CY`,
"front-epwechat-module-v1-unbound-desc":`Remove binding will clear the bound account. Are you sure to unbind?`,
"pagecreator_button_publish":`Publish`,
"font-evaluate-module-v1-case-owners":`Notify case owner:`,
"label.pw.new":`Please enter a new password`,
"message.tabsearch.nokeywords":`Please enter a keyword of at least one character length`,
"label.sendemail.send.erroruser":`Incorrect user`,
"label.personalinfo":`My Personal Information`,
"label.case":`Cases`,
"lable.product.pricebooks.now":`Existing Price Books`,
"label.ccpeak.take.notice":`Note: ID, Auto Number, Created By, Created Date and other system fields do not need enter the values.`,
"label.page.first":`The 1st Page`,
"label.icon.168":`Sights`,
"label.choices":`Select`,
"label.is.delete.document":`Are you sure you want to delete this file?`,
"homepage.layout.custom":`Custom Layouts`,
"label.emailobject.template.insert.field":`Fields`,
"label.ccpeak.folder.all":`All Class Folders`,
"front-console-conversation-btn3":`Forward Email`,
"label.ems.port":`Port`,
"label.app.introduce":`An app is a group of tabs that work as a unit to provide functionality. Users can switch between apps using the app drop-down menu at the top-right corner of every page.`,
"label.file.library.managemembers.admin":`Library Administrator`,
"vue_label_salesadvance_win":`Won`,
"label.email.click.complete.info":`Click the "finish" button to return to the previous page.`,
"label.umeng.activity.event.willbegin":`Your event #event starts in #time.`,
"label.mobile.phone.week.summary":`Weekly Summary`,
"label.quickbooks.fieldlabel.terms":`Terms`,
"lable.currencyManage.advcurrencyEnabled.dis":`Allows you to manage dated exchange rates that map a currency conversion rate to a specific date range. Dated exchange rates are applied to currency fields on opportunities, opportunity products, and the reports associated with these two objects.`,
"label.weixin.data.save.failed":`Failure to save data.`,
"label.service.gantt.filter.logic":`Filter Logic:`,
"vue_label_pool_adopt":`Collect`,
"label.emailobject.markasunread":`Mark as unread`,
"label_please_select_a_member":`Please select members.`,
"label.salescloud.unit.ci":`Unit(Time)`,
"vue_label_pool_obsolete":`discarded`,
"label.cancelall":`Deselect All`,
"label.exchange.sync.state.setting.m2":`Users in active CloudCC Exchange configurations:`,
"vue_label_pool_claimtime":`Collect Time`,
"label.forecast.forehistory.history":`Forecast History`,
"label.knowledge.article.record":`The knowledge article is unqualified.`,
"label.setting.intergrationlist.button.uninstall":`Uninstall Integration`,
"label_tabpage_gotit":`Got it`,
"label.data.exp.csvform":`Valid only for exported data.`,
"UG.Forcast.06":`Please select the users who are allowed to forecast`,
"vue_label_report_savereport":`Save Report`,
"setup.object.field.dependency.label.mustone":`You must select 1 value of the dependent field at least.`,
"label.batchadd.newbatchpage.des1":`Name field of the record is required, and if not, the record is not saved.`,
"lable.custom.CurrentandPreviousCYt":`Current and Previous 2 CY`,
"label.versiontype.Professional":`Professional Edition`,
"label.customfields.configprofilefieldsafety":`Establish Field-Level Security`,
"label.ccpeak.wgd.time":`Unfiled Scheduled Classes`,
"component.telerecord.label.subject":`Theme`,
"label_year":`Year`,
"pagecreator_layout_label_modifylayout":`Layout editor`,
"label.compact.layout.frame.splitline":`Seperation line of right screen and left screen`,
"lable.PowerProcess.enter.the.process":`{describeName} Entry Process`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Please select the imported data`,
"label.setup.mobile.bottombutton.recovery.default.success":`Successfully restored default?state`,
"label.datamanage.import.accountfield":`Select the fields in the import file that should be imported to each account from the list below. Then click "Next Step":`,
"vue_label_opportunity_related_list":`Add to related list`,
"label.group.recent":`Recently viewed groups`,
"vue_label_pool_finalclaimtime":`Final Collect Time`,
"vue_label_homepage_30daysnocontact":`No Contact Opportunities for 30 Days`,
"label.tianyancha.field.error":`Tianyancha data has not been found, please contact the system administrator to perform initialization`,
"label.product.go":`Go to Reports`,
"label.customsetting.manage.introduce":`If the custom setting is a list, click New to add a new set of data. For example, if your application had a setting for Country codes, each set might include the Country name and dialing code.`,
"label.task.dateadd":`Plus`,
"label.email.recipients.select":`Please select the recipients`,
"chatter.emailListMyChat":`Likes a post or a comment I made`,
"label.batchadd.newbatchpage.save.name":`If the name is null, the system will not add this record by default, make sure the name is not null, and then save.`,
"UG_Lead_011":`Create a clue`,
"vue_label_salesfunnel_notice2":`Total Ongoing Opportunities`,
"APPIntegration_Social_linkedinerror":`You must enter a valid URL for linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Real-time Query Account Name`,
"label.stdashbord.xsld.business.ajssx":`By Role`,
"lable.info.queue.showalluser":`View All Users`,
"label.generatepage.c1":`It must begain with a letter.It must contain only uppercase and lowercase letters,numbers,and underscore.`,
"label.thenset":`And Then According`,
"label.salescloud.salescloud.defaultteam":`Default opportunity team of user`,
"label_partner_workspace_tab_selectedoption":`Selected tabs`,
"label.tippage.li":`Delete custom report data source will：`,
"lable.quote.syncingfrom.syncingto":`Opportunity products have been been synchronized to quote line items`,
"label.emailobject.delete":`Delete`,
"label.data.selectimportobject":`Select the object to import to`,
"label.knowledge.language.dutch":`Dutch`,
"message.campaign.page.overtime":`The page has expired.`,
"label.ccchat.message.search.desc4":`Check the spelling of search words.`,
"label.login.forgetPsd":`Forget password`,
"vue_label_title_order":`Order`,
"template.report.contract.follow.status":`Followup Status of Contract`,
"label.forecast.edit.kjnd":`Fiscal Year`,
"front-electronic-export-listTitle":`Mailchimp List`,
"label.dataimport.error.khmc.notnull":`Error: You must enter the account name`,
"label.testobject":`Test Object`,
"label_chatter_nextStep":`Next Step`,
"label.file.public.link.share":`Public link sharing`,
"label.weixin.organization.name":`Organization Name`,
"label.quote.email":`Email`,
"label.reg_field":`Regular Field`,
"font-evaluate-module-v1-response":`Reply after evaluation:`,
"label.chatter.sendmail":`Send Email`,
"label.weixin.start.incorrect":`Invalid formatof start date`,
"component_chatter_link_label_url":`URL Link`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Yes, I want to enable Advanced Currency Management.`,
"label.east.africa.time":`Eastern African Time`,
"label.product.proof.Three":`In {0}, please choose a minimum of {1} product options, but up to {2}.`,
"label_emailtocloudcc_filed_password":`Password`,
"component.task.label.person":`* Assigned  To`,
"pagecreator_systemstyle_label_buttonareacolor":`Operation area color`,
"label.clearrule":`Clear Rules`,
"lable.customer.access":`Account access permission`,
"label.finish.wait":`Your request has been processed, please be careful to check the completion notification in your mailbox.`,
"label.weixin.appr.auditor":`Approver`,
"label.tabpage.systemz":`System(s)`,
"label.file.nocan.process.desc":`Unable to process request. we cannot handle content delivery`,
"label.relationobject.name":`Related Object Name`,
"setup.layout.group.relatedlist":`Related Lists`,
"label.generatepage.title":`Web to CloudCC Page`,
"label.page.step3.input.url.information":`Step 3 Enter the URL Details`,
"label.change.to":`Change Campaign Member Status To`,
"label.validate.function.funcFormat.TIMEVALUE":`TIMEVALUE(date)`,
"label.partnerCloud.seriesSettings":`Product Family Setup`,
"component.timeline.label.1monthahead":`1 month before`,
"label.batchadd.senumberpage.selnum":`Select the number of records to be added`,
"label.downloadapp":`Download App`,
"label.dashboardSetup.showmainpage":`Displayed on Homepage`,
"label.h5.nophoneprompt":`The colleague did not enter the contact number`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Do you want to delete the filter “{name}”?`,
"label.appupload.state1":`Uploaded`,
"component_timeline_button_filter":`Filter`,
"label.passwordPolicy.setup.subtitle":`Set the password restrictions and login lockout policies for all users.`,
"vue_label_normal_quote_sf":`Quotes`,
"label.productsales.today.noevttskaddall":`There are no open events and expiring tasks, you can click “ ” in the upper right corner to add new event and task.`,
"label.projectManagement.no.end.date":`No end date`,
"label.sendmail.batch.chosetemplate":`Batch Email: Select a template`,
"serviceterritorymember.serviceresource.isactive.notactive":`This service resource is not enabled. You can assign the service territories to an enabled service resource.`,
"label.notification.event.overlapEvent.continue":`Continue`,
"label.appupload.component.type.obj":`Custom Object`,
"label.partnerCloud.financeSetting.basicConfiguration":`Access Path: Public Platform  Development  Basic Configuration`,
"lable.outlook.detail.info":`Exchange Sync Configuration Details`,
"vue_label_commonobjects_detail_activity_commingevents":`Available upcoming event`,
"coderules.nullvalue2":`Failed to generate. Please enter the value for 【{0}】,【{1}】 used in the generation rules.`,
"label.version.sum.workflowrule":`workflow rule(s)`,
"label.sso.saml.idp.config.enable":`Enable Identity Provider`,
"label.temp.exp.conf":`Are you sure you want to export the template?`,
"label.department":`Department`,
"label.trigger.operation.email.template":`Get Email template information`,
"label.page.content.frame.height":`Content Frame Height (pixels)`,
"label.ServiceCloud.jinengyaoqiu":`Skills Requirement`,
"PageLayout.Search.MultiSearch.001":`Select up to 3 fields.`,
"label.error500":`Oops!Error...<br />Please contract the administrator...`,
"label.appexchange.download.stop":`Stop the installation with conflict`,
"label.service.dispatchingUnits.left.right.totalAll":`Currently {left}-{right} records, {totalCount} records in total.`,
"label.tabpage.haschangedz":`This lead has been converted`,
"label.industrialandcommercialverification.button.cancel":`Cancel`,
"label.edit.role":`Role Edit`,
"label.mr.descreption.condition2":`Rules-according to the first few characters: please enter a number, find the duplicates according to the first few characters of the entered number.`,
"label.testgrammer":`Check Syntax`,
"label.age":`Age`,
"lable.real.time.chat":`Technical support of realtime chatting is provided by Easemob. Please configure advanced setup in Easmob.`,
"vue_label_opportunity_selected":`{sum} selected`,
"label.weixin.optionone":`Choice 1`,
"label.file.delete.public.link.desc":`Deleting the public link means no one can access the file with that url.if you create a new one,it will be a different URL.`,
"label_tabpage_cancel":`Cancel`,
"template.report.opportunity.analysis":`Analysis of Opportunity Stage`,
"label.escalation.setup.newrule.inputrule":`Enter the rule name`,
"label.ccpeak.getapi.name":`Directget the API name of the field while getting the record value:`,
"second":`The Second`,
"label_tabpage_uploadsz":`Upload`,
"label.description":`Notes`,
"label.ccchat.person.invite.notsamepwd":`Inconsistent password`,
"label.mobile.app.isEnableAblumWatermark":`Add watermark to photo selected from mobile albums upon check-in`,
"vue_label_allsearch_searchable_items":`Searchable Items`,
"lable.outlook.detail.react":`Recent Activities`,
"label.sales.team":`Opportunity Team`,
"label.guif.standard.time":`Gulf Standard Time`,
"label.emailobject.emaildetail.button.forward":`Forward`,
"label.refused":`Rejected`,
"homepage.components.one":`Step 1 Enter the custom component name`,
"day":`Day`,
"label.dataimport.error.number":`Error: Number`,
"label.customer.tab.step2.same.option2":`Default Off`,
"component_button_ok":`Confirm`,
"label.allrecordmeetprocess":`All records should enter this step`,
"label.version.onefile.size":`Size Of Each Uploaded Attachement`,
"label.partnerCloud.orderingPlatform.allProducts":`All Products`,
"pagecreator.page.message.publish.success":`Page published successfully`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Previous Range`,
"label.attendance.persons":`Suitable Users`,
"label.send.an.email":`Send an email`,
"registration.page.browser.title":`Campagin Marketing Channel Registration`,
"label.importfilestep3":`Step 2 Select and upload your file(s)`,
"lable.currencyAdv.exchagecurrency.rate.next":`Next Range`,
"label.ems.no.sync.msg":`You have not configured mail synchronization information yet.`,
"label.total_views":`Form Submission Preview`,
"label.knowledge.article.notnull":`Please choose at least one article.`,
"message.error.view.lastview.delete":`Cannot delete the last public list view</br>You cannot delete the last public list view that is visible to all users.<br><br>`,
"label.integrations.second.half":`piece(s) of data, select the imported data`,
"vue_label_systemSettings_mobelparams":`Mobile App Parameters Setup`,
"message.choose.maximum":`You can choose up to 150 records to share, now`,
"vue_label_homepage_won&unprocessed":`Open Unprocessed`,
"UG.contact.01":`How to make the most of your contacts?`,
"label.data.import.setup.remark":`Administrator can set the rules to be executed when importing data, including whether to execute validation rules, triggers and duplication and matching rules.`,
"pagecreator_layout_message_delete_success":`Layout deleted successfully`,
"lable.account.name":`Fiscal Quarter Name`,
"label.userinfo.must.updatepwd":`For security, you must change your password.`,
"label.mobile.phone.subordinate.setup":`Cannot set to contain subordinates, please select all and set them to allow forecasts.`,
"label.monitorsys.delete.date":`Delete Date`,
"label_emailsync_form_emailaddress":`Email Address`,
"label.projectManagement.cancelled":`Canceled`,
"label.partnerCloud.partnerAccount.rechargeAmount":`Topup amount needs to be between 0.1 and 100000000.`,
"label.select.relatedlist.approval.layout":`Select Related Lists to display on Approval Page Layout`,
"label.userphoto.thumbnail":`Thumbnail`,
"label.assignment.setup.list.rulename":`Rule Name`,
"label.emailtemplate.usemergefields":`Merge Fields in Email Template`,
"label.tabpage.enabletomobile":`Whether to enable the mobile-side`,
"setup_layout_label_desc":`Descending`,
"vue_label_pool_abandonreasondiscription":`Discard reason description`,
"label.ems.outputmails":`Send email server (smtp)`,
"font-evaluate-module-v1-evall":`All Evaluations`,
"front-epwechat-module-v1-unbound-tips":`The following data will be cleared up after unbinding:`,
"label.weixin.number.data":`Data`,
"front-objectTemplate-V1-UseObject":`Applicable Object`,
"label.call.center.configuration":`Call Center Settings`,
"vue_label_systemSettings_website":`Web Portal of Customer Service`,
"lable.currencyAdv.foreverdate":`Permanent Date`,
"label.globalselect.view":`View Value Set of Picklist`,
"component_newrecords_label_title":`Recent Records`,
"component_assistant_label_title":`Assistant`,
"label.equals.deletebut.bulk.delete":`Includes delete button, mass delete (to Recycle Bin)`,
"label.field.duplicate.error.msg4":`Error: Invalid Data.`,
"label.input.right.date":`Please enter the valid date format`,
"file.error.notsel":`Error: Please select the file to upload`,
"label.customcomponent.page.add.title":`New Custom Component`,
"message.chooseatleastthreefield":`Choose 3 fields at least`,
"label.dataimport.system.unnecessary":`,the system cannot determine several`,
"message.login.wrong":`Incorrect username or password.`,
"label.appupload.install.recheck":`Check again`,
"label.ems.option":`Option`,
"label.wei.subject.img":`Subject lcon`,
"chatter.emailReceiveOrNotAccept":`Select this option allow CCChat reminder, deselecting this option prevents you from receiving ccchat reminder.`,
"label.icon.46":`Furnace`,
"label.newpw":`New Password`,
"font-evaluate-module-v1-praise":`The type of evaluation is Positive`,
"label.help.user":`User Guide`,
"label.callcenter.no.searchs":`No relevant query to the information`,
"UG_homepage_007":`From sending follow-up emails to automating sales campaigns, from creating workflows using our Blueprint technology to triggering custom macros, automate daily tasks and focus more on building relationships.`,
"label.saveandnew":`Save`,
"component_salesperformance_label_70finish":`Ended - unprocessed (>70%)`,
"lable.account.dp":`This page allows you to define custom fiscal years.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} is in critical state. Please process as soon as possible`,
"label.workflow.edit.esimaterule":`Error: You cannot change the evaluation criteria to "created or every time it is edited" while you have time triggers associated with this rule.`,
"label.partnerCloud.basicSetting.feature":`Functional Settings`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (This service only supports mainland China)`,
"vue_label_homepage_components":`Please select component`,
"label_chatter_allactivity":`All activities`,
"label.quickcreate.title":`Quick Create Layouts`,
"label.tabpage.exclusivez":`Exclude`,
"front-service-cloud-transfer-desc":`When transferring asset BOM owner, the current asset and the own assets under the asset will be changed owner`,
"label.data.downpage.i.list.desc1":`During the import, data that is not successfully imported because the data is incorrectly formatted, or because the trigger or validation rule fails, generates the CSV file to be displayed on the current page. The data successfully imported will not be displayed on the current page.`,
"template.report.individual.case.status":`Cases Status`,
"label.report.export.file.format":`Format: Excel format .xlsx`,
"vue_label_filternotice1":`That is, each filter condition is met at the same time, for example: 1 business opportunity with an amount greater than 1 million business opportunities, 2 is a business opportunity with an estimated contract date equal to this month, and the screening result shows business opportunities greater than 1 million this month; when <span style="color: red">the advanced filter is enabled</span> When you need to manually filter the conditions into the advanced filter box`,
"label.lead.score.confirm1":`This can take several minutes. You will receive a confirmation email once completed.`,
"label.scores":`Scores`,
"label.dashboard.message.mainnoset":`Home dashboard is not configured`,
"label.customfields.optionlist.fieldvaluelist":`Please enter values, with each value separated by a new line`,
"label.autosearch.title":`Complete Title Search Automatically`,
"label.knowledge.setting.hint.seventeen":`Create some articles`,
"label_tabpage_closez":`Close`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Cart`,
"label.recalculate":`Recalculate`,
"label.umeng.approval.approvalmes4obj":`#numsucc records were approved in #obj, #numfailed reocrds were failed to approve.`,
"label.appointment.wizard.subtitle2-2":`To`,
"label.validate.function.funcExplain.AND":`Check if all parameters are true. Return TRUE if all parameters are true.`,
"label.recordtype.batchaddattachments.remark":`Step 1 Chose file, Step 2 Archive, Step 3 Click the "start upload" button,upload files, Step 4 Click button to finish.`,
"label.reportlist.findreport":`Find Reports`,
"label.partnerCloud.financeSetting.enterAppsecret":`Please enter Appsecret`,
"label.campagin.roi.query2":`View Marketing Channels ROI`,
"label.sendmail.notice.immediately":`Send notification email`,
"label.file.library.managemembers1":`Manage Members`,
"label.forecast.customforecast.foredis.yclb":`Forecast Category`,
"label.no.target.model.available.":`No available target model. Please create target model first, or contact the system administrator.`,
"label.quote.contactname":`Contact name`,
"label.customer.tab.step2.same":`Apply one tab visibility to all profiles`,
"UG_product_03":`Multi-currency supported price manual`,
"label.pc.system.prompt":`System Prompt`,
"homepage.components.description":`Component Description`,
"front-email-payment-safety-code":`Security Code`,
"label.the.extra.reward.group.describes":`Add quote line group description`,
"label.isEnableVisualpage.new.rightlist":`Active Custom Pages`,
"label.icon.84":`Transformer`,
"label.chat.message.to":`Receipient`,
"lable.product.pricebooks.edit":`Price Book Edit`,
"label.partner.workspace.member.belong":`Belongs to`,
"pagecreator_systemstyle_message_delete_success":`Style deleted successfully`,
"label.salescloud.teamrole.message.chooseatleastone":`Please select a user at least.`,
"label.knowledgebase.self.window":`Identical Window`,
"label.product.cost":`Cost`,
"label.imgfield.remove":`Clear Pictures`,
"label.event.lastweek":`Last Week`,
"template.report.today.statistics":`Sales of Today`,
"label.emailobject.recipients":`Recipients({0})`,
"vue_label_commonobjects_view_successfully":`Set the default view successfully`,
"label.uploadfail.typeerror":`Upload failed, the file type is invalid.`,
"vue_label_lead_required_fields":`Please fill in the required fields`,
"front-console-reopen":`Reopen`,
"message.layout.unique.relatedlist":`Please return to the unique constraints of the related list in the page layout, please confirm and save again.`,
"label.emailobject.emaildetail.nextactivity":`Next Activities`,
"label.publicgroup.save.error":`Error: One of the following groups is already the parent group of this group`,
"label.editdefaultshare.tip":`Edit your organization-wide sharing defaults below. Changing these defaults will cause all sharing rules to be recalculated. This could require significant system resources and time depending on the amount of data in your organization.`,
"label.icon.53":`Car`,
"label.exchange.sync.state.setting.m3":`Users with linked Microsoft Exchange and CloudCC email addresses:`,
"label.currency.enable":`Currencies: Enable Currency`,
"component.timeline.label.past":`Past activities`,
"workflow.action.tasks.assignortype.user":`User`,
"setup_layout_label_relatedlistsetup":`Related List Settings`,
"label.systemadmin":`System Administrator`,
"label_tabpage_allz":`All`,
"label.ems.subject":`Subject`,
"message.recordtype.selectlayout.tip":`Select the page layout that users with this profile see for records with this record type. After saving, choose the picklist values that are available with this record type.`,
"label.current.version":`Current Version`,
"label.sourceoffile":`Untranslated - Produces a set of files, by language, with text that is not yet translated`,
"label.file.versionerror":`Please use the file feature tab in the new version of the interface`,
"label.validate.function.funcExplain.MINUTE":`Return minute of day (From Date/Time fields)`,
"abel.setup.mobile.bottombutton.profile.setting":`Customize bottom menu of profile`,
"label.recycle.dis.tip3":`Select My Recycle Bin from the drop-down list to view items you deleted. Administrator can select All Recycle Bin to view all organization data that has been deleted.`,
"message.selectnothing":`None Selected`,
"label.develop":`Develop`,
"label.tab.lightningpage":`Lightning Version Page`,
"label.chat.micropost.share.info":`Share`,
"label.block.pricing.editor":`Block Pricing Editor`,
"label.ccchat.file.unavailable":`This file is not available`,
"label_component_helper_businesschange_0UntreatActivity":`Opportunities without unprocessed activity`,
"label.search.setup.obj":`Can set at most 100 objects.`,
"component.setup.button.cancel":`Cancel`,
"message.longtextareamaxlength":`Length cannot exceed 32,000 characters`,
"vue_label_chat_removedby":`You have been removed from the group chat by the "Administrator"`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Cannot be less than 8 characters`,
"label.informassigner":`Notify the Assignee`,
"font-evaluate-module-v1-not-received":`Never receive any satisfaction evaluation from contacts`,
"label.trigger.triggertime":`Trigger Time`,
"label.attendance.cannot.make":`Unable to mark`,
"label.shouldallrecords":`All records should be included in the calculation`,
"label.eidt.queue.alter1":`Please select queue members`,
"L":`Picklist`,
"label_emailtocloudcc_filed_email":`Email`,
"label.productsales.contract.badversion":`Your current edition does not support viewing contract object so you cannot view contract amounts.`,
"label.tabpage.operation":`Operation`,
"label.file.copy.public.link":`The public link has been copied`,
"label.all.SMS":`ALL SMS Alerts`,
"UG_opportunity_008":`Opportunity Team`,
"UG.Campaign.002":`Plan, execute and monitor the effectiveness of market activities.`,
"label.jiandangfenpei.title":`Profile Assignment`,
"pagecreator.systemstyle.message.delete":`Do you delete the current selected style?`,
"lable.outlook.mcto.repeat":`If duplicate records are found, the email is associated with the`,
"label.user.field":`User Fields`,
"vue_label_commonobjects_detail_market_hierarchy":`Market hierarchy`,
"label.ems.emails":`Emails`,
"label.tabpage.deleteviewfailed":`View delete failed`,
"label.data.exp.new.expobjtemp":`Create the object exported template`,
"label.useformulassetval":`Use formulas to set new values`,
"label.service.newBuildDialog.six.fields":`Up to 6 fields can be selected.`,
"error":`Error`,
"template.chart.sdyyfx":`Lost Reason Analysis`,
"label.icon.191":`Moustache`,
"label.app.step3.tabused":`Selected Tabs`,
"label.user.level":`User Level`,
"label.custombutton.querydata.notexist":`The data does not exist.`,
"label.executestate.calculating":`Calculating...`,
"label.visualpage.folder.notdel2":`1.This folder contains files and cannot be deleted.2.This folder contains hidden files and cannot be deleted. A hidden file is freated from a logical delete object (delete from Setup-Create-Obkects), which iis hidden because the object is not actually deleted.`,
"vue_label_report_conditiondesc_three":`You will be notified if all conditions are met`,
"approval.request.email.subect":`Approval Request`,
"label.log.user.value":`Please enter user name for searching!`,
"label.isCompanyCurrency":`Corporate`,
"label.related.2018":`Related Lists`,
"label.tonga.time":`Tonga Time`,
"message.actionfailed":`Action failed`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`The object ID of the query cannot be null.`,
"label.list.userinterface.setup":`User Interface`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`The email format is incorrect. Please reenter`,
"label.chatter.content":`Content`,
"label.projectManagement.Addnotes":`Add Notes`,
"label.service.newBuildDialog.reservation":`Showing ordered`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Non-group holders cannot invite users to join group chats`,
"label_partner_workspace_member_belong":`Belongs to`,
"label.task.modify":`Edit Task`,
"label.tabpage.transformationsz":`Convert`,
"label.new.password.no.indexof":`The new password cannot contain Chinese characters and spaces.`,
"label.ji.quarter":`No. {a} Quarter`,
"label.sso.isActiveNo":`No`,
"label.mobile.phone.week.report":`Weekly Work Notes`,
"label.email.template.please.select.folder":`Please choose a folder`,
"label.pc.ui.2018.tab.groups":`Menu group`,
"label.h5.approval.status":`Approval Status`,
"setup.mainpage.label.welcome27":`The CloudCC cloud platform provides functions such as importing, exporting, batch deleting, and batch transfer of all object data in the system.`,
"vue_label_systemSettings_setHomePage":`Setup Home`,
"label.select.button":`Available Buttons`,
"label_emailsync_status_enable":`Active Connect`,
"label.trigger.triggerVersion.detail":`This field is not editable. There are currently two versions of triggers, 1.0 and 2.0, and all of the new triggers are 2.0, version 1.0 has been banned for from being created.`,
"pagecreator_layout_message_save_fail":`Layout save failed`,
"label.salescloud.salesdashboard.10big":`Top 10 Opportunities in the next 3 months`,
"label.file.share.size":`The maxinum share and publiclink of each file is`,
"label.page.simple":`Simple`,
"pagecreator.page.message.delete":`Do you delete the current selected page?`,
"label.weixin.newspaper.coverage.detailinfo":`Risk Sheet Detail Information`,
"label.list.userinterface.chattersetup":`CCChat Settings`,
"lable.opppdt.addpdt.table.quantity":`Quantity`,
"label.product.description":`Product Description`,
"button_partner_back":`Return`,
"label.user.current.loginuser.sessionid":`The current logged user's SessionID is:`,
"label.otherreport":`Other Reports`,
"pagecreator_button_mobilepage":`Mobile-side`,
"label.mobile.phone.state":`Status`,
"lable.currencyManage.unenableCurrencyAdv":`Deactivate Advanced Currency Management.`,
"lable.product.addp":`Add Price`,
"label.field.validate.notpass":`No syntax errors.`,
"label.app.global.search.obj":`Up to {0} objects you can setup to use in global searching.`,
"label.group.archived":`Archive`,
"vue_label_approve_to_submit":`To submit`,
"showfrom":`Show from`,
"chatter.emailNotification":`Email Notification`,
"label.callcenter.pleaseenter.enterprise.number":`Please enter the enterprise No.`,
"label.forecast.customforecast.forecastnumber":`Forecast Numbers`,
"label.vlidaterule.messagelocation":`Error Location`,
"label.h5.similar.opportunity.step3.conment":`The Relevance column, which represents the number of matching fields, will always be displayed.`,
"label.ccchat.group.gd.setting.info":`Modify CCChat group settings`,
"label.knowledgebase.delete.article.succeeded":`Delete article successfully`,
"message.layout.edit":`The page layout management is a separate value-added function. If your organization confirms that it has purchased the function module, ask the system administrator for the password. Contacted CloudCC.com to know more.`,
"label.case.create":`Case ({0}) is created`,
"label.icon.170":`Shopping`,
"message.error.contact.null":`Contact cannot be empty`,
"label.appupload.install.error.hasinstalled":`This software package is already installed in your organization. before installing the new version, you need to uninstall the installed version first.`,
"label.service.miniProgram.imageType":`PNG, JPG and JPEG format are supported. 750*349 pixels pictures are recommended. Hover mouse on the picture to reupload or delete.`,
"label.leadscore.rule.edit":`Leads Scoring Rule: Edit Rule`,
"vue_label_commonobject_anytime":`Anytime`,
"label.clearing.conditions":`Clear Conditions`,
"label.campagin.roi.ydkhjhze":`Total amount of customer opportunities won`,
"Lead_Auto_Scoring_Setting_001":`Automatically score when editing or saving (Except the leads which are batch imported or created via  interface )`,
"pagecreator.systemstyle.label.buttonareacolor":`Operation area color`,
"label.batchregist.huanxinuser.finish":`Batch user signed up has been completed`,
"UG_opportunity_006":`Opportunity genius`,
"message.serviceappo.violation":`Assignment period violation: it's in conflict with other service appointment.`,
"label.recordtypeselect.selectnew":`Select new record type`,
"Lead.Tools.BatchScoring":`Lead Batch Scoring`,
"label.partnerCloud.financeSetting.enterWechat":`Please enter WeChat merchant account.`,
"label.philippine.time":`Philippines Time`,
"five":`Five`,
"label_average_value":`AVERAGE`,
"message.realdelete":`Are you sure?`,
"label.currency.note":`Enter information for the new currency. Note that you can not delete a currency once you activate it.`,
"label.projectManagement.delete.prompt":`Delete Prompt`,
"label.approval.present":`(Current)`,
"label.escalation.setup.newrule.name":`Rule Name`,
"label.edit.list":`Editable data list`,
"label.partnerCloud.financeSetting.informationOne":`1. Visit Alipay merchant center (b.alipay.com) and log in with Alipay subscriber.`,
"label.customfields.numberText":`2.The sum of the length of the entered number and the number of decimal places must not exceed 18 places.`,
"label.biaoqing.businessverify.relation.tip":`Writes the returned value of bid&tender on the lead field`,
"label.icon.149":`Robot`,
"System.btn.SaveAndCommit":`Save & Submit`,
"label.calendar.many":`Multi User`,
"label.ccchat.create.email":`The Email has been created`,
"template.report.income.marketing.activities":`Report of Campaign Revenue`,
"label.ccchat.person.invite.needemail":`Enter an email address.`,
"template.report.open.amount":`Unclosed Amount`,
"label.currentoperate":`Selected Actions`,
"label.finalapprove":`Final Approve`,
"label.emailmerge.mergepage.step2":`2. Select the mail merge template, up to 20:`,
"label_tabpage_sorttypez":`Sort type`,
"label.workbanch":`My Workbench`,
"font-evaluate-module-v1-disable":`Are you sure to deactivate this？`,
"label.ServiceCloud.distributionMap":`Distribution Map`,
"lable.Confirm.potential.customers":`Confirm to collect {num} leads.`,
"label.mobile.quickcreate.default.nearby":`Nearby`,
"label.isremider.noremider":`No Reminder`,
"label.approval.select.step":`Select which approval step to return`,
"chatter.error.pm":`Error: File size is too large.`,
"UG_activity_08":`Reserve a schedule`,
"label.marketsea.notwinopportunitydays":`Number of days without a deal (needs to be greater than the number of days without creating a business opportunity)`,
"label.selectpage":`Select an existing page`,
"label.dashboard.dispalyOnTheHomePage":`Dispalyed Homepage`,
"front-lightning-module-v1-details-page-chart-set-report":`Set up report`,
"vue_label_pool_mydeal":`My deal`,
"vue_label_report_lastone":`Last one`,
"label.tabpage.potentialcustomersz":`Leads`,
"font-evaluate-module-v1-more-satisfied":`We are not good enough。 We will make you more satisfied next time!`,
"label.trigger.instructions":`<p>Instructions For Use：</p><p><li>Parameters Can Be Directly Quoted:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li><li>When To Get Value Of Record Please Directly "get" Field's API Name</li><li>If Create New Record,Use "String id = IDGenerator.generateID("ID Prefix")"</li><li>If Need Return Error Message:Please Use "trigger.addErrorMessage("")";trigger Will Return At Current Line,No Longer Execut Down！</li></p><font color="red">Note:Maximum Support 200KB Characters,About 200,000 Bytes.</font><font size=3 color="red">【Key：Must Add Notes!】</font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Commitment Completion Rate`,
"label.umeng.approval.dlsp.approvenew":`Delegated approval: #actorname is requesting approval #objapiname#recordname`,
"label.edit.visualpagefolder":`Custom Page : Edit Folder`,
"label.pc.flash.teach":`Video Teaching`,
"label.showsearch":`Show Search`,
"label.reportsSubscriptionPage.condition.title1":`You will get notified when all oof the conditions are met(AND)`,
"label.h5.search.result":`Count`,
"vue_label_commonobjects_view_chart_pie":`Pie Chart`,
"label_please_enter_currency":`Please enter the currency`,
"chatter.share.to.profile":`Your profile`,
"label.mykeeptouchset":`My Keep In Touch Settings`,
"label.profile.mustcopyaprofile":`You must select an existing profile to clone from.`,
"label.managereport":`Manage Reports`,
"label.total.choice":`files, selected`,
"label_emailtocloudcc_help":`Please enter the correct email password or authorization code. If your email server needs to turn on the IMAP/SMTP service to login by a third-party account, you must login to the email account settings to enable the service first, and copy the approproate authorization code to this password enter box.`,
"label.trigger.sel":`Triggers in This Folder`,
"label.dashboardLookUp":`View Dashboards`,
"label.batchadd.newbatchpage.save.emptytext":`Please check if there are required information not filled in.`,
"setup.mainpage.label.welcome16":`Instructions: Click on the menu on the left side of the page → Application Settings → Create → Workflow, Approval Process, Tasks, Email Notification, Field Update, and more.`,
"vue_label_email_mark as":`Mark as`,
"label.customobjdel.cannot.delete.try":`The object cannot be deleted because it is associated with the following relationship of other objects.`,
"label.customsetting.visible.public":`Public`,
"label.log.bit":`Bits`,
"label.data.exportall.all.desc":`Exports all data for all objects that the current user has permission to view.`,
"message.login.mfadevice.already.bound":`The user has already bound the MFA device.`,
"label.campaign.channel.please.img":`Please Upload the Image`,
"assetbom.manage.notpermission":`Please contact your administrator for enabling the access of manage asset BOM.`,
"schedstarttime.schedendtime.time.illegal":`The scheduled start time of the service appointment should be less than or equal to the actual end time.`,
"label.referperson":`Owner`,
"front-email-payment-area":`District`,
"label.c.d.least":`Each "C" record must have at least one related "D" record.`,
"label.weixin.longitude.isnull":`Longitude and latitude are empty or invalid`,
"setup.layout.button.ok":`Confirm`,
"vue_label_fiter_component_date_customdate":`Custom Date`,
"label.enable.case.createarticle":`Allow users to create articles from cases.`,
"label.event.moveup.8hour":`8 hours ahead`,
"label.input.most.string":`Please enter up to {0} characters`,
"lable.SalesCommitmentKanBan.contractEndDate":`Contract End Date`,
"label.visualpage.function.name":`Name the function to be:`,
"label_emailtocloudcc_redmessage1":`Invalid email address`,
"message.aliasnameinput":`Error: The name must be unique, and begain with a letter. It must contain only letters and numbers.`,
"label.data.exp.selectedtemp":`Select the template used to data export`,
"label.import.page1.suitedwayoflinkman":`Contact matching style`,
"label.customsetting":`Custom Settings`,
"label.versiontype.Free":`Free Plan`,
"setup.layout.label.norelatedlist":`No related lists`,
"label.forecast.edittotal.de.leiji":`Rollup from`,
"label.customfields.file.max":`The file uploaded is too large,please do not exceed 5m`,
"label_partner_all_workspace":`Workspace`,
"label.searchrelation":`Lookup Relation`,
"label.icon.185":`Advisory`,
"label.service.gantt.effective":`Valid`,
"label.newreportstp1":`Step 1 Select Tabular Format`,
"label.category.9":`Manufacturing`,
"label.zuowei":`As`,
"front-quotation-v1-select-quota":`Select Quote`,
"label.dashboard.refresh":`Refresh`,
"label.weixin.saveandnew.log":`Save`,
"label.report.list":`Report Lists`,
"FL":`File`,
"label.h5.followingcolleagues":`Colleagues fallowed`,
"template.report.conversions.number":`Number of Leads Conversions (By Owner)`,
"label.validate.function.funcFormat.MONTH":`MONTH(date)`,
"front-kefu-moudle-v1-tenant-ID":`Lessee ID`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Time`,
"label.multilang.workflow.everyotherday":`Every {0} days`,
"label.chat.message.send.message":`Send information`,
"label.knowledgebase.fast.operation.error":`Quickoperating Error`,
"label.multilang.dupicatecheck.dumplicatedata":`In the {0} records, a total of {1} groups of duplicated data satisfying the condition have been found, and the query took {2} milliseconds. Each page shows {3} groups of data.`,
"vue_label_report_addFile_detail_Information":`Export only 2000 detail rows. Use this data for additional calculations, or upload to other systems.`,
"label.ccchat.message.search.desc3":`Search tips`,
"message.deletereport.prompt":`Cannot delete this report`,
"pagecreator.page.message.save.success":`Page saved successfully`,
"vue_label_rise":`Ascend`,
"label.appupload.install.error.choicehead":`How to deal with if the existing components in the system conflict with the components to be installed?`,
"message.dispatch.violation":`Assignment time violation: assignment period is not within the range of resources working time.`,
"label.tool":`Tools`,
"label.sso.saml.idp.downloadcert":`Download Certificate`,
"label.chatter.detailinfo":`Detailed information`,
"label.area.tree":`Territories Hierachy Tree View`,
"label.partnerCloud.priceOfManual.notEnabled":`Do Not Activate`,
"label.chosesubject.call":`Call`,
"label.leadscore.rule.detail":`Leads Scoring: Rule Detail`,
"front-welcome-to-try":`Welcome to Try`,
"label.umeng.activity.event.willbegin1":`Event #event starts in #time.`,
"component.event.label.noevent":`It looks like you have completed your work today.`,
"label.document.templatesetof.folder":`Template Set of Folder`,
"label.quickbooks.none":`No matches found，Please type a name to search or create a new customer`,
"label.assignment.setup.newrule.inputrule":`Enter the Assignment Rule Name`,
"label.appointmentdetail.wizard.title4":`Company name`,
"label.malaysia.time":`Malaysia Time`,
"label.partnerCloud.partnerAccount.way":`Topup Method`,
"label.roleoflinkman":` Contact Role`,
"mesage.error.role.delate.user":`The role cannot be deleted because it has assigned the users.`,
"chatter.warning":`Warning: If you select a different object, your changes will not be saved. Are you sure you want to do this?`,
"label.service.gantt.violations.sum":`Service appointments with violations`,
"label.permission.objectpermission.recordfenpei1":`Assigned Record Types`,
"label.mobile.phone.required.plan":`Plan is required`,
"label.after_leaving":`Current data will not be saved after leaving`,
"label.cpq.opportunity.mainquote.trasnfer.order":`There's been a primary quotation under the opportunity and transfered to order.`,
"component.setup.iframe.label.title":`Customize page`,
"visit.dispatchplatform.nopermission":`Permission Denied: You are not authorized to access to the dispatch console. Please contact the administrator.`,
"label.validate.function.funcExplain.RIGHT":`Returns the specified number of characters from the end of a text`,
"component.chatter.link.button.save":`Publish`,
"label.knowledge.selection":`Each Knowledge has a maximum of 8 data groups can be selected.`,
"chatter.email.homePage":`Send me a message on my CCChat homepage`,
"vue_label_commonobjects_view_copy_view":`Copy View`,
"label.documentmessage":`Document Details`,
"label.emailtocloudcc.step1":`Step 1`,
"label.user.mfa.unbind":`Unbind the MFA to the selected users`,
"label.stdashbord.xsld.business.sdzje":`Total Amount(Closed-Lost Opportunities)`,
"vue.please.select.the.total.method":`Please select summation way.`,
"label.stdashbord.xsld.business.img1":`Number of stages with a probability of 1%  99%`,
"label.reportsSubscriptionPage.condition.title":`In addition to subscribing, you can set up conditions on this report. You will be notified when conditions are met. This is optional.`,
"chatter.sel.field":`Error: More than 20 fields are selected.`,
"label.login.access.year":`Year`,
"label.dashboard.all":`All dashboards`,
"label.approver":`Approver`,
"Lead.Homepage.Tools.BatchScoring":`Batch Score`,
"lable.opppdt.selPdt.lesscondtions":`Fewer filters`,
"label.integrations.action.export":`Export`,
"label.datamanage.lookupandsure":`(View and Confirm)`,
"label.email.attach.to.mail":`Attach to email`,
"message.nodataordeleted":`Data does not exist or has been deleted`,
"component_newrecords_label_all":`View all`,
"lable.currencyAdv.startdate.rate":`Show all rates defined for the start date in following range`,
"label.callbackoperate":`Recall Actions`,
"label.knowledge.setting.hint.eighteen":`Start to create an article for the knowledge`,
"label.user.step4.submit.email":`Step 4 Your email send reuest has submitted`,
"label.appointment.wizard.subtitle4-1":`Travel Time Between Events`,
"component.assistant.button.newtask":`New Task`,
"label.icon.129":`Card`,
"label.relatedlist":`related lists`,
"label.report.recently":`Recently Viewed`,
"label.batchadd":`Batch Add`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" is deleted successfully`,
"label.appupload.upload.otherdetail":`Additional Details`,
"label.emailobject.link":`Link:`,
"label.quickbooks.createcustomer":`Create Customer in QuickBooks`,
"report.label.projectcount":`items, sort by report name`,
"vue_label_normal_contact_sf":`Contact`,
"chatter.group.groupActivities":`All Groups`,
"label_tabpage_addoptionsz":`Add options`,
"label.knowledgebase.submit.for.translation":`Submit for Translation`,
"vue_label_pool_notallowed":`The nature of the business is not allowed`,
"label.icon.80":`Papermaking`,
"label.readonlys":`Read-Only`,
"label.recordsediting":`Record Editability`,
"label.mr.title.email":`Email`,
"label.partner.all.enable":`Enable`,
"label.customsetting.manage.errmessage":`Maintain custom fields before you manage the data.`,
"label.cloudccclass.list.cls":`Class`,
"label.weixin.click.loadall":`Click to load all`,
"label.weixin.appr.initialtime":`Submitted Time`,
"UG_ST_002":`Determine`,
"setup_mainpage_label_welcome17":`Permission settings`,
"label.appupload.state0":`Not Uploaded`,
"label.icon.115":`House`,
"setup_mainpage_label_welcome5":`Custom field`,
"lable.custom.year.ovdate":`Custom Year End Date`,
"label_tabpage_findz":`Search`,
"label.appupload.uploading":`Uploading...`,
"setup.mainpage.label.welcome1":`Need corresponding permission`,
"label.file.folder.delete2":`Delete Library?`,
"2018UI_Homepage_DataNoAccess_Info":`You have no permission to view this record, please click to return to previous step.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Hawaii-Aleutian Standard Time`,
"template.report.unfinished.tasks":`Uncompleted Tasks`,
"vue_label_calendar_add_calendar":`Add Calendar`,
"label.button.sel.useremail":`Email Selected Users`,
"user.email.template":`Dear{username}：<br>The invitation code of [{Campaign.name}] shows as follows<br>{Campaign.ColleagueInvitationLetter}<br>and the URL is：<br>{Campaign.ColleagueInvitationLetterLink}<br>QR code registration and URL link registration are supported for the present campaign! Thanks for your support! <br>Marketing Executive:{Campaign.Owner}`,
"label.forecast.settings.shouru":`Revenue`,
"label.casesensitive":`Consider "ABC" and "abc" as different values (case sensitive)`,
"message.pleaseinputrightdistanceweek":`Please fill in the correct interval week.`,
"label.linellae-group":`column grouping`,
"label.showdefault_times":`Show Default Publish Time`,
"label.smstemplate.finishmessagedetailinfo":`Complete the details of the SMS template`,
"label.service.miniProgram.backgroundImage":`Background Picture`,
"label.recentview.news":`Latest Records`,
"label.reportType.chose.and.form":`Select the report data source and a report format`,
"setup.layout.button.additem":`Add the selected items`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? A contract is a written agreement between the parties. Many companies use contracts to define terms for doing business with other companies. Use Cloud CC to establish and document your existing contracts with your customers and business opportunities. Track the contract through the approval process.<br>?Assist the contract function and manage your transactions through the collection plan.`,
"label_mobile_version_nonsupport_feature":`This feature is not supported in current version. Please update to the latest version.`,
"label.icon.44":`Fire`,
"label.data.downpage.i.title.num3":`3、BBefore importing, make sure to import all related records. For example: if there is to lookup relationship between the objects you are currently importing and the contacts, you should import the contacts first and then import your data.`,
"label.mr.object.customer":`Accounts`,
"label.social.user.null":`User information of Social cannot be empty`,
"front-epwechat-module-v1-unbound-item2":` all data of application settings`,
"label.partnerCloud.partnerAccount.noempty":`The topup amount cannot be empty.`,
"label.weixin.myapproval":`My Approvals`,
"label.data.setok.e_desc1":`Export success, you will receive a system message alerts,derived data is temporarily stored in the server, the system only for you to save 48 hours, please as soon as possible to`,
"lable.batchadd.service.cfq.after":`Triggers (After Insert)`,
"label.umeng.activity.youhaveanevent":`You have a new event.`,
"label_emailsync_status_connectaccounts":`Connected Email Account`,
"label.multilang.shenpi.count":`A total of {0} records：`,
"pagecreator.page.message.delete.fail":`Page deletion failed`,
"label.version.sum.lookupmdfield":`Master-Detail Relation Fields`,
"vue_label_pool_clueduplication":`Duplicate Clue`,
"label.system.setup.log":`System Behavior Log`,
"label.globaloperation.operationtype.send.e-mail":`Send email`,
"vue_label_pricebook_entry":`New price list entry`,
"label.forecast.forehistory.submit.date":`Submitted Date/Time`,
"chatter.handle":`What are you working on?`,
"lable.SalesCommitmentKanBan.complete":`Completed Amount`,
"label.weixin.upload.pictures":`Upload Image`,
"label.create.document":`New Document`,
"vue_label_commonobjects_detail_unlockconfirm":`Confirm to unlock?`,
"label.customer.page":`Custom Page Tabs`,
"button.partner.workspace.saveas":`Save as`,
"setup.layout.label.asc":`Ascending`,
"label.ccpeak.folder.time":`Unfiled Scheduled Class Folders`,
"label_tabpage_includez":`Include`,
"label.custom.button":`Custom Buttons`,
"label.weixin.binding":`Bind`,
"P":`Percent`,
"chatter.stop.n":`Stop following this record`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Wednesday`,
"template.report.revenue.marketing.activities":`Campaign Revenue`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Actual Receipts`,
"vue_label_popularresults":`Popular Results`,
"label.log.belongs":`Subordinate part`,
"label.profile.remark":`Users with this profile have the permissions and page layouts listed below. Administrators may alter a user's profile by editing their personal info.`,
"label.appupload.component.type.button":`Button`,
"label.partner.all.operate":`Operation`,
"vue_label_notice_modify_fail":`Fail to edit`,
"label.icon.137":`Earth`,
"front-dialog-module-v1-nosupport-copy":`Clone is not supported`,
"label.integrations.mailchimp.massage3":`Integration successfully uninstalled`,
"UG.opportunity.010":`Create a transaction`,
"front-lightning-module-v1-details-page-chart-selecting-reports":`· You can only choose public reports, i.e. reports with access for all users, and unfiled public reports.`,
"System_btn_SaveAndCommit":`Save & Submit`,
"vue_label_dashboard_statisticaltype":`Please select statistical type`,
"label.mr.object.opportunity":`Opportunities`,
"label.area.detail.remark":`View Users in This Territory`,
"label.view.sortview.index":`Order`,
"label.mobile.quickcreate.default.events":`Events`,
"label.product.price":`Sale Price`,
"label.leadmarketsea.edit.title":`Lead Pool Edit`,
"pagecreator.layout.button.edit":`Edit layout`,
"label.addressee":`Recipients`,
"label.movablesearchlayout":`Activity Search Layouts`,
"label.ems.confirm":`Confirm`,
"vue_label_file_save_to_file":`Save to File`,
"component_chatter_button_more":`See more details`,
"label.ccdocument.hidden.trace":`Hidden Trace`,
"label.partnerCloud.maximumTwo":`A maximum of 2M file is supported.`,
"label.event.moveup.4hour":`4 hours ahead`,
"label.batchadd.save":`Add sharing failure`,
"label.passwordPolicy.setup.expireDate":`User password expire in`,
"label.workflowrule":`Workflow Rules`,
"vue_label_notice_pleaseselecview":`Please select a view`,
"label.h5.chatter.colleagues":`About the colleagues`,
"lable.opppdt.addpdt.subtitle":`Add Product to`,
"label.data.import.setup.repeat.no":`No-Insert all records into my import file.`,
"label.changeCorporate":`Change Company Currency`,
"label.customfields.dateandtime.tip":`Allow users to enter a date and time, or pick a date from a popup calendar. When users click a date in the popup, that date and the current time are entered into the Date/Time field.`,
"label.integrations.mailchimp.massage1":`Please select 1 record at least to export`,
"lable.PowerProcess.custom":`Based on custom condition`,
"label.service.editDialog.displays.service.appointmentsFordays":`Show service appointments of {} days before level date and {} days after level date.`,
"label.Receivables.ActualMoneyTime":`Actual Recieve Date`,
"label.matrixreport.intro":`Matrix Reports show summary data calculated in horizontal and vertical terms in grid form.`,
"message.validation.isnotnumber":`Please enter the invalid number.`,
"label.partner.workspace.member.search":`Search`,
"label.customfields.deletewill":`Deleting a custom field will:`,
"label.content":`Content`,
"component.setup.button.weburl":`External URL`,
"setup.mainpage.label.welcome28":`Instructions: Click on the menu on the left side of this page → Manage Settings → Data Management → Data Import and Export, Batch Transfer, Batch Delete.`,
"label.related.setup":`Task and event setting`,
"label.weixin.sign":`Dear,you have already signed in, no need to do it again`,
"label.norecord":`No Records`,
"label.emailmerge.detail.emailtempldatemerge":`Mail Merge Templates`,
"label_emailsync_status_role":`Role`,
"label.mobileapp.modelsetting2":`Select modules that meet your business needs<br>Activate：allows selected modules to show in More -Standard Function<br>Deactivate: the selected modules will not be able shown in More - Standard Function.`,
"component.sendmail.label.title":`Send email`,
"component_assistant_button_newevent":`New event`,
"label.chatter.input":`Please input content`,
"message.error.view.operate.rtnlink":`Click<a href='javascript:history.back();'>here</a> to back.`,
"lable.new.profile":`New Profile`,
"label.custom.field.null":`There is no available`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Saturday`,
"label.stdashbord.xsld.business.img4":`Total Amount of Stages with Probability 100%`,
"pagecreator_layout_button_splitall":`Split all`,
"label.mobile.phone.total.amount":`Total Amount (ten thousand)`,
"label.ratifyhistory":`Approval History`,
"label.projectManagement.Antecedents":`Pre-task`,
"label.projectManagement.Newserviceappointment":`New Service Appointment`,
"label.delete.record.is.approval":`The records you want to delete are requesting for approval, are you sure you want to delete?`,
"front-gantt-module-no-tasks-describe":`Gantt charts can view how work items are organized anytime, how they overlap, and how they are related`,
"vue_label_visualize_data":`Data from TianYanCha is filled in. Please save changes.`,
"UG.activity.02":`Assign tasks`,
"label.field.duplicate2":`No duplicated values allowed`,
"label.cloudccclass.list.tip":`Allows developers to develop classes on the CloudCC.com platform that can be used to customize pages and triggers.`,
"before":`Before`,
"UG.ST.001":`Prompt`,
"label_tabpage_userGuidez":`User guide`,
"vue_label_account_looking_for":`Please enter what you are searching for`,
"vue_label_calendar_notice_timecantmove":`The time of the calendar cannot be changed by dragging`,
"label.mobile.phone.enter.summary":`Enter your summary`,
"label.object.api.existed":`This object API name already exist, please change another API name.`,
"label.weixin..xsld.order.by.time":`Order By Close Date`,
"label.h5.chatter.whether":`Whether or not`,
"label.file.delete.success":`File deleted successfully`,
"label.imgfield.type.url.tip1":`The user can enter the link that references the picture, and set the size of the picture by adding`,
"label.tomanyrecords":`More than 5,000 items in the form.`,
"label.save.partnercloud":`Error while saving Partner Cloud`,
"vue_label_homepage_fliteritems":`Filter configuration items`,
"pagecreator_page_button_new":`New page`,
"label.sharerule.baseofcondition":`Based on criteria`,
"label.dashboard.snapshot":`Dashboard Snapshots`,
"label.appointmentpage.wizard.subtitle1.1":`Choose date and time`,
"label.reportsSubscriptionPage.condition.emailsummary":`Summary only`,
"chatter.group.showAll":`Show All`,
"label.tabpage.helpNavigationz":`Help and navigation`,
"label.emailtocloudcc.button.back":`Cancel`,
"approval_request_email_subect":`Approval Request`,
"label.lookup.error":`An error occurred while searching`,
"label.publicgroup.save.groupisnull":`The group data is null during save. Please save it again. If there is stiil a error, please contact your administrator.`,
"label.pie":`Pie Chart`,
"chatter.feed.is":`is a corporate network that lets your users work together, talk to each other, and share information, all in real time.`,
"label.customfields.file.max5m":`The maximum file size is 5m`,
"com.cloudcc.login.error.message.vaildauthfail":`Invalid login authentication`,
"label.profile.appsetuppermission":`App Settings Management`,
"label.customfields.file.totalmax":`The file uploaded is too large,please do not exceed 500m`,
"label.sms.list":`SMS Interface List`,
"message.error.referencedcolumnIdnotexist":`The report reference fields have been deleted and cannot be displayed properly. Please contact your administrator for help.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Set up chart of report`,
"label.recordtype.profile.enables":`Record Types Currently Available`,
"chatter.this.n":`this record`,
"label.only.upload.file":`Only jpg/png file is allowed to upload and no more than 500kb.`,
"vue_label_lead_conversion_failed":`Conversion failed`,
"label.file.share.file.success":`Share files successfully`,
"label.processsetting.delete.process":`Are you sure you want to delete the path?`,
"message.uniquenamevalidate":`It must begain with a letter.It must begain with a letter.It must contain only letters,numbers,and underscore.`,
"label.group.archived.desc.info":`This group has been archived so you cannot create new posts or share files with this group. enabling group enables all features.`,
"label.customer.maincontact":`Primary Contact`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Product Family Revenue`,
"label.dashboardSetup.tz.ybb":`Jump to Dashboards`,
"label.recordowner":`Record Owner`,
"message.approval.othersdoing":`Someone else is working on this process, please refresh to get the latest data.`,
"Opportunity_Detailed_Phase_Label_002":`{0} day(s) in current stage`,
"label.field.validating.rule.isnot.passed":`Validation rule compile failed, please check syntax.`,
"label.textmessage.fieldskong":`Some of the inserted fields in the message are null, please edit and resend!`,
"com.cloudcc.login.error.message.islocked":`Your id is locked`,
"label.forecast.customforecast.foredis.debfb":`% Quota`,
"lable.opppdt.selPbk.changepbk.worning":`Modify the price book for this opportunity, and the opportunity product associated with this opportinity will be deleted. Are you sure?`,
"label.mr.backLookReData":`Go Back and View Duplicate List`,
"label.quickbooks.searchqb":`Search QuickBooks`,
"label.service.gantt.searchSkills":`Search Skills`,
"label.account.Current.and.NexttFQ":`Current and Next 3 FQ`,
"customer.notopen.chat":`The organization has not activated the chat function, please contact the administrator`,
"vue_label_commonobjects_view_sum":`Total {total} record(s)`,
"label.partnerCloud.orderingPlatform.adjust":`Adjust Order Product`,
"label.emailmerge.mergeFolder.tips":`A Microsoft Word file with the contact data can be generated in this page. Please choose email templates to be merged, and a maximum of 20 templates can be selected.`,
"vue_label_ccchat_notice_deletecommentfail":`Failed to delete comment`,
"label.emailsync.status":`User's Email Status`,
"label.forecast.forecastroleuserpage.desc":`Assign a forecast manager to this role. The forecasts of his or her subordinates will be aggregated into forecasts of his or her manager .`,
"label.step1.total4":`Step 1 of 4`,
"front-kefu-moudle-confirm-fjcase":`Are you sure to split this case`,
"label.icon.60":`Crane`,
"label.appointmentpage.wizard.subtitle3":`Enter your infomation`,
"label.loginservice.license.exceed.time":`The licence has expired.`,
"label.customcomponent.check.tag.lastrow":`The last line must be`,
"label.product.code":`Product Code`,
"label.salescloud.salesdashboard.phone":`Phone`,
"label_please_input_price_list_price":`Please enter the list price.`,
"label.multilang.page3":`page(s)`,
"label.file.lastmodifydate":`Modified Time`,
"label.icon.121":`Computer`,
"message.error.system.service.unknow":`Unknown services, please contact your administrator.`,
"label.thesecond":`The 2nd Column`,
"vue_label_report_conditiondesc_two":`Add Criteria to This Report`,
"label.exchange.serverUrl":`Server Address`,
"RL":`reference`,
"label.emailobject.emailsend.sendindividuallyprompt":`Every receipt will receive a message only sent to him. Are you sure？`,
"label.appointmentconfirmpage.wizard.subtitle4":`Particpants`,
"message.save.opportunity.team.save.failed":`Opportunity team failed`,
"vue_labenl_normal_notice_share_success":`Shared successfully`,
"label.triggerfolder":`Trigger Folders`,
"label.more":`More`,
"label.file.num":`Quantity`,
"label.dashboard.list.sortBy":`item(s), sort by access time`,
"c":`Currencies`,
"label.weixin.detail.edit":`Edit`,
"label.escalation.setup.newentries.step2":`Step 2 Select the criteria for this rule entry`,
"label.report.error.prompt":`Configuration failed. Only series report with set of rows is supported. Please make sure it is a public report and not deleted!`,
"label.notification.new":`New`,
"label_tabpage_releaseTourz":`Publish guide`,
"label.icon.41":`Positioning`,
"label.sendsms.hello.new":`Hello,you have a new`,
"label.custom.combination":`Combine`,
"label.project.hit.fifteen":`Milestone Assignment Notice`,
"label.campaign.channel.step6.mobile":`Generate Mobile Page`,
"label.goback.N.step":`Return to previous Step N`,
"label_partner_all_name":`Partner Cloud Name:`,
"label.usermanage.loginusername.exist":`The username already exists.`,
"template.chart.cpxse":`Product Sales`,
"chatter.feed.deletecomments":`Are you sure you want to delete this comment?`,
"label.list.userinterface.show.newrcords.enable":`Disable Latest Records`,
"label.sso.saml.idp.config.enablelogout":`Enable Single Logout`,
"label.file.library.create":`New Library`,
"label.event.moveup.half.day":`0.5 day ahead`,
"label.stdashbord.xsld.business.jhzje":`Total Amount of Opportunities`,
"label.partnerCloud.orderingPlatform.unitPrice":`Unit Price`,
"label.recordtype.edit.attribute":`General Properties`,
"front-template-V1-TemplatePreview":`Template Preview`,
"label.tabpage.personalCenterz":`Personal center`,
"label.setuplookuplayout":`Search Layouts`,
"label.no.merge.records":`No records can be merged`,
"label.attachementNew.set2":`Step 2 Archive`,
"label.publicgroup.detail.showmembers":`View Group Members`,
"UG.Forcast.03":`Start planning and execute business strategies. <br>We wish you a pleasant forecast!`,
"label.h5.manageprompt":`Select a tab to add homepage, or click the tab to open it.`,
"label.icon.145":`Related`,
"label.select":`Select`,
"label.publicgroup":`Public Groups`,
"label.customcomponent.usewhere.title":`Where is this component used:`,
"label.custom.page.button.name":`Button Name`,
"pagecreator_layout_button_vertical":`Longitudinal disassembly`,
"label.marketsea.autorecyclerule":`Autorecycle Rules`,
"label.reportsSubscription.entrance.attachment":`Excel format .xlsx`,
"component_chatter_button_collect":`Bookmark`,
"label.page.step2.of.step5":`Step 2 of 5`,
"label.reportsSubscription.addfile.helptext":`You can set whether to add report attachment in the subscription emails, and the format of attached reports.`,
"label.oldpw":`Old Password`,
"lable.SalesCommitmentKanBan.contractAmount":`Signed Amount`,
"lable.Bundle":`Superior Package`,
"label.weixin.unit.million":`Unit (ten thousand yuan)`,
"label.app.choseprofile":`Assign Profile`,
"label_tabpage_editz":`Edit`,
"label.email.attachement.size.info":`File can not be larger than`,
"label.chatter.pastSevenday":`The past 7 days`,
"label.weixin.end.later.start":`End date must be later than start date.`,
"label.passwordPolicy.setup.lockoutPeriod":`Lockout effective period`,
"pagecreator_page_funcpath":`/ builder / page list`,
"label.emailobject.apperror":`No mail service available, please contact administrator.`,
"label.custom.page.button.broadband":`Button Size (Pixel)`,
"label.weixin.contract.rate":`Contract achievement rate`,
"label.brief.payments":`Payments`,
"lable.approvaldatamove.transfermsg":`Batch transfer of all pending approval request to a new user`,
"label.datamanage.account.namenull":`Note: If the account name fiels is null, the record will not be imported.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Total Rollup Receipts Amount`,
"Opportunity_Detailed_Phase_Label_001":`Stage`,
"vue_label_helpcenter_calendar2":`<br> Object calendars: Calendars that you create with objects display the record data as calendar entries in the date field on the calendar view. You can edit or delete object calendars, and customize the color for each object calendar. <br> New Event<br> You can create a new event in the calendar view in two ways. <br> (1) Click the New Event button in the upper right corner of the calendar view to create a new event. In a new event you can associate the event with other objects, such as business opportunities, by selecting other objects in the Related Items and Name fields. Event records that are associated with other objects are synchronized in the Activity module of the other objects details page. <br> (2) Or you can create a new event by clicking on the calendar grid. <br> New Object Calendar<br> Step 1: Click the Calendar tab in the navigation menu to go to the Calendar view page. <br> Step 2: Find My Calendars on the right side of the view, click the icon next to My Calendars, and proceed in the New Object Calendar pop-up window. <br> Step 3: Start by naming the created object calendar. Select the object that is the basis of the calendar, and select the fields that determine the content of the calendar display, "Start field", "View filter", "Display field". The Start field determines the time range over which data is displayed, you can filter the data by view filters, and the Display field determines what is displayed on the calendar entry. <br> Other calendars<br> Other calendars contain the calendars of other users added. You can add calendars of people who are subordinate to you and shared calendar with you. <br> Share My Events Calendar<br> Step 1: Click the Calendar tab of the navigation menu to go to the Calendar view page. <br> Step 2: Find My Events on the right side of the calendar view under My Calendars, click the drop-down button to the right of My Events, and select Share Calendar. <br> Step 3: In the Shared Calendar pop-up, select the users and access rights you want to share the calendar with. In addition, you can also view your shared calendar records by clicking on "Who currently has access" and remove the shared records by clicking on the "x" icon to the right of the shared records. <br> Once the calendar is shared, your subordinate colleagues can add your event calendar to other calendars and then view your event calendar. <br> Add a calendar<br> Step 1: Click the Calendar tab in the navigation menu to go to the Calendar view page. <br> Step 2: Click the drop-down button for other calendars on the right side of the calendar view and select Add Calendar. <br> Step 3: In the Shared Calendars pop-up, select the event calendars of the people you want to add. You can select the event calendars of your subordinates as well as the event calendars that are shared to you. Click Add to add successfully. <br> Remove the added calendar<br> Click the drop-down button to the right of the calendar you want to remove below the other calendars and select Remove.`,
"label.callcenter.Seat.number":`Seat Number`,
"vue_label_commonobjects_view_change_all_selected_records":`Change all selected records`,
"label.user.notinuse":`The user is inactive, please comtact your administrator.`,
"label.usermanage.hasbeen.reached":`The maximum number of licensed users has been reached, please contact the service provider for more licenses.`,
"vue_label_help_list":`List View`,
"label.infomation.edit":`Edit Essential Information`,
"label.ccchat.person.setting.info":`Open your business network for free! Allow CloudCC users to invite colleagues who do not have a CloudCC license for CCChat. Users who accept invitations can only see profiles, files, and groups, but they cannot see any object details unless you authorize them a full CloudCC license.`,
"label.sso.isDelete":`Is Delete`,
"label.unique.identification.number":`Unique Identification Code`,
"label.weixin.no.pending.projects":`No items to approve`,
"label.projectManagement.Pleaseenteramember":`Please enter a member`,
"label.salescloud.salesdashboard.visit":`Visit`,
"label.weixin.user.registered":`User Registration`,
"message.loginhistory.downloadcsv":`Download the last six months login history. ( CSV )`,
"label.icon.37":`Positioning`,
"template.chart.schdyqyx":`Expected Response from Campaigns`,
"label.tel.ten":`You can enter up to 10 phone numbers to be notified by SMS, and each phone number is separated by a ";".`,
"label.data.exp.objdata":`You will export the data for this object according to the following conditions`,
"label.loginservice.after.use":`after that,you can use the.`,
"pagecreator_systemstyle_message_delete":`Do you delete the current selected style?`,
"label.globalselect.deleteerror":`Since this option list value set is used by the following fields, it cannot be deleted temporarily.`,
"label.department.add":`Add new department`,
"label.attendance.dingwei":`Location`,
"label.workflow.editrule":`Edit Rule`,
"lable.product.pecm":`Please enter the correct amount.`,
"label.icon.182":`Briefcase`,
"label.help.release.notes":`Release Notes of CloudCC R7.1`,
"UG.product.05":`Import product`,
"label.email2":`Email`,
"label.weekrepeat":`Week Repeat`,
"label.mr.descreption.oneGroupReData2":`set(s)`,
"chatter.at.d":`Contribution`,
"label.mr.descreption.oneGroupReData1":`Find Duplicates and Merge Process: a total of`,
"label.weixin.mobile.fly.android":`Share on Android Mobile App`,
"label.brackets.right":`)Close Parenthesis`,
"message.recordtype.applytoAllProfiles":`Apply a page layout to all profiles`,
"label.customcomponent.page.index.tip":`Similar to the way the function works in a programming language, custom components allow you to encapsulate common design patterns and then reuse them in one or more custom pages.`,
"lable.List.properties":`List Attributes`,
"label.fieldinfo":`Field Details`,
"label.ems.error.fail":`Load failed, please try again or contact the system administrator.`,
"label_emailsync_form_email":`Email`,
"lable.currencyManage.button.manageRate":`Manage Currency`,
"component_salesperformance_label_100finish":`Ended`,
"label.knowledgebase.data.assignment.failed":`{a} data assign failed`,
"label.custom.buttonandlink.remark":`Select the behavior: Display in existing window/Display in new window (Existing window:dispaly in current window. New window: display in new window)`,
"label.list.userinterface.watermark.setup":`Watermark Setup`,
"component_timeline_label_7daysahead":`7 days before`,
"label.sendemail.chat.replyinchat":`Comments of post:`,
"component.salesperformance.label.title":`Sales performance`,
"label.data.downpage.e.list.desc2":`After completing, you will receive an email reminding you that the data has been exported successfully.`,
"vue_label_campaign_fromclosedopprotunities":`From {sjcb} closed opportunities`,
"label.umeng.activity.taskviewed":`The task you assigned to #name is viewed`,
"vue_label_salesadvance_retentions":`Retention Number`,
"label.fieldtag":`Field Label`,
"label.quickbooks.button.searchinquickbooks":`Search in QuickBooks`,
"label.quickbooks.viewlist.action":`ACTION`,
"label.weixin.sysapp":`System Apps`,
"label.approval.examine.level":`Review by user level, the maximum user level is:`,
"label.appupload.upload.error":`This App cannot be installed. Please cancel install or modify the API within your system, and install again.`,
"label.emailtemplate":`Email Template`,
"front-email-payment-Invoice-amount":`Invoice Amount`,
"label.viewselectedproducts":`View Selected Products`,
"label.tianyancha.businessverify.openfirst":`Please enable business data verification`,
"lable.SalesCommitmentKanBan.returnAList":`Back to List: Colleagues`,
"label.knowledgebase.nopublished.draft.translations":`No published or draft version of translation`,
"vue_label_calendar_day_view":`Calendar-day view`,
"label.globalselect.remark":`The global option list value set lets you share values among objects.`,
"label.orderby":`Sort By`,
"lable.weixin.LastaDaysFinished":`Completed in the past 7 days`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Allows you to manage dated exchange rates that map a currency conversion rate to a specific date range. Dated exchange rates are applied to currency fields on opportunities, opportunity products, and the reports associated with these two objects. They are not applied to fields on other objects or other report types. For example, the exchange rate on January 1 was 1 USD to 6.68 CNY, but on February 6, it changed to 1 USD to 6.70 CNY. Your opportunities that closed between January 1 and February 6 use the first exchange rate (1 = 1.68), while opportunities that closed after February 6 used the second exchange rate (1 = 6.70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`One`,
"label.leadtoobjectfield":`Map Custom Lead Fields`,
"label.dashboardSetup.shujuyuan":`Data Sources`,
"label.tabpage.userz":`Users`,
"label.sms.companyname.dsf":`SMS-1 Setting`,
"label.step2.total3":`Step 2 of 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Drag to reorder tasks!`,
"label.dashboard.snapshot.no.enabled":`Dashboard snapshot feature not enabled`,
"label.dashboard.unit3":`Unit: integer unit`,
"label.forecast.shrepage.desc2":`Users, roles and territories with sharing access.`,
"label.commonobjects.new":`New {eventName}`,
"label.view.nameonlyone":`View Unique Name`,
"label.assignment.setup.newentries.user":`Users`,
"label.otheremails":`Additional Emails`,
"component_sendmail_button_send":`Send`,
"vue_label_accountpool":`Account Pool`,
"label.h5.approval.actortime":`Date Submitted`,
"message.approval.cannotsubmit":`Unable to Submit for Approval`,
"vue_label_pool_createdbyme":`I Created`,
"label.change.event":`Event View`,
"vue_label_homepage_personalpage":`Personal Homepage`,
"label.new.collect.target":`New Aggregate Target`,
"label.ServiceCloud.zichanxuhao":`Asset No.`,
"label.product.userl":`Columns for all users`,
"label.syslog":`System Log`,
"label.reportcreatestatus":`Report Generation Status`,
"label.datamanage.account.novalue":`Note: The account name field is null,the account records will not be imported.`,
"label.letter.body":`Invitation Text`,
"label.select.please":`Please select`,
"label.escalation.setup.entrydetail.description":`1.Click Edit to change the rule entries. <br/>2.Click New to add update operation.`,
"label.component.salesDashboard.nodata":`Add the business opportunity you are using, then return here to see the performance.`,
"vue_label_helpcenter_account":`?In the detailed information, click the tree diagram button next to the customer to view the customer hierarchy diagram, understand the child-parent relationship of related customers, and view some field information of each customer.<br>?When changing the owner of a customer, you can choose to change the owner of the customer-related business opportunities, cases and other information at the same time.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Intelligent Service Call Center`,
"label.productby":`Generated By`,
"label.operation.date":`Operated Date`,
"label.name.donot.delete":`Name can not be removed`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(date)`,
"label.escalation.setup.entrydetail.howescalationtime":`How escalation times are set`,
"label.view.step2":`Step 2 Specify Filter Criteria`,
"lable.outlook.edit.notnull":`You must enter the field name.`,
"label.knowledgebase.createnewbrowser":`New Browser Tab`,
"label.partner.all.name":`Partner Cloud Name:`,
"chatter.group.groupSetUp":`Group Settings`,
"label.reportlist.findfolder":`Find a folder...`,
"component.setup.tabs.label.title":`Tab paging`,
"label.passwordPolicy.setup.pswComplexReq":`Password complexity requirement`,
"label.emaildocument":`Send a document in the form of an emai`,
"message.selectgsummaryconditon":`please select the summary criteria`,
"component_todaytask_label_notask":`There is no expiry task today, take a coffee.`,
"label.user.organization.notexists":`The organization is not found.`,
"label.isEnableVisualpage.new.leftlist":`Available Custom Pages`,
"label.mobile.phone.write.week.report":`New Weekly Work Notes`,
"label.emailmerge.edittemplate.edit":`Mail Merge Template Edit`,
"template.dashboard.folder.sales.manage":`Sales Management`,
"label.confirm.order.productsToassets":`Are you sure you want to convert order product to asset?`,
"label.service.dispatchingUnits.leftRight.total":`Currently {{ left }}-{{ right }} records, {{ totalCount }} records in total.`,
"label.import.step1.chooseidorother":`2、You can choose to use ID or name to match the record and fill in the lookup field. If you need the corresponding record ID and other information, you can create a report and set the record name and record ID as group columns, and then export the report.`,
"label_tabpage_completez":`Mark the selected status to complete`,
"chatter.c.adr":`Address`,
"label.account.d":`This page allows you to define and edit custom fiscal quarter. The date of the custom fiscal quarter will be generated based on the choices you make below.`,
"label.tag.more50":`Create up to 50 tags`,
"setup.layout.label.areashow":`Display Section Header On`,
"label.partnerCloud.basicSetting.rebate":`Activate Rebate`,
"label.tabpage.greaterequalz":`Greater than or equal to`,
"vue.please.select.the.aggregate.basis":`Please select SUM BY options.`,
"label.form":`Forms`,
"label.chatter.colleagues.list.beizhu":`Enable`,
"label.priority":`Priority`,
"vue_label_checkduplicate_set_repeat_rules":`Set Duplicate Rules`,
"label.share_form":`Share your form`,
"label_relation_shareholder":`Shareholders and subsidiaries cannot be the same.`,
"label.project.hit.sixteen":`Issue Expiration Reminder`,
"label.service.miniProgram.imageFormat":`Only PNG, JPG and JPEG pictures are supported to upload.`,
"label.summary.mode":`Summary method`,
"vue_label_beforeverification":`Verify the first`,
"label.data.newtemplate.desc":`Save the fields and criterias selected by users as template and users can export data directly by export data template.`,
"lable.evaluation.badreview":`Bad`,
"label.total.tabs":`{0} Total {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Templates in this folder`,
"vue_label_normal_notice_repeated":`Please don't add repeatedly`,
"label.icon.140":`Data`,
"label.fromonetoanother":`from one user to another`,
"label.user.list":`All Users`,
"label.file.prevent.share.operate":`Prevent others from sharing and unsharing`,
"label.app.detail":`App Details`,
"label.h5.similar.opportunity.correlation":`Relativity`,
"label_emailtocloudcc_filed_username":`Email Address`,
"vue_labe_account_shareholdingratio":`Shareholding Ratio`,
"label.data.dataexpalltype.all_desc3":`3. Exported Successful data will generate a compressed file that users can download from the export success list page according to the information in the mail.`,
"label.callcenter.please.select .seatID":`Please choose the seat number`,
"label.remark.length.cannot.than":`The description can not include more than 255 charecters.`,
"label.batchtransfer.dateandtimetype.tip":`For date/time fields, enter the value in following format:`,
"label.component.helper.businesschange.0UntreatActivity":`Opportunities without unprocessed activity`,
"front-project-module-v1-plase-input-start-time":`Start Date`,
"label.event.moveup.6hour":`6 hours ahead`,
"label.data.exp.tempexp":`Export By Template`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Format`,
"label.objectHasBeenDeleted":`Deleted Objects`,
"label.ServiceCloud.chaxunchenggong":`Successfully searched`,
"label.campaign.channel.input.notice.owner":`Notify Owner`,
"label.bajisitan.time":`Pakistan Time`,
"label.warnMes":`Object referenced, delete failed.`,
"lable.Up.to.ten.fields":`Choose an object and add up to 10 fields to the chart. Click on the up and down arrows to sort the fields order.`,
"label.approverule":`Approval Rules`,
"message.error.specific":`Return specific error message`,
"front-template-V1-saveUse":`Save & Preview`,
"label.uploadfile.success":`uploaded successfully`,
"label.tabname.donot.database.key":`Tab name cannot be a database keyword`,
"message.recordtype.selectlayout.select":`--Select Page Layout--`,
"front-detail-module-v1-list-cardview":`List/Card View`,
"label.product.maintenance":`Maintenance`,
"vue_label_helpcenter_approve":`1. Items to be approved<br> List all the items that need your approval. You can search for records to be approved by the start date, end date, submitter, record type, and related items of the approval record.<br>Process a single record: Click the left button of each record.<br> A. Approval<br> Step 1: Click "Approve" to open the approval request page<br> Step 2: Click "Approve" or "Reject" to complete the approval operation.<br> If the next approval step in the approval process configuration needs to manually select an approver, step 3 is executed after "Approval".<br> Step 3: Select the next approver to complete the approval operation.<br> If you need to select the return step after the approval is rejected in the approval process configuration, go to step 4 after "Reject".<br> Step 4: Select the approval step to be returned to complete the approval operation.<br> B. Redistribution<br> Step 1: Click "Reassign"<br> Step 2: Find the reassigner<br> Step 3: Click "Reassign Approval Request" to complete the reassignment of approvers.<br>Note: If you are the deputy approver of a record, you cannot perform the reassignment operation.<br> Batch-process multiple records: After selecting multiple items to be approved, click the operation button above the list.<br> C. Approval<br> Step 1: Select multiple records to be approved<br> Step 2: Click "Approve"<br> Step 3: Click "Approve" or "Reject" to complete the approval operation.<br> If you need to select the return step after the approval is rejected in the approval process configuration, go to step 4 after "Reject".<br> Step 4: Select the approval step to be returned to complete the approval operation.<br> D. Redistribution<br> Step 1: Select multiple records to be approved<br> Step 2: Click "Reassign"<br> Step 3: Find reassigners<br> Step 4: Click "Reassign Approval Request" to complete the reassignment of approvers.<br> 2. Submitted projects<br> Lists all the approved items you have submitted. You can quickly search for the record you want to view through the start date, end date, submitter, record type, related items, and approval status of the approval record.<br> 3. My approved projects<br> Lists all the approved items that you have approved. You can quickly search for the record you want to view through the start date, end date, submitter, record type, related items, and approval status of the approval record.<br> 4. Reject items <br> Lists all the approved items that you have rejected. You can quickly search for the record you want to view through the start date, end date, submitter, record type, related items, and approval status of the approval record.`,
"label.knowledgebase.knowledge.article":`Knowledge Article`,
"march":`March`,
"label.accraditation":`Approve`,
"vue_label_pool_cantreach":`Can't reach the account`,
"label.service.appointmentList.startOf.maturityPeriod":`Start of Due Period`,
"message.huanxin.closed":`Inactive Chat Function`,
"label.implementation.time.operation":`Execute Scheduled Jobs`,
"label.setting.intergrationlist.permissions":`INTEGRATION PERMISSIONS`,
"label.translation.norecord":`No Records`,
"label.lack.expression":`Expression is lost`,
"setup.layout.message.relatedlistfield":`Select fields to display on the related list.`,
"label.group.file":`Group files`,
"message.error.id.null":`No such id information`,
"label.a_b_least":`Each "A" record must have at least one related "B" record.`,
"label.addattachment.step3":`Step 4 Click "Complete" to back to the previous page.`,
"label.data.exportsf":`Exported Files`,
"label.callcenter.call.out":`Call out`,
"front-electronic-export-exportIntro":`The selected data will be exported to the Mailchimp list you selected`,
"label.custombutton.deletedata.notnull":`Deleted data can not be empty.`,
"UG.homepage.002":`Manage your clues, leads, sales transaction funnels, and account information with integrated business tools`,
"label.globaloperation":`Global operation`,
"label.icon.58":`Worker`,
"vue_label_salesadvance_lostrate":`Churn Rate`,
"chatter.from":`from`,
"front-epwechat-module-v1-account-binding":`Bind on Account`,
"label.list.userinterface.old.page.setup":`Old page`,
"label.forecast.settings.periods":`&nbsp;cycle(s)`,
"label.file.share.email.content":`#sharedBy has shared a file with you on #orgname`,
"label.knowledge.category.hint.five":`Data Category Setting`,
"setup.layout.label.selectedfield":`Select fields`,
"label_business_income":`Opportunity Revenue`,
"vue_label_display_options_field":`Show Picklist Fields`,
"label.emailtocloudcc.set":`Set Mailbox Information`,
"label.knowledge.setting.data.five":`Delete Category: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Bound Enterprise`,
"label.ccpeak.delete.recycle":`The record will be removed into the recycle bin`,
"label.leadconvers.tip":`Leads cannot be converted to accounts, contacts, opportunities, and followup tasks.You should only convert a lead once you have identified it as qualified.`,
"label.rsa.key.invalid":`The public key is invalid, please log in again.`,
"label.mobile.bind.success":`Bind successfully`,
"label.emailtocloudcc.filed.servertype":`Email Server`,
"label.user.new":`New User`,
"label.setup.mobile.homepageshortcuts.remark":`Organizations can set the organization-level swift functions shown on the homepage top area according to the business scenario.`,
"label_emailtocloudcc_select2":`Select Display Type`,
"page.send.email":`Send Email`,
"label.service.newBuildDialog.field.display":`Fields to Display`,
"vue_label_homepage_card_impending":`Impending Opportunities`,
"label.message.contactispartner.delete":`A partner user is associated with this contact, cannot be deleted`,
"label.attendance.checkout":`Check Out`,
"label.emailmerge.newtemplate.description":`Enter information about your mail merge template.Note that the description displays in CloudCC.com only, not in Word.`,
"laebe.data.exp.success":`After successful export, you will receive an email reminder. The exported data will be saved on the server for 48 hours. Please download from the exported data list page as soon as possible.`,
"lable.Maximum.number":`A maximum of 50 characters is allowed for the template name.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Drag an existing task to current category`,
"label.forecast.tree.desc":`The forecast hierarchy determines how forecasts roll up within the organization, and who can view and adjust them. It is automatically generated based on your role hierarchy, but you may need to add or edit managers, sales reps, or other users.`,
"vue_label_chatter_upload_file_type":`Selected upload file-type post`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Analysis Dimension`,
"vue_label_homepage_custom_homepage":`Custom homepage`,
"label.icon.39":`Positioning`,
"label.appointmentpage.wizard.notif1":`Please choose a time first!`,
"vue_label_report_filterby":`Filter By {screenCondition}`,
"label.argentina.time":`Argentine Time`,
"label.role.assign.notremove":`Cannot remove the users from <b>Selected Users</b> to "All Unassigned and Active Users" or "All Unassigned Users".`,
"label.sharerule.detailsetshare":`Sharing Rule Details`,
"label.file.publicview.error1":`The file is deleted or public link is not enable`,
"label.data.downpage.e_title.num4":`4. The export files have two formats: CSV format and the compression format. The compression format is divided into two types: one is to automatically generate the compressed file password, the other is to manually enter the compressed file password.`,
"label.knowledge.case.article":`Case Article`,
"label.data.newtemplate.e.conditions":`Export Conditions`,
"front-object-change-owner":`The owner of the related lists record that corresponds to this account owner will also be changed to the new owner`,
"label.newdashboardpage.edittitle":`Edit Title`,
"label.datamove.end.query.no.record":`End of the query, no qualified records.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Collection Target`,
"label.orderagain":`Reorder`,
"vue_report_dashboard_transfer":`Move Folder`,
"label.view.sortview.default":`Default View`,
"label.brasilia.time":`Brasilia Summer Time`,
"label.industrialandcommercialverification.instructions":`Enable Industrial and Commercial Data Verification to assist the user to enter the correct client industrial and commercial registration information.Please note that this feature only supports querying the industrial and commercial registration info in mainland China.`,
"label.chatter":`Cloud post`,
"label.sso.goBackToList":`Back to List: Key Management`,
"label.mobile.side.tab.state":`Start custom slider`,
"label.weixin.addbus":`Add Vehicles`,
"label.dropbox.description":`Link your DropBox account to use it in CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Set this filter available to all users.`,
"label.knowledge.language.thai":`Thai`,
"label.passwordPolicy.setup.foreverlock":`Forever(must be reset by admin)`,
"label.bmap.unreported.location":`You didnot share your location information. Please set up in WeChat Official Account .`,
"label.tag.field":`Tags`,
"label.addyourlanguage":`Click Add to add the languages your organization supports.`,
"label.chat.topic.my.use":`Topics I use`,
"UG.contact.06":`Import contacts`,
"label.embed_code":`Embed Code`,
"label.campaign.channel.input.chenben":`3. Actual Cost:`,
"label.quickbooks.estimates":`Estimates`,
"label.report.items.i.created":`Reports I created`,
"label.forecast.edit.fwqd":`Range Start`,
"label.validate.function.funcExplain.DATEVALUE":`Create a date from its datetime`,
"vue_label_helpcenter_calendar1.1":`Events are a powerful tool to ensure that you always understand customer relationships and close deals. You can associate events with opportunities, leads, customers, and contacts. The calendar view mainly displays event records.<br> 1. Calendar view and list view<br>View calendar<br> Click the calendar tab of the navigation menu to access the calendar page. <br>Calendar view<br> Classification of calendar views: Calendar views are divided into month view, week view, day view and availability view. The recorded data of different time ranges can be displayed separately through different grid styles. The availability view displays daily record data with each calendar as the dimension, including my calendar and other calendars. Click the "calendar button" icon at the top right of the calendar page to switch views. <br> What can be viewed in the calendar view: Calendar includes my calendar and other calendars. You can view my calendar on the calendar view, including all the recorded data of my event calendar and object calendar. We refer to these records as "calendar entries." <br> You can view all the events you have in the calendar view. The calendar you create with the object will display the data as calendar entries in the calendar view in the date field. You can also view other calendars on the calendar view, that is, you can view any calendar entries shared by your colleagues that you have added to the view. <br>`,
"label.tabpage.rowsz":`Delete rows`,
"label.file.library.managemembers.memberlist":`Current Members`,
"label.report.action.addtodashboard4":`Add to Exsiting Dshboard`,
"label.chat.send.voice":`Send a voice message`,
"label.home.dashboard.add":`Add to Homepage Dashboards`,
"front-dialog-module-v1-copied-requestid":`Request ID is cloned`,
"label.customfields.exportdata":`Data Export`,
"label.emailobject.signature":`Signature`,
"label.hide.source":`Hide Source Code`,
"label.icon.71":`Service`,
"vue_label_help_whatslightning":`What is Lightning`,
"report.type.label.systemReport":`System Reports`,
"front-kefu-moudle-v1-input-email":`Please enter email address`,
"label.event.moveup.5minutes":`5 minutes ahead`,
"message.error.postsid.null":`Post ID cannot be empty!`,
"UG.Account.05":`Contact structure diagram`,
"label_emailtocloudcc_description3":`Connect your enterprise email account, such as sales@company.com, info@company.com, support@company.com. Automatically log emails you recieved as leads and cases records in CloudCC to ensure timely follow-up of customer's letters.`,
"report.label.searchresult":`Search Results`,
"vue_label_report_detailsonly_desc":`Export detail rows only. Use this data for additional calculations or to upload to other systems.`,
"label.partnerCloud.partnerAccount.payment":`Payment Amount:`,
"vue_label_commonobjects_view_select_member":`Select member`,
"label.emailtocloudcc.step1.lead1":`Email to Lead`,
"label.forecast.settings.current":`Current Period`,
"label.canceluploadfile":`Cancel upload`,
"label.manual.shared":`Manual Sharing`,
"label.document.uniquename.length.cannot.than":`The length of the document unique name cannot exceed 255 charecters.`,
"vue_label_lead_notcreateopportunity":`Do not create opportunity`,
"APPIntegration.Social.twittererror":`You must enter a valid URL for twitter.com`,
"message.duplication.label.errormessage":`Error Message`,
"label.file.img":`Image`,
"label.tabpage.sum":`Total Count?`,
"label.permission.systempermission.fenpei":`Permission Assignment`,
"template.dashboard.folder.data":`Data Analysis`,
"label.sms.account":`User Account`,
"label.product.filter":`Product Filter`,
"label.file.content":`Text content`,
"label.percent":`Percentage`,
"label.single.attachment":`Single`,
"label.processsetting.failed.enable.process":`Failed to activate path`,
"label.view.modify":`Edit`,
"label.knowledgebase.enter.keywords.filter":`Pleas enter keywords to filter`,
"label.tabpage.uploadfailez":`Upload failed, please reupload.`,
"label.please.enter.the.target.model.name":`Please enter the name of target model.`,
"label.layout.availabletab.related":`related`,
"label.label":`Label`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Saturday`,
"label.addattachment.unit":`byte`,
"vue_label_commonobjects_view_selected":`{checkedLength} record(s) selected`,
"label.view.sortview.printble":`Printable`,
"label.umeng.insert.approval.approvaling":`#applyer submits #obj #objname for your approval`,
"label.forecast.customforecast.tztotal":`Adjusted Total Amount`,
"label.ccchat.failtoset":`ccchat setting error`,
"label.ccchat.message.new.error2":`CCChat User`,
"label.validate.function.category.Advanced":`Advanced`,
"label.projectManagement.team.members":`Team members`,
"vue_label_report_clickcrosstofliter":`Click the intersections in the table above to filter details.`,
"lable.opppdt.selPdt.leasttwenty":`You can select up to 25 lines`,
"label.campaign.channel.download":`Download HD QR Code`,
"component_event_label_person":`Assigned person`,
"vue_label_homepage_new_homepage":`New Homepage`,
"label.version.sum.vlidaterule":`Validation Rules`,
"vue_label_chat_click_for_details":`Click for details`,
"label.fold":`Fold`,
"label.readonly":`Read-Only`,
"label.h5.similar.opportunity.result":`Similar Opportunities`,
"label.yourimportsuc":`Your import request has been processed, please view your email.`,
"label.report.line.yixuan":`Selected report column`,
"setup_layout_label_areaname":`Section Name`,
"label.forecast.edit.title":`Targets`,
"label.chatter.allweather":`All-weather`,
"label.service.ganttBaiduMap.scheduled.endtime":`Planned End Date`,
"lable.create.new.list":`New List`,
"label.emailobject.groupemail.msg3":`{0}mail`,
"lable.opppdt.selPdt.description":`Enter your keyword and filter criteria.then click Search to begin your search Click More filters to use more than one filter.Search results include all records that match both your keyword and filter entries.`,
"label.file.versionerror1":`You can click the link below to switch directly to the new interface file tab, or you can use the file tab function after manually switching to the new interface`,
"label.under.approve.record":`Pending`,
"front-epwechat-module-v1-open":`Enable`,
"label.projectManagement.delete.task":`Task and all related information of this task will also be deleted if you remove the task, and the data cannot be recovered. Are you sure to confirm the deletion?`,
"label.reportforms":`Reports`,
"label.tabpage.onlymevisible":`Me only`,
"label.customer.tab.please.name":`Please enter the tab name`,
"label_emailsync_form_stutas":`Status`,
"message.recordtype.nolist":`No record types defined.`,
"label.version.forecasting.sales":`Forecasts`,
"chatter.sel.mostfield":`You can select up to`,
"label.data.derived":`Data Export`,
"label.component.helper.businesschange.expiredtask":`Opportunities with Overdue Tasks`,
"label.cycle":`Cycle`,
"lable.product.standp":`Standard Price`,
"label.sendemail.batchapproval":`Batch Approval Action`,
"message.organization.not.open.mffverification":`The organization does not enable the secondary certification.`,
"label.icon.131":`Umbrella`,
"UG.activity.08":`Reserve a schedule`,
"label_partner_workspace_member_choicepermission":`Select permission set`,
"label.reportTypeCategory":`Report Data Source`,
"label.exporttwotype":`You can export two kinds of text`,
"message.oppdt.selectpricebook":`Please select price book`,
"vue_label_dashboard_generatefromlistview":`Generate from List View`,
"label.quote.title":`Title`,
"label.tianyancha.businessverify.cancel.sure":`After disabling the verification of business data, it is impossible to backfill business registration information when creating/editing a customer. is it confirmed?`,
"label.save":`Save`,
"label.mobile.quickcreate.default.appstore":`Apps`,
"label.partnerCloud.orderingPlatform.configure":`{a} products are not configured, please save after configuration.`,
"front-epwechat-module-v1-unbound-role":`Unbound Roles`,
"label.partnerCloud.financeSetting.enterAlipay":`Please enter enterprise acocunt of Alipay.`,
"label.validate.function.funcExplain.TODAY":`Back to Current Date`,
"label.visualpage.parameter.values":`Display parameter values directly on the page:`,
"label.version.task.and.activity":`Task and Activity Tacking`,
"label.audit.history":`Approval History`,
"setup.object.field.dependency.label.addtolist":`Add the selected values`,
"vue_label_report_exportquantity":`Export quantity:`,
"label_tabpage_havez":`Attached`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Available Rebate Amount`,
"label.createralias":`Created By Alias`,
"label.created_followup":`Create Followup Email`,
"label_chatter_mygroups":`My groups`,
"label.chat.topic.no.display":`No displayable topics`,
"vue_label_calendar_month_view":`Calendar-month view`,
"label.service.gantt.resources.assigned.work":`Resources with Assigned Work`,
"UG_activity_07":`Create a task`,
"label.quote.xsjg":`Selling price`,
"message.toomanyrows":`Too many records to query.`,
"label.importsourcestep1":`Step 1 Prepare the translated Tab Separated File`,
"vue_label_normal_appointment_sf":`Appointment`,
"lable.list.queue.message":`The queue cannot be deleted, because there are object records belong to the queue.`,
"label.service.major.event.desc":`Milestone represents time-dependent steps in the support process. It can be added to the beginning of the entitlement process. You can then apply the process to accounts entitlement and create case or work order from them.`,
"label.ems.hostorport.null":`Both the server and the port cannot be empty.`,
"chatter.group.private":`Private`,
"label.icon.192":`Soap Bar`,
"vue_label_systemSettings_list":`Related List Display Setup`,
"label.activity.saveobj.notnull":`The saved object cannot be empty.`,
"vue_label_chatter_current_no_people_approval":`Currently no people requiring approval`,
"label.tianyancha.reglocation":`Registered address`,
"UG_ST_005":`I've got it, do not show me this page again and login straight next time.`,
"label.vlidaterule.example.truetodisplay":`This message will appear when Error Condition formula is true`,
"label.icon.99":`Notes`,
"label.whenselectmoreapprover":`When you select more than one approver`,
"label.forecast.customforecast.directorbest":`Best Case of Direct Subordinate`,
"label.customsetting.view.introduce":`Provide values for the fields you created. This data is cached with the application.`,
"label.there.are.no.unenabled.rules":`All rules are enabled.`,
"front-project-module-v1-plase-selectemplat":`Please select project template`,
"label.campaignmember.selectmember.from":`From`,
"setup_layout_button_quicksave":`Quick Save`,
"label.setup.service.report":`Service Report Template Setup`,
"label.visualpage.direction.for.use":`Instruction Of Custome Pages [version 2.0]`,
"message.modify":`Are you sure you want to modify?`,
"label.sms.inside":`Interior`,
"label.category.3":`Education`,
"label.login.mfadevice.verification.title":`MFA Devices Verification`,
"UG_Forcast_08":`Previous step`,
"label.projectManagement.unable.to.complete":`Unable to complete`,
"front-kefu-moudle-all-missphone":`All missed calls`,
"font-evaluate-module-v1-emergency":`Warning`,
"label.sso.saml.sp.idsource.attr":`Identity is in an Attribute element`,
"chatter.not.meg":`Cannot send an empty message.`,
"label.chatter.startDate":`Start Date`,
"label.emailobject.track.times":`Total opens: {0}`,
"label.customsetting.fieldhasbeendeleted":`Deleted fields`,
"label.knowledge.setting.hint.thirteen":`Add Other Data Category`,
"message.duplication.label.newfiltertitle":`New Duplicate Rule`,
"setup_object_field_dependency_label_selectedfieldvalue":`Available Field Values`,
"vue_label_calendar_who_currently_has_access":`Who currently has access`,
"message.passwordPolicy.validate.minlengthe":`character(s)`,
"label.emailsync.status.disconnect":`Cancel Conncet`,
"label.applt.down.one":`Download`,
"label.manageAll.sel.one2":`Items I submitted`,
"message.error.SQLTimeout":`Due to the improper configuration of the system or unoptimized custom SQL queries, the system has exceeded the query capability allowed which cause the query failure. Please contact the system administrator for system tuning.`,
"label.global.search.obj.setup":`Global Searchable Object Settings`,
"vue_label_commonobjects_view_chat":`Team`,
"vue_label_systemSettings_startSet":`Start Setup`,
"label.quickbooks.viewlist.balance":`BALANCE`,
"message.error.fieldid.null":`fieldid cannot be empty! File content id`,
"label.replaceallnullvalue":`Replace all blank values`,
"label.georgia.time":`Georgia Time`,
"label.hastransfer":`Contains Converted`,
"label.partner.all.description":`Description`,
"font-evaluate-module-v1-following-peopple":`When you received the negative review, notify the following users`,
"label_business_count":`Opportunity Amount`,
"vue_label_ccchat_closedetail":`Close`,
"label.partner.all.disable":`Disable`,
"label.view.relationship":`Object Relation`,
"label.noless":`>=Greater Than or Equal`,
"label.sendsms.batch.step2":`Step 2 Select an template or customize your SMS content`,
"label.stdashbord.xsld.business.jieduan":`Stage Name`,
"label.appupload.component.type.trigger":`Trigger`,
"label.knowledge.setting.data.two":`The category name is required.`,
"label.color.display.of.completion.rate":`Color Display of Fulfillment Rate`,
"label.loginhis.default":`List the last 200 history records by default`,
"vue_label_pricebook_book":`Current price list`,
"label.knowledgebase.data.deletion.failed":`{a} data delete failed`,
"label_partner_workspace_member_permission":`Available permissions set`,
"label.list.userinterface.approval.setup":`Approval Setup`,
"label.weixin.binding.effect":`Binding invalid, please login again.`,
"label.appupload.install.newapicannotnull":`New api name cannot be empty`,
"chatter.feed.menutype.feed.company":`All Posts`,
"label.assignment.setup.detail.email":`Email`,
"label_tabpage_selectcontentz":`Please select content`,
"template.report.converted.leads.campaign":`Converted Leads from Campaigns`,
"label.forecast.season":`This Quarter`,
"label.post":`Post`,
"label.knowledge.setting.hint.fifteen":`The foundation has been laid. Now you and your team can write and organize your Knowledge articles.`,
"front-kefu-moudle-v1-Seats-name":`Agent Nickname`,
"label.weixin.leadname":`Lead Name`,
"label.account.quarter":`Quarters`,
"label.detail.field":`View Fields`,
"label.icon.189":`Cosmetic`,
"label.appointment.disable.reappointment":`Deactivate Reschedule`,
"label.appointmentconfirmpage.wizard.subtitle1":`Event name`,
"label.campaign.channel.step6.remark3":`System will generate a unique QR code for solicitation, which can be used by employees and the accomplished solicitations can be counted towards their personal performances.`,
"System.AddressFieldType.Post":`Zip Code`,
"label_partner_new_step2":`Step 2 Confirm template`,
"vue_label_helpcenter_file":`View and manage your files<br> Use the new version of the file object to view and manage files owned by you or shared by others. You can preview files in some formats online. <br>File library<br> Use the file library function to establish a team knowledge base, set up different administrators and members for convenient management; use the folder function to classify files.`,
"label.locateddowncurrentvalue":`The value below the current one`,
"label.tianyancha.businessverify.msg5":`2. service reliability`,
"label.setup.mobile.bottombutton.change.success":`Successfully changed`,
"label.appointmentconfirmail.wizard.subtitle2":`Time`,
"label.email.address.lookup":`Search email address`,
"setup.mainpage.label.welcome":`Welcome to CloudCC PaaS platform, the main functions of the platform are as follows:`,
"label.icon.55":`Bulldozer`,
"label_tabpage_enterrecordnamez":`Please enter the record owner`,
"label.tabpage.andz":`And`,
"label.selectfiletoimport":`Select file to import`,
"label.version.sum.trigger":`trigger(s)`,
"label.multi.layout":`Compact Layout`,
"pagecreator.button.back":`Previous Step`,
"label.imgfield.truetype":`Please upload the correct picture type`,
"front-kefu-moudle-v1-publicKey":`Shared Key`,
"label.data.exp.newtemp":`Template Create`,
"label.martrixreport.2018.step4.new":`Step 4 Choose column headers`,
"label.sendemail.chat.addComentsatsubject":`I was mentioned in CloudCC CCChat message`,
"vue_label_applauncher_description_leadpool":`Use the Lead Pool to conveniently manage the follow-up status within the organization and motivate personnel to complete transactions.`,
"label.knowledgebase.archive.published.articles.without.drafts":`You can only archive published articles that without any drafts.`,
"label.projectManagement.bar.chart":`Bar Chart`,
"label.ccpeak.condition.return.sort":`Return and sort by conditions`,
"label.salescloud.opportunity.contactrole":`Opportunity Contact Role`,
"label.language":`Language`,
"message.error.view.badprevilege":`Sorry, you are not authorized. Please contact the administrator!`,
"label.textmessage.managetemplates":`Manage templates`,
"message.error.type.null":`The type cannot be null!`,
"setup.mainpage.label.welcome9":`Users can realize the classification display and layout adjustment of all page elements and the setting of read-only and required fields of the fields on the page by dragging and dropping the mouse without code development.`,
"label.appupload.component.type.page":`Custom Pages`,
"label.textmessage.bookschedule":`Click the link below to see and book my schedule:`,
"component_chatter_post_button_save":`Publish`,
"lable.oppt.jieduan.signcomplete":`Mark the status as completed`,
"label.help.notes":`HELP AND GUIDE`,
"label_tabpage_reallproplez":`Record all people`,
"label.obtain.authorization.failure":`Failed to acquire authorization code. Please reauthorize.`,
"label.account.FiscalQuarter":`Fiscal Quarter`,
"label.customsetting.savecustomvalue":`Data for this location already exists, please modify it and save it again.`,
"label.maximum":`Maximum`,
"component_chatter_file_label_maxsize":`Maximum file size is 20m`,
"c218":`Your post has been saved as a draft`,
"c875":`New post for conversation`,
"c1623":`Validate Provider`,
"c183":`Tag Filter`,
"c366":`Configure the Pool`,
"c91":`Email Interaction Score`,
"c2193":`Maximum field length 1500`,
"c184":`Stage Advancement`,
"c1957":`Recents`,
"c750":`Initiator:`,
"c1016":`Parameter Name`,
"c2084":`Package ID cannot be empty`,
"c619":`Twitter posts must have 280 characters or less. Try using contractions to shorten things up.`,
"c2094":`Note: Assignment priority of case owner is lower than that of Rules of assigned cases.`,
"c1261":`Trial product series`,
"c1172":`Select Buttons`,
"c1220":`Selected Custom Component(s)`,
"c69":`Payable`,
"c675":`Leftaligned`,
"c1280":`Assigned users in East China`,
"c1880":`Estimated Time`,
"c2307":`Row {0} has mismatched value format. Please enter in format of yyyy/MM/dd or yyyy-MM-dd`,
"c533":`Count of Upgraded Cases`,
"c1662":`Attendance Entries`,
"c167":`The order length is required`,
"c682":`Square`,
"c1572":`Create a file containing the label and translation for each language you want to import.`,
"c960":`Super Edition`,
"c1797":`10 days`,
"c1966":`This field cannot be used to create main condition`,
"c1126":`Edit currency type: New currency (Select new currency from list)`,
"c1033":`At least 2 options under each question!`,
"c850":`This shows the current number of followers for each of your social accounts except for Facebook which shows the current number of page likes.`,
"c343":`Add Project Members`,
"c1007":`Copy Total Price`,
"c8":`Choose form`,
"c1548":`Add pre-determined selection`,
"c157":`Open order taking mode`,
"c1039":`View Email`,
"c1656":`Invoices`,
"c1482":`Clear coordinates`,
"c1359":`Hovering layout`,
"c1832":`Registration processor template is automatically created on save`,
"c397":`Service Crew`,
"c556":`images are failed to be posted`,
"c563":`Active Time`,
"c179":`Partner Logo`,
"c1856":`Calculation Rules`,
"c147":`Order Taking Rules`,
"c1787":`Punch-in reminder`,
"c303":`Legal Obligation`,
"c1491":`Properties`,
"c885":`Hide sidebar`,
"c1849":`Drag or choose file to upload`,
"c1012":`Standard Price`,
"c1503":`Pane height in pixels (Range of input value: 1-2560px)`,
"c808":`Insert Image`,
"c718":`Continue set up`,
"c414":`Thank you for your time in completing it.`,
"c9":`Employee who sent invitation`,
"c1066":`Main Label Language`,
"c1683":`Objects`,
"c1974":`Assignment Cancelled`,
"c1844":`Application connected with OAuth`,
"c1448":`Maximum quantity cannot be empty.`,
"c2104":`Form Configuration`,
"c15":`It has been invoiced. Please reselect`,
"c1806":`Please check whether the basic form is complete`,
"c1226":`Trigger Action`,
"c1179":`Approval or Rejection Based on the First Reply`,
"c1919":`Upload Word files after creating templates.`,
"c59":`Please bind as Easemob administrator seat first and then enter the advanced setup.`,
"c1529":`< span style='color: # ff0000' > error: incorrect field format < / span >`,
"c504":`Plan projects, assign work, manage resources and collaborate with your team to achieve project goals, control project progress, deliver the project on schedule and within budget.`,
"c836":`Bind Fadada Account`,
"c2233":`Access identity URL service`,
"c187":`Thank You Page`,
"c208":`Download Package`,
"c1851":`First-time login`,
"c952":`Brazil`,
"c104":`Reply once`,
"c1171":`Available Buttons`,
"c1834":`Verify provider details`,
"c1847":`Enable Quick Creation`,
"c346":`Calculation of Task Resources`,
"c1801":`Unable to create queue, number of queues for {0} object(s) exceeds limit.`,
"c1322":`Show columns`,
"c1194":`2 cycles ago`,
"c913":`Expand sidebar`,
"c571":`{selectnumber} form(s) has been selected`,
"c1749":`Click Log out`,
"c1558":`Detail data`,
"c44":`Choose a network to connect`,
"label.social.posts.content.null":`Post content is empty`,
"c1799":`Never expire`,
"c852":`Company Name (Unfilled)`,
"c561":`Apply Filter`,
"c1072":`Case Team Roles to Be Replaced`,
"c2235":`No matching resources. Try changing strategy.`,
"c1626":`Webpage Tools`,
"c1058":`Hide History`,
"c1881":`Folder test`,
"obtain.contract.envelopeid.fail":`Failed to get envelope information or unbound message information`,
"c465":`Only orders using the same currency can generate an invoice`,
"c982":`The current price book is deactivated`,
"c350":`Task Sorting`,
"c352":`Personnel Resource Calendar`,
"c670":`Graphic Icons`,
"front-electronic-signature-given":`Delivery`,
"c542":`Satisfaction Evaluation`,
"c314":`Generate Invoice File`,
"c2257":`Manage Support Items`,
"c148":`Email Notification Setup`,
"c47":`Connect Domain`,
"c1745":` Limits of Authority`,
"c1440":`Please enter pool name`,
"c754":`Fill in`,
"c326":`Asset BOM`,
"c2311":`Overdue & cancel assignment`,
"c289":`Preference`,
"c196":`Limitation Notice`,
"c1306":`Task sync direction`,
"c63":`Open {objName}`,
"c769":`The initiated signed task document will be cleared after the revocation. Continue to undo?`,
"c216":`Your post has been scheduled`,
"c842":`Send Notification of Submission Email`,
"c389":`Parent Service Territory`,
"c7":`Promotion Owner`,
"c981":`Tianjin`,
"c143":`Select the user to receive notifications. This setting can be changed in any landing pages that the form is used on.`,
"c930":`Employee Positioning Switch`,
"c1861":`New Record Type`,
"c1621":`User and Control`,
"c2313":`Dispatch of {!ServiceTerritory.name} overdue and cancelled. ID {!ServiceAppointment.name}, click to view.`,
"c515":`Add Work Summary`,
"c393":`Service Territory Member`,
"c1162":`Remove field`,
"c1235":`Forecast data set`,
"c357":`Rate`,
"c1660":`Absence if Service Resources`,
"c597":`Target Gauge`,
"front-electronic-signature-cancelIntro1":`The Esignature of DocuSign will not be available after unbinding. Are you sure to unbind?`,
"c271":`You have a timeout of accepting order, number: {0}. Please deal with it promptly and be aware of work delaying. Click to see more >`,
"c1292":`Different colours are used to show different status.`,
"c1059":`Invoice Item`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amap does not work properly. Please check whether the secret key is correct!`,
"c424":`Service Territory Management`,
"c1729":`Properties of Time Field `,
"c2164":`Auto wrap text`,
"c995":`Please select pool!`,
"c711":`Connect your social accounts and reach a whole new world of fans.`,
"c1658":`Field Service Cloud Objects`,
"c1770":`Time Dimension`,
"c197":`You have reached the maximum number of submissions. Thanks for your participation!`,
"front-electronic-signature-save-success":`Save mapping successfully`,
"c765":`Blocked`,
"c1852":`Organization-level default sharing settings`,
"c1445":`Other Settings`,
"c1575":`Please upload files in CSV format`,
"c1383":`{n} Cycle(s)`,
"c2151":`Share the parent work order of the dispatched service appointment with the assigned service team members`,
"c1244":`Maximum length exceeded`,
"c286":`Noncompliance`,
"c145":`The submitted work hours for one/multiple tasks per person per day cannot exceed 24 hours.`,
"c264":`Manage Personal Fields`,
"label.china":`China`,
"label.no.bind.mobile":`No mobile. Please go to personal information and bind`,
"c95":`Delete Selected Products`,
"front-electronic-signature-open-signInfo1":`The Esignature&stamp of DocuSign is enabled. Please turn it off then enable the Esignature&stamp of Fadada.`,
"c1342":`Please note that this verification only supports industrial and commercial enterprise data registered by Chinese mainland.`,
"c1393":`Download login history (last 6 months)`,
"c1501":`Pane Height`,
"c1077":`Member Names`,
"c1661":`Service Resource Man-Hours`,
"c1659":`Service Contracts`,
"c1283":`Mapping field`,
"c391":`View Comment`,
"c1499":`3 times`,
"c1802":`List of optional search results fields`,
"c106":`Interactions`,
"c2090":`Instructions for Service Applications`,
"c1120":`Please select a field and click Insert. Labels followed by '>' indicates that there are more fields available.`,
"c1736":`Provider Type`,
"c2258":`Script Name`,
"c519":`All related information of this timesheet will also be deleted if you delete this timesheet, and the data cannot be recovered. Are you sure to confirm the deletion?`,
"c528":`Log Timesheet`,
"c1000":`Got it!`,
"c78":`Order No.`,
"c983":`Link URL`,
"c41":`Unbind successfully`,
"c1495":`10 Characters`,
"c517":`Please enter a valid tax rate`,
"c1624":`Authorize Link Management`,
"c774":`Sign progress`,
"c296":`Please fill in the field name`,
"c996":`Please select reason!`,
"c1112":`Waiting for input`,
"c757":`To accept`,
"c1251":`The following shows a list of the valid and invalid approval processes for 220309-subchecks. 
To create an approval process, click create New approval process, and then select use Jump start Wizard to set up your approval process in just a few steps. Alternatively, select Use Standard Guide to configure all approval options.`,
"front-electronic-signature-confirmintro":`Bind successfully. You can initiate signing from the Contracts object now.`,
"c1434":`Mobile page layout: applied to the display layout of WeChat web pages and mobile devices`,
"c1169":`Reversed`,
"c1006":`Total Product Price`,
"c1805":`Please check whether the URL parameter name configuration is complete`,
"c1543":`CloudCC License`,
"c1950":`Author`,
"c1561":`Mail Template Name`,
"c1737":`Provider Name`,
"c446":`Task Status`,
"c238":`{!ServiceResource.name} accpted the order. Account: "{!ServiceAppointment.accountid.name}", Subject: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}"`,
"c980":`Shanghai`,
"c802":`Each user can only be added as a service resource`,
"c1895":`Transfer to this Call Center`,
"c1312":`Check passed`,
"c387":`Service Resource Skills`,
"c965":`EaseMob Service is not enabled`,
"c1070":`Case Access`,
"c480":`To which list shall we send?`,
"c2140":`{0} shared a post in {1}. Click to view.`,
"c937":`Change Phone Number`,
"c1229":`Object ID`,
"c1920":`View tutorial for creating Word files.`,
"c632":`View on Facebook`,
"c131":`The account field of the invoice is empty, please add the information.`,
"c1088":`Records to apply rules to`,
"c1632":`Customize Portal`,
"c680":`White`,
"c806":`When`,
"c2174":`Partner contact belongs to current customer by default`,
"c2237":`Notification Settings`,
"c1873":`Brand domain`,
"c1971":`Failed to create new rules. Please retry.`,
"c2143":`Dispatches Shared
`,
"c649":`You've read everything in your inbox.`,
"c797":`Recent Contacts`,
"c616":`Open link in new window`,
"c987":`Scheduled Time`,
"c169":`Sorry, you don't have the permission to view this chart`,
"c1545":`CloudCC Partner License`,
"c1923":`Please upload .docx files when combining related record fields.`,
"c1316":`Service account username (domain username or UPN)`,
"c1577":`English`,
"c1214":`New Custom Object menu`,
"c21":`The product number cannot be less than the invoiced amount`,
"c1512":`Please do not add duplicated component.`,
"c1432":`Row layout: the layout displayed when it is applied to the master-slave input of the foreground and the batch addition`,
"c231":`Cannot be less than the number of products that has packed`,
"c1057":`View More`,
"c1900":`Ready?`,
"c1009":`Activate/Deactivate Price Book`,
"c1110":`All modules`,
"c555":`Your post image is failed to be published.`,
"c583":`Map of China`,
"c1629":`Self-Service Portal`,
"c1932":`Create data categories`,
"c1633":`Portal User`,
"c1869":`Starting range`,
"c1218":`Create Action`,
"c1488":`Add footer tools`,
"front-electronic-signature-open-signInfo2":`The Esignature&stamp of Fadada is enabled. Please turn it off then enable the Esignature&stamp of DocuSign`,
"c822":`New External Contacts`,
"c600":`Numeric Chart`,
"c1918":`Upload Word template.`,
"c442":`Allround project management system`,
"c1136":`Add assignments`,
"c762":`To sign`,
"label.user.not.permission":`The current user does not have permission to operate`,
"c35":`Subscription Name`,
"c1477":`Case upgrade rule: New`,
"c1916":`Current object`,
"c921":`role(s)`,
"c1207":`Copy the following script and paste it into the HTML source code of the site before the closing tag, which must be inserted into each page where the window widget is to be displayed.`,
"c2210":`New Translation`,
"c305":`Public Interests`,
"c1836":`Please select provider type`,
"c2312":`Dispatch overdue and cancelled. ID {!ServiceAppointment.name}, click to view.`,
"c730":`You cannot reuse the old password`,
"c1885":`Call Center URL`,
"c1638":`Project Cloud Settings`,
"c1223":`Untitled Condition 1`,
"c1155":`The name must be unique.`,
"c525":`Disable Portal User`,
"c942":`America`,
"c780":`Signature Process`,
"c1202":`action. Continue?`,
"c447":`Final Channel Source`,
"c1408":`Configure the organizational home page according to the actual usage scenario.<br>You can disable or disable components that are not related to the enterprise business from the default configuration. <br>Enabled: enabled modules are displayed on the home pages of all members. <br>Disabled: disabled modules are not displayed on all members' home pages, nor are they supported in the configure my Home Page list on mobile. <br>Off: it is not displayed on the home page of all members of the organization by default. Users can open the module by "configuring my home page" on the mobile side.`,
"c1200":`Deletion cancelled`,
"c369":`Send Quote File`,
"c702":`Make Draft`,
"c22":`The paid amount on invoice will be greater than the total value if you continue to create this payment detail. Please readjust the amount and save again.`,
"c79":`Order Date`,
"c2260":`Enable script?`,
"c785":`Real Name (Optional)`,
"label.insert.approval.reassign.error":`Approval in the inserting approval status cannot be reassigned`,
"c1096":`This rule will apply to all records`,
"c998":`Module`,
"c273":`Accepting order timeout. Cancel the dispatching.`,
"c3":`Delete chart successfully`,
"c448":`Chat Session`,
"c495":`Everything You Need to Sell Faster and Smarter`,
"c429":`Dispatch KPI`,
"c1977":`Please enter custom script`,
"c1811":`Developer`,
"c1147":`Permission name`,
"c1269":`Option`,
"c16":`More than one invoiced orders exist. Please reselect`,
"c1087":`Use the following strategies`,
"c1644":`Account Group Settings`,
"c1084":`Tax amount should be a number`,
"c1708":`Disabled: disabled modules are not displayed on all members' home pages, nor are they supported in the configure my Home Page list on mobile.`,
"c128":`Up to 5 rows can be added`,
"c955":`The minimum width of {label} is {minWidth}px`,
"c1427":`AUD`,
"c1556":`Group name`,
"c716":`You're ready to start posting right from CloudCC`,
"c1702":`Upload Photos or Not`,
"c1724":`Format error. Please use the format of yyyy/MM/dd HH: mm: ss or yyyy-MM-dd HH: mm: ss, or function: Today()`,
"c2123":`Allow external users to register and be auto-activated`,
"c638":`Publishing Options`,
"c746":`Revoke request of destroying`,
"c534":`Count of Closed Cases`,
"c1685":`Project Plan`,
"c948":`Italy`,
"c1710":`Verification Failed`,
"c317":`Send Purchase Order File`,
"c426":`Service Resource Management`,
"c1252":`You may create various page layouts in this page to display user data. 
Click <Page Layout Assignment> to select the default layout for users.`,
"c1831":`Auto create registration processor template`,
"c1219":`Available Custom Components`,
"c457":`Aggregate Contract Amount Ranking`,
"c263":`Personal Fields`,
"c372":`Generate Order`,
"c1930":`Article translation - Edit`,
"c907":`Only available in lightning version`,
"c1795":`Buttons displayed on the bottom of detail page`,
"c771":`Fill progress`,
"c2197":`Custom Label Details`,
"c408":`Customisable field service application`,
"c1522":`Custom Buttons and Links`,
"c12":`Growth Rate`,
"c1827":`Custom logout URL`,
"c379":`Payment Details`,
"c410":`Work Type`,
"c510":`Partner Ordering`,
"c1928":`View drafts`,
"c701":`Assign Campaign`,
"c617":`Text is required to publish a post`,
"c2136":`Not authorized`,
"c1630":`Brand Reconstruction`,
"c213":`EPS Format`,
"c1649":`Score Settings`,
"c2230":`Grant Access?`,
"c473":`The system will generate unique invitation code for employees, who can use the invitation code to make invitations and count as personal performance. Please note that the lead owner will be the current campaign owner or marketing channel inviter`,
"c975":`Approve and Schedule Draft`,
"c1239":`Share`,
"c1975":`Dispatch {0} cancelled. Click to view.`,
"c1921":`View field value`,
"c168":`Please choose a chart!`,
"c121":`Uncategorized`,
"label.send.invoice":`Send Invoice`,
"c792":`Confirm Initiating`,
"c1309":`Please enter name of workflow`,
"c686":`Size`,
"c2102":`Prompt when exceeding limit`,
"c1373":`1 Column`,
"c1295":`Workflow rules allow you to perform certain automatic actions on specific records based on filter conditions. 
Workflow automation can send Emails, update fields, create records, and so on.`,
"c1108":`Please check whether condition configuration is completed`,
"c1603":`Properties of Image Field`,
"c1959":`Number of Decimal cannot be empty`,
"c652":`This shows the number of posts that were poblished across your accounts within the selected period. This also incloudes posts that were published to your connected accounts outside of CloudCC.`,
"c136":`Please enter brief introduction here`,
"c1970":`Create New Dynamic Layout Rules`,
"c662":`Custom icon`,
"c1191":`Select   Final Approval   Lock Records`,
"c2082":`Install Package`,
"c1865":`User 2`,
"label.invoice.customer.is.error":`Invoice generation is only supported for orders placed by the same customer.`,
"c580":`Bubble Chart`,
"c1101":`New webhook`,
"c894":`Assign campaign for post and you can review all related posts in the same campaign. This used for anlyazing marketing effort.`,
"c1297":`New Workflow`,
"c570":`Design`,
"c1597":`Properties of Picklist (Multi-Select) Field`,
"c1613":`Import My Accounts`,
"c133":`exceed`,
"c564":`Dear user: <br/> Welcome to CloudCC system. You requested to reset your password at {!operatetime}, please login with the verification code below within 15 minutes.<br/>Random Verification Code: <b>{!authcode}</b><br/><br/> <b>Important: </b><br/>If you did not request this operation, or you think this message should not reach out to you, please contact your administrator immediately!`,
"c2176":`Accepting failed`,
"c854":`Looks like there's nothing pubilshed.`,
"c1947":`Type of package`,
"c2218":`Main Label:`,
"c1248":`Which layout do you want to copy?`,
"c2107":`Please enter prompt`,
"c1243":`Create New Layout`,
"c1798":`15 days`,
"c775":`Discontinued`,
"c105":`Replay more than once`,
"c1948":`Enable counts`,
"c1078":`Update Case Team Members`,
"c2139":`Dispatch Successful!`,
"c729":`Please confirm that you have configured social platform or not. Go to backend settings  Integrations  Enable (Twitter/Facebook/LinkedIn)`,
"c1275":`Maximum`,
"c1475":`Use assign rules to automatically send records to corresponding users. 
An assign rule consists of conditions and multiple rule entries defined on a record.`,
"c491":`Deactivated`,
"c609":`Trademark`,
"c1469":`End Date of fiscal year cannot be empty.`,
"c611":`Link to`,
"c843":`View Submission`,
"c933":`Conversion Page`,
"c383":`Opportunity Products`,
"c2314":`Overdue & auto reject`,
"c186":`The unique ID already exists. Please do not add repeatedly`,
"c1305":`Conflict behaviour`,
"c608":`Replace`,
"c149":`Turn on notification from Outlook (only support part of email services)`,
"c1028":`Suppliers`,
"c1350":`Vonage Settings`,
"c1606":`Properties of File Upload`,
"c1931":`Article translation - Publish`,
"c486":`Reply to Email Address:`,
"c1555":`Created successfully`,
"c1186":`3 cycles`,
"c598":`Donut Chart`,
"c726":`Request destroying successfully`,
"c645":`Approve Draft`,
"label.verificationCode.is.invalid":`The verification code was invalid. Please reacquire it`,
"c1284":`Assigning successful!`,
"c1410":`5 min`,
"c904":`Between`,
"c1397":`Request failed`,
"c594":`2D Line Chart`,
"c103":`Click more than once`,
"c188":`comment(s)`,
"c891":`The record may not be a contact, opportunity, lead or account`,
"c1254":`2. Hover page layout: applied to the layout displayed in the foreground hover window`,
"c902":`Distance between signin address and visitor`,
"c1539":`Maturity`,
"c484":`Emails:`,
"c421":`Work Order Generation Method`,
"c1889":`Provider's Tel`,
"c406":`Automated sales management`,
"c1426":`The same language cannot be added repeatedly.`,
"c1113":`Formula check failed, please check syntax`,
"c1654":`Objects`,
"c1100":`Image file must be smaller than 20k`,
"c1246":`Notes and Attachments`,
"c1228":`Function under development.`,
"c739":`Campaign: Employee Solicitation`,
"c2201":`New Custom Label`,
"c1511":`Auto login tools after user login.`,
"c1181":`Unique name must be a string.`,
"c329":`Asset Replacement`,
"c1857":`Settings: Contract Sharing Rules`,
"c1011":`Product Type`,
"c351":`Recurrence Frequency`,
"c622":`Network stats last refreshed at`,
"c1367":`Title only visible on Detail page.`,
"2":`Configure filtering options successfully`,
"c463":`My Opportunities`,
"c268":`Merge information successfully`,
"label.mobile.no.letter.blankcharacter":`Mobile number cannot contain letters and blank characters`,
"c1531":`Less than or equal to`,
"c1637":`Service Cloud Mobile`,
"c2275":`Share parent work orders of dispatched service appointments to dispatched service resources`,
"c1855":`Enter name to search`,
"c1125":`With advanced currency management enabled, you can map currency exchange rates to expired rates within a specific date range. 
The expired exchange rate is used for business opportunities, opportunity products, and reports related to these two objects. 
The expired exchange rate cannot be used for fields of other objects or other types of reports. 
For example, the exchange rate on January 1 is 1 USD equals 6.68 CNY, but on February 6 the exchange rate is changed to 1 USD equals 6.70 CNY. 
Opportunities with an end date between January 1 and February 6 use the first exchange rate (1 = 6.68), while opportunities with an end date after February 6 use the second rate (1 = 6.70).`,
"c438":`Transfer`,
"c581":`MoM&YoY Table`,
"c2232":`Access {0}?`,
"c953":`South Korea`,
"c90":`Subject`,
"c2":`Delete dashboard successfully!`,
"c1618":`Template Printing Settings`,
"c1680":`Product Request Row Catalogue`,
"c1964":`Cannot exceed 10`,
"c1201":`This will delete the entire`,
"c1691":`Rebate Account`,
"c897":`Upload failed，file can not exceed 200k`,
"c444":`First Channel Source`,
"c1286":`Cancelled and cannot complete.`,
"c1544":`CCChat Free License`,
"c242":`{!ServiceResource.name} rejected the order. Account: "{!ServiceAppointment.accountid.name}", Number: "{!ServiceAppointment.name}"`,
"c135":`Blank Template`,
"c659":`Follow me`,
"c773":`Finalizing`,
"c11":`Marketing by Forms`,
"c1209":`Go Enable`,
"c1580":`Korean`,
"c799":`External Contacts`,
"c1260":`Please enter description`,
"c1014":`Price book unavailable in current organization. Please contact the administrator to enable.`,
"c1075":`Member Count`,
"c1830":`Registration processor  Search`,
"c880":`edit social posts`,
"c890":`Send invitation email successfully`,
"c1614":`Import My Contacts`,
"c846":`Please select an eligible service appointment`,
"c2305":`Row {0} has mismatched field type`,
"front-electronic-signature-sucessSign":`Start signing successfully`,
"c472":`Choose a form to apply the poster on`,
"c1384":`Fiscal Quarter {n}`,
"c963":`Name field is required`,
"c1076":`Member Roles`,
"c390":`Child Service Territory`,
"c2291":`Share service appointments to users in corresponding service areas`,
"c248":`Acceptance of the order transfering is pending`,
"c1505":`60 days`,
"c1675":`Asset Scan Record`,
"c1875":`Need links and domains?`,
"c646":`Inbox Stream`,
"c2202":`Register Partner Cloud Account`,
"c1665":`Planning Strategy Target`,
"c1425":`You can map the currency exchange rate to the expired rate within a specific date range. 
The expired exchange rate is used for opportunities, opportunity products, and reports related to these two objects.`,
"c308":`Select at least one data`,
"c858":`Are you sure you want to save {a} posts as drafts? These posts won't publish unless you schedule them again.`,
"c152":`Number of completed service appointments in the currently selected time range / Number of all service appointments in the currently selected time range`,
"c2293":`Share assigned service appointments to service resources`,
"c1754":`Simultaneously start snatching?`,
"c1666":`Planning Strategy`,
"c1925":`View drafts`,
"c1403":`Folders: New`,
"c1118":`Please select at least one existing operation`,
"c1571":`Step 1: Prepare the translated file (Please make sure the file meets the following conditions before importing)`,
"c316":`View Case Progress`,
"c2081":`Uninstall failed`,
"c1828":`If you want the user to redirect to a specific page, enter the destination address for the user after he or she logs out of the site or custom domain. Use this feature to accelerate OpenID Connect single point logout or to be used as a redirect after logout. Absolute URL needs to start with http:// or https://.`,
"c1808":`Please check whether the configuration of additional header parameters is complete`,
"c2222":`Choose account`,
"c1381":`Add advanced filter`,
"c1270":`Close all`,
"c1602":`Properties of Text Area (Long) Field `,
"c1492":`Tool Properties`,
"c1444":`Select a user from the left and add it to Selected Users list.`,
"c1904":`Ready to configure your host`,
"c435":`View Version`,
"c1053":`Please Select the Template You Want To Use`,
"c1409":`When this feature is enabled, members of the organization can create, view, edit and delete records in a network-free state on the mobile side. 
The selected menu will be enabled as the default offline cache menu on the mobile side of the entire organization. Each user can set the menu offline cache of organizational settings on the mobile side according to different scene needs, or switch to enable other required menus.`,
"c1304":`Event conflict behavior: Exchange is always preferred`,
"c1190":`6 cycles`,
"c1109":`Result not found`,
"c362":`Attached Product Constraints`,
"c1299":`Contact conflict behavior: CloudCC.com is always preferred`,
"c800":`Please enter name or company name`,
"c415":`Scheduled Start`,
"c1395":`Replace option list value`,
"c1790":`Associate user`,
"c1149":`Hide by default`,
"c1523":`Please enter a valid Email address.`,
"c1276":`Product not associated with any taxes`,
"c735":`The name cannot be repeated`,
"c903":`Select Application Icon`,
"c1222":`Edit Conditions`,
"c1023":`Sorry! Access blocked since this URL may pose security damage to the website.`,
"c1082":`Special characters not allowed`,
"c1655":`Order`,
"c1417":`Default format error`,
"label.insert.approval.massreassign.error":`Batch approvals existing Inserting approval cannot be reassigned. The system will autofilter for you`,
"c1516":`Regions and subordinate regions`,
"c1898":`Ready to configure your host`,
"c354":`Edit Timesheet`,
"c409":`Onestop customer service platform`,
"c1945":`Selected item cannot be empty`,
"c2234":`Manage user data with API`,
"c651":`This shows the current number of followers for each of your social accounts except for Facebook which shows the current number of page likes.`,
"c1667":`Service Objectives`,
"c1121":`When creating records`,
"c582":`World Map`,
"c1360":`Start Time cannot be later than End Time`,
"c994":`Custom Lightning Components`,
"c1826":`Custom error URL`,
"c1374":`2 Columns`,
"c1199":`Fields to be updated`,
"c826":`Are you sure you want to discard your changes?`,
"c1361":`End Time cannot be later than Start Time`,
"c781":`Enterprise: Please enter the company name on the business license. Checking will be done when signing.`,
"c1139":`Edit permission set`,
"c1845":`Required fields exist and cannot be deleted.`,
"c873":`More details`,
"c1612":`Import My Leads`,
"c837":`After unbinding, Fadada Esignature function cannot be used, and the autofill and backfill field function that have been set will be deleted. Are you sure to unbind the account?`,
"label.diedirect.sale":`Direct Price Reductions`,
"c798":`Internal Contacts`,
"c368":`Generate Quote File`,
"c770":`Initiated`,
"c1551":`Other Emails`,
"c882":`Terms of Service`,
"c2129":`Default Role`,
"front-setting-dialog-title-two":`Set up from the personal information page if not input this time. Bind as you enter the number`,
"c2116":`Portal Configuration`,
"c1449":`Info incorrect`,
"c535":`Unsolved`,
"front-electronic-signature-look-account":`View account`,
"c1972":`Delete this rule?`,
"c19":`Record Detail Display Mode`,
"c1890":`Add User`,
"c52":`Tax Name`,
"c2169":`Approval ID`,
"c388":`Associate and Use Entitlement`,
"c1451":`SGD`,
"c1648":`Opportunity Contact`,
"c1156":`When the intervaltype type is minute, the interval must be greater than or equal to 30 minutes and less than or equal to 59 minutes.`,
"c1390":`Create a dependency that will result in dynamic filtering of values in the option list or multi-selection list based on the values selected by the user in another field.`,
"c18":`More than one inactive orders exist, please reselect`,
"c2093":`③ External user scans QR code to submit a service application`,
"c820":`Please enter the phone number/mailbox`,
"c285":`Overview`,
"c1245":`Shuttle Box`,
"c1552":`Current user Email`,
"c478":`Authenticate Mailchimp`,
"c1608":`Properties of Encrypted Text (Storage Encryption) Field `,
"c1206":`Imbedding`,
"c164":`Please enter an integer value from 060`,
"label.tip.excess.quota":`This resource usage has been exceeded`,
"c318":`Generate Purchase Order File`,
"c698":`Social Network`,
"c1116":`Add descriptions`,
"c1092":`When conditions are met`,
"c1915":`Select fields to combine and copy to Word (Supports showing related list records by conditions)`,
"c312":`Multiple orders are not yet effective, please select again`,
"c110":`Group by projects`,
"c549":`The date range cannot exceed 31 days!`,
"c1128":`Current currency`,
"c1896":`Stay with current Call Center`,
"c845":`Please select at least one service appointment`,
"c1329":`Picklist (More than one)`,
"c282":`Manage Personal Data of Customers within CRM`,
"c1587":`Properties of Lookup Relation Field`,
"c1969":`Go back to list`,
"c270":`Accepting order timeout`,
"c288":`Change Data Processing Basis`,
"c1231":`Read/Write-Users can view and overwrite forecast data.`,
"c878":`Current Address`,
"c1287":`Default status`,
"c2206":`Enter any comma-separated values you choose in this field.
When you create a custom label list view, text entered in this field can be used in the filter conditions.`,
"c1698":`Mobile Module Settings for Recommendation Function`,
"c1651":`Attendance Settings`,
"c1161":`Are you sure to delete this field from Business Card view?`,
"c324":`Add Queues to Cases`,
"c2122":`Self-help Registration`,
"c1099":`Please select images in .jpg or .png`,
"c1145":`Visible to all users`,
"c2146":`Share dispatched service appointments to assigned service resources`,
"c1462":`It is not allowed to remove users from Selected Users to all unassigned and enabled users and to all unassigned users.`,
"c1840":`Enter authentication endpoint URL`,
"c1616":`Import Accounts / Contacts`,
"c129":`This action will permanently delete the file. Do you want to continue?`,
"c1510":`Auto Start`,
"c339":`GDPR Data Destroy`,
"c1106":`Operation is for communication with third-party apps and sending web notifications to third-party apps immediately when specific events/activities occur.`,
"c1303":`Event conflict behavior: CloudCC.com is always preferred`,
"c405":`Crew Size`,
"c848":`Linkedin accounts`,
"c1524":`Operation column`,
"c345":`Project Template`,
"c591":`Map of Australia`,
"c180":`Language on Login Page`,
"c126":`Delivered`,
"c2126":`Unique identifier`,
"c1824":`User info endpoint URL`,
"c1404":`Folders: Edit`,
"c2304":`Row {0} has unset field value`,
"c2306":`Row {0} has mismatched value type`,
"c311":`Not effective, please select again`,
"c587":`Map of Mexico`,
"c37":`This is the text to be seen on the preference page of communication by your customer`,
"c1914":`Select value of fields to be combined`,
"c840":`Yay! No unsuccsessful posts.`,
"c1866":`Start with a letter. Do not use special characters other than underscores.`,
"c1355":`Select the role to which you want to assign this layout permission`,
"c1183":`1 cycle`,
"c2087":`{!ServiceResource.name} accepted order {!ServiceAppointment.name}. Click to view.`,
"c1371":`Some names are displayed at`,
"c1519":`Properties of Text Area (Rich Text) Field `,
"c241":`{!ServiceResource.name} rejected the order. Account: "{!ServiceAppointment.accountid.name}", Subject: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}"`,
"c1215":`Choose image source of custom application icon.`,
"c141":`The thanks message is required`,
"c1466":`Click New to define a new custom year.`,
"c1205":`Batch Transfer Approval successfully requested.`,
"c1430":`The range of Start Time and End Time cannot exceed 2 months.`,
"c1689":`Partner Account`,
"c1540":`Attitude towards our company`,
"c1271":`Open all`,
"c1337":`Channel group number (MD5)`,
"obtain.contract.fail":`Failed to acquire contract information`,
"c1541":`Visit count score`,
"c1129":`CNY`,
"c1786":`Please punch out. (ignore if already punched out)`,
"c945":`Russia`,
"c1321":`Form verification failed`,
"c454":`Contract Amount Monthly`,
"c34":`You have 100 products in your shopping cart. Please clear at least one item before adding new product.`,
"c1550":`Operation value cannot be empty`,
"c243":`{!ServiceResource.name} rejected the order. Subject: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}"`,
"c548":`Task/Issue, subtask, and project cannot be edited from a timesheet`,
"c1640":`Lead Pool Settings`,
"c807":`Post Now`,
"c590":`Map of Germany`,
"c831":`Certifying`,
"c198":`Your form is securely published and can be used at the following URL to share your form as a public link.`,
"c1437":`Please choose Start Time and End Time.`,
"c977":`This is how your post will display on {0}. Slight differences may occur if {1} makes any layout adjustments.`,
"c1927":`Manage articles`,
"c66":`Logistics information of product is updated to Delivered`,
"c1327":`Action will delete this data. Continue?`,
"c1599":`Properties of Master-Detail Relation Field`,
"c1829":`Registration Processor`,
"c1756":`Enable Full-Text Search`,
"label.twitter.title.setting":`Twitter Integrated Information`,
"c922":`Please contact the administrator to enable Team`,
"c1926":`View archived articles`,
"c1538":`Role 1`,
"c1705":`The field whose value is filtered is called a dependent field. 
Custom option lists and multiple selection lists can be dependent fields`,
"front-email-payment-Invoice-Tips":`Please contact the administrator to enable PayPal or VISA and then initiate online payment`,
"c605":`	
Default billing address`,
"c1704":`Unique name of record type`,
"c1871":`Fiscal year 2022`,
"c403":`Projects`,
"c1891":`Batch Remove`,
"c1793":`Encrypt by sha512?`,
"c156":`Order Taking Rules for Mobileside`,
"c1485":`Footer Tools`,
"c635":`Schedule Another Post`,
"c1810":`Free`,
"c2097":`Select user or queue as creator of the case record. Selected user must have permission to create case objects.`,
"c1249":`Layout Names`,
"c1628":`Brand Stories and Information`,
"c1755":`When started, users who are booked by the dispatch service can grab orders in CloudCC Service app.`,
"c1153":`If the sharing mode of all objects in the queue is Public Read/Write/Transfer, you do not need to assign users to the queue because all users already have access to the records of these objects.`,
"c753":`Participant`,
"c1822":`Verification endpoint URL`,
"c1196":`Email notifications let users know specific events/activities occurred.`,
"c1433":`Hover page layout: applied to the layout displayed in the foreground hover window`,
"c1042":`4. How to save files`,
"c2302":`Row {0} has unset operator`,
"c1641":`Group Settings`,
"c1036":`When using the API from your company, you need a security token to log in. What is a security token? This is a case-sensitive alphanumeric code and is associated with the password.`,
"c2158":`Countersign`,
"c2209":`Type`,
"c1777":`Please login to Call Center first`,
"c1676":`Expense Report`,
"c647":`All activity`,
"c295":`After turning off, all personal fields marking, data processing basis and other information to comply with DGPR will be removed except operation history for records. Are you sure to turn off?`,
"c915":`Open Pool`,
"front-electronic-signature-signStatus":`You have started online signing. The contract status is {signStauts}`,
"c568":`Edit Layout`,
"c1051":`With this feature, you can generate a document based on the merge template you choose, where the merge field references the CloudCC field. To merge related list fields, please upload the merge template in docx format.`,
"c1256":`Other phone numbers`,
"c744":`Please enter a valid number between 0 and 100`,
"c1285":`Planned duration`,
"c1480":`Set Coordinates`,
"c1278":`System defined layout`,
"c1358":`PC page layout`,
"c464":`post(s) are deleted`,
"c385":`Work Summary`,
"c1973":`Edit Main Fields`,
"c1839":`Please enter keys`,
"c2213":`Not you?`,
"c1419":`Step 2: On the following page, edit the filter rules that control the values that appear in the dependent field for each value in the control field.`,
"c392":`Choose the Solution You Need`,
"c1858":`Use Sharing Rules to share data meeting set conditions to specified role.`,
"c418":`Assigned Service Resources`,
"c256":`Changing account will clear the order with selected items. Are you sure to change?`,
"c1751":`When enabled, users who are booked by the dispatch service can accept and reject orders at CloudCC Service APP.`,
"c1188":`4 cycles`,
"c690":`Image loading`,
"c261":`Destroy Data`,
"c2105":`Description of related info`,
"c1407":`< span style= "color: red" > Tip: the customized bottom menu of the profile will overlay the uniform settings of the company's bottom menu </span>`,
"c62":`Employee Solicitation`,
"c1365":`Single column`,
"c892":`The current record was not found`,
"c909":`Price definitions for this currency have been added. Please do not add again!`,
"c2194":`Current static resources beyond limits`,
"c2156":`New Static Resource`,
"c883":`&`,
"c1617":`Style of Related List`,
"c1739":`Get Authorization Code`,
"c1154":`The name must begin with a letter, can only contain uppercase and lowercase letters, numbers, underscores, and cannot be greater than 40 in length.`,
"c1672":`Asset Relation`,
"c134":`Upper limit of the pool's members`,
"c1671":`Travel Application Form`,
"c896":`Record has locked and don't support adding files. Please contact the administrator to unlock`,
"c974":`Publish a new post to start a new converstaion.`,
"c209":`Medium size`,
"c185":`Statistic on this page`,
"c796":`Please contact the administrator to set up a contract template on the Fadada platform before initiating signing.`,
"c60":`Project Count`,
"c2154":`You have been removed from {0}`,
"c991":`Data Sharing Rules`,
"c1573":`The top of each file must contain language attributes (Chinese import is not supported). 
Language attributes such as: Language=en_US.`,
"c2132":`Related Description`,
"c866":`Set Up Application`,
"c666":`Display`,
"c219":`Your post has been deleted`,
"c732":`Poster`,
"c2315":`You have rejected the order automatically for overdue. ID {!ServiceAppointment.name}, click to view.`,
"c1048":`Please enable at least one template`,
"c1854":`Custom Sharing Rules`,
"c1345":`Acquire essential info (including contacts) of enterprise`,
"c1595":`Set required or read-only`,
"c155":`{name} Name`,
"c1328":` Install this integration now?`,
"c511":`Econtract`,
"c1598":`Properties of Numeric Field `,
"c240":`Rejected`,
"c1454":`Choose pictures`,
"c1024":`Exchange rate`,
"c2092":`② Service agent generates QR code of the case`,
"c1730":`The default url format is incorrect!`,
"c468":`Sorting type is empty`,
"c961":`Q{quarter} {year}`,
"c1455":`Please enter activity name`,
"c1420":`Configured content (Please click 'Control Fields' value to edit.)`,
"c404":`A tool for multichannel marketing and customer acquiring`,
"c1234":`All unassigned & activated users`,
"c586":`Map of Singapore`,
"c1062":`Custom Label`,
"c694":`Width/Height`,
"c1025":`Recalculate product price by the exchange rate above`,
"c1536":`The maximum score for each item is 20 (and repeatable).`,
"c1897":`Remove selected user(s)?`,
"c1909":`2. Enter values of fields to be combined: View values of current field and related fields, and select values of fields to be combined and copy to local Word templates`,
"c297":`Please enter the type of personal data`,
"c2214":`To revoke access, go to Link in Personal Settings`,
"c860":`Change Address`,
"c1740":`Get Token`,
"c58":`Project Homepage`,
"c2170":`Approver ID`,
"c1791":`No associated with attendance group, not required to punch in.`,
"c1650":`Upgrade Rules`,
"c920":`If auto-recycle rules are configured, the system will auto-recycle the records to the pool when the lead has not converted after the time limit. That improves the efficiency of lead follow-up.`,
"c27":`Please enter the floating amount to adjust the gross amount, for example,  10 or 10.`,
"c94":`3 times up`,
"c1":`Mobile Only`,
"c557":`Received Cases`,
"c1127":`Number of decimal (Enter the number of decimal places that can be displayed when displaying data in the new currency (the number of places to the right of the decimal point), which must be an integer between 0 and 6).`,
"c294":`Turn Off GDPR Compliance Settings`,
"c1842":`Please enter registration processor`,
"c970":`You must select one price book at least.`,
"c1727":`Properties of Text Field `,
"c1324":`DingTalk - H5 Mini Programme`,
"c565":`Assign this task to`,
"c668":`Alignment`,
"c972":`Marketing Promotion Name`,
"c2208":`to user`,
"c660":`Copyright`,
"c433":`Lead Pool Field Tracking`,
"c443":`Archive All`,
"c1372":`Columns partially displayed`,
"c1105":`All Layouts`,
"c275":`{0} has a timeout of accepting order, and the dispatching is canceled. Number: {1}. Click to see more >`,
"c691":`Link(Optional)`,
"c956":`You have not activated your Mailchimp account yet. Please go to settings>Integration>Integration list to activate your Mailchimp account or contact administrator.`,
"c1750":`Start receiving`,
"c910":`New Work Order`,
"c692":`Default Browser`,
"c1067":`Main Label Text`,
"c2134":`URL for registration`,
"c355":`Batch Add Timesheets`,
"c1289":`Display recommendation policy rules`,
"c122":`Product Image`,
"c395":`Territory Type`,
"c689":`Max Height`,
"c344":`View Project with Gantt Chart`,
"c1150":`Enter the queue name and Email to be used when sending notifications (for example, when case has been placed in queue). The Email may not be filled in and will not be notified.`,
"c1663":`Service Area Work Type`,
"c1483":`Please submit after form is completed.`,
"c656":`Refresh Time`,
"c943":`Japan`,
"c1450":`General view`,
"c1813":`Screenshot`,
"c1490":`Permanent (Require administrator to unlock)`,
"c1104":`Connector`,
"front-electronic-signature-outerSinger":`External signatory`,
"front-generate-v1-invoiceDetail":`Invoice Detail`,
"front-electronic-signature-open-vertify":`Please enter verification code`,
"c1775":`Case Owner`,
"c291":`Personal Data Type`,
"c2089":`Service applications submitted through website will generate case records in the system. You can configure service application here, which applies to both web and mobile pages.`,
"c1471":`China time zone`,
"front-setting-phone-message":`Please input the mobile number`,
"c559":`Escalated Cases`,
"c1453":`Send Emails to members?`,
"c990":`Sync Emails`,
"c1102":`Authorization Type`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Google map does not work properly. Please check whether the secret key is correct!`,
"c259":`Data Processing Basics`,
"c1924":`Permitted to view knowledge`,
"c1722":`Properties of Date Field`,
"c1065":`Main Label`,
"c1346":`Time-Dependent Trigger`,
"c1838":`Please enter client ID`,
"c488":`Invited Time`,
"c6":`Promotion Name`,
"front-electronic-signature-signerInfo":`Set Up Signatory Info`,
"c1168":`Navigation style`,
"c512":`Project Members`,
"c507":`Lead Cultivation`,
"c1385":`Last Modified By`,
"c760":`Rejected`,
"c756":`No send`,
"c321":`Required or not`,
"c817":`View permission settings of custom page menu`,
"c2295":`Share parent work orders of service appointments to service resources`,
"c949":`Spain`,
"c1133":`Please select license`,
"label.biaoqing.field.relation.tip":`Bid&tender discovery field`,
"c382":`Relation Net Scoring`,
"c265":`This order cannot be changed for it is not yet effective`,
"c417":`Service Resource Work Information`,
"c847":`Facebook accounts`,
"c1521":`Standard Buttons and Links`,
"c2100":`Configure review from here. User can post review to the case/work order through a link.`,
"c494":`Achieve unified management of all channels in CloudCC Marketing Cloud. Build connections and long-lasting trust with your customers, drive ROI with analytics, and turn reach into revenue.`,
"c86":`Campaign: Edit Employee Referal`,
"c1098":`Crop image`,
"c2249":`Notify & auto reject order`,
"c1080":`Case Team`,
"c1138":`Please select user(s) to delete`,
"c776":`Undo successfully`,
"c2220":`Main Label Language:`,
"c2152":`Service Partners`,
"c709":`Choose a network to connect`,
"c2008":`Overall review`,
"label.mobile.orVerificationCode.is.error":`The mobile number or verification code error`,
"c579":`Radar Chart`,
"c1037":`After resetting the token, you cannot use the old token in API application and desktop application.`,
"c413":`Service Appointment Status`,
"c2228":`If your account is already shared by many people, when you successfully bind MFA, other people who are not bound to MFA will not be able to log in. 
The solution is to have others install the MFA application and scan the QR code on this page, or save the QR code picture for others to scan later. 
However, from the perspective of security best practices, we recommend that you cancel the multi-person shared account.`,
"c950":`Netherlands`,
"c1493":`8 Characters`,
"c1785":`Punch-out reminder`,
"c1735":`Customer Service Case Chart`,
"c1841":`Enter tag endpoint URL`,
"c2155":`Online Review Template`,
"c1178":`Select the related lists to display on the hovering page layout (select at most 3 related lists, too many will affect the page layout)`,
"c1236":`Choose users`,
"c573":`2D Bar Chart`,
"label.choose.is.tax":`Choose Tax Type`,
"c768":`The initiated contract signing task has not been completed. Please download the document after the contract is signed.`,
"c604":`Billing address already exists, save the current as new billing address`,
"c160":`Overdue treatment`,
"c1158":`The intervaltype type is incorrect. Please confirm the type.`,
"c239":`Accepted`,
"c1210":`Open record`,
"c988":`The current price book entry is used and cannot be deleted`,
"c1699":`Electronic Fence`,
"c2261":`Disable script?`,
"c834":`Preliminary Passed`,
"c113":`Send {name}`,
"c146":`Relevant products will be cleared after changing the currency. Do you want to continue to change?`,
"c313":`Send Invoice File`,
"c140":`Choose object and template`,
"c1311":`Checking syntax`,
"c298":`Noncompliant`,
"c2199":`Translation Content`,
"c1399":`Email merging templates: Edit
`,
"c681":`Circle`,
"c870":`Are you sure to batch delete?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days} </span> days remaining in the trial`,
"c2163":`Allow to insert Approval?`,
"c1481":`Select step to start editing`,
"c88":`Days left in trial`,
"c1694":`Multilingual Workbench`,
"c1298":`Contact sync direction`,
"c1819":`Verify provider edit`,
"c175":`Failed to get detail information`,
"c64":`Whether or not to open {objName}`,
"c319":`Form Style Setup`,
"label.pay.online":`Initiate Online Payment`,
"c941":`China - Taiwan`,
"c550":`Please choose the start date or end date`,
"c1546":`Please enter condition formula`,
"c365":`Sync Quote Line to Opportunity Product`,
"c908":`Select Icon`,
"c260":`Request to Destroy`,
"c1238":`Activate User`,
"c50":`Tax Rate`,
"c869":`Are you sure to archive all data`,
"c1468":`Start Date of fiscal year cannot be empty.`,
"c2238":`Maximum of 50 columns can be selected.`,
"c93":`Open Repeatedly`,
"c280":`Delete Email`,
"c1526":`CCChat is an enterprise social network where employees can share information at work.`,
"c23":`The paid amount on invoice will be greater than the order amount if you continue to create this payment detail. Please readjust the amount and save again.`,
"front-console-v1-see-contacts":`Identified multiple contacts. Please select`,
"c607":`Shipping address already exists, save the current as new billing address`,
"c2172":`Role of first registered user is Partner Administrator by default`,
"c1472":`Email`,
"c1056":`Please enable full text search`,
"c1639":`Objects`,
"c1711":`Please check the following fields`,
"c1542":`Length is between 1 to 16 characters.`,
"c229":`Delete Milestone`,
"front-filter-v1-filter-by-name":`Filter by '{name}'`,
"c2277":`Search Objects`,
"c125":`In transit`,
"c1952":`Click to search`,
"c1679":`Product Request`,
"c513":`Timesheets`,
"c80":`Billing Address`,
"c1833":`Undo`,
"c1954":`Service access error. Please try again later.`,
"c1422":`Maximum tracking fields (20) exceeded.`,
"c648":`Conversations`,
"c521":`Count of Ordered`,
"c560":`Closed Cases`,
"c973":`You 've read everything in your inbox`,
"c2224":`Don't have an account?`,
"c1882":`Name displayed in Call Center`,
"c509":`Packing List`,
"c685":`Add New Address`,
"c2171":`Self-help Registration`,
"c178":`The format of the uploaded image is not supported. Please uploade images in the format of png, jpg, and jpeg.`,
"c1003":`By associating with the collaboration capabilities of DingTalk, CCDing helps you to operate private domain traffic more completely, to track and manage the full lifecycle of customer relationships, and to improve the operation efficiency and profitability of the enterprise.`,
"c436":`Visitor Details`,
"front-electronic-signature-prepareTemplate":`Please contact the administrator to preset contract template in the system before start signing.`,
"c749":`Signing Process`,
"c1894":`Specific user`,
"c2098":`Associated record type`,
"c114":`Please click the Generate {name} button to generate {name} before sending.`,
"c1446":`Removing a user from Selected Users list will assign the user to the role selected above.`,
"c898":`File Uploaded `,
"c279":`Sales`,
"c232":`Cannot exceed the number of products to be packed`,
"c1282":`url test`,
"c911":`Dispatch Canceled`,
"c901":`Your number of submissions has reached the limit.`,
"c1366":`Double column`,
"c1934":`Create data classification`,
"c663":`Alternative text`,
"c1657":`Purchase Orders`,
"c541":`Statistics of Current Case`,
"c1584":`Field Label Translation`,
"c1340":`Select creating conditions`,
"c536":`Received`,
"front-project-v1-batch-deletion-confirmation-information":`Batch deletion of the selected records will also delete all information associated with the selected ones, and the data cannot be recovered,. Are you sure to delete?`,
"c1809":`Recommended applications`,
"c2256":`Control which support organization your users can grant login access to.`,
"c1301":`The formula verifies to be true`,
"c1318":`This action will enable the workflow, continue or not?`,
"c893":`The current user cannot have access to edit account detail address field`,
"c623":`Monitor`,
"c1956":`Workflow Execution`,
"c1198":`Field updates allow you to automatically change a field value to a specified value. Field updates are actions related to workflow rules and the approval process.`,
"c493":`Shape Digital Marketing, Seize All Opportunities`,
"c1557":`Case Upgrade Rule: New`,
"c1937":`In current available version, a maximum of {!count} languages are allowed in addition to {!language}.`,
"c1377":`Delete permanently`,
"c1063":`Chinese symbols cannot be used for filtering conditions`,
"c327":`Asset Hierarchy`,
"c747":`Your total number of products is full. Please delete some products first and then continue to add products.`,
"c728":`Data Privacy`,
"c1423":`Related List cannot be empty.`,
"c1581":`French`,
"front-reportlist-v1-optimizedReport":`reports are optimized after query. Please do not modify randomly.`,
"c1265":`Add to profile`,
"c1143":`Fields displayed`,
"c741":`Please fill in the mail content!`,
"c643":`Post Details`,
"c537":`Avg Response Time`,
"front-electronic-signature-add-field":`Add Backfill Field`,
"c1574":`Make sure that the file you imported is in the correct encoding format, and if you do not specify the system, it will be encoded in UTF-8.`,
"c1152":`To add a member to this queue, select a member type, then select a role or user from Available Members, and move it to Selected Members.`,
"c626":`All Users`,
"c199":`Form link`,
"c1300":`New`,
"c2149":`Share the parent work order of the dispatched service appointment with the assigned service team leader`,
"c1611":`Data Import`,
"c917":`Use the pool to stimulate the potential of team and improve the efficiency of account follow-up. The pool administrator makes unified management for accounts and batch assignments. Sales staff can also screen leads and receive follow-ups.`,
"c1414":`Length format error (cannot be 0)`,
"c1773":`Name of Case Type `,
"c1412":`60 min`,
"c1933":`Manage data categories`,
"c159":`The order length don't exceed a maximum of`,
"c640":`Schedule Post`,
"c1001":`Try the DingTalk integrated back-end system settings`,
"c192":`Current page layout:`,
"c978":`No account information`,
"c969":`{0} Selected`,
"c871":`This is how your post will display on {a}. Slight differences may occur if {a} makes any layout adjustments.`,
"c1264":`The result of the formula is not compatible with the expected data type (true or false).`,
"c814":`1{0} selected`,
"c1559":`0 min`,
"c235":`{!ServiceResource.name} accpted the order. Subject: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}"`,
"c215":`Your post has been published`,
"c425":`Service Appointment Management`,
"c182":`The work order and case record cannot be connected at once`,
"c194":`Limit number of submissions`,
"c657":`No permission to operate， please contact the administrator`,
"c1352":`Please fill in the form correctly before saving`,
"c855":`Looks like there's nothing scheduled.`,
"c1204":`Prompt-Delete`,
"c2091":`① Service manager configures Online Case Form`,
"c333":`Budget Cost`,
"c1518":`Request failed`,
"c1091":`Rule of Execution`,
"c1043":`Save to Document`,
"c338":`Supplier  Destroy`,
"c1421":`This page allows you to select fields to track in the Field tracking related list. 
Whenever the user modifies any of the fields selected below, the old and new field values, as well as the date, time, changed properties, and the user who made the change will be added to the Field tracking related list. Note: only the fields displayed in the changed section are tracked, and only "changed" is displayed when tracking field values.`,
"c431":`Campaign Hierarchy`,
"c2211":`Translation Info`,
"c374":`Price Book Product`,
"c506":`Automated Schedule`,
"font-trade-module-invoice-totalMoney":`Total Invoice Receivables`,
"c203":`Share your forms through Mailchimp`,
"c962":`{month} {year}`,
"c786":`Telephone number/Mailbox`,
"c1487":`Must contain uppercase and lowercase letters and numbers`,
"c469":`The page is in editing state. Current data cannot be saved if you leave the page`,
"c137":`Choose a template for the form`,
"c993":`Data Storage (All Objects)`,
"c1905":`Operation Instructions:`,
"c483":`Campaign Info`,
"c1396":`Email merging template: New`,
"c1876":`Learn how`,
"c947":`France`,
"c190":`The currency of payment items should be consistent with the currency of order, invoice, and payment. Please refine the currency and save again.`,
"c386":`Fulfilled`,
"c2135":`Cancel assignment?`,
"c803":`Accounts: All Accounts`,
"c1119":`Please fill in the form completely before saving`,
"c759":`To fill`,
"c1917":`Filter related objects`,
"c1678":`Work Rules`,
"c823":`Order Setting`,
"c1187":`Webhook List`,
"c1498":`Choose the icon for your tools. Recommended size is x px*y px.`,
"c422":`Service Appointment Generation Method`,
"c1686":`Knowledge`,
"c1326":`Action will delete this time trigger. Continue?`,
"c782":`How to Participate`,
"c1461":`Removing a user from Selected Users will assign the user to the role selected above.`,
"c416":`Service Report Push Record`,
"c2294":`Share service appointments to service resources`,
"c1494":`Name your tools to make it easy for users to understand the functions. The names are displayed in the footer of the app. `,
"c758":`Accepted`,
"c407":`Service Crew Member`,
"c51":`New Tax`,
"c844":`Bind DocuSign Account`,
"c1086":`Candidate Strategy`,
"c361":`Edit Menu`,
"c602":`Matrix Chart`,
"c1257":`Set layout editor`,
"c191":`Edit permission of current view is required`,
"c299":`Select at least one object`,
"c432":`Campaign History`,
"c650":`Publish a new post to start a new converstaion`,
"c1038":`Reset Security Token`,
"c1721":`Properties of Roll-Up Summary Field`,
"c1681":`Objects`,
"c531":`Count of Received Cases`,
"c13":`Current user does not have the permission to edit`,
"c162":`Simultaneously inform the assignor and the assignee`,
"c1620":`Tax Settings`,
"c1182":`Please enter unique name.`,
"c1045":`Save and Download`,
"c992":`File Storage`,
"c1307":`Task conflict behaviour: CloudCC.com is always preferred`,
"c171":`Shareholding`,
"c230":`Delete Task`,
"c470":`Autofilling Fields`,
"c367":`Generate Contract`,
"c1338":`Not`,
"c2150":`Share dispatched service appointments with assigned service team members`,
"c26":`Set up Discount`,
"c1517":`Required items cannot be empty`,
"c989":`Forecasts User's Manual`,
"c1424":`Use this page to define all currencies used by your organization. <br>The company currency should be set to the currency used by the company headquarters for revenue reporting. <br>If you specify another currency as the company currency, all exchange rates are modified to reflect this change.`,
"c1314":`Action will permanently delete this workflow. Continue?`,
"c705":`Published Posts`,
"c1949":`Previous user`,
"c613":`External Page`,
"front-electronic-signature-openSign":`Start Signing`,
"c349":`Drag and Drop`,
"c683":`Load More`,
"c1253":`1. Row layout: the layout displayed when it is applied to the master-slave input of the foreground and the batch addition`,
"c679":`Gray`,
"c1741":`Get User Information`,
"c2173":`Selected user can manage new partner account info and approval`,
"c2159":`Joint signing`,
"c1386":`Edit Field Properties`,
"c914":`Fold sidebar`,
"c1725":`Properties of Lookup Relation (Multi-Select)`,
"c1585":`Check skill level`,
"c224":`Go to Milestone`,
"c220":`Your post has been published unsuccessfully`,
"c498":`CloudCC Inventory efficiently supports online and offline omni-channel business, realizing the flow and management of goods and funds. Multiple modules are effectively combined, and users can achieve refined order management to create win-win situations with partners.`,
"c566":`Autoretrieve account's address after saving`,
"c1978":`Custom Script (JavaScript)`,
"front-electronic-signature-ContractTemplate":`Choose Contract Template`,
"c1976":`New Customized Script Menu`,
"c1951":`Short note`,
"c540":`Solving Time by Channels`,
"c793":`Document templates`,
"c293":`Set Objects to Enable GDPR Compliance`,
"front-invoice-online-pay-again":`You have already initiated an online payment. Please don't try it again.`,
"front-electronic-signature-open-password":`Please enter the password`,
"front-v1-partner-background-tooltip":`A maximum of 2M file is supported. It is recommended to upload clear images.`,
"c449":`Chat History`,
"c30":`Classic`,
"c1195":`Notify assigner`,
"c1497":`5 times`,
"c1645":`Score Settings of Relationship Network`,
"c245":`{!oldServiceResource.name} transferred the work order numbered {!ServiceAppointment.name} to {!newServiceResource.name}`,
"c923":`Here's your Team`,
"c24":`Show Map`,
"c1712":`Step 1: Select one control field and a dependent field. Click Continue when completed.`,
"c872":`Name (Unfilled)`,
"c886":`Open sidebar`,
"c1074":`Pre-determining of Case Team`,
"c1259":`Please select template for Email`,
"c1820":`URL suffix`,
"c1068":`Gap To Quota`,
"c1596":`Case sensitive`,
"c1389":`Lightning Detail page embedded custom page`,
"c1892":`Confirm changes? Changes may affect users.`,
"c1435":`Please enter page layout name`,
"c485":`Form Name:`,
"c1554":`Replacement succeeded`,
"c1780":`New approval process`,
"c101":`pc(s)`,
"c1883":`Unique label`,
"c816":`View post`,
"c1814":`Payment is deemed to be your agreement to the platform agreement`,
"c2255":`Log-in Access Policy`,
"c2205":`This is the default language. To change language of the label, first change your preferred language.`,
"c1652":`DingTalk External Contacts`,
"c445":`Project Role`,
"c1911":`Download template`,
"c1677":`Expense Report Catalogue`,
"c1046":`Please select a file type!`,
"c2212":`Allow`,
"c1429":`Set permissions`,
"c1094":`When`,
"c1004":`CCDing has the powerful customization of CloudCC, and can quickly and flexibly configure extensions based on your personalized business needs.`,
"c2259":`Search Pages`,
"c1035":`Sorry, you do not have the current operating authority. Please contact the administrator!`,
"c1267":`Option 1`,
"c1653":`WeCom Contact`,
"c2299":`Administrators can log in as any user`,
"c853":`This shows the number of likes and comments for your published posts.`,
"c398":`Start Now`,
"c522":`Count of Invoiced`,
"c1763":`Registration Processor`,
"c287":`Compliance`,
"c578":`MoM&YoY Numeric Chart`,
"c40":`Please enter the password`,
"c631":`View on Twitter`,
"c489":`Deactivated Time`,
"c819":`Phone number/Mailbox`,
"c1380":`Note: All fields in this section will be moved to Unused Items section.`,
"c935":`Form Type`,
"c625":`All Campaigns`,
"c471":`Campaign: Employee Referral`,
"front-electronic-signature-writen":`Filled`,
"c1148":`Object Permissions`,
"c1015":`User-defined format parameters`,
"c889":`Deactivate user account successfully`,
"c201":`Share this form through your social media`,
"c467":`Sorting field is empty`,
"label.mobile.no.null":`Mobile number cannot be empty`,
"c307":`Entitlement`,
"c1796":`The first 5 buttons are fixed at the bottom. Other buttons can be accessed in "More".`,
"c1489":`Footer tools are utility fixed at the bottom.`,
"c1019":`Add header parameters (e.g. API keys, tokens, etc.)`,
"c1163":`Business card is hidden, therefore cannot be customized.`,
"front-kefu-moudle-wait-calling":`Calling in progress, please try again later`,
"c2250":`Notify dispatcher & the dispatched person`,
"c784":`Please enter the company name on the business license`,
"c490":`Last Login Time`,
"c790":`Handwritten Signature`,
"c336":`Leads  Destroy`,
"c453":`Homepage Kanban`,
"c1157":`When the intervaltype type is hour, the interval must be greater than or equal to 1 hour and less than or equal to 23 hours.`,
"c1738":`Suffix `,
"c1760":`The number of filenames does not match the number of uploaded pictures!`,
"c1177":`The operator "{! parameter.type1}" parameter is of the wrong type. 
Expected {! parameter.type2}, but received {! parameter.type3}`,
"c1960":`Select to add component(s)`,
"c1765":`A maximum of {n} file(s) can be uploaded`,
"c1013":`Parameters of standard format`,
"c1083":`Name cannot be empty`,
"c1208":`Online chat account not activated. Please enable chat function first.`,
"c530":`Please set up the company mailbox first`,
"c1268":`Option 2`,
"c610":`The icon will link to the master domain if you did not specify the URL`,
"c359":`Chart`,
"c1438":`Please select page layout`,
"c1279":`● Read/Write - Users can view & overwrite forecast data`,
"c193":`Limitations`,
"label.mobile.verificationCode.exceeded.times":`Retry count exceeded. Please request again`,
"c138":`Company Template`,
"c821":`New Internal Contacts`,
"c381":`Request Pay Online`,
"c1590":`Whether repeat is allowed`,
"c1484":`Must contain uppercase and lowercase letters and numbers and symbols`,
"c761":`Signing`,
"c1370":`Some names`,
"c2108":`Service Application Review`,
"c964":`Master-detail relation field is required`,
"c585":`Map of United Kingdom`,
"c500":`Provide one-stop customer service solutions with standardized processes and efficient management, coordinate service resources to provide the best support to your customers.`,
"c1502":`Pane width in pixels (Range of input value: 1-1920px)`,
"c214":`Include bitmaps in three sizes and vector graphics in all formats`,
"c714":`Schedule posts to publish at the right time.`,
"c1341":`Check to enable industrial and commercial data verification. When users enter enterprise customer information, they can help users enter correct customer industrial and commercial registration information.`,
"c1718":`It has been already planned to {0} and cannot be planned repeatedly.`,
"c1044":`Download to Document`,
"c1846":`Select the main field that controls this Rule.`,
"c1789":`Attendance Personnel`,
"c552":`Rejected`,
"c684":`{sumTotalCount} more`,
"c54":`Please fill in the tax type`,
"c320":`Select Form Fields`,
"c1008":`Copy Product Details`,
"c236":`{!ServiceResource.name} accpted the order. Account: "{!ServiceAppointment.accountid.name}", Number: "{!ServiceAppointment.name}"`,
"c1592":`Properties of Auto Number Field`,
"c1588":`Value cannot be a database keyword`,
"c1901":`DNS changes can take up to 24 hours to take effect around the world.`,
"c123":`Logistics Information`,
"c2181":`Show data`,
"c654":`Back to Dashboard List`,
"c1442":`To assign other users to this role`,
"c1779":`Total size of pictures cannot exceed 20M.`,
"c1363":`Some of the titles are displayed at`,
"c335":`Profit Margin`,
"c267":`Failed to commit changes for the criterion is not met`,
"c1818":`Workflow Rules Configuration`,
"c1803":`Please enter URL`,
"c2226":`Common applications that support MFA on smart devices are Alibaba Cloud and Google Authenticator.`,
"c226":`Go to Subtask`,
"c102":`Click once`,
"c637":`Save as Drafts`,
"c1336":`End character`,
"c633":`Create New Social Posts`,
"c1103":`Regular`,
"c777":`Set Up Participant Information`,
"c223":`Add to Project`,
"c592":`Waterfall Chart`,
"c1714":`Select modules that meet business requirements based on actual scenarios`,
"c1439":`Nothing to save`,
"c1402":`Forecast category value cannot be empty.`,
"c315":`Only valid orders can generate invoices`,
"c89":`Email Event Name`,
"c108":`Automatch successfully`,
"c1507":`180 days`,
"c402":`Field`,
"c748":`Please select a price book for {title}. You can only add products from a single price book. Changing the selected price book will result in the deletion of all existing products.`,
"c1293":`After setting up a service account with impersonation permissions for the user in Microsoft Exchange, enter the service account credentials to allow CloudCC to communicate with the Exchange server. If you have saved your service account credentials but the user is still unable to synchronize the records, make sure that you have set up Exchange Sync correctly.`,
"c1625":`Channel of Communication `,
"c501":`Provide Quality Field Service to Your Customers`,
"c1877":`Login time`,
"c269":`Failed to merge information`,
"front-electronic-signature-open-confirm":`Bind Account`,
"c584":`Map of United States`,
"c437":`Unsuccessful`,
"c738":`Date Sent`,
"c2096":`Edit the service types that users can choose from and the system record type associated with the current service type.`,
"c274":`You have a timeout of accepting order, and the dispatching is canceled. Number: {0}. Click to see more >`,
"c83":`Search data`,
"c206":`PNG Format`,
"c1903":`How to create Word files`,
"c309":`Send Order File`,
"c1899":`Verify`,
"c539":`Highest Proportion of Sources`,
"c304":`Major Interests`,
"c2130":`Related customer`,
"c1835":`CloudCC configurations`,
"c1413":`Field label cannot be empty`,
"c1348":`Extended Interface URL`,
"c2203":`The name field can only contain underscores and alphanumeric characters. 
It must be unique, starting with a letter, excluding spaces, must not end with an underscore, and must not contain two consecutive underscores`,
"c1452":`Queue label`,
"c1064":`Protected Components`,
"c151":`Briefly describe the main content of the form`,
"c1912":`View templates for different objects (Downloading supported)`,
"c1294":`Exchange Sync configurations`,
"c639":`Post Now`,
"c1401":`Option list value cannot be empty`,
"c1535":`The scoring rules used to configure the contact five-star chart in the customer contact structure diagram`,
"c720":`No，thanks`,
"c2301":`Row {0} has unset field`,
"c1913":`Download Word templates`,
"c801":`New Contacts`,
"c900":`No address information is available for visitor, so the checkin distance cannot be calculated.`,
"c2145":`Share the parent work orders of the assigned service appointment with the users in the corresponding service zone`,
"c1669":`Consumable Products`,
"c1069":`Roles of Case Team`,
"c695":`Original Size`,
"c2138":`Failed to cancel assignment`,
"c864":`Choose a Form`,
"c1443":`Select from picklist to view available users`,
"c881":`I've read and agreed`,
"c2142":`Assignments Shared`,
"c794":`Signing template`,
"c543":`Received Evaluations`,
"c1400":`Control field or dependent field cannot be empty`,
"c2125":`Self-help Registration Settings`,
"c1217":`Configuration of Custom Component menu`,
"c466":`Only orders using the same price book can generate an invoice`,
"c1783":`Also, when record is in approval process, it is always locked and can only be edited by administrator. However, you can allow the currently assigned approver to edit this record.`,
"c867":`{userName} will receive an invitation email that will prompt to create a password for accessing your Help Center.
Continue?`,
"c1185":`2 cycles`,
"c529":`No available ways to top up, please contact the administrator`,
"c2079":`Uninstall package?`,
"c742":`A maximum of 4 images can be selected and each of them cannot exceed 200K. Click image to select.`,
"c430":`Search Performance Term`,
"c2303":`Row {0} has unset field type`,
"c1180":`Related Roles`,
"c553":`Last Invited Time`,
"c575":`Column Chart`,
"c124":`Delivery Pending`,
"c1664":`Planning Strategy Work Rules`,
"c1525":`Lead field is associated with Campaign Member field.`,
"c629":`Unsuccessful`,
"c554":`First Invited Time`,
"c547":`Last 7 days`,
"c1682":`Time Entries`,
"c1368":`Title only visible on Edit page`,
"c599":`Table Chart`,
"c588":`Map of Canada`,
"c703":`Via`,
"c1357":`Select end date`,
"c1031":`Add at least one product`,
"c713":`Create social posts from inside CloudCC.`,
"c142":`This is the action that will be taken after a visitor submits the form on your site`,
"c2316":`{!ServiceTerritory.name} overdue and auto rejected. ID {!ServiceAppointment.name}, click to view.`,
"c1111":`URL notifications`,
"c153":`After clearing the products associated with the current record, you can change the currency.`,
"c1942":`Mobile URL`,
"c1431":`You may create various page layouts in this page to display user data. 
Click <Page Layout Assignment> to select the default layout for users.`,
"c253":`GDPR Compliance`,
"c1479":`Formula error. Please check!`,
"c1313":`Error: checking rule complication failed. Please check syntax.`,
"c1771":`The Service Requisition submitted through the website can generate case records in the system, where you can configure the Service Requisition page. Web pages for computers and mobile phones`,
"c1079":`Case Team Members`,
"c612":`Internal Page`,
"c1382":`Clear advanced filter`,
"c1716":`To Be Accepted`,
"c400":`Location of Service Resources`,
"c1176":`Cancel required fields`,
"c1398":`Click to Upload`,
"c671":`Icon and Word`,
"c1227":`Select Users`,
"c20":`Cannot exceed the quantity to be invoiced of the related order.`,
"c514":`Report's Graphs`,
"c1055":`Parameter of RequestBody Not In json Format`,
"c946":`United Kingdom`,
"c1635":`Asset QR Code Rules`,
"c1506":`90 days`,
"c1351":`By setting up a Nexmo API account, users can access Vonage API accounts on the CloudCC platform to send and receive text messages.`,
"c1719":` DingTalk Integration`,
"c717":`New Post`,
"c1308":`Task conflict behaviour: Exchange is always preferred`,
"c174":`All edited successfully`,
"c1330":`Multi-selection list`,
"c1465":`Mars time zone`,
"c940":`China - Hong Kong`,
"c1553":`Email address of record owner`,
"c743":`Please enter valid numbers`,
"c1232":`Select users shown in Available User List to assign to the role CEO`,
"c1940":`URL on PC/URL on mobile is required.`,
"c2085":`Uninstall canceled`,
"c1963":`MFA binding disabled`,
"c2236":`Sales notifications will keep you updated on communications of important customers.`,
"c441":`Smart business and financial management`,
"c1794":`Time-out Process`,
"c2115":`Highlights`,
"c1910":`3. Upload Email combining templates: Upload Word files after modifying Word templates offline`,
"c1406":`Please upload files`,
"c1197":`Other Emails`,
"c423":`Dispatch Platform`,
"c723":`Confirm to request destroying`,
"c664":`No social network`,
"c1071":`Role Replacing for Case Team`,
"c859":`Please input {0}`,
"c2147":`Share the parent work order of the dispatched service appointment to the assigned service resources`,
"c356":`Planned Cost`,
"c221":`Go to Project`,
"c1225":`Icon on PCs`,
"c1906":`Skip instructions?`,
"c1569":`Your export request has been processed, please check your Email.`,
"c1339":`Select object to create template`,
"c1837":`Please enter URL suffix `,
"front-email-payment-Invoice-Tips1":`Please contact the administrator to enable WeChat, Alipay, PayPal or VISA and then initiate online payment`,
"c99":`Product QTY`,
"c278":`Do you want to delete following emails?`,
"c364":`Quote Line`,
"c572":`The Selected Fields cannot be empty, please add field(s)`,
"c2080":`Uninstalled`,
"c310":`Generate Order File`,
"c247":`Transferred`,
"c158":`Assign Time Threshold`,
"c325":`Case Assignment Notification Template`,
"c1600":`Properties of Geolocation Field `,
"c985":`The network is disconnected. Please check the network connection`,
"c1277":`New   Global option list set`,
"c877":`Fill Nonorderly`,
"c1364":`Column layout`,
"c1564":`Properties of Checkbox Field`,
"front-filter-v1-press":`Press`,
"c505":`Visitors Tracking`,
"c523":`Add as Portal User`,
"c727":`Destroy data successfully`,
"front-electronic-signature-sended":`Sent`,
"c150":`Please fill in the required information`,
"c700":`LAST UPDATED TIME`,
"c1325":`WeCom - H5 Mini Programme`,
"c1263":`Field dependencies: Editing`,
"c1700":`Radius of Electronic Fence`,
"c824":`Sign in Order`,
"c710":`One home to manage all your social media`,
"c1320":`Form verification failed in the current step, please check before the next step`,
"c1130":`Edit the exchange rate between the currencies used by your organization and other currencies`,
"c1610":`Properties of Currency Field `,
"c358":`Budget`,
"c1537":`Enter visit counts of user and visit count score is calculated by rules.`,
"c1530":`New essential information layout`,
"c1968":`Insufficient quota. Please contact administrator.`,
"c544":`Channels`,
"c1211":`Standard style`,
"c212":`SVG Format`,
"c1255":`3. Mobile page layout: applied to the layout of Wechat small web pages and mobile version display`,
"c2231":`CLoudCC-api-auth2.0(Code) asks permission to:`,
"c165":`Please enter an integer value from 024`,
"c1081":`Team`,
"c1922":`Support files up to 5 MB`,
"c1463":`US time zone`,
"c1583":`Spanish`,
"c1415":`Length format error`,
"c932":`Spam`,
"c888":`Activate user account successfully`,
"c838":`Operator`,
"c98":`Product Category`,
"c830":`CREATED BY`,
"c661":`Network`,
"c1073":`Case Role for Replacing`,
"c1509":`password(s)`,
"c818":`Custom page menu settings`,
"c861":`Choose from Map`,
"c736":`Posted By`,
"c204":`Standard`,
"c1962":`Password successfully reset`,
"c1753":`When started, you can set the maximum allowable order length and timeout post-processing mode.`,
"c1563":`Properties of Address Field `,
"c1709":`Off: it is not displayed on the home page of all members of the organization by default. Users can open the module by "configuring my home page" on the mobile side.`,
"c1049":`Generation failed. Currently, only docx type templates are supported to generate PDF files.`,
"c1961":`Only .xlsx files are supported`,
"c1123":`When creating or editing records`,
"c839":`Looks like there's nothing scheduled.`,
"c1473":`New assign rules`,
"c456":`Paid Amount`,
"c1697":`New Software Package`,
"c1151":`If Send Email to Members is selected, queue members will be notified when objects are assigned to the queue, and Don't Notify will not be selected.`,
"c2215":`Error with authorization`,
"c341":`Final Accounts`,
"c1281":`Pieces Displayed`,
"c724":`Confirm to destroy data`,
"c1017":`Value Description`,
"c1668":`User Region`,
"c1943":`Maximum number of articles reached. Please contact administrator to upgrade.`,
"c865":`I have read and agree to {0} and {1}`,
"c1193":`3 cycles ago`,
"c1744":`Custom registration processing class`,
"c1142":`Filter conditions`,
"c1164":`Unhide to customize to display in Detail page.`,
"c332":`The amount cannot exceed the order to be invoiced`,
"c520":`Payment failed. The available rebate is insufficient`,
"c906":`Minus`,
"c1174":`Customize Settings`,
"c482":`Name Your Compagin:`,
"c49":`Update Safety Setup of Domain`,
"c1290":`Candidate List`,
"c725":`Revoke request of destroying successfully`,
"c76":`PAY`,
"c1622":`Identity Provider`,
"c1331":`Not empty`,
"c1134":`Please select permission set`,
"c558":`On Hold Cases`,
"c1884":`First, create custom page on Developer Platform, and add Call Center component to custom page.`,
"c1690":`Top-up History`,
"c876":`Sign Nonorderly`,
"front-invoices-v1-nofilles-tocreate":`Please click the Generate Invoice button to generate an invoice and then send it.`,
"c779":`Signing Deadline`,
"c1095":`Add another option`,
"c603":`MoM&YoY Biaxial Chart`,
"c1527":`CCChat Settings`,
"c1752":`Order duration threshold`,
"c1093":`When conditions are not met`,
"c1144":`Visibility`,
"c1203":`Please first select the data to be transferred.`,
"c1496":`10 times`,
"c455":`Contract Target`,
"c1766":`Click here or drag and drop the file here to attach`,
"c1731":`Dispatch failed`,
"c428":`Dispatch in Map Mode`,
"c55":`Please fill in the tax value`,
"c1604":`Introduced Images`,
"c899":`Checkin Distance`,
"c1887":`Provider's Auth Token 1`,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Recipient Name:`,
"label.social.posts.info":`No post content was found`,
"c704":`Audience`,
"c1005":`To use CCDing, please contact us.`,
"c673":`Web Image`,
"front-electronic-signature-singed":`Signing started`,
"c722":`1 account connected`,
"c595":`Area Chart`,
"c1886":`Provider's Account`,
"c1054":`No contents under this template. Please save after template is set.`,
"c2300":`Profile Users`,
"c1344":`Edit Workflow`,
"c120":`type(s)`,
"c68":`Payable Order`,
"c479":`CloudCC Forms Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Esignature and Stamping`,
"c5":`Tax`,
"c1022":`View PDF`,
"c2114":`Company Introduction`,
"c976":`Approve and Schedule Posts {0}`,
"c812":`COMMENTS`,
"c532":`Count of Resting Cases`,
"c330":`Contract Line Item`,
"c1296":`New Rules`,
"c249":`post is going out now`,
"c630":`View on LinkedIn`,
"c1160":`The first execution time is #time, and then every #number hour(s).`,
"c1356":`Select start date`,
"c958":`Post Like ID cannot be empty`,
"c1378":`Move to not selected fields`,
"c170":`Faild to create data with the record id {0}, failed reason: {1};`,
"c810":`REPLIES`,
"c783":`Signature Requirements`,
"c968":`Disconnect`,
"c752":`Initiate Signing Task`,
"c1040":`We have sent a new security token to customer {0}'s email address.`,
"c439":`Visitor`,
"c1002":`CCDing application is an integrated solution for marketing, sales and services created based on CloudCC and DingTalk platform.`,
"c1470":`Required fields unfilled.`,
"c1184":`Webhook Configurations`,
"c1707":`You can disable or disable components that are not related to the enterprise business from the default configuration`,
"c2248":`Notify & cancel assignment`,
"c67":`Submit order successfully!`,
"front-generate-v1-invoice":`Generate Invoice`,
"c477":`You must authenticate yourself with your Mailchimp account. Please click on “Authenticate Mailchimp”button and you’ll be redirected to Mailchimp to send campaigns.`,
"c1315":`Contact conflict behaviour`,
"c966":`Please contact the administrator `,
"c1726":`Properties of Percent Field `,
"c764":`Rejected`,
"c301":`Up to 200 characters can be entered`,
"c1027":`Please check if key pair is correct or deactivated`,
"c61":`Please open the Knowledge first and then use it`,
"c815":`Archive all`,
"c827":`You have unsaved changes on this page that will be lost if you continue.`,
"c1460":`Select a user from the left and add it to Selected Users list`,
"c688":`Max Width`,
"c1693":`DingTalk Integration Settings`,
"c1692":`Action`,
"c1939":`A maximum of {!count} articles are supported in current version.`,
"c1237":`Please select status`,
"c33":`Edit Subscription Type`,
"c217":`post is going out {date}`,
"c721":`Disconnect acoount`,
"c284":`Process Data Request from Customers within CRM`,
"c1273":`Visibility of Menu`,
"c2310":`{!ServiceTerritory.name} overdue. ID {!ServiceAppointment.name}, click to view.`,
"c2227":`If you are unable to verify due to some reasons (such as the loss of your phone or the removal of the MFA application by mistake), you can unbind the MFA through your administrator.`,
"c939":`China - Macao`,
"c503":`Keep Track of Your Project Progress`,
"c1090":`Select by conditions`,
"c2103":`Page Address Prefix`,
"c1800":`Maximum number of queues for a single object is {0}`,
"c492":`Invited`,
"c2216":`You are unable to authorize due to errors below. For more info, please contact CloudCC administrator.`,
"c2144":`Share the assigned service appointments with the users in the corresponding service zone`,
"c1428":`Mark as required`,
"c73":`Current Balance`,
"label.the.peoples.republic.of.china":`People's Republic of China`,
"c828":`POST`,
"c36":`Preview`,
"c954":`New Phone Number`,
"c1504":`30 days`,
"c1520":`Below is a list of buttons and links. To add a button or link, edit the page layout. <br />Buttons can be displayed on the details page, related lists, and list views: <br />1. To customize the buttons or links on the details page, edit the page layout. <br />2. To customize the buttons or links on the related list, edit the properties of the related list where it appears on the page layout. <br />3. To customize the buttons or links on the list view, edit the list view layout in search layout.<br />`,
"front-electronic-signature-innerSinger":`Internal signatory`,
"c2113":`Page Configuration`,
"c1457":`Select from picklist to view available users`,
"c508":`ROI Analysis`,
"c833":`Certification Passed`,
"c1872":`Subdomain`,
"c1804":`URL format verification failed, please check`,
"c2148":`Share dispatched service appointments with assigned service team leader`,
"c1212":`Batch deletion of records can be carried out on this page.`,
"c207":`Vector Format`,
"c1441":`Use this page to define all currencies used by your organization. <br />The company currency should be set to the currency used by the company headquarters for revenue reporting. <br />If you specify another currency as the company currency, all exchange rates are modified to reflect this change.`,
"c31":`Half Screen`,
"c71":`Please choose a payment option`,
"c1061":`Post`,
"c373":`Standard Price Book`,
"c545":`Solving Time (h)`,
"c77":`Set Up Module`,
"label.lastcompiledate":`Last Compilation Time`,
"c1216":`Not uploaded`,
"c119":`Confirm Receipt`,
"c1047":`Please choose a method to save the file!`,
"c281":`Data Processing`,
"c1713":`Step 2: On the page below, edit filter conditions that control the values that appear in the dependent field for each value in the control field`,
"c1332":`Empty`,
"c1189":`5 cycles`,
"c715":`Monitor brand mentions and respond quickly.`,
"c1347":`Periodic Time Trigger`,
"c127":`Manage Columns`,
"c2157":`Edit Static Resource`,
"c1500":`Pane Width`,
"c1391":`The fields that drive filtering are called control fields. 
Standard and custom check boxes and option lists with at least one value and less than 300 values can be control fields`,
"c1173":`Unable to display list preview`,
"c283":`Data Request`,
"c1464":`UK time zone`,
"c919":`Use the pool to stimulate the potential of team and improve lead conversion rate. The pool administrator makes unified management for leads and batch assignments. Sales staff can also screen leads and receive follow-ups.`,
"c1979":`Customized Script Menu`,
"c82":`Only for Lightning`,
"front-file-delete-intro":`The file was removed`,
"c1634":`Customer Satisfaction`,
"c1213":`Console style`,
"c606":`Default shipping address`,
"c1250":`Are you sure to delete this layout?`,
"c1474":`Rule name cannot be empty`,
"c2106":`5 days`,
"c1732":`Allocation failed`,
"c2137":`Assignment cancelled`,
"c905":`Add`,
"c644":`PUBLISHED TIME`,
"c1560":`Whether To Enable Team`,
"c75":`Rebate Balance`,
"c1026":`Please check if user security token is updated`,
"c1586":`Properties of Formula Field `,
"c884":`Privacy Policy`,
"c538":`Avg Solving Time`,
"c322":`New Invoice`,
"c1140":`Permission Set Name`,
"c1135":`Assign custom pages`,
"c1167":`Up to 10 fields can be added to your business card.`,
"c461":`Payment Trend`,
"c825":`Enterprises`,
"c56":`The total invoice receivables and receivable amount are not consistent. Please fill again.`,
"c931":`You have not enabled employee positioning switch and cannot use location sharing interval. Continue?`,
"c1981":`Save & Export`,
"c1673":`Time Slot`,
"c276":`Enable GDPR Compliance`,
"c334":`Budget Amount`,
"c733":`Campaign: New Poster`,
"c1146":`Apply to mobile terminal?`,
"c384":`New Packing List`,
"c139":`Meeting Template`,
"c1908":`View your DNS records`,
"c1576":`Already added`,
"c1568":`Already existing`,
"c2133":`Page Address`,
"c957":`Post Comment ID cannot be empty`,
"c2124":`Allow partners to register and be activated after approval`,
"c1060":`Purchase Order Item`,
"front-electronic-signature-nosign":`No service provider of Esignature has been chosen by your org. Please contact the administrator to enable this service.`,
"c1411":`20 min`,
"c1050":`Generated successfully. The document has been saved to the file list`,
"c419":`Maintenance Plan`,
"c1230":`This page lists users, roles, and areas that have shared access to CEO`,
"c934":`Conversion Title`,
"c1020":`1. After price book is enabled, the system will generate one standard price book containing all products by default.`,
"c677":`Rightaligned`,
"c593":`Line Chart`,
"c272":`{0} has a timeout of accepting order. Account: {1}, Subject: {2}, Number: {3}. Click to see more >`,
"c1742":`Custom Error Pages`,
"c811":`RETWEETS`,
"c451":`Split Case`,
"c277":`Once you delete the email, the following emails will also be deleted and will not be sent to future contacts. This is irriversible.`,
"c244":`{!ServiceResource.name} rejected the order. Number: "{!ServiceAppointment.name}"`,
"c627":`Published`,
"c2141":`Assignments and Dispatches
`,
"c1862":`Preview URL`,
"c1578":`Japanese`,
"c601":`Target Chart`,
"c251":`post(s) publishing is failed`,
"c202":`Share in Mailchimp`,
"font-social-prohibit-create":`You cannot create a new post while editing`,
"c394":`CloudCC helps you manage the business online and improve the efficiency. Please choose the application you want to use and follow the introduction and guidance.`,
"c1642":`Member Settings`,
"c1684":`Objects`,
"c1362":`Empty`,
"c1124":`Exchange rate range: 2022-05-31 to Tue May 31 00:00:00 CST 2022`,
"c1323":`Show required fields`,
"c323":`PDF Format`,
"front-setting-dialog-title-one":`In order to prevent account loss, log in quickly and retrieve easily, please bind the mobile number`,
"front-electronic-signature-cancelIntro2":`If this is your first time to bind account, please click Continue to go on the next step. If you are rebinding after unbind, it is recommended to click Cancel and rebind after clearing browsing data.`,
"c1715":`Enable: The module will be displayed in "More" - "Standard Features" on the mobile side after checking the box
Disable: The module will no longer be shown in "More" - "Standard Features" on the mobile side after checking the box`,
"c1379":`Delete this sub-column now?`,
"c2095":`Click to configure assignment rules`,
"c353":`Display of Timesheets`,
"c621":`Rich text content`,
"front-v1-partner-image-tooltip":`A maximum of 2M file is supported. The image will be scaled down to {size}. It is recommended to upload clear images with similar proportions.`,
"c1967":`Record locked. Please contact administrator.`,
"c772":`Finalized`,
"c1018":`Add entity parameters`,
"c734":`Poster Channel's Name`,
"c380":`New Payment`,
"c1291":`Status Colour Legend`,
"c2217":`Enable Inserted Approval?`,
"c979":`Chongqing`,
"c1723":`Format error. Please use the format of yyyy/MM/dd or yyyy-MM-dd, or function: Today()`,
"c1247":`Unanimous approval from all selected approvers is required`,
"c1514":`Role: Shandong One`,
"c233":`You cannot delete the packing list of shipped status`,
"c2162":`Failed to create index`,
"c458":`Accounts Distribution Map`,
"c697":`Choose account address{name}`,
"c1701":`Basis Address`,
"c476":`Choose the employee to send invitation code to`,
"c634":`Create an engaging post and connect with the world`,
"c1567":`Please enter the correct number with a maximum length of 8 digits`,
"c1288":`Recommendation policy rules`,
"c1607":`Properties of Date and Time Field `,
"c1166":`Customize`,
"c144":`The end time cannot exceed 2038. Please select a new end time.`,
"c2229":`Enter 6-digit security code`,
"c1032":`Converted by currency exchange rate`,
"c2177":`Rejection failed`,
"c474":`You can reassign by using the lead assignment rules. For the assignment rules please see`,
"c2207":`Link Open ID Connect account`,
"c371":`Sync to Opportunity`,
"c420":`Maintenance Assets`,
"c620":`This is used to group multiple pieces of content for analysis a single marketing effort.`,
"c1643":`Replace Group Roles`,
"c708":`Unify the scale or not`,
"c100":`Discount`,
"c576":`2D Column Chart`,
"c2290":`Share dispatched service appointments to dispatched service resources`,
"c751":`Signing Deadline:`,
"c1132":`Please enter label`,
"c252":`Compliance Settings`,
"c1562":`Nothing to change`,
"c699":`New Only`,
"c74":`Pay by Rebate`,
"c1778":`Allowed number of pictures`,
"c805":`Choose a social network to get started:`,
"c452":`Case History`,
"c740":`Please select an employee to send invitation`,
"c596":`Biaxial Chart`,
"c1508":`Remember`,
"c1137":`Delete assignments`,
"c1636":`Service Report Templates`,
"c2219":`Main Label Content:`,
"c1792":`Re-assign Operation`,
"c2128":`Default profile`,
"c832":`Reviewing`,
"c971":`Scheduled Release`,
"c262":`History`,
"c363":`Sensitive`,
"c2101":`Upper limit of submitters`,
"c1117":`Operation will permanently delete this workflow rule. Continue?`,
"label.singleSignOn.is.invalid":`Loginfree was invalid`,
"c1941":`Lightning Version on PC`,
"c72":`Thirdparty Payment`,
"c1870":`Assign hosting location of your content`,
"c292":`Marketing`,
"c1874":`Top domain`,
"c1131":`New permission set`,
"c1807":`Please check whether the RequestBody format parameters are in the correct format`,
"c1349":`Copy Workflow`,
"c2153":`Service Resources`,
"c499":`Efficient Customer Service to Impress Customers`,
"c574":`Stacked Bar Chart`,
"c1593":`Properties of URL Field`,
"c618":`Change the content or publish time for this post.  Twitter doesn't allow more than one post with the same content to be published within 24 hours.`,
"c2160":`Approval Mode`,
"front-setting-phone-format":`Please input phone number in correct format`,
"c460":`Account Size Ranking`,
"c189":`The currency of invoice should be consistent with the currency of order. Please refine the currency and save again.`,
"label.exe.supported.request.rejected":`exe. file is not supported to be sent. The request is refused!`,
"c835":`An invoice has already existed for this quotation. To continue or not?`,
"c1907":`1. Download template: Select object (Supports downloading templates for current object)`,
"c2223":`Log in with another account`,
"c2168":`Create new case`,
"c1720":`Search for Auxiliary Fields`,
"c1850":`Confirm that the files imported are wrapped at the end`,
"c655":`Posting from`,
"c1513":`Owner equals to biysuat ordinary`,
"c1781":`When defining approval steps, approval requests can be assigned to different users. One of the options is to send these requests automatically using the user field.`,
"c1392":`End Date`,
"c45":`Connect By`,
"c1821":`Keys`,
"c43":`Connect Account`,
"c1534":`Essential information layout field cannot be empty`,
"c481":`Sign in as a different user`,
"c674":`External Address`,
"c266":`This order cannot be changed for it has been completed`,
"c967":`You're about to disconnect {0} account.This will remove all social media settings and publishing options associated with this account`,
"c1010":`Deactivated`,
"c1769":`Expire to {Date}`,
"c154":`Please search price books after selecting products`,
"c841":`Got ideas? Draft away.   `,
"c615":`No account has been selected`,
"c1416":`Decimal format error`,
"c84":`Choose emloyee to send invitation code`,
"c401":`Service`,
"c290":`Enabled Objects`,
"c1733":`Dispatch`,
"c205":`Download QR Code`,
"c928":`Up to 10 fields can be selected.`,
"c195":`Submission Limit`,
"1":`No available actions`,
"c1224":`Insufficient permissions, please contact the system administrator to configure the role under the multi-organization configuration library user table information, role ID: {id}`,
"c46":`Authorize successfully`,
"c459":`Signed Contract Amount`,
"c1387":`Unused Fields`,
"c1394":`Edit option list value`,
"c1274":`Edit   Global option list set`,
"c1528":`Greater than or equal to`,
"c2083":`Please enter Package ID`,
"c250":`posts are saved as drafts`,
"c399":`Inventory`,
"c1107":`Advanced filter condition check failed, please re-check`,
"c1589":`Properties of Text Area Field `,
"c1774":`Configured Fields`,
"c1034":`Object name too long`,
"c518":`The #recordName of #label failed the approval for #failReason`,
"c396":`Choose different solutions`,
"c300":`Destroy requested by`,
"c789":`Unrestricted Signature Method`,
"c874":`You've read everything in your inbox.`,
"c1955":`There is risk of SQL injection in request value. Please check input parameters. `,
"c38":`Community block number`,
"c228":`Add Subtask`,
"c1122":`When meeting rule condition for the first time while creating or editing records`,
"c342":`Profit`,
"c1747":`Click Login to initialize`,
"c1703":`Whether images from album are allowed to be uploaded`,
"c2167":`Modify case`,
"c879":`Clone social posts`,
"c173":`Rebind successfully`,
"c2127":`Verification method`,
"c1089":`All Records`,
"c1354":`Page layout name`,
"c778":`Initiator`,
"c1594":`Require`,
"c1334":`SMS Gateway password (MD5)`,
"c1946":`Value of required fields cannot be empty.`,
"c1515":`Rewriting standard buttons and links changes the meaning of CloudCC URL and all calls to that URL, such as CloudCC pages, browser shortcuts, or external systems. <br />You can replace standard buttons or linked CloudCC URL with CloudCC's custom page. <br />Please select a custom page to replace this standard button or linked CloudCC URL.`,
"c211":`Small size`,
"c1601":`Properties of Picklist Field `,
"c1159":`The first execution time is # time, and then every #number minutes.`,
"c1825":`Mark issuer`,
"c1478":`Enter rule name and select enabled check box to use this rule for automatic case upgrade. 
Enabling this rule disables the current case upgrade rule.`,
"c1388":`Create New Field`,
"c496":`CloudCC Sales Cloud-A smart CRM for all scenarios to help you achieve your sales goals`,
"c1085":`Edit Profile`,
"c427":`Dispatch in Gantt Chart Mode`,
"c851":`This shows the number of posts that were published across your accounts within the selected period.`,
"c32":`New Subscription Type`,
"c1953":`404 error. Please contact administrator.`,
"c1165":`Business Card`,
"c28":`Yearonyear growth`,
"c2088":`{!ServiceResource.name} rejected order {!ServiceAppointment.name}. Click to view.`,
"c163":`Simultaneously inform and cancel dispatch`,
"c1772":`Online case`,
"c1743":`Custom Logout Page`,
"c1863":`Secondary Email`,
"c225":`Go to Task`,
"c569":`Please choose account first`,
"c1317":`Action will disable this workflow. Continue?`,
"c92":`Open once`,
"c1706":`Configure organization-level home page by actual scenario`,
"c2166":`Member duplicated`,
"c412":`AutoCreate Service Appointment`,
"c81":`Add to Cart`,
"c999":`Wrong mobile number or password`,
"c653":`This shows the number of likes, reactions, and comments for your published posts. This also includes posts that were published to your connected accounts outside of CloudCC If you're looking for Twitter retweets, you'll find them in Shares.`,
"c1762":`Extension Field`,
"c1467":`Fiscal Year name must be a positive integer.`,
"c2298":`Package Testing`,
"c1647":`Opportunity Group Settings`,
"c516":`Attendance`,
"c1241":`Allow or transfer users to edit personal information`,
"c1459":`Download and save to file.`,
"c918":`If auto-recycle rules are configured, the system will auto-recycle the records to the pool when the account has not closed the deal after the time limit. That improves the efficiency of account follow-up.`,
"c809":`LIKES`,
"c1570":`Export exceptions`,
"c1532":`Select function`,
"c1192":`These are the tasks assigned to users when executing workflow rules, blueprints, and approval processes.`,
"c2297":`No contents`,
"c181":`Please fill in work order or case record`,
"c745":`Please enter up to 2 decimal places`,
"c669":`Color`,
"c929":`Please check the network connection`,
"c2292":`Share parent work orders of service appointments to users in corresponding areas`,
"c117":`Save & Pay`,
"c1240":`Partner Cloud roles and user settings-Number of user roles`,
"c938":`China Mainland`,
"c112":`All {name} templates are currently disabled. Please contact the administrator to enable the template before generating {name}.`,
"c347":`Change Work Hours of Project Task`,
"c795":`Please choose contract template`,
"c1631":`Access Settings`,
"c17":`Inactive. Please reselect`,
"c787":`Signed by the Operator`,
"c829":`CAMPAIGN`,
"c1929":`Article translation - Submit translation`,
"c1041":`3. File Type`,
"c161":`Also inform`,
"c1936":`All records are shown when no field condition is set.`,
"c2198":``,
"c65":`Do you want to change the logistics status of product to Delivered`,
"c1958":`Exchange rate cannot be empty`,
"c1843":`Connection`,
"c1823":`Mark endpoint URL`,
"c665":`Add one more`,
"c767":`Check Signing Progress`,
"c2131":`Page Title`,
"c87":`QR Code of Campaign Form`,
"c589":`Map of France`,
"c1343":`You are currently using the free version. The maximum number of queries of the API per day is 10,000. If you need to expand the number of queries, it is recommended to purchase services. After purchasing the service, obtain the token from the manufacturer to configure it on this page, and the manufacturer will provide you with the corresponding paid service. <br>For purchase or inquiry, please contact 400-642-2008`,
"c1405":`The Email merging template is a Microsoft Word document, where the merging field refers to the CloudCC field. Click New Template to upload a new Email merging template.`,
"front-electronic-signature-newTime":`Last Updated At`,
"c2165":`Crop text to cell`,
"c813":`SHARE`,
"c85":`{member} inviter selected`,
"c951":`Poland`,
"c1853":`Add Picklist value: Group Role`,
"c1788":`Type and press ENTER to search`,
"c2204":`Link Open ID Connect account`,
"c29":`Monthonmonth growth`,
"c1170":`Select standard buttons displayed on the related list. You can also reorder selected buttons.`,
"c210":`Large size`,
"c1615":`Import Quota`,
"c39":`Archived`,
"c672":`Word`,
"c97":`This picklist should at least contain one "Converted" option`,
"c687":`Max Size`,
"c1646":`Record Type Name`,
"c916":`Close Pool`,
"c475":`Please fill in the campaign owner`,
"c2099":`Creator of QR code`,
"c1376":`What would you like to do?`,
"c1097":`Rules of applying`,
"c1812":`Introduction`,
"c1486":`Start Time`,
"c628":`Scheduled`,
"c788":`The price book for this opportunity is currently disabled. Please enable the price book before creating a new order.`,
"c1030":`Product(s) within package`,
"c1670":`Resource Preferences`,
"c1436":`Select layout`,
"c1302":`Event synchronization direction`,
"c1768":`Modify`,
"c1902":`Back`,
"c177":`Suggested Size: 390*210`,
"c1980":`Cannot be 0`,
"c1859":`Note: Roles and Subordinates include all users in specific roles the roles below.`,
"c856":`Yay! No unsuccsessful posts.`,
"c2117":`{0} already assigned. Cannot repeat.`,
"c1782":`To apply this option to any approval steps, please select a field from the list below.`,
"c70":`Order Information`,
"c1533":`Label cannot be empty`,
"c1141":`License type`,
"c546":`Last 24 hours`,
"c1447":`It is not allowed to remove users from the selected user list to all unassigned and enabled users and to all unassigned users`,
"c331":`Convert Assets`,
"label.order.paidamount.greater.than.total":`After the new payment details are created, the refunded amount of the order will be greater than the order amount. Please readjust the payment and then save it.`,
"c524":`Reinvite`,
"c1456":`To assign other users to this role:`,
"c1758":`Total size of pictures cannot exceed 20MB`,
"c1175":`Set as required field`,
"c1547":`View/add unused values`,
"c1717":`You have received a new work order {0}. Please click to view and process it in time.`,
"c246":`{!oldServiceResource.name} transferred the work order numbered {!ServiceAppointment.name} to you.`,
"c986":`Download manuals`,
"c2274":`Discarding…`,
"c1748":`Existing User`,
"label.parameter.is.incorrect":`Wrong parameters`,
"c1242":`Related List name`,
"c1982":`Details`,
"c1687":`Topics`,
"c1591":`The field name must begin with a letter and can only contain uppercase and lowercase letters, numbers, underscores, maximum length {maxApinameLength}, and minimum 2 digits`,
"c667":`Iconspacing`,
"c1817":`Apex details`,
"c1375":`Delete fields you want to remove in this layout, or move them to Unused Fields pane on the left.`,
"c737":`Social Platform`,
"c1695":`Developer Space`,
"c48":`Disconnect`,
"c111":`Generate {name}`,
"c1582":`German`,
"c2178":`Rejection successful`,
"c755":`In sequence`,
"c2289":`Client Script`,
"c1333":`Add Trigger`,
"c526":`Enable Portal User`,
"c450":`Merge Cases`,
"front-electronic-export-reChoseChimp":`The current view has no data records and cannot be exported. Please select a new view`,
"c1759":`Icon of Mobile Service Cloud`,
"label.invoice.paidamount.greater.than.total":`After the new payment details are created, the refunded amount of the invoice will be greater than the total value. Please readjust the payment and then save it.`,
"c1688":`Objects`,
"c222":`Edit Project`,
"c849":`Twitter accounts`,
"c1549":`Batch add selection`,
"c2309":`Order overdue. ID {!ServiceAppointment.name}, click to view and process.`,
"c1369":`Title not visible`,
"c678":`Black and White`,
"c502":`Offer comprehensive solutions for handling the entire processes involved in the field services to streamline operations, improve productivity, increase customer loyalty and satisfaction.`,
"c1476":`Deleted!`,
"c1052":`Change Page Layout Template`,
"c497":`Smarter Inventory, Stronger Business and Financial Management`,
"c1458":`Save to File`,
"c1815":`Digital products don not support unwarranted return`,
"c200":`Share on social media`,
"c1893":`Select users of Call Center`,
"c1258":`Please select template for SMS notification`,
"c1272":`Hide all`,
"c658":`Rich Text`,
"c434":`New Related Contact`,
"c1848":`Create file containing name and translation of the language you need to import.`,
"c641":`You can only choose no more than 4 images，click selected image to deselecte it. The size of image you upload should under 200kb`,
"c944":`Germany`,
"c1221":`Are you sure to delete?`,
"c411":`Due Date Offset`,
"c1114":`Select the field to insert`,
"c1353":`To find API keys and API secrets, you can log in to your Vonage API account and go to Settings under your account name. To find the phone number in your Vonage API account, go to number under products, and then click your number to see all the phone numbers you have.`,
"c1776":`Default link validity`,
"c1565":`New Custom Object`,
"c1619":`Online Payment Settings`,
"c1115":`Enter name of workflow rule`,
"c624":` All Accounts`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c1319":`Restriction released`,
"c1696":`Installed Software Packages`,
"c1746":`Authorized issuer`,
"c791":`Standard Signature`,
"c1965":`Enter number from 1 to 10`,
"c1728":`Properties of Score Field`,
"c306":`Agree`,
"c14":`Current user does not have the permission to delete`,
"c176":`Only png, jpg and jpeg images are supported to upload. The uploaded image cannot exceed 2M.`,
"c1335":`Start character`,
"c997":`SKU Function List`,
"c1233":`All unassigned users`,
"c2225":`You must install a MFA application on your smart device before you can proceed.`,
"c1566":`Must start with a letter, can only contain uppercase and lowercase letters, numbers, underscores, maximum length 30, minimum 2 digits, and cannot be keywords in the database`,
"c166":`Please enter the maximum order length according to the rules`,
"c731":`Change the selected price book will also delete all existing products. Are you sure to change to the new price book?`,
"c2086":`Search for objects`,
"c237":`{!ServiceResource.name} accpted the order. Number: "{!ServiceAppointment.name}"`,
"c887":`Reinvite user successfully`,
"c1418":`Step 1: Select a control field and a dependent field. 
Click Continue after finished.`,
"c227":`Edit Subtask`,
"c1674":`Evaluation Item`,
"c257":`Available Contact`,
"c2175":`Accepting successful`,
"c1867":`Length of menu name should be 2 to 20.`,
"c1864":`User 1`,
"c712":`Report and compare performance across networks, posts, and campaigns.`,
"c107":`Search users by name, account, and mobile number`,
"c1767":`Expiration Date of Link`,
"c1310":`Task conflict behaviour`,
"c1627":`WeChat Mini Programs`,
"c1266":`Add to custom applications`,
"c1262":`Last edit`,
"c370":`Contract`,
"c1878":`Status`,
"c1784":`Please punch in. (ignore if already punched in)`,
"c895":`Distance calculation failed, please enter the complete address`,
"c1029":`Product Configuration`,
"c693":`Autoregulation`,
"c763":`Signed`,
"c302":`Legitimate Interests`,
"c577":`Stacked Column Chart`,
"c258":`Make a Complaint`,
"c1757":`Allow Restrictions on Pictures`,
"c1879":`Log in to system`,
"c2296":`Fiscal year {0}`,
"c676":`Center`,
"c1609":`Properties of Email Field `,
"c868":`After deactivating this account, the system will restrict its access or operations in your portal. Continue?`,
"c53":`Ratio (%)`,
"c2161":`Reason for insertion`,
"c527":`#userName has assigned approval task to you`,
"c1816":`+ Add`,
"c1579":`Japanese`,
"c984":`The network is connected`,
"c1021":`2. Price book may affect product price in opportunities, quotes, orders, invoices, and purchase orders. If the 5 objects above is associated with the price book, sales staff can select only products in the price book whose price is taken as default`,
"label.facebook.title.setting":`Facebook Integrated Information`,
"c1888":`Provider's Auth Token 2`,
"c340":`Change the Owner of Project Plan`,
"c1764":`QR Code of Online Case`,
"c1868":`Please enter the correct email address`,
"c706":`About the charts`,
"label.mobile.used":`The mobile number has been used`,
"c328":`Asset QR Code`,
"c1761":`Individual Customer`,
"c337":`Contacts  Destroy`,
"c1605":`Properties of Phone Field`,
"c1935":`No permission. Please contact administrator.`,
"c642":`Recent Images`,
"c2403":`SQL loading timeout`,
"c2348":`Disabled`,
"c2429":`The article {name} has been attached to work order!`,
"c2398":`Default`,
"c2318":`Total file size exceeds the limit of {0} MB`,
"c2400":`Field Properties of Record Type`,
"c2430":`The article {name} has been cancelled to be attached to work order! `,
"c2424":``,
"c2374":`Create & Edit  Fields`,
"c2347":`Call Center Market`,
"c2343":`Contact Email`,
"c2366":`openApi requests too frequent`,
"c2436":`Export only the Detail Info column. Use these data for more calculation or to upload to other systems. A maximum of {number} pieces of data can be exported at once when exporting by multiple pages. `,
"c2391":`Parameters`,
"c2377":`According to the actual scenario, select the module that serves the business requirements < br > Enable: when enabled, the module will be displayed on the mobile side "more" > "tools" < br > Disabled: when disabled, the module will not be displayed on the mobile side "more" > "tools".`,
"c2446":`Please drag & drop field here.`,
"c2445":`Blog`,
"c2437":`No permission to assign. Please contact administrator to enable.`,
"c2337":`Class Subject`,
"c2335":`URL: Call Back`,
"c2330":`Please enter URL suffix`,
"c2420":`The value does not exist or does not match the filter criteria`,
"c2362":`Trigger Notifications`,
"c2409":`Maximum 1 region-matching rule`,
"c2319":`The total size is limited to {0} MB, or a maximum of {1} pictures`,
"c2320":`Formats supported: JPEG, PNG, GIF, BMP`,
"c2432":`No permission to assign. Please contact adminidtrator to enable.`,
"c2378":`Bottom Menu Config (Universal)`,
"c2414":`Duplicated Work Rules`,
"c2411":`Maximum 1 shortest-travel target`,
"c2360":`{0} have integrated Call Center {1}. Move them to this Call Center?`,
"c2418":`Keep at least one button at the bottom of Detail page`,
"c2358":`Delete this custom Call Center?`,
"c2379":`Organizations can initialize the bottom menu at the organization level according to the business scenario.`,
"c2331":`Verification Provider ID`,
"c2361":`Select at least 1 user`,
"c2447":`Delete the custom field <{name}>?`,
"c2444":`Configure Host`,
"c2338":`Select ID`,
"c2345":`Contact Phone`,
"c2419":`Prefer`,
"c2339":`All Panned Work`,
"c2329":`Non-real fields (e.g. Formula) do not support filtering`,
"c2408":`Maximum 1 resource availability rule`,
"c2406":`Maximum 1 required-resource rule`,
"c2370":`Custom tags allow developers to create multilingual applications by displaying information (such as Help or Error ) to users in their native language.`,
"c2371":`If you enable Translation Workbench for CloudCC organization, you can translate these labels into any language supported by CloudCC.`,
"c2351":`Using provider's name is recommended`,
"c2443":`Verify Address`,
"c2326":`URL Suffix`,
"c2363":`Report Optimization SQL validation error`,
"c2399":`Custom script`,
"c2401":`Create and edit fields in the Layout Editor`,
"c2359":`Disable this Call Center?`,
"c2353":`Label must consist of less than 40 letters or numbers, can only start with a letter, and the name must be unique`,
"c2334":`URL: Existing Users`,
"c2404":`Maximum 12 work rules`,
"c2397":`Current User`,
"c2435":`Enter description`,
"c2342":`Connected App`,
"c2376":`Common Tool Configuration`,
"c2416":`Distance`,
"c2332":`URL: Icons`,
"c2442":`Select Domain`,
"c2413":`Duplicated Service Targets`,
"c2322":`Reject`,
"c2395":`Log-In Methods`,
"c2434":`Type of Insertion`,
"c2438":`No Available Resources`,
"c2407":`Maximum 1 resource-excluding rule`,
"c2440":`New tab on the right`,
"c2356":`All Users`,
"c2421":`Cannot remove the last button in the layout.`,
"c2373":`Disable Multi-Language?`,
"c2439":`Pop-up window`,
"c2350":`Call Center Name cannot be empty`,
"c2328":`Field does not support sorting`,
"c2405":`Maximum 1 skill-matching rule`,
"c2324":`Reason of Rejection`,
"c2382":`Tip: Bottom Menu Config (for Profiles) will overwrite Bottom Menu Config (Universal).`,
"c2336":`URL: Click to Log Out`,
"c2340":`CloudCC Licence`,
"c2431":``,
"c2317":`You can only upload up to {0} pictures. Please try again.`,
"c2372":`You can create up to 5,000 custom labels each containing up to 1,000 characters.`,
"c2323":`Plan conflict`,
"c2402":`SQL syntax exception`,
"c2341":`CloudCC Platform Licence`,
"c2392":`Maximum of 200 columns can be selected.`,
"c2380":`Please select the 4 bottom menus that need to be displayed on the mobile`,
"c2333":`URL: Click to Initialize`,
"c2381":`Bottom Menu Config (for Profiles)`,
"c2352":`Unique Label cannot be empty`,
"c2321":`Accept`,
"c2415":`Distance: Calculation error`,
"c2375":`Organizations can configure four shortcut functions in the top of the organization-level homepage according to the business scenario.`,
"c2357":`Assign specific users to use Call Center`,
"c2423":`Review Content`,
"c2344":`CloudCC Partner Licence`,
"c2441":`Length`,
"c2354":`Custom Page cannot be empty`,
"c2386":`Assign custom menu permissions`,
"c2422":`Configure Review Items`,
"c2433":`Add`,
"c2448":`[Task Reminder] You have 1 task reminder. Click to view.`,
"c2349":`Define Call Center`,
"c2355":`Save & Enable`,
"c2346":`Auto Log In`,
"c2412":`Maximum 12 service targets`,
"c2364":`Report Optimization SQL format error`,
"c2383":`Enable ES`,
"c2396":`Close all menus`,
"c2325":`Please enter reason`,
"c2410":`Maximum 1 preferred resource target`,
"c2327":`Client ID`
}